msgid ""
msgstr ""
"POT-Creation-Date: 2026-09-21 16:13-0400\n"
"MIME-Version: 1.0\n"
"Content-Type: text/plain; charset=utf-8\n"
"Content-Transfer-Encoding: 8bit\n"
"X-Generator: @lingui/cli\n"
"Language: en\n"
"Project-Id-Version: \n"
"Report-Msgid-Bugs-To: \n"
"PO-Revision-Date: \n"
"Last-Translator: \n"
"Language-Team: \n"
"Plural-Forms: \n"

#: src/pages/assetLens/components/tabs/imagesTabComponents/ImageTrendAnalysis.tsx
msgid " - Monitor for potential changes"
msgstr " - Monitor for potential changes"

#: src/pages/processData/components/helpGuide/HelpGuideChapters.tsx
msgid " — drag a window and give it a title and description. "
msgstr " — drag a window and give it a title and description. "

#: src/pages/processData/components/helpGuide/HelpGuideChapters.tsx
msgid " — drag across a window for its High, Low, Range, and Mean. Drag the edges to adjust; "
msgstr " — drag across a window for its High, Low, Range, and Mean. Drag the edges to adjust; "

#: src/pages/processData/components/helpGuide/HelpGuideChapters.tsx
msgid " — drag the edge of either side pane, or the divider between Tags and Tag Configuration."
msgstr " — drag the edge of either side pane, or the divider between Tags and Tag Configuration."

#: src/pages/processData/buildMode/dock/EvalsDockTab.tsx
msgid " — mark label rows as “anomaly” on the right, or draw labels in View mode."
msgstr " — mark label rows as “anomaly” on the right, or draw labels in View mode."

#: src/pages/processData/components/helpGuide/HelpGuideChapters.tsx
msgid " — one click pins a sample's value and timestamp."
msgstr " — one click pins a sample's value and timestamp."

#: src/features/timeSeries/sentinelStudio/SentinelBuilderPanel.tsx
msgid " — signing…"
msgstr " — signing…"

#: src/pages/processData/components/helpGuide/HelpGuideChapters.tsx
msgid " — the bell shows or hides them on the chart. "
msgstr " — the bell shows or hides them on the chart. "

#: src/pages/processData/components/helpGuide/HelpGuideChapters.tsx
msgid " — the eye on the Selected Tags rail hides every pen at once; click any row to hide or show just that one."
msgstr " — the eye on the Selected Tags rail hides every pen at once; click any row to hide or show just that one."

#: src/pages/processData/components/helpGuide/HelpGuideChapters.tsx
msgid " — the info icon on the Tags pane and the Selected Tags rail shows or hides them."
msgstr " — the info icon on the Tags pane and the Selected Tags rail shows or hides them."

#: src/pages/processData/components/helpGuide/HelpGuideChapters.tsx
msgid " — the list narrows as you type, matching tag names and descriptions at once."
msgstr " — the list narrows as you type, matching tag names and descriptions at once."

#: src/pages/processData/components/helpGuide/HelpGuideChapters.tsx
msgid " — the panel buttons at the top right hide either side rail entirely."
msgstr " — the panel buttons at the top right hide either side rail entirely."

#: src/features/timeSeries/utils/uPlotPlugins.ts
msgid " · {magnitude}× band"
msgstr " · {magnitude}× band"

#: src/features/timeSeries/components/SentinelsTab.tsx
msgid " · drift "
msgstr " · drift "

#: src/features/timeSeries/components/SentinelsTab.tsx
msgid " · err scale "
msgstr " · err scale "

#: src/features/timeSeries/experiment/CleaningControls.tsx
msgid " · kept {formattedKept}"
msgstr " · kept {formattedKept}"

#: src/features/sentinels/components/CasesPanel.tsx
msgid " · measured"
msgstr " · measured"

#: src/features/sentinels/components/CasesPanel.tsx
msgid " · method "
msgstr " · method "

#: src/features/timeSeries/experiment/NormalizationViewer.tsx
msgid " · n="
msgstr " · n="

#: src/features/timeSeries/experiment/NormalizationViewer.tsx
msgid " · n={value356_38}"
msgstr " · n={value356_38}"

#: src/features/sentinels/components/CasesPanel.tsx
msgid " · residual"
msgstr " · residual"

#: src/features/knowledgeDocumentViewer/components/viewer/search/ConnectorLookupPanel.tsx
msgid " · Rev {revision}"
msgstr " · Rev {revision}"

#: src/features/timeSeries/experiment/DiagnosticsPanel.tsx
msgid " · split_date="
msgstr " · split_date="

#: src/features/timeSeries/experiment/NormalizationViewer.tsx
msgid " · std"
msgstr " · std"

#: src/features/timeSeries/experiment/CleaningControls.tsx
#: src/features/timeSeries/experiment/ExperimentTab.tsx
msgid " · target"
msgstr " · target"

#: src/features/sentinels/components/DesignRunDetails.tsx
msgid " · target "
msgstr " · target "

#: src/pages/processData/buildMode/dock/SamplingSection.tsx
msgid " · test "
msgstr " · test "

#: src/features/timeSeries/experiment/DiagnosticsPanel.tsx
msgid " · test="
msgstr " · test="

#: src/pages/processData/buildMode/dock/SamplingSection.tsx
msgid " · train "
msgstr " · train "

#: src/features/sentinels/components/SentinelList.tsx
#: src/features/sentinels/components/SentinelList.tsx
msgid " · updated"
msgstr " · updated"

#: src/pages/processData/buildMode/dock/SamplingSection.tsx
msgid " · val"
msgstr " · val"

#: src/features/timeSeries/experiment/DiagnosticsPanel.tsx
msgid " · val="
msgstr " · val="

#: src/features/sentinels/components/CasesPanel.tsx
msgid " (band ±"
msgstr " (band ±"

#: src/features/timeSeries/components/DataSmoothing.tsx
#: src/features/timeSeries/components/ThresholdFiltering.tsx
msgid " (derived)"
msgstr " (derived)"

#: src/features/sentinels/components/RecentScorePanel.tsx
msgid " (every"
msgstr " (every"

#: src/features/timeSeries/components/ScatterPlotTableLegend.tsx
msgid " (predicted)"
msgstr " (predicted)"

#: src/features/timeSeries/components/InterpolatedValueTooltip.tsx
msgid " (predicted):"
msgstr " (predicted):"

#: src/features/timeSeries/experiment/DiagnosticsPanel.tsx
msgid " (q={value315_25})"
msgstr " (q={value315_25})"

#: src/features/timeSeries/experiment/CorrelationCard.tsx
msgid " (r={value296_31})"
msgstr " (r={value296_31})"

#: src/features/timeSeries/sentinelStudio/SentinelBuilderPanel.tsx
msgid " (revision {planRevision} — redesigning replaces it)"
msgstr " (revision {planRevision} — redesigning replaces it)"

#: src/features/sentinels/components/RecentScorePanel.tsx
msgid " (saved"
msgstr " (saved"

#: src/features/timeSeries/components/SentinelsTab.tsx
msgid " (the most recent "
msgstr " (the most recent "

#: src/features/timeSeries/experiment/DiagnosticsPanel.tsx
msgid " = k ("
msgstr " = k ("

#: src/pages/processData/buildMode/dock/EvalLabelTable.tsx
msgid " ⚠ in training data"
msgstr " ⚠ in training data"

#: src/pages/processData/components/helpGuide/HelpGuideChapters.tsx
msgid " across the chart to zoom into a time window."
msgstr " across the chart to zoom into a time window."

#: src/features/timeSeries/agentTab/dock/BacktestTab.tsx
msgid " add event"
msgstr " add event"

#: src/features/timeSeries/agentTab/dock/WindowsTab.tsx
msgid " add range"
msgstr " add range"

#: src/pages/processData/buildMode/dock/WindowsDockTab.tsx
msgid " Add window"
msgstr " Add window"

#: src/pages/processData/components/helpGuide/HelpGuideChapters.tsx
msgid " adds separate name and description fields, AND/OR matching, multi-select, and filtering by point source and recent data. "
msgstr " adds separate name and description fields, AND/OR matching, multi-select, and filtering by point source and recent data. "

#: src/features/timeSeries/sentinelStudio/SentinelBuilderPanel.tsx
msgid " and has neither finished nor failed — its training job was likely killed. Delete it and design a new one."
msgstr " and has neither finished nor failed — its training job was likely killed. Delete it and design a new one."

#: src/features/timeSeries/experiment/DiagnosticsPanel.tsx
msgid " around expected / zero residual."
msgstr " around expected / zero residual."

#: src/pages/processData/components/helpGuide/HelpGuideChapters.tsx
msgid " brings you back."
msgstr " brings you back."

#: src/features/timeSeries/experiment/DiagnosticsPanel.tsx
msgid " calibration rows ("
msgstr " calibration rows ("

#: src/features/timeSeries/agentTab/dock/AlertingTab.tsx
msgid " can never happen — this rule would never fire."
msgstr " can never happen — this rule would never fire."

#: src/pages/processData/components/helpGuide/HelpGuideChapters.tsx
msgid " captures the chart as an image."
msgstr " captures the chart as an image."

#: src/features/sentinels/components/RecentScorePanel.tsx
msgid " Case opened at {value492_41} — see the Monitor tab."
msgstr " Case opened at {value492_41} — see the Monitor tab."

#: src/pages/processData/components/helpGuide/HelpGuideChapters.tsx
msgid " connects them, sloping between samples for analog tags and holding each value until the next one for digital and step tags."
msgstr " connects them, sloping between samples for analog tags and holding each value until the next one for digital and step tags."

#: src/features/timeSeries/agentTab/dock/AlertingTab.tsx
msgid " days out of "
msgstr " days out of "

#: src/pages/processData/buildMode/dock/BacktestDockTab.tsx
msgid " days per run — shorten the range."
msgstr " days per run — shorten the range."

#: src/features/sentinels/components/RecentScorePanel.tsx
msgid " days, native interval"
msgstr " days, native interval"

#: src/features/timeSeries/components/RegressionPrediction.tsx
msgid " Details"
msgstr " Details"

#: src/pages/processData/components/helpGuide/HelpGuideChapters.tsx
msgid " discards local edits and reloads the saved version."
msgstr " discards local edits and reloads the saved version."

#: src/features/timeSeries/experiment/CorrelationCard.tsx
msgid " each side (step "
msgstr " each side (step "

#: src/pages/processData/components/helpGuide/HelpGuideChapters.tsx
msgid " finds both"
msgstr " finds both"

#: src/features/timeSeries/sentinelStudio/SentinelBuilderPanel.tsx
msgid " It stopped reporting a while ago — its job most likely died. Start it again below; nothing was kept."
msgstr " It stopped reporting a while ago — its job most likely died. Start it again below; nothing was kept."

#: src/pages/processData/components/helpGuide/HelpGuideChapters.tsx
msgid " keeps your changes; the pencil renames. The first save of a new view asks for a name."
msgstr " keeps your changes; the pencil renames. The first save of a new view asks for a name."

#: src/features/timeSeries/components/SentinelsTab.tsx
msgid " Loading drivers…"
msgstr " Loading drivers…"

#: src/features/timeSeries/components/LabelsTab.tsx
msgid " Loading labels…"
msgstr " Loading labels…"

#: src/features/timeSeries/components/SentinelsTab.tsx
msgid " Loading sentinel…"
msgstr " Loading sentinel…"

#: src/features/timeSeries/components/SentinelsTab.tsx
msgid " Loading sentinels…"
msgstr " Loading sentinels…"

#: src/features/sentinels/components/RecentScorePanel.tsx
msgid " min), scored with models trained through "
msgstr " min), scored with models trained through "

#: src/features/sentinels/components/RecentScorePanel.tsx
msgid " Opening case…"
msgstr " Opening case…"

#: src/pages/processData/components/helpGuide/HelpGuideChapters.tsx
msgid " opens the full list to rename or delete;"
msgstr " opens the full list to rename or delete;"

#: src/features/timeSeries/components/InterpolatedValueTooltip.tsx
msgid " out of band"
msgstr " out of band"

#: src/features/timeSeries/experiment/ExperimentTab.tsx
msgid " outside the band (white dots on the chart). Worst offenders:"
msgstr " outside the band (white dots on the chart). Worst offenders:"

#: src/pages/processData/buildMode/dock/EvalsDockTab.tsx
msgid " overlap training data"
msgstr " overlap training data"

#: src/features/timeSeries/experiment/ExperimentTab.tsx
msgid " per period, drawn beside the raw pen."
msgstr " per period, drawn beside the raw pen."

#: src/pages/processData/components/helpGuide/HelpGuideChapters.tsx
msgid " removes a chip."
msgstr " removes a chip."

#: src/features/timeSeries/experiment/DiagnosticsPanel.tsx
msgid " rows · train="
msgstr " rows · train="

#: src/features/timeSeries/components/RelativeDateConfig.tsx
msgid " sec)"
msgstr " sec)"

#: src/features/timeSeries/components/SentinelsTab.tsx
#: src/features/timeSeries/components/SentinelsTab.tsx
msgid " Sentinels"
msgstr " Sentinels"

#: src/pages/metrics/Metrics.tsx
msgid " Showing the last loaded selection below."
msgstr " Showing the last loaded selection below."

#: src/pages/processData/components/helpGuide/HelpGuideChapters.tsx
msgid " shows the actual sampled values;"
msgstr " shows the actual sampled values;"

#: src/features/sentinels/SentinelInstancePicker.tsx
msgid " slots bound"
msgstr " slots bound"

#: src/pages/processData/components/helpGuide/HelpGuideChapters.tsx
msgid " starts blank."
msgstr " starts blank."

#: src/pages/processData/components/helpGuide/HelpGuideChapters.tsx
msgid " to box-zoom both axes."
msgstr " to box-zoom both axes."

#: src/features/timeSeries/components/SentinelsTab.tsx
msgid " to build one."
msgstr " to build one."

#: src/pages/processData/components/helpGuide/HelpGuideChapters.tsx
msgid " to lock a term in as a "
msgstr " to lock a term in as a "

#: src/pages/processData/components/helpGuide/HelpGuideChapters.tsx
msgid " to put it away."
msgstr " to put it away."

#: src/pages/details/extensions/flow/FilesExtension.tsx
msgid " to upload reports"
msgstr " to upload reports"

#: src/features/timeSeries/components/SentinelsTab.tsx
msgid " Training — this updates on its own."
msgstr " Training — this updates on its own."

#: src/features/timeSeries/experiment/ExperimentTab.tsx
msgid " vs expected"
msgstr " vs expected"

#: src/features/sentinels/components/CasesPanel.tsx
msgid " vs expected "
msgstr " vs expected "

#: src/features/timeSeries/components/SentinelsTab.tsx
msgid "-day scoring limit, so the band covers "
msgstr "-day scoring limit, so the band covers "

#: src/features/knowledgeDocumentViewer/components/DocumentUnavailablePanel.tsx
msgid "— not present"
msgstr "— not present"

#: src/pages/processData/components/helpGuide/HelpGuideChapters.tsx
msgid ", below the tag list, sets each pen's color and y-axis — one scale per pen with "
msgstr ", below the tag list, sets each pen's color and y-axis — one scale per pen with "

#: src/pages/processData/components/helpGuide/HelpGuideChapters.tsx
msgid ", or a shared one with "
msgstr ", or a shared one with "

#: src/features/timeSeries/sentinelStudio/SentinelBuilderPanel.tsx
msgid ", started"
msgstr ", started"

#: src/pages/processData/components/helpGuide/HelpGuideChapters.tsx
msgid ", then add another. Every chip must match, in any order — no wildcards needed: "
msgstr ", then add another. Every chip must match, in any order — no wildcards needed: "

#: src/features/timeSeries/experiment/ExperimentTab.tsx
msgid ". Changing the dates above moves the chart to match."
msgstr ". Changing the dates above moves the chart to match."

#: src/features/sentinels/components/RecentScorePanel.tsx
msgid ". Fresh data"
msgstr ". Fresh data"

#: src/features/timeSeries/sentinelStudio/SentinelBuilderPanel.tsx
msgid ". It updates on its own; every run gets its own sentinel, so a second target off this same context is a new saved model."
msgstr ". It updates on its own; every run gets its own sentinel, so a second target off this same context is a new saved model."

#: src/features/sentinels/components/MonitorTab.tsx
msgid ". Lower is tighter (more sensitive); the fit seeded this from the model's own band."
msgstr ". Lower is tighter (more sensitive); the fit seeded this from the model's own band."

#: src/features/timeSeries/sentinelStudio/SentinelBuilderPanel.tsx
msgid ". The plots, metrics and served model are on the sentinel itself."
msgstr ". The plots, metrics and served model are on the sentinel itself."

#: src/features/timeSeries/sentinelStudio/SentinelBuilderPanel.tsx
msgid ". You can retry or build without it."
msgstr ". You can retry or build without it."

#: src/features/mdCases/components/ProvenanceContentViewer.tsx
msgid "· <0>edited</0>"
msgstr "· <0>edited</0>"

#: src/features/timeSeries/experiment/CorrelationCard.tsx
msgid "· applied "
msgstr "· applied "

#: src/features/knowledgeDocumentViewer/artifacts/ArtifactPanelHeader.tsx
msgid "· Downloaded {downloadedAgo}"
msgstr "· Downloaded {downloadedAgo}"

#: src/features/mdCases/components/ProvenanceContentViewer.tsx
msgid "· kind: <0>{kind}</0>"
msgstr "· kind: <0>{kind}</0>"

#: src/features/lotoReports/components/LotoPagePanelHeader.tsx
msgctxt "LOTO panel title"
msgid "· page {pageNumber}"
msgstr "· page {pageNumber}"

#: src/features/mdCases/components/ProvenanceContentViewer.tsx
msgid "· ref: <0/>"
msgstr "· ref: <0/>"

#: src/pages/processData/buildMode/dock/SamplingSection.tsx
msgid "· rows "
msgstr "· rows "

#: src/features/mdCases/components/ProvenanceContentViewer.tsx
msgid "· source: <0>{source}</0>"
msgstr "· source: <0>{source}</0>"

#: src/features/mdCases/components/ProvenanceContentViewer.tsx
msgid "· tag: <0>{tagDerived}</0>"
msgstr "· tag: <0>{tagDerived}</0>"

#: src/features/mdCases/components/ProvenanceContentViewer.tsx
msgid "· value: <0>{displayValue}</0>"
msgstr "· value: <0>{displayValue}</0>"

#: src/features/mdCases/components/ProvenanceContentViewer.tsx
msgid "· value: <0>null</0>"
msgstr "· value: <0>null</0>"

#: src/features/lotoReports/components/DeleteLotoReportButton.tsx
msgid "“{name}” will be removed for everyone at this site. The attached documents are not affected."
msgstr "“{name}” will be removed for everyone at this site. The attached documents are not affected."

#: src/features/knowledgeDocumentViewer/components/DocumentTabContent.tsx
msgid "\"{selfText}\" is this document's own drawing number"
msgstr "\"{selfText}\" is this document's own drawing number"

#: src/features/mdCases/components/ProvenanceContentViewer.tsx
msgid "(empty message)"
msgstr "(empty message)"

#: src/features/mdCases/components/ProvenanceContentViewer.tsx
msgid "(empty payload)"
msgstr "(empty payload)"

#: src/features/chatbot/components/conversationMessage/ProposalCard.tsx
#: src/features/mdCases/components/ProvenanceContentViewer.tsx
msgid "(empty)"
msgstr "(empty)"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/documentsCardView/DocumentCardResultCountLabel.tsx
msgid "(filtered from {totalCountLabel})"
msgstr "(filtered from {totalCountLabel})"

#: src/pages/assetLens/components/AssetHeader.tsx
msgid "(Manufacturer Unknown) {model}"
msgstr "(Manufacturer Unknown) {model}"

#: src/features/mdCases/components/ProvenanceContentViewer.tsx
msgid "(no content)"
msgstr "(no content)"

#: src/features/mdCases/components/ProvenanceContentViewer.tsx
msgid "(no description)"
msgstr "(no description)"

#: src/features/mdCases/components/ProvenanceContentViewer.tsx
msgid "(no evidence refs)"
msgstr "(no evidence refs)"

#: src/features/mdCases/components/ProvenanceContentViewer.tsx
#: src/features/mdCases/components/ProvenanceContentViewer.tsx
#: src/features/mdCases/components/ProvenanceContentViewer.tsx
#: src/features/mdCases/components/ProvenanceContentViewer.tsx
msgid "(no payload fields)"
msgstr "(no payload fields)"

#: src/features/mdCases/components/ProvenanceContentViewer.tsx
msgid "(no thresholds)"
msgstr "(no thresholds)"

#: src/features/mdCases/components/CaseTimeline.tsx
msgid "(occurred {occurredLabel})"
msgstr "(occurred {occurredLabel})"

#: src/features/mdCases/components/ProvenanceContentViewer.tsx
msgid "(payload not loaded)"
msgstr "(payload not loaded)"

#: src/features/timeSeries/sentinelStudio/SentinelBuilderPanel.tsx
msgid ") — change it with the range selector below the chart."
msgstr ") — change it with the range selector below the chart."

#: src/features/timeSeries/experiment/DiagnosticsPanel.tsx
msgid ") × err_scale ("
msgstr ") × err_scale ("

#: src/features/timeSeries/experiment/DiagnosticsPanel.tsx
msgid ") where err_scale ="
msgstr ") where err_scale ="

#: src/features/sentinels/components/RecentScorePanel.tsx
msgid "). No retraining."
msgstr "). No retraining."

#: src/features/timeSeries/experiment/DiagnosticsPanel.tsx
msgid "). Not per-day or per-point — one scalar per model."
msgstr "). Not per-day or per-point — one scalar per model."

#: src/features/chatbot/components/CitationTooltip.tsx
msgid "[{abbreviatedFile}, {abbreviatedSection}, p.{pageNumber}]"
msgstr "[{abbreviatedFile}, {abbreviatedSection}, p.{pageNumber}]"

#: src/features/richText/nodes/ImageNode.tsx
#: src/features/richText/nodes/ImageNode.tsx
msgid "[Image]"
msgstr "[Image]"

#: src/features/timeSeries/components/timeSeriesScatterplot/useUPlotGenerators.ts
msgid "[non-string-label]"
msgstr "[non-string-label]"

#. placeholder {0}: activeFilterPills.length
#: src/pages/cases/md/MdCasesListPage.tsx
msgid "{0, plural, one {# active filter} other {# active filters}}"
msgstr "{0, plural, one {# active filter} other {# active filters}}"

#. placeholder {0}: counts.alerts
#. placeholder {0}: target.alerts.length
#: src/features/chatbot/components/AttachmentPills.tsx
#: src/features/mdCases/components/ProvenanceContentViewer.tsx
msgid "{0, plural, one {# alert} other {# alerts}}"
msgstr "{0, plural, one {# alert} other {# alerts}}"

#. placeholder {0}: allAliasKeys.length
#: src/features/fimReview/ReviewActions.tsx
msgid "{0, plural, one {# alias} other {# aliases}}"
msgstr "{0, plural, one {# alias} other {# aliases}}"

#. placeholder {0}: dataIssues.length
#: src/pages/facilityModel/FacilityModelDataIssues.tsx
msgid "{0, plural, one {# Asset Instance not represented in the catalog} other {# Asset Instances not represented in the catalog}}"
msgstr "{0, plural, one {# Asset Instance not represented in the catalog} other {# Asset Instances not represented in the catalog}}"

#. placeholder {0}: props.numTotalUnitsAtSite
#: src/pages/overview/sidebar/assetTracker/SiteViewAssetTracker.tsx
msgid "{0, plural, one {# Asset} other {# Assets}}"
msgstr "{0, plural, one {# Asset} other {# Assets}}"

#. placeholder {0}: citation.region.boxes.length
#: src/pages/facilityModel/SubjectDetailPage.tsx
msgid "{0, plural, one {# box} other {# boxes}}"
msgstr "{0, plural, one {# box} other {# boxes}}"

#. placeholder {0}: mdCasesWithDiagnostics.length
#: src/pages/cases/md/MdCasesListPage.tsx
msgid "{0, plural, one {# case excluded due to M&D diagnostics.} other {# cases excluded due to M&D diagnostics.}}"
msgstr "{0, plural, one {# case excluded due to M&D diagnostics.} other {# cases excluded due to M&D diagnostics.}}"

#. placeholder {0}: slot.channel_count
#: src/pages/facilityModel/SubjectAssetPanel.tsx
msgid "{0, plural, one {# channel} other {# channels}}"
msgstr "{0, plural, one {# channel} other {# channels}}"

#. placeholder {0}: missing.length
#: src/features/fimReview/InspectSources.tsx
msgid "{0, plural, one {# constituent record is no longer in this site’s source data.} other {# constituent records are no longer in this site’s source data.}}"
msgstr "{0, plural, one {# constituent record is no longer in this site’s source data.} other {# constituent records are no longer in this site’s source data.}}"

#. placeholder {0}: counts.documents
#: src/features/chatbot/components/AttachmentPills.tsx
msgid "{0, plural, one {# doc} other {# docs}}"
msgstr "{0, plural, one {# doc} other {# docs}}"

#. placeholder {0}: conversation.turn_count
#. placeholder {0}: s.messageCount
#: src/features/mdCases/components/ProvenanceContentViewer.tsx
#: src/features/timeSeries/agentTab/chat/ConversationDrawer.tsx
msgid "{0, plural, one {# message} other {# messages}}"
msgstr "{0, plural, one {# message} other {# messages}}"

#. placeholder {0}: stats.open
#: src/pages/assetLens/components/tabs/AnomalyDashboard.tsx
msgid "{0, plural, one {# Open Anomaly} other {# Open Anomalies}}"
msgstr "{0, plural, one {# Open Anomaly} other {# Open Anomalies}}"

#. placeholder {0}: subjectLineage.length
#: src/features/fimReview/IdentityPanel.tsx
msgid "{0, plural, one {# prior Subject} other {# prior Subjects}}"
msgstr "{0, plural, one {# prior Subject} other {# prior Subjects}}"

#. placeholder {0}: models.length
#: src/features/timeSeries/agentTab/ModelPicker.tsx
msgid "{0, plural, one {# saved model} other {# saved models}}"
msgstr "{0, plural, one {# saved model} other {# saved models}}"

#. placeholder {0}: group.sites.length
#: src/pages/manageAccess/components/scope/SiteSelect.tsx
msgid "{0, plural, one {# site} other {# sites}}"
msgstr "{0, plural, one {# site} other {# sites}}"

#. placeholder {0}: alertCard.streamCount
#: src/pages/cases/md/MdCaseDetailsInspector.tsx
msgid "{0, plural, one {# stream} other {# streams}}"
msgstr "{0, plural, one {# stream} other {# streams}}"

#. placeholder {0}: p.after_subjects.length
#: src/features/fimReview/DecisionHistory.tsx
msgid "{0, plural, one {# subject} other {# subjects}}"
msgstr "{0, plural, one {# subject} other {# subjects}}"

#. placeholder {0}: subsystems.length
#: src/features/mdCases/components/ProvenanceContentViewer.tsx
msgid "{0, plural, one {# subsystem} other {# subsystems}}"
msgstr "{0, plural, one {# subsystem} other {# subsystems}}"

#. placeholder {0}: counts.tags
#: src/features/chatbot/components/AttachmentPills.tsx
msgid "{0, plural, one {# tag} other {# tags}}"
msgstr "{0, plural, one {# tag} other {# tags}}"

#. placeholder {0}: counts.timeWindows
#: src/features/chatbot/components/AttachmentPills.tsx
msgid "{0, plural, one {# time range} other {# time ranges}}"
msgstr "{0, plural, one {# time range} other {# time ranges}}"

#. placeholder {0}: candidateRows.length
#: src/pages/facilityModel/SubjectAssetPanel.tsx
msgid "{0, plural, one {# unconfirmed candidate} other {# unconfirmed candidates}}"
msgstr "{0, plural, one {# unconfirmed candidate} other {# unconfirmed candidates}}"

#. placeholder {0}: activityEvents.length
#: src/pages/cases/md/MdCaseDetailsMainColumn.tsx
msgid "{0, plural, one {# update} other {# updates}}"
msgstr "{0, plural, one {# update} other {# updates}}"

#. placeholder {0}: group.overflow.count
#. placeholder {0}: group.overflowCount
#: src/features/facilityModel/provenance/ProvenanceChain.tsx
#: src/features/facilityModel/provenance/ProvenanceChain.tsx
#: src/features/mdCases/components/CaseStorySection.tsx
msgid "{0, plural, one {+ # additional linked alert} other {+ # additional linked alerts}}"
msgstr "{0, plural, one {+ # additional linked alert} other {+ # additional linked alerts}}"

#. placeholder {0}: reviewSaves.failedCount
#: src/pages/nnpp/imports/NnppImportVerificationPage.tsx
msgid "{0, plural, one {A review did not save. Open it to retry or discard it.} other {# reviews did not save. Open them to retry or discard them.}}"
msgstr "{0, plural, one {A review did not save. Open it to retry or discard it.} other {# reviews did not save. Open them to retry or discard them.}}"

#. placeholder {0}: emails.length || 1
#: src/pages/manageAccess/components/invite/InviteUsersDialog.tsx
msgid "{0, plural, one {Invite} other {Invite # people}}"
msgstr "{0, plural, one {Invite} other {Invite # people}}"

#. placeholder {0}: folded.length
#: src/pages/facilityModel/SubjectAssetPanel.tsx
msgid "{0, plural, one {No evidence yet for # optional slot:} other {No evidence yet for # optional slots:}}"
msgstr "{0, plural, one {No evidence yet for # optional slot:} other {No evidence yet for # optional slots:}}"

#. placeholder {0}: inspectionReports.length
#: src/pages/details/extensions/flow/FilesExtension.tsx
msgid "{0, plural, one {Report} other {Reports}}"
msgstr "{0, plural, one {Report} other {Reports}}"

#. placeholder {0}: subjectLineage.length
#: src/features/fimReview/IdentityPanel.tsx
msgid "{0, plural, one {This Subject includes records that previously belonged to another Subject.} other {This Subject includes records that previously belonged to # other Subjects.}}"
msgstr "{0, plural, one {This Subject includes records that previously belonged to another Subject.} other {This Subject includes records that previously belonged to # other Subjects.}}"

#. placeholder {0}: selected.length
#: src/pages/evaluations/metadata/labeling/components/DataLabelingTypeFilter.tsx
msgid "{0, plural, one {Type: #} other {Types: #}}"
msgstr "{0, plural, one {Type: #} other {Types: #}}"

#: src/features/timeSeries/experiment/CorrelationCard.tsx
msgid "{abs} × {interval}{value121_36} = {value122_7}h"
msgstr "{abs} × {interval}{value121_36} = {value122_7}h"

#: src/features/timeSeries/experiment/CorrelationCard.tsx
msgid "{abs} × {interval}{value127_36} = {value128_7}min"
msgstr "{abs} × {interval}{value127_36} = {value128_7}min"

#: src/features/timeSeries/experiment/CorrelationCard.tsx
msgid "{abs} × {interval}s = {seconds}s"
msgstr "{abs} × {interval}s = {seconds}s"

#: src/pages/cases/md/MdCasesListPage.tsx
msgid "{activeCount} active"
msgstr "{activeCount} active"

#: src/features/knowledgeDocumentViewer/components/viewer/search/IntraDocSearchBar.tsx
msgid "{activeHitNumber} of {hitCount}"
msgstr "{activeHitNumber} of {hitCount}"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatRevisionDiffCard.tsx
msgid "{added} added"
msgstr "{added} added"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsMoney.ts
msgid "{amount} (currency not supplied)"
msgstr "{amount} (currency not supplied)"

#: src/pages/assetLens/components/tabs/timeSeriesAnalysis/TimeSeriesSidebar.tsx
msgid "{anomalyCount, plural, one {# anomaly detected in current timeframe} other {# anomalies detected in current timeframe}}"
msgstr "{anomalyCount, plural, one {# anomaly detected in current timeframe} other {# anomalies detected in current timeframe}}"

#: src/pages/cases/md/MdCasesListPage.tsx
msgid "{archivedCount} archived"
msgstr "{archivedCount} archived"

#: src/features/timeSeries/agentTab/chat/BuildCard.tsx
msgid "{axis} axis"
msgstr "{axis} axis"

#: src/features/timeSeries/agentTab/chat/BuildCard.tsx
msgid "{baselineRows} baseline rows · data through {dataThrough}"
msgstr "{baselineRows} baseline rows · data through {dataThrough}"

#: src/pages/facilityModel/SubjectAssetPanel.tsx
msgid "{boundSlots} of {slotCount}"
msgstr "{boundSlots} of {slotCount}"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatInspectionCard.tsx
msgid "{capCount} bins reached the calculation cap. These are not precise life estimates."
msgstr "{capCount} bins reached the calculation cap. These are not precise life estimates."

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatRevisionDiffCard.tsx
msgid "{changed} changed"
msgstr "{changed} changed"

#: src/features/mdCases/components/ProvenanceContentViewer.tsx
msgid "{checkCount} · {signals} signals"
msgstr "{checkCount} · {signals} signals"

#: src/features/mdCases/components/ProvenanceContentViewer.tsx
msgid "{checks, plural, one {# check} other {# checks}}"
msgstr "{checks, plural, one {# check} other {# checks}}"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/EvidenceChip.tsx
msgid "{chipLabel} · p.{pageNum}"
msgstr "{chipLabel} · p.{pageNum}"

#: src/features/knowledgeDocumentViewer/components/sidebar/OcrTable.tsx
msgid "{count, plural, one {# Connected Asset} other {# Connected Assets}}"
msgstr "{count, plural, one {# Connected Asset} other {# Connected Assets}}"

#: src/features/kestrelViewer/labelOverlay/LabelOverlayLayer.tsx
msgid "{count, plural, one {# label} other {# labels}}"
msgstr "{count, plural, one {# label} other {# labels}}"

#: src/features/knowledgeDocumentViewer/artifacts/artifactText.ts
msgid "{count, plural, one {# open item} other {# open items}}"
msgstr "{count, plural, one {# open item} other {# open items}}"

#: src/features/fimReview/StructuralReviewFlow.tsx
msgid "{count, plural, one {# record} other {# records}}"
msgstr "{count, plural, one {# record} other {# records}}"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/utils/docChatText.ts
msgid "{count, plural, one {# result} other {# results}}"
msgstr "{count, plural, one {# result} other {# results}}"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/utils/docChatText.ts
msgid "{count, plural, one {Retrieved # source} other {Retrieved # sources}}"
msgstr "{count, plural, one {Retrieved # source} other {Retrieved # sources}}"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatRevisionMissingCard.tsx
msgid "{count} available"
msgstr "{count} available"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatRevisionMissingCard.tsx
msgid "{count} missing"
msgstr "{count} missing"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatRevisionMissingCard.tsx
msgid "{count} need review (not counted as missing)"
msgstr "{count} need review (not counted as missing)"

#: src/pages/evaluations/metadata/dashboard/components/dataLabeling/DataLabelingDashboardSummaryCards.tsx
msgid "{coverage} of pages have a human confirmation"
msgstr "{coverage} of pages have a human confirmation"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatTagPickerCard.tsx
msgid "{current} of {total}"
msgstr "{current} of {total}"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/documentsCardView/PaginationControls.tsx
msgid "{currentPageNumber} of {totalPages}"
msgstr "{currentPageNumber} of {totalPages}"

#: src/features/knowledgeDocumentViewer/components/toolbar/SearchResultsNavigator.tsx
msgid "{currentPosition} of {totalCount}"
msgstr "{currentPosition} of {totalCount}"

#: src/pages/manageAccess/components/invite/InviteUsersDialog.tsx
msgid "{currentTypeLabel} — User type"
msgstr "{currentTypeLabel} — User type"

#: src/pages/manageAccess/components/userType/UserTypeSelect.tsx
msgid "{currentTypeLabel} — user type for {personName}"
msgstr "{currentTypeLabel} — user type for {personName}"

#: src/features/modelOperations/fimShared.ts
msgid "{day}d ago"
msgstr "{day}d ago"

#: src/features/fimReview/relativeTime.ts
msgid "{days}d ago"
msgstr "{days}d ago"

#: src/features/timeSeries/agentTab/dock/AlertingTab.tsx
msgid "{daysBeyond}/{ofDays} days"
msgstr "{daysBeyond}/{ofDays} days"

#: src/features/kestrelUpload/KestrelModelUploadSection.tsx
msgid "{deleted} file(s) deleted, {failed} failed. Retry to delete the remaining files."
msgstr "{deleted} file(s) deleted, {failed} failed. Retry to delete the remaining files."

#: src/features/mdCases/components/ProvenanceContentViewer.tsx
msgid "{docs, plural, one {# doc} other {# docs}}"
msgstr "{docs, plural, one {# doc} other {# docs}}"

#: src/features/lotoReports/components/LotoSessionOtherPages.tsx
msgid "{document} · page {pageNumber}"
msgstr "{document} · page {pageNumber}"

#: src/features/lotoReports/components/LotoIsolationPointRow.tsx
#: src/features/lotoReports/components/LotoSheetOpenOnDrawing.tsx
msgid "{document} p.{pageNumber}"
msgstr "{document} p.{pageNumber}"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/AgenticInlineDocumentResults.tsx
msgid "{documentCount, plural, one {# source} other {# sources}}"
msgstr "{documentCount, plural, one {# source} other {# sources}}"

#: src/features/lotoReports/components/LotoPagePanelHeader.tsx
msgid "{documentName} · page {pageNumber}"
msgstr "{documentName} · page {pageNumber}"

#: src/features/lotoReports/components/LotoDrawingsCoverage.tsx
msgid "{drawingName} p.{pageList}"
msgstr "{drawingName} p.{pageList}"

#: src/features/lotoReports/components/LotoTargetDrawings.tsx
msgid "{drawingNumber} · page {pageNumber}"
msgstr "{drawingNumber} · page {pageNumber}"

#: src/features/timeSeries/agentTab/dock/VersionsTab.tsx
msgid "{driverCount} drivers"
msgstr "{driverCount} drivers"

#: src/pages/cases/md/MdCaseDetailsProvider.tsx
msgid "{entryTypeLabel} Updated"
msgstr "{entryTypeLabel} Updated"

#: src/features/kestrelUpload/KestrelModelUploadSection.tsx
msgid "{existingFileCount} files"
msgstr "{existingFileCount} files"

#: src/pages/details/extensions/DetailsPageExtensionsProvider.tsx
#: src/pages/details/extensions/DetailsPageExtensionsProvider.tsx
#: src/pages/details/extensions/DetailsPageExtensionsProvider.tsx
msgid "{extensionTitle} Error"
msgstr "{extensionTitle} Error"

#: src/features/knowledgeDocumentViewer/components/viewer/shared/SparklineTooltipContent.tsx
msgid "{extraDatapointCount, plural, one {+# more datapoint} other {+# more datapoints}}"
msgstr "{extraDatapointCount, plural, one {+# more datapoint} other {+# more datapoints}}"

#: src/features/mdCases/components/CaseTimeline.tsx
msgid "{fieldLabel} updated"
msgstr "{fieldLabel} updated"

#: src/features/powerCustomerUploads/components/PowerCustomerUploadAttachments.tsx
msgid "{fileCount, plural, one {# file} other {# files}}"
msgstr "{fileCount, plural, one {# file} other {# files}}"

#: src/features/powerCustomerUploads/components/PowerCustomerUploadHistoryPanel.tsx
msgid "{fileCount, plural, one {# file} other {# files}} · {createdAt}"
msgstr "{fileCount, plural, one {# file} other {# files}} · {createdAt}"

#: src/features/powerCustomerUploads/components/powerCustomerUploadHistoryPresentation.ts
msgid "{filename} + {remainingCount} more"
msgstr "{filename} + {remainingCount} more"

#: src/features/facilityModel/columns.ts
msgid "{filledCount} filled, {gapCount} gaps of {totalCount}"
msgstr "{filledCount} filled, {gapCount} gaps of {totalCount}"

#: src/features/powerCustomerUploads/components/powerCustomerUploadProgressModel.ts
msgid "{finishedUploadAttemptCountLabel} / {expectedUploadCountLabel} files · {uploadedPercent}%"
msgstr "{finishedUploadAttemptCountLabel} / {expectedUploadCountLabel} files · {uploadedPercent}%"

#: src/features/chatbot/components/conversationMessage/AIResponseExtras.tsx
#: src/features/chatbot/components/StreamingReferences.tsx
msgid "{first} +{rest} more"
msgstr "{first} +{rest} more"

#: src/features/powerCustomerUploads/components/PowerCustomerUploadReviewTablePagination.tsx
msgid "{firstVisibleRowLabel}-{lastVisibleRowLabel} of {totalRows}"
msgstr "{firstVisibleRowLabel}-{lastVisibleRowLabel} of {totalRows}"

#: src/features/powerCustomerUploads/components/PowerCustomerUploadAttachments.tsx
msgid "{folderCount, plural, one {# folder} other {# folders}}"
msgstr "{folderCount, plural, one {# folder} other {# folders}}"

#: src/pages/assetLens/components/tabs/imagesTabComponents/ImageTrendAnalysis.tsx
msgid "{formatted} °F"
msgstr "{formatted} °F"

#: src/pages/assetLens/components/tabs/imagesTabComponents/ImageTrendAnalysis.tsx
msgid "{formatted} dB"
msgstr "{formatted} dB"

#: src/pages/evaluations/metadata/components/MetricsContent.tsx
msgid "{formatted} pts vs {versionLabel}"
msgstr "{formatted} pts vs {versionLabel}"

#: src/pages/evaluations/metadata/components/MetricsContent.tsx
msgid "{formatted} pts vs previous config"
msgstr "{formatted} pts vs previous config"

#: src/pages/assetLens/components/tabs/imagesTabComponents/ImageTrendAnalysis.tsx
msgid "{formatted}%"
msgstr "{formatted}%"

#: src/pages/assetLens/components/tabs/imagesTabComponents/ImageTrendAnalysis.tsx
msgid "{formatted}°F"
msgstr "{formatted}°F"

#: src/features/mdCases/mdCaseDisplay.ts
msgid "{fromLabel} -> {toLabel}"
msgstr "{fromLabel} -> {toLabel}"

#: src/pages/details/visualization/alerts/specificAlerts/DuplicateCDFAlert.tsx
msgid "{groupCount, plural, one {Found {totalDuplicates} CDFs with identical parameters in # group} other {Found {totalDuplicates} CDFs with identical parameters in # groups}}"
msgstr "{groupCount, plural, one {Found {totalDuplicates} CDFs with identical parameters in # group} other {Found {totalDuplicates} CDFs with identical parameters in # groups}}"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatRevisionDiffCard.tsx
msgid "{headline} ({impact} impact)"
msgstr "{headline} ({impact} impact)"

#: src/features/timeSeries/agentTab/AgentHeader.tsx
msgid "{hidablePenCount, plural, one {Hide the # tag pen, leaving the KPI and its expectation} other {Hide all # tag pens, leaving the KPI and its expectation}}"
msgstr "{hidablePenCount, plural, one {Hide the # tag pen, leaving the KPI and its expectation} other {Hide all # tag pens, leaving the KPI and its expectation}}"

#: src/features/timeSeries/agentTab/AgentHeader.tsx
msgid "{hidablePenCount, plural, one {Show the # tag pen again} other {Show the # tag pens again}}"
msgstr "{hidablePenCount, plural, one {Show the # tag pen again} other {Show the # tag pens again}}"

#: src/features/fimEvidence/SubjectGlyphs.tsx
#: src/features/modelOperations/Corroboration.tsx
msgid "{hitCount}-source"
msgstr "{hitCount}-source"

#: src/features/timeSeries/agentTab/dock/TargetTab.tsx
msgid "{hours} h"
msgstr "{hours} h"

#: src/features/timeSeries/sentinelStudio/SentinelBuilderPanel.tsx
msgid "{hours} hour{value138_27} ago"
msgstr "{hours} hour{value138_27} ago"

#: src/features/fimReview/relativeTime.ts
msgid "{hours}h ago"
msgstr "{hours}h ago"

#: src/features/timeSeries/agentTab/chat/BuildCard.tsx
#: src/features/timeSeries/agentTab/useAgentView.ts
msgid "{hours}h rolling average of {tag}"
msgstr "{hours}h rolling average of {tag}"

#: src/features/modelOperations/fimShared.ts
msgid "{hr}h ago"
msgstr "{hr}h ago"

#: src/features/timeSeries/agentTab/chat/TagLinkedMarkdown.tsx
msgid "{id} · add to the chart"
msgstr "{id} · add to the chart"

#: src/features/timeSeries/agentTab/chat/TagLinkedMarkdown.tsx
msgid "{id} · on the chart"
msgstr "{id} · on the chart"

#: src/pages/manageAccess/components/dialogs/ConfirmUserTypeChangeDialog.tsx
msgid "{inviteCount, plural, one {Invite {personName} as an administrator?} other {Invite these # people as administrators?}}"
msgstr "{inviteCount, plural, one {Invite {personName} as an administrator?} other {Invite these # people as administrators?}}"

#: src/pages/assetLens/components/tabs/SensorIssuesTab.tsx
msgid "{issueCount} of {issueCount} issues"
msgstr "{issueCount} of {issueCount} issues"

#: src/features/fimReview/InspectSources.tsx
msgid "{kind} · {precision} · norm: {norm}"
msgstr "{kind} · {precision} · norm: {norm}"

#: src/features/knowledgeDocumentViewer/artifacts/pdf/PdfFooter.tsx
msgid "{label} · Page {pageNumber} of {totalPages}"
msgstr "{label} · Page {pageNumber} of {totalPages}"

#: src/features/knowledgeDocumentViewer/components/sidebar/RelatedDocumentsTable.tsx
msgid "{label} (You are here)"
msgstr "{label} (You are here)"

#: src/features/modelOperations/SubjectDetails.tsx
msgid "{label} failed: {reason}"
msgstr "{label} failed: {reason}"

#: src/features/assetVizAdapter/MeasurementStrip.tsx
msgid "{label} information"
msgstr "{label} information"

#: src/pages/manageAccess/components/invite/InviteRoleGroup.tsx
msgid "{label} is required for every invitation and cannot be removed."
msgstr "{label} is required for every invitation and cannot be removed."

#: src/features/knowledgeDocumentViewer/utils/sharedMetadataFieldBridge.ts
msgid "{leading}, and {last}"
msgstr "{leading}, and {last}"

#: src/features/mdCases/components/ProvenanceContentViewer.tsx
msgid "{linkedDocsCount, plural, one {# linked document} other {# linked documents}}"
msgstr "{linkedDocsCount, plural, one {# linked document} other {# linked documents}}"

#: src/features/knowledgeDocumentViewer/components/viewer/shared/OffPageConnectorTooltip.tsx
msgid "{linkedDocumentCount} linked documents"
msgstr "{linkedDocumentCount} linked documents"

#: src/features/timeSeries/services/thresholdService.ts
msgid "{lowerName} threshold ({lowerValue}) must be less than {upperName} threshold ({upperValue})"
msgstr "{lowerName} threshold ({lowerValue}) must be less than {upperName} threshold ({upperValue})"

#: src/features/mdCases/components/CaseStorySection.tsx
msgid "{magnitudeLabel}× band"
msgstr "{magnitudeLabel}× band"

#: src/pages/assetLens/components/AssetHeader.tsx
msgid "{manufacturer} (Model Unknown)"
msgstr "{manufacturer} (Model Unknown)"

#: src/features/knowledgeDocumentViewer/components/viewer/search/DocReferencePreviewCard.tsx
msgid "{matchCount} matching documents — click to choose"
msgstr "{matchCount} matching documents — click to choose"

#: src/features/knowledgeDocumentViewer/components/metadata/RevisionAuditBadge.tsx
msgid "{matchedCount} matched in system"
msgstr "{matchedCount} matched in system"

#: src/features/knowledgeDocumentViewer/components/metadata/RevisionAuditBadge.tsx
msgid "{matchedCount} matched in system · {unmatchedCount} may be missing"
msgstr "{matchedCount} matched in system · {unmatchedCount} may be missing"

#: src/pages/assetLens/components/tabs/imagesTabComponents/ImageGalleryView.tsx
msgid "{maxDecibel} dB"
msgstr "{maxDecibel} dB"

#: src/pages/assetLens/components/tabs/imagesTabComponents/ImageGalleryView.tsx
msgid "{maxTemp}°F"
msgstr "{maxTemp}°F"

#: src/features/modelOperations/fimShared.ts
msgid "{min}m ago"
msgstr "{min}m ago"

#: src/features/fimReview/relativeTime.ts
msgid "{mins}m ago"
msgstr "{mins}m ago"

#: src/features/timeSeries/agentTab/dock/TargetTab.tsx
msgid "{minutes} min"
msgstr "{minutes} min"

#: src/features/timeSeries/sentinelStudio/SentinelBuilderPanel.tsx
msgid "{minutes} minute{value136_49} ago"
msgstr "{minutes} minute{value136_49} ago"

#: src/features/chatbot/components/conversationMessage/AIResponseExtras.tsx
msgid "{minutes}m"
msgstr "{minutes}m"

#: src/features/chatbot/components/conversationMessage/AIResponseExtras.tsx
msgid "{minutes}m {remainingSeconds}s"
msgstr "{minutes}m {remainingSeconds}s"

#: src/features/fim/matchingRuns.ts
msgid "{minutes}m {seconds}s"
msgstr "{minutes}m {seconds}s"

#: src/features/timeSeries/agentTab/useActiveModel.ts
msgid "{modelName} · expected ±{bandSigmas}σ"
msgstr "{modelName} · expected ±{bandSigmas}σ"

#: src/features/modelOperations/fimShared.ts
msgid "{mon}mo ago"
msgstr "{mon}mo ago"

#: src/pages/metrics/helpers/monthly.ts
msgid "{monthLabel} MTD"
msgstr "{monthLabel} MTD"

#: src/features/timeSeries/agentTab/toolSentence.ts
msgid "{n, plural, one {Checked data coverage on # tag} other {Checked data coverage on # tags}}"
msgstr "{n, plural, one {Checked data coverage on # tag} other {Checked data coverage on # tags}}"

#: src/features/timeSeries/agentTab/toolSentence.ts
msgid "{n, plural, one {Checking data coverage on # tag} other {Checking data coverage on # tags}}"
msgstr "{n, plural, one {Checking data coverage on # tag} other {Checking data coverage on # tags}}"

#: src/features/timeSeries/agentTab/toolSentence.ts
msgid "{n, plural, one {Cross-checked # tag against each other} other {Cross-checked # tags against each other}}"
msgstr "{n, plural, one {Cross-checked # tag against each other} other {Cross-checked # tags against each other}}"

#: src/features/timeSeries/agentTab/toolSentence.ts
msgid "{n, plural, one {Cross-checking # tag against each other} other {Cross-checking # tags against each other}}"
msgstr "{n, plural, one {Cross-checking # tag against each other} other {Cross-checking # tags against each other}}"

#: src/features/timeSeries/agentTab/toolSentence.ts
msgid "{n, plural, one {Fitted {kpi} against # driver} other {Fitted {kpi} against # drivers}}"
msgstr "{n, plural, one {Fitted {kpi} against # driver} other {Fitted {kpi} against # drivers}}"

#: src/features/timeSeries/agentTab/toolSentence.ts
msgid "{n, plural, one {Fitted the model against # driver} other {Fitted the model against # drivers}}"
msgstr "{n, plural, one {Fitted the model against # driver} other {Fitted the model against # drivers}}"

#: src/features/timeSeries/agentTab/toolSentence.ts
msgid "{n, plural, one {Fitting {kpi} against # driver} other {Fitting {kpi} against # drivers}}"
msgstr "{n, plural, one {Fitting {kpi} against # driver} other {Fitting {kpi} against # drivers}}"

#: src/features/timeSeries/agentTab/toolSentence.ts
msgid "{n, plural, one {Fitting the model against # driver} other {Fitting the model against # drivers}}"
msgstr "{n, plural, one {Fitting the model against # driver} other {Fitting the model against # drivers}}"

#: src/features/timeSeries/agentTab/toolSentence.ts
msgid "{n, plural, one {Pulled # tag into {dataset}} other {Pulled # tags into {dataset}}}"
msgstr "{n, plural, one {Pulled # tag into {dataset}} other {Pulled # tags into {dataset}}}"

#: src/features/timeSeries/agentTab/toolSentence.ts
msgid "{n, plural, one {Pulled # tag} other {Pulled # tags}}"
msgstr "{n, plural, one {Pulled # tag} other {Pulled # tags}}"

#: src/features/timeSeries/agentTab/toolSentence.ts
msgid "{n, plural, one {Pulling # tag into {dataset}} other {Pulling # tags into {dataset}}}"
msgstr "{n, plural, one {Pulling # tag into {dataset}} other {Pulling # tags into {dataset}}}"

#: src/features/timeSeries/agentTab/toolSentence.ts
msgid "{n, plural, one {Pulling # tag} other {Pulling # tags}}"
msgstr "{n, plural, one {Pulling # tag} other {Pulling # tags}}"

#: src/features/timeSeries/agentTab/toolSentence.ts
msgid "{n, plural, one {Tested # date for step changes in {kpi}} other {Tested # dates for step changes in {kpi}}}"
msgstr "{n, plural, one {Tested # date for step changes in {kpi}} other {Tested # dates for step changes in {kpi}}}"

#: src/features/timeSeries/agentTab/toolSentence.ts
msgid "{n, plural, one {Tested # date for step changes} other {Tested # dates for step changes}}"
msgstr "{n, plural, one {Tested # date for step changes} other {Tested # dates for step changes}}"

#: src/features/timeSeries/agentTab/toolSentence.ts
msgid "{n, plural, one {Testing # date for step changes in {kpi}} other {Testing # dates for step changes in {kpi}}}"
msgstr "{n, plural, one {Testing # date for step changes in {kpi}} other {Testing # dates for step changes in {kpi}}}"

#: src/features/timeSeries/agentTab/toolSentence.ts
msgid "{n, plural, one {Testing # date for step changes} other {Testing # dates for step changes}}"
msgstr "{n, plural, one {Testing # date for step changes} other {Testing # dates for step changes}}"

#: src/features/knowledgeDocumentViewer/utils/textHelpers.ts
msgid "{normalizedDrawingNumber} - s.{normalizedSheetNumber}"
msgstr "{normalizedDrawingNumber} - s.{normalizedSheetNumber}"

#: src/features/lotoReports/components/LotoDrawingsCoverage.tsx
msgid "{pageCount, plural, one {# page} other {# pages}}"
msgstr "{pageCount, plural, one {# page} other {# pages}}"

#: src/features/powerCustomerUploads/components/PowerCustomerUploadReviewTablePagination.tsx
msgid "{pageSize, plural, one {# row} other {# rows}}"
msgstr "{pageSize, plural, one {# row} other {# rows}}"

#: src/pages/facilityModel/FacilityModelCatalog.tsx
msgid "{pageStartText}–{pageEndText} of {activeTotalText}"
msgstr "{pageStartText}–{pageEndText} of {activeTotalText}"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatTrendCard.tsx
msgid "{penCount, plural, one {# pen} other {# pens}}"
msgstr "{penCount, plural, one {# pen} other {# pens}}"

#: src/features/timeSeries/components/timeSeriesScatterplot/TimeSeriesScatterplotChart.tsx
msgid "{penCount, plural, one {Fetching # pen — this can take a moment.} other {Fetching # pens — this can take a moment.}}"
msgstr "{penCount, plural, one {Fetching # pen — this can take a moment.} other {Fetching # pens — this can take a moment.}}"

#: src/features/timeSeries/components/timeSeriesScatterplot/TimeSeriesScatterplotChart.tsx
msgid "{penCount, plural, one {Fetching # pen.} other {Fetching # pens.}}"
msgstr "{penCount, plural, one {Fetching # pen.} other {Fetching # pens.}}"

#: src/features/mdCases/components/ProvenanceContentViewer.tsx
msgid "{piTags} PI tags · {regimeCount} regimes · {specsNeededCount} specs needed · {manualsNeeded} manuals needed"
msgstr "{piTags} PI tags · {regimeCount} regimes · {specsNeededCount} specs needed · {manualsNeeded} manuals needed"

#: src/features/lotoReports/components/LotoProposalCard.tsx
msgid "{pointCount, plural, one {# isolation point, in hang order} other {# isolation points, in hang order}}"
msgstr "{pointCount, plural, one {# isolation point, in hang order} other {# isolation points, in hang order}}"

#: src/features/lotoReports/components/LotoPageCard.tsx
msgid "{pointCount, plural, one {# isolation point} other {# isolation points}}"
msgstr "{pointCount, plural, one {# isolation point} other {# isolation points}}"

#: src/features/facilityModel/components/ReferencePreviewPanel.tsx
msgid "{position} of {total} · p. {pageNumber}"
msgstr "{position} of {total} · p. {pageNumber}"

#: src/features/powerCustomerUploads/components/powerCustomerUploadProgressModel.ts
msgid "{preparedPercent}% - {duplicateSkippedCount, plural, one {# duplicate skipped} other {# duplicates skipped}}"
msgstr "{preparedPercent}% - {duplicateSkippedCount, plural, one {# duplicate skipped} other {# duplicates skipped}}"

#: src/features/powerCustomerUploads/components/powerCustomerUploadProgressModel.ts
msgid "{preparedPercent}% complete"
msgstr "{preparedPercent}% complete"

#: src/features/fimReview/IdentityPanel.tsx
msgid "{priorSubjectsLabel}; collapse the list"
msgstr "{priorSubjectsLabel}; collapse the list"

#: src/features/fimReview/IdentityPanel.tsx
msgid "{priorSubjectsLabel}; expand the list"
msgstr "{priorSubjectsLabel}; expand the list"

#: src/features/fimReview/IdentityPanel.tsx
msgid "{referenceCount, plural, one {# reference} other {# references}}"
msgstr "{referenceCount, plural, one {# reference} other {# references}}"

#: src/features/fimReview/IdentityPanel.tsx
msgid "{referenceCountLabel}; collapse {aliasValue}"
msgstr "{referenceCountLabel}; collapse {aliasValue}"

#: src/features/fimReview/IdentityPanel.tsx
msgid "{referenceCountLabel}; expand {aliasValue}"
msgstr "{referenceCountLabel}; expand {aliasValue}"

#: src/features/facilityModel/components/ReferencePreviewPanel.tsx
msgid "{referenceLabel}, page {pageNumber}"
msgstr "{referenceLabel}, page {pageNumber}"

#: src/pages/manageAccess/components/invite/InviteUsersDialog.tsx
msgid "{rejectedEmails} do not look like email addresses."
msgstr "{rejectedEmails} do not look like email addresses."

#: src/pages/manageAccess/components/invite/InviteUsersDialog.tsx
msgid "{rejectedEmails} does not look like an email address."
msgstr "{rejectedEmails} does not look like an email address."

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatRevisionDiffCard.tsx
msgid "{removed} removed"
msgstr "{removed} removed"

#: src/components/SearchBar.tsx
msgid "{resultCount, plural, =0 {No results} one {# result} other {# results}}"
msgstr "{resultCount, plural, =0 {No results} one {# result} other {# results}}"

#: src/pages/facilityModel/SubjectAssetPanel.tsx
msgid "{reviewSlots, plural, one {# slot awaiting adjudication} other {# slots awaiting adjudication}}"
msgstr "{reviewSlots, plural, one {# slot awaiting adjudication} other {# slots awaiting adjudication}}"

#: src/pages/manageAccess/components/table/RoleGroupCells.tsx
msgid "{roleLabel} — {personName}"
msgstr "{roleLabel} — {personName}"

#: src/features/chatbot/components/conversationMessage/AIResponseExtras.tsx
#: src/features/fim/matchingRuns.ts
msgid "{seconds}s"
msgstr "{seconds}s"

#: src/features/knowledgeDocumentViewer/components/table/GeckoPowerTable.tsx
msgid "{selectedCount} {name} Selected"
msgstr "{selectedCount} {name} Selected"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/documentsCardView/documentCardFilterBar/MultiSelectFilterField.tsx
msgid "{selectedCount} selected"
msgstr "{selectedCount} selected"

#: src/features/knowledgeDocumentViewer/components/DocumentUnavailablePanel.tsx
msgid "{selectedPipelineConfigId} · preview"
msgstr "{selectedPipelineConfigId} · preview"

#: src/features/knowledgeDocumentViewer/components/table/enhancements/BulkEditModal.tsx
msgid "{selectedRowCount, plural, one {# row selected} other {# rows selected}}"
msgstr "{selectedRowCount, plural, one {# row selected} other {# rows selected}}"

#: src/components/table/TableComponent.tsx
msgid "{selectedRowCount} {footerName} Selected"
msgstr "{selectedRowCount} {footerName} Selected"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/utils/docChatText.ts
msgid "{seriesCount, plural, one {# datapoint} other {# datapoints}}"
msgstr "{seriesCount, plural, one {# datapoint} other {# datapoints}}"

#: src/pages/cases/md/MdCaseDetailsInspector.tsx
msgid "{severityLabel} severity"
msgstr "{severityLabel} severity"

#: src/pages/cases/md/MdCasesListPage.tsx
msgid "{shelvedCount} shelved"
msgstr "{shelvedCount} shelved"

#: src/features/timeSeries/regressionHelpers.ts
msgid "{sign} {coefStr}t^{i}"
msgstr "{sign} {coefStr}t^{i}"

#: src/features/powerCustomerUploads/components/powerCustomerUploadProgressModel.ts
msgid "{stagedCount, plural, one {# file} other {# files}} · {selectedBytesLabel}"
msgstr "{stagedCount, plural, one {# file} other {# files}} · {selectedBytesLabel}"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatTagPickerCard.tsx
msgid "{stagedCount} tags selected — they will apply to your next message."
msgstr "{stagedCount} tags selected — they will apply to your next message."

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatTagPickerCard.tsx
msgid "{stagedLabel} selected — it will apply to your next message."
msgstr "{stagedLabel} selected — it will apply to your next message."

#: src/pages/manageAccess/components/table/UsersTablePager.tsx
msgid "{start}–{end} of {total}"
msgstr "{start}–{end} of {total}"

#: src/pages/cases/md/mdCaseDetailsHelpers.ts
msgid "{startAt} -> {endAt}"
msgstr "{startAt} -> {endAt}"

#: src/features/powerCustomerUploads/components/PowerCustomerUploadProgressPanel.tsx
msgid "{stepLabel} progress"
msgstr "{stepLabel} progress"

#: src/features/mdCases/components/ProvenanceContentViewer.tsx
#: src/features/mdCases/components/ProvenanceContentViewer.tsx
msgid "{streamCount, plural, one {# stream} other {# streams}}"
msgstr "{streamCount, plural, one {# stream} other {# streams}}"

#: src/features/timeSeries/agentTab/toolSentence.ts
msgid "{subject}, smoothed over {days} days"
msgstr "{subject}, smoothed over {days} days"

#: src/pages/facilityModel/SubjectDetailPage.tsx
msgid "{subjectName} trends"
msgstr "{subjectName} trends"

#: src/features/mdCases/components/ProvenanceContentViewer.tsx
msgid "{subsystemCount} · {equipmentCount} equipment · {outputs} primary outputs"
msgstr "{subsystemCount} · {equipmentCount} equipment · {outputs} primary outputs"

#: src/features/workspaceTabs/components/WorkspaceTabSwitcher.tsx
msgid "{tabCount, plural, one {{activeLabel}. # open tab} other {{activeLabel}. # open tabs}}"
msgstr "{tabCount, plural, one {{activeLabel}. # open tab} other {{activeLabel}. # open tabs}}"

#: src/features/lotoReports/components/LotoSortablePoints.tsx
msgid "{tag} dropped at position {position} of {count}."
msgstr "{tag} dropped at position {position} of {count}."

#: src/features/lotoReports/components/LotoSortablePoints.tsx
msgid "{tag} moved to position {position} of {count}."
msgstr "{tag} moved to position {position} of {count}."

#: src/features/mdCases/components/ProvenanceContentViewer.tsx
msgid "{tags} PI tags"
msgstr "{tags} PI tags"

#: src/features/knowledgeDocumentViewer/components/toolbar/OutlineUnitList.tsx
msgid "{title} — page {startPage}"
msgstr "{title} — page {startPage}"

#: src/features/knowledgeDocumentViewer/components/toolbar/OutlineUnitList.tsx
msgid "{title} — pages {startPage}–{endPage}"
msgstr "{title} — pages {startPage}–{endPage}"

#: src/pages/facilityModel/SubjectAssetPanel.tsx
msgid "{title} (optional)"
msgstr "{title} (optional)"

#: src/features/knowledgeDocumentViewer/artifacts/artifactText.ts
msgid "{title} drafted"
msgstr "{title} drafted"

#: src/features/knowledgeDocumentViewer/components/metadata/RevisionFamilyCard.tsx
msgid "{title} selected"
msgstr "{title} selected"

#: src/features/knowledgeDocumentViewer/artifacts/artifactText.ts
msgid "{title} updated"
msgstr "{title} updated"

#: src/features/knowledgeDocumentViewer/artifacts/artifactText.ts
msgid "{title} updated · {changedSections, plural, one {# section changed} other {# sections changed}}"
msgstr "{title} updated · {changedSections, plural, one {# section changed} other {# sections changed}}"

#: src/features/embeddedSidebar/chatHistory/AgenticChatHistorySessionRow.tsx
msgid "{title}, new reply"
msgstr "{title}, new reply"

#: src/features/embeddedSidebar/chatHistory/AgenticChatHistorySessionRow.tsx
msgid "{title}, pinned"
msgstr "{title}, pinned"

#: src/features/embeddedSidebar/chatHistory/AgenticChatHistorySessionRow.tsx
msgid "{title}, pinned, new reply"
msgstr "{title}, pinned, new reply"

#: src/features/embeddedSidebar/chatHistory/AgenticChatHistorySessionRow.tsx
msgid "{title}, pinned, thinking"
msgstr "{title}, pinned, thinking"

#: src/features/embeddedSidebar/chatHistory/AgenticChatHistorySessionRow.tsx
msgid "{title}, thinking"
msgstr "{title}, thinking"

#: src/features/knowledgeDocumentViewer/components/viewer/shared/PositionedTooltip.tsx
msgid "{tooltipLinkedCount, plural, one {# document} other {# documents}}"
msgstr "{tooltipLinkedCount, plural, one {# document} other {# documents}}"

#: src/pages/cases/md/MdCasesListPage.tsx
msgid "{totalCount} filtered"
msgstr "{totalCount} filtered"

#: src/pages/overview/sidebar/assetTracker/SiteViewAssetTracker.tsx
msgid "{totalFilteredAssetsNum, plural, one {# Asset} other {# Assets}}"
msgstr "{totalFilteredAssetsNum, plural, one {# Asset} other {# Assets}}"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/EvidenceChip.tsx
msgid "{truncatedChipLabel} · p.{pageNum}"
msgstr "{truncatedChipLabel} · p.{pageNum}"

#: src/pages/details/extensions/flow/filesExt/FileTags.tsx
msgid "{typeLabel} is different"
msgstr "{typeLabel} is different"

#: src/pages/details/extensions/flow/filesExt/FileTags.tsx
msgid "{typeLabel} is missing"
msgstr "{typeLabel} is missing"

#: src/features/mdCases/components/ProvenanceContentViewer.tsx
msgid "{unitCount} proposed"
msgstr "{unitCount} proposed"

#: src/features/knowledgeDocumentViewer/components/metadata/RevisionAuditBadge.tsx
msgid "{unmatchedCount} may be missing"
msgstr "{unmatchedCount} may be missing"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatRevisionMissingCard.tsx
msgid "{unreadable} documents could not be read."
msgstr "{unreadable} documents could not be read."

#: src/pages/nnpp/imports/NnppImportVerificationPage.tsx
msgid "{unresolvedItems, plural, one {# item needs verification} other {# items need verification}}"
msgstr "{unresolvedItems, plural, one {# item needs verification} other {# items need verification}}"

#: src/features/powerCustomerUploads/components/powerCustomerUploadProgressModel.ts
msgid "{uploadedPercent}% complete"
msgstr "{uploadedPercent}% complete"

#: src/features/fimReview/StructuralReviewFlow.tsx
msgid "{value} (OCR variant)"
msgstr "{value} (OCR variant)"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatTagPickerCard.tsx
msgid "{value} as of {timestamp}"
msgstr "{value} as of {timestamp}"

#: src/pages/facilityModel/FacilityModelFilters.tsx
msgid "{value}%+ confidence"
msgstr "{value}%+ confidence"

#: src/pages/facilityModel/FacilityModelFilters.tsx
msgid "{value}+ sources"
msgstr "{value}+ sources"

#: src/features/timeSeries/experiment/ExperimentTab.tsx
msgid "{value1029_37}× band"
msgstr "{value1029_37}× band"

#: src/features/timeSeries/components/chartActions/MarkupToolButtons.tsx
msgid "{value116_23} (active — click to deactivate, Esc to exit)"
msgstr "{value116_23} (active — click to deactivate, Esc to exit)"

#: src/features/timeSeries/components/ThresholdConfigurationModal.tsx
msgid "{value131_20} ({value131_47}) must be less than {value131_93} ({value131_124})"
msgstr "{value131_20} ({value131_47}) must be less than {value131_93} ({value131_124})"

#: src/features/timeSeries/experiment/overlays.ts
msgid "{value182_16} ±band (experiment)"
msgstr "{value182_16} ±band (experiment)"

#: src/features/timeSeries/components/panes/TagConfigurationList.tsx
msgid "{value204_34} Y min"
msgstr "{value204_34} Y min"

#: src/features/timeSeries/components/SensorScatterplotTableColumns.tsx
msgid "{value215_28} Y min"
msgstr "{value215_28} Y min"

#: src/features/timeSeries/components/panes/TagConfigurationList.tsx
msgid "{value215_34} Y max"
msgstr "{value215_34} Y max"

#: src/pages/processData/buildMode/dock/EvalsDockTab.tsx
msgid "{value231_27} FP/30d"
msgstr "{value231_27} FP/30d"

#: src/features/timeSeries/components/SensorScatterplotTableColumns.tsx
msgid "{value233_28} Y max"
msgstr "{value233_28} Y max"

#: src/features/sentinels/components/CasesPanel.tsx
msgid "{value234_27}x band"
msgstr "{value234_27}x band"

#: src/features/timeSeries/components/panes/TagConfigurationList.tsx
msgid "{value255_38} — computed"
msgstr "{value255_38} — computed"

#: src/features/timeSeries/agentTab/modelCard.ts
msgid "{value256_21} (this chat)"
msgstr "{value256_21} (this chat)"

#: src/features/timeSeries/components/panes/TagConfigurationList.tsx
msgid "{value265_34} Y min"
msgstr "{value265_34} Y min"

#: src/features/timeSeries/components/panes/TagConfigurationList.tsx
msgid "{value276_34} Y max"
msgstr "{value276_34} Y max"

#: src/features/timeSeries/agentTab/dock/SettingsTab.tsx
msgid "{value305_21}h rolling average, drawn on {value305_66}"
msgstr "{value305_21}h rolling average, drawn on {value305_66}"

#: src/features/timeSeries/components/ScatterPlotTableConfig.tsx
msgid "{value335_38} Y min"
msgstr "{value335_38} Y min"

#: src/features/timeSeries/components/ScatterPlotTableConfig.tsx
msgid "{value348_38} Y max"
msgstr "{value348_38} Y max"

#: src/features/timeSeries/agentTab/dock/SettingsTab.tsx
msgid "{value380_38} Y min"
msgstr "{value380_38} Y min"

#: src/features/timeSeries/agentTab/dock/TargetTab.tsx
msgid "{value384_23}σ below expected — worth a look"
msgstr "{value384_23}σ below expected — worth a look"

#: src/features/timeSeries/agentTab/dock/TargetTab.tsx
msgid "{value385_23}σ — within the band"
msgstr "{value385_23}σ — within the band"

#: src/features/timeSeries/agentTab/dock/SettingsTab.tsx
msgid "{value389_38} Y max"
msgstr "{value389_38} Y max"

#: src/features/timeSeries/components/LabelsTab.tsx
msgid "{value454_15} of this label's pens are not in this site's tag list and were not added."
msgstr "{value454_15} of this label's pens are not in this site's tag list and were not added."

#: src/features/timeSeries/experiment/SplitBuilder.tsx
msgid ""
"{value456_25}: {value456_37} rows ({value456_53} train / {value456_82} test)\n"
"{value456_109} → {value456_128}"
msgstr ""
"{value456_25}: {value456_37} rows ({value456_53} train / {value456_82} test)\n"
"{value456_109} → {value456_128}"

#: src/features/timeSeries/experiment/SplitBuilder.tsx
msgid ""
"{value457_25}: {value457_37} rows\n"
"{value457_53} → {value457_72}"
msgstr ""
"{value457_25}: {value457_37} rows\n"
"{value457_53} → {value457_72}"

#: src/features/timeSeries/experiment/SplitBuilder.tsx
msgid "{value463_25} train / {value463_54} test"
msgstr "{value463_25} train / {value463_54} test"

#: src/features/timeSeries/components/TagNamesSidebar.tsx
msgid "{value59_28} predicted value for {value59_72}"
msgstr "{value59_28} predicted value for {value59_72}"

#: src/features/timeSeries/components/SentinelsTab.tsx
msgid "{value634_34}% out of band · worst {value634_98}σ"
msgstr "{value634_34}% out of band · worst {value634_98}σ"

#: src/features/timeSeries/components/LabelsTab.tsx
msgid "{value637_21} of {value637_48} labels"
msgstr "{value637_21} of {value637_48} labels"

#: src/features/timeSeries/components/chartActions/MarkupToolButtons.tsx
msgid "{value78_35} (active)"
msgstr "{value78_35} (active)"

#: src/features/sentinels/useSentinelList.ts
msgid "{value90_17} · {value90_49} drivers"
msgstr "{value90_17} · {value90_49} drivers"

#: src/features/sentinels/useSentinelList.ts
msgid "{value91_17} tags in {value91_49} families"
msgstr "{value91_17} tags in {value91_49} families"

#: src/pages/facilityModel/FacilityModelCatalog.tsx
msgid "{visibleCountText} of {activeTotalText}"
msgstr "{visibleCountText} of {activeTotalText}"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatInspectionCard.tsx
msgid "{years} years · calculated minimum"
msgstr "{years} years · calculated minimum"

#: src/features/modelOperations/fimShared.ts
msgid "{yr}y ago"
msgstr "{yr}y ago"

#: src/pages/processData/components/helpGuide/HelpGuideChapters.tsx
msgid "* — in the date picker, keeps the chart pinned to now. Zooming pauses it. "
msgstr "* — in the date picker, keeps the chart pinned to now. Zooming pauses it. "

#: src/pages/processData/components/helpGuide/HelpGuideChapters.tsx
msgid "* Data syncs every 5 minutes and depends on the VPN connection."
msgstr "* Data syncs every 5 minutes and depends on the VPN connection."

#: src/features/timeSeries/experiment/SplitBuilder.tsx
msgid "% of each un-assigned chunk → test"
msgstr "% of each un-assigned chunk → test"

#: src/features/timeSeries/experiment/SplitBuilder.tsx
msgid "% of rows become test, the rest train (shown as “mixed”). Clicking a chunk still assigns it a whole-chunk role; click past test to hand it back to the tail split."
msgstr "% of rows become test, the rest train (shown as “mixed”). Clicking a chunk still assigns it a whole-chunk role; click past test to hand it back to the tail split."

#: src/features/timeSeries/components/FormulaBuilder.tsx
msgid "• Functions: sqrt, abs, sin, cos, log, exp, etc."
msgstr "• Functions: sqrt, abs, sin, cos, log, exp, etc."

#: src/features/timeSeries/components/FormulaBuilder.tsx
msgid "• Type numbers and operators (+, -, *, /, ^) directly"
msgstr "• Type numbers and operators (+, -, *, /, ^) directly"

#: src/features/timeSeries/components/FormulaBuilder.tsx
msgid "• Type sensor names and press space or Enter to add them"
msgstr "• Type sensor names and press space or Enter to add them"

#: src/features/timeSeries/components/timeSeriesScatterplot/NoDataInRange.tsx
msgid "← Jump to earlier data"
msgstr "← Jump to earlier data"

#: src/features/fimReview/StructuralReviewFlow.tsx
msgid "+ Add another Subject"
msgstr "+ Add another Subject"

#: src/features/timeSeries/experiment/TransparencyStrip.tsx
msgid "+ after driver ffill("
msgstr "+ after driver ffill("

#: src/pages/facilityModel/SubjectAssetPanel.tsx
msgid "+{hiddenDocCount} more"
msgstr "+{hiddenDocCount} more"

#: src/features/workspaceTabs/components/WorkspaceTabSwitcher.tsx
msgid "+{otherTabCount} more"
msgstr "+{otherTabCount} more"

#: src/features/mdCases/components/CaseStorySection.tsx
msgid "±2 h"
msgstr "±2 h"

#: src/pages/systemView/components/AnnotationsTab.tsx
msgid "<0>⚠️ Kestrel Viewer Required</0>To edit annotations, please start the Kestrel viewer in the panel on the right. The edit popup will appear there when you click an annotation."
msgstr "<0>⚠️ Kestrel Viewer Required</0>To edit annotations, please start the Kestrel viewer in the panel on the right. The edit popup will appear there when you click an annotation."

#: src/pages/details/visualization/photogrammetry/NiraHud.tsx
msgid "<0>Double Click</0> to focus on point"
msgstr "<0>Double Click</0> to focus on point"

#: src/pages/details/visualization/photogrammetry/NiraHud.tsx
msgid "<0>Scroll Wheel</0> or <1>Right Mouse + Drag</1> to zoom"
msgstr "<0>Scroll Wheel</0> or <1>Right Mouse + Drag</1> to zoom"

#: src/pages/details/visualization/photogrammetry/NiraHud.tsx
msgid "<0>Shift + Left Mouse + Drag</0> to pan"
msgstr "<0>Shift + Left Mouse + Drag</0> to pan"

#: src/features/timeSeries/utils/maxZoom.ts
msgid "~{value57_34}s"
msgstr "~{value57_34}s"

#: src/features/timeSeries/utils/maxZoom.ts
msgid "~{value59_34}m"
msgstr "~{value59_34}m"

#: src/features/timeSeries/utils/maxZoom.ts
msgid "~{value60_15}h"
msgstr "~{value60_15}h"

#: src/features/timeSeries/experiment/TransparencyStrip.tsx
msgid "~Fit / band-calib"
msgstr "~Fit / band-calib"

#: src/features/knowledgeDocumentViewer/components/ContextMenu.tsx
msgid "⌘+Click"
msgstr "⌘+Click"

#: src/pages/processData/buildMode/dock/CompareDockTab.tsx
msgid "★ champion per model (lowest test MAE) · green = best MAE across the board."
msgstr "★ champion per model (lowest test MAE) · green = best MAE across the board."

#: src/features/knowledgeDocumentViewer/components/table/enhancements/BulkEditModal.tsx
msgid "⚠️ This action will permanently delete the selected rows and cannot be undone."
msgstr "⚠️ This action will permanently delete the selected rows and cannot be undone."

#: src/features/knowledgeDocumentViewer/components/DocumentUnavailablePanel.tsx
msgid "✓ available"
msgstr "✓ available"

#: src/features/timeSeries/agentTab/dock/TargetTab.tsx
msgid "1 day"
msgstr "1 day"

#: src/features/mdCases/components/CaseStorySection.tsx
msgid "24 h"
msgstr "24 h"

#: src/pages/details/visualization/tools/ThreeDimensionsToggle.tsx
msgid "2D mode"
msgstr "2D mode"

#: src/pages/facilityModel/FacilityModelFilters.tsx
msgid "3+ sources"
msgstr "3+ sources"

#: src/pages/details/visualization/tools/ThreeDimensionsToggle.tsx
msgid "3D mode"
msgstr "3D mode"

#: src/features/kestrelViewer/ui/tools/photoreel/annotation/PhotoOutlineBridge.tsx
msgid "3D outline partially projected"
msgstr "3D outline partially projected"

#: src/features/navbar/navConfig.ts
msgid "3D View"
msgstr "3D View"

#: src/features/mdCases/components/CaseStorySection.tsx
msgid "7 d"
msgstr "7 d"

#: src/pages/metrics/Metrics.tsx
msgid "7-day avg"
msgstr "7-day avg"

#: src/pages/assetLens/components/tabs/AnomalyDashboard.tsx
msgid "7-Day Trend"
msgstr "7-Day Trend"

#: src/features/timeSeries/sentinelStudio/SentinelBuilderPanel.tsx
msgid ""
"8f3a-tempA\n"
"8f3a-tempB\n"
"8f3a-flow01\n"
"8f3a-pressure"
msgstr ""
"8f3a-tempA\n"
"8f3a-tempB\n"
"8f3a-flow01\n"
"8f3a-pressure"

#: src/features/timeSeries/agentTab/dock/useModelDraft.ts
msgid "a baseline window is required"
msgstr "a baseline window is required"

#: src/features/knowledgeDocumentViewer/components/metadata/RevisionAuditBadge.tsx
msgid "A declared revision is missing from the uploaded documents"
msgstr "A declared revision is missing from the uploaded documents"

#: src/features/knowledgeDocumentViewer/components/metadata/RevisionAuditBadge.tsx
msgid "A declared revision is missing from the uploaded documents."
msgstr "A declared revision is missing from the uploaded documents."

#: src/features/knowledgeDocumentViewer/components/metadata/RevisionAuditBadge.tsx
msgid "A declared revision may be missing"
msgstr "A declared revision may be missing"

#: src/features/fim/useFimService.ts
msgid "A fill is already in progress for this asset — wait for it to finish, then try again."
msgstr "A fill is already in progress for this asset — wait for it to finish, then try again."

#: src/pages/processData/components/helpGuide/HelpGuideChapters.tsx
msgid "A full pass: find tags, plot and scale them, then zoom."
msgstr "A full pass: find tags, plot and scale them, then zoom."

#: src/features/timeSeries/agentTab/dock/FitTab.tsx
msgid "A gap that lives in one band only is usually a physical regime, not a whole-machine decline."
msgstr "A gap that lives in one band only is usually a physical regime, not a whole-machine decline."

#: src/features/timeSeries/sentinelStudio/SentinelBuilderPanel.tsx
#: src/features/timeSeries/sentinelStudio/SentinelBuilderPanel.tsx
msgid "a little while ago"
msgstr "a little while ago"

#: src/pages/details/visualization/Visualization.tsx
msgid "A measurement data layer is overlaid on the asset, colored by the active color scale. All values are in metric units (meters, degrees Celsius, mega-pascals, etc)."
msgstr "A measurement data layer is overlaid on the asset, colored by the active color scale. All values are in metric units (meters, degrees Celsius, mega-pascals, etc)."

#: src/features/timeSeries/agentTab/dock/SettingsTab.tsx
msgid "A model normally takes the chart over — its tags, nothing else. With this on your other pens stay in the list above, just hidden, so they are one click away instead of a search in the tag browser. Applies the next time a model is drawn."
msgstr "A model normally takes the chart over — its tags, nothing else. With this on your other pens stay in the list above, just hidden, so they are one click away instead of a search in the tag browser. Applies the next time a model is drawn."

#: src/features/timeSeries/agentTab/dock/BacktestTab.tsx
msgid "A negative lead time means the model only noticed after the event began. Zero days scored means no at-load days survived the gate in that window, which is a coverage problem rather than a detection one."
msgstr "A negative lead time means the model only noticed after the event began. Zero days scored means no at-load days survived the gate in that window, which is a coverage problem rather than a detection one."

#: src/features/knowledgeDocumentViewer/components/metadata/PageRevisionFamilyDropdown.tsx
msgid "A newer revision is available"
msgstr "A newer revision is available"

#: src/features/fimReview/ReviewActions.tsx
msgid "A reason is required to remove input."
msgstr "A reason is required to remove input."

#: src/features/knowledgeDocumentViewer/components/metadata/DeferPageMetadataDialog.tsx
msgid "A reason is required. Deferred pages stay out of your default unlabeled pool."
msgstr "A reason is required. Deferred pages stay out of your default unlabeled pool."

#: src/pages/cases/md/MdCaseDetailsPage.tsx
msgid "A reopen reason is required to move this case back to Open."
msgstr "A reopen reason is required to move this case back to Open."

#: src/pages/processData/components/helpGuide/HelpGuideChapters.tsx
msgid "A ruler measuring a window, and a pinned point annotation."
msgstr "A ruler measuring a window, and a pinned point annotation."

#: src/features/timeSeries/sentinelStudio/SentinelBuilderPanel.tsx
msgid "A run needs a target, at least one driver, and at least one method."
msgstr "A run needs a target, at least one driver, and at least one method."

#: src/pages/facilityModel/FacilityModelDataIssues.tsx
msgid "a second Asset Instance already resolved to this Subject"
msgstr "a second Asset Instance already resolved to this Subject"

#: src/features/timeSeries/agentTab/dock/TargetTab.tsx
msgid "A sigma is only as good as what it is divided by. This one is the gap against how much the daily gap itself wandered during the baseline — not against hourly noise, which would flatter it."
msgstr "A sigma is only as good as what it is divided by. This one is the gap against how much the daily gap itself wandered during the baseline — not against hourly noise, which would flatter it."

#: src/features/fimReview/subjectDecisionBuilders.ts
msgid "A split needs at least two source records to separate."
msgstr "A split needs at least two source records to separate."

#: src/features/fimReview/subjectDecisionBuilders.ts
msgid "A split needs at least two Subjects."
msgstr "A split needs at least two Subjects."

#: src/pages/facilityModel/SubjectAssetPanel.tsx
msgid "A template fill is queued."
msgstr "A template fill is queued."

#: src/pages/facilityModel/SubjectAssetPanel.tsx
msgid "A template fill is running."
msgstr "A template fill is running."

#: src/features/timeSeries/sentinelStudio/SentinelBuilderPanel.tsx
msgid "A training job is fitting this plan, so it can no longer be edited."
msgstr "A training job is fitting this plan, so it can no longer be edited."

#: src/pages/details/extensions/fde/ffsLtaGeneration/FfsLtaGenerationSidebar.tsx
msgid "A valid inspection, component, and CDS are required to generate LTAs."
msgstr "A valid inspection, component, and CDS are required to generate LTAs."

#: src/pages/assetLens/AssetLens.tsx
msgid "A valid Unit ID is required to view the Asset Lens."
msgstr "A valid Unit ID is required to view the Asset Lens."

#: src/features/timeSeries/experiment/KnobHelp.tsx
#: src/pages/manageAccess/components/table/ColumnHeaderHelp.tsx
msgid "About {label}"
msgstr "About {label}"

#: src/features/timeSeries/experiment/CorrelationCard.tsx
msgid "About best shifts"
msgstr "About best shifts"

#: src/pages/manageAccess/components/table/ColumnHeaderHelp.tsx
msgid "About this column"
msgstr "About this column"

#: src/features/timeSeries/experiment/KnobHelp.tsx
msgid "About this setting"
msgstr "About this setting"

#: src/features/mdCases/components/CaseStorySection.tsx
msgid "Above expected range"
msgstr "Above expected range"

#: src/features/timeSeries/experiment/ModelKnobs.tsx
msgid "abs quantile"
msgstr "abs quantile"

#: src/pages/processData/buildMode/dock/BandsDockTab.tsx
msgid "Abs quantile"
msgstr "Abs quantile"

#: src/features/chatbot/components/conversationMessage/ProposalCard.tsx
#: src/pages/nnpp/acceptance/NnppAcceptanceReviewPage.tsx
msgid "Accept"
msgstr "Accept"

#: src/features/terms/TermsModal.tsx
msgid "Accept Terms"
msgstr "Accept Terms"

#: src/pages/nnpp/acceptance/NnppAcceptanceReviewPage.tsx
msgid "Acceptance review"
msgstr "Acceptance review"

#: src/features/chatbot/components/conversationMessage/ProposalCard.tsx
msgid "accepted"
msgstr "accepted"

#: src/pages/manageAccess/hooks/useListedRoster.ts
msgid "Access removed for this view."
msgstr "Access removed for this view."

#: src/pages/manageAccess/hooks/useListedRoster.ts
msgid "Access revoked. The user was removed."
msgstr "Access revoked. The user was removed."

#: src/pages/cases/components/CaseFeedbackModal.tsx
msgid "Accurate"
msgstr "Accurate"

#: src/pages/alerts/components/AlertsTableColumns.tsx
msgid "Acknowledge"
msgstr "Acknowledge"

#: src/pages/alerts/AlertDetails.tsx
msgid "Acknowledge Alert"
msgstr "Acknowledge Alert"

#: src/pages/alerts/AlertDetails.tsx
#: src/pages/alerts/components/AlertsTableColumns.tsx
#: src/pages/assetLens/components/tabs/AnomalyDashboard.tsx
msgid "Acknowledged"
msgstr "Acknowledged"

#: src/pages/assetLens/components/tabs/imagesTabComponents/EnvironmentalCorrelationCard.tsx
msgid "acoustic"
msgstr "acoustic"

#: src/pages/assetLens/components/tabs/imagesTabComponents/ImageTimelineView.tsx
msgid "Acoustic + Thermal Imaging Timeline"
msgstr "Acoustic + Thermal Imaging Timeline"

#: src/pages/assetLens/components/tabs/imagesTabComponents/ImageGalleryView.tsx
msgid "Acoustic Images"
msgstr "Acoustic Images"

#: src/pages/assetLens/components/tabs/imagesTabComponents/ImageComparisonView.tsx
msgid "Acoustic Scan - {comparisonImageDate}"
msgstr "Acoustic Scan - {comparisonImageDate}"

#: src/pages/assetLens/components/tabs/imagesTabComponents/ImageComparisonView.tsx
msgid "Acoustic Scan - {currentImageDate}"
msgstr "Acoustic Scan - {currentImageDate}"

#: src/pages/assetLens/components/tabs/imagesTabComponents/ImageGalleryView.tsx
msgid "Acoustic Scan - {imageDate}"
msgstr "Acoustic Scan - {imageDate}"

#: src/pages/assetLens/components/tabs/imagesTabComponents/ImageGalleryView.tsx
msgid "Acoustic Scan from {imageDate}"
msgstr "Acoustic Scan from {imageDate}"

#: src/pages/assetLens/components/tabs/imagesTabComponents/ImageTrendAnalysis.tsx
msgid "Acoustic Trend Analysis"
msgstr "Acoustic Trend Analysis"

#: src/pages/assetLens/components/tabs/imagesTabComponents/ImageTrendAnalysis.tsx
msgid "Acoustic trend is"
msgstr "Acoustic trend is"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/ReportTable.tsx
#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/ReportTable.tsx
#: src/features/lotoReports/components/LotoReportsTable.tsx
#: src/pages/assetLens/components/tabs/AnomalyDashboard.tsx
#: src/pages/assetLens/components/tabs/DocumentsTab.tsx
#: src/pages/manageAccess/components/table/UsersTableHead.tsx
#: src/pages/systemView/components/unitsTab/UnitListItem.tsx
msgid "Actions"
msgstr "Actions"

#: src/pages/manageAccess/components/table/UserRowActions.tsx
msgid "Actions for {userName}"
msgstr "Actions for {userName}"

#: src/pages/processData/components/viewSwitcher/ViewSwitcher.tsx
msgid "Actions for {value125_43}"
msgstr "Actions for {value125_43}"

#: src/features/timeSeries/components/panes/TagFilterControls.tsx
#: src/pages/cases/md/MdCasesListPage.tsx
msgid "Active"
msgstr "Active"

#: src/pages/manageAccess/users.ts
msgctxt "access status"
msgid "Active"
msgstr "Active"

#: src/pages/cases/md/MdCasesListPage.tsx
msgid "Active ({activeCount})"
msgstr "Active ({activeCount})"

#: src/pages/assetLens/components/tabs/AnomalyDashboard.tsx
#: src/pages/assetLens/components/tabs/timeSeriesAnalysis/TimeSeriesSidebar.tsx
msgid "Active Anomalies"
msgstr "Active Anomalies"

#: src/features/sentinels/coverage.ts
msgid "Active monitor · {experimentsLabel}"
msgstr "Active monitor · {experimentsLabel}"

#: src/features/mdCases/components/ProvenanceContentViewer.tsx
msgid "Active regimes"
msgstr "Active regimes"

#: src/pages/cases/activity/ActivitySection.tsx
#: src/pages/cases/md/MdCaseDetailsMainColumn.tsx
#: src/pages/cases/md/MdCaseDetailsPage.tsx
#: src/pages/facilityModel/SentinelDetailPage.tsx
msgid "Activity"
msgstr "Activity"

#: src/pages/cases/md/MdCaseDetailsMainColumn.tsx
msgid "Activity is collapsed by default."
msgstr "Activity is collapsed by default."

#: src/features/knowledgeDocumentViewer/workOrders/workOrderPdf.ts
msgid "Actual"
msgstr "Actual"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
#: src/features/knowledgeDocumentViewer/workOrders/legacyCmmsRecordPdf.ts
msgid "Actual date"
msgstr "Actual date"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
#: src/features/knowledgeDocumentViewer/workOrders/workOrderFields.ts
#: src/features/knowledgeDocumentViewer/workOrders/workOrderPresentation.ts
msgid "Actual finish"
msgstr "Actual finish"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
#: src/features/knowledgeDocumentViewer/workOrders/workOrderFields.ts
msgid "Actual labor cost"
msgstr "Actual labor cost"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
#: src/features/knowledgeDocumentViewer/workOrders/workOrderFields.ts
msgid "Actual labor hours"
msgstr "Actual labor hours"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
#: src/features/knowledgeDocumentViewer/workOrders/workOrderFields.ts
msgid "Actual material cost"
msgstr "Actual material cost"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
#: src/features/knowledgeDocumentViewer/workOrders/workOrderFields.ts
msgid "Actual service cost"
msgstr "Actual service cost"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
#: src/features/knowledgeDocumentViewer/workOrders/workOrderFields.ts
#: src/features/knowledgeDocumentViewer/workOrders/workOrderPresentation.ts
msgid "Actual start"
msgstr "Actual start"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
#: src/features/knowledgeDocumentViewer/workOrders/workOrderFields.ts
msgid "Actual tool cost"
msgstr "Actual tool cost"

#: src/features/timeSeries/experiment/ExperimentTab.tsx
msgid "Actual vs expected and the residual band for this method draw directly on the main chart (target pen + shaded band), where zoom, tooltip, and ruler work."
msgstr "Actual vs expected and the residual band for this method draw directly on the main chart (target pen + shaded band), where zoom, tooltip, and ruler work."

#: src/features/timeSeries/experiment/DiagnosticsPanel.tsx
msgid "Actual y"
msgstr "Actual y"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatEvalCaseCitations.tsx
#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatEvalCaseReview.tsx
#: src/features/modelOperations/SubjectDetails.tsx
#: src/features/richText/components/TaggableUsersCard.tsx
#: src/features/timeSeries/components/PensTab.tsx
#: src/features/timeSeries/components/SentinelsTab.tsx
msgid "Add"
msgstr "Add"

#: src/pages/cases/components/RelatedObjectsSection.tsx
msgid "Add {lowerCaseSingularTitle}"
msgstr "Add {lowerCaseSingularTitle}"

#: src/features/timeSeries/agentTab/dock/FitTab.tsx
msgid "Add {newRole}"
msgstr "Add {newRole}"

#: src/features/timeSeries/components/labelTool/LabelConfigPanel.tsx
msgid "Add {value523_49} to the chart"
msgstr "Add {value523_49} to the chart"

#: src/pages/assetLens/components/tabs/SensorIssuesTab.tsx
msgid "Add a comment..."
msgstr "Add a comment..."

#: src/features/timeSeries/agentTab/dock/WindowsTab.tsx
#: src/features/timeSeries/agentTab/dock/WindowsTab.tsx
msgid "Add a range"
msgstr "Add a range"

#: src/features/timeSeries/agentTab/dock/WindowsTab.tsx
msgid "Add a window the machine was healthy in."
msgstr "Add a window the machine was healthy in."

#: src/features/timeSeries/components/LabelsTab.tsx
msgid "Add all"
msgstr "Add all"

#: src/features/timeSeries/agentTab/dock/BacktestTab.tsx
msgid "Add an event"
msgstr "Add an event"

#: src/features/knowledgeDocumentViewer/components/sidebar/FeedbackModal.tsx
msgid "Add any additional details..."
msgstr "Add any additional details..."

#: src/pages/cases/md/MdCasesListPage.tsx
msgid "Add Case"
msgstr "Add Case"

#: src/features/chatbot/components/FeedbackMenu.tsx
#: src/features/knowledgeDocumentViewer/components/metadata/PageMetadataEvalComments.tsx
#: src/features/knowledgeDocumentViewer/components/metadata/PageMetadataEvalComments.tsx
msgid "Add comment"
msgstr "Add comment"

#: src/pages/cases/md/MdCaseDetailsMainColumn.tsx
msgid "Add Comment"
msgstr "Add Comment"

#: src/pages/site/components/CustomFieldsTableCard.tsx
msgid "Add Custom Field"
msgstr "Add Custom Field"

#: src/features/timeSeries/components/ScatterplotSidebarAddData.tsx
msgid "Add Data"
msgstr "Add Data"

#: src/pages/assetLens/components/tabs/DocumentsTab.tsx
msgid "Add Document"
msgstr "Add Document"

#: src/pages/cases/md/MdCaseReferencesDrawer.tsx
msgid "Add document reference"
msgstr "Add document reference"

#: src/features/knowledgeDocumentViewer/components/table/enhancements/filters/AddFilter.tsx
msgid "Add filter"
msgstr "Add filter"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatEvalCaseCitations.tsx
msgid "Add from search results"
msgstr "Add from search results"

#: src/features/knowledgeDocumentViewer/components/toolbar/DocumentTabs.tsx
#: src/features/knowledgeDocumentViewer/components/toolbar/DocumentTabs.tsx
msgid "Add new tab"
msgstr "Add new tab"

#: src/features/navbar/siteSelectors/SiteSelectorsSidebar.tsx
#: src/features/navbar/siteSelectors/SiteSelectorsTopBar.tsx
msgid "Add Org"
msgstr "Add Org"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatEvalCaseCitations.tsx
msgid "Add page {pageNum} of {title}"
msgstr "Add page {pageNum} of {title}"

#: src/features/timeSeries/components/rulerTool/RulerMetricsPanel.tsx
msgid "Add pen"
msgstr "Add pen"

#: src/features/fim/photos/SubjectPhotoUploader.tsx
msgid "Add photo"
msgstr "Add photo"

#: src/pages/cases/md/MdCaseReferencesDrawer.tsx
msgid "Add PI Tag reference"
msgstr "Add PI Tag reference"

#: src/features/timeSeries/experiment/SplitBuilder.tsx
msgid "Add range"
msgstr "Add range"

#: src/pages/cases/md/MdCaseReferencesDrawer.tsx
#: src/pages/cases/md/MdCaseReferencesDrawer.tsx
msgid "Add Reference"
msgstr "Add Reference"

#: src/features/timeSeries/components/LabelsTab.tsx
msgid "Add referenced tags"
msgstr "Add referenced tags"

#: src/features/timeSeries/components/LabelsTab.tsx
msgid "Add referenced tags from {value738_62} to chart"
msgstr "Add referenced tags from {value738_62} to chart"

#: src/features/timeSeries/components/LabelsTab.tsx
msgid "Add referenced tags to chart"
msgstr "Add referenced tags to chart"

#: src/features/timeSeries/components/RegressionPrediction.tsx
#: src/features/timeSeries/components/RegressionPrediction.tsx
msgid "Add Regression"
msgstr "Add Regression"

#: src/features/navbar/siteSelectors/SiteSelectorsSidebar.tsx
#: src/features/navbar/siteSelectors/SiteSelectorsTopBar.tsx
#: src/pages/noSites/NoSites.tsx
#: src/pages/site/CreateSite.tsx
msgid "Add Site"
msgstr "Add Site"

#: src/features/timeSeries/components/ScatterPlotTableConfig.tsx
msgid "Add tags or derived values to configure them."
msgstr "Add tags or derived values to configure them."

#: src/features/timeSeries/agentTab/AgentHeader.tsx
msgid "Add the residual (actual − expected), computed from the saved fit"
msgstr "Add the residual (actual − expected), computed from the saved fit"

#: src/features/lotoReports/components/LotoSelectedReport.tsx
msgid "Add this page"
msgstr "Add this page"

#: src/features/timeSeries/components/labelTool/LabelConfigPanel.tsx
msgid "Add this pen to the chart"
msgstr "Add this pen to the chart"

#: src/features/timeSeries/agentTab/dock/FitTab.tsx
msgid "Add this role"
msgstr "Add this role"

#: src/features/timeSeries/components/LabelsTab.tsx
msgid "Add to chart"
msgstr "Add to chart"

#: src/features/knowledgeDocumentViewer/components/ContextMenu.tsx
msgid "Add to context"
msgstr "Add to context"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/documentsCardView/DocumentResultCard.tsx
#: src/features/knowledgeDocumentViewer/components/toolbar/KnowledgeDocumentHeaderBar.tsx
#: src/features/knowledgeDocumentViewer/workOrders/WorkOrderViewer.tsx
#: src/features/knowledgeDocumentViewer/workOrders/WorkOrderViewer.tsx
msgid "Add to favorites"
msgstr "Add to favorites"

#: src/features/modelOperations/SubjectDetails.tsx
msgid "Add to Process Data"
msgstr "Add to Process Data"

#: src/features/timeSeries/components/SentinelsTab.tsx
msgid "Add to the comparison table"
msgstr "Add to the comparison table"

#: src/features/cases/components/SupplementaryLinksActivityContent.tsx
#: src/features/knowledgeDocumentViewer/components/revisionCompare/RevisionStatusLegend.tsx
#: src/features/modelOperations/SubjectDetails.tsx
msgid "Added"
msgstr "Added"

#: src/features/timeSeries/agentTab/dock/SettingsTab.tsx
msgid "added by the agent"
msgstr "added by the agent"

#: src/features/timeSeries/agentTab/useAgentView.ts
msgid "Added by the agent"
msgstr "Added by the agent"

#: src/pages/assetLens/components/tabs/imagesTabComponents/ImageUploadModal.tsx
msgid "Additional Notes"
msgstr "Additional Notes"

#: src/pages/site/forms/siteInfoFormFields.ts
msgid "Address"
msgstr "Address"

#: src/pages/processData/buildMode/dock/ModelDockTab.tsx
msgid "Adds driver lags and a rolling mean; the usual default."
msgstr "Adds driver lags and a rolling mean; the usual default."

#: src/pages/processData/buildMode/dock/ModelDockTab.tsx
msgid "Adds prior target values; can hide slow target drift."
msgstr "Adds prior target values; can hide slow target drift."

#: src/pages/manageAccess/users.ts
msgctxt "access role"
msgid "Admin"
msgstr "Admin"

#: src/pages/manageAccess/users.ts
msgctxt "access role"
msgid "Admins can manage people and permissions. Members can’t manage access."
msgstr "Admins can manage people and permissions. Members can’t manage access."

#: src/features/timeSeries/experiment/ExperimentTab.tsx
msgid "Advanced: cleaning plan JSON"
msgstr "Advanced: cleaning plan JSON"

#: src/features/fimReview/StructuralReviewFlow.tsx
#: src/features/knowledgeDocumentViewer/components/revisionCompare/RevisionChangeCitations.tsx
#: src/features/knowledgeDocumentViewer/components/revisionCompare/RevisionChangeCropPair.tsx
#: src/features/knowledgeDocumentViewer/components/revisionCompare/RevisionCompareContent.tsx
msgid "After"
msgstr "After"

#: src/features/knowledgeDocumentViewer/components/table/enhancements/filters/DateFilter.tsx
msgid "After {startDate}"
msgstr "After {startDate}"

#: src/features/timeSeries/experiment/TransparencyStrip.tsx
msgid "After cleaning"
msgstr "After cleaning"

#: src/features/timeSeries/experiment/TransparencyStrip.tsx
msgid "After lag warm-up"
msgstr "After lag warm-up"

#: src/features/knowledgeDocumentViewer/components/table/enhancements/filters/DateFilter.tsx
msgid "After:"
msgstr "After:"

#: src/features/timeSeries/components/ScatterplotSidebar.tsx
msgid "Agent"
msgstr "Agent"

#: src/features/knowledgeDocumentViewer/components/bugReport/BugReportAgentModeField.tsx
msgid "Agent automation"
msgstr "Agent automation"

#: src/features/timeSeries/agentTab/useActiveModel.ts
msgid "agent model"
msgstr "agent model"

#: src/features/timeSeries/agentTab/agentKpiPen.ts
msgid "Agent model {value193_36}"
msgstr "Agent model {value193_36}"

#: src/features/fimReview/provenance.ts
msgid "Agent-asserted"
msgstr "Agent-asserted"

#: src/features/timeSeries/agentTab/dock/TargetTab.tsx
msgid "Agent’s reading"
msgstr "Agent’s reading"

#: src/features/embeddedSidebar/sessions/documentChatSessionRolodex.ts
msgid "Agentic search"
msgstr "Agentic search"

#: src/features/timeSeries/experiment/RunComparison.tsx
msgid "agg {value99_24}→{value99_44}"
msgstr "agg {value99_24}→{value99_44}"

#: src/features/timeSeries/components/PenTransformControls.tsx
#: src/pages/processData/buildMode/dock/SamplingSection.tsx
msgid "Aggregate"
msgstr "Aggregate"

#: src/features/timeSeries/experiment/knobCopy.ts
msgid "Aggregate (prod): put every tag onto a shared time grid by binning historian samples (e.g. 10 min mean). Raw: pull every available historian point and outer-join on exact timestamps — tags only share a row when stamps match exactly. Raw is denser but much sparser across tags."
msgstr "Aggregate (prod): put every tag onto a shared time grid by binning historian samples (e.g. 10 min mean). Raw: pull every available historian point and outer-join on exact timestamps — tags only share a row when stamps match exactly. Raw is denser but much sparser across tags."

#: src/features/timeSeries/experiment/SamplingKnobs.tsx
msgid "Aggregate onto grid (prod default)"
msgstr "Aggregate onto grid (prod default)"

#: src/features/timeSeries/experiment/SamplingKnobs.tsx
#: src/pages/processData/buildMode/dock/SamplingSection.tsx
#: src/pages/processData/buildMode/dock/SamplingSection.tsx
msgid "Aggregation"
msgstr "Aggregation"

#: src/pages/details/visualization/alerts/specificAlerts/ConduitPipelineAlert.tsx
msgid "Aggregation pipelines in progress: {aggregationCount}"
msgstr "Aggregation pipelines in progress: {aggregationCount}"

#: src/pages/evaluations/metadata/dashboard/components/dataLabeling/DataLabelingDashboardFieldDrilldown.tsx
#: src/pages/evaluations/metadata/dashboard/components/dataLabeling/DataLabelingDashboardSites.tsx
#: src/pages/evaluations/metadata/dashboard/components/dataLabeling/DataLabelingDashboardSummaryCards.tsx
msgid "Agreement"
msgstr "Agreement"

#: src/pages/evaluations/metadata/dashboard/components/dataLabeling/DataLabelingDashboardAgreementByField.tsx
msgid "Agreement by field"
msgstr "Agreement by field"

#: src/pages/evaluations/metadata/labeling/utils/pageClassificationTaxonomy.ts
msgid "Agreements and business terms"
msgstr "Agreements and business terms"

#: src/features/chatbot/components/ChatbotSidePanel.tsx
msgid "AI Chat unavailable"
msgstr "AI Chat unavailable"

#: src/features/mdCases/components/ProvenanceContentViewer.tsx
#: src/features/mdCases/components/ProvenanceContentViewer.tsx
msgid "AI explanation"
msgstr "AI explanation"

#: src/features/fimReview/IdentityPanel.tsx
msgid "AI merge"
msgstr "AI merge"

#: src/pages/metrics/components/DailySearchesChart.tsx
msgid "AI search"
msgstr "AI search"

#: src/features/workspaceTabs/utils/getWorkspaceTabLabel.ts
msgid "AI Search"
msgstr "AI Search"

#: src/pages/metrics/components/DailySearchesChart.tsx
msgid "AI search (7d avg)"
msgstr "AI search (7d avg)"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/utils/docChatText.ts
msgid "AI search could not complete — found {resultLabel} via standard search"
msgstr "AI search could not complete — found {resultLabel} via standard search"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/utils/docChatText.ts
msgid "AI search could not complete. Showing standard document search results — this is not a full AI answer."
msgstr "AI search could not complete. Showing standard document search results — this is not a full AI answer."

#: src/pages/evaluations/metadata/dashboard/components/dataLabeling/DataLabelingDashboardSites.tsx
msgid "AI-extracted page metadata vs human-confirmed per site"
msgstr "AI-extracted page metadata vs human-confirmed per site"

#: src/pages/evaluations/metadata/components/MetricsCard.tsx
msgid "AI-labeled metadata vs human labels across <0>{organizationName}</0>"
msgstr "AI-labeled metadata vs human labels across <0>{organizationName}</0>"

#: src/features/fimReview/provenance.ts
msgid "AI-matched — cited evidence"
msgstr "AI-matched — cited evidence"

#: src/pages/details/visualization/Visualization.tsx
#: src/pages/homepage/Homepage.tsx
msgid "AIR · AI + Robotics"
msgstr "AIR · AI + Robotics"

#: src/pages/alerts/alertStatusLabel.ts
msgid "Alarm"
msgstr "Alarm"

#: src/features/chatbot/components/AttachmentPills.tsx
msgid "alert"
msgstr "alert"

#: src/features/facilityModel/provenance/ProvenanceChain.tsx
#: src/features/mdCases/hooks/useOpenAlertInProcessData.ts
#: src/features/mdCases/mdCaseDisplay.ts
#: src/features/timeSeries/components/timeSeriesScatterplot/MdDraftAlertCaseFlowPanels.tsx
#: src/pages/alerts/components/AlertTimeSeriesChart.tsx
#: src/pages/cases/components/CaseDetailsSidebar.tsx
#: src/pages/cases/components/CaseSidebar.tsx
#: src/pages/cases/md/MdCaseDetailsPage.tsx
msgid "Alert"
msgstr "Alert"

#: src/pages/alerts/AlertDetails.tsx
msgid "Alert - {timestamp}"
msgstr "Alert - {timestamp}"

#: src/features/mdCases/components/CaseTimeline.tsx
msgid "Alert detected"
msgstr "Alert detected"

#: src/pages/processData/components/helpGuide/HelpGuideChapters.tsx
msgid "Alert markers"
msgstr "Alert markers"

#: src/pages/alerts/AlertDetails.tsx
msgid "Alert not found."
msgstr "Alert not found."

#: src/pages/cases/md/MdCasesCardList.tsx
#: src/pages/cases/md/MdCasesColumnHeader.tsx
msgid "Alert Range"
msgstr "Alert Range"

#: src/pages/cases/md/MdCaseDetailsMainColumn.tsx
msgid "Alert Range {alertRangeLabel}"
msgstr "Alert Range {alertRangeLabel}"

#: src/features/mdCases/components/ProvenanceContentViewer.tsx
#: src/features/mdCases/components/ProvenanceContentViewer.tsx
msgid "Alerted value"
msgstr "Alerted value"

#: src/pages/alerts/AlertDetails.tsx
#: src/pages/alerts/components/AlertsTableColumns.tsx
msgid "Alerted Value"
msgstr "Alerted Value"

#: src/features/timeSeries/agentTab/dock/AgentDock.tsx
msgid "Alerting"
msgstr "Alerting"

#: src/features/timeSeries/agentTab/dock/AgentDock.tsx
msgid "Alerting needs a saved model — there is nothing to schedule until this one has an entry. Ask the agent to save it."
msgstr "Alerting needs a saved model — there is nothing to schedule until this one has an entry. Ask the agent to save it."

#: src/pages/alerts/components/AlertsTable.tsx
msgid "alerts"
msgstr "alerts"

#: src/features/navbar/navConfig.ts
#: src/pages/alerts/Alerts.tsx
#: src/pages/alerts/Alerts.tsx
#: src/pages/cases/components/CaseDetailsSidebar.tsx
#: src/pages/cases/components/CaseSidebar.tsx
msgid "Alerts"
msgstr "Alerts"

#: src/features/sentinels/components/SentinelAlertsPanel.tsx
msgid "Alerts "
msgstr "Alerts "

#: src/features/mdCases/components/MonitorLineagePanel.tsx
msgid "Alerts ({alertCount})"
msgstr "Alerts ({alertCount})"

#: src/features/fimReview/IdentityPanel.tsx
#: src/features/knowledgeDocumentViewer/components/sidebar/SubjectDocumentsPanel.tsx
msgid "Alias"
msgstr "Alias"

#: src/features/fimReview/ReviewActions.tsx
msgid "Aliases"
msgstr "Aliases"

#: src/features/copcPointClouds/CopcSpatialContextControl.tsx
#: src/features/forecastNotifications/NotificationsDropdownContent.tsx
#: src/features/knowledgeDocumentViewer/components/table/enhancements/filters/DateFilter.tsx
#: src/features/knowledgeDocumentViewer/components/table/enhancements/filters/MultiSelectFilter.tsx
#: src/features/knowledgeDocumentViewer/components/table/enhancements/filters/MultiSelectFilter.tsx
#: src/features/powerCustomerUploads/components/PowerCustomerUploadStatus.tsx
#: src/features/timeSeries/components/panes/TagFilterControls.tsx
#: src/features/timeSeries/components/panes/TagFilterControls.tsx
#: src/features/timeSeries/components/TagsTab.tsx
#: src/pages/evaluations/metadata/dashboard/components/dataLabeling/DataLabelingDashboardDisagreementFilters.tsx
#: src/pages/evaluations/metadata/dashboard/components/dataLabeling/DataLabelingDashboardDisagreementFilters.tsx
#: src/pages/evaluations/metadata/labeling/components/DataLabelingLabeledByFilter.tsx
#: src/pages/overview/sidebar/filterSelects/groupingsFilter/GenerateGroupingSelect.tsx
#: src/pages/overview/sidebar/filterSelects/unitFilter/UnitTypeFilter.tsx
#: src/pages/processData/buildMode/rightPanel/SavedModelShelf.tsx
#: src/pages/processData/components/viewSwitcher/ViewSwitcher.tsx
#: src/pages/systemView/components/SystemViewAnnotationSidebar.tsx
msgid "All"
msgstr "All"

#: src/pages/cases/md/MdCasesListPage.tsx
msgid "All ({totalCount})"
msgstr "All ({totalCount})"

#: src/features/lotoReports/components/LotoEditorSaveState.tsx
msgid "All changes saved"
msgstr "All changes saved"

#: src/pages/manageAccess/components/scope/SiteSelect.tsx
msgid "All orgs"
msgstr "All orgs"

#: src/pages/details/extensions/flow/FilesExtension.tsx
msgid "All other files for asset"
msgstr "All other files for asset"

#: src/pages/details/extensions/flow/FilesExtension.tsx
msgid "All other reports for asset"
msgstr "All other reports for asset"

#: src/pages/forgingsReporting/ForgingsReportingPage.tsx
msgid "All reports"
msgstr "All reports"

#: src/pages/facilityModel/SubjectAssetPanel.tsx
msgid "All required slots filled"
msgstr "All required slots filled"

#: src/pages/evaluations/metadata/dashboard/components/dataLabeling/DataLabelingDashboardFieldDrilldown.tsx
msgid "All results"
msgstr "All results"

#: src/pages/processData/buildMode/rightPanel/SavedModelShelf.tsx
msgid "All saved models"
msgstr "All saved models"

#: src/pages/assetLens/components/tabs/AnomalyDashboard.tsx
msgid "All Severity"
msgstr "All Severity"

#: src/features/mdCases/components/CaseStorySection.tsx
msgid "All shown"
msgstr "All shown"

#: src/pages/evaluations/metadata/dashboard/components/dataLabeling/DataLabelingDashboardOrg.tsx
msgid "all sites"
msgstr "all sites"

#: src/pages/evaluations/metadata/dashboard/components/dataLabeling/DataLabelingDashboardFieldDrilldown.tsx
#: src/pages/manageAccess/components/scope/SiteSelect.tsx
msgid "All sites"
msgstr "All sites"

#: src/features/timeSeries/components/AllTagsTab.tsx
#: src/features/timeSeries/components/panes/TagFilterControls.tsx
msgid "All sources"
msgstr "All sources"

#: src/pages/assetLens/components/tabs/AnomalyDashboard.tsx
msgid "All Status"
msgstr "All Status"

#: src/features/powerCustomerUploads/components/PowerCustomerUploadHistoryPanel.tsx
#: src/pages/evaluations/metadata/labeling/components/DataLabelingStatusFilter.tsx
msgid "All statuses"
msgstr "All statuses"

#: src/pages/facilityModel/FacilityModelCatalog.tsx
msgid "All Subjects"
msgstr "All Subjects"

#: src/features/timeSeries/components/panes/TagFilterControls.tsx
msgid "All tags"
msgstr "All tags"

#: src/features/timeSeries/components/TimeRangeSelector.tsx
msgid "All Time Ranges"
msgstr "All Time Ranges"

#: src/pages/evaluations/metadata/labeling/components/DataLabelingTypeFilter.tsx
msgid "All types"
msgstr "All types"

#: src/features/powerCustomerUploads/components/PowerCustomerUploadHistoryPanel.tsx
msgid "All upload types"
msgstr "All upload types"

#: src/pages/evaluations/metadata/labeling/utils/vendorOptions.ts
msgid "All vendors"
msgstr "All vendors"

#: src/pages/details/visualization/screenshot/ScreenshotTools.tsx
msgid "Allow Freeform Aspect Ratio"
msgstr "Allow Freeform Aspect Ratio"

#: src/pages/details/visualization/screenshot/ScreenshotTools.tsx
msgid "Allow Natural Asset Dimensions"
msgstr "Allow Natural Asset Dimensions"

#: src/features/timeSeries/experiment/ExperimentTab.tsx
msgid "Also save model weights (slower re-fit)"
msgstr "Also save model weights (slower re-fit)"

#: src/features/knowledgeDocumentViewer/components/toolbar/SettingsMenu.tsx
msgid "Always open links in new tab"
msgstr "Always open links in new tab"

#: src/pages/assetLens/components/tabs/imagesTabComponents/ImageTrendAnalysis.tsx
msgid "Ambient Temperature"
msgstr "Ambient Temperature"

#: src/features/fimReview/ReviewActions.tsx
msgid "An alias is spelled wrong"
msgstr "An alias is spelled wrong"

#: src/features/fimReview/TypeCombobox.tsx
msgid "An asset template exists for this type — validated subjects can be instantiated"
msgstr "An asset template exists for this type — validated subjects can be instantiated"

#: src/features/richText/components/ToolbarPlugin.tsx
msgid "An error occurred during upload"
msgstr "An error occurred during upload"

#: src/pages/manageAccess/components/table/UserRowActions.tsx
msgid "An invitation is already being sent."
msgstr "An invitation is already being sent."

#: src/features/timeSeries/components/DerivedValues.tsx
msgid "An unknown error occurred."
msgstr "An unknown error occurred."

#: src/pages/assetLens/components/AssetTabs.tsx
msgid "Analysis"
msgstr "Analysis"

#: src/pages/assetLens/components/tabs/canvas/AnalysisState.tsx
msgid "Analysis State"
msgstr "Analysis State"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
#: src/features/knowledgeDocumentViewer/workOrders/legacyCmmsRecordPdf.ts
msgid "Ancestor"
msgstr "Ancestor"

#: src/pages/processData/components/helpGuide/HelpGuideChapters.tsx
msgid "Annotate"
msgstr "Annotate"

#: src/pages/systemView/components/DataPanel.tsx
#: src/pages/systemView/components/SystemViewAnnotationSidebar.tsx
msgid "Annotations"
msgstr "Annotations"

#: src/pages/processData/components/helpGuide/HelpGuideChapters.tsx
msgid "Annotations save with the view."
msgstr "Annotations save with the view."

#: src/features/timeSeries/components/TimeRangeSelector.tsx
msgid "Annual trend"
msgstr "Annual trend"

#: src/pages/assetLens/components/tabs/AnomalyDashboard.tsx
#: src/pages/assetLens/components/tabs/imagesTabComponents/ImageComparisonView.tsx
#: src/pages/assetLens/components/tabs/imagesTabComponents/ImageComparisonView.tsx
#: src/pages/assetLens/components/tabs/imagesTabComponents/ImageGalleryView.tsx
msgid "Anomaly"
msgstr "Anomaly"

#: src/pages/assetLens/components/tabs/SensorIssuesTab.tsx
msgid "Anomaly Cases"
msgstr "Anomaly Cases"

#: src/pages/assetLens/components/AssetTabs.tsx
#: src/pages/assetLens/components/tabs/AnomalyDashboard.tsx
msgid "Anomaly Dashboard"
msgstr "Anomaly Dashboard"

#: src/pages/assetLens/components/tabs/timeSeriesAnalysis/CompositeTimeSeriesAnalysis.tsx
msgid "Anomaly detected"
msgstr "Anomaly detected"

#: src/pages/assetLens/components/tabs/imagesTabComponents/ImageComparisonView.tsx
#: src/pages/assetLens/components/tabs/imagesTabComponents/ImageComparisonView.tsx
#: src/pages/assetLens/components/tabs/imagesTabComponents/ImageTimelineView.tsx
msgid "Anomaly Detected"
msgstr "Anomaly Detected"

#: src/features/navbar/navConfig.ts
msgid "Anomaly Detection"
msgstr "Anomaly Detection"

#: src/pages/assetLens/components/tabs/AnomalyDashboard.tsx
msgid "Anomaly status updated to {statusLabel}"
msgstr "Anomaly status updated to {statusLabel}"

#: src/pages/assetLens/components/tabs/imagesTabComponents/ImageAnomalyDisplay.tsx
msgid "Anomaly: {description}"
msgstr "Anomaly: {description}"

#: src/pages/manageAccess/components/table/UserRow.tsx
msgid "Another active admin is required before you can change your own user type."
msgstr "Another active admin is required before you can change your own user type."

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatEvalCaseReview.tsx
msgid "Answer"
msgstr "Answer"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/documentsCardView/documentCardFilterBar/MultiSelectFilterField.tsx
msgid "Any"
msgstr "Any"

#: src/pages/facilityModel/FacilityModelFilters.tsx
msgid "Any confidence"
msgstr "Any confidence"

#: src/pages/facilityModel/FacilityModelFilters.tsx
msgid "Any fill status"
msgstr "Any fill status"

#: src/pages/facilityModel/FacilityModelFilters.tsx
msgid "Any kind"
msgstr "Any kind"

#: src/features/timeSeries/components/panes/TagFilterControls.tsx
msgid "Any monitor coverage"
msgstr "Any monitor coverage"

#: src/pages/assetLens/components/tabs/imagesTabComponents/ImageUploadModal.tsx
msgid "Any observations or notes about this scan (e.g., operating conditions, suspected issues)"
msgstr "Any observations or notes about this scan (e.g., operating conditions, suspected issues)"

#: src/pages/facilityModel/FacilityModelFilters.tsx
msgid "Any sources"
msgstr "Any sources"

#: src/pages/facilityModel/FacilityModelFilters.tsx
msgid "Any system"
msgstr "Any system"

#: src/pages/facilityModel/FacilityModelFilters.tsx
msgid "Any template"
msgstr "Any template"

#: src/pages/facilityModel/FacilityModelFilters.tsx
msgid "Any type"
msgstr "Any type"

#: src/pages/facilityModel/FacilityModelFilters.tsx
msgid "Any validation state"
msgstr "Any validation state"

#: src/pages/cases/components/CaseFeedbackModal.tsx
msgid "Anything generally helpful, confusing, or missing?"
msgstr "Anything generally helpful, confusing, or missing?"

#: src/features/timeSeries/sentinelStudio/SentinelBuilderPanel.tsx
msgid "anything the agent should know about this asset"
msgstr "anything the agent should know about this asset"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/utils/inspectionAnalysisCitations.ts
msgid "API 570"
msgstr "API 570"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/utils/inspectionAnalysisCitations.ts
msgid "API 653"
msgstr "API 653"

#: src/features/lotoReports/recordSheet/recordSheetLayout.ts
msgid "Appendix F"
msgstr "Appendix F"

#: src/features/modelOperations/templates/templateModel.ts
msgid "Applies-to type is required — it is how fusion matches this template to Subjects."
msgstr "Applies-to type is required — it is how fusion matches this template to Subjects."

#: src/features/timeSeries/components/CustomRangePicker.tsx
#: src/features/timeSeries/experiment/CorrelationCard.tsx
msgid "Apply"
msgstr "Apply"

#: src/features/timeSeries/agentTab/dock/AgentDock.tsx
msgid "Apply & refit"
msgstr "Apply & refit"

#: src/features/timeSeries/experiment/CorrelationCard.tsx
msgid "Apply best shifts (all)"
msgstr "Apply best shifts (all)"

#: src/features/timeSeries/experiment/ExperimentTab.tsx
msgid "Apply gate to test range"
msgstr "Apply gate to test range"

#: src/features/timeSeries/components/DataSmoothing.tsx
msgid "Apply moving window operations to reduce noise"
msgstr "Apply moving window operations to reduce noise"

#: src/features/fimReview/StructuralReviewFlow.tsx
msgid "Apply previewed change"
msgstr "Apply previewed change"

#: src/features/fimReview/DecisionHistory.tsx
msgid "Apply revert"
msgstr "Apply revert"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatTagPickerCard.tsx
msgid "Apply selection"
msgstr "Apply selection"

#: src/features/timeSeries/components/DataSmoothing.tsx
msgid "Apply to all sensors"
msgstr "Apply to all sensors"

#: src/features/fimReview/StructuralReviewFlow.tsx
msgid "Applying…"
msgstr "Applying…"

#: src/features/embeddedSidebar/chatHistory/AgenticChatHistorySessionOverflowMenu.tsx
#: src/features/forecastNotifications/NotificationDetailPanel.tsx
msgid "Archive"
msgstr "Archive"

#: src/features/embeddedSidebar/chatHistory/ChatHistoryOverflowMenu.tsx
msgid "Archive all"
msgstr "Archive all"

#: src/pages/cases/md/MdCasesCardList.tsx
msgid "Archive Case"
msgstr "Archive Case"

#: src/features/embeddedSidebar/chatHistory/ChatHistoryBulkActionDialog.tsx
msgid "Archive chats"
msgstr "Archive chats"

#: src/features/forecastNotifications/NotificationsDropdownContent.tsx
msgid "Archive notification"
msgstr "Archive notification"

#: src/features/embeddedSidebar/chatHistory/ChatHistoryBulkActionDialog.tsx
msgid "Archive recent chats?"
msgstr "Archive recent chats?"

#: src/features/forecastNotifications/notificationUtils.ts
#: src/pages/cases/md/MdCasesListPage.tsx
msgid "Archived"
msgstr "Archived"

#: src/pages/cases/md/MdCasesListPage.tsx
msgid "Archived ({archivedCount})"
msgstr "Archived ({archivedCount})"

#: src/features/embeddedSidebar/chatHistory/ChatHistoryOverflowMenu.tsx
msgid "Archived chat actions"
msgstr "Archived chat actions"

#: src/features/embeddedSidebar/chatHistory/AgenticChatHistorySidebar.tsx
msgid "Archived chats"
msgstr "Archived chats"

#: src/pages/cases/md/MdCasesCardList.tsx
msgid "Archiving..."
msgstr "Archiving..."

#: src/features/embeddedSidebar/chatHistory/AgenticChatHistorySessionRow.tsx
#: src/features/embeddedSidebar/chatHistory/ChatHistoryBulkActionDialog.tsx
msgid "Archiving…"
msgstr "Archiving…"

#: src/features/auth/AuthInactivityMonitor.tsx
msgid "Are you still there?"
msgstr "Are you still there?"

#: src/pages/cases/components/CaseDetailsContent.tsx
msgid "Are you sure you want to delete this case?"
msgstr "Are you sure you want to delete this case?"

#: src/pages/manageAccess/components/dialogs/ConfirmUserTypeChangeDialog.tsx
msgid "Are you sure you want to make {personName} an administrator? They will be able to manage access, including inviting and deactivating people in the selected scope."
msgstr "Are you sure you want to make {personName} an administrator? They will be able to manage access, including inviting and deactivating people in the selected scope."

#: src/pages/systemView/components/SystemViewAnnotationSidebar.tsx
msgid "Are you sure you would like to delete \"{deletingWhiteboardName}\"? This action cannot be undone."
msgstr "Are you sure you would like to delete \"{deletingWhiteboardName}\"? This action cannot be undone."

#: src/features/dataFilter/categoryFilter/ValueBreakdownDisplayTypeSelector.tsx
#: src/pages/alerts/AlertDetails.tsx
#: src/pages/alerts/components/AlertsTableColumns.tsx
#: src/pages/details/visualization/markupEditing/RectAreaDisplay.tsx
msgid "Area"
msgstr "Area"

#: src/features/richText/components/slashCommandCards/UnitSlashCommandCard.tsx
msgid "Area: {unitArea}"
msgstr "Area: {unitArea}"

#: src/pages/processData/buildMode/dock/WindowsDockTab.tsx
msgid "Arm a role in the toolbar and drag on the chart, or Add window."
msgstr "Arm a role in the toolbar and drag on the chart, or Add window."

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/ResponseSegmentValueChip.tsx
msgid "as of {timestampText}"
msgstr "as of {timestampText}"

#: src/pages/cases/activity/ActivitySection.tsx
msgid "Ascending"
msgstr "Ascending"

#: src/features/chatbot/components/ChatbotInputCard.tsx
msgid "Ask a question..."
msgstr "Ask a question..."

#: src/pages/cases/md/MdCaseDetailsPage.tsx
#: src/pages/cases/md/MdCaseDetailsPage.tsx
msgid "Ask about this case"
msgstr "Ask about this case"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/AgenticChatColumn.tsx
msgid "Ask Cantilever"
msgstr "Ask Cantilever"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/InspectionPreviewPanel.tsx
msgid "Ask Cantilever to reopen this assessment to generate a report."
msgstr "Ask Cantilever to reopen this assessment to generate a report."

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/AgenticChatColumn.tsx
#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatResultsHeader.tsx
msgid "Ask Cantilever..."
msgstr "Ask Cantilever..."

#: src/features/timeSeries/agentTab/chat/Composer.tsx
msgid "Ask for a model, an edit, or an explanation…"
msgstr "Ask for a model, an edit, or an explanation…"

#: src/pages/details/extensions/flow/FilesExtension.tsx
msgid "Ask Rolodex for "
msgstr "Ask Rolodex for "

#: src/features/copcPointClouds/CopcViewerOverlay.tsx
#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/sensors/SensorPreviewPanel.tsx
#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/sensors/SensorTableColumns.tsx
#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
#: src/features/knowledgeDocumentViewer/workOrders/legacyCmmsRecordPdf.ts
#: src/features/knowledgeDocumentViewer/workOrders/legacyCmmsRecordPdf.ts
#: src/features/knowledgeDocumentViewer/workOrders/legacyCmmsRecordPdf.ts
#: src/features/knowledgeDocumentViewer/workOrders/WorkOrderCardMetadata.tsx
#: src/features/knowledgeDocumentViewer/workOrders/workOrderPresentation.ts
#: src/features/timeSeries/sentinelStudio/SentinelBuilderPanel.tsx
#: src/pages/cases/components/CaseDetailsSidebar.tsx
#: src/pages/cases/components/CaseSidebar.tsx
msgid "Asset"
msgstr "Asset"

#: src/pages/homepage/constants.ts
msgid "Asset Database"
msgstr "Asset Database"

#: src/pages/overview/sidebar/table/SiteViewSidebarTableOrganizers.tsx
msgid "Asset Details"
msgstr "Asset Details"

#: src/pages/assetLens/components/tabs/DocumentsTab.tsx
msgid "Asset Documents"
msgstr "Asset Documents"

#: src/pages/facilityModel/SubjectAssetPanel.tsx
msgid "Asset enrichment"
msgstr "Asset enrichment"

#: src/features/sentinels/SentinelInstancePicker.tsx
msgid "Asset instances"
msgstr "Asset instances"

#: src/pages/assetLens/AssetLens.tsx
msgid "Asset Lens: {unitLabel} | {DEFAULT_DOCUMENT_TITLE}"
msgstr "Asset Lens: {unitLabel} | {DEFAULT_DOCUMENT_TITLE}"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
msgid "Asset meter"
msgstr "Asset meter"

#: src/features/knowledgeDocumentViewer/workOrders/legacyCmmsRecordPdf.ts
msgid "Asset meters"
msgstr "Asset meters"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatInspectionCard.tsx
msgid "Asset model"
msgstr "Asset model"

#: src/pages/details/extensions/flow/AssetModelEditorExtension.tsx
#: src/pages/details/extensions/flow/AssetModelEditorExtension.tsx
#: src/pages/details/extensions/flow/AssetModelEditorExtension.tsx
msgid "Asset Model Editor"
msgstr "Asset Model Editor"

#: src/pages/alerts/components/AssetInfoCard.tsx
msgid "Asset Name"
msgstr "Asset Name"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
msgid "Asset register"
msgstr "Asset register"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
msgid "Asset specification"
msgstr "Asset specification"

#: src/features/knowledgeDocumentViewer/workOrders/legacyCmmsRecordPdf.ts
msgid "Asset specifications"
msgstr "Asset specifications"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
#: src/features/knowledgeDocumentViewer/workOrders/legacyCmmsRecordPdf.ts
msgid "Asset type"
msgstr "Asset type"

#: src/pages/systemView/components/unitsTab/UnitListItem.tsx
msgid "Asset Type: {assetTypeLabel}"
msgstr "Asset Type: {assetTypeLabel}"

#: src/features/knowledgeDocumentViewer/components/toolbar/AssetTypeFilter.tsx
msgid "Asset Types"
msgstr "Asset Types"

#: src/features/copcPointClouds/CopcViewerOverlay.tsx
msgid "Asset view"
msgstr "Asset view"

#: src/features/assetVizAdapter/ForecastAssetVizWindow.tsx
msgid "Asset viewer"
msgstr "Asset viewer"

#: src/pages/details/visualization/Visualization.tsx
msgid "Asset visualization description"
msgstr "Asset visualization description"

#: src/features/navbar/navConfig.ts
#: src/pages/cases/components/CaseDetailsSidebar.tsx
#: src/pages/cases/components/CaseSidebar.tsx
#: src/pages/facilityModel/FacilityModelCatalog.tsx
#: src/pages/facilityModel/FacilityModelCatalog.tsx
#: src/pages/systemView/components/DataPanel.tsx
msgid "Assets"
msgstr "Assets"

#: src/pages/manageAccess/components/dialogs/ConfirmUserTypeChangeDialog.tsx
msgid "Assign Admin Permissions"
msgstr "Assign Admin Permissions"

#: src/features/fimReview/ReviewActions.tsx
msgid "Assign alias(es) as junk"
msgstr "Assign alias(es) as junk"

#: src/features/fimReview/ReviewActions.tsx
msgid "Assign as junk"
msgstr "Assign as junk"

#: src/features/fimReview/ReviewActions.tsx
msgid "Assign each source to Subject A or Subject B."
msgstr "Assign each source to Subject A or Subject B."

#: src/features/timeSeries/experiment/knobCopy.ts
msgid "Assign each time chunk to train, val, or test. Train fits the model; val (if any) calibrates the residual band; test is held out for metrics. Click a chunk to cycle roles. Prod default ≈ first 90% train, last 10% test."
msgstr "Assign each time chunk to train, val, or test. Train fits the model; val (if any) calibrates the residual band; test is held out for metrics. Click a chunk to cycle roles. Prod default ≈ first 90% train, last 10% test."

#: src/features/fimReview/subjectDecisionBuilders.ts
msgid "Assign every source record before previewing ({unassigned} unassigned)."
msgstr "Assign every source record before previewing ({unassigned} unassigned)."

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
#: src/features/knowledgeDocumentViewer/workOrders/workOrderFields.ts
msgid "Assigned owner group"
msgstr "Assigned owner group"

#: src/features/fimReview/ReviewActions.tsx
msgid "Assigning…"
msgstr "Assigning…"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/JumpToLatestButton.tsx
msgid "Assistant is responding"
msgstr "Assistant is responding"

#: src/features/chatbot/hooks/useReconnect.ts
#: src/features/chatbot/utils/mapBackendMessages.ts
msgid "Assistant message errored"
msgstr "Assistant message errored"

#: src/features/chatbot/components/SessionHeaderBar.tsx
msgid "Assistant: {content}"
msgstr "Assistant: {content}"

#: src/features/mdCases/mdCaseDisplay.ts
msgid "at {fromLabel}"
msgstr "at {fromLabel}"

#: src/features/knowledgeDocumentViewer/workOrders/workOrderPdf.ts
msgid "At approval"
msgstr "At approval"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatInspectionCard.tsx
msgid "At calculation floor"
msgstr "At calculation floor"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatInspectionCard.tsx
msgid "At calculation limit"
msgstr "At calculation limit"

#: src/features/timeSeries/agentTab/dock/AlertingTab.tsx
msgid "at least"
msgstr "at least"

#: src/features/timeSeries/components/ThresholdConfigurationModal.tsx
#: src/features/timeSeries/services/thresholdService.ts
msgid "At least one threshold must be configured when enabled"
msgstr "At least one threshold must be configured when enabled"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatSearchBox.tsx
msgid "Attach an image"
msgstr "Attach an image"

#: src/features/fim/photos/PhotoUploadRow.tsx
msgid "Attach failed"
msgstr "Attach failed"

#: src/features/knowledgeDocumentViewer/components/bugReport/BugReportScreenshots.tsx
msgid "Attach or paste screenshots to help explain the issue. Images are sent to Gecko Support when you submit."
msgstr "Attach or paste screenshots to help explain the issue. Images are sent to Gecko Support when you submit."

#: src/features/knowledgeDocumentViewer/components/bugReport/BugReportScreenshots.tsx
msgid "Attach PNG, JPEG, or GIF images."
msgstr "Attach PNG, JPEG, or GIF images."

#: src/features/knowledgeDocumentViewer/components/bugReport/BugReportScreenshots.tsx
#: src/features/knowledgeDocumentViewer/components/bugReport/BugReportScreenshots.tsx
msgid "Attach screenshots"
msgstr "Attach screenshots"

#: src/features/fim/photos/PhotoLightbox.tsx
msgid "Attached"
msgstr "Attached"

#: src/features/lotoReports/components/LotoDrawingsCoverage.tsx
msgid "Attached drawings"
msgstr "Attached drawings"

#: src/features/lotoReports/printReport/printPageText.ts
msgid "Attached page {position} of {count}"
msgstr "Attached page {position} of {count}"

#: src/features/lotoReports/printReport/printPageText.ts
msgid "Attached page {position} of {count}: {drawing} could not be loaded."
msgstr "Attached page {position} of {count}: {drawing} could not be loaded."

#: src/features/fim/photos/SubjectPhotos.tsx
msgid "Attached photos"
msgstr "Attached photos"

#: src/features/fim/photos/PhotoUploadRow.tsx
msgid "Attaching…"
msgstr "Attaching…"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
#: src/features/knowledgeDocumentViewer/workOrders/legacyCmmsRecordPdf.ts
msgid "Attribute"
msgstr "Attribute"

#: src/features/mdCases/components/ProvenanceContentViewer.tsx
msgid "Audit"
msgstr "Audit"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatRevisionMissingCard.tsx
msgid "Audit state: {auditState}"
msgstr "Audit state: {auditState}"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
msgid "Author"
msgstr "Author"

#: src/features/timeSeries/components/XAxisSection.tsx
#: src/features/timeSeries/components/XAxisSection.tsx
#: src/features/timeSeries/components/XAxisSection.tsx
#: src/features/timeSeries/components/YAxisItem.tsx
#: src/features/timeSeries/components/YScaleControls.tsx
msgid "Auto"
msgstr "Auto"

#: src/features/kestrelViewer/ui/tools/photoreel/adjustments/PhotoAdjustPanel.tsx
msgid "Auto adjust"
msgstr "Auto adjust"

#: src/features/fimReview/SubjectDiagnostics.tsx
msgid "auto-applicable"
msgstr "auto-applicable"

#: src/pages/cases/components/EditCaseForm.tsx
msgid "Auto-saving..."
msgstr "Auto-saving..."

#: src/features/navbar/navConfig.ts
msgid "Availability Planning"
msgstr "Availability Planning"

#: src/features/knowledgeDocumentViewer/workOrders/workOrderPdf.ts
msgid "Availability reflects the recorded calculation, not installed or consumed parts."
msgstr "Availability reflects the recorded calculation, not installed or consumed parts."

#: src/features/knowledgeDocumentViewer/components/metadata/RevisionAuditBadge.tsx
msgid "available"
msgstr "available"

#: src/features/knowledgeDocumentViewer/components/metadata/RevisionAuditBadge.tsx
msgid "Available"
msgstr "Available"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
#: src/features/knowledgeDocumentViewer/workOrders/legacyCmmsRecordPdf.ts
msgid "Available balance field"
msgstr "Available balance field"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatRevisionMissingCard.tsx
msgid "Available count unknown"
msgstr "Available count unknown"

#: src/features/knowledgeDocumentViewer/components/DocumentUnavailablePanel.tsx
msgid "Available under"
msgstr "Available under"

#: src/pages/nnpp/imports/NnppImportProcessingPage.tsx
msgid "Available when processing completes successfully."
msgstr "Available when processing completes successfully."

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
#: src/features/knowledgeDocumentViewer/workOrders/legacyCmmsRecordPdf.ts
msgid "Average cost"
msgstr "Average cost"

#: src/pages/assetLens/components/tabs/imagesTabComponents/ImageUploadModal.tsx
msgid "Average Decibel (dB)"
msgstr "Average Decibel (dB)"

#: src/pages/assetLens/components/tabs/imagesTabComponents/ImageUploadModal.tsx
msgid "Average Temperature (°F)"
msgstr "Average Temperature (°F)"

#: src/pages/details/extensions/flow/SummarizerExtension.tsx
msgid "Average thickness"
msgstr "Average thickness"

#: src/features/assetLifecycleV2/views/observations/LtaObservationCompositeViz.tsx
msgid "Average Thickness"
msgstr "Average Thickness"

#: src/features/copcPointClouds/CopcPointCloudScene.tsx
#: src/features/copcPointClouds/CopcPointCloudScene.tsx
#: src/features/copcPointClouds/CopcViewerOverlay.tsx
msgid "Axial"
msgstr "Axial"

#: src/features/copcPointClouds/CopcOrientationCube.tsx
#: src/features/knowledgeDocumentViewer/components/toolbar/KnowledgeDocumentHeaderBar.tsx
#: src/features/knowledgeDocumentViewer/workOrders/WorkOrderViewer.tsx
#: src/features/powerCustomerUploads/components/PowerCustomerUploadReviewHeader.tsx
#: src/pages/processData/components/helpGuide/HelpGuideDialog.tsx
msgid "Back"
msgstr "Back"

#: src/features/mdCases/components/ProvenanceContentViewer.tsx
msgid "Back to {parentLabel}"
msgstr "Back to {parentLabel}"

#: src/features/knowledgeDocumentViewer/components/toolbar/KnowledgeDocumentHeaderBar.tsx
#: src/features/knowledgeDocumentViewer/components/toolbar/KnowledgeDocumentHeaderBar.tsx
msgid "Back to {referenceOriginLabel}"
msgstr "Back to {referenceOriginLabel}"

#: src/pages/alerts/AlertDetails.tsx
#: src/pages/alerts/AlertDetails.tsx
msgid "Back to alerts"
msgstr "Back to alerts"

#: src/pages/cases/components/CaseHeader.tsx
#: src/pages/cases/md/MdCaseDetailsPage.tsx
msgid "Back to cases"
msgstr "Back to cases"

#: src/features/timeSeries/components/DashboardHeader.tsx
msgid "Back to charts"
msgstr "Back to charts"

#: src/pages/evaluations/metadata/labeling/components/DataLabelingLandingBack.tsx
msgid "Back to dashboard"
msgstr "Back to dashboard"

#: src/pages/evaluations/components/BackToEvaluations.tsx
msgid "Back to Evaluations"
msgstr "Back to Evaluations"

#: src/features/powerCustomerUploads/components/PowerCustomerUploadPage.tsx
msgid "Back to home"
msgstr "Back to home"

#: src/pages/assetLens/components/tabs/SensorIssuesTab.tsx
msgid "Back to Issues"
msgstr "Back to Issues"

#: src/features/knowledgeDocumentViewer/components/toolbar/EvalSessionHeaderBar.tsx
msgid "Back to landing"
msgstr "Back to landing"

#: src/pages/evaluations/metadata/dashboard/components/dataLabeling/DataLabelingDashboardFieldDrilldown.tsx
msgid "Back to overview"
msgstr "Back to overview"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/ReportView.tsx
msgid "Back to report"
msgstr "Back to report"

#: src/features/powerCustomerUploads/state/powerCustomerUploadApprovalResponseMapping.ts
msgid "Backend could not create an upload session."
msgstr "Backend could not create an upload session."

#: src/features/powerCustomerUploads/state/powerCustomerUploadRowUpdates.ts
msgid "Backend did not return an approval result for this file."
msgstr "Backend did not return an approval result for this file."

#: src/features/powerCustomerUploads/components/PowerCustomerUploadReviewTable.tsx
msgid "Backend response"
msgstr "Backend response"

#: src/features/powerCustomerUploads/api/powerCustomerUploadClient.ts
msgid "Backend returned an invalid upload approval response."
msgstr "Backend returned an invalid upload approval response."

#: src/features/powerCustomerUploads/api/powerCustomerUploadClient.ts
msgid "Backend returned an invalid upload history files response."
msgstr "Backend returned an invalid upload history files response."

#: src/features/powerCustomerUploads/api/powerCustomerUploadClient.ts
msgid "Backend returned an invalid upload history response."
msgstr "Backend returned an invalid upload history response."

#: src/features/powerCustomerUploads/api/powerCustomerUploadClient.ts
msgid "Backend returned an invalid upload history sessions response."
msgstr "Backend returned an invalid upload history sessions response."

#: src/features/powerCustomerUploads/api/powerCustomerUploadClient.ts
msgid "Backend returned an invalid upload processing status response."
msgstr "Backend returned an invalid upload processing status response."

#: src/features/powerCustomerUploads/api/powerCustomerUploadClient.ts
msgid "Backend returned an invalid upload transfer failure response."
msgstr "Backend returned an invalid upload transfer failure response."

#: src/features/timeSeries/agentTab/dock/AgentDock.tsx
#: src/pages/processData/buildMode/components/BuildDock.tsx
msgid "Backtest"
msgstr "Backtest"

#: src/features/timeSeries/agentTab/dock/BacktestTab.tsx
msgid "Backtest {value152_51}"
msgstr "Backtest {value152_51}"

#: src/pages/processData/buildMode/dock/BacktestDockTab.tsx
msgid "Backtest a saved model"
msgstr "Backtest a saved model"

#: src/pages/processData/buildMode/dock/BacktestDockTab.tsx
msgid "Backtest end"
msgstr "Backtest end"

#: src/pages/processData/buildMode/dock/BacktestDockTab.tsx
msgid "Backtest start"
msgstr "Backtest start"

#: src/features/timeSeries/agentTab/dock/AgentDock.tsx
msgid "Backtesting needs a saved model. Ask the agent to save this one first."
msgstr "Backtesting needs a saved model. Ask the agent to save this one first."

#: src/features/timeSeries/agentTab/dock/AlertingTab.tsx
msgid "bad direction"
msgstr "bad direction"

#: src/features/chatbot/components/FeedbackMenu.tsx
msgid "Bad response"
msgstr "Bad response"

#: src/features/timeSeries/agentTab/dock/VersionsTab.tsx
msgid "band"
msgstr "band"

#: src/pages/processData/buildMode/dock/BandsDockTab.tsx
msgid "band (±)"
msgstr "band (±)"

#: src/features/timeSeries/agentTab/dock/TargetTab.tsx
msgid "band (1σ, sd of daily fit error)"
msgstr "band (1σ, sd of daily fit error)"

#: src/features/timeSeries/experiment/RunComparison.tsx
msgid "band {value74_25}→{value74_45}"
msgstr "band {value74_25}→{value74_45}"

#: src/features/timeSeries/components/SentinelsTab.tsx
msgid "Band compares {intervalMinutes}-minute averages against the model."
msgstr "Band compares {intervalMinutes}-minute averages against the model."

#: src/features/timeSeries/experiment/DiagnosticsPanel.tsx
#: src/features/timeSeries/experiment/RunComparison.tsx
msgid "Band cov."
msgstr "Band cov."

#: src/features/timeSeries/experiment/ModelKnobs.tsx
#: src/pages/processData/buildMode/dock/BandsDockTab.tsx
msgid "Band estimator"
msgstr "Band estimator"

#: src/features/timeSeries/agentTab/dock/TargetTab.tsx
msgid "Band from {bandSource}. Leave-one-out, so the fit is not graded against rows it memorised."
msgstr "Band from {bandSource}. Leave-one-out, so the fit is not graded against rows it memorised."

#: src/pages/processData/buildMode/dock/BandsDockTab.tsx
#: src/pages/processData/buildMode/dock/BandsDockTab.tsx
msgid "Band k"
msgstr "Band k"

#: src/features/timeSeries/experiment/ModelKnobs.tsx
msgid "Band k (multiplier)"
msgstr "Band k (multiplier)"

#: src/features/timeSeries/experiment/ModelKnobs.tsx
#: src/pages/processData/buildMode/dock/BandsDockTab.tsx
msgid "Band quantile"
msgstr "Band quantile"

#: src/features/sentinels/components/MonitorTab.tsx
msgid "Band width (x residual scale) — breach when |residual| exceeds this"
msgstr "Band width (x residual scale) — breach when |residual| exceeds this"

#: src/features/timeSeries/experiment/RunComparison.tsx
msgid "band_k {value72_27}→{value72_48}"
msgstr "band_k {value72_27}→{value72_48}"

#: src/features/timeSeries/agentTab/chat/BuildCard.tsx
msgid "banded {bandStart} → {bandEnd}"
msgstr "banded {bandStart} → {bandEnd}"

#: src/pages/processData/buildMode/components/BuildDock.tsx
msgid "Bands"
msgstr "Bands"

#: src/features/timeSeries/agentTab/dock/VersionsTab.tsx
msgid "baseline"
msgstr "baseline"

#: src/features/timeSeries/agentTab/dock/WindowsTab.tsx
msgid "Baseline — learned from"
msgstr "Baseline — learned from"

#: src/features/timeSeries/agentTab/chat/BuildCard.tsx
msgid "baseline <0>{baselineMedian}</0>"
msgstr "baseline <0>{baselineMedian}</0>"

#: src/features/timeSeries/agentTab/dock/TargetTab.tsx
msgid "baseline median"
msgstr "baseline median"

#: src/features/timeSeries/agentTab/dock/TargetTab.tsx
msgid "baseline rows"
msgstr "baseline rows"

#: src/pages/facilityModel/SubjectAssetPanel.tsx
msgid "basis: {basis}"
msgstr "basis: {basis}"

#: src/features/fimReview/StructuralReviewFlow.tsx
#: src/features/knowledgeDocumentViewer/components/revisionCompare/RevisionChangeCitations.tsx
#: src/features/knowledgeDocumentViewer/components/revisionCompare/RevisionChangeCropPair.tsx
#: src/features/knowledgeDocumentViewer/components/revisionCompare/RevisionCompareContent.tsx
msgid "Before"
msgstr "Before"

#: src/features/knowledgeDocumentViewer/components/table/enhancements/filters/DateFilter.tsx
msgid "Before {endDate}"
msgstr "Before {endDate}"

#: src/features/knowledgeDocumentViewer/components/table/enhancements/filters/DateFilter.tsx
msgid "Before:"
msgstr "Before:"

#: src/features/mdCases/components/CaseStorySection.tsx
msgid "Below expected range"
msgstr "Below expected range"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatInspectionCard.tsx
msgid "Below minimum thickness"
msgstr "Below minimum thickness"

#: src/pages/processData/buildMode/dock/EngineeringSection.tsx
msgid "best shift"
msgstr "best shift"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatAgentsMenu.tsx
#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatBetaSwitch.tsx
#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatBetaSwitch.tsx
#: src/pages/processData/components/helpGuide/HelpGuideChapters.tsx
msgid "Beta"
msgstr "Beta"

#: src/features/permissions/profiles/power.ts
msgid "Beta features"
msgstr "Beta features"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
#: src/features/knowledgeDocumentViewer/workOrders/legacyCmmsRecordPdf.ts
msgid "Bin"
msgstr "Bin"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
msgid "Bin balance"
msgstr "Bin balance"

#: src/features/knowledgeDocumentViewer/workOrders/legacyCmmsRecordPdf.ts
msgid "Bin balances"
msgstr "Bin balances"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatInspectionCard.tsx
msgid "Bin columns [{xStart}, {xEnd}), rows [{yStart}, {yEnd})"
msgstr "Bin columns [{xStart}, {xEnd}), rows [{yStart}, {yEnd})"

#: src/pages/details/visualization/alerts/specificAlerts/DimensionMismatchAlert.tsx
msgid "Bin size: {formattedBinSize}"
msgstr "Bin size: {formattedBinSize}"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
msgid "Bin-level stock snapshot; not a reservation or availability guarantee."
msgstr "Bin-level stock snapshot; not a reservation or availability guarantee."

#: src/pages/evaluations/metadata/dashboard/components/dataLabeling/DataLabelingDashboardComparisonRow.tsx
#: src/pages/evaluations/metadata/dashboard/components/dataLabeling/DataLabelingDashboardComparisonRow.tsx
msgid "Blank"
msgstr "Blank"

#: src/features/timeSeries/agentTab/dock/SettingsTab.tsx
msgid "Blanks every pen on days the gate or a masked range removed, so the chart shows only what the fit graded. The axis still spans the full window, so the gaps stay visible."
msgstr "Blanks every pen on days the gate or a masked range removed, so the chart shows only what the fit graded. The axis still spans the full window, so the gaps stay visible."

#: src/features/richText/components/ToolbarPlugin.tsx
msgid "Bold (Ctrl+B)"
msgstr "Bold (Ctrl+B)"

#: src/features/timeSeries/experiment/RunComparison.tsx
msgid "Bold method = lowest test MAE within its run. Metrics come from each method's held-out test split."
msgstr "Bold method = lowest test MAE within its run. Metrics come from each method's held-out test split."

#: src/features/timeSeries/utils/uPlotPlugins.ts
msgid "Bookmarked point"
msgstr "Bookmarked point"

#: src/pages/evaluations/metadata/dashboard/components/dataLabeling/DataLabelingDashboardComparisonRow.tsx
#: src/pages/evaluations/metadata/dashboard/components/dataLabeling/DataLabelingDashboardFieldDrilldown.tsx
msgid "Both blank"
msgstr "Both blank"

#: src/features/copcPointClouds/CopcOrientationCube.tsx
msgid "Bottom"
msgstr "Bottom"

#: src/features/workbench/LayoutToggles.tsx
msgid "bottom panel"
msgstr "bottom panel"

#: src/pages/facilityModel/SubjectAssetPanel.tsx
msgid "Bound"
msgstr "Bound"

#: src/pages/processData/buildMode/dock/TagCleaningEditor.tsx
msgid "Bounds max"
msgstr "Bounds max"

#: src/pages/processData/buildMode/dock/TagCleaningEditor.tsx
msgid "Bounds min"
msgstr "Bounds min"

#: src/pages/processData/buildMode/components/ChartOverlayToggles.tsx
#: src/pages/processData/buildMode/components/ChartOverlayToggles.tsx
msgid "Bounds on the target"
msgstr "Bounds on the target"

#: src/features/knowledgeDocumentViewer/components/viewer/shared/OffPageConnectorTooltip.tsx
#: src/features/knowledgeDocumentViewer/components/viewer/shared/PositionedTooltip.tsx
msgid "Box {boxId}"
msgstr "Box {boxId}"

#: src/features/kestrelViewer/ui/tools/photoreel/adjustments/PhotoAdjustPanel.tsx
#: src/features/kestrelViewer/ui/tools/photoreel/adjustments/PhotoAdjustPanel.tsx
msgid "Brightness"
msgstr "Brightness"

#: src/features/kestrelViewer/ui/tools/photoreel/PhotoViewerToolbar.tsx
msgid "Brightness / contrast (A: toggle auto-adjust; double-click to auto)"
msgstr "Brightness / contrast (A: toggle auto-adjust; double-click to auto)"

#: src/pages/evaluations/metadata/labeling/components/DataLabelingLanding.tsx
msgid "Browse labeled"
msgstr "Browse labeled"

#: src/features/knowledgeDocumentViewer/components/toolbar/SearchResultsNavigator.tsx
msgid "Browse search results"
msgstr "Browse search results"

#: src/features/permissions/profiles/power.ts
msgid "Browse, search, and download documents."
msgstr "Browse, search, and download documents."

#: src/features/timeSeries/components/PenTransformControls.tsx
msgid "Bucket"
msgstr "Bucket"

#: src/features/timeSeries/agentTab/dock/TargetTab.tsx
msgid "bucket by"
msgstr "bucket by"

#: src/features/timeSeries/components/PenTransformControls.tsx
msgid "Bucket interval"
msgstr "Bucket interval"

#: src/features/navbar/navConfig.ts
msgid "Budgeting"
msgstr "Budgeting"

#: src/features/knowledgeDocumentViewer/components/bugReport/BugReportTypeField.tsx
msgid "Bug"
msgstr "Bug"

#: src/features/knowledgeDocumentViewer/components/bugReport/DocumentsBugReportButton.tsx
msgid "Bug details"
msgstr "Bug details"

#: src/pages/processData/buildMode/components/ModeSwitcher.tsx
msgid "Build"
msgstr "Build"

#: src/features/timeSeries/sentinelStudio/SentinelBuilderPanel.tsx
msgid "Build & run everything"
msgstr "Build & run everything"

#: src/features/timeSeries/agentTab/AgentChatPanel.tsx
msgid "Build a health model for the gas turbine compressor: isentropic efficiency, field-fitted against 2022."
msgstr "Build a health model for the gas turbine compressor: isentropic efficiency, field-fitted against 2022."

#: src/features/timeSeries/sentinelStudio/SentinelBuilderPanel.tsx
msgid "Build context"
msgstr "Build context"

#: src/features/sentinels/useSentinelList.ts
msgid "building context…"
msgstr "building context…"

#: src/features/timeSeries/sentinelStudio/SentinelBuilderPanel.tsx
msgid "Building context…"
msgstr "Building context…"

#: src/features/timeSeries/sentinelStudio/SentinelBuilderPanel.tsx
msgid "Building the context bundle"
msgstr "Building the context bundle"

#: src/features/timeSeries/sentinelStudio/SentinelBuilderPanel.tsx
msgid "Builds the context, then designs, fits and evaluates end to end without the per-stage buttons. Stops early if the context is ineligible or the plan cannot run."
msgstr "Builds the context, then designs, fits and evaluates end to end without the per-stage buttons. Stops early if the context is ineligible or the plan cannot run."

#: src/features/knowledgeDocumentViewer/components/table/enhancements/BulkEditModal.tsx
#: src/features/knowledgeDocumentViewer/components/table/enhancements/TableTopBar.tsx
msgid "Bulk Actions"
msgstr "Bulk Actions"

#: src/features/knowledgeDocumentViewer/components/table/enhancements/BulkEditModal.tsx
msgid "Bulk Delete"
msgstr "Bulk Delete"

#: src/features/knowledgeDocumentViewer/components/table/enhancements/BulkEditModal.tsx
msgid "Bulk Edit Field"
msgstr "Bulk Edit Field"

#: src/features/richText/components/ToolbarPlugin.tsx
msgid "Bullet List"
msgstr "Bullet List"

#: src/pages/evaluations/metadata/labeling/utils/pageClassificationTaxonomy.ts
msgid "Business and organizational information"
msgstr "Business and organizational information"

#: src/pages/evaluations/metadata/labeling/utils/pageClassificationTaxonomy.ts
msgid "Business correspondence and project narratives"
msgstr "Business correspondence and project narratives"

#: src/features/mdCases/components/CaseTimeline.tsx
msgid "by {user}"
msgstr "by {user}"

#: src/pages/processData/buildMode/dock/WindowsDockTab.tsx
msgid "By month"
msgstr "By month"

#: src/pages/processData/buildMode/dock/WindowsDockTab.tsx
msgid "By N days"
msgstr "By N days"

#: src/pages/processData/buildMode/dock/WindowsDockTab.tsx
msgid "By year"
msgstr "By year"

#: src/features/assetLifecycleV2/views/observations/LtaObservationCompositeViz.tsx
msgid "C Extent"
msgstr "C Extent"

#: src/features/sentinels/components/MonitorTab.tsx
msgid "Cadence"
msgstr "Cadence"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatInspectionCard.tsx
msgid "Calculated as of"
msgstr "Calculated as of"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatInspectionCard.tsx
msgid "Calculated from available bins; not an inspection interval or an asset pass/fail assessment."
msgstr "Calculated from available bins; not an inspection interval or an asset pass/fail assessment."

#: src/features/timeSeries/components/ActiveTimeRangeSelector.tsx
msgid "Calculating"
msgstr "Calculating"

#: src/pages/processData/buildMode/dock/BandsDockTab.tsx
msgid "calib rows"
msgstr "calib rows"

#: src/pages/processData/buildMode/dock/BandsDockTab.tsx
msgid "Calibrated"
msgstr "Calibrated"

#: src/features/chatbot/hooks/useMessageSender.ts
#: src/features/chatbot/hooks/useMessageSender.ts
msgid "Calling {functionName}"
msgstr "Calling {functionName}"

#: src/features/chatbot/utils/mapBackendMessages.ts
msgid "Calling {toolName}"
msgstr "Calling {toolName}"

#: src/features/copcPointClouds/CopcOrientationCube.tsx
msgid "Camera orientation"
msgstr "Camera orientation"

#: src/features/kestrelViewer/ui/tools/photoreel/PhotoReel2DToolbar.tsx
msgid "Camera pose projections"
msgstr "Camera pose projections"

#: src/features/kestrelViewer/ui/tools/photoreel/PhotoReel2DToolbar.tsx
msgid "Camera poses"
msgstr "Camera poses"

#: src/pages/manageAccess/users.ts
msgctxt "access role"
msgid "Can open Manage Access and change who has access, including inviting and deactivating people."
msgstr "Can open Manage Access and change who has access, including inviting and deactivating people."

#: src/components/NamePromptModal.tsx
#: src/features/chatbot/components/ChatbotHelpModal.tsx
#: src/features/chatbot/components/conversationMessage/UserMessage.tsx
#: src/features/embeddedSidebar/chatHistory/AgenticChatHistorySessionOverflowMenu.tsx
#: src/features/embeddedSidebar/chatHistory/AgenticChatHistorySessionOverflowMenu.tsx
#: src/features/embeddedSidebar/chatHistory/ChatHistoryBulkActionDialog.tsx
#: src/features/fim/photos/PhotoLightbox.tsx
#: src/features/forecastNotifications/NotificationPreferencesModal.tsx
#: src/features/kestrelUpload/KestrelModelUploadSection.tsx
#: src/features/kestrelUpload/KestrelModelUploadSection.tsx
#: src/features/kestrelUpload/KestrelModelUploadSection.tsx
#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatEvalCaseReview.tsx
#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatFeedbackDialog.tsx
#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatQueuedMessageRow.tsx
#: src/features/knowledgeDocumentViewer/components/bugReport/DocumentsBugReportButton.tsx
#: src/features/knowledgeDocumentViewer/components/metadata/ChooseEditScopePanel.tsx
#: src/features/knowledgeDocumentViewer/components/metadata/DeferPageMetadataDialog.tsx
#: src/features/knowledgeDocumentViewer/components/metadata/MetadataEditFormChrome.tsx
#: src/features/knowledgeDocumentViewer/components/sidebar/FeedbackModal.tsx
#: src/features/lotoReports/components/DeleteLotoReportButton.tsx
#: src/features/lotoReports/components/LotoLeaveDialog.tsx
#: src/features/powerCustomerUploads/components/PowerCustomerUploadPage.tsx
#: src/features/powerCustomerUploads/components/PowerCustomerUploadSelection.tsx
#: src/features/timeSeries/components/chartActions/ChartSaveAction.tsx
#: src/features/timeSeries/components/DerivedValues.tsx
#: src/features/timeSeries/components/LabelsTab.tsx
#: src/features/timeSeries/components/labelTool/LabelConfigPanel.tsx
#: src/features/timeSeries/components/panes/DerivedTagsPane.tsx
#: src/features/timeSeries/components/panes/TagConfigurationPane.tsx
#: src/features/timeSeries/components/RegressionPrediction.tsx
#: src/features/timeSeries/components/ThresholdConfigurationModal.tsx
#: src/pages/cases/components/CaseFeedbackModal.tsx
#: src/pages/cases/components/DeleteCaseModal.tsx
#: src/pages/cases/md/MdCaseDetailsMainColumn.tsx
#: src/pages/cases/md/MdCaseDetailsMainColumn.tsx
#: src/pages/cases/md/MdCaseDetailsMainColumn.tsx
#: src/pages/cases/md/MdCaseDetailsPage.tsx
#: src/pages/cases/md/MdCaseReferencesDrawer.tsx
#: src/pages/cases/md/MdCaseReferencesDrawer.tsx
#: src/pages/details/extensions/flow/filesExt/FileMenuButton.tsx
#: src/pages/facilityModel/SubjectDetailPage.tsx
#: src/pages/manageAccess/components/dialogs/ConfirmUserTypeChangeDialog.tsx
#: src/pages/manageAccess/components/dialogs/ManagedUserConfirmDialog.tsx
#: src/pages/manageAccess/components/dialogs/SiteAccessDialog.tsx
#: src/pages/manageAccess/components/invite/InviteUsersDialog.tsx
#: src/pages/nnpp/acceptance/NnppAcceptanceReviewPage.tsx
#: src/pages/processData/components/viewSwitcher/ViewActionDialogs.tsx
#: src/pages/processData/components/viewSwitcher/ViewActionDialogs.tsx
#: src/pages/systemView/components/SystemViewAnnotationSidebar.tsx
msgid "Cancel"
msgstr "Cancel"

#: src/features/knowledgeDocumentViewer/components/metadata/ChooseEditScopePanel.tsx
msgid "Cancel choose edit scope"
msgstr "Cancel choose edit scope"

#: src/pages/systemView/components/SystemViewAnnotationSidebar.tsx
msgid "Cancel editing"
msgstr "Cancel editing"

#: src/features/knowledgeDocumentViewer/components/metadata/DocumentMetadataEditSection.tsx
msgid "Cancel editing document metadata"
msgstr "Cancel editing document metadata"

#: src/features/knowledgeDocumentViewer/components/metadata/PageMetadataEditSection.tsx
msgid "Cancel editing page metadata"
msgstr "Cancel editing page metadata"

#: src/features/timeSeries/agentTab/chat/ConversationDrawer.tsx
msgid "Cancel rename"
msgstr "Cancel rename"

#: src/pages/processData/buildMode/components/BuildPrimaryCta.tsx
msgid "Cancel training"
msgstr "Cancel training"

#: src/features/powerCustomerUploads/components/PowerCustomerUploadHistoryPanel.tsx
#: src/features/powerCustomerUploads/components/powerCustomerUploadHistoryPresentation.ts
#: src/features/powerCustomerUploads/components/PowerCustomerUploadStatus.tsx
msgid "Cancelled"
msgstr "Cancelled"

#: src/pages/manageAccess/users.ts
msgctxt "access role"
msgid "Cannot open Manage Access or change other people's access."
msgstr "Cannot open Manage Access or change other people's access."

#: src/features/knowledgeDocumentViewer/hooks/useAppendDocumentPageMetadataUserEditComment.ts
msgid "Cannot save a comment without a document id"
msgstr "Cannot save a comment without a document id"

#: src/features/timeSeries/hooks/useChartSave.ts
msgid "Cannot save chart: Invalid chart ID"
msgstr "Cannot save chart: Invalid chart ID"

#: src/features/knowledgeDocumentViewer/hooks/useDocumentMetadataUserEditSaveActions.ts
msgid "Cannot save document metadata without a document id"
msgstr "Cannot save document metadata without a document id"

#: src/features/knowledgeDocumentViewer/hooks/usePageMetadataUserEditSaveActions.ts
msgid "Cannot save page metadata without a document id"
msgstr "Cannot save page metadata without a document id"

#: src/pages/cases/md/MdCasesListProvider.tsx
msgid "Cannot shelve an M&D case without a current user email"
msgstr "Cannot shelve an M&D case without a current user email"

#: src/features/fimReview/subjectDecisionBuilders.ts
msgid "Canonical name is required."
msgstr "Canonical name is required."

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/AgenticChatColumn.tsx
msgid "Cantilever can make mistakes. Double-check responses."
msgstr "Cantilever can make mistakes. Double-check responses."

#: src/features/terms/TermsModal.tsx
msgid "Cantilever Terms of Service"
msgstr "Cantilever Terms of Service"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/EvidencePreview.tsx
msgid "Cantilever was unable to verify this claim. Please verify the source."
msgstr "Cantilever was unable to verify this claim. Please verify the source."

#: src/pages/assetLens/components/AssetTabs.tsx
msgid "Canvas"
msgstr "Canvas"

#: src/pages/overview/sidebar/capexOutlook/SiteViewCapExOutlook.tsx
msgid "CapEx Outlook"
msgstr "CapEx Outlook"

#: src/pages/overview/sidebar/capexOutlook/SiteViewCapExOutlookMenu.tsx
msgid "CapEx outlook settings"
msgstr "CapEx outlook settings"

#: src/features/fim/photos/PhotoLightbox.tsx
msgid "Caption"
msgstr "Caption"

#: src/features/fim/photos/SubjectPhotoLightbox.tsx
msgid "Caption save failed: {reason}"
msgstr "Caption save failed: {reason}"

#: src/pages/cases/md/MdCaseDetailsMainColumn.tsx
msgid "Capture what we know, what we checked, and what still needs follow-up."
msgstr "Capture what we know, what we checked, and what still needs follow-up."

#: src/features/fim/photos/PhotoLightbox.tsx
msgid "Captured {capturedAt} (at upload time)"
msgstr "Captured {capturedAt} (at upload time)"

#: src/features/fim/photos/PhotoLightbox.tsx
msgid "Captured {capturedAt} (from the camera clock)"
msgstr "Captured {capturedAt} (from the camera clock)"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatEvalCaseReview.tsx
msgid "Captured from"
msgstr "Captured from"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocumentViewModeToggle.tsx
msgid "Card"
msgstr "Card"

#: src/pages/processData/buildMode/dock/SamplingSection.tsx
msgid "carry forward"
msgstr "carry forward"

#: src/pages/alerts/components/AlertsTableColumns.tsx
#: src/pages/cases/md/MdCasesColumnHeader.tsx
#: src/pages/facilityModel/SentinelOverviewPage.tsx
msgid "Case"
msgstr "Case"

#: src/features/chatbot/components/conversationMessage/ProposalCard.tsx
msgid "Case context unavailable. Open this case directly to accept."
msgstr "Case context unavailable. Open this case directly to accept."

#: src/pages/cases/md/MdCaseDetailsInspector.tsx
msgid "Case Controls"
msgstr "Case Controls"

#: src/features/mdCases/components/CaseTimeline.tsx
msgid "Case created"
msgstr "Case created"

#: src/features/cases/components/CreateCaseModal.tsx
msgid "Case created successfully!"
msgstr "Case created successfully!"

#: src/pages/cases/components/CaseDetailsContent.tsx
#: src/pages/cases/components/CaseMetadataForm.tsx
#: src/pages/cases/md/MdCaseDetailsMainColumn.tsx
#: src/pages/cases/md/MdCaseDetailsPage.tsx
msgid "Case Details"
msgstr "Case Details"

#: src/pages/cases/components/CaseDetailsSidebar.tsx
msgid "Case Information"
msgstr "Case Information"

#: src/pages/cases/components/CaseDetailsContent.tsx
#: src/pages/cases/components/EditCaseForm.tsx
#: src/pages/cases/md/mdCaseDetailsHelpers.ts
msgid "Case not found"
msgstr "Case not found"

#: src/pages/assetLens/components/tabs/SensorIssuesTab.tsx
msgid "Case Priority"
msgstr "Case Priority"

#: src/features/mdCases/components/CaseStorySection.tsx
msgid "Case signals · {target}"
msgstr "Case signals · {target}"

#: src/features/cases/forms/caseFormFields.ts
#: src/pages/assetLens/components/tabs/SensorIssuesTab.tsx
#: src/pages/cases/components/CasesTableColumns.tsx
msgid "Case Status"
msgstr "Case Status"

#: src/pages/cases/md/MdCaseDetailsMainColumn.tsx
msgid "Case title"
msgstr "Case title"

#: src/features/cases/forms/caseFormFields.ts
msgid "Case Title"
msgstr "Case Title"

#: src/features/cases/forms/caseFormFields.ts
#: src/pages/cases/components/CasesTableColumns.tsx
msgid "Case Type"
msgstr "Case Type"

#: src/pages/cases/contexts/CaseDetailsProvider.tsx
#: src/pages/cases/contexts/CaseDetailsProvider.tsx
msgid "Case Updated"
msgstr "Case Updated"

#: src/pages/cases/components/CasesTable.tsx
#: src/pages/cases/components/CasesTable.tsx
msgid "cases"
msgstr "cases"

#: src/features/navbar/navConfig.ts
#: src/features/sentinels/components/CasesPanel.tsx
#: src/features/sentinels/components/CasesPanel.tsx
#: src/pages/cases/CasesList.tsx
#: src/pages/cases/components/CaseHeader.tsx
#: src/pages/cases/components/CasesTable.tsx
#: src/pages/cases/md/MdCasesListPage.tsx
msgid "Cases"
msgstr "Cases"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
#: src/features/knowledgeDocumentViewer/workOrders/legacyCmmsRecordPdf.ts
msgid "Catalog code"
msgstr "Catalog code"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
msgid "Catalog item"
msgstr "Catalog item"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
msgid "Catalog specifications; not proof of installation."
msgstr "Catalog specifications; not proof of installation."

#: src/features/knowledgeDocumentViewer/graph/nodeTooltip.ts
#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
#: src/features/knowledgeDocumentViewer/workOrders/legacyCmmsRecordPdf.ts
#: src/features/knowledgeDocumentViewer/workOrders/legacyCmmsRecordPdf.ts
msgid "Category"
msgstr "Category"

#: src/pages/details/visualization/alerts/specificAlerts/DimensionMismatchAlert.tsx
msgid "CDF bounds greatly exceed asset model bounds"
msgstr "CDF bounds greatly exceed asset model bounds"

#: src/pages/details/visualization/alerts/specificAlerts/DimensionMismatchAlert.tsx
msgid "CDF bounds slightly exceed asset model bounds"
msgstr "CDF bounds slightly exceed asset model bounds"

#: src/pages/details/visualization/alerts/specificAlerts/DimensionMismatchAlert.tsx
msgid "CDF bounds somewhat exceed asset model bounds"
msgstr "CDF bounds somewhat exceed asset model bounds"

#: src/features/timeSeries/experiment/ExperimentTab.tsx
msgid "Centered window over each denoised tag, "
msgstr "Centered window over each denoised tag, "

#: src/features/fimReview/StructuralReviewFlow.tsx
#: src/features/fimReview/StructuralReviewFlow.tsx
#: src/features/knowledgeDocumentViewer/components/metadata/ActiveEditScopeBanner.tsx
msgid "Change"
msgstr "Change"

#: src/pages/manageAccess/components/dialogs/ConfirmUserTypeChangeDialog.tsx
msgid "Change {personName} from {currentTypeLabel} to {nextTypeLabel}? This updates their Cantilever access in the selected scope."
msgstr "Change {personName} from {currentTypeLabel} to {nextTypeLabel}? This updates their Cantilever access in the selected scope."

#: src/features/knowledgeDocumentViewer/components/revisionCompare/RevisionCompareContent.tsx
msgid "Change details are unavailable."
msgstr "Change details are unavailable."

#: src/features/knowledgeDocumentViewer/components/metadata/ActiveEditScopeBanner.tsx
msgid "Change edit scope"
msgstr "Change edit scope"

#: src/features/fimReview/ReviewActions.tsx
msgid "Change the name, kind, or type"
msgstr "Change the name, kind, or type"

#: src/features/fimReview/ReviewActions.tsx
msgid "Change the name, kind, or type to save."
msgstr "Change the name, kind, or type to save."

#: src/features/navbar/ThemeModeToggle.tsx
#: src/features/navbar/ThemeModeToggle.tsx
msgid "Change theme to {theme}"
msgstr "Change theme to {theme}"

#: src/features/navbar/UnitsToggle.tsx
msgid "Change units to inches"
msgstr "Change units to inches"

#: src/features/navbar/UnitsToggle.tsx
msgid "Change units to millimeters"
msgstr "Change units to millimeters"

#: src/pages/manageAccess/components/dialogs/ConfirmUserTypeChangeDialog.tsx
msgid "Change user type?"
msgstr "Change user type?"

#: src/features/knowledgeDocumentViewer/components/revisionCompare/RevisionStatusLegend.tsx
msgid "Changed"
msgstr "Changed"

#: src/features/cases/components/CasePropertyChangedContent.tsx
msgid "Changed {fieldName}"
msgstr "Changed {fieldName}"

#: src/features/knowledgeDocumentViewer/components/metadata/PageMetadataEditSection.tsx
msgid "Changing Drawing # or Sheet # removes this document from the revision family."
msgstr "Changing Drawing # or Sheet # removes this document from the revision family."

#: src/features/knowledgeDocumentViewer/components/metadata/DocumentMetadataEditSection.tsx
msgid "Changing Drawing # removes this document from the revision family."
msgstr "Changing Drawing # removes this document from the revision family."

#: src/features/richText/components/slashCommandCards/ChartSlashCommandCard.tsx
msgid "Chart"
msgstr "Chart"

#: src/features/timeSeries/agentTab/chat/BuildCard.tsx
msgid "chart · {changes}"
msgstr "chart · {changes}"

#: src/features/timeSeries/components/ScatterplotConfigSidebar.tsx
msgid "Chart Configuration"
msgstr "Chart Configuration"

#: src/features/timeSeries/components/DashboardHeader.tsx
msgid "Chart has unsaved changes"
msgstr "Chart has unsaved changes"

#: src/features/mdCases/components/ProvenanceContentViewer.tsx
#: src/features/mdCases/components/ProvenanceContentViewer.tsx
msgid "Chart ID"
msgstr "Chart ID"

#: src/features/timeSeries/components/YScaleControls.tsx
msgid "Chart mode"
msgstr "Chart mode"

#: src/features/timeSeries/components/DashboardHeader.tsx
msgid "Chart name"
msgstr "Chart name"

#: src/pages/processData/buildMode/components/ChartOverlayToggles.tsx
#: src/pages/processData/buildMode/components/ChartOverlayToggles.tsx
msgid "Chart overlay visibility"
msgstr "Chart overlay visibility"

#: src/pages/processData/buildMode/components/ChartOverlayToggles.tsx
msgid "Chart overlays"
msgstr "Chart overlays"

#: src/features/timeSeries/hooks/useChartSave.ts
msgid "Chart saved successfully!"
msgstr "Chart saved successfully!"

#: src/features/timeSeries/experiment/ExperimentTab.tsx
msgid "Chart shows "
msgstr "Chart shows "

#: src/features/sentinels/components/RecentScorePanel.tsx
msgid "Chart x-axis pinned to "
msgstr "Chart x-axis pinned to "

#: src/pages/cases/md/MdCaseDetailsPage.tsx
msgid "Chat"
msgstr "Chat"

#: src/features/chatbot/components/SessionHeaderBar.tsx
msgid "Chat history"
msgstr "Chat history"

#: src/features/chatbot/components/ChatbotContent.tsx
msgid "Chat scoped to case"
msgstr "Chat scoped to case"

#: src/features/knowledgeDocumentViewer/components/toolbar/KnowledgeDocumentHeaderBar.tsx
msgid "Chat Session"
msgstr "Chat Session"

#: src/pages/processData/buildMode/rightPanel/PromoteModelAction.tsx
msgid "Check cadence"
msgstr "Check cadence"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/CitedResponseSegments.tsx
msgid "Check how this was calculated"
msgstr "Check how this was calculated"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatEvalCaseReview.tsx
msgid "Check the query, answer, checks, and cited documents before this case is saved."
msgstr "Check the query, answer, checks, and cited documents before this case is saved."

#: src/pages/processData/buildMode/dock/CompareDockTab.tsx
msgid "Check two or more saved models on the shelf to compare their test metrics side by side."
msgstr "Check two or more saved models on the shelf to compare their test metrics side by side."

#: src/features/timeSeries/experiment/knobCopy.ts
msgid "Checked (default): gate ops drop failing rows across the whole window — train, val, AND test (matches prod behavior). Unchecked: gates only remove train/val rows; the test range keeps every row, so held-out metrics stay honest about all operating regimes instead of only scoring the gated one."
msgstr "Checked (default): gate ops drop failing rows across the whole window — train, val, AND test (matches prod behavior). Unchecked: gates only remove train/val rows; the test range keeps every row, so held-out metrics stay honest about all operating regimes instead of only scoring the gated one."

#: src/features/timeSeries/agentTab/toolSentence.ts
msgid "Checked data coverage"
msgstr "Checked data coverage"

#: src/features/timeSeries/agentTab/toolSentence.ts
msgid "Checking data coverage"
msgstr "Checking data coverage"

#: src/pages/nnpp/imports/NnppImportVerificationPage.tsx
msgid "Checking links…"
msgstr "Checking links…"

#: src/features/knowledgeDocumentViewer/components/DocumentUnavailablePanel.tsx
msgid "Checking this site's pipeline configs…"
msgstr "Checking this site's pipeline configs…"

#: src/features/timeSeries/components/AllTagsTab.tsx
msgid "Checking..."
msgstr "Checking..."

#: src/pages/details/visualization/markupEditing/IconSelector.tsx
msgid "Checkmark"
msgstr "Checkmark"

#: src/pages/processData/components/helpGuide/HelpGuideChapters.tsx
msgid "Chip search: lock terms in, refine live, toggle tags on and off."
msgstr "Chip search: lock terms in, refine live, toggle tags on and off."

#: src/features/fimReview/ReviewActions.tsx
msgid "Choose a decision first."
msgstr "Choose a decision first."

#: src/features/fimReview/ReviewActions.tsx
msgid "Choose a decision to continue."
msgstr "Choose a decision to continue."

#: src/features/knowledgeDocumentViewer/components/viewer/search/ConnectorLookupPanel.tsx
msgid "Choose a destination:"
msgstr "Choose a destination:"

#: src/features/fimReview/subjectDecisionBuilders.ts
msgid "Choose a different subject to merge."
msgstr "Choose a different subject to merge."

#: src/features/lotoReports/components/LotoReportSelect.tsx
msgid "Choose a LOTO"
msgstr "Choose a LOTO"

#: src/features/fimReview/StructuralReviewFlow.tsx
msgid "Choose a source record…"
msgstr "Choose a source record…"

#: src/features/knowledgeDocumentViewer/components/table/enhancements/BulkEditModal.tsx
msgid "Choose an action:"
msgstr "Choose an action:"

#: src/features/knowledgeDocumentViewer/components/metadata/ChooseEditScopePanel.tsx
msgid "Choose document edit scope"
msgstr "Choose document edit scope"

#: src/features/lotoReports/components/LotoPresetCombobox.tsx
msgid "Choose or type…"
msgstr "Choose or type…"

#: src/features/knowledgeDocumentViewer/components/metadata/ChooseEditScopePanel.tsx
msgid "Choose page edit scope"
msgstr "Choose page edit scope"

#: src/features/fimReview/StructuralReviewFlow.tsx
#: src/features/fimReview/StructuralReviewFlow.tsx
msgid "Choose Subject…"
msgstr "Choose Subject…"

#: src/features/fimReview/StructuralReviewFlow.tsx
msgid "Choose the misread value…"
msgstr "Choose the misread value…"

#: src/features/fimReview/subjectDecisionBuilders.ts
msgid "Choose the observed OCR value."
msgstr "Choose the observed OCR value."

#: src/features/fimReview/subjectDecisionBuilders.ts
msgid "Choose the source record with the OCR error."
msgstr "Choose the source record with the OCR error."

#: src/pages/manageAccess/components/dialogs/SiteAccessDialog.tsx
msgid "Choose which sites {userName} can reach. Access within each site is set on that site's page."
msgstr "Choose which sites {userName} can reach. Access within each site is set on that site's page."

#: src/features/fimReview/subjectDecisionBuilders.ts
msgid "Choose which subject survives the merge."
msgstr "Choose which subject survives the merge."

#: src/features/timeSeries/experiment/SplitBuilder.tsx
msgid "Chunk unit"
msgstr "Chunk unit"

#: src/features/timeSeries/experiment/SplitBuilder.tsx
msgid "Chunks appear after a data preview loads."
msgstr "Chunks appear after a data preview loads."

#: src/pages/processData/buildMode/dock/WindowsDockTab.tsx
msgid "Chunks appear once the data preview loads — pick a target and drivers first."
msgstr "Chunks appear once the data preview loads — pick a target and drivers first."

#: src/features/copcPointClouds/CopcViewerOverlay.tsx
msgid "Circ"
msgstr "Circ"

#: src/features/copcPointClouds/CopcPointCloudScene.tsx
#: src/features/copcPointClouds/CopcPointCloudScene.tsx
msgid "Circumferential"
msgstr "Circumferential"

#: src/features/assetLifecycleV2/views/observations/LtaObservationCompositeViz.tsx
msgid "Circumferential Critical Thickness Profile"
msgstr "Circumferential Critical Thickness Profile"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatEvalCaseCitations.tsx
msgid "Cited"
msgstr "Cited"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatEvalCaseCitations.tsx
msgid "Cited documents"
msgstr "Cited documents"

#: src/features/fimReview/SubjectDiagnostics.tsx
msgid "Cited evidence"
msgstr "Cited evidence"

#: src/features/knowledgeDocumentViewer/components/viewer/search/CitedTextBar.tsx
msgid "Cited text"
msgstr "Cited text"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
#: src/features/knowledgeDocumentViewer/workOrders/legacyCmmsRecordPdf.ts
msgid "City"
msgstr "City"

#: src/pages/evaluations/metadata/labeling/utils/pageClassificationTaxonomy.ts
msgid "Civil and geotechnical analysis"
msgstr "Civil and geotechnical analysis"

#: src/features/knowledgeDocumentViewer/utils/documentTypeLabels.ts
#: src/pages/evaluations/metadata/labeling/utils/pageClassificationTaxonomy.ts
msgid "Civil/Structural Details"
msgstr "Civil/Structural Details"

#: src/features/fimReview/ReviewActions.tsx
msgid "Classification change preview"
msgstr "Classification change preview"

#: src/features/timeSeries/experiment/ExperimentTab.tsx
#: src/pages/processData/buildMode/dock/CleaningSection.tsx
msgid "Cleaning"
msgstr "Cleaning"

#: src/pages/processData/buildMode/dock/CleaningSection.tsx
msgid "Cleaning for {tag}"
msgstr "Cleaning for {tag}"

#: src/features/powerCustomerUploads/components/PowerCustomerUploadAttachments.tsx
#: src/features/powerCustomerUploads/components/PowerCustomerUploadAttachments.tsx
#: src/features/timeSeries/components/FormulaBuilder.tsx
msgid "Clear"
msgstr "Clear"

#: src/features/timeSeries/components/EditableRangeInput.tsx
msgid "Clear (auto scale)"
msgstr "Clear (auto scale)"

#: src/pages/metrics/components/FilterPopover.tsx
msgid "Clear {label} filter"
msgstr "Clear {label} filter"

#: src/pages/evaluations/metadata/labeling/components/DataLabelingFilterActions.tsx
msgid "Clear all"
msgstr "Clear all"

#: src/features/timeSeries/components/YScaleControls.tsx
msgid "Clear all custom ranges and auto-scale every pen"
msgstr "Clear all custom ranges and auto-scale every pen"

#: src/features/powerCustomerUploads/components/PowerCustomerUploadHistoryPanel.tsx
#: src/features/timeSeries/components/LabelsTab.tsx
#: src/pages/cases/md/MdCasesListPage.tsx
msgid "Clear filters"
msgstr "Clear filters"

#: src/features/knowledgeDocumentViewer/components/viewer/search/CitedTextBar.tsx
#: src/features/knowledgeDocumentViewer/components/viewer/search/CitedTextBar.tsx
msgid "Clear highlight"
msgstr "Clear highlight"

#: src/features/timeSeries/experiment/ExperimentTab.tsx
msgid "Clear ops"
msgstr "Clear ops"

#: src/features/lotoReports/components/LotoPointPositionCombobox.tsx
msgid "Clear position for {tag}"
msgstr "Clear position for {tag}"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/SearchSuggestionsDropdown.tsx
msgid "Clear recents"
msgstr "Clear recents"

#: src/features/timeSeries/experiment/RunComparison.tsx
msgid "Clear runs"
msgstr "Clear runs"

#: src/pages/details/extensions/flow/SummarizerExtension.tsx
#: src/pages/processData/buildMode/dock/CompareDockTab.tsx
msgid "Clear selection"
msgstr "Clear selection"

#: src/pages/facilityModel/FacilityModelCatalog.tsx
msgid "Clear this filter"
msgstr "Clear this filter"

#: src/features/mdCases/mdCaseDisplay.ts
msgid "Cleared"
msgstr "Cleared"

#: src/features/lotoReports/components/LotoIsolationPointsTable.tsx
msgid "Click a node on the drawing to add an isolation point."
msgstr "Click a node on the drawing to add an isolation point."

#: src/features/sentinels/components/RecentScorePanel.tsx
msgid "Click a point outside the band to open a case for that breach — then run RCA from the Cases tab."
msgstr "Click a point outside the band to open a case for that breach — then run RCA from the Cases tab."

#: src/pages/processData/components/helpGuide/HelpGuideChapters.tsx
msgid "Click a row to plot the tag; click again to remove it."
msgstr "Click a row to plot the tag; click again to remove it."

#: src/features/copcPointClouds/CopcViewerOverlay.tsx
msgid "Click a UT point or drag the origin"
msgstr "Click a UT point or drag the origin"

#: src/features/mdCases/components/ProvenanceContentViewer.tsx
msgid "Click an artifact or file in the lineage to view it here."
msgstr "Click an artifact or file in the lineage to view it here."

#: src/features/lotoReports/components/LotoTargetEquipmentList.tsx
msgid "Click equipment on the drawing to add or remove it. Press Esc when done."
msgstr "Click equipment on the drawing to add or remove it. Press Esc when done."

#: src/pages/details/visualization/markupEditing/EditToolBar.tsx
msgid "Click on the asset to add a label."
msgstr "Click on the asset to add a label."

#: src/pages/details/visualization/markupEditing/EditToolBar.tsx
msgid "Click on the asset to add an icon."
msgstr "Click on the asset to add an icon."

#: src/pages/assetLens/components/tabs/DocumentsTab.tsx
#: src/pages/assetLens/components/tabs/imagesTabComponents/ImageUploadModal.tsx
msgid "Click or drag file to this area to upload"
msgstr "Click or drag file to this area to upload"

#: src/pages/processData/buildMode/components/ModelingTagsPane.tsx
msgid "Click tags above — the first becomes the modeled tag, every further one a driver feeding it."
msgstr "Click tags above — the first becomes the modeled tag, every further one a driver feeding it."

#: src/pages/assetLens/components/tabs/DocumentsTab.tsx
msgid "Click the document menu button above to list or upload documents"
msgstr "Click the document menu button above to list or upload documents"

#: src/pages/processData/components/helpGuide/HelpGuideChapters.tsx
msgid "Click the view's title to search and switch views."
msgstr "Click the view's title to search and switch views."

#: src/features/timeSeries/agentTab/chat/ToolCard.tsx
msgid "Click to add to the chart"
msgstr "Click to add to the chart"

#: src/features/powerCustomerUploads/components/PowerCustomerUploadSelection.tsx
msgid "click to browse"
msgstr "click to browse"

#: src/features/timeSeries/agentTab/dock/SettingsTab.tsx
msgid "Click to hide this pen"
msgstr "Click to hide this pen"

#: src/pages/alerts/AlertDetails.tsx
msgid "Click to mark as unacknowledged"
msgstr "Click to mark as unacknowledged"

#: src/features/knowledgeDocumentViewer/components/viewer/search/DocReferencePreviewCard.tsx
msgid "Click to open"
msgstr "Click to open"

#: src/features/knowledgeDocumentViewer/components/viewer/shared/OffPageConnectorTooltip.tsx
msgid "Click to open • Cmd/Ctrl + click for new tab"
msgstr "Click to open • Cmd/Ctrl + click for new tab"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/ResponseSegmentValueChip.tsx
msgid "Click to open the chart for this answer."
msgstr "Click to open the chart for this answer."

#: src/features/knowledgeDocumentViewer/graph/GraphTooltip.tsx
msgid "Click to open the connected page."
msgstr "Click to open the connected page."

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/ResponseSegmentValueChip.tsx
msgid "Click to put this series on the chart."
msgstr "Click to put this series on the chart."

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/ResponseSegmentValueChip.tsx
msgid "Click to put this tag on the chart."
msgstr "Click to put this tag on the chart."

#: src/features/timeSeries/components/FormulaTokenElement.tsx
msgid "Click to replace with a sensor or value"
msgstr "Click to replace with a sensor or value"

#: src/features/timeSeries/components/timeSeriesScatterplot/MdDraftAlertCaseFlowPanels.tsx
msgid "Click to restore alert highlight"
msgstr "Click to restore alert highlight"

#: src/pages/details/visualization/markupEditing/EditToolBar.tsx
msgid "Click to set the location of the new rectangle."
msgstr "Click to set the location of the new rectangle."

#: src/features/timeSeries/agentTab/dock/SettingsTab.tsx
msgid "Click to show this pen"
msgstr "Click to show this pen"

#: src/features/knowledgeDocumentViewer/components/viewer/shared/InstrumentTimeSeriesPreview.tsx
msgid "Click: {resolvedClickHint}"
msgstr "Click: {resolvedClickHint}"

#: src/features/knowledgeDocumentViewer/components/toolbar/SettingsMenu.tsx
msgid "Clickable Assets"
msgstr "Clickable Assets"

#: src/pages/processData/buildMode/dock/TagCleaningEditor.tsx
msgid "Clip quantile high"
msgstr "Clip quantile high"

#: src/pages/processData/buildMode/dock/TagCleaningEditor.tsx
msgid "Clip quantile low"
msgstr "Clip quantile low"

#: src/pages/processData/components/helpGuide/HelpGuideMedia.tsx
msgid "Clip unavailable"
msgstr "Clip unavailable"

#: src/features/assetVizAdapter/ForecastAssetVizWindow.tsx
#: src/features/forecastNotifications/NotificationPreferencesModal.tsx
#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatFeedbackDialog.tsx
#: src/features/knowledgeDocumentViewer/components/bugReport/DocumentsBugReportButton.tsx
#: src/features/mdCases/components/ProvenanceContentViewer.tsx
#: src/features/mdCases/components/ProvenanceContentViewer.tsx
#: src/features/mdCases/components/ProvenanceContentViewer.tsx
#: src/features/mdCases/components/ProvenanceContentViewer.tsx
#: src/features/mdCases/components/ProvenanceContentViewer.tsx
#: src/features/mdCases/components/ProvenanceContentViewer.tsx
#: src/features/mdCases/components/ProvenanceContentViewer.tsx
#: src/features/mdCases/components/ProvenanceContentViewer.tsx
#: src/features/mdCases/components/ProvenanceContentViewer.tsx
#: src/features/modelOperations/SubjectTargetPickerColumn.tsx
#: src/features/richText/components/slashCommandCards/ChartSlashCommandCard.tsx
#: src/features/richText/components/slashCommandCards/SystemSlashCommandCard.tsx
#: src/features/richText/components/slashCommandCards/UnitConfigurationModal.tsx
#: src/features/richText/nodes/MentionNode.tsx
#: src/features/timeSeries/components/panes/TagSearchDialog.tsx
#: src/features/timeSeries/components/ScatterplotSidebar.tsx
#: src/pages/assetLens/components/tabs/AnomalyDashboard.tsx
#: src/pages/manageAccess/components/dialogs/ConfirmUserTypeChangeDialog.tsx
msgid "Close"
msgstr "Close"

#: src/features/knowledgeDocumentViewer/components/viewer/search/IntraDocSearchBar.tsx
msgid "Close (Escape)"
msgstr "Close (Escape)"

#: src/features/workspaceTabs/components/WorkspaceTabBar.tsx
#: src/features/workspaceTabs/components/WorkspaceTabSwitcher.tsx
msgid "Close {label} tab"
msgstr "Close {label} tab"

#: src/pages/assetLens/components/tabs/imagesTabComponents/ImageComparisonView.tsx
#: src/pages/assetLens/components/tabs/imagesTabComponents/ImageComparisonView.tsx
msgid "Close Comparison"
msgstr "Close Comparison"

#: src/features/knowledgeDocumentViewer/components/sidebar/CrossReferencePanel.tsx
msgid "Close cross-reference"
msgstr "Close cross-reference"

#: src/features/knowledgeDocumentViewer/components/viewer/search/ConnectorLookupPanel.tsx
msgid "Close destination lookup"
msgstr "Close destination lookup"

#: src/features/knowledgeDocumentViewer/artifacts/ArtifactPanelHeader.tsx
msgid "Close document"
msgstr "Close document"

#: src/features/knowledgeDocumentViewer/components/viewer/search/IntraDocSearchBar.tsx
msgid "Close find"
msgstr "Close find"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/ImagePreviewPanel.tsx
msgid "Close image preview"
msgstr "Close image preview"

#: src/features/lotoReports/components/LotoPagePanelHeader.tsx
msgid "Close LOTO panel"
msgstr "Close LOTO panel"

#: src/features/chatbot/components/ChatbotHelpModal.tsx
msgid "Close modal"
msgstr "Close modal"

#: src/features/navbar/MenuDrawer.tsx
msgid "Close navigation"
msgstr "Close navigation"

#: src/features/knowledgeDocumentViewer/components/sidebar/GraphNodePanel.tsx
msgid "Close node panel"
msgstr "Close node panel"

#: src/features/kestrelViewer/ui/tools/photoreel/annotation/ReelAnnotationsPanel.tsx
#: src/features/kestrelViewer/ui/tools/photoreel/annotation/ReelAnnotationsPanel.tsx
msgid "Close photo reel"
msgstr "Close photo reel"

#: src/features/facilityModel/components/ReferencePreviewPanel.tsx
#: src/features/facilityModel/components/ReferencePreviewPanel.tsx
#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/documentPreview/DocumentPreviewPanel.tsx
#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/documentPreview/DocumentPreviewPanel.tsx
#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/InspectionPreviewPanel.tsx
#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/InspectionPreviewPanel.tsx
#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/sensors/SensorPreviewPanel.tsx
msgid "Close preview"
msgstr "Close preview"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/RevisionComparePreviewPanel.tsx
msgid "Close revision compare"
msgstr "Close revision compare"

#: src/features/knowledgeDocumentViewer/workOrders/WorkOrderViewer.tsx
msgid "Close search"
msgstr "Close search"

#: src/features/chatbot/components/SessionTabs.tsx
msgid "Close session"
msgstr "Close session"

#: src/features/knowledgeDocumentViewer/components/sidebar/SubjectDocumentsPanel.tsx
msgid "Close subject panel"
msgstr "Close subject panel"

#: src/features/modelOperations/SubjectTargetPickerColumn.tsx
msgid "Close Subject picker"
msgstr "Close Subject picker"

#: src/features/knowledgeDocumentViewer/components/toolbar/DocumentTabs.tsx
msgid "Close tab"
msgstr "Close tab"

#: src/features/terms/TermsModal.tsx
msgid "Close terms of service"
msgstr "Close terms of service"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/TrendPreviewPanel.tsx
msgid "Close trend preview"
msgstr "Close trend preview"

#: src/features/copcPointClouds/CopcViewerOverlay.tsx
msgid "Close view settings"
msgstr "Close view settings"

#: src/features/mdCases/mdCaseDisplay.ts
#: src/pages/assetLens/components/tabs/SensorIssuesTab.tsx
msgid "Closed"
msgstr "Closed"

#: src/features/lotoReports/components/LotoPointPositionCombobox.tsx
msgctxt "LOTO isolation position"
msgid "Closed"
msgstr "Closed"

#: src/features/fimEvidence/SubjectGlyphs.tsx
#: src/features/fimReview/provenance.ts
#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatAgentsMenu.tsx
#: src/features/modelOperations/Corroboration.tsx
msgid "CMMS"
msgstr "CMMS"

#: src/features/embeddedSidebar/cmmsSidebarNav.ts
msgid "CMMS Explorer"
msgstr "CMMS Explorer"

#: src/pages/documents/CmmsExplorerRoutePage.tsx
msgid "CMMS explorer is not enabled for this site."
msgstr "CMMS explorer is not enabled for this site."

#: src/features/knowledgeDocumentViewer/components/toolbar/DocumentTabs.tsx
#: src/features/knowledgeDocumentViewer/workOrders/WorkOrderViewer.tsx
#: src/features/knowledgeDocumentViewer/workOrders/WorkOrderViewer.tsx
msgid "CMMS record"
msgstr "CMMS record"

#: src/features/fimReview/provenance.ts
msgid "CMMS row"
msgstr "CMMS row"

#: src/features/timeSeries/components/RegressionPrediction.tsx
msgid "Coefficient"
msgstr "Coefficient"

#: src/pages/processData/components/helpGuide/HelpGuideChapters.tsx
msgid "Collapse"
msgstr "Collapse"

#: src/features/lotoReports/components/LotoIsolationPointsTable.tsx
msgid "Collapse all"
msgstr "Collapse all"

#: src/features/knowledgeDocumentViewer/components/table/TableBodyRow.tsx
msgid "Collapse row"
msgstr "Collapse row"

#: src/features/timeSeries/components/SensorScatterplotTableColumns.tsx
msgid "Color"
msgstr "Color"

#: src/pages/systemView/components/unitsTab/FilterControls.tsx
msgid "Color Labels By"
msgstr "Color Labels By"

#: src/features/assetVizAdapter/MeasurementStrip.tsx
msgid "Color scale"
msgstr "Color scale"

#: src/features/assetVizAdapter/MeasurementStrip.tsx
msgid "Color scale settings"
msgstr "Color scale settings"

#: src/features/dataFilter/rangeFilter/RangeSlider.tsx
msgid "Color scale thresholds"
msgstr "Color scale thresholds"

#: src/features/knowledgeDocumentViewer/components/table/enhancements/ColumnConfiguration.tsx
msgid "Columns"
msgstr "Columns"

#: src/features/timeSeries/components/panes/DerivedTagsPane.tsx
msgid "Combine plotted tags into a calculated pen, such as a difference, a ratio, or a unit conversion."
msgstr "Combine plotted tags into a calculated pen, such as a difference, a ratio, or a unit conversion."

#: src/features/fimReview/IdentityPanel.tsx
msgid "Combined records"
msgstr "Combined records"

#: src/features/timeSeries/experiment/NormalizationViewer.tsx
msgid "combined variance reduction · flatness="
msgstr "combined variance reduction · flatness="

#: src/features/richText/components/slashCommandCards/SystemSlashCommandCard.tsx
msgid "Coming soon: System View Configuration"
msgstr "Coming soon: System View Configuration"

#: src/designSystem/components/Command.tsx
msgid "Command Palette"
msgstr "Command Palette"

#: src/features/knowledgeDocumentViewer/components/metadata/PageMetadataEvalComments.tsx
#: src/pages/cases/components/CaseFeedbackModal.tsx
msgid "Comment"
msgstr "Comment"

#: src/features/knowledgeDocumentViewer/components/sidebar/FeedbackModal.tsx
msgid "Comment (optional)"
msgstr "Comment (optional)"

#: src/features/knowledgeDocumentViewer/hooks/useAppendDocumentPageMetadataUserEditComment.ts
msgid "Comment added"
msgstr "Comment added"

#: src/features/knowledgeDocumentViewer/hooks/useAppendDocumentPageMetadataUserEditComment.ts
msgid "Comment added, but updated comments could not be refreshed"
msgstr "Comment added, but updated comments could not be refreshed"

#: src/features/knowledgeDocumentViewer/components/metadata/PageMetadataEvalComments.tsx
msgid "Comment is saved when you Confirm or Defer."
msgstr "Comment is saved when you Confirm or Defer."

#: src/pages/assetLens/components/tabs/SensorIssuesTab.tsx
#: src/pages/cases/md/MdCaseDetailsMainColumn.tsx
msgid "Comments"
msgstr "Comments"

#: src/pages/evaluations/metadata/labeling/utils/pageClassificationTaxonomy.ts
msgid "Commercial and financial records"
msgstr "Commercial and financial records"

#: src/features/knowledgeDocumentViewer/workOrders/legacyCmmsRecordPdf.ts
msgid "Company"
msgstr "Company"

#: src/features/timeSeries/components/SentinelsTab.tsx
#: src/pages/processData/buildMode/components/BuildDock.tsx
msgid "Compare"
msgstr "Compare"

#: src/pages/processData/buildMode/dock/CompareDockTab.tsx
msgid "Compare · test metrics · "
msgstr "Compare · test metrics · "

#: src/pages/processData/buildMode/rightPanel/SavedModelsPane.tsx
msgid "Compare ({compareCount})"
msgstr "Compare ({compareCount})"

#: src/pages/processData/buildMode/rightPanel/SavedModelShelf.tsx
msgid "Compare {value208_37}"
msgstr "Compare {value208_37}"

#: src/features/timeSeries/experiment/ExperimentTab.tsx
msgid "Compare runs"
msgstr "Compare runs"

#: src/pages/processData/buildMode/dock/CompareDockTab.tsx
msgid "Compare saved models"
msgstr "Compare saved models"

#: src/pages/assetLens/components/tabs/imagesTabComponents/ImageComparisonView.tsx
msgid "Compare with Next"
msgstr "Compare with Next"

#: src/pages/assetLens/components/tabs/imagesTabComponents/ImageComparisonView.tsx
msgid "Compare with Previous"
msgstr "Compare with Previous"

#: src/pages/evaluations/metadata/dashboard/components/dataLabeling/DataLabelingDashboardFieldDrilldown.tsx
msgid "Compared pages"
msgstr "Compared pages"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatRevisionDiffCard.tsx
msgid "Compared with revision {from}"
msgstr "Compared with revision {from}"

#: src/features/timeSeries/components/SentinelsTab.tsx
msgid "Comparing "
msgstr "Comparing "

#: src/pages/details/visualization/tools/CompartmentsToggle.tsx
msgid "Compartments shown"
msgstr "Compartments shown"

#: src/features/facilityModel/views.ts
#: src/features/fim/assetInventory.ts
msgid "Complete"
msgstr "Complete"

#: src/pages/nnpp/imports/NnppImportVerificationPage.tsx
msgid "Complete the document details and requirement selection to continue."
msgstr "Complete the document details and requirement selection to continue."

#: src/features/timeSeries/experiment/RunComparison.tsx
msgid "complete_rows {value80_25}→{value80_70}"
msgstr "complete_rows {value80_25}→{value80_70}"

#: src/features/powerCustomerUploads/components/PowerCustomerUploadHistoryPanel.tsx
#: src/features/powerCustomerUploads/components/powerCustomerUploadHistoryPresentation.ts
msgid "Completed"
msgstr "Completed"

#: src/pages/nnpp/imports/NnppImportVerificationPage.tsx
msgid "Completing import…"
msgstr "Completing import…"

#: src/pages/details/extensions/flow/filesExt/FileTags.tsx
#: src/pages/details/visualization/tools/VizControlTools.tsx
msgid "Component"
msgstr "Component"

#: src/pages/evaluations/metadata/labeling/utils/pageClassificationTaxonomy.ts
msgid "Component fabrication and assembly details"
msgstr "Component fabrication and assembly details"

#: src/features/navbar/navConfig.ts
msgid "Components"
msgstr "Components"

#: src/features/timeSeries/agentTab/toolSentence.ts
msgid "Computed the KPI"
msgstr "Computed the KPI"

#: src/features/timeSeries/agentTab/toolSentence.ts
msgid "Computed the KPI {name}"
msgstr "Computed the KPI {name}"

#: src/features/timeSeries/agentTab/toolSentence.ts
msgid "Computing the KPI"
msgstr "Computing the KPI"

#: src/features/timeSeries/agentTab/toolSentence.ts
msgid "Computing the KPI {name}"
msgstr "Computing the KPI {name}"

#: src/features/timeSeries/experiment/NormalizationViewer.tsx
msgid "Computing…"
msgstr "Computing…"

#: src/pages/details/visualization/alerts/specificAlerts/ConduitPipelineAlert.tsx
msgid "Conduit pipelines are currently in progress"
msgstr "Conduit pipelines are currently in progress"

#: src/features/facilityModel/columns.ts
#: src/features/modelOperations/SubjectDetails.tsx
#: src/pages/facilityModel/FacilityModelFilters.tsx
#: src/pages/facilityModel/SubjectDetailPage.tsx
msgid "Confidence"
msgstr "Confidence"

#: src/pages/facilityModel/SubjectAssetPanel.tsx
msgid "confidence {confidence}%"
msgstr "confidence {confidence}%"

#: src/features/timeSeries/agentTab/dock/AgentDock.tsx
msgid "Config"
msgstr "Config"

#: src/pages/processData/buildMode/components/BuildPrimaryCta.tsx
msgid "Config changed since the last run — results are stale"
msgstr "Config changed since the last run — results are stale"

#: src/pages/processData/buildMode/rightPanel/CurrentModelPane.tsx
msgid "Config changed since this run — retrain before saving"
msgstr "Config changed since this run — retrain before saving"

#: src/pages/processData/buildMode/rightPanel/SavedModelShelf.tsx
msgid "config only"
msgstr "config only"

#: src/features/richText/components/slashCommandCards/UnitConfigurationModal.tsx
msgid "Configuration saved successfully"
msgstr "Configuration saved successfully"

#: src/features/workbench/WorkbenchDock.tsx
msgid "Configuration section"
msgstr "Configuration section"

#: src/features/timeSeries/components/ScatterplotSidebarDefault.tsx
msgid "Configure"
msgstr "Configure"

#: src/features/workbench/WorkbenchShell.tsx
msgid "Configure chart"
msgstr "Configure chart"

#: src/features/timeSeries/components/ScatterplotSidebarConfig.tsx
msgid "Configure Chart"
msgstr "Configure Chart"

#: src/features/richText/components/slashCommandCards/SystemSlashCommandCard.tsx
msgid "Configure metadata for System"
msgstr "Configure metadata for System"

#: src/features/timeSeries/components/ThresholdConfigurationModal.tsx
msgid "Configure Sensor Thresholds"
msgstr "Configure Sensor Thresholds"

#: src/features/timeSeries/components/ChartControls.tsx
msgid "Configure Thresholds"
msgstr "Configure Thresholds"

#: src/features/timeSeries/components/ThresholdConfigurationModal.tsx
msgid "Configure thresholds for each sensor. You can set any combination of Upper High, Upper, Lower, and Lower Low thresholds. At least one threshold must be configured when enabled. These will be displayed as reference lines on the chart when the Alert Thresholds layer is enabled."
msgstr "Configure thresholds for each sensor. You can set any combination of Upper High, Upper, Lower, and Lower Low thresholds. At least one threshold must be configured when enabled. These will be displayed as reference lines on the chart when the Alert Thresholds layer is enabled."

#: src/features/richText/components/slashCommandCards/UnitConfigurationModal.tsx
msgid "Configure View Settings - {entryName}"
msgstr "Configure View Settings - {entryName}"

#: src/features/lotoReports/components/LotoSheetHeaderFields.tsx
msgid "Confined space #"
msgstr "Confined space #"

#: src/features/lotoReports/recordSheet/recordSheetLayout.ts
msgid "CONFINED SPACE #:"
msgstr "CONFINED SPACE #:"

#: src/features/fim/photos/PhotoLightbox.tsx
#: src/features/knowledgeDocumentViewer/components/metadata/PageMetadataEvalChrome.tsx
#: src/pages/details/extensions/flow/filesExt/FileMenuButton.tsx
#: src/pages/facilityModel/SubjectDetailPage.tsx
msgid "Confirm"
msgstr "Confirm"

#: src/features/knowledgeDocumentViewer/hooks/useAppendDocumentPageMetadataUserEditComment.ts
msgid "Confirm or defer this page before adding a comment"
msgstr "Confirm or defer this page before adding a comment"

#: src/features/knowledgeDocumentViewer/components/metadata/PageMetadataEvalChrome.tsx
msgid "Confirm page metadata"
msgstr "Confirm page metadata"

#: src/pages/evaluations/metadata/components/LabelingActions.tsx
msgid "Confirm page metadata by hand so the pipeline has ground truth to be scored against."
msgstr "Confirm page metadata by hand so the pipeline has ground truth to be scored against."

#: src/features/chatbot/components/SessionTabs.tsx
msgid "Confirm rename"
msgstr "Confirm rename"

#: src/features/fimReview/ReviewActions.tsx
msgid "Confirm subject"
msgstr "Confirm subject"

#: src/features/knowledgeDocumentViewer/components/metadata/PageMetadataEvalChrome.tsx
msgid "Confirm the full page, or defer with a reason."
msgstr "Confirm the full page, or defer with a reason."

#: src/pages/facilityModel/SubjectDetailPage.tsx
msgid "Confirm this Subject is correct as shown — the same decision as “Everything looks right” in the review rail"
msgstr "Confirm this Subject is correct as shown — the same decision as “Everything looks right” in the review rail"

#: src/pages/facilityModel/SubjectDetailPage.tsx
msgid "Confirm validation"
msgstr "Confirm validation"

#: src/features/knowledgeDocumentViewer/components/metadata/PageMetadataEvalStatusChip.tsx
#: src/pages/evaluations/metadata/labeling/components/DataLabelingStatusFilter.tsx
msgid "Confirmed"
msgstr "Confirmed"

#: src/features/timeSeries/components/XAxisSection.tsx
msgid "Connect Points:"
msgstr "Connect Points:"

#: src/features/knowledgeDocumentViewer/components/sidebar/OcrTable.tsx
msgid "Connected Assets"
msgstr "Connected Assets"

#: src/features/knowledgeDocumentViewer/graph/offPageConnectorTooltipRows.ts
msgid "Connection"
msgstr "Connection"

#: src/features/chatbot/components/ChatbotHelpModal.tsx
msgid "Connection Failure"
msgstr "Connection Failure"

#: src/features/chatbot/hooks/useMessageSender.ts
msgid "Connection to the assistant was interrupted."
msgstr "Connection to the assistant was interrupted."

#: src/features/knowledgeDocumentViewer/components/viewer/search/ConnectorLookupPanel.tsx
msgid "Connector destination lookup"
msgstr "Connector destination lookup"

#: src/features/timeSeries/experiment/DiagnosticsPanel.tsx
msgid "constant ±"
msgstr "constant ±"

#: src/features/permissions/components/PermissionsGate.tsx
msgid "Consult with your admin for gaining access"
msgstr "Consult with your admin for gaining access"

#: src/features/fimReview/ReviewActions.tsx
msgid "Contains multiple subjects"
msgstr "Contains multiple subjects"

#: src/pages/evaluations/metadata/labeling/utils/pageClassificationTaxonomy.ts
msgid "Contents, indexes, and drawing registers"
msgstr "Contents, indexes, and drawing registers"

#: src/features/timeSeries/sentinelStudio/SentinelBuilderPanel.tsx
msgid "Context"
msgstr "Context"

#: src/features/sentinels/useSentinelList.ts
msgid "context built · not designed"
msgstr "context built · not designed"

#: src/features/copcPointClouds/CopcSpatialContextControl.tsx
msgid "Context radius"
msgstr "Context radius"

#: src/features/fimReview/IdentityPanel.tsx
msgid "contextual name"
msgstr "contextual name"

#: src/features/fimReview/InspectSources.tsx
msgid "Contextual name"
msgstr "Contextual name"

#: src/pages/manageAccess/components/dialogs/ConfirmUserTypeChangeDialog.tsx
msgid "Continue"
msgstr "Continue"

#: src/features/sentinels/components/DesignRunDetails.tsx
msgid "Continue from"
msgstr "Continue from"

#: src/features/knowledgeDocumentViewer/components/toolbar/SettingsMenu.tsx
msgid "Continuous scroll"
msgstr "Continuous scroll"

#: src/features/kestrelViewer/ui/tools/photoreel/adjustments/PhotoAdjustPanel.tsx
#: src/features/kestrelViewer/ui/tools/photoreel/adjustments/PhotoAdjustPanel.tsx
msgid "Contrast"
msgstr "Contrast"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatEvalCaseReview.tsx
msgid "Conversation"
msgstr "Conversation"

#: src/pages/metrics/components/ConversationExplorerCard.tsx
msgid "Conversation Explorer"
msgstr "Conversation Explorer"

#: src/pages/metrics/components/ConversationExplorerCard.tsx
msgid "Conversation Explorer site"
msgstr "Conversation Explorer site"

#: src/features/timeSeries/agentTab/chat/ConversationDrawer.tsx
msgid "Conversation name"
msgstr "Conversation name"

#: src/features/copcPointClouds/CopcCoordinateOriginControl.tsx
msgid "Coordinate origin · this session"
msgstr "Coordinate origin · this session"

#: src/pages/details/extensions/flow/ImageryExtension.tsx
msgid "Coordinates:"
msgstr "Coordinates:"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatMessageActions.tsx
#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatMessageActions.tsx
msgid "Copied"
msgstr "Copied"

#: src/features/chatbot/components/SessionHeaderBar.tsx
#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatMessageActions.tsx
msgid "Copy"
msgstr "Copy"

#: src/features/chatbot/components/SessionHeaderBar.tsx
msgid "Copy conversation"
msgstr "Copy conversation"

#: src/features/navbar/EmailSupport.tsx
msgid "Copy Email Address"
msgstr "Copy Email Address"

#: src/features/knowledgeDocumentViewer/workOrders/WorkOrderViewer.tsx
#: src/features/knowledgeDocumentViewer/workOrders/WorkOrderViewer.tsx
msgid "Copy link"
msgstr "Copy link"

#: src/pages/systemView/components/SystemViewAnnotationSidebar.tsx
msgid "Copy link to {whiteboardLabel}"
msgstr "Copy link to {whiteboardLabel}"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatMessageActions.tsx
msgid "Copy response"
msgstr "Copy response"

#: src/pages/systemView/components/SystemViewAnnotationSidebar.tsx
msgid "Copy shareable link to this whiteboard"
msgstr "Copy shareable link to this whiteboard"

#: src/features/navbar/EmailSupport.tsx
msgid "Copy to Clipboard"
msgstr "Copy to Clipboard"

#: src/features/fimReview/ReviewActions.tsx
msgid "Correct the alias spelling"
msgstr "Correct the alias spelling"

#: src/features/fimReview/StructuralReviewFlow.tsx
msgid "Corrected"
msgstr "Corrected"

#: src/features/timeSeries/agentTab/dock/AlertingTab.tsx
msgid "corrected for the scan"
msgstr "corrected for the scan"

#: src/features/fimReview/DecisionHistory.tsx
msgid "Corrected OCR"
msgstr "Corrected OCR"

#: src/features/timeSeries/experiment/ExperimentTab.tsx
msgid "Correlation"
msgstr "Correlation"

#: src/features/timeSeries/experiment/CorrelationCard.tsx
msgid "Correlation & phase shifts"
msgstr "Correlation & phase shifts"

#: src/features/timeSeries/experiment/CorrelationCard.tsx
msgid "Correlation chart loads after preview has drivers + target."
msgstr "Correlation chart loads after preview has drivers + target."

#: src/features/fimEvidence/SubjectGlyphs.tsx
msgid "Corroborated by {hitCount} of {totalCount} source types: {hitLabels}"
msgstr "Corroborated by {hitCount} of {totalCount} source types: {hitLabels}"

#: src/features/modelOperations/Corroboration.tsx
msgid "Corroborated by {hitCount} of {typeCount} source types: {hitLabels}"
msgstr "Corroborated by {hitCount} of {typeCount} source types: {hitLabels}"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/utils/inspectionLayers.ts
msgid "Corrosion rate"
msgstr "Corrosion rate"

#: src/features/navbar/configSettings/ConfigSettingsSidebarMenuItems.tsx
#: src/features/navbar/configSettings/ConfigSettingsSidebarMenuItems.tsx
#: src/features/navbar/configSettings/ConfigSettingsTopBarMenuItems.tsx
msgid "Cost Dashboard"
msgstr "Cost Dashboard"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
msgid "Cost distribution"
msgstr "Cost distribution"

#: src/features/knowledgeDocumentViewer/workOrders/legacyCmmsRecordPdf.ts
#: src/features/knowledgeDocumentViewer/workOrders/legacyCmmsRecordPdf.ts
msgid "Cost distributions"
msgstr "Cost distributions"

#: src/features/knowledgeDocumentViewer/workOrders/workOrderPdf.ts
msgid "Costs on tickets and work orders"
msgstr "Costs on tickets and work orders"

#: src/features/embeddedSidebar/chatHistory/AgenticChatHistorySessionRow.tsx
msgid "Could not archive"
msgstr "Could not archive"

#: src/features/embeddedSidebar/chatHistory/ChatHistoryBulkActionDialog.tsx
msgid "Could not archive recent chats. Please try again."
msgstr "Could not archive recent chats. Please try again."

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatSearchBox.tsx
msgid "Could not attach that image."
msgstr "Could not attach that image."

#: src/pages/manageAccess/hooks/useListedRoster.ts
msgid "Could not change access. Try again in a moment."
msgstr "Could not change access. Try again in a moment."

#: src/pages/manageAccess/hooks/useListedRoster.ts
msgid "Could not change user type. Try again in a moment."
msgstr "Could not change user type. Try again in a moment."

#: src/features/knowledgeDocumentViewer/workOrders/WorkOrderViewer.tsx
msgid "Could not copy link"
msgstr "Could not copy link"

#: src/features/lotoReports/components/LotoNewDraftForm.tsx
#: src/features/lotoReports/components/NewLotoReportDialog.tsx
msgid "Could not create the LOTO report. Try again."
msgstr "Could not create the LOTO report. Try again."

#: src/features/embeddedSidebar/chatHistory/AgenticChatHistorySessionRow.tsx
msgid "Could not delete"
msgstr "Could not delete"

#: src/features/embeddedSidebar/chatHistory/ChatHistoryBulkActionDialog.tsx
msgid "Could not delete archived chats. Please try again."
msgstr "Could not delete archived chats. Please try again."

#: src/features/lotoReports/components/DeleteLotoReportButton.tsx
msgid "Could not delete the LOTO report. Try again."
msgstr "Could not delete the LOTO report. Try again."

#: src/features/knowledgeDocumentViewer/workOrders/CmmsScrollPage.tsx
msgid "Could not display this page. Try downloading the PDF."
msgstr "Could not display this page. Try downloading the PDF."

#: src/features/knowledgeDocumentViewer/hooks/useCrossReference.ts
msgid "Could not find related documents. Try again."
msgstr "Could not find related documents. Try again."

#: src/features/lotoReports/components/LotoSheetEditor.tsx
msgid "Could not generate the record sheet. Try again."
msgstr "Could not generate the record sheet. Try again."

#: src/pages/manageAccess/ManageAccessPage.tsx
msgid "Could not load access policies. Try again in a moment."
msgstr "Could not load access policies. Try again in a moment."

#: src/features/embeddedSidebar/chatHistory/AgenticChatHistorySidebar.tsx
msgid "Could not load chats."
msgstr "Could not load chats."

#: src/features/knowledgeDocumentViewer/components/DocumentTabContent.tsx
msgid "Could not load connected documents. Reload and try again."
msgstr "Could not load connected documents. Reload and try again."

#: src/features/knowledgeDocumentViewer/components/sidebar/GraphNodePanel.tsx
msgid "Could not load documents for this node."
msgstr "Could not load documents for this node."

#: src/features/lotoReports/components/LotoPagePanel.tsx
#: src/features/lotoReports/components/LotoReportsListContent.tsx
msgid "Could not load LOTO reports."
msgstr "Could not load LOTO reports."

#: src/features/kestrelUpload/KestrelModelUploadSection.tsx
msgid "Could not load model files"
msgstr "Could not load model files"

#: src/features/knowledgeDocumentViewer/hooks/useDocumentFavoritesRepository.ts
msgid "Could not load or import document favorites. Please try again."
msgstr "Could not load or import document favorites. Please try again."

#: src/features/lotoReports/components/LotoAttachmentsSection.tsx
msgid "Could not load page details. Pages can be previewed once they load."
msgstr "Could not load page details. Pages can be previewed once they load."

#: src/features/timeSeries/agentTab/useConversations.ts
msgid "Could not load past conversations."
msgstr "Could not load past conversations."

#: src/features/lotoReports/components/LotoTargetDrawings.tsx
msgid "Could not load the drawings for this equipment."
msgstr "Could not load the drawings for this equipment."

#: src/features/lotoReports/components/LotoReportEditorLoader.tsx
msgid "Could not load the LOTO report."
msgstr "Could not load the LOTO report."

#: src/features/lotoReports/components/LotoReportsScopeGate.tsx
msgid "Could not load the site’s pipeline configuration."
msgstr "Could not load the site’s pipeline configuration."

#: src/features/fim/photos/photoService.ts
msgid "Could not load this photo. Please try again."
msgstr "Could not load this photo. Please try again."

#: src/pages/manageAccess/components/table/UsersSection.tsx
msgid "Could not load users. Try again in a moment."
msgstr "Could not load users. Try again in a moment."

#: src/features/knowledgeDocumentViewer/components/sidebar/EvalMetadataSection.tsx
msgid "Could not load your saved page edits."
msgstr "Could not load your saved page edits."

#: src/features/knowledgeDocumentViewer/hooks/useConnectorLookup.ts
msgid "Could not look up the destination. Try again."
msgstr "Could not look up the destination. Try again."

#: src/features/embeddedSidebar/chatHistory/AgenticChatHistorySessionRow.tsx
msgid "Could not open"
msgstr "Could not open"

#: src/features/timeSeries/agentTab/useAgentChat.ts
msgid "Could not open that conversation."
msgstr "Could not open that conversation."

#: src/features/knowledgeDocumentViewer/graph/useOpenOffPageConnector.ts
msgid "Could not open the connected page. Please try again."
msgstr "Could not open the connected page. Please try again."

#: src/features/embeddedSidebar/chatHistory/AgenticChatHistorySessionRow.tsx
msgid "Could not pin"
msgstr "Could not pin"

#: src/features/lotoReports/components/LotoPrintPreview.tsx
msgid "Could not prepare the print preview. Try again."
msgstr "Could not prepare the print preview. Try again."

#: src/features/powerCustomerUploads/uploadSource/powerCustomerUploadZipArchiveFiles.ts
msgid "Could not read nested ZIP archive."
msgstr "Could not read nested ZIP archive."

#: src/features/knowledgeDocumentViewer/components/bugReport/BugReportScreenshots.tsx
msgid "Could not read that image. Please try another file."
msgstr "Could not read that image. Please try another file."

#: src/features/powerCustomerUploads/uploadRequest/powerCustomerUploadErrors.ts
msgid "Could not read this file from your computer. Make sure it is saved locally, then try again."
msgstr "Could not read this file from your computer. Make sure it is saved locally, then try again."

#: src/features/kestrelUpload/KestrelModelUploadSection.tsx
msgid "Could not refresh the model file list: {errorMessage}"
msgstr "Could not refresh the model file list: {errorMessage}"

#: src/features/embeddedSidebar/chatHistory/AgenticChatHistorySessionRow.tsx
msgid "Could not rename"
msgstr "Could not rename"

#: src/pages/manageAccess/hooks/useListedRoster.ts
msgid "Could not revoke access. Try again in a moment."
msgstr "Could not revoke access. Try again in a moment."

#: src/features/knowledgeDocumentViewer/hooks/useFavoriteDocuments.ts
msgid "Could not save document favorites. Please try again."
msgstr "Could not save document favorites. Please try again."

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatMessageActions.tsx
msgid "Could not save the eval case"
msgstr "Could not save the eval case"

#: src/features/lotoReports/components/LotoProposalCard.tsx
#: src/features/lotoReports/components/LotoReportEditorHeader.tsx
msgid "Could not save the LOTO report. Try again."
msgstr "Could not save the LOTO report. Try again."

#: src/features/knowledgeDocumentViewer/components/bugReport/DocumentsBugReportButton.tsx
msgid "Could not send the issue report. Please try again."
msgstr "Could not send the issue report. Please try again."

#: src/features/knowledgeDocumentViewer/components/bugReport/DocumentsBugReportButton.tsx
msgid "Could not send the report with its screenshots. Please retry, or remove the screenshots to send a text-only report."
msgstr "Could not send the report with its screenshots. Please retry, or remove the screenshots to send a text-only report."

#: src/features/knowledgeDocumentViewer/components/advancedSearch/hooks/useDocChatFeedbackDialog.ts
msgid "Could not send your feedback. Please try again."
msgstr "Could not send your feedback. Please try again."

#: src/features/embeddedSidebar/chatHistory/AgenticChatHistorySessionRow.tsx
msgid "Could not unarchive"
msgstr "Could not unarchive"

#: src/features/embeddedSidebar/chatHistory/ChatHistoryBulkActionDialog.tsx
msgid "Could not unarchive chats. Please try again."
msgstr "Could not unarchive chats. Please try again."

#: src/features/embeddedSidebar/chatHistory/AgenticChatHistorySessionRow.tsx
msgid "Could not unpin"
msgstr "Could not unpin"

#: src/features/lotoReports/components/LotoPrintPreview.tsx
msgid "Could not update the print preview. Showing the last version."
msgstr "Could not update the print preview. Showing the last version."

#: src/features/lotoReports/components/LotoSheetEditor.tsx
msgid "Could not update the record sheet. Showing the last version."
msgstr "Could not update the record sheet. Showing the last version."

#: src/features/powerCustomerUploads/uploadRequest/powerCustomerUploadErrors.ts
msgid "Could not upload this file to the approved upload session."
msgstr "Could not upload this file to the approved upload session."

#: src/pages/evaluations/metadata/dashboard/components/dataLabeling/DataLabelingDashboardOverview.tsx
msgid "Couldn't load active pipeline comparisons."
msgstr "Couldn't load active pipeline comparisons."

#: src/pages/evaluations/metadata/dashboard/components/dataLabeling/DataLabelingDashboard.tsx
#: src/pages/evaluations/metadata/dashboard/components/dataLabeling/DataLabelingDashboardOrg.tsx
msgid "Couldn't load dashboard metrics."
msgstr "Couldn't load dashboard metrics."

#: src/pages/evaluations/metadata/labeling/components/DataLabelingLandingCounts.tsx
msgid "Couldn't load labeling counts."
msgstr "Couldn't load labeling counts."

#: src/pages/evaluations/metadata/components/OrganizationMetrics.tsx
msgid "Couldn't load metadata evaluation metrics."
msgstr "Couldn't load metadata evaluation metrics."

#: src/features/forecastNotifications/NotificationPreferencesModal.tsx
msgid "Couldn't load preferences. Please try again."
msgstr "Couldn't load preferences. Please try again."

#: src/features/facilityModel/catalogQuery.ts
msgid "Couldn't load subjects — retry."
msgstr "Couldn't load subjects — retry."

#: src/pages/evaluations/metadata/labeling/components/DataLabelingSessionViewer.tsx
msgid "Couldn't load the labeling queue."
msgstr "Couldn't load the labeling queue."

#: src/features/knowledgeDocumentViewer/components/viewer/search/CitedTextBar.tsx
msgid "Couldn't locate on page"
msgstr "Couldn't locate on page"

#: src/features/lotoReports/components/LotoSaveStatusText.tsx
msgid "Couldn’t save"
msgstr "Couldn’t save"

#: src/features/lotoReports/components/LotoLeaveDialog.tsx
msgid "Couldn’t save: {errorMessage}"
msgstr "Couldn’t save: {errorMessage}"

#: src/features/fimReview/SubjectDiagnostics.tsx
msgid "Counter-case (adversarial)"
msgstr "Counter-case (adversarial)"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
#: src/features/knowledgeDocumentViewer/workOrders/legacyCmmsRecordPdf.ts
msgid "Country"
msgstr "Country"

#: src/features/mdCases/components/ProvenanceContentViewer.tsx
#: src/features/mdCases/components/ProvenanceContentViewer.tsx
#: src/features/mdCases/components/ProvenanceContentViewer.tsx
msgid "Counts"
msgstr "Counts"

#: src/pages/details/extensions/fde/ffsLtaGeneration/FfsLtaGenerationSidebar.tsx
msgid "Course"
msgstr "Course"

#: src/pages/details/extensions/fde/ffsLtaGeneration/FfsLtaGenerationSidebar.tsx
msgid "Course threshold for {courseName} must be a positive number."
msgstr "Course threshold for {courseName} must be a positive number."

#: src/pages/details/extensions/fde/ffsLtaGeneration/FfsLtaGenerationSidebar.tsx
msgid "Course thresholds"
msgstr "Course thresholds"

#: src/features/mdCases/components/ProvenanceContentViewer.tsx
msgid "Coverage notes"
msgstr "Coverage notes"

#: src/pages/evaluations/metadata/labeling/utils/pageClassificationTaxonomy.ts
msgid "Covers and document identification"
msgstr "Covers and document identification"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
#: src/features/knowledgeDocumentViewer/workOrders/legacyCmmsRecordPdf.ts
msgid "Craft"
msgstr "Craft"

#: src/features/lotoReports/components/LotoNewDraftForm.tsx
#: src/features/lotoReports/components/NewLotoReportDialog.tsx
#: src/features/timeSeries/components/DerivedValues.tsx
#: src/features/timeSeries/components/panes/DerivedTagsPane.tsx
msgid "Create"
msgstr "Create"

#: src/features/knowledgeDocumentViewer/components/bugReport/BugReportAgentModeField.tsx
msgid "Create a Linear ticket."
msgstr "Create a Linear ticket."

#: src/features/fimReview/StructuralReviewFlow.tsx
msgid "Create a new Subject"
msgstr "Create a new Subject"

#: src/features/lotoReports/components/LotoReportsEmptyState.tsx
msgid "Create a report, then open its drawing pages in the document viewer to add isolation points in hang order."
msgstr "Create a report, then open its drawing pages in the document viewer to add isolation points in hang order."

#: src/features/timeSeries/components/DerivedValues.tsx
msgid "Create calculated values from sensor combinations"
msgstr "Create calculated values from sensor combinations"

#: src/features/cases/components/CreateCaseModal.tsx
#: src/features/cases/components/CreateCaseModal.tsx
#: src/features/timeSeries/components/DashboardHeader.tsx
msgid "Create Case"
msgstr "Create Case"

#: src/pages/details/overlays/inspections/CreatePredictedInspectionCard.tsx
msgid "Create Forecast"
msgstr "Create Forecast"

#: src/pages/details/extensions/flow/AssetModelEditorExtension.tsx
msgid "Create New Asset Model"
msgstr "Create New Asset Model"

#: src/pages/systemView/components/SystemViewAnnotationSidebar.tsx
msgid "Create new whiteboard"
msgstr "Create new whiteboard"

#: src/features/modelOperations/SubjectDetails.tsx
#: src/pages/facilityModel/SubjectDetailPage.tsx
msgid "Create the Asset Instance for this validated Subject and queue its template fill"
msgstr "Create the Asset Instance for this validated Subject and queue its template fill"

#: src/pages/assetLens/components/tabs/AnomalyDashboard.tsx
msgid "Create Work Order"
msgstr "Create Work Order"

#: src/pages/details/overlays/inspections/CreatePredictedInspectionCard.tsx
msgid "Create<0/>Forecast"
msgstr "Create<0/>Forecast"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
#: src/features/lotoReports/components/LotoReportsTable.tsx
#: src/pages/cases/md/MdCasesCardList.tsx
#: src/pages/cases/md/MdCasesColumnHeader.tsx
#: src/pages/processData/components/viewSwitcher/ManageViewsDialog.tsx
msgid "Created"
msgstr "Created"

#: src/features/lotoReports/components/LotoReportCard.tsx
msgid "Created {created}"
msgstr "Created {created}"

#: src/pages/cases/md/MdCaseDetailsMainColumn.tsx
msgid "Created {createdAtLabel}"
msgstr "Created {createdAtLabel}"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatEvalCaseReview.tsx
#: src/pages/processData/components/viewSwitcher/ManageViewsDialog.tsx
msgid "Created by"
msgstr "Created by"

#: src/pages/assetLens/components/tabs/SensorIssuesTab.tsx
msgid "Created by: {userName}"
msgstr "Created by: {userName}"

#: src/features/cases/components/CaseCreatedContent.tsx
msgid "Created this case"
msgstr "Created this case"

#: src/pages/cases/md/MdCasesListPage.tsx
#: src/pages/systemView/components/SystemViewAnnotationSidebar.tsx
msgid "Creating..."
msgstr "Creating..."

#: src/features/lotoReports/components/LotoNewDraftForm.tsx
#: src/features/lotoReports/components/NewLotoReportDialog.tsx
msgid "Creating…"
msgstr "Creating…"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
#: src/features/knowledgeDocumentViewer/workOrders/workOrderFields.ts
msgid "Crew work group"
msgstr "Crew work group"

#: src/pages/assetLens/components/tabs/AnomalyDashboard.tsx
#: src/pages/assetLens/components/tabs/SensorIssuesTab.tsx
msgid "Critical"
msgstr "Critical"

#: src/pages/assetLens/components/tabs/AnomalyDashboard.tsx
msgid "Critical Severity"
msgstr "Critical Severity"

#: src/features/knowledgeDocumentViewer/components/revisionCompare/RevisionChangeCropPair.tsx
msgid "Crop unavailable"
msgstr "Crop unavailable"

#: src/features/timeSeries/agentTab/toolSentence.ts
msgid "Cross-checked tags against each other"
msgstr "Cross-checked tags against each other"

#: src/features/timeSeries/agentTab/toolSentence.ts
msgid "Cross-checking tags against each other"
msgstr "Cross-checking tags against each other"

#: src/features/timeSeries/experiment/CorrelationCard.tsx
msgid "Cross-correlation vs phase shift (periods)"
msgstr "Cross-correlation vs phase shift (periods)"

#: src/features/knowledgeDocumentViewer/components/ContextMenu.tsx
#: src/features/knowledgeDocumentViewer/components/sidebar/CrossReferencePanel.tsx
msgid "Cross-reference"
msgstr "Cross-reference"

#: src/features/knowledgeDocumentViewer/components/viewer/shared/CrossReferenceMarker.tsx
msgid "Cross-reference location"
msgstr "Cross-reference location"

#: src/features/knowledgeDocumentViewer/components/sidebar/CrossReferencePanel.tsx
msgid "Cross-reference results"
msgstr "Cross-reference results"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
#: src/features/knowledgeDocumentViewer/workOrders/legacyCmmsRecordPdf.ts
msgid "Currency"
msgstr "Currency"

#: src/features/knowledgeDocumentViewer/components/metadata/RevisionFamilyDropdownItem.tsx
#: src/pages/alerts/AlertDetails.tsx
#: src/pages/alerts/components/AssetInfoCard.tsx
msgid "Current"
msgstr "Current"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
#: src/features/knowledgeDocumentViewer/workOrders/legacyCmmsRecordPdf.ts
msgid "Current balance"
msgstr "Current balance"

#: src/pages/details/extensions/flow/FilesExtension.tsx
msgid "Current component selection"
msgstr "Current component selection"

#: src/features/knowledgeDocumentViewer/workOrders/workOrderPdf.ts
msgid "Current estimate"
msgstr "Current estimate"

#: src/pages/details/extensions/flow/FilesExtension.tsx
msgid "Current inspection selection"
msgstr "Current inspection selection"

#: src/pages/processData/buildMode/rightPanel/CurrentModelPane.tsx
msgid "Current model"
msgstr "Current model"

#: src/features/knowledgeDocumentViewer/components/toolbar/PdfDownloadMenuOptions.tsx
#: src/features/knowledgeDocumentViewer/components/toolbar/PrintDocumentMenuOptions.tsx
msgid "Current page ({currentPageNumber})"
msgstr "Current page ({currentPageNumber})"

#: src/pages/documents/PowerCustomerUploadLeaveWarning.tsx
msgid "Current progress is saved, but leaving this page will cancel the upload that is still in progress."
msgstr "Current progress is saved, but leaving this page will cancel the upload that is still in progress."

#: src/features/timeSeries/components/TimeRangeSelector.tsx
msgid "Current shift"
msgstr "Current shift"

#: src/features/knowledgeDocumentViewer/components/DocumentUnavailablePanel.tsx
msgid "Current site config"
msgstr "Current site config"

#: src/features/knowledgeDocumentViewer/components/toolbar/PdfDownloadMenuOptions.tsx
msgid "Current slide ({currentPageNumber})"
msgstr "Current slide ({currentPageNumber})"

#: src/features/timeSeries/agentTab/dock/AlertingTab.tsx
msgid "Current verdict "
msgstr "Current verdict "

#: src/features/timeSeries/components/TimeRangeSelector.tsx
msgid "Custom"
msgstr "Custom"

#: src/features/copcPointClouds/CopcLocalizationColorControl.tsx
msgid "Custom color"
msgstr "Custom color"

#: src/pages/site/components/CustomFieldsTableCard.tsx
msgid "Custom Field"
msgstr "Custom Field"

#: src/pages/site/components/CustomFieldsTableCard.tsx
msgid "Custom Fields"
msgstr "Custom Fields"

#: src/features/copcPointClouds/CopcLocalizationColorControl.tsx
msgid "Custom LiDAR color"
msgstr "Custom LiDAR color"

#: src/features/timeSeries/components/CustomRangePicker.tsx
#: src/features/timeSeries/components/TimeRangeSelector.tsx
#: src/features/timeSeries/components/TimeRangeSelector.tsx
#: src/features/timeSeries/components/TimeRangeSelector.tsx
msgid "Custom Range"
msgstr "Custom Range"

#: src/features/nnpp/nnppReportPresentation.ts
msgid "Customer"
msgstr "Customer"

#: src/pages/processData/components/helpGuide/HelpGuideChapters.tsx
msgid "Customize"
msgstr "Customize"

#: src/pages/processData/components/helpGuide/HelpGuideChapters.tsx
msgid "Customize the Workspace"
msgstr "Customize the Workspace"

#: src/features/timeSeries/components/PenTransformControls.tsx
#: src/features/timeSeries/components/ThresholdFiltering.tsx
msgid "CV %"
msgstr "CV %"

#: src/features/timeSeries/experiment/DiagnosticsPanel.tsx
msgid "d={value217_19} · y={value217_44} · shared={value217_76}"
msgstr "d={value217_19} · y={value217_44} · shared={value217_76}"

#: src/features/lotoReports/recordSheet/recordSheetLayout.ts
msgid "D1.0"
msgstr "D1.0"

#: src/features/timeSeries/agentTab/dock/AlertingTab.tsx
msgid "daily"
msgstr "daily"

#: src/pages/metrics/Metrics.tsx
msgid "Daily"
msgstr "Daily"

#: src/features/timeSeries/components/TimeRangeSelector.tsx
msgid "Daily overview"
msgstr "Daily overview"

#: src/pages/metrics/Metrics.tsx
#: src/pages/metrics/Metrics.tsx
msgid "Daily searches"
msgstr "Daily searches"

#: src/features/knowledgeDocumentViewer/components/viewer/shared/InstrumentTimeSeriesPreview.tsx
msgid "dashboard"
msgstr "dashboard"

#: src/pages/evaluations/metadata/dashboard/components/dataLabeling/DataLabelingDashboardMetricsUnavailable.tsx
msgid "Dashboard metrics require additional permission."
msgstr "Dashboard metrics require additional permission."

#: src/pages/alerts/AlertDetails.tsx
msgid "Data"
msgstr "Data"

#: src/features/timeSeries/components/ChartConfiguration.tsx
#: src/features/timeSeries/components/ScatterplotSidebarAddData.tsx
msgid "Data from Calculations"
msgstr "Data from Calculations"

#: src/features/timeSeries/components/ChartConfiguration.tsx
#: src/features/timeSeries/components/ScatterplotSidebarAddData.tsx
msgid "Data from Tags"
msgstr "Data from Tags"

#: src/pages/details/visualization/alerts/specificAlerts/CDSMissingWarning.tsx
msgid "Data layer is not tagged to a snapshot"
msgstr "Data layer is not tagged to a snapshot"

#: src/features/timeSeries/components/timeSeriesScatterplot/TimeSeriesScatterplotContent.tsx
msgid "Data Layers"
msgstr "Data Layers"

#: src/pages/processData/buildMode/dock/SamplingSection.tsx
msgid "Data preview failed: "
msgstr "Data preview failed: "

#: src/pages/assetLens/components/tabs/timeSeriesAnalysis/TimeSeriesSidebar.tsx
msgid "Data Processing"
msgstr "Data Processing"

#: src/pages/assetLens/components/tabs/timeSeriesAnalysis/TimeSeriesSidebar.tsx
msgid "DATA PROCESSING"
msgstr "DATA PROCESSING"

#: src/pages/overview/sidebar/assetTracker/SiteViewAssetCountBreakdownLabels.tsx
msgid "Data Quality"
msgstr "Data Quality"

#: src/pages/assetLens/components/tabs/timeSeriesAnalysis/DataProcessingToolbar.tsx
msgid "Data Smoothing"
msgstr "Data Smoothing"

#: src/features/timeSeries/experiment/ExperimentTab.tsx
msgid "Data Studio"
msgstr "Data Studio"

#: src/features/timeSeries/agentTab/dock/TargetTab.tsx
msgid "data through"
msgstr "data through"

#: src/features/mdCases/components/ProvenanceContentViewer.tsx
#: src/features/mdCases/components/ProvenanceContentViewer.tsx
msgid "Datapoint IDs"
msgstr "Datapoint IDs"

#: src/features/timeSeries/sentinelStudio/SentinelBuilderPanel.tsx
msgid "Datapoint ids, one per line"
msgstr "Datapoint ids, one per line"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatInspectionCard.tsx
msgid "Dataset"
msgstr "Dataset"

#: src/features/modelOperations/SubjectDetails.tsx
msgid "Datastreams"
msgstr "Datastreams"

#: src/features/forecastNotifications/NotificationListPanel.tsx
#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/documentsTableView/DocumentTableColumns.tsx
#: src/features/lotoReports/components/LotoSheetHeaderFields.tsx
#: src/pages/site/forms/customFieldInfoFormFields.ts
msgid "Date"
msgstr "Date"

#: src/pages/cases/components/CasesTableColumns.tsx
msgid "Date Created"
msgstr "Date Created"

#: src/pages/assetLens/components/tabs/imagesTabComponents/ImageUploadModal.tsx
msgid "Date of Capture"
msgstr "Date of Capture"

#: src/features/powerCustomerUploads/components/PowerCustomerUploadHistoryPanel.tsx
msgid "Date unavailable"
msgstr "Date unavailable"

#: src/features/timeSeries/experiment/ExperimentTab.tsx
msgid "Date window"
msgstr "Date window"

#: src/features/lotoReports/recordSheet/recordSheetLayout.ts
msgid "DATE:"
msgstr "DATE:"

#: src/features/lotoReports/recordSheet/recordSheetLayout.ts
#: src/features/lotoReports/recordSheet/recordSheetLayout.ts
msgid "Date/Time:"
msgstr "Date/Time:"

#: src/features/timeSeries/agentTab/dock/BacktestTab.tsx
msgid "Dates come from the work orders — an outage, a valve repair, a wash. With hold-out on, each window is masked out of the baseline before fitting, which is the only honest way to ask whether the model would have seen it coming."
msgstr "Dates come from the work orders — an outage, a valve repair, a wash. With hold-out on, each window is masked out of the baseline before fitting, which is the only honest way to ask whether the model would have seen it coming."

#: src/features/timeSeries/components/RelativeDateConfig.tsx
msgid "Days"
msgstr "Days"

#: src/pages/processData/buildMode/dock/WindowsDockTab.tsx
msgid "Days per chunk"
msgstr "Days per chunk"

#: src/features/timeSeries/agentTab/dock/BacktestTab.tsx
msgid "days scored"
msgstr "days scored"

#: src/features/timeSeries/components/SentinelsTab.tsx
msgid "days). Zoom in to score the range you are viewing."
msgstr "days). Zoom in to score the range you are viewing."

#: src/pages/manageAccess/users.ts
msgctxt "access status"
msgid "Deactivated"
msgstr "Deactivated"

#: src/pages/manageAccess/components/table/UserRowActions.tsx
msgid "Deactivated users cannot be impersonated."
msgstr "Deactivated users cannot be impersonated."

#: src/pages/manageAccess/components/table/UserRow.tsx
msgid "Deactivated users cannot have their permissions changed."
msgstr "Deactivated users cannot have their permissions changed."

#: src/pages/details/visualization/tools/VizDebugMenu.tsx
msgid "Debug stats"
msgstr "Debug stats"

#: src/features/fimReview/ReviewActions.tsx
msgid "Decision"
msgstr "Decision"

#: src/features/modelOperations/SubjectDetails.tsx
#: src/pages/facilityModel/SubjectDetailPage.tsx
msgid "Decisions"
msgstr "Decisions"

#: src/features/knowledgeDocumentViewer/components/metadata/RevisionAuditBadge.tsx
msgid "declared"
msgstr "declared"

#: src/pages/assetLens/components/tabs/imagesTabComponents/ImageTrendAnalysis.tsx
msgid "decreasing"
msgstr "decreasing"

#: src/features/richText/components/ToolbarPlugin.tsx
#: src/pages/systemView/components/unitsTab/FilterControls.tsx
msgid "Default"
msgstr "Default"

#: src/features/sentinels/components/RecentScorePanel.tsx
msgid "default last 7 days · up to "
msgstr "default last 7 days · up to "

#: src/features/knowledgeDocumentViewer/components/metadata/DeferPageMetadataDialog.tsx
#: src/features/knowledgeDocumentViewer/components/metadata/PageMetadataEvalChrome.tsx
msgid "Defer"
msgstr "Defer"

#: src/features/knowledgeDocumentViewer/components/metadata/PageMetadataEvalChrome.tsx
msgid "Defer page metadata"
msgstr "Defer page metadata"

#: src/features/knowledgeDocumentViewer/components/metadata/DeferPageMetadataDialog.tsx
msgid "Defer this page"
msgstr "Defer this page"

#: src/features/knowledgeDocumentViewer/components/metadata/PageMetadataEvalDeferReason.tsx
msgid "Deferral reason:"
msgstr "Deferral reason:"

#: src/features/knowledgeDocumentViewer/components/metadata/PageMetadataEvalStatusChip.tsx
#: src/pages/evaluations/metadata/labeling/components/DataLabelingStatusFilter.tsx
msgid "Deferred"
msgstr "Deferred"

#: src/pages/evaluations/metadata/labeling/components/DataLabelingLandingCounts.tsx
msgid "Deferred by me"
msgstr "Deferred by me"

#: src/features/knowledgeDocumentViewer/components/metadata/DeferPageMetadataDialog.tsx
msgid "Deferring…"
msgstr "Deferring…"

#: src/features/timeSeries/components/RegressionPrediction.tsx
msgid "Degree"
msgstr "Degree"

#: src/features/embeddedSidebar/chatHistory/AgenticChatHistorySessionOverflowMenu.tsx
#: src/features/embeddedSidebar/chatHistory/AgenticChatHistorySessionOverflowMenu.tsx
#: src/features/fim/photos/PhotoLightbox.tsx
#: src/features/kestrelUpload/KestrelModelUploadSection.tsx
#: src/features/lotoReports/components/DeleteLotoReportButton.tsx
#: src/features/timeSeries/components/LabelsTab.tsx
#: src/features/timeSeries/components/labelTool/LabelConfigPanel.tsx
#: src/features/timeSeries/components/timeSeriesScatterplot/MdDraftAlertCaseFlowPanels.tsx
#: src/features/timeSeries/experiment/ExperimentTab.tsx
#: src/pages/cases/components/CaseDetailsContent.tsx
#: src/pages/cases/components/DeleteCaseModal.tsx
#: src/pages/details/extensions/flow/filesExt/FileMenuButton.tsx
#: src/pages/processData/components/viewSwitcher/ViewActionDialogs.tsx
#: src/pages/processData/components/viewSwitcher/ViewSwitcher.tsx
#: src/pages/systemView/components/SystemViewAnnotationSidebar.tsx
#: src/pages/systemView/components/unitsTab/UnitListItem.tsx
msgid "Delete"
msgstr "Delete"

#: src/pages/processData/components/viewSwitcher/ViewActionDialogs.tsx
msgid "Delete “"
msgstr "Delete “"

#: src/features/timeSeries/agentTab/ModelPicker.tsx
msgid "Delete \"{modelName}\"? This removes the saved model and its fit series."
msgstr "Delete \"{modelName}\"? This removes the saved model and its fit series."

#: src/features/timeSeries/components/SentinelsTab.tsx
msgid "Delete \"{name}\"? This permanently removes it."
msgstr "Delete \"{name}\"? This permanently removes it."

#: src/pages/cases/md/MdCasesListPage.tsx
msgid ""
"Delete \"{pendingDeletionLabel}\"?\n"
"\n"
"This action cannot be undone."
msgstr ""
"Delete \"{pendingDeletionLabel}\"?\n"
"\n"
"This action cannot be undone."

#: src/features/timeSeries/agentTab/chat/ConversationDrawer.tsx
msgid "Delete “{title}”? Everyone at this site loses the transcript. Saved models are not affected."
msgstr "Delete “{title}”? Everyone at this site loses the transcript. Saved models are not affected."

#: src/features/kestrelUpload/KestrelModelUploadSection.tsx
msgid "Delete {filename}"
msgstr "Delete {filename}"

#: src/features/kestrelUpload/KestrelModelUploadSection.tsx
msgid "Delete {filename}? This cannot be undone."
msgstr "Delete {filename}? This cannot be undone."

#: src/features/timeSeries/agentTab/ModelPicker.tsx
msgid "Delete {modelName}"
msgstr "Delete {modelName}"

#: src/features/timeSeries/agentTab/chat/ConversationDrawer.tsx
msgid "Delete {title}"
msgstr "Delete {title}"

#: src/pages/processData/buildMode/rightPanel/SavedModelShelf.tsx
msgid "Delete {value235_40}"
msgstr "Delete {value235_40}"

#: src/features/timeSeries/components/LabelsTab.tsx
msgid "Delete {value725_48}"
msgstr "Delete {value725_48}"

#: src/pages/systemView/components/SystemViewAnnotationSidebar.tsx
msgid "Delete {whiteboardLabel}"
msgstr "Delete {whiteboardLabel}"

#: src/features/kestrelUpload/KestrelModelUploadSection.tsx
msgid "Delete 3D asset file?"
msgstr "Delete 3D asset file?"

#: src/features/embeddedSidebar/chatHistory/ChatHistoryOverflowMenu.tsx
#: src/features/kestrelUpload/KestrelModelUploadSection.tsx
#: src/features/kestrelUpload/KestrelModelUploadSection.tsx
#: src/features/kestrelUpload/KestrelModelUploadSection.tsx
#: src/features/kestrelUpload/KestrelModelUploadSection.tsx
msgid "Delete all"
msgstr "Delete all"

#: src/features/kestrelUpload/KestrelModelUploadSection.tsx
msgid "Delete all 3D asset files?"
msgstr "Delete all 3D asset files?"

#: src/features/kestrelUpload/KestrelModelUploadSection.tsx
msgid "Delete all files in {category}?"
msgstr "Delete all files in {category}?"

#: src/features/embeddedSidebar/chatHistory/ChatHistoryBulkActionDialog.tsx
msgid "Delete archived chats?"
msgstr "Delete archived chats?"

#: src/pages/cases/components/CaseDetailsContent.tsx
#: src/pages/cases/components/CaseDetailsContent.tsx
#: src/pages/cases/md/MdCasesCardList.tsx
msgid "Delete Case"
msgstr "Delete Case"

#: src/features/embeddedSidebar/chatHistory/AgenticChatHistorySessionOverflowMenu.tsx
msgid "Delete chat?"
msgstr "Delete chat?"

#: src/features/embeddedSidebar/chatHistory/ChatHistoryBulkActionDialog.tsx
msgid "Delete chats"
msgstr "Delete chats"

#: src/features/fim/photos/SubjectPhotoLightbox.tsx
msgid "Delete failed: {reason}"
msgstr "Delete failed: {reason}"

#: src/features/lotoReports/components/DeleteLotoReportButton.tsx
msgid "Delete LOTO report {name}"
msgstr "Delete LOTO report {name}"

#: src/features/lotoReports/components/DeleteLotoReportButton.tsx
msgid "Delete LOTO report?"
msgstr "Delete LOTO report?"

#: src/pages/cases/md/MdCasesListPage.tsx
msgid "Delete M&D Case"
msgstr "Delete M&D Case"

#: src/features/knowledgeDocumentViewer/components/table/enhancements/BulkEditModal.tsx
msgid "Delete Rows"
msgstr "Delete Rows"

#: src/features/timeSeries/experiment/ExperimentTab.tsx
msgid "Delete saved experiment \"{label}\"?"
msgstr "Delete saved experiment \"{label}\"?"

#: src/pages/processData/buildMode/rightPanel/SavedModelShelf.tsx
msgid "Delete saved model"
msgstr "Delete saved model"

#: src/features/timeSeries/components/timeSeriesScatterplot/MdDraftAlertCaseFlow.tsx
msgid "Delete this alert?"
msgstr "Delete this alert?"

#: src/features/timeSeries/components/timeSeriesScatterplot/MdDraftAlertCaseFlow.tsx
msgid "Delete this alert? It will also be removed from the linked M&D case."
msgstr "Delete this alert? It will also be removed from the linked M&D case."

#: src/features/timeSeries/components/SentinelsTab.tsx
msgid "Delete this design"
msgstr "Delete this design"

#: src/features/timeSeries/components/LabelsTab.tsx
msgid "Delete this label?"
msgstr "Delete this label?"

#: src/features/timeSeries/agentTab/ModelPicker.tsx
msgid "Delete this model"
msgstr "Delete this model"

#: src/features/fim/photos/PhotoLightbox.tsx
msgid "Delete this photo everywhere?"
msgstr "Delete this photo everywhere?"

#: src/features/timeSeries/components/SentinelsTab.tsx
msgid "Delete this sentinel"
msgstr "Delete this sentinel"

#: src/pages/systemView/components/UnitsTab.tsx
msgid "Delete this unit link?"
msgstr "Delete this unit link?"

#: src/pages/processData/components/viewSwitcher/ManageViewsDialog.tsx
msgid "Delete view"
msgstr "Delete view"

#: src/pages/systemView/components/SystemViewAnnotationSidebar.tsx
msgid "Delete Whiteboard"
msgstr "Delete Whiteboard"

#: src/pages/processData/buildMode/dock/CustomRangesTable.tsx
#: src/pages/processData/buildMode/dock/CustomRangesTable.tsx
msgid "Delete window"
msgstr "Delete window"

#: src/features/embeddedSidebar/chatHistory/ChatHistoryBulkActionDialog.tsx
msgid "Delete your archived chats for this site from your history and close their open tabs. Pinned chats, running replies, and chats with unsent drafts will stay. Recent chats will stay. Deleted chats cannot be restored."
msgstr "Delete your archived chats for this site from your history and close their open tabs. Pinned chats, running replies, and chats with unsent drafts will stay. Recent chats will stay. Deleted chats cannot be restored."

#: src/features/kestrelUpload/KestrelModelUploadSection.tsx
msgid "Deleted {deleted} model file(s)."
msgstr "Deleted {deleted} model file(s)."

#: src/features/timeSeries/experiment/ExperimentTab.tsx
msgid "Deleted {label}"
msgstr "Deleted {label}"

#: src/features/timeSeries/experiment/ExperimentTab.tsx
msgid "Deleted current save"
msgstr "Deleted current save"

#: src/features/timeSeries/components/timeSeriesScatterplot/MdDraftAlertCaseFlowPanels.tsx
#: src/pages/cases/components/DeleteCaseModal.tsx
#: src/pages/cases/md/MdCasesCardList.tsx
#: src/pages/systemView/components/unitsTab/UnitListItem.tsx
msgid "Deleting..."
msgstr "Deleting..."

#: src/features/embeddedSidebar/chatHistory/AgenticChatHistorySessionRow.tsx
#: src/features/embeddedSidebar/chatHistory/ChatHistoryBulkActionDialog.tsx
#: src/features/lotoReports/components/DeleteLotoReportButton.tsx
msgid "Deleting…"
msgstr "Deleting…"

#: src/pages/evaluations/metadata/components/MetricsContent.tsx
msgid "Delta"
msgstr "Delta"

#: src/features/timeSeries/experiment/CleaningControls.tsx
msgid "Denoise window"
msgstr "Denoise window"

#: src/features/timeSeries/components/RegressionPrediction.tsx
msgid "Dependent Variable (Y)"
msgstr "Dependent Variable (Y)"

#: src/features/fimReview/InspectSources.tsx
msgid "Derived by the {sourceLabel} adapter · not in the upload"
msgstr "Derived by the {sourceLabel} adapter · not in the upload"

#: src/features/timeSeries/components/panes/DerivedTagsPane.tsx
msgid "Derived tag description"
msgstr "Derived tag description"

#: src/features/timeSeries/components/panes/DerivedTagsPane.tsx
msgid "Derived tag name"
msgstr "Derived tag name"

#: src/features/timeSeries/components/panes/DerivedTagsPane.tsx
msgid "Derived tag unit"
msgstr "Derived tag unit"

#: src/features/timeSeries/components/panes/DerivedTagsPane.tsx
msgid "Derived Tags"
msgstr "Derived Tags"

#: src/features/fimReview/StructuralReviewFlow.tsx
msgid "Derived unless set"
msgstr "Derived unless set"

#: src/features/timeSeries/components/TagsTab.tsx
msgid "Derived Values"
msgstr "Derived Values"

#: src/features/timeSeries/utils/scatterPlotTableHelpers.ts
msgid "Derived: {value136_54}"
msgstr "Derived: {value136_54}"

#: src/pages/cases/activity/ActivitySection.tsx
msgid "Descending"
msgstr "Descending"

#: src/features/chatbot/components/ChatbotHelpModal.tsx
msgid "Describe the issue"
msgstr "Describe the issue"

#: src/features/cases/components/CreateCaseModal.tsx
#: src/pages/cases/components/EditCaseForm.tsx
msgid "Describe the issue..."
msgstr "Describe the issue..."

#: src/features/timeSeries/agentTab/chat/Transcript.tsx
msgid "Describe what you want graded and the agent finds the tags, checks their health, computes a physics KPI, and field-fits it against a baseline window. Every step appears here as it happens. It can also load and edit any model it saved before."
msgstr "Describe what you want graded and the agent finds the tags, checks their health, computes a physics KPI, and field-fits it against a baseline window. Every step appears here as it happens. It can also load and edit any model it saved before."

#: src/features/fimReview/IdentityPanel.tsx
msgid "description"
msgstr "description"

#: src/features/cases/components/CreateCaseModal.tsx
#: src/features/chatbot/components/ChatbotHelpModal.tsx
#: src/features/fimReview/InspectSources.tsx
#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/sensors/SensorTableColumns.tsx
#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
#: src/features/knowledgeDocumentViewer/workOrders/legacyCmmsRecordPdf.ts
#: src/features/knowledgeDocumentViewer/workOrders/legacyCmmsRecordPdf.ts
#: src/features/knowledgeDocumentViewer/workOrders/workOrderPdf.ts
#: src/features/lotoReports/components/LotoSheetPointRow.tsx
#: src/features/mdCases/components/ProvenanceContentViewer.tsx
#: src/features/timeSeries/components/AllTagsTable.tsx
#: src/features/timeSeries/components/labelTool/LabelConfigPanel.tsx
#: src/features/timeSeries/components/panes/TagSearchDialog.tsx
#: src/features/timeSeries/components/SensorScatterplotTableColumns.tsx
#: src/pages/alerts/AlertDetails.tsx
#: src/pages/alerts/components/AlertsTableColumns.tsx
#: src/pages/alerts/components/AssetInfoCard.tsx
#: src/pages/assetLens/components/tabs/DocumentsTab.tsx
#: src/pages/assetLens/components/tabs/DocumentsTab.tsx
#: src/pages/assetLens/components/tabs/SensorIssuesTab.tsx
msgid "Description"
msgstr "Description"

#: src/features/timeSeries/components/DerivedValues.tsx
#: src/features/timeSeries/components/panes/DerivedTagsPane.tsx
msgid "Description (optional)"
msgstr "Description (optional)"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
msgid "Description and task text describe scope; status alone does not verify performed work."
msgstr "Description and task text describe scope; status alone does not verify performed work."

#: src/features/knowledgeDocumentViewer/workOrders/workOrderPdf.ts
msgid "Description and task text describe work scope; recorded status alone does not verify the work performed."
msgstr "Description and task text describe work scope; recorded status alone does not verify the work performed."

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
#: src/features/knowledgeDocumentViewer/workOrders/legacyCmmsRecordPdf.ts
msgid "Description detail"
msgstr "Description detail"

#: src/features/richText/components/slashCommandCards/ChartSlashCommandCard.tsx
#: src/pages/details/extensions/flow/ImageryExtension.tsx
msgid "Description:"
msgstr "Description:"

#: src/features/richText/components/slashCommandCards/ChartSlashCommandCard.tsx
msgid "Description: {chartDescription}"
msgstr "Description: {chartDescription}"

#: src/pages/processData/components/helpGuide/HelpGuideChapters.tsx
msgid "Descriptions"
msgstr "Descriptions"

#: src/features/timeSeries/sentinelStudio/SentinelBuilderPanel.tsx
msgid "Design again"
msgstr "Design again"

#: src/features/sentinels/components/DesignRunOverviewSections.tsx
msgid "Design context"
msgstr "Design context"

#: src/features/knowledgeDocumentViewer/utils/metadataFieldLabelMessages.ts
msgid "Design Facility"
msgstr "Design Facility"

#: src/features/navbar/profileAndSettings/ProfileAndSettingsSidebar.tsx
#: src/features/navbar/profileAndSettings/ProfileAndSettingsTopBar.tsx
msgid "Design System Library"
msgstr "Design System Library"

#: src/features/timeSeries/sentinelStudio/SentinelBuilderPanel.tsx
msgid "Design the model"
msgstr "Design the model"

#: src/features/sentinels/components/DesignRunOverviewSections.tsx
#: src/features/sentinels/components/DesignRunOverviewSections.tsx
msgid "Design warnings"
msgstr "Design warnings"

#: src/features/sentinels/useSentinelList.ts
msgid "designed for {value179_35} · not run"
msgstr "designed for {value179_35} · not run"

#: src/features/timeSeries/sentinelStudio/SentinelBuilderPanel.tsx
msgid "Designing…"
msgstr "Designing…"

#: src/features/fim/photos/PhotoLightbox.tsx
msgid "Detach"
msgstr "Detach"

#: src/features/fim/photos/PhotoLightbox.tsx
msgid "Detach everywhere and delete the photo"
msgstr "Detach everywhere and delete the photo"

#: src/features/fim/photos/SubjectPhotoLightbox.tsx
msgid "Detach failed: {reason}"
msgstr "Detach failed: {reason}"

#: src/features/fim/photos/PhotoLightbox.tsx
msgid "Detach this photo from this Subject?"
msgstr "Detach this photo from this Subject?"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
msgid "Detail"
msgstr "Detail"

#: src/features/mdCases/components/ProvenanceContentViewer.tsx
#: src/features/mdCases/components/ProvenanceContentViewer.tsx
msgid "Details"
msgstr "Details"

#: src/features/lotoReports/components/LotoIsolationPointRow.tsx
msgid "Details for {tag}"
msgstr "Details for {tag}"

#: src/pages/alerts/components/AlertsTableColumns.tsx
msgid "Detected"
msgstr "Detected"

#: src/features/mdCases/components/CaseStorySection.tsx
msgid "detected {detectedLabel}"
msgstr "detected {detectedLabel}"

#: src/features/timeSeries/utils/uPlotPlugins.ts
msgid "Detection"
msgstr "Detection"

#: src/pages/assetLens/components/tabs/AnomalyDashboard.tsx
msgid "Detection Time:"
msgstr "Detection Time:"

#: src/features/knowledgeDocumentViewer/graph/nodeTooltip.ts
msgid "Device information"
msgstr "Device information"

#: src/features/timeSeries/utils/uPlotPlugins.ts
msgid "Diagnosed"
msgstr "Diagnosed"

#: src/features/sentinels/components/CasesPanel.tsx
msgid "Diagnosing… (this can take a minute)"
msgstr "Diagnosing… (this can take a minute)"

#: src/pages/evaluations/metadata/labeling/utils/pageClassificationTaxonomy.ts
msgid "Diagnostic and root-cause analysis"
msgstr "Diagnostic and root-cause analysis"

#: src/features/knowledgeDocumentViewer/components/DocumentUnavailablePanel.tsx
#: src/features/timeSeries/experiment/ExperimentTab.tsx
msgid "Diagnostics"
msgstr "Diagnostics"

#: src/features/knowledgeDocumentViewer/components/viewer/image/ImageViewerWithOverlay.tsx
msgid "diagram"
msgstr "diagram"

#: src/features/knowledgeDocumentViewer/components/viewer/image/ImageViewerWithOverlay.tsx
msgid "diagram page {pageNumber}"
msgstr "diagram page {pageNumber}"

#: src/pages/processData/buildMode/dock/EvalsDockTab.tsx
msgid "Did we hit the labels?"
msgstr "Did we hit the labels?"

#: src/features/mdCases/components/CaseStorySection.tsx
msgid "different config"
msgstr "different config"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
#: src/features/knowledgeDocumentViewer/workOrders/workOrderFields.ts
msgid "Direct-issue material availability"
msgstr "Direct-issue material availability"

#: src/features/sentinels/components/MonitorTab.tsx
#: src/features/timeSeries/components/ThresholdConfigurationModal.tsx
msgid "Disabled"
msgstr "Disabled"

#: src/pages/evaluations/metadata/dashboard/components/dataLabeling/DataLabelingDashboardFieldDrilldown.tsx
#: src/pages/evaluations/metadata/dashboard/components/dataLabeling/DataLabelingDashboardOverviewTabs.tsx
#: src/pages/evaluations/metadata/dashboard/components/dataLabeling/DataLabelingDashboardSites.tsx
#: src/pages/evaluations/metadata/dashboard/components/dataLabeling/DataLabelingDashboardSummaryCards.tsx
msgid "Disagreements"
msgstr "Disagreements"

#: src/features/fim/photos/PhotoUploadRow.tsx
#: src/features/lotoReports/components/LotoReportEditorHeader.tsx
#: src/features/lotoReports/components/LotoSelectedReport.tsx
#: src/features/timeSeries/agentTab/dock/AgentDock.tsx
msgid "Discard"
msgstr "Discard"

#: src/features/lotoReports/components/LotoLeaveDialog.tsx
msgid "Discard and continue"
msgstr "Discard and continue"

#: src/pages/processData/components/ProcessDataTopBar.tsx
msgid "Discard local edits and reload the saved view"
msgstr "Discard local edits and reload the saved view"

#: src/pages/facilityModel/SubjectDetailPage.tsx
msgid "Discard the unfinished Subject correction?"
msgstr "Discard the unfinished Subject correction?"

#: src/features/lotoReports/components/LotoReportEditorHeader.tsx
msgid "Discard unsaved changes to {name}?"
msgstr "Discard unsaved changes to {name}?"

#: src/features/facilityModel/columns.ts
msgid "Discovered"
msgstr "Discovered"

#: src/pages/facilityModel/SubjectDetailPage.tsx
msgid "Discovered subject"
msgstr "Discovered subject"

#: src/features/forecastNotifications/NotificationsDropdownContent.tsx
#: src/features/timeSeries/agentTab/AgentChatPanel.tsx
#: src/features/timeSeries/components/rulerTool/RulerMetricsPanel.tsx
msgid "Dismiss"
msgstr "Dismiss"

#: src/features/forecastNotifications/NotificationsDropdownContent.tsx
msgid "Dismiss notification"
msgstr "Dismiss notification"

#: src/features/timeSeries/agentTab/AgentBandOverlay.tsx
msgid "Dismiss the highlighted range"
msgstr "Dismiss the highlighted range"

#: src/pages/site/components/CustomFieldsTableColumns.tsx
#: src/pages/site/forms/customFieldInfoFormFields.ts
msgid "Display Name"
msgstr "Display Name"

#: src/pages/details/extensions/flow/ImageryExtension.tsx
msgid "Distance from centerline (Port):"
msgstr "Distance from centerline (Port):"

#: src/features/timeSeries/experiment/DiagnosticsPanel.tsx
msgid "Distances"
msgstr "Distances"

#: src/pages/evaluations/metadata/labeling/utils/pageClassificationTaxonomy.ts
msgid "Dividers, blank leaves, and notes pages"
msgstr "Dividers, blank leaves, and notes pages"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatEvalCaseCitations.tsx
#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatEvalCaseCitations.tsx
msgid "Do not include this document"
msgstr "Do not include this document"

#: src/features/chatbot/components/AttachmentPills.tsx
msgid "doc"
msgstr "doc"

#: src/features/knowledgeDocumentViewer/components/metadata/MetadataScopeToggle.tsx
msgid "Doc"
msgstr "Doc"

#: src/features/fimEvidence/SubjectGlyphs.tsx
#: src/features/modelOperations/Corroboration.tsx
msgid "Doc Nav"
msgstr "Doc Nav"

#: src/features/facilityModel/columns.ts
msgid "Doc reference"
msgstr "Doc reference"

#: src/features/knowledgeDocumentViewer/utils/metadataFieldLabelMessages.ts
msgid "Doc Type"
msgstr "Doc Type"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatTimeline.tsx
msgid "Docchat conversation"
msgstr "Docchat conversation"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/FloatingChatWindow.tsx
#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/FloatingChatWindow.tsx
msgid "Dock the chat beside the preview"
msgstr "Dock the chat beside the preview"

#: src/features/knowledgeDocumentViewer/components/sidebar/CrossReferencePanel.tsx
#: src/features/workspaceTabs/utils/getWorkspaceTabLabel.ts
#: src/features/workspaceTabs/utils/getWorkspaceTabLabel.ts
#: src/pages/assetLens/components/tabs/DocumentsTab.tsx
#: src/pages/cases/md/MdCaseReferencesDrawer.tsx
#: src/pages/evaluations/metadata/dashboard/components/dataLabeling/DataLabelingDashboardComparisonTable.tsx
msgid "Document"
msgstr "Document"

#: src/pages/cases/md/mdCaseDetailsHelpers.ts
msgid "Document {position}"
msgstr "Document {position}"

#: src/features/knowledgeDocumentViewer/components/toolbar/KnowledgeDocumentHeaderBar.tsx
#: src/features/knowledgeDocumentViewer/components/toolbar/KnowledgeDocumentHeaderBar.tsx
msgid "Document actions"
msgstr "Document actions"

#: src/features/knowledgeDocumentViewer/hooks/useConnectorLookup.ts
msgid "Document configuration changed. Reload and try again."
msgstr "Document configuration changed. Reload and try again."

#: src/features/knowledgeDocumentViewer/components/metadata/ScopeSummaryCard.tsx
msgid "Document data changes apply only to {trimmedFilename}."
msgstr "Document data changes apply only to {trimmedFilename}."

#: src/features/knowledgeDocumentViewer/components/metadata/ScopeSummaryCard.tsx
msgid "Document data changes apply only to this document."
msgstr "Document data changes apply only to this document."

#: src/features/knowledgeDocumentViewer/components/metadata/ScopeSummaryCard.tsx
msgid "Document data changes apply to every document in this revision family."
msgstr "Document data changes apply to every document in this revision family."

#: src/features/knowledgeDocumentViewer/components/sidebar/KnowledgeDocumentSidebar.tsx
msgid "Document details"
msgstr "Document details"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/documentPreview/PreviewDocumentDetailsSection.tsx
#: src/features/knowledgeDocumentViewer/components/metadata/DocumentMetadataEditSection.tsx
#: src/features/knowledgeDocumentViewer/utils/sharedMetadataFieldBridge.ts
msgid "Document Details"
msgstr "Document Details"

#: src/features/permissions/profiles/power.ts
msgid "Document Editor"
msgstr "Document Editor"

#: src/features/knowledgeDocumentViewer/contexts/KnowledgeDocumentDataContext.tsx
#: src/features/knowledgeDocumentViewer/hooks/useSaveDocumentMetadataUserEdit.ts
msgid "Document metadata updated"
msgstr "Document metadata updated"

#: src/features/knowledgeDocumentViewer/hooks/useSaveDocumentMetadataUserEdit.ts
msgid "Document metadata updated for {revisionCount, plural, one {# revision} other {# revisions}}"
msgstr "Document metadata updated for {revisionCount, plural, one {# revision} other {# revisions}}"

#: src/pages/assetLens/components/tabs/DocumentsTab.tsx
msgid "Document not available"
msgstr "Document not available"

#: src/features/knowledgeDocumentViewer/contexts/KnowledgeDocumentDataContext.tsx
msgid "Document not found"
msgstr "Document not found"

#: src/features/fimReview/provenance.ts
msgid "Document page"
msgstr "Document page"

#: src/features/chatbot/components/CitationDocumentModal.tsx
msgid "Document Preview"
msgstr "Document Preview"

#: src/features/fimReview/InspectSources.tsx
#: src/features/fimReview/StructuralReviewFlow.tsx
msgid "Document reference"
msgstr "Document reference"

#: src/features/knowledgeDocumentViewer/components/toolbar/SettingsMenu.tsx
msgid "Document references"
msgstr "Document references"

#: src/features/modelOperations/templates/templateModel.ts
msgid "Document row {row} needs a label."
msgstr "Document row {row} needs a label."

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/documentsCardView/documentCardFilterBar/types.ts
#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/documentsTableView/DocumentTableColumns.tsx
#: src/pages/assetLens/components/tabs/DocumentsTab.tsx
msgid "Document Title"
msgstr "Document Title"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatEvalCaseCitations.tsx
msgid "Document to cite"
msgstr "Document to cite"

#: src/pages/assetLens/components/tabs/DocumentsTab.tsx
msgid "Document uploaded successfully"
msgstr "Document uploaded successfully"

#: src/features/permissions/profiles/power.ts
msgid "Document Uploader"
msgstr "Document Uploader"

#: src/features/powerCustomerUploads/components/PowerCustomerUploadPage.tsx
msgid "Document Uploads"
msgstr "Document Uploads"

#: src/features/permissions/profiles/power.ts
msgid "Document Viewer"
msgstr "Document Viewer"

#: src/features/fimReview/provenance.ts
msgid "Document Vision"
msgstr "Document Vision"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/utils/constants.ts
#: src/features/knowledgeDocumentViewer/components/sidebar/RelatedDocumentsTable.tsx
#: src/features/knowledgeDocumentViewer/components/sidebar/RelatedDocumentsTable.tsx
#: src/features/modelOperations/SubjectDetails.tsx
#: src/features/navbar/navConfig.ts
#: src/features/workspaceTabs/utils/getWorkspaceTabLabel.ts
#: src/pages/assetLens/components/AssetDocumentsWrapper.tsx
#: src/pages/assetLens/components/tabs/DocumentsTab.tsx
#: src/pages/cases/md/MdCaseReferencesDrawer.tsx
#: src/pages/facilityModel/SubjectAssetPanel.tsx
msgid "Documents"
msgstr "Documents"

#: src/pages/assetLens/components/AssetHeader.tsx
msgid "Documents ({documentCount})"
msgstr "Documents ({documentCount})"

#: src/pages/facilityModel/SubjectDetailPage.tsx
msgid "Documents and evidence"
msgstr "Documents and evidence"

#: src/features/sentinels/SentinelInstancePicker.tsx
msgid "documents bound"
msgstr "documents bound"

#: src/pages/metrics/components/SiteRowsTable.tsx
#: src/pages/metrics/Metrics.tsx
msgid "Documents hosted"
msgstr "Documents hosted"

#: src/pages/assetLens/components/tabs/DocumentsTab.tsx
msgid "Documents table"
msgstr "Documents table"

#: src/features/fimReview/DecisionHistory.tsx
msgid "does not exist"
msgstr "does not exist"

#: src/features/copcPointClouds/CopcViewerOverlay.tsx
#: src/features/timeSeries/components/ScatterplotSidebarAddData.tsx
#: src/features/timeSeries/components/ScatterplotSidebarConfig.tsx
#: src/pages/details/visualization/markupEditing/EditToolBar.tsx
#: src/pages/processData/components/helpGuide/HelpGuideDialog.tsx
msgid "Done"
msgstr "Done"

#: src/pages/cases/components/EditCaseForm.tsx
msgid "Done Editing"
msgstr "Done Editing"

#: src/features/knowledgeDocumentViewer/artifacts/ArtifactPanelHeader.tsx
#: src/pages/details/extensions/flow/ImageryExtension.tsx
msgid "Download"
msgstr "Download"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/documentsSearchActions/DownloadSearchResultButton.tsx
msgid "Download {documentLabel}"
msgstr "Download {documentLabel}"

#: src/pages/details/extensions/flow/filesExt/FileDownloadButton.tsx
msgid "Download {fileName}"
msgstr "Download {fileName}"

#: src/pages/assetLens/components/tabs/DocumentsTab.tsx
msgid "Download {title}"
msgstr "Download {title}"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/documentsSearchActions/DownloadSearchResultButton.tsx
#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/documentsSearchActions/DownloadSearchResultButton.tsx
#: src/features/knowledgeDocumentViewer/components/toolbar/DownloadDocumentButton.tsx
#: src/features/knowledgeDocumentViewer/components/toolbar/DownloadDocumentButton.tsx
msgid "Download Document"
msgstr "Download Document"

#: src/pages/assetLens/components/tabs/DocumentsTab.tsx
msgid "Download File"
msgstr "Download File"

#: src/pages/details/extensions/flow/filesExt/ReportItem.tsx
msgid "Download not available"
msgstr "Download not available"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/documentsSearchActions/DownloadSearchResultButton.tsx
#: src/features/knowledgeDocumentViewer/components/toolbar/DownloadDocumentButton.tsx
msgid "Download original"
msgstr "Download original"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/documentsSearchActions/DownloadSearchResultButton.tsx
#: src/features/knowledgeDocumentViewer/workOrders/WorkOrderDownloadButton.tsx
msgid "Download Page {pageNumber}"
msgstr "Download Page {pageNumber}"

#: src/features/knowledgeDocumentViewer/components/toolbar/PageRangeControls.tsx
msgid "Download page range"
msgstr "Download page range"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/documentsSearchActions/DownloadSearchResultButton.tsx
#: src/features/knowledgeDocumentViewer/workOrders/WorkOrderDownloadButton.tsx
#: src/features/knowledgeDocumentViewer/workOrders/WorkOrderDownloadButton.tsx
#: src/features/knowledgeDocumentViewer/workOrders/WorkOrderDownloadButton.tsx
#: src/features/knowledgeDocumentViewer/workOrders/WorkOrderDownloadButton.tsx
msgid "Download PDF"
msgstr "Download PDF"

#: src/features/knowledgeDocumentViewer/components/toolbar/DownloadDocumentButton.tsx
msgid "Download PDF version"
msgstr "Download PDF version"

#: src/features/knowledgeDocumentViewer/artifacts/ArtifactPanelHeader.tsx
msgid "Downloading…"
msgstr "Downloading…"

#: src/features/mdCases/mdCaseDisplay.ts
msgid "Draft"
msgstr "Draft"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatEvalCaseReview.tsx
msgid "Draft eval"
msgstr "Draft eval"

#: src/pages/cases/md/MdCaseDetailsMainColumn.tsx
msgid "Draft the recommendation for publication."
msgstr "Draft the recommendation for publication."

#: src/pages/processData/components/helpGuide/HelpGuideChapters.tsx
msgid "Drag"
msgstr "Drag"

#: src/features/copcPointClouds/CopcViewerOverlay.tsx
msgid "Drag the dot freely or an arrow along its axis"
msgstr "Drag the dot freely or an arrow along its axis"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatInspectionViewer.tsx
msgid "Drag to rotate. Scroll to zoom. Hover to inspect readings. Uncolored areas have no displayed reading."
msgstr "Drag to rotate. Scroll to zoom. Hover to inspect readings. Uncolored areas have no displayed reading."

#: src/features/timeSeries/components/timeSeriesScatterplot/TimeSeriesScatterplotContent.tsx
msgid "Drag to shift this axis vertically. Shift-select multiple axes to drag together."
msgstr "Drag to shift this axis vertically. Shift-select multiple axes to drag together."

#: src/pages/processData/components/helpGuide/HelpGuideChapters.tsx
msgid "Drag to zoom, right-drag to box-zoom, reset."
msgstr "Drag to zoom, right-drag to box-zoom, reset."

#: src/pages/processData/buildMode/components/WindowDrawToolButtons.tsx
msgid "Draw {role} windows"
msgstr "Draw {role} windows"

#: src/pages/processData/buildMode/components/WindowDrawToolButtons.tsx
msgid "Draw {role} windows on the chart"
msgstr "Draw {role} windows on the chart"

#: src/features/timeSeries/components/PenTransformControls.tsx
msgid "Draw as"
msgstr "Draw as"

#: src/features/timeSeries/experiment/ExperimentTab.tsx
msgid "Draw experiment overlays on the chart"
msgstr "Draw experiment overlays on the chart"

#: src/features/timeSeries/agentTab/ModelPicker.tsx
msgid "Draw this model on the chart"
msgstr "Draw this model on the chart"

#: src/features/lotoReports/components/LotoProposalCard.tsx
msgid "Drawing"
msgstr "Drawing"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatRevisionMissingCard.tsx
msgid "Drawing {drawing}"
msgstr "Drawing {drawing}"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatRevisionMissingCard.tsx
msgid "Drawing {drawing}, sheet {sheet}"
msgstr "Drawing {drawing}, sheet {sheet}"

#: src/features/lotoReports/printReport/printPageText.ts
msgid "Drawing {drawingName}"
msgstr "Drawing {drawingName}"

#: src/features/lotoReports/printReport/printPageText.ts
msgid "Drawing {drawingName}, page {pageNumber}"
msgstr "Drawing {drawingName}, page {pageNumber}"

#: src/pages/processData/buildMode/components/WindowDrawToolButtons.tsx
msgid "Drawing {role} windows — Esc or click to stop"
msgstr "Drawing {role} windows — Esc or click to stop"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/documentPreview/DocumentPreviewMeta.tsx
#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/documentPreview/PreviewDocumentDetailsSection.tsx
#: src/features/knowledgeDocumentViewer/utils/metadataFieldLabelMessages.ts
msgid "Drawing #"
msgstr "Drawing #"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/documentsCardView/documentCardFilterBar/types.ts
#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/documentsTableView/DocumentTableColumns.tsx
msgid "Drawing Number"
msgstr "Drawing Number"

#: src/features/fimReview/provenance.ts
msgid "Drawing OCR"
msgstr "Drawing OCR"

#: src/features/lotoReports/components/LotoAttachmentsSection.tsx
msgid "Drawing pages this LOTO report covers."
msgstr "Drawing pages this LOTO report covers."

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
#: src/features/knowledgeDocumentViewer/workOrders/legacyCmmsRecordPdf.ts
msgid "Drawing reference"
msgstr "Drawing reference"

#: src/features/knowledgeDocumentViewer/components/metadata/RevisionDropdownTrigger.tsx
msgid "Drawing revision"
msgstr "Drawing revision"

#: src/features/knowledgeDocumentViewer/components/metadata/RevisionDropdownTrigger.tsx
msgid "Drawing revision is out of date"
msgstr "Drawing revision is out of date"

#: src/features/lotoReports/components/LotoProposalCard.tsx
#: src/features/lotoReports/components/LotoReportCard.tsx
#: src/features/lotoReports/components/LotoReportsTable.tsx
#: src/features/lotoReports/components/LotoTargetEquipmentList.tsx
msgid "Drawings"
msgstr "Drawings"

#: src/features/lotoReports/components/LotoTargetEquipmentList.tsx
msgid "Drawings for {name}"
msgstr "Drawings for {name}"

#: src/features/lotoReports/components/LotoTargetDrawings.tsx
msgid "Drawings showing {name}"
msgstr "Drawings showing {name}"

#: src/pages/processData/buildMode/dock/WindowsDockTab.tsx
msgid "Drawn / custom windows"
msgstr "Drawn / custom windows"

#: src/features/timeSeries/agentTab/chat/BuildCard.tsx
msgid "drawn on the chart · save it in the model card below to alert or backtest"
msgstr "drawn on the chart · save it in the model card below to alert or backtest"

#: src/features/timeSeries/experiment/DiagnosticsPanel.tsx
msgid "Drift"
msgstr "Drift"

#: src/features/timeSeries/experiment/ModelKnobs.tsx
msgid "Driver ffill limit"
msgstr "Driver ffill limit"

#: src/pages/processData/buildMode/dock/EngineeringSection.tsx
msgid "Driver forward-fill limit"
msgstr "Driver forward-fill limit"

#: src/pages/processData/buildMode/dock/EngineeringSection.tsx
msgid "driver history"
msgstr "driver history"

#: src/pages/processData/buildMode/dock/EngineeringSection.tsx
msgid "Driver history"
msgstr "Driver history"

#: src/features/timeSeries/experiment/ModelKnobs.tsx
msgid "Driver history (lags + rolling)"
msgstr "Driver history (lags + rolling)"

#: src/pages/processData/buildMode/dock/EngineeringSection.tsx
msgid "Driver lags"
msgstr "Driver lags"

#: src/features/timeSeries/experiment/ModelKnobs.tsx
msgid "Driver lags (comma-separated periods)"
msgstr "Driver lags (comma-separated periods)"

#: src/pages/processData/buildMode/dock/EngineeringSection.tsx
msgid "Driver lags (periods)"
msgstr "Driver lags (periods)"

#: src/features/timeSeries/components/SentinelsTab.tsx
#: src/features/timeSeries/experiment/ExperimentTab.tsx
#: src/features/timeSeries/sentinelStudio/SentinelComparison.tsx
msgid "Drivers"
msgstr "Drivers"

#: src/features/sentinels/components/DesignRunDetails.tsx
msgid "drivers · created "
msgstr "drivers · created "

#: src/features/timeSeries/agentTab/dock/FitTab.tsx
msgid "Drivers must be conditions — ambient, load, pressure ratio. A sibling of the target smuggles the answer into the fit and hides the very excursion you are hunting."
msgstr "Drivers must be conditions — ambient, load, pressure ratio. A sibling of the target smuggles the answer into the fit and hides the very excursion you are hunting."

#: src/features/timeSeries/experiment/ModelKnobs.tsx
msgid "Drivers trail the current period; the target is shifted one period so its own value stays out, as the features are built. Replaces a denoise overlay on the same pen."
msgstr "Drivers trail the current period; the target is shifted one period so its own value stays out, as the features are built. Replaces a denoise overlay on the same pen."

#: src/pages/systemView/components/DataPanel.tsx
msgid "Drone Scan"
msgstr "Drone Scan"

#: src/features/powerCustomerUploads/components/PowerCustomerUploadSelection.tsx
msgid "Drop files or folders below, then review your selection before uploading."
msgstr "Drop files or folders below, then review your selection before uploading."

#: src/features/powerCustomerUploads/components/PowerCustomerUploadSelection.tsx
msgid "Drop files or folders here, or "
msgstr "Drop files or folders here, or "

#: src/features/timeSeries/experiment/CleaningControls.tsx
msgid "Drop points outside these data quantiles (0–1). Typical: 0.01 / 0.99."
msgstr "Drop points outside these data quantiles (0–1). Typical: 0.01 / 0.99."

#: src/features/timeSeries/experiment/CleaningControls.tsx
msgid "Drop points outside this physical range (sets them missing). Bounds default from raw tag stats."
msgstr "Drop points outside this physical range (sets them missing). Bounds default from raw tag stats."

#: src/features/timeSeries/experiment/CleaningControls.tsx
msgid "Drop runs of more than max_repeat identical consecutive values (stuck sensor)."
msgstr "Drop runs of more than max_repeat identical consecutive values (stuck sensor)."

#: src/pages/site/forms/customFieldInfoFormFields.ts
msgid "Dropdown"
msgstr "Dropdown"

#: src/features/powerCustomerUploads/components/PowerCustomerUploadStatus.tsx
msgid "Duplicate content"
msgstr "Duplicate content"

#: src/pages/details/visualization/alerts/specificAlerts/DuplicateCDFAlert.tsx
msgid "Duplicate setting group {groupNumber}:"
msgstr "Duplicate setting group {groupNumber}:"

#: src/features/timeSeries/agentTab/dock/TargetTab.tsx
msgid "e.g. (load > 450) & (steady > 0)"
msgstr "e.g. (load > 450) & (steady > 0)"

#: src/features/timeSeries/agentTab/dock/FitTab.tsx
msgid "e.g. ambient_t"
msgstr "e.g. ambient_t"

#: src/features/lotoReports/components/NewLotoReportDialog.tsx
msgid "e.g. Boiler feed pump 1A outage"
msgstr "e.g. Boiler feed pump 1A outage"

#: src/features/timeSeries/agentTab/dock/BacktestTab.tsx
msgid "e.g. HP bypass valve repair"
msgstr "e.g. HP bypass valve repair"

#: src/features/lotoReports/components/LotoNewDraftForm.tsx
msgid "e.g. Pump B isolation"
msgstr "e.g. Pump B isolation"

#: src/pages/assetLens/components/tabs/imagesTabComponents/ImageUploadModal.tsx
msgid "e.g., 1000-5000 Hz"
msgstr "e.g., 1000-5000 Hz"

#: src/pages/assetLens/components/tabs/imagesTabComponents/ImageUploadModal.tsx
msgid "e.g., 150.2"
msgstr "e.g., 150.2"

#: src/pages/assetLens/components/tabs/imagesTabComponents/ImageUploadModal.tsx
msgid "e.g., 180.5"
msgstr "e.g., 180.5"

#: src/pages/assetLens/components/tabs/imagesTabComponents/ImageUploadModal.tsx
msgid "e.g., 65.8"
msgstr "e.g., 65.8"

#: src/pages/assetLens/components/tabs/imagesTabComponents/ImageUploadModal.tsx
msgid "e.g., 75.2"
msgstr "e.g., 75.2"

#: src/pages/assetLens/components/tabs/imagesTabComponents/ImageUploadModal.tsx
msgid "e.g., Motor Housing, Pipe Section XYZ"
msgstr "e.g., Motor Housing, Pipe Section XYZ"

#: src/features/timeSeries/experiment/ExperimentTab.tsx
msgid "Each bounded tag marks its own excluded points. A gate drops those rows for every tag in training, but on the chart it marks only its own pen. Quantile clip and frozen have no chart equivalent."
msgstr "Each bounded tag marks its own excluded points. A gate drops those rows for every tag in training, but on the chart it marks only its own pen. Quantile clip and frozen have no chart equivalent."

#: src/features/sentinels/components/CasesPanel.tsx
msgid "Each case is a point where the target left its band. Open one and run the RCA agent to diagnose the real-world cause."
msgstr "Each case is a point where the target left its band. Open one and run the RCA agent to diagnose the real-world cause."

#: src/features/knowledgeDocumentViewer/components/bugReport/BugReportScreenshots.tsx
msgid "Each screenshot must be a non-empty image of 5 MB or less."
msgstr "Each screenshot must be a non-empty image of 5 MB or less."

#: src/features/chatbot/components/conversationMessage/UserMessage.tsx
#: src/features/knowledgeDocumentViewer/components/metadata/MetadataEditFormChrome.tsx
#: src/features/lotoReports/components/LotoReportEditorHeader.tsx
#: src/features/navbar/siteSelectors/EmbeddedSelectorSection.tsx
#: src/features/navbar/siteSelectors/SiteSelectorsTopBar.tsx
msgid "Edit"
msgstr "Edit"

#: src/features/navbar/siteSelectors/EmbeddedSelectorSection.tsx
#: src/features/timeSeries/components/panes/DerivedTagsPane.tsx
msgid "Edit {name}"
msgstr "Edit {name}"

#: src/features/navbar/siteSelectors/EmbeddedSelectorSection.tsx
msgid "Edit {selectedEditLabel}"
msgstr "Edit {selectedEditLabel}"

#: src/features/knowledgeDocumentViewer/components/metadata/ScopeSummaryCard.tsx
msgid "Edit all {familySize} revisions"
msgstr "Edit all {familySize} revisions"

#: src/pages/details/extensions/flow/assetModelEditorExt/AssetModelEditorRawJSON.tsx
msgid "Edit Asset Model"
msgstr "Edit Asset Model"

#: src/pages/cases/components/CaseDetailsContent.tsx
#: src/pages/cases/components/EditCaseForm.tsx
msgid "Edit Case"
msgstr "Edit Case"

#: src/pages/cases/md/MdCaseDetailsMainColumn.tsx
msgid "Edit case title"
msgstr "Edit case title"

#: src/features/chatbot/components/FeedbackMenu.tsx
msgid "Edit comment"
msgstr "Edit comment"

#: src/features/copcPointClouds/CopcViewerOverlay.tsx
msgid "Edit coordinate origin"
msgstr "Edit coordinate origin"

#: src/pages/site/components/CustomFieldsTableCard.tsx
msgid "Edit Custom Field"
msgstr "Edit Custom Field"

#: src/features/timeSeries/components/panes/DerivedTagsPane.tsx
msgid "Edit derived tag"
msgstr "Edit derived tag"

#: src/features/permissions/profiles/power.ts
msgid "Edit document details including drawing numbers, revisions, etc."
msgstr "Edit document details including drawing numbers, revisions, etc."

#: src/features/knowledgeDocumentViewer/components/metadata/DocumentMetadataEditSection.tsx
msgid "Edit document metadata"
msgstr "Edit document metadata"

#: src/pages/cases/md/MdCaseDetailsMainColumn.tsx
msgid "Edit investigation notes"
msgstr "Edit investigation notes"

#: src/features/knowledgeDocumentViewer/components/metadata/ScopeSummaryCard.tsx
#: src/features/knowledgeDocumentViewer/components/metadata/ScopeSummaryCard.tsx
msgid "Edit just this document"
msgstr "Edit just this document"

#: src/features/timeSeries/components/labelTool/LabelConfigPanel.tsx
msgid "Edit label"
msgstr "Edit label"

#: src/pages/details/visualization/markupEditing/EditToolBar.tsx
msgid "Edit markup layer \"{markupLayerName}\""
msgstr "Edit markup layer \"{markupLayerName}\""

#: src/features/navbar/siteSelectors/SiteSelectorsTopBar.tsx
msgid "Edit Org"
msgstr "Edit Org"

#: src/pages/manageAccess/users.ts
msgctxt "access role"
msgid "Edit other people's permissions, plus everything below."
msgstr "Edit other people's permissions, plus everything below."

#: src/features/knowledgeDocumentViewer/components/metadata/PageMetadataEditSection.tsx
msgid "Edit page metadata"
msgstr "Edit page metadata"

#: src/features/timeSeries/components/ActiveTimeRangeSelector.tsx
#: src/features/timeSeries/components/ActiveTimeRangeSelector.tsx
msgid "Edit pens"
msgstr "Edit pens"

#: src/features/timeSeries/experiment/ExperimentTab.tsx
msgid "Edit plan JSON"
msgstr "Edit plan JSON"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatQueuedMessageRow.tsx
#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatQueuedMessageRow.tsx
msgid "Edit queued message {position}"
msgstr "Edit queued message {position}"

#: src/pages/cases/md/MdCaseDetailsMainColumn.tsx
msgid "Edit recommendation draft"
msgstr "Edit recommendation draft"

#: src/features/navbar/siteSelectors/SiteSelectorsTopBar.tsx
#: src/pages/site/EditSite.tsx
msgid "Edit Site"
msgstr "Edit Site"

#: src/features/knowledgeDocumentViewer/components/sidebar/SubjectDocumentsPanel.tsx
#: src/features/knowledgeDocumentViewer/components/sidebar/SubjectDocumentsPanel.tsx
msgid "Edit subject in Facility Model"
msgstr "Edit subject in Facility Model"

#: src/pages/details/extensions/flow/assetModelEditorExt/AssetModelEditorRawJSON.tsx
msgid "Edit Unit"
msgstr "Edit Unit"

#: src/features/timeSeries/experiment/knobCopy.ts
msgid "Editable cleaning plan with a tags map keyed by ID and a summary. Each tag contains a verdict, notes, and operations. Operations: range, clip_quantile, frozen, gate, denoise_mean, denoise_median."
msgstr "Editable cleaning plan with a tags map keyed by ID and a summary. Each tag contains a verdict, notes, and operations. Operations: range, clip_quantile, frozen, gate, denoise_mean, denoise_median."

#: src/features/lotoReports/components/LotoLastEdited.tsx
msgid "Edited {relative}"
msgstr "Edited {relative}"

#: src/features/lotoReports/components/LotoLastEdited.tsx
msgid "Edited {when}"
msgstr "Edited {when}"

#: src/features/lotoReports/components/LotoLastEdited.tsx
msgid "Edited {when} by {editedBy}"
msgstr "Edited {when} by {editedBy}"

#: src/features/timeSeries/experiment/ExperimentTab.tsx
msgid "Editing: "
msgstr "Editing: "

#: src/pages/manageAccess/users.ts
msgctxt "access role"
msgid "Editor"
msgstr "Editor"

#: src/features/timeSeries/agentTab/dock/AlertingTab.tsx
msgid "Efficiency falling is \"below\"; backpressure rising is \"above\". Daily is the sensible cadence — these are daily-median series, so checking hourly re-reads the same number."
msgstr "Efficiency falling is \"below\"; backpressure rising is \"above\". Daily is the sensible cadence — these are daily-median series, so checking hourly re-reads the same number."

#: src/features/powerCustomerUploads/state/powerCustomerUploadRowUpdates.ts
msgid "Elasticsearch native text"
msgstr "Elasticsearch native text"

#: src/features/lotoReports/recordSheet/recordSheetLayout.ts
msgid ""
"Electrical\n"
"STW"
msgstr ""
"Electrical\n"
"STW"

#: src/features/knowledgeDocumentViewer/utils/documentTypeLabels.ts
msgid "Electrical One Line"
msgstr "Electrical One Line"

#: src/pages/evaluations/metadata/labeling/utils/pageClassificationTaxonomy.ts
msgid "Electrical One-Line Diagram"
msgstr "Electrical One-Line Diagram"

#: src/pages/evaluations/metadata/labeling/utils/pageClassificationTaxonomy.ts
msgid "Electrical power and protection analysis"
msgstr "Electrical power and protection analysis"

#: src/features/knowledgeDocumentViewer/utils/documentTypeLabels.ts
#: src/pages/evaluations/metadata/labeling/utils/pageClassificationTaxonomy.ts
msgid "Electrical Schematic"
msgstr "Electrical Schematic"

#: src/features/knowledgeDocumentViewer/utils/documentTypeLabels.ts
msgid "Electrical Three Line"
msgstr "Electrical Three Line"

#: src/pages/evaluations/metadata/labeling/utils/pageClassificationTaxonomy.ts
msgid "Electrical Three-Line Diagram"
msgstr "Electrical Three-Line Diagram"

#: src/pages/manageAccess/components/invite/InviteUsersDialog.tsx
msgid "Email addresses"
msgstr "Email addresses"

#: src/features/forecastNotifications/NotificationPreferencesModal.tsx
msgid "Email Notifications"
msgstr "Email Notifications"

#: src/features/navbar/EmailSupport.tsx
#: src/features/navbar/profileAndSettings/ProfileAndSettingsSidebar.tsx
msgid "Email Support"
msgstr "Email Support"

#: src/features/richText/nodes/MentionNode.tsx
msgid "Email:"
msgstr "Email:"

#: src/pages/manageAccess/components/invite/InviteRoleGroup.tsx
msgid "Enable {requiredLabel} before enabling {label}."
msgstr "Enable {requiredLabel} before enabling {label}."

#: src/pages/manageAccess/components/table/RoleGroupCells.tsx
msgid "Enable {requiredLabel} before enabling {roleLabel}."
msgstr "Enable {requiredLabel} before enabling {roleLabel}."

#: src/pages/details/extensions/fde/ffsLtaGeneration/FfsLtaGenerationSidebar.tsx
msgid "Enable API 510 Evaluation of Pitting"
msgstr "Enable API 510 Evaluation of Pitting"

#: src/pages/processData/buildMode/components/BuildPrimaryCta.tsx
msgid "Enable at least one method in the Models tab"
msgstr "Enable at least one method in the Models tab"

#: src/features/timeSeries/experiment/CleaningControls.tsx
msgid "Enable denoise"
msgstr "Enable denoise"

#: src/features/timeSeries/experiment/CleaningControls.tsx
msgid "Enable frozen"
msgstr "Enable frozen"

#: src/features/timeSeries/experiment/CleaningControls.tsx
msgid "Enable gate"
msgstr "Enable gate"

#: src/features/timeSeries/experiment/CleaningControls.tsx
msgid "Enable quantile"
msgstr "Enable quantile"

#: src/features/timeSeries/experiment/CleaningControls.tsx
msgid "Enable range"
msgstr "Enable range"

#: src/features/sentinels/components/MonitorTab.tsx
#: src/features/timeSeries/components/ThresholdConfigurationModal.tsx
msgid "Enabled"
msgstr "Enabled"

#: src/features/timeSeries/experiment/ExperimentTab.tsx
#: src/pages/cases/md/MdCaseReferencesDrawer.tsx
msgid "End"
msgstr "End"

#: src/features/knowledgeDocumentViewer/components/table/enhancements/filters/DateFilter.tsx
#: src/features/timeSeries/components/CustomRangePicker.tsx
msgid "End date"
msgstr "End date"

#: src/features/timeSeries/components/AbsoluteDateConfig.tsx
#: src/features/timeSeries/components/RelativeDateConfig.tsx
msgid "End Date"
msgstr "End Date"

#: src/features/timeSeries/components/CustomRangePicker.tsx
#: src/features/timeSeries/components/TimeRangeSelector.tsx
#: src/features/timeSeries/components/TimeRangeSelector.tsx
msgid "End Time"
msgstr "End Time"

#: src/features/timeSeries/components/CustomRangePicker.tsx
msgid "End time must be after start time."
msgstr "End time must be after start time."

#: src/features/lotoReports/printReport/printPageText.ts
msgid "Energized"
msgstr "Energized"

#: src/pages/processData/buildMode/dock/EngineeringSection.tsx
msgid "Engineering"
msgstr "Engineering"

#: src/pages/evaluations/metadata/labeling/utils/pageClassificationTaxonomy.ts
msgid "Engineering calculations and analysis"
msgstr "Engineering calculations and analysis"

#: src/features/timeSeries/experiment/TransparencyStrip.tsx
msgid "Enough for kNN (≥"
msgstr "Enough for kNN (≥"

#: src/pages/processData/components/helpGuide/HelpGuideChapters.tsx
msgid "Enter"
msgstr "Enter"

#: src/components/NamePromptModal.tsx
msgid "Enter a name"
msgstr "Enter a name"

#: src/features/lotoReports/components/NewLotoReportDialog.tsx
msgid "Enter a name of up to 500 characters."
msgstr "Enter a name of up to 500 characters."

#: src/features/fimReview/ReviewActions.tsx
msgid "Enter a name to save."
msgstr "Enter a name to save."

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatEvalCaseCitations.tsx
msgid "Enter a page from 1 to {numPages}."
msgstr "Enter a page from 1 to {numPages}."

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatEvalCaseCitations.tsx
msgid "Enter a page number of 1 or more."
msgstr "Enter a page number of 1 or more."

#: src/features/lotoReports/components/LotoReportEditorHeader.tsx
msgid "Enter a report name of up to 500 characters."
msgstr "Enter a report name of up to 500 characters."

#: src/pages/assetLens/components/tabs/DocumentsTab.tsx
msgid "Enter document description"
msgstr "Enter document description"

#: src/pages/assetLens/components/tabs/DocumentsTab.tsx
msgid "Enter document title if different from filename"
msgstr "Enter document title if different from filename"

#: src/features/timeSeries/components/ThresholdConfigurationModal.tsx
msgid "Enter lower low threshold"
msgstr "Enter lower low threshold"

#: src/features/timeSeries/components/ThresholdConfigurationModal.tsx
msgid "Enter lower threshold"
msgstr "Enter lower threshold"

#: src/features/knowledgeDocumentViewer/components/toolbar/PageRangeControls.tsx
msgid "Enter pages between 1 and {totalPages}"
msgstr "Enter pages between 1 and {totalPages}"

#: src/pages/details/visualization/tools/ScreenshotModeToggle.tsx
msgid "Enter screenshot mode"
msgstr "Enter screenshot mode"

#: src/features/fimReview/subjectDecisionBuilders.ts
msgid "Enter the corrected value."
msgstr "Enter the corrected value."

#: src/features/knowledgeDocumentViewer/components/table/enhancements/BulkActionModalEditConfiguration.tsx
#: src/features/knowledgeDocumentViewer/components/table/enhancements/BulkActionModalEditConfiguration.tsx
#: src/features/knowledgeDocumentViewer/components/table/enhancements/BulkActionModalEditConfiguration.tsx
msgid "Enter the new value"
msgstr "Enter the new value"

#: src/features/timeSeries/components/ThresholdConfigurationModal.tsx
msgid "Enter upper high threshold"
msgstr "Enter upper high threshold"

#: src/features/timeSeries/components/ThresholdConfigurationModal.tsx
msgid "Enter upper threshold"
msgstr "Enter upper threshold"

#: src/features/knowledgeDocumentViewer/components/toolbar/PdfDownloadMenuOptions.tsx
#: src/features/knowledgeDocumentViewer/components/toolbar/PrintDocumentMenuOptions.tsx
msgid "Entire document ({totalPages} pages)"
msgstr "Entire document ({totalPages} pages)"

#: src/features/knowledgeDocumentViewer/components/toolbar/PdfDownloadMenuOptions.tsx
msgid "Entire PDF ({totalPages} pages)"
msgstr "Entire PDF ({totalPages} pages)"

#: src/features/navbar/EntryBrowserButton.tsx
#: src/pages/details/visualization/alerts/specificAlerts/DuplicateCDFAlert.tsx
msgid "Entry"
msgstr "Entry"

#: src/features/embeddedSidebar/EmbeddedSidebar.tsx
#: src/features/embeddedSidebar/EmbeddedSidebar.tsx
#: src/features/embeddedSidebar/EmbeddedSidebar.tsx
#: src/features/navbar/EntryBrowserButton.tsx
#: src/features/navbar/EntryBrowserButton.tsx
#: src/features/navbar/navConfig.ts
msgid "Entry Browser"
msgstr "Entry Browser"

#: src/features/richText/components/slashCommandCards/ChartSlashCommandCard.tsx
#: src/features/richText/components/slashCommandCards/SystemSlashCommandCard.tsx
msgid "Entry:"
msgstr "Entry:"

#: src/features/copcPointClouds/CopcViewerOverlay.tsx
msgid "Environment"
msgstr "Environment"

#: src/pages/assetLens/components/tabs/imagesTabComponents/EnvironmentalCorrelationCard.tsx
msgid "Environmental Correlation Detected"
msgstr "Environmental Correlation Detected"

#: src/features/facilityModel/columns.ts
#: src/features/facilityModel/provenance/ProvenanceChain.tsx
#: src/features/fimReview/InspectSources.tsx
#: src/features/fimReview/StructuralReviewFlow.tsx
#: src/features/lotoReports/components/LotoReportCard.tsx
#: src/features/lotoReports/components/LotoReportsTable.tsx
#: src/pages/facilityModel/FacilityModelCatalog.tsx
#: src/pages/facilityModel/FacilityModelCatalog.tsx
#: src/pages/facilityModel/SentinelOverviewPage.tsx
msgid "Equipment"
msgstr "Equipment"

#: src/pages/evaluations/metadata/labeling/utils/pageClassificationTaxonomy.ts
msgid "Equipment descriptions and capabilities"
msgstr "Equipment descriptions and capabilities"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
msgid "Equipment identity and recorded configuration."
msgstr "Equipment identity and recorded configuration."

#: src/pages/evaluations/metadata/labeling/utils/pageClassificationTaxonomy.ts
msgid "Equipment maintenance and condition records"
msgstr "Equipment maintenance and condition records"

#: src/features/lotoReports/components/LotoSheetHeaderFields.tsx
msgid "Equipment/system"
msgstr "Equipment/system"

#: src/features/lotoReports/recordSheet/recordSheetLayout.ts
msgid "EQUIPMENT/SYSTEM:"
msgstr "EQUIPMENT/SYSTEM:"

#: src/pages/processData/buildMode/dock/BandsDockTab.tsx
msgid "err scale"
msgstr "err scale"

#: src/features/powerCustomerUploads/components/PowerCustomerUploadStatus.tsx
#: src/features/powerCustomerUploads/components/PowerCustomerUploadStatus.tsx
msgid "Error"
msgstr "Error"

#: src/features/timeSeries/services/workOrderService.ts
msgid "Error importing data: {message}"
msgstr "Error importing data: {message}"

#: src/pages/assetLens/components/tabs/imagesTabComponents/ImageComparisonView.tsx
msgid "Error loading image"
msgstr "Error loading image"

#: src/features/copcPointClouds/CopcSurfaceControl.tsx
msgid "Error loading surface: {error}"
msgstr "Error loading surface: {error}"

#: src/pages/details/extensions/flow/assetModelEditorExt/AssetModelEditorRawJSON.tsx
msgid ""
"Error parsing JSON before patching! Error below:\n"
"\n"
"{error}"
msgstr ""
"Error parsing JSON before patching! Error below:\n"
"\n"
"{error}"

#: src/features/auth/vendors/Auth0Provider.tsx
#: src/features/auth/vendors/CognitoLoginScreen.tsx
#: src/features/auth/vendors/KeycloakLoginScreen.tsx
msgid "Error: {errorDetail}"
msgstr "Error: {errorDetail}"

#: src/features/chatbot/components/SessionHeaderBar.tsx
msgid "Error: {text}"
msgstr "Error: {text}"

#: src/pages/processData/components/helpGuide/HelpGuideChapters.tsx
msgid "Esc"
msgstr "Esc"

#: src/features/modelOperations/SubjectDetails.tsx
msgid "escalation tier {tier}"
msgstr "escalation tier {tier}"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
#: src/features/knowledgeDocumentViewer/workOrders/workOrderFields.ts
msgid "Estimate at approval: labor cost"
msgstr "Estimate at approval: labor cost"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
#: src/features/knowledgeDocumentViewer/workOrders/workOrderFields.ts
msgid "Estimate at approval: labor hours"
msgstr "Estimate at approval: labor hours"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
#: src/features/knowledgeDocumentViewer/workOrders/workOrderFields.ts
msgid "Estimate at approval: material cost"
msgstr "Estimate at approval: material cost"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
#: src/features/knowledgeDocumentViewer/workOrders/workOrderFields.ts
msgid "Estimate at approval: service cost"
msgstr "Estimate at approval: service cost"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
#: src/features/knowledgeDocumentViewer/workOrders/workOrderFields.ts
msgid "Estimate at approval: tool cost"
msgstr "Estimate at approval: tool cost"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
#: src/features/knowledgeDocumentViewer/workOrders/workOrderFields.ts
msgid "Estimated duration (hours)"
msgstr "Estimated duration (hours)"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
#: src/features/knowledgeDocumentViewer/workOrders/workOrderFields.ts
msgid "Estimated labor cost"
msgstr "Estimated labor cost"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
#: src/features/knowledgeDocumentViewer/workOrders/workOrderFields.ts
msgid "Estimated labor hours"
msgstr "Estimated labor hours"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
#: src/features/knowledgeDocumentViewer/workOrders/workOrderFields.ts
msgid "Estimated material cost"
msgstr "Estimated material cost"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
#: src/features/knowledgeDocumentViewer/workOrders/workOrderFields.ts
msgid "Estimated service cost"
msgstr "Estimated service cost"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
#: src/features/knowledgeDocumentViewer/workOrders/workOrderFields.ts
msgid "Estimated tool cost"
msgstr "Estimated tool cost"

#: src/pages/processData/buildMode/dock/BandsDockTab.tsx
msgid "Estimator"
msgstr "Estimator"

#: src/pages/processData/buildMode/dock/EvalLabelTable.tsx
msgid "eval as"
msgstr "eval as"

#: src/pages/processData/buildMode/components/BuildDock.tsx
msgid "Evals"
msgstr "Evals"

#: src/features/timeSeries/sentinelStudio/SentinelBuilderPanel.tsx
#: src/features/timeSeries/sentinelStudio/SentinelBuilderPanel.tsx
msgid "Evaluate"
msgstr "Evaluate"

#: src/features/timeSeries/agentTab/dock/AlertingTab.tsx
msgid "Evaluate now"
msgstr "Evaluate now"

#: src/features/timeSeries/sentinelStudio/SentinelBuilderPanel.tsx
msgid "Evaluating reads the fitted residuals off the run, so it needs a finished one."
msgstr "Evaluating reads the fitted residuals off the run, so it needs a finished one."

#: src/features/timeSeries/agentTab/dock/AlertingTab.tsx
#: src/features/timeSeries/sentinelStudio/SentinelBuilderPanel.tsx
msgid "Evaluating…"
msgstr "Evaluating…"

#: src/pages/processData/buildMode/dock/EvalLabelTable.tsx
msgid "Evaluation kind for {value77_57}"
msgstr "Evaluation kind for {value77_57}"

#: src/features/navbar/profileAndSettings/ProfileAndSettingsSidebar.tsx
#: src/features/navbar/profileAndSettings/ProfileAndSettingsTopBar.tsx
#: src/pages/evaluations/EvaluationsPage.tsx
#: src/pages/evaluations/EvaluationsPage.tsx
#: src/pages/evaluations/metadata/dashboard/components/dataLabeling/DataLabelingDashboardBreadcrumb.tsx
msgid "Evaluations"
msgstr "Evaluations"

#: src/pages/assetLens/components/tabs/canvas/AnalysisState.tsx
msgid "Events"
msgstr "Events"

#: src/pages/facilityModel/SentinelOverviewPage.tsx
msgid "Every {cadenceMinutes} min"
msgstr "Every {cadenceMinutes} min"

#: src/pages/processData/buildMode/rightPanel/PromoteModelAction.tsx
msgid "Every {value138_39}"
msgstr "Every {value138_39}"

#: src/features/sentinels/components/MonitorTab.tsx
msgid "Every 5 min"
msgstr "Every 5 min"

#: src/features/timeSeries/agentTab/dock/AlertingTab.tsx
msgid "every 6 hours"
msgstr "every 6 hours"

#: src/features/sentinels/components/MonitorTab.tsx
msgid "Every hour"
msgstr "Every hour"

#: src/pages/processData/components/helpGuide/HelpGuideChapters.tsx
msgid "Every plotted tag becomes a pen. "
msgstr "Every plotted tag becomes a pen. "

#: src/features/fimReview/subjectDecisionBuilders.ts
msgid "Every Subject needs a source record."
msgstr "Every Subject needs a source record."

#: src/features/timeSeries/components/panes/TagConfigurationPane.tsx
msgid "Every tag comes off the chart. The view itself is not deleted."
msgstr "Every tag comes off the chart. The view itself is not deleted."

#: src/features/timeSeries/agentTab/dock/useModelDraft.ts
msgid "every window needs a start before its end"
msgstr "every window needs a start before its end"

#: src/features/fimReview/ReviewActions.tsx
msgid "Everything looks right"
msgstr "Everything looks right"

#: src/features/mdCases/components/ProvenanceContentViewer.tsx
msgid "Evidence ({evidenceCount})"
msgstr "Evidence ({evidenceCount})"

#: src/features/fimReview/SubjectDiagnostics.tsx
msgid "Evidence against"
msgstr "Evidence against"

#: src/features/fimReview/SubjectDiagnostics.tsx
msgid "Evidence for"
msgstr "Evidence for"

#: src/features/timeSeries/experiment/TransparencyStrip.tsx
msgid "Exact overlap with target:"
msgstr "Exact overlap with target:"

#: src/pages/processData/buildMode/components/WindowDrawToolButtons.tsx
msgid "Excl"
msgstr "Excl"

#: src/pages/processData/buildMode/components/OnOffToggle.tsx
msgid "Exclude {subject}"
msgstr "Exclude {subject}"

#: src/pages/metrics/Metrics.tsx
msgid "Exclude Gecko searches"
msgstr "Exclude Gecko searches"

#: src/pages/metrics/Metrics.tsx
msgid "Exclude org-level searches"
msgstr "Exclude org-level searches"

#: src/features/timeSeries/agentTab/dock/WindowsTab.tsx
msgid "Excluded — ignored entirely"
msgstr "Excluded — ignored entirely"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatInspectionCard.tsx
msgid "Excluded bins"
msgstr "Excluded bins"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatInspectionCard.tsx
msgid "Excluded cells have no finite calculated result. This is not an inspection coverage percentage."
msgstr "Excluded cells have no finite calculated result. This is not an inspection coverage percentage."

#: src/pages/evaluations/metadata/dashboard/components/dataLabeling/DataLabelingDashboardFieldDrilldown.tsx
msgid "Excluded pages: {excludedLabel} (both values blank or no active output)."
msgstr "Excluded pages: {excludedLabel} (both values blank or no active output)."

#: src/features/timeSeries/components/PenTransformControls.tsx
msgid "Excluded points are marked with a red x. Other pens keep every sample."
msgstr "Excluded points are marked with a red x. Other pens keep every sample."

#: src/features/timeSeries/agentTab/dock/WindowsTab.tsx
msgid "Excluded rows leave the model completely — neither learned from nor graded. That is the difference from the gate, which is about fair operating conditions rather than untrustworthy periods."
msgstr "Excluded rows leave the model completely — neither learned from nor graded. That is the difference from the gate, which is about fair operating conditions rather than untrustworthy periods."

#: src/features/knowledgeDocumentViewer/components/table/enhancements/BulkEditModal.tsx
msgid "Execute Action"
msgstr "Execute Action"

#: src/features/modelOperations/SubjectDetails.tsx
#: src/pages/facilityModel/SubjectDetailPage.tsx
msgid "Existence confidence"
msgstr "Existence confidence"

#: src/features/fimEvidence/SubjectGlyphs.tsx
#: src/features/modelOperations/Corroboration.tsx
msgid "existence confidence {confidence}"
msgstr "existence confidence {confidence}"

#: src/features/kestrelUpload/KestrelModelUploadSection.tsx
msgid "Existing 3D asset files"
msgstr "Existing 3D asset files"

#: src/features/fimReview/InspectSources.tsx
msgid "Exists"
msgstr "Exists"

#: src/features/fimReview/InspectSources.tsx
msgid "Exists and connected"
msgstr "Exists and connected"

#: src/features/knowledgeDocumentViewer/components/photoMode/PhotoModeHeader.tsx
msgid "Exit"
msgstr "Exit"

#: src/features/knowledgeDocumentViewer/components/toolbar/DocumentFullscreenOverlay.tsx
#: src/features/knowledgeDocumentViewer/components/toolbar/DocumentFullscreenOverlay.tsx
#: src/features/knowledgeDocumentViewer/components/viewer/shared/ZoomControls.tsx
msgid "Exit fullscreen"
msgstr "Exit fullscreen"

#: src/features/knowledgeDocumentViewer/components/toolbar/KnowledgeDocumentHeaderBar.tsx
msgid "Exit labeling mode"
msgstr "Exit labeling mode"

#: src/pages/details/visualization/tools/ScreenshotModeToggle.tsx
msgid "Exit screenshot mode"
msgstr "Exit screenshot mode"

#: src/features/timeSeries/components/panes/TagFilterControls.tsx
msgid "Exp"
msgstr "Exp"

#: src/features/timeSeries/components/rulerTool/RulerMetricsPanel.tsx
msgid "Expand"
msgstr "Expand"

#: src/features/knowledgeDocumentViewer/components/revisionCompare/RevisionChangeCropPair.tsx
msgid "Expand {caption}"
msgstr "Expand {caption}"

#: src/features/lotoReports/components/LotoIsolationPointsTable.tsx
msgid "Expand all"
msgstr "Expand all"

#: src/features/assetVizAdapter/forecastAssetVizWindow/ForecastAssetVizWindowSurface.tsx
msgid "Expand asset viewer"
msgstr "Expand asset viewer"

#: src/features/knowledgeDocumentViewer/components/table/TableBodyRow.tsx
msgid "Expand row"
msgstr "Expand row"

#: src/features/timeSeries/components/panes/TagBrowserPane.tsx
#: src/features/timeSeries/components/panes/TagBrowserPane.tsx
#: src/pages/processData/components/helpGuide/HelpGuideChapters.tsx
msgid "Expanded search"
msgstr "Expanded search"

#: src/features/timeSeries/agentTab/dock/TargetTab.tsx
msgid "expected"
msgstr "expected"

#: src/features/mdCases/components/CaseStorySection.tsx
msgid "Expected-range band scored over the visible window · snapshot values on each alert are authoritative."
msgstr "Expected-range band scored over the visible window · snapshot values on each alert are authoritative."

#: src/features/timeSeries/components/ScatterplotSidebar.tsx
msgid "Experiment"
msgstr "Experiment"

#: src/features/timeSeries/experiment/ExperimentTab.tsx
msgid "experiment name"
msgstr "experiment name"

#: src/features/knowledgeDocumentViewer/components/bugReport/BugReportAgentModeField.tsx
msgid "Explain the problem and propose options."
msgstr "Explain the problem and propose options."

#: src/features/mdCases/components/ProvenanceContentViewer.tsx
#: src/features/mdCases/components/ProvenanceContentViewer.tsx
msgid "Explanation"
msgstr "Explanation"

#: src/features/navbar/navConfig.ts
msgid "Explorer"
msgstr "Explorer"

#: src/features/timeSeries/experiment/RunComparison.tsx
msgid "Export"
msgstr "Export"

#: src/pages/assetLens/components/tabs/AnomalyDashboard.tsx
msgid "Export Data"
msgstr "Export Data"

#: src/features/timeSeries/components/chartActions/ExportPngButton.tsx
#: src/features/timeSeries/components/chartActions/ExportPngButton.tsx
#: src/features/timeSeries/components/chartActions/ExportPngButton.tsx
#: src/pages/processData/components/helpGuide/HelpGuideChapters.tsx
msgid "Export PNG"
msgstr "Export PNG"

#: src/features/timeSeries/agentTab/dock/VersionsTab.tsx
msgid "expression"
msgstr "expression"

#: src/features/timeSeries/components/RegressionPrediction.tsx
msgid "Extend to date"
msgstr "Extend to date"

#: src/pages/evaluations/metadata/dashboard/components/dataLabeling/DataLabelingDashboardComparisonTable.tsx
msgid "Extracted (active config)"
msgstr "Extracted (active config)"

#: src/features/navbar/navConfig.ts
#: src/pages/facilityModel/FacilityModelCatalog.tsx
msgid "Facility Model"
msgstr "Facility Model"

#: src/pages/facilityModel/FacilityModelCatalog.tsx
msgid "Facility model presets"
msgstr "Facility model presets"

#: src/features/mdCases/components/ProvenanceContentViewer.tsx
msgid "Facility type"
msgstr "Facility type"

#: src/features/facilityModel/views.ts
#: src/features/powerCustomerUploads/components/PowerCustomerUploadHistoryPanel.tsx
#: src/features/powerCustomerUploads/components/powerCustomerUploadHistoryPresentation.ts
msgid "Failed"
msgstr "Failed"

#: src/features/sentinels/components/SentinelList.tsx
msgid "failed · "
msgstr "failed · "

#: src/features/knowledgeDocumentViewer/hooks/useAppendDocumentPageMetadataUserEditComment.ts
msgid "Failed to add comment"
msgstr "Failed to add comment"

#: src/pages/cases/md/MdCasesListPage.tsx
msgid "Failed to archive case: {reason}"
msgstr "Failed to archive case: {reason}"

#: src/features/cases/components/CreateCaseModal.tsx
msgid "Failed to create case: {error}"
msgstr "Failed to create case: {error}"

#: src/pages/cases/md/MdCasesListPage.tsx
msgid "Failed to create case: {reason}"
msgstr "Failed to create case: {reason}"

#: src/pages/cases/components/CasesTable.tsx
msgid "Failed to create new case"
msgstr "Failed to create new case"

#: src/features/timeSeries/components/timeSeriesScatterplot/MdDraftAlertCaseFlow.tsx
msgid "Failed to delete alert: {value281_53}"
msgstr "Failed to delete alert: {value281_53}"

#: src/pages/cases/md/MdCasesListPage.tsx
msgid "Failed to delete case: {reason}"
msgstr "Failed to delete case: {reason}"

#: src/features/timeSeries/components/labelTool/useLabelTool.ts
msgid "Failed to delete label: {value376_53}"
msgstr "Failed to delete label: {value376_53}"

#: src/features/timeSeries/components/LabelsTab.tsx
msgid "Failed to delete label: {value536_39}"
msgstr "Failed to delete label: {value536_39}"

#: src/features/kestrelUpload/KestrelModelUploadSection.tsx
msgid "Failed to delete model files: {errorMessage}"
msgstr "Failed to delete model files: {errorMessage}"

#: src/features/sentinels/hooks/useDeleteSentinel.ts
msgid "Failed to delete sentinel"
msgstr "Failed to delete sentinel"

#: src/pages/processData/components/viewSwitcher/ViewActionDialogs.tsx
msgid "Failed to delete view: {error}"
msgstr "Failed to delete view: {error}"

#: src/features/knowledgeDocumentViewer/hooks/useInstrumentTimeSeriesData.ts
msgid "Failed to fetch data"
msgstr "Failed to fetch data"

#: src/pages/alerts/components/AlertTimeSeriesChart.tsx
msgid "Failed to fetch time series data"
msgstr "Failed to fetch time series data"

#: src/pages/details/extensions/fde/ffsLtaGeneration/FfsLtaGenerationSidebar.tsx
msgid "Failed to generate Local Thin Areas. Please try again."
msgstr "Failed to generate Local Thin Areas. Please try again."

#: src/features/timeSeries/components/SentinelsTab.tsx
msgid "Failed to load drivers."
msgstr "Failed to load drivers."

#: src/features/richText/nodes/ImageNode.tsx
msgid "Failed to load image"
msgstr "Failed to load image"

#: src/features/forecastNotifications/NotificationListPanel.tsx
#: src/features/forecastNotifications/NotificationsDropdownContent.tsx
msgid "Failed to load notifications"
msgstr "Failed to load notifications"

#: src/features/timeSeries/components/SentinelsTab.tsx
msgid "Failed to load: "
msgstr "Failed to load: "

#: src/features/mdCases/components/ProvenanceContentViewer.tsx
#: src/pages/facilityModel/SentinelDetailPage.tsx
msgid "Failed to load: {error}"
msgstr "Failed to load: {error}"

#: src/pages/processData/components/viewSwitcher/ViewActionDialogs.tsx
msgid "Failed to rename view: {error}"
msgstr "Failed to rename view: {error}"

#: src/features/timeSeries/ScatterplotContext.tsx
msgid "Failed to resolve chart {chartID}: {value433_65}"
msgstr "Failed to resolve chart {chartID}: {value433_65}"

#: src/features/richText/components/TaggableUsersCard.tsx
msgid "Failed to save allowed users list"
msgstr "Failed to save allowed users list"

#: src/pages/cases/components/EditableCaseTitle.tsx
msgid "Failed to save case title"
msgstr "Failed to save case title"

#: src/features/timeSeries/hooks/useChartSave.ts
msgid "Failed to save chart: {err}"
msgstr "Failed to save chart: {err}"

#: src/features/knowledgeDocumentViewer/hooks/useSaveDocumentMetadataUserEdit.ts
msgid "Failed to save document metadata for all revisions. Confirm cantilever hosts exist."
msgstr "Failed to save document metadata for all revisions. Confirm cantilever hosts exist."

#: src/features/knowledgeDocumentViewer/hooks/useSaveDocumentMetadataUserEdit.ts
msgid "Failed to save document metadata. Confirm cantilever hosts exist for this document."
msgstr "Failed to save document metadata. Confirm cantilever hosts exist for this document."

#: src/pages/cases/components/CaseFeedbackModal.tsx
msgid "Failed to save feedback: {errorMessage}"
msgstr "Failed to save feedback: {errorMessage}"

#: src/features/timeSeries/components/labelTool/useLabelTool.ts
msgid "Failed to save label range: {value261_57}"
msgstr "Failed to save label range: {value261_57}"

#: src/features/timeSeries/components/labelTool/useLabelTool.ts
msgid "Failed to save label: {value337_53}"
msgstr "Failed to save label: {value337_53}"

#: src/features/timeSeries/components/labelTool/useLabelTool.ts
msgid "Failed to save label: {value358_53}"
msgstr "Failed to save label: {value358_53}"

#: src/features/knowledgeDocumentViewer/hooks/useSaveDocumentPageMetadataUserEdit.ts
msgid "Failed to save page metadata for all revisions. Confirm cantilever hosts exist."
msgstr "Failed to save page metadata for all revisions. Confirm cantilever hosts exist."

#: src/features/knowledgeDocumentViewer/hooks/useSaveDocumentPageMetadataUserEdit.ts
msgid "Failed to save page metadata. Confirm cantilever hosts exist for this page."
msgstr "Failed to save page metadata. Confirm cantilever hosts exist for this page."

#: src/pages/site/contexts/SiteUXLayer.tsx
#: src/pages/site/contexts/SiteUXLayer.tsx
msgid "Failed to save site"
msgstr "Failed to save site"

#: src/features/knowledgeDocumentViewer/contexts/DocumentTabDataContext.tsx
msgid "Failed to save to Rolodex"
msgstr "Failed to save to Rolodex"

#: src/features/chatbot/components/ChatbotHelpModal.tsx
msgid "Failed to send support request: {error}"
msgstr "Failed to send support request: {error}"

#: src/pages/cases/md/MdCasesListPage.tsx
msgid "Failed to shelve case: {reason}"
msgstr "Failed to shelve case: {reason}"

#: src/pages/assetLens/components/tabs/AnomalyDashboard.tsx
msgid "Failed to update anomaly status"
msgstr "Failed to update anomaly status"

#: src/features/knowledgeDocumentViewer/hooks/useSaveDocumentMetadataUserEdit.ts
msgid "Failed to update Document Details for all revisions. Confirm cantilever hosts exist."
msgstr "Failed to update Document Details for all revisions. Confirm cantilever hosts exist."

#: src/features/knowledgeDocumentViewer/contexts/KnowledgeDocumentDataContext.tsx
msgid "Failed to update document metadata"
msgstr "Failed to update document metadata"

#: src/features/knowledgeDocumentViewer/hooks/useSaveDocumentPageMetadataUserEdit.ts
msgid "Failed to update Page Details for all revisions. Confirm cantilever hosts exist."
msgstr "Failed to update Page Details for all revisions. Confirm cantilever hosts exist."

#: src/pages/overview/sidebar/capexOutlook/SiteViewCapExOutlookMenu.tsx
msgid "Failed to update site config."
msgstr "Failed to update site config."

#: src/pages/assetLens/components/tabs/DocumentsTab.tsx
#: src/pages/assetLens/components/tabs/DocumentsTab.tsx
msgid "Failed to upload document"
msgstr "Failed to upload document"

#: src/features/richText/components/ToolbarPlugin.tsx
#: src/features/richText/editorPlugins/DragDropPastePlugin.tsx
msgid "Failed to upload image"
msgstr "Failed to upload image"

#: src/features/mdCases/components/ProvenanceContentViewer.tsx
msgid "Failure mode · Unit: {unitSlug}"
msgstr "Failure mode · Unit: {unitSlug}"

#: src/features/mdCases/components/ProvenanceContentViewer.tsx
msgid "Failure modes"
msgstr "Failure modes"

#: src/pages/assetLens/components/tabs/AnomalyDashboard.tsx
msgid "False Positive"
msgstr "False Positive"

#: src/pages/assetLens/components/tabs/SensorIssuesTab.tsx
msgid "Fault detected."
msgstr "Fault detected."

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/LandingScrollSections.tsx
msgid "FAVORITES"
msgstr "FAVORITES"

#: src/features/knowledgeDocumentViewer/components/bugReport/BugReportTypeField.tsx
msgid "Feature"
msgstr "Feature"

#: src/features/knowledgeDocumentViewer/components/bugReport/DocumentsBugReportButton.tsx
msgid "Feature request details"
msgstr "Feature request details"

#: src/features/timeSeries/experiment/ModelKnobs.tsx
#: src/pages/processData/buildMode/components/BuildDock.tsx
msgid "Features"
msgstr "Features"

#: src/pages/processData/components/helpGuide/HelpGuideChapters.tsx
msgid "Feedback"
msgstr "Feedback"

#: src/pages/processData/components/helpGuide/HelpGuideChapters.tsx
msgid "Feedback and Requests"
msgstr "Feedback and Requests"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatFeedbackDialog.tsx
msgid "Feedback details"
msgstr "Feedback details"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatFeedbackDialog.tsx
msgid "Feedback reasons"
msgstr "Feedback reasons"

#: src/pages/cases/components/CaseFeedbackModal.tsx
msgid "Feedback saved"
msgstr "Feedback saved"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatFeedbackButton.tsx
#: src/features/knowledgeDocumentViewer/components/sidebar/FeedbackModal.tsx
msgid "Feedback sent"
msgstr "Feedback sent"

#: src/features/timeSeries/components/PenTransformControls.tsx
msgid "Fetched on the same bucket grid the models train on, drawn stepped."
msgstr "Fetched on the same bucket grid the models train on, drawn stepped."

#: src/pages/cases/md/MdCaseReferenceSparklinePreview.tsx
msgid "Fetching data around alert"
msgstr "Fetching data around alert"

#: src/features/knowledgeDocumentViewer/components/viewer/shared/SparklineTooltipContent.tsx
msgid "Fetching live data"
msgstr "Fetching live data"

#: src/pages/evaluations/metadata/dashboard/components/dataLabeling/DataLabelingDashboardComparisonTable.tsx
#: src/pages/evaluations/metadata/dashboard/components/dataLabeling/DataLabelingDashboardDisagreementFilters.tsx
#: src/pages/evaluations/metadata/dashboard/components/dataLabeling/DataLabelingDashboardDisagreementFilters.tsx
msgid "Field"
msgstr "Field"

#: src/features/timeSeries/agentTab/chat/BuildCard.tsx
msgid "field fit · baseline {baselineStart} → {baselineEnd} · gate {gate} · drivers {drivers}"
msgstr "field fit · baseline {baselineStart} → {baselineEnd} · gate {gate} · drivers {drivers}"

#: src/pages/evaluations/metadata/dashboard/components/dataLabeling/DataLabelingDashboardFieldDrilldown.tsx
#: src/pages/evaluations/metadata/dashboard/components/dataLabeling/DataLabelingDashboardOverview.tsx
#: src/pages/evaluations/metadata/dashboard/components/dataLabeling/DataLabelingDashboardSummaryCards.tsx
msgid "Field mismatches vs pipeline"
msgstr "Field mismatches vs pipeline"

#: src/pages/site/components/CustomFieldsTableColumns.tsx
#: src/pages/site/forms/customFieldInfoFormFields.ts
msgid "Field Name"
msgstr "Field Name"

#: src/features/knowledgeDocumentViewer/components/table/enhancements/BulkActionModalEditConfiguration.tsx
msgid "Field to Edit"
msgstr "Field to Edit"

#: src/features/mdCases/components/ProvenanceContentViewer.tsx
msgid "Fields"
msgstr "Fields"

#: src/features/chatbot/components/CitationTooltip.tsx
#: src/pages/assetLens/components/tabs/DocumentsTab.tsx
#: src/pages/site/components/SiteFilesTableCard.tsx
msgid "File"
msgstr "File"

#: src/features/chatbot/components/ChatbotHelpModal.tsx
msgid "File a Help Request to Cantilever AI"
msgstr "File a Help Request to Cantilever AI"

#: src/features/richText/editorPlugins/DragDropPastePlugin.tsx
msgid "File must be smaller than {MAX_FILE_SIZE_MB}MB"
msgstr "File must be smaller than {MAX_FILE_SIZE_MB}MB"

#: src/features/richText/components/ToolbarPlugin.tsx
msgid "File must be smaller than {maxSizeInMB}MB"
msgstr "File must be smaller than {maxSizeInMB}MB"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/documentsCardView/documentCardFilterBar/types.ts
#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/documentsTableView/DocumentTableColumns.tsx
msgid "File Name"
msgstr "File Name"

#: src/pages/details/extensions/flow/filesExt/FileMenuButton.tsx
msgid "File options for {fileName}"
msgstr "File options for {fileName}"

#: src/pages/assetLens/components/tabs/imagesTabComponents/ImageUploadModal.tsx
msgid "File Required"
msgstr "File Required"

#: src/pages/assetLens/components/tabs/imagesTabComponents/ImageUploadModal.tsx
msgid "File Too Large"
msgstr "File Too Large"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/documentPreview/PreviewDocumentDetailsSection.tsx
msgid "File Type"
msgstr "File Type"

#: src/features/richText/components/ToolbarPlugin.tsx
#: src/features/richText/editorPlugins/DragDropPastePlugin.tsx
msgid "File type not accepted. Please upload: {acceptedList}"
msgstr "File type not accepted. Please upload: {acceptedList}"

#: src/features/powerCustomerUploads/state/powerCustomerUploadApprovalResponseMapping.ts
msgid "File with that name already exists."
msgstr "File with that name already exists."

#: src/features/powerCustomerUploads/components/PowerCustomerUploadHistoryPanel.tsx
#: src/pages/details/extensions/flow/FilesExtension.tsx
msgid "Files"
msgstr "Files"

#: src/features/fim/assetInventory.ts
msgid "Fill failed"
msgstr "Fill failed"

#: src/pages/processData/buildMode/dock/EngineeringSection.tsx
msgid "Fill limit"
msgstr "Fill limit"

#: src/features/fim/assetInventory.ts
msgid "Fill queued"
msgstr "Fill queued"

#: src/features/fim/assetInventory.ts
msgid "Fill stale"
msgstr "Fill stale"

#: src/features/facilityModel/columns.ts
#: src/pages/facilityModel/FacilityModelFilters.tsx
#: src/pages/facilityModel/SubjectAssetPanel.tsx
msgid "Fill status"
msgstr "Fill status"

#: src/pages/facilityModel/SubjectAssetPanel.tsx
msgid "Filled at"
msgstr "Filled at"

#: src/pages/facilityModel/SubjectAssetPanel.tsx
msgid "Filled slots"
msgstr "Filled slots"

#: src/features/fim/assetInventory.ts
msgid "Filling"
msgstr "Filling"

#: src/features/timeSeries/components/PenTransformControls.tsx
msgid "Filter"
msgstr "Filter"

#: src/features/knowledgeDocumentViewer/components/table/cells/HeaderCell.tsx
msgid "Filter {cellText}"
msgstr "Filter {cellText}"

#: src/features/knowledgeDocumentViewer/components/table/cells/HeaderCell.tsx
#: src/features/knowledgeDocumentViewer/components/table/enhancements/filters/StringFilter.tsx
msgid "Filter {columnHeaderLower}..."
msgstr "Filter {columnHeaderLower}..."

#: src/pages/metrics/components/FilterPopover.tsx
msgid "Filter {label}…"
msgstr "Filter {label}…"

#: src/pages/systemView/components/unitsTab/FilterControls.tsx
msgid "Filter By"
msgstr "Filter By"

#: src/features/timeSeries/components/LabelsTab.tsx
msgid "Filter by {value618_41} group"
msgstr "Filter by {value618_41} group"

#: src/features/timeSeries/agentTab/ModelPicker.tsx
msgid "Filter by name or KPI…"
msgstr "Filter by name or KPI…"

#: src/features/timeSeries/components/AllTagsTab.tsx
msgid "Filter by source"
msgstr "Filter by source"

#: src/features/timeSeries/components/LabelsTab.tsx
msgid "Filter by ungrouped"
msgstr "Filter by ungrouped"

#: src/features/timeSeries/agentTab/ModelPicker.tsx
msgid "Filter models"
msgstr "Filter models"

#: src/features/forecastNotifications/NotificationListPanel.tsx
msgid "Filter notifications..."
msgstr "Filter notifications..."

#: src/pages/facilityModel/FacilityModelFilters.tsx
msgid "Filter the facility model"
msgstr "Filter the facility model"

#: src/features/timeSeries/components/PenTransformControls.tsx
msgid "Filter this pen"
msgstr "Filter this pen"

#: src/features/powerCustomerUploads/components/PowerCustomerUploadHistoryPanel.tsx
msgid "Filter upload history"
msgstr "Filter upload history"

#: src/features/powerCustomerUploads/components/PowerCustomerUploadHistoryPanel.tsx
msgid "Filter upload history (active)"
msgstr "Filter upload history (active)"

#: src/features/timeSeries/components/PenTransformControls.tsx
msgid "Filter upper value"
msgstr "Filter upper value"

#: src/features/timeSeries/components/PenTransformControls.tsx
msgid "Filter value"
msgstr "Filter value"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/documentsCardView/documentCardFilterBar/TextFilterField.tsx
msgid "Filter..."
msgstr "Filter..."

#: src/pages/facilityModel/FacilityModelFilters.tsx
msgid "Filters"
msgstr "Filters"

#: src/features/navbar/navConfig.ts
#: src/pages/metrics/Metrics.tsx
msgid "FIM Metrics"
msgstr "FIM Metrics"

#: src/features/knowledgeDocumentViewer/components/toolbar/KnowledgeDocumentHeaderBar.tsx
#: src/features/knowledgeDocumentViewer/components/viewer/search/IntraDocSearchBar.tsx
#: src/features/knowledgeDocumentViewer/workOrders/WorkOrderViewer.tsx
#: src/features/knowledgeDocumentViewer/workOrders/WorkOrderViewer.tsx
#: src/features/knowledgeDocumentViewer/workOrders/WorkOrderViewer.tsx
msgid "Find in document"
msgstr "Find in document"

#: src/features/knowledgeDocumentViewer/components/toolbar/KnowledgeDocumentHeaderBar.tsx
msgid "Find in document (Ctrl+F)"
msgstr "Find in document (Ctrl+F)"

#: src/features/knowledgeDocumentViewer/components/viewer/search/IntraDocSearchBar.tsx
#: src/features/knowledgeDocumentViewer/workOrders/WorkOrderViewer.tsx
msgid "Find in document..."
msgstr "Find in document..."

#: src/pages/processData/buildMode/rightPanel/SavedModelShelf.tsx
msgid "Find models…"
msgstr "Find models…"

#: src/pages/processData/components/helpGuide/HelpGuideChapters.tsx
#: src/pages/processData/components/helpGuide/HelpGuideChapters.tsx
msgid "Find Tags"
msgstr "Find Tags"

#: src/features/timeSeries/components/panes/TagBrowserList.tsx
#: src/pages/processData/components/helpGuide/HelpGuideChapters.tsx
msgid "Find tags..."
msgstr "Find tags..."

#: src/pages/processData/components/viewSwitcher/ViewSwitcher.tsx
msgid "Find views..."
msgstr "Find views..."

#: src/features/knowledgeDocumentViewer/components/viewer/search/ConnectorLookupPanel.tsx
msgid "Finding destination…"
msgstr "Finding destination…"

#: src/features/knowledgeDocumentViewer/components/sidebar/CrossReferencePanel.tsx
msgid "Finding related documents…"
msgstr "Finding related documents…"

#: src/features/knowledgeDocumentViewer/hooks/useConnectorLookup.ts
msgid "Finding the destination timed out. Try again."
msgstr "Finding the destination timed out. Try again."

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatRevisionMissingCard.tsx
msgid "Findings are unavailable for this drawing."
msgstr "Findings are unavailable for this drawing."

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatInspectionCard.tsx
msgid "Finite result bins"
msgstr "Finite result bins"

#: src/features/mdCases/components/ProvenanceContentViewer.tsx
#: src/features/mdCases/components/ProvenanceContentViewer.tsx
msgid "Fired {firedAt}"
msgstr "Fired {firedAt}"

#: src/features/timeSeries/agentTab/dock/BacktestTab.tsx
msgid "first breach"
msgstr "first breach"

#: src/features/knowledgeDocumentViewer/components/bugReport/BugReportPriorityField.tsx
msgid "First thing during working hours."
msgstr "First thing during working hours."

#: src/features/lotoReports/components/LotoReportEditorHeader.tsx
msgid "Fit"
msgstr "Fit"

#: src/features/facilityModel/components/ReferencePreviewPanel.tsx
#: src/features/facilityModel/components/ReferencePreviewPanel.tsx
msgid "Fit page"
msgstr "Fit page"

#: src/features/timeSeries/components/RegressionPrediction.tsx
msgid "Fit regression models and predict future values"
msgstr "Fit regression models and predict future values"

#: src/pages/processData/buildMode/dock/ModelDockTab.tsx
#: src/pages/processData/buildMode/dock/ModelDockTab.tsx
msgid "Fit row cap"
msgstr "Fit row cap"

#: src/features/timeSeries/agentTab/toolSentence.ts
msgid "Fitted {kpi}"
msgstr "Fitted {kpi}"

#: src/features/timeSeries/sentinelStudio/SentinelBuilderPanel.tsx
msgid "Fitted and saved"
msgstr "Fitted and saved"

#: src/features/timeSeries/agentTab/toolSentence.ts
msgid "Fitted the model"
msgstr "Fitted the model"

#: src/features/timeSeries/agentTab/toolSentence.ts
msgid "Fitting {kpi}"
msgstr "Fitting {kpi}"

#: src/features/timeSeries/agentTab/toolSentence.ts
msgid "Fitting the model"
msgstr "Fitting the model"

#: src/pages/processData/buildMode/dock/BacktestDockTab.tsx
msgid "flagged points"
msgstr "flagged points"

#: src/pages/processData/buildMode/dock/BandsDockTab.tsx
msgid "Flags fire when |actual − expected| leaves band k × the calibrated residual scale. Wider k = fewer, bigger flags."
msgstr "Flags fire when |actual − expected| leaves band k × the calibrated residual scale. Wider k = fewer, bigger flags."

#: src/pages/processData/buildMode/dock/BacktestDockTab.tsx
msgid "Flags over the range"
msgstr "Flags over the range"

#: src/features/navbar/navConfig.ts
msgid "Fleet Analysis"
msgstr "Fleet Analysis"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/AgenticChatPage.tsx
#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/AgenticChatPage.tsx
msgid "Float the chat over the preview"
msgstr "Float the chat over the preview"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/FloatingChatWindow.tsx
msgid "Floating chat"
msgstr "Floating chat"

#: src/features/lotoReports/components/LotoIsolationPointRow.tsx
msgid "Focus {tag} on the drawing"
msgstr "Focus {tag} on the drawing"

#: src/features/powerCustomerUploads/components/PowerCustomerUploadHistoryPanel.tsx
msgid "Folders"
msgstr "Folders"

#: src/features/knowledgeDocumentViewer/components/DocumentTabContent.tsx
msgid "Followed connector to {destination} page {destinationPage}"
msgstr "Followed connector to {destination} page {destinationPage}"

#: src/features/powerCustomerUploads/components/PowerCustomerUploadSelection.tsx
msgid "For best performance, upload folders with fewer than 10,000 files. Compress larger folders into a ZIP before uploading."
msgstr "For best performance, upload folders with fewer than 10,000 files. Compress larger folders into a ZIP before uploading."

#: src/features/timeSeries/experiment/knobCopy.ts
msgid "For tail-fraction splits: fraction of rows used as the “head” (usually train). Remainder is the tail (usually test)."
msgstr "For tail-fraction splits: fraction of rows used as the “head” (usually train). Remainder is the tail (usually test)."

#: src/features/knowledgeDocumentViewer/workOrders/workOrderSheet.ts
msgid "Forecast"
msgstr "Forecast"

#: src/features/navbar/navConfig.ts
#: src/pages/forgingsReporting/ForgingsReportingPage.tsx
msgid "Forgings Reporting"
msgstr "Forgings Reporting"

#: src/pages/forgingsReporting/ForgingsReportingPage.tsx
#: src/pages/forgingsReporting/ForgingsReportPage.tsx
msgid "Forgings reporting is not available for this site."
msgstr "Forgings reporting is not available for this site."

#: src/features/richText/components/ToolbarPlugin.tsx
msgid "Format"
msgstr "Format"

#: src/pages/assetLens/components/tabs/imagesTabComponents/ImageUploadModal.tsx
msgid "Format must be like \"1000-5000 Hz\""
msgstr "Format must be like \"1000-5000 Hz\""

#: src/features/knowledgeDocumentViewer/components/toolbar/KnowledgeDocumentHeaderBar.tsx
#: src/features/knowledgeDocumentViewer/workOrders/WorkOrderViewer.tsx
msgid "Forward"
msgstr "Forward"

#: src/pages/processData/buildMode/dock/EvalsDockTab.tsx
msgid "FP —"
msgstr "FP —"

#: src/pages/processData/buildMode/dock/CompareDockTab.tsx
msgid "FP/30d"
msgstr "FP/30d"

#: src/pages/details/extensions/flow/ImageryExtension.tsx
msgid "Frame:"
msgstr "Frame:"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
#: src/features/knowledgeDocumentViewer/workOrders/legacyCmmsRecordPdf.ts
msgid "Frequency"
msgstr "Frequency"

#: src/pages/assetLens/components/tabs/imagesTabComponents/ImageUploadModal.tsx
msgid "Frequency Range (Hz)"
msgstr "Frequency Range (Hz)"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
#: src/features/knowledgeDocumentViewer/workOrders/legacyCmmsRecordPdf.ts
msgid "Frequency unit"
msgstr "Frequency unit"

#: src/features/knowledgeDocumentViewer/components/revisionCompare/RevisionPairPicker.tsx
#: src/features/knowledgeDocumentViewer/components/toolbar/PageRangeControls.tsx
#: src/features/timeSeries/components/LabelsTab.tsx
msgid "From"
msgstr "From"

#: src/features/timeSeries/sentinelStudio/SentinelBuilderPanel.tsx
msgid "From an asset"
msgstr "From an asset"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
#: src/features/knowledgeDocumentViewer/workOrders/legacyCmmsRecordPdf.ts
msgid "From bin"
msgstr "From bin"

#: src/features/knowledgeDocumentViewer/graph/offPageConnectorTooltipRows.ts
msgid "From drawing"
msgstr "From drawing"

#: src/features/knowledgeDocumentViewer/components/revisionCompare/RevisionPairPicker.tsx
msgid "From revision"
msgstr "From revision"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
#: src/features/knowledgeDocumentViewer/workOrders/legacyCmmsRecordPdf.ts
msgid "From storeroom"
msgstr "From storeroom"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/ResponseSegmentInspectionChip.tsx
msgid "From the inspection analysis of this component."
msgstr "From the inspection analysis of this component."

#: src/features/copcPointClouds/CopcOrientationCube.tsx
msgid "Front"
msgstr "Front"

#: src/pages/processData/buildMode/dock/TagCleaningEditor.tsx
msgid "Frozen repeat limit"
msgstr "Frozen repeat limit"

#: src/pages/processData/buildMode/dock/TagCleaningEditor.tsx
msgid "Frozen repeats"
msgstr "Frozen repeats"

#: src/features/timeSeries/experiment/CleaningControls.tsx
msgid "Frozen sensor"
msgstr "Frozen sensor"

#: src/features/knowledgeDocumentViewer/components/viewer/shared/ZoomControls.tsx
msgid "Fullscreen"
msgstr "Fullscreen"

#: src/features/knowledgeDocumentViewer/components/toolbar/EvalSessionHeaderBar.tsx
#: src/features/knowledgeDocumentViewer/components/toolbar/EvalSessionHeaderBar.tsx
#: src/features/knowledgeDocumentViewer/components/toolbar/KnowledgeDocumentHeaderBar.tsx
#: src/features/knowledgeDocumentViewer/components/toolbar/KnowledgeDocumentHeaderBar.tsx
msgid "Fullscreen document"
msgstr "Fullscreen document"

#: src/features/timeSeries/sentinelStudio/SentinelBuilderPanel.tsx
msgid "Fully agentic — design, run and evaluate automatically"
msgstr "Fully agentic — design, run and evaluate automatically"

#: src/features/knowledgeDocumentViewer/components/bugReport/BugReportAgentModeField.tsx
msgid "Fully resolve"
msgstr "Fully resolve"

#: src/features/fimReview/IdentityPanel.tsx
msgid "func. location"
msgstr "func. location"

#: src/features/fimReview/InspectSources.tsx
msgid "Func. location"
msgstr "Func. location"

#: src/features/knowledgeDocumentViewer/graph/nodeTooltip.ts
msgid "Function"
msgstr "Function"

#: src/features/timeSeries/agentTab/dock/FitTab.tsx
msgid "ƒ marks a role the KPI expression uses."
msgstr "ƒ marks a role the KPI expression uses."

#: src/features/timeSeries/agentTab/dock/TargetTab.tsx
#: src/features/timeSeries/agentTab/dock/VersionsTab.tsx
msgid "gap (σ)"
msgstr "gap (σ)"

#: src/features/timeSeries/agentTab/chat/BuildCard.tsx
msgid "gap <0>{last30Gap}</0> ({last30Sigma}σ)"
msgstr "gap <0>{last30Gap}</0> ({last30Sigma}σ)"

#: src/features/timeSeries/agentTab/dock/FitTab.tsx
msgid "Gap by band of "
msgstr "Gap by band of "

#: src/features/timeSeries/experiment/SamplingKnobs.tsx
#: src/pages/processData/buildMode/dock/SamplingSection.tsx
#: src/pages/processData/buildMode/dock/SamplingSection.tsx
msgid "Gap fill"
msgstr "Gap fill"

#: src/features/timeSeries/agentTab/dock/VersionsTab.tsx
msgid "gate"
msgstr "gate"

#: src/pages/processData/buildMode/dock/TagCleaningEditor.tsx
msgid "Gate ceiling"
msgstr "Gate ceiling"

#: src/features/timeSeries/experiment/CleaningControls.tsx
msgid "Gate drops rows for every tag, not just this one."
msgstr "Gate drops rows for every tag, not just this one."

#: src/pages/processData/buildMode/dock/TagCleaningEditor.tsx
msgid "Gate floor"
msgstr "Gate floor"

#: src/pages/processData/buildMode/dock/TagCleaningEditor.tsx
msgid "Gate max"
msgstr "Gate max"

#: src/pages/processData/buildMode/dock/TagCleaningEditor.tsx
msgid "Gate min"
msgstr "Gate min"

#: src/features/timeSeries/experiment/CleaningControls.tsx
msgid "Gate min / max"
msgstr "Gate min / max"

#: src/pages/processData/buildMode/dock/CleaningSection.tsx
msgid "gates apply to test range"
msgstr "gates apply to test range"

#: src/features/timeSeries/experiment/ExperimentTab.tsx
msgid "Gates only remove train/val rows — the test range keeps every row, so held-out metrics stay honest about all operating regimes."
msgstr "Gates only remove train/val rows — the test range keeps every row, so held-out metrics stay honest about all operating regimes."

#: src/features/timeSeries/agentTab/dock/AlertingTab.tsx
msgid "Gecko switches models on as live monitors during the beta."
msgstr "Gecko switches models on as live monitors during the beta."

#: src/features/knowledgeDocumentViewer/utils/documentTypeLabels.ts
#: src/pages/evaluations/metadata/labeling/utils/pageClassificationTaxonomy.ts
msgid "General Arrangement"
msgstr "General Arrangement"

#: src/pages/details/extensions/fde/ffsLtaGeneration/FfsLtaGenerationSidebar.tsx
msgid "Generated {ltaCount, plural, one {# LTA} other {# LTAs}} and {entryCount, plural, one {# entry} other {# entries}}."
msgstr "Generated {ltaCount, plural, one {# LTA} other {# LTAs}} and {entryCount, plural, one {# entry} other {# entries}}."

#: src/pages/processData/components/helpGuide/HelpGuideChapters.tsx
msgid "generator mw from exciter"
msgstr "generator mw from exciter"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatSelectionFeedback.tsx
msgid "Give feedback"
msgstr "Give feedback"

#: src/features/embeddedSidebar/EmbeddedSidebar.tsx
#: src/features/embeddedSidebar/EmbeddedSidebar.tsx
#: src/features/embeddedSidebar/EmbeddedSidebar.tsx
#: src/features/embeddedSidebar/EmbeddedSidebar.tsx
msgid "Give Feedback"
msgstr "Give Feedback"

#: src/features/timeSeries/components/DashboardHeader.tsx
msgid "Give the chart a name before saving so it can be found later."
msgstr "Give the chart a name before saving so it can be found later."

#: src/features/timeSeries/components/chartActions/ChartSaveAction.tsx
msgid "Give the view a name before saving so it can be found later."
msgstr "Give the view a name before saving so it can be found later."

#: src/pages/errorFallback/ErrorFallback.tsx
msgid "Go back"
msgstr "Go back"

#: src/features/timeSeries/components/LabelsTab.tsx
msgid "Go to {value712_45}"
msgstr "Go to {value712_45}"

#: src/features/modelOperations/SubjectDetails.tsx
msgid "Go to Asset"
msgstr "Go to Asset"

#: src/features/navbar/siteSelectors/EmbeddedSidebarBrandHomeLink.tsx
#: src/features/navbar/siteSelectors/EmbeddedSidebarBrandHomeLink.tsx
msgid "Go to Home"
msgstr "Go to Home"

#: src/features/timeSeries/components/LabelsTab.tsx
msgid "Go to Label"
msgstr "Go to Label"

#: src/designSystem/components/Pagination.tsx
msgid "Go to next page"
msgstr "Go to next page"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/documentsCardView/PaginationControls.tsx
#: src/features/knowledgeDocumentViewer/components/table/enhancements/Pagination.tsx
#: src/features/knowledgeDocumentViewer/components/thumbnailSidebar/PageThumbnailItem.tsx
msgid "Go to page {pageNumber}"
msgstr "Go to page {pageNumber}"

#: src/designSystem/components/Pagination.tsx
msgid "Go to previous page"
msgstr "Go to previous page"

#: src/features/chatbot/components/conversationMessage/AIResponseExtras.tsx
#: src/features/chatbot/components/conversationMessage/AIResponseExtras.tsx
msgid "Go to tab"
msgstr "Go to tab"

#: src/features/chatbot/components/FeedbackMenu.tsx
msgid "Good response"
msgstr "Good response"

#: src/features/knowledgeDocumentViewer/graph/useDocumentGraph.ts
msgid "Graph data could not be loaded."
msgstr "Graph data could not be loaded."

#: src/features/knowledgeDocumentViewer/graph/useDocumentGraph.ts
msgid "Graph extraction is incomplete. No overlays are available yet."
msgstr "Graph extraction is incomplete. No overlays are available yet."

#: src/features/knowledgeDocumentViewer/components/toolbar/SettingsMenu.tsx
msgid "Graph mode"
msgstr "Graph mode"

#: src/features/knowledgeDocumentViewer/graph/useDocumentGraph.ts
msgid "Graph unavailable for the selected pipeline."
msgstr "Graph unavailable for the selected pipeline."

#: src/features/copcPointClouds/CopcLocalizationColorControl.tsx
msgid "Grey"
msgstr "Grey"

#: src/features/copcPointClouds/CopcSpatialContextControl.tsx
#: src/features/copcPointClouds/CopcSpatialContextControl.tsx
msgid "Ground height"
msgstr "Ground height"

#: src/pages/evaluations/metadata/dashboard/components/dataLabeling/DataLabelingDashboardComparisonTable.tsx
msgid "Ground truth"
msgstr "Ground truth"

#: src/pages/evaluations/metadata/dashboard/components/dataLabeling/DataLabelingDashboardFieldDrilldown.tsx
msgid "Ground truth vs active pipeline config"
msgstr "Ground truth vs active pipeline config"

#: src/features/timeSeries/components/labelTool/LabelConfigPanel.tsx
msgid "Group"
msgstr "Group"

#: src/features/lotoReports/recordSheet/recordSheetLayout.ts
msgid "Group LOTO Record Sheet"
msgstr "Group LOTO Record Sheet"

#: src/features/lotoReports/components/LotoReportsList.tsx
msgid "Group LOTO record sheets for this site and the drawing pages they cover."
msgstr "Group LOTO record sheets for this site and the drawing pages they cover."

#: src/pages/metrics/components/MonthlyTable.tsx
msgid "Growth"
msgstr "Growth"

#: src/features/dataFilter/categoryFilter/CategorySelector.tsx
msgid "Growth Work Upper Bound"
msgstr "Growth Work Upper Bound"

#: src/pages/processData/components/helpGuide/HelpGuideDialog.tsx
msgid "Guide chapters"
msgstr "Guide chapters"

#: src/pages/assetLens/components/tabs/imagesTabComponents/ImageUploadModal.tsx
msgid "Handheld Inspection"
msgstr "Handheld Inspection"

#: src/pages/assetLens/components/tabs/imagesTabComponents/ImageMetadata.tsx
msgid "Handheld Scan"
msgstr "Handheld Scan"

#: src/features/timeSeries/components/panes/TagFilterControls.tsx
msgid "Has data"
msgstr "Has data"

#: src/pages/processData/buildMode/rightPanel/SavedModelShelf.tsx
msgid "Has model weights"
msgstr "Has model weights"

#: src/features/auth/vendors/Auth0Provider.tsx
#: src/features/auth/vendors/CognitoLoginScreen.tsx
#: src/features/auth/vendors/KeycloakLoginScreen.tsx
msgid "Having trouble logging in? Contact <0>support@geckorobotics.com</0>"
msgstr "Having trouble logging in? Contact <0>support@geckorobotics.com</0>"

#: src/features/lotoReports/recordSheet/recordSheetLayout.ts
msgid "Hazardous Energy Control Program (LOTO)"
msgstr "Hazardous Energy Control Program (LOTO)"

#: src/features/richText/components/ToolbarPlugin.tsx
msgid "Heading 1"
msgstr "Heading 1"

#: src/features/richText/components/ToolbarPlugin.tsx
msgid "Heading 2"
msgstr "Heading 2"

#: src/features/richText/components/ToolbarPlugin.tsx
msgid "Heading 3"
msgstr "Heading 3"

#: src/pages/overview/sidebar/table/SiteViewSidebarTableOrganizers.tsx
msgid "Health"
msgstr "Health"

#: src/features/navbar/configSettings/ConfigSettingsSidebarMenuItems.tsx
#: src/features/navbar/configSettings/ConfigSettingsSidebarMenuItems.tsx
#: src/features/navbar/configSettings/ConfigSettingsTopBarMenuItems.tsx
msgid "Health Check"
msgstr "Health Check"

#: src/features/navbar/navConfig.ts
#: src/pages/homepage/constants.ts
msgid "Health Plans"
msgstr "Health Plans"

#: src/features/nnpp/nnppReportPresentation.ts
msgid "Heat number"
msgstr "Heat number"

#: src/pages/evaluations/metadata/labeling/utils/pageClassificationTaxonomy.ts
msgid "Heat-trace layouts"
msgstr "Heat-trace layouts"

#: src/pages/details/visualization/tools/HeatmapToggle.tsx
msgid "Heatmap disabled"
msgstr "Heatmap disabled"

#: src/features/timeSeries/agentTab/dock/BacktestTab.tsx
msgid "held out"
msgstr "held out"

#: src/pages/homepage/Homepage.tsx
msgid "Hello, {userName}."
msgstr "Hello, {userName}."

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatMessageActions.tsx
#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatMessageActions.tsx
msgid "Helpful"
msgstr "Helpful"

#: src/features/fim/photos/PhotoHeroAction.tsx
#: src/features/fim/photos/PhotoTile.tsx
#: src/features/fim/photos/PhotoTile.tsx
msgid "Hero"
msgstr "Hero"

#: src/features/fim/photos/useSubjectPhotoActions.ts
msgid "Hero photo change failed: {reason}"
msgstr "Hero photo change failed: {reason}"

#: src/features/assetVizAdapter/MeasurementStrip.tsx
msgid "Hi"
msgstr "Hi"

#: src/features/timeSeries/agentTab/chat/BuildCard.tsx
msgid "hid {hidden}"
msgstr "hid {hidden}"

#: src/features/permissions/components/PermissionsGate.tsx
msgid "Hidden for any of:"
msgstr "Hidden for any of:"

#: src/pages/processData/buildMode/dock/ModelDockTab.tsx
msgid "Hidden layer sizes"
msgstr "Hidden layer sizes"

#: src/pages/processData/buildMode/dock/ModelDockTab.tsx
msgid "Hidden layers"
msgstr "Hidden layers"

#: src/features/kestrelUpload/KestrelModelUploadSection.tsx
#: src/features/navbar/PermissionGateToggle.tsx
#: src/features/timeSeries/components/RegressionPrediction.tsx
msgid "Hide"
msgstr "Hide"

#: src/features/workbench/LayoutToggles.tsx
msgid "Hide {label}"
msgstr "Hide {label}"

#: src/pages/cases/md/MdCaseDetailsMainColumn.tsx
msgid "Hide Activity"
msgstr "Hide Activity"

#: src/features/timeSeries/agentTab/dock/SettingsTab.tsx
msgid "Hide all"
msgstr "Hide all"

#: src/features/timeSeries/components/chartActions/PenDisplayActions.tsx
#: src/features/timeSeries/components/chartActions/PenDisplayActions.tsx
#: src/features/timeSeries/components/PenDrawer.tsx
#: src/features/timeSeries/components/PenDrawer.tsx
msgid "Hide all alerts"
msgstr "Hide all alerts"

#: src/features/timeSeries/components/chartActions/PenDisplayActions.tsx
#: src/features/timeSeries/components/chartActions/PenDisplayActions.tsx
#: src/features/timeSeries/components/PenDrawer.tsx
#: src/features/timeSeries/components/PenDrawer.tsx
msgid "Hide all pens"
msgstr "Hide all pens"

#: src/pages/assetLens/components/tabs/imagesTabComponents/ImageTimelineView.tsx
msgid "Hide Anomalies"
msgstr "Hide Anomalies"

#: src/pages/details/visualization/tools/CameraControlsToggle.tsx
msgid "Hide camera controls"
msgstr "Hide camera controls"

#: src/pages/facilityModel/SubjectAssetPanel.tsx
msgid "Hide candidates"
msgstr "Hide candidates"

#: src/pages/overview/sidebar/capexOutlook/SiteViewCapExOutlookMenu.tsx
msgid "Hide CapEx Outlook"
msgstr "Hide CapEx Outlook"

#: src/features/timeSeries/components/panes/TagConfigurationPane.tsx
#: src/features/timeSeries/components/panes/TagConfigurationPane.tsx
msgid "Hide chart controls"
msgstr "Hide chart controls"

#: src/pages/details/visualization/tools/DebugMenuToggle.tsx
msgid "Hide debug menu"
msgstr "Hide debug menu"

#: src/features/timeSeries/components/chartActions/PenDisplayActions.tsx
#: src/features/timeSeries/components/chartActions/PenDisplayActions.tsx
#: src/features/timeSeries/components/panes/TagBrowserPane.tsx
#: src/features/timeSeries/components/panes/TagBrowserPane.tsx
#: src/features/timeSeries/components/PenDrawer.tsx
#: src/features/timeSeries/components/PenDrawer.tsx
msgid "Hide descriptions"
msgstr "Hide descriptions"

#: src/pages/cases/activity/ActivityContent.tsx
msgid "Hide details"
msgstr "Hide details"

#: src/pages/processData/buildMode/rightPanel/SavedModelsPane.tsx
msgid "Hide filters"
msgstr "Hide filters"

#: src/features/copcPointClouds/CopcSpatialContextControl.tsx
msgid "Hide floor and ground"
msgstr "Hide floor and ground"

#: src/pages/details/visualization/tools/KestrelTools.tsx
msgid "Hide Kestrel"
msgstr "Hide Kestrel"

#: src/pages/details/visualization/tools/ShowLabelsToggle.tsx
msgid "Hide labels"
msgstr "Hide labels"

#: src/pages/details/visualization/screenshot/ScreenshotTools.tsx
msgid "Hide Legend"
msgstr "Hide Legend"

#: src/features/knowledgeDocumentViewer/components/toolbar/KnowledgeDocumentHeaderBar.tsx
msgid "Hide LOTO panel"
msgstr "Hide LOTO panel"

#: src/features/knowledgeDocumentViewer/components/toolbar/KnowledgeDocumentHeaderBar.tsx
msgid "Hide Metadata"
msgstr "Hide Metadata"

#: src/features/knowledgeDocumentViewer/components/viewer/shared/ZoomControls.tsx
msgid "Hide Minimap"
msgstr "Hide Minimap"

#: src/features/knowledgeDocumentViewer/components/toolbar/KnowledgeDocumentHeaderBar.tsx
msgid "Hide Page Thumbnails"
msgstr "Hide Page Thumbnails"

#: src/features/workbench/WorkbenchDock.tsx
msgid "Hide panel"
msgstr "Hide panel"

#: src/features/timeSeries/agentTab/AgentTab.tsx
msgid "Hide past conversations"
msgstr "Hide past conversations"

#: src/features/navbar/PermissionGateToggle.tsx
msgid "Hide permission gates"
msgstr "Hide permission gates"

#: src/features/knowledgeDocumentViewer/components/viewer/shared/ZoomControls.tsx
msgid "Hide photo counts"
msgstr "Hide photo counts"

#: src/pages/details/visualization/tools/NiraToggle.tsx
msgid "Hide Photogrammetry"
msgstr "Hide Photogrammetry"

#: src/pages/details/visualization/tools/CopcPointCloudToggle.tsx
#: src/pages/details/visualization/tools/LidarPointCloudToggle.tsx
msgid "Hide Point Cloud"
msgstr "Hide Point Cloud"

#: src/features/timeSeries/agentTab/dock/SettingsTab.tsx
msgid "Hide rows the model filtered out"
msgstr "Hide rows the model filtered out"

#: src/pages/processData/buildMode/rightPanel/SavedModelsPane.tsx
msgid "Hide shelf filters"
msgstr "Hide shelf filters"

#: src/pages/kestrel/components/DesktopSidebarToggle.tsx
#: src/pages/kestrel/components/DesktopSidebarToggle.tsx
msgid "Hide sidebar"
msgstr "Hide sidebar"

#: src/pages/details/extensions/flow/filesExt/ReportItem.tsx
#: src/pages/details/extensions/flow/filesExt/ReportItem.tsx
msgid "Hide tags"
msgstr "Hide tags"

#: src/features/timeSeries/components/AllTagsTab.tsx
msgid "Hide tags without data"
msgstr "Hide tags without data"

#: src/features/fimReview/IdentityPanel.tsx
msgid "Hide the prior Subjects folded into this one"
msgstr "Hide the prior Subjects folded into this one"

#: src/features/fimReview/IdentityPanel.tsx
msgid "Hide the references behind this alias"
msgstr "Hide the references behind this alias"

#: src/pages/details/visualization/tools/HideToolbarToggle.tsx
msgid "Hide toggles"
msgstr "Hide toggles"

#: src/pages/details/visualization/tools/HideToolbarToggle.tsx
msgid "Hide Toggles"
msgstr "Hide Toggles"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatModelSettingsMenu.tsx
#: src/features/knowledgeDocumentViewer/components/bugReport/BugReportPriorityField.tsx
#: src/features/mdCases/mdCaseDisplay.ts
#: src/features/timeSeries/components/rulerTool/RulerMetricsPanel.tsx
#: src/pages/assetLens/components/tabs/AnomalyDashboard.tsx
#: src/pages/assetLens/components/tabs/SensorIssuesTab.tsx
msgid "High"
msgstr "High"

#: src/pages/processData/buildMode/dock/TagCleaningEditor.tsx
msgid "High clip quantile"
msgstr "High clip quantile"

#: src/features/knowledgeDocumentViewer/components/toolbar/SettingsMenu.tsx
msgid "Highlight Assets"
msgstr "Highlight Assets"

#: src/features/knowledgeDocumentViewer/components/revisionCompare/RevisionCompareContent.tsx
msgid "Highlight changes"
msgstr "Highlight changes"

#: src/features/kestrelViewer/ui/tools/photoreel/PhotoReel2DToolbar.tsx
msgid "Highlight current pose"
msgstr "Highlight current pose"

#: src/features/fimEvidence/SubjectGlyphs.tsx
#: src/features/modelOperations/Corroboration.tsx
msgid "Historian"
msgstr "Historian"

#: src/features/timeSeries/agentTab/dock/FitTab.tsx
msgid "historian tag"
msgstr "historian tag"

#: src/features/fimReview/provenance.ts
msgid "Historian tag"
msgstr "Historian tag"

#: src/features/chatbot/components/SessionHeaderBar.tsx
#: src/features/powerCustomerUploads/components/PowerCustomerUploadHistoryPanel.tsx
msgid "History"
msgstr "History"

#: src/features/timeSeries/experiment/ExperimentTab.tsx
msgid "Hit Train to band the target pen on the chart and see metrics here."
msgstr "Hit Train to band the target pen on the chart and see metrics here."

#: src/pages/details/visualization/photogrammetry/NiraHud.tsx
msgid "Hold <0>Left Mouse + Drag</0> to orbit"
msgstr "Hold <0>Left Mouse + Drag</0> to orbit"

#: src/features/timeSeries/agentTab/dock/BacktestTab.tsx
msgid "hold each event out of the baseline"
msgstr "hold each event out of the baseline"

#: src/features/timeSeries/components/SentinelsTab.tsx
msgid "Holdout quality of the selected model method: scaled mean absolute error (lower is better), residual drift, and typical residual size"
msgstr "Holdout quality of the selected model method: scaled mean absolute error (lower is better), residual drift, and typical residual size"

#: src/features/navbar/navConfig.ts
#: src/features/navbar/siteSelectors/EmbeddedSidebarBrandHomeLink.test.tsx
#: src/features/navbar/siteSelectors/useBrandHomeLink.ts
#: src/features/navbar/siteSelectors/useBrandHomeLink.ts
#: src/pages/documents/usePowerCustomerUploadLeaveWarning.ts
msgid "Home"
msgstr "Home"

#: src/features/knowledgeDocumentViewer/components/table/SyncedTableHorizontalScrollbar.tsx
#: src/features/knowledgeDocumentViewer/components/table/SyncedTableHorizontalScrollbar.tsx
msgid "Horizontal table scroll"
msgstr "Horizontal table scroll"

#: src/features/timeSeries/agentTab/dock/AlertingTab.tsx
msgid "hourly"
msgstr "hourly"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsRecordPdf.ts
msgid "hours"
msgstr "hours"

#: src/features/timeSeries/components/RelativeDateConfig.tsx
msgid "Hours"
msgstr "Hours"

#: src/pages/assetLens/components/tabs/ModelViewerTab.tsx
msgid "Hover over a point to see temperature"
msgstr "Hover over a point to see temperature"

#: src/features/timeSeries/experiment/knobCopy.ts
msgid "How far (in sample periods) the correlation scan looks each side of zero. Larger = slower preview but catches longer leads/lags. Time equivalent = max × interval."
msgstr "How far (in sample periods) the correlation scan looks each side of zero. Larger = slower preview but catches longer leads/lags. Time equivalent = max × interval."

#: src/pages/cases/components/CaseFeedbackModal.tsx
msgid "How good was the investigation framing, reasoning, and evidence?"
msgstr "How good was the investigation framing, reasoning, and evidence?"

#: src/features/timeSeries/experiment/knobCopy.ts
msgid "How many historical neighbors vote for each prediction. Smaller k = noisier / more local; larger k = smoother / more averaged."
msgstr "How many historical neighbors vote for each prediction. Smaller k = noisier / more local; larger k = smoother / more averaged."

#: src/features/timeSeries/experiment/knobCopy.ts
msgid "How multiple raw samples inside one interval bin are collapsed to a single value. Mean is the production default. Median is more outlier-resistant; last_value keeps the newest sample in the bin. Only used in aggregate mode."
msgstr "How multiple raw samples inside one interval bin are collapsed to a single value. Mean is the production default. Median is more outlier-resistant; last_value keeps the newest sample in the bin. Only used in aggregate mode."

#: src/features/timeSeries/experiment/DiagnosticsPanel.tsx
msgid "How the band is chosen:"
msgstr "How the band is chosen:"

#: src/features/timeSeries/experiment/knobCopy.ts
msgid "How the residual error scale is measured on calibration rows, then multiplied by Band k. IQR (prod) = P75−P25 of |error|. Std = std(|error|). Abs quantile = chosen percentile of |error|. Band is one constant per model, not per point."
msgstr "How the residual error scale is measured on calibration rows, then multiplied by Band k. IQR (prod) = P75−P25 of |error|. Std = std(|error|). Abs quantile = chosen percentile of |error|. Band is one constant per model, not per point."

#: src/features/sentinels/components/DesignRunOverviewSections.tsx
msgid "How this run was produced"
msgstr "How this run was produced"

#: src/features/timeSeries/experiment/knobCopy.ts
msgid "How to carve the timeline into chunks: tail fraction (prod-like), calendar month/year, fixed N-day blocks, or custom date ranges you type in. Custom ranges are the only mode where a row can belong to no chunk — those rows are excluded from fitting and scoring."
msgstr "How to carve the timeline into chunks: tail fraction (prod-like), calendar month/year, fixed N-day blocks, or custom date ranges you type in. Custom ranges are the only mode where a row can belong to no chunk — those rows are excluded from fitting and scoring."

#: src/pages/processData/components/ProcessDataTopBar.tsx
msgid "How to use this page"
msgstr "How to use this page"

#: src/pages/details/visualization/tools/VizDebugMenu.tsx
msgid "Html overlay debug colors"
msgstr "Html overlay debug colors"

#: src/pages/evaluations/metadata/dashboard/components/dataLabeling/DataLabelingDashboardSites.tsx
msgid "Human coverage"
msgstr "Human coverage"

#: src/features/fimReview/IdentityPanel.tsx
msgid "Human merge"
msgstr "Human merge"

#: src/features/fimReview/IdentityPanel.tsx
msgid "Human split"
msgstr "Human split"

#: src/features/fimReview/provenance.ts
msgid "Human-confirmed"
msgstr "Human-confirmed"

#: src/pages/evaluations/metadata/dashboard/components/dataLabeling/DataLabelingDashboardSummaryCards.tsx
msgid "Human-confirmed pages"
msgstr "Human-confirmed pages"

#: src/pages/evaluations/metadata/dashboard/components/dataLabeling/DataLabelingDashboardSummaryCards.tsx
msgid "Humans vs pipeline"
msgstr "Humans vs pipeline"

#: src/pages/assetLens/components/tabs/imagesTabComponents/EnvironmentalCorrelationCard.tsx
msgid "humidity"
msgstr "humidity"

#: src/pages/assetLens/components/tabs/imagesTabComponents/ImageTrendAnalysis.tsx
msgid "Humidity"
msgstr "Humidity"

#: src/features/lotoReports/recordSheet/recordSheetLayout.ts
msgid ""
"Hung\n"
"Initial"
msgstr ""
"Hung\n"
"Initial"

#: src/features/lotoReports/recordSheet/recordSheetLayout.ts
msgid ""
"Hung\n"
"Order"
msgstr ""
"Hung\n"
"Order"

#: src/features/lotoReports/components/LotoSheetPointRow.tsx
msgid "Hung order"
msgstr "Hung order"

#: src/features/lotoReports/components/LotoSheetPointRow.tsx
msgid "Hung position"
msgstr "Hung position"

#: src/features/lotoReports/recordSheet/recordSheetLayout.ts
msgid "Hung Position"
msgstr "Hung Position"

#: src/features/auth/AuthInactivityMonitor.tsx
msgid "I'm here!"
msgstr "I'm here!"

#: src/features/richText/components/slashCommandCards/ChartSlashCommandCard.tsx
#: src/features/richText/components/slashCommandCards/SystemSlashCommandCard.tsx
msgid "ID:"
msgstr "ID:"

#: src/features/richText/components/slashCommandCards/InspectionSlashCommandCard.tsx
#: src/features/richText/components/slashCommandCards/UnitSlashCommandCard.tsx
msgid "ID: {entryID}"
msgstr "ID: {entryID}"

#: src/pages/details/visualization/markupEditing/IconSelector.tsx
msgid "Image"
msgstr "Image"

#: src/pages/assetLens/components/tabs/imagesTabComponents/ImageUploadModal.tsx
msgid "Image File"
msgstr "Image File"

#: src/pages/assetLens/components/tabs/imagesTabComponents/ImageComparisonView.tsx
msgid "Image loading..."
msgstr "Image loading..."

#: src/pages/assetLens/components/tabs/imagesTabComponents/ImageUploadModal.tsx
msgid "Image must be smaller than 5MB!"
msgstr "Image must be smaller than 5MB!"

#: src/pages/assetLens/components/tabs/imagesTabComponents/ImageGalleryView.tsx
msgid "Image not available"
msgstr "Image not available"

#: src/features/richText/components/ToolbarPlugin.tsx
#: src/features/richText/editorPlugins/DragDropPastePlugin.tsx
msgid "Image uploaded successfully"
msgstr "Image uploaded successfully"

#: src/pages/details/extensions/flow/ImageryExtension.tsx
msgid "Imagery"
msgstr "Imagery"

#: src/pages/details/extensions/flow/ImageryExtension.tsx
msgid "Images"
msgstr "Images"

#: src/features/knowledgeDocumentViewer/components/revisionCompare/RevisionStatusLegend.tsx
msgid "Impact"
msgstr "Impact"

#: src/features/knowledgeDocumentViewer/components/revisionCompare/RevisionComparePane.tsx
msgid "Impact:"
msgstr "Impact:"

#: src/pages/manageAccess/components/table/UserRowActions.tsx
msgid "Impersonate user"
msgstr "Impersonate user"

#: src/pages/manageAccess/components/table/UserRowActions.tsx
msgid "Impersonation is unavailable for your own account or a user whose access has not loaded."
msgstr "Impersonation is unavailable for your own account or a user whose access has not loaded."

#: src/features/knowledgeDocumentViewer/components/bugReport/BugReportAgentModeField.tsx
msgid "Implement a fix and open a PR."
msgstr "Implement a fix and open a PR."

#: src/features/knowledgeDocumentViewer/workOrders/workOrderSheet.ts
msgid "Imported"
msgstr "Imported"

#: src/features/knowledgeDocumentViewer/workOrders/legacyCmmsRecordPdf.ts
msgid "Imported source data. Plans and orders do not establish performed work; stock figures are snapshots."
msgstr "Imported source data. Plans and orders do not establish performed work; stock figures are snapshots."

#: src/features/navbar/navConfig.ts
msgid "Imports"
msgstr "Imports"

#: src/features/knowledgeDocumentViewer/components/bugReport/BugReportTypeField.tsx
msgid "Improvement"
msgstr "Improvement"

#: src/features/knowledgeDocumentViewer/components/bugReport/DocumentsBugReportButton.tsx
msgid "Improvement details"
msgstr "Improvement details"

#: src/designSystem/components/RecordHeader.tsx
#: src/designSystem/components/RecordHeader.tsx
#: src/features/powerCustomerUploads/components/PowerCustomerUploadHistoryPanel.tsx
#: src/features/powerCustomerUploads/components/powerCustomerUploadHistoryPresentation.ts
#: src/features/powerCustomerUploads/components/PowerCustomerUploadSummary.tsx
msgid "In progress"
msgstr "In progress"

#: src/features/timeSeries/agentTab/dock/TargetTab.tsx
msgid "in range ({displayedHealthRatio}×)"
msgstr "in range ({displayedHealthRatio}×)"

#: src/pages/systemView/components/unitsTab/FilterControls.tsx
#: src/pages/systemView/components/unitsTab/UnitListItem.tsx
msgid "In Service"
msgstr "In Service"

#: src/pages/cases/components/CaseFeedbackModal.tsx
msgid "Inaccurate"
msgstr "Inaccurate"

#: src/pages/processData/buildMode/components/OnOffToggle.tsx
msgid "Include {subject}"
msgstr "Include {subject}"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatAgentsMenu.tsx
msgid "Includes imported maintenance work orders in your search results."
msgstr "Includes imported maintenance work orders in your search results."

#: src/features/timeSeries/experiment/knobCopy.ts
msgid "Inclusive end of the historian window (UTC day). Capped at “now”."
msgstr "Inclusive end of the historian window (UTC day). Capped at “now”."

#: src/features/timeSeries/experiment/knobCopy.ts
msgid "Inclusive start of the historian window pulled into the experiment."
msgstr "Inclusive start of the historian window pulled into the experiment."

#: src/pages/facilityModel/FacilityModelCatalog.tsx
msgid "Incomplete load"
msgstr "Incomplete load"

#: src/features/knowledgeDocumentViewer/components/sidebar/FeedbackModal.tsx
msgid "Incorrect Label"
msgstr "Incorrect Label"

#: src/features/knowledgeDocumentViewer/components/sidebar/FeedbackModal.tsx
msgid "Incorrect Off Page Connector"
msgstr "Incorrect Off Page Connector"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/utils/docChatFeedback.ts
msgid "Incorrect or incomplete"
msgstr "Incorrect or incomplete"

#: src/features/chatbot/components/ChatbotHelpModal.tsx
msgid "Incorrect Response"
msgstr "Incorrect Response"

#: src/pages/assetLens/components/tabs/imagesTabComponents/ImageTrendAnalysis.tsx
msgid "increasing"
msgstr "increasing"

#: src/features/timeSeries/components/RegressionPrediction.tsx
msgid "Independent Variable(s) (X)"
msgstr "Independent Variable(s) (X)"

#: src/pages/evaluations/metadata/labeling/utils/pageClassificationTaxonomy.ts
msgid "Indexes, covers and document control"
msgstr "Indexes, covers and document control"

#: src/pages/assetLens/components/tabs/SensorIssuesTab.tsx
msgid "Info"
msgstr "Info"

#: src/pages/assetLens/components/tabs/imagesTabComponents/ImageGalleryView.tsx
msgid "Infrared Thermal Images"
msgstr "Infrared Thermal Images"

#: src/features/fimReview/ReviewActions.tsx
msgid "Input removal scope"
msgstr "Input removal scope"

#: src/features/fimReview/DecisionHistory.tsx
msgid "Input removed"
msgstr "Input removed"

#: src/pages/site/components/CustomFieldsTableColumns.tsx
#: src/pages/site/forms/customFieldInfoFormFields.ts
msgid "Input Type"
msgstr "Input Type"

#: src/features/timeSeries/components/AllTagsTable.tsx
msgid "input[type=\"checkbox\"]"
msgstr "input[type=\"checkbox\"]"

#: src/features/timeSeries/experiment/knobCopy.ts
msgid "Inputs that should physically determine the target under normal operation (load, flow, ambient, upstream states). Keep the set small and non-redundant."
msgstr "Inputs that should physically determine the target under normal operation (load, flow, ambient, upstream states). Keep the set small and non-redundant."

#: src/features/richText/editorPlugins/SlashCommandPlugin.tsx
msgid "Insert {entryTypeName}"
msgstr "Insert {entryTypeName}"

#: src/features/richText/editorPlugins/SlashCommandPlugin.tsx
msgid "Insert Entry"
msgstr "Insert Entry"

#: src/pages/facilityModel/SubjectDetailPage.tsx
msgid "Inspect sources ({constituentCount})"
msgstr "Inspect sources ({constituentCount})"

#: src/features/modelOperations/SubjectDetails.tsx
msgid "Inspect sources ({sourceCount})"
msgstr "Inspect sources ({sourceCount})"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatInspectionCard.tsx
#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatInspectionCard.tsx
#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatInspectionCard.tsx
#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatInspectionViewer.tsx
#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/InspectionPreviewPanel.tsx
#: src/features/richText/components/slashCommandCards/InspectionSlashCommandCard.tsx
#: src/pages/details/extensions/flow/filesExt/FileTags.tsx
msgid "Inspection"
msgstr "Inspection"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatInspectionCard.tsx
msgid "Inspection · Remaining life"
msgstr "Inspection · Remaining life"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/utils/inspectionAnalysisCitations.ts
msgid "Inspection {date}"
msgstr "Inspection {date}"

#: src/pages/evaluations/metadata/labeling/utils/pageClassificationTaxonomy.ts
msgid "Inspection and test results"
msgstr "Inspection and test results"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
msgid "Inspection asset"
msgstr "Inspection asset"

#: src/features/navbar/navConfig.ts
msgid "Inspection Dashboard"
msgstr "Inspection Dashboard"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/utils/inspectionAnalysisCitations.ts
msgid "Inspection data"
msgstr "Inspection data"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatInspectionCard.tsx
msgid "Inspection date"
msgstr "Inspection date"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
#: src/features/knowledgeDocumentViewer/workOrders/legacyCmmsRecordPdf.ts
msgid "Inspection field"
msgstr "Inspection field"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
#: src/features/knowledgeDocumentViewer/workOrders/legacyCmmsRecordPdf.ts
msgid "Inspection form"
msgstr "Inspection form"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatInspectionViewer.tsx
msgid "Inspection heatmap data is unavailable."
msgstr "Inspection heatmap data is unavailable."

#: src/pages/details/extensions/flow/ImageryExtension.tsx
msgid "Inspection image unavailable"
msgstr "Inspection image unavailable"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatInspectionViewer.tsx
msgid "Inspection layer"
msgstr "Inspection layer"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/ResponseSegmentInspectionChip.tsx
msgid "Inspection of {date}"
msgstr "Inspection of {date}"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/ResponseSegmentInspectionChip.tsx
msgid "Inspection of {date} · {state}"
msgstr "Inspection of {date} · {state}"

#: src/pages/details/visualization/alerts/specificAlerts/ConduitPipelineAlert.tsx
msgid "Inspection processing pipelines in progress: {processInspectionRunsCount}"
msgstr "Inspection processing pipelines in progress: {processInspectionRunsCount}"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
#: src/features/knowledgeDocumentViewer/workOrders/legacyCmmsRecordPdf.ts
msgid "Inspection question number"
msgstr "Inspection question number"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
msgid "Inspection response"
msgstr "Inspection response"

#: src/features/knowledgeDocumentViewer/workOrders/legacyCmmsRecordPdf.ts
msgid "Inspection responses"
msgstr "Inspection responses"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
#: src/features/knowledgeDocumentViewer/workOrders/legacyCmmsRecordPdf.ts
#: src/features/knowledgeDocumentViewer/workOrders/legacyCmmsRecordPdf.ts
msgid "Inspection result"
msgstr "Inspection result"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/utils/docChatText.ts
msgid "Inspection results ready"
msgstr "Inspection results ready"

#: src/features/navbar/navConfig.ts
msgid "Inspection Scheduling"
msgstr "Inspection Scheduling"

#: src/features/richText/components/slashCommandCards/UnitConfigurationModal.tsx
msgid "Inspection Version"
msgstr "Inspection Version"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatInspectionCard.tsx
msgid "Inspection view"
msgstr "Inspection view"

#: src/features/navbar/navConfig.ts
msgid "Inspections"
msgstr "Inspections"

#: src/pages/evaluations/metadata/labeling/utils/pageClassificationTaxonomy.ts
msgid "Installation and assembly"
msgstr "Installation and assembly"

#: src/pages/facilityModel/FacilityModelCatalog.tsx
msgid "Instant search — the full catalog is loaded locally"
msgstr "Instant search — the full catalog is loaded locally"

#: src/pages/facilityModel/FacilityModelCatalog.tsx
msgid "Instant search active"
msgstr "Instant search active"

#: src/features/modelOperations/SubjectDetails.tsx
#: src/pages/facilityModel/SubjectDetailPage.tsx
msgid "Instantiate"
msgstr "Instantiate"

#: src/pages/facilityModel/SubjectDetailPage.tsx
msgid "Instantiate failed: {reason}"
msgstr "Instantiate failed: {reason}"

#: src/features/modelOperations/SubjectDetails.tsx
msgid "Instantiating…"
msgstr "Instantiating…"

#: src/pages/evaluations/metadata/labeling/utils/pageClassificationTaxonomy.ts
msgid "Instructions and technical requirements"
msgstr "Instructions and technical requirements"

#: src/features/facilityModel/columns.ts
#: src/features/fimReview/InspectSources.tsx
#: src/features/fimReview/StructuralReviewFlow.tsx
msgid "Instrument"
msgstr "Instrument"

#: src/features/timeSeries/components/AllTagsTable.tsx
#: src/features/timeSeries/experiment/TagLabel.tsx
msgid "Instrument "
msgstr "Instrument "

#: src/pages/facilityModel/FacilityModelCatalog.tsx
#: src/pages/facilityModel/FacilityModelCatalog.tsx
msgid "Instruments"
msgstr "Instruments"

#: src/features/timeSeries/experiment/knobCopy.ts
msgid "Integer sample-period lead/lag per tag. Positive = treat the tag as leading (at time t use its value from t − N periods). Use the correlation chart / “Apply best shifts” to find useful offsets."
msgstr "Integer sample-period lead/lag per tag. Positive = treat the tag as leading (at time t use its value from t − N periods). Use the correlation chart / “Apply best shifts” to find useful offsets."

#: src/pages/details/visualization/Visualization.tsx
msgid "Interactive 2D visualization of component {componentName} on unit {unitName}."
msgstr "Interactive 2D visualization of component {componentName} on unit {unitName}."

#: src/pages/details/visualization/Visualization.tsx
msgid "Interactive 2D visualization of component {componentName}."
msgstr "Interactive 2D visualization of component {componentName}."

#: src/pages/details/visualization/Visualization.tsx
msgid "Interactive 3D visualization of component {componentName} on unit {unitName}."
msgstr "Interactive 3D visualization of component {componentName} on unit {unitName}."

#: src/pages/details/visualization/Visualization.tsx
msgid "Interactive 3D visualization of component {componentName}."
msgstr "Interactive 3D visualization of component {componentName}."

#: src/pages/details/visualization/Visualization.tsx
msgid "Interactive asset visualization."
msgstr "Interactive asset visualization."

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatInspectionCard.tsx
msgid "Interactive inspection"
msgstr "Interactive inspection"

#: src/features/timeSeries/components/RegressionPrediction.tsx
msgid "Intercept"
msgstr "Intercept"

#: src/features/timeSeries/experiment/NormalizationViewer.tsx
msgid "intercept={value122_30}"
msgstr "intercept={value122_30}"

#: src/pages/facilityModel/FacilityModelDataIssues.tsx
msgid "Internal"
msgstr "Internal"

#: src/features/powerCustomerUploads/components/PowerCustomerUploadFailureDetails.tsx
msgid "Internal:"
msgstr "Internal:"

#: src/features/timeSeries/components/XAxisSection.tsx
msgid "Interpolate:"
msgstr "Interpolate:"

#: src/features/timeSeries/components/TimeRangeSelector.tsx
#: src/features/timeSeries/components/TimeRangeSelector.tsx
#: src/features/timeSeries/experiment/SamplingKnobs.tsx
#: src/pages/processData/buildMode/dock/SamplingSection.tsx
#: src/pages/processData/buildMode/dock/SamplingSection.tsx
msgid "Interval"
msgstr "Interval"

#: src/features/timeSeries/experiment/RunComparison.tsx
msgid "interval {value70_29}→{value70_51}"
msgstr "interval {value70_29}→{value70_51}"

#: src/pages/processData/buildMode/dock/SamplingSection.tsx
msgid "Interval unit"
msgstr "Interval unit"

#: src/pages/evaluations/metadata/labeling/utils/pageClassificationTaxonomy.ts
msgid "Introductions and document scope"
msgstr "Introductions and document scope"

#: src/components/DateTimeWithTimezone.tsx
msgid "Invalid date"
msgstr "Invalid date"

#: src/features/timeSeries/components/FormulaBuilder.tsx
msgid "Invalid expression"
msgstr "Invalid expression"

#: src/pages/assetLens/components/tabs/imagesTabComponents/ImageUploadModal.tsx
msgid "Invalid File Type"
msgstr "Invalid File Type"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/utils/reportViewSchema.ts
msgid "Invalid report source reference or columns"
msgstr "Invalid report source reference or columns"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
#: src/features/knowledgeDocumentViewer/workOrders/legacyCmmsRecordPdf.ts
msgid "Inventory balance"
msgstr "Inventory balance"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
#: src/features/knowledgeDocumentViewer/workOrders/legacyCmmsRecordPdf.ts
msgid "Inventory stock"
msgstr "Inventory stock"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
#: src/features/knowledgeDocumentViewer/workOrders/legacyCmmsRecordPdf.ts
#: src/features/knowledgeDocumentViewer/workOrders/legacyCmmsRecordPdf.ts
msgid "Inventory usage"
msgstr "Inventory usage"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
#: src/features/knowledgeDocumentViewer/workOrders/legacyCmmsRecordPdf.ts
msgid "Inventory valuation"
msgstr "Inventory valuation"

#: src/pages/details/visualization/screenshot/ScreenshotTools.tsx
msgid "Invert Colors"
msgstr "Invert Colors"

#: src/features/mdCases/mdCaseDisplay.ts
#: src/pages/evaluations/metadata/dashboard/components/dataLabeling/DataLabelingDashboardComparisonTable.tsx
msgid "Investigate"
msgstr "Investigate"

#: src/pages/assetLens/components/tabs/AnomalyDashboard.tsx
#: src/pages/assetLens/components/tabs/AnomalyDashboard.tsx
msgid "Investigate with AI"
msgstr "Investigate with AI"

#: src/pages/assetLens/components/tabs/AnomalyDashboard.tsx
msgid "Investigating"
msgstr "Investigating"

#: src/features/chatbot/components/conversationMessage/ProposalCard.tsx
#: src/pages/cases/md/MdCaseDetailsMainColumn.tsx
#: src/pages/cases/md/MdCaseDetailsPage.tsx
msgid "Investigation"
msgstr "Investigation"

#: src/features/mdCases/components/CaseTimeline.tsx
msgid "Investigation completed"
msgstr "Investigation completed"

#: src/features/mdCases/components/CaseTimeline.tsx
msgid "Investigation failed"
msgstr "Investigation failed"

#: src/features/mdCases/components/CaseTimeline.tsx
msgid "Investigation notes"
msgstr "Investigation notes"

#: src/pages/cases/components/CaseFeedbackModal.tsx
msgid "Investigation Quality"
msgstr "Investigation Quality"

#: src/features/mdCases/components/CaseTimeline.tsx
msgid "Investigation started"
msgstr "Investigation started"

#: src/pages/manageAccess/hooks/useListedRoster.ts
msgid "Invitation only partly succeeded. Try again, even if the person already appears on the roster."
msgstr "Invitation only partly succeeded. Try again, even if the person already appears on the roster."

#: src/pages/manageAccess/components/table/UserRowActions.tsx
msgid "Invitation resent"
msgstr "Invitation resent"

#: src/pages/manageAccess/components/table/UserRowActions.tsx
msgid "Invitations cannot be sent to deactivated users."
msgstr "Invitations cannot be sent to deactivated users."

#: src/pages/manageAccess/hooks/useListedRoster.ts
msgid "Invitations sent"
msgstr "Invitations sent"

#: src/pages/manageAccess/components/invite/InviteUsersDialog.tsx
#: src/pages/manageAccess/components/table/UsersSection.tsx
msgid "Invite people"
msgstr "Invite people"

#: src/pages/manageAccess/users.ts
msgctxt "access status"
msgid "Invited"
msgstr "Invited"

#: src/features/timeSeries/experiment/ModelKnobs.tsx
msgid "IQR (prod)"
msgstr "IQR (prod)"

#: src/pages/assetLens/components/tabs/imagesTabComponents/ImageComparisonView.tsx
msgid "IR Scan - {comparisonImageDate}"
msgstr "IR Scan - {comparisonImageDate}"

#: src/pages/assetLens/components/tabs/imagesTabComponents/ImageComparisonView.tsx
msgid "IR Scan - {currentImageDate}"
msgstr "IR Scan - {currentImageDate}"

#: src/pages/assetLens/components/tabs/imagesTabComponents/ImageGalleryView.tsx
msgid "IR Scan - {imageDate}"
msgstr "IR Scan - {imageDate}"

#: src/pages/assetLens/components/tabs/imagesTabComponents/ImageGalleryView.tsx
msgid "IR Scan from {imageDate}"
msgstr "IR Scan from {imageDate}"

#: src/pages/details/extensions/flow/filesExt/FileTags.tsx
msgid "is tagged as a report"
msgstr "is tagged as a report"

#: src/features/lotoReports/printReport/printPageText.ts
msgid "Isolated"
msgstr "Isolated"

#: src/pages/evaluations/metadata/labeling/utils/pageClassificationTaxonomy.ts
msgid "Isolated pipe spool fabrication"
msgstr "Isolated pipe spool fabrication"

#: src/features/lotoReports/printReport/printPageText.ts
msgid "Isolation point (record sheet row)"
msgstr "Isolation point (record sheet row)"

#: src/features/lotoReports/components/LotoIsolationPointsTable.tsx
#: src/features/lotoReports/components/LotoReportsTable.tsx
msgid "Isolation points"
msgstr "Isolation points"

#: src/features/lotoReports/components/LotoPointsCoverage.tsx
msgid "Isolation points in hang order"
msgstr "Isolation points in hang order"

#: src/features/lotoReports/components/LotoSheetEditor.tsx
msgid "Isolation points on page {pageNumber}"
msgstr "Isolation points on page {pageNumber}"

#: src/pages/assetLens/components/tabs/SensorIssuesTab.tsx
msgid "Issue Severity"
msgstr "Issue Severity"

#: src/features/chatbot/components/ChatbotHelpModal.tsx
msgid "Issue Type"
msgstr "Issue Type"

#: src/features/knowledgeDocumentViewer/components/sidebar/FeedbackModal.tsx
msgid "Issue Type *"
msgstr "Issue Type *"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
#: src/features/knowledgeDocumentViewer/workOrders/legacyCmmsRecordPdf.ts
msgid "Issue unit"
msgstr "Issue unit"

#: src/features/lotoReports/components/LotoSheetHeaderFields.tsx
msgid "Issued by"
msgstr "Issued by"

#: src/features/lotoReports/recordSheet/recordSheetLayout.ts
msgid "ISSUED BY:"
msgstr "ISSUED BY:"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
#: src/features/knowledgeDocumentViewer/workOrders/legacyCmmsRecordPdf.ts
msgid "Issued quantity"
msgstr "Issued quantity"

#: src/features/timeSeries/components/LabelsTab.tsx
msgid "It is removed from every chart at this site."
msgstr "It is removed from every chart at this site."

#: src/features/richText/components/ToolbarPlugin.tsx
msgid "Italic (Ctrl+I)"
msgstr "Italic (Ctrl+I)"

#: src/features/chatbot/components/AttachmentPills.tsx
msgid "item"
msgstr "item"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
#: src/features/knowledgeDocumentViewer/workOrders/legacyCmmsRecordPdf.ts
#: src/features/knowledgeDocumentViewer/workOrders/legacyCmmsRecordPdf.ts
msgid "Item"
msgstr "Item"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
#: src/features/knowledgeDocumentViewer/workOrders/legacyCmmsRecordPdf.ts
msgid "Item set"
msgstr "Item set"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
msgid "Item type"
msgstr "Item type"

#: src/features/knowledgeDocumentViewer/workOrders/legacyCmmsRecordPdf.ts
msgid "Item vendors"
msgstr "Item vendors"

#: src/pages/evaluations/metadata/dashboard/components/dataLabeling/DataLabelingDashboardSites.tsx
msgid "Items"
msgstr "Items"

#: src/pages/details/extensions/flow/filesExt/FileTags.tsx
msgid "Job"
msgstr "Job"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
#: src/features/knowledgeDocumentViewer/workOrders/legacyCmmsRecordPdf.ts
#: src/features/knowledgeDocumentViewer/workOrders/legacyCmmsRecordPdf.ts
msgid "Job plan"
msgstr "Job plan"

#: src/features/knowledgeDocumentViewer/workOrders/workOrderPresentation.ts
msgid "Job plan (jpnum)"
msgstr "Job plan (jpnum)"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
#: src/features/knowledgeDocumentViewer/workOrders/legacyCmmsRecordPdf.ts
msgid "Job task"
msgstr "Job task"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
#: src/features/knowledgeDocumentViewer/workOrders/legacyCmmsRecordPdf.ts
#: src/features/knowledgeDocumentViewer/workOrders/workOrderFields.ts
msgid "Job-plan revision"
msgstr "Job-plan revision"

#: src/features/navbar/navConfig.ts
msgid "Jobs Overview"
msgstr "Jobs Overview"

#: src/features/timeSeries/experiment/TransparencyStrip.tsx
msgid "Joined rows"
msgstr "Joined rows"

#: src/pages/details/extensions/flow/assetModelEditorExt/AssetModelEditorRawJSON.tsx
msgid ""
"JSON appears to be malformed! Error below:\n"
"\n"
"{error}"
msgstr ""
"JSON appears to be malformed! Error below:\n"
"\n"
"{error}"

#: src/features/timeSeries/services/workOrderService.ts
msgid "JSON data must be an array of work orders."
msgstr "JSON data must be an array of work orders."

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatEvalCaseReview.tsx
msgid "Judge criterion"
msgstr "Judge criterion"

#: src/pages/homepage/Homepage.tsx
msgid "JUMP TO"
msgstr "JUMP TO"

#: src/features/timeSeries/components/timeSeriesScatterplot/NoDataInRange.tsx
msgid "Jump to later data →"
msgstr "Jump to later data →"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/JumpToLatestButton.tsx
msgid "Jump to latest"
msgstr "Jump to latest"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/JumpToLatestButton.tsx
msgid "Jump to latest message"
msgstr "Jump to latest message"

#: src/features/knowledgeDocumentViewer/components/table/enhancements/Pagination.tsx
msgid "Jump to page {page}"
msgstr "Jump to page {page}"

#: src/features/fimReview/relativeTime.ts
#: src/features/modelOperations/fimShared.ts
#: src/features/timeSeries/sentinelStudio/SentinelBuilderPanel.tsx
msgid "just now"
msgstr "just now"

#: src/features/timeSeries/experiment/knobCopy.ts
msgid "k-nearest-neighbors / APR: expected target = mean of the k most similar historical current-driver snapshots (partial distance if some drivers are missing). No parametric fit; bounded by history."
msgstr "k-nearest-neighbors / APR: expected target = mean of the k most similar historical current-driver snapshots (partial distance if some drivers are missing). No parametric fit; bounded by history."

#: src/features/fim/photos/PhotoRemoveButton.tsx
#: src/features/timeSeries/components/PenTransformControls.tsx
msgid "Keep"
msgstr "Keep"

#: src/features/timeSeries/experiment/CleaningControls.tsx
msgid "Keep only rows where this tag is in [min, max]. Rows where it falls outside the range are removed across all tags (operating-regime filter)."
msgstr "Keep only rows where this tag is in [min, max]. Rows where it falls outside the range are removed across all tags (operating-regime filter)."

#: src/features/timeSeries/agentTab/dock/SettingsTab.tsx
msgid "Keep pens the model does not use (hidden)"
msgstr "Keep pens the model does not use (hidden)"

#: src/features/navbar/KeyboardShortcutsToggle.tsx
msgid "Keyboard Shortcuts"
msgstr "Keyboard Shortcuts"

#: src/features/facilityModel/columns.ts
#: src/features/fimReview/IdentityPanel.tsx
#: src/features/fimReview/ReviewActions.tsx
#: src/features/fimReview/ReviewActions.tsx
#: src/features/fimReview/ReviewActions.tsx
#: src/features/fimReview/StructuralReviewFlow.tsx
#: src/features/fimReview/StructuralReviewFlow.tsx
#: src/features/knowledgeDocumentViewer/components/sidebar/SubjectDocumentsPanel.tsx
#: src/features/modelOperations/SubjectDetails.tsx
#: src/pages/facilityModel/FacilityModelFilters.tsx
#: src/pages/facilityModel/SubjectDetailPage.tsx
msgid "Kind"
msgstr "Kind"

#: src/features/fimReview/DecisionHistory.tsx
msgid "kind → {kind}"
msgstr "kind → {kind}"

#: src/features/fimReview/InspectSources.tsx
msgid "Kind guess"
msgstr "Kind guess"

#: src/features/sentinels/methodLabels.ts
msgid "kNN"
msgstr "kNN"

#: src/features/timeSeries/experiment/knobCopy.ts
msgid "knn — similarity baseline"
msgstr "knn — similarity baseline"

#: src/pages/processData/buildMode/dock/ModelDockTab.tsx
msgid "kNN / APR"
msgstr "kNN / APR"

#: src/features/timeSeries/agentTab/dock/FitTab.tsx
msgid "kNN drivers · the conditions that define “expected”"
msgstr "kNN drivers · the conditions that define “expected”"

#: src/features/timeSeries/agentTab/dock/AgentDock.tsx
msgid "kNN fit"
msgstr "kNN fit"

#: src/features/timeSeries/experiment/ModelKnobs.tsx
msgid "kNN k"
msgstr "kNN k"

#: src/features/timeSeries/experiment/DiagnosticsPanel.tsx
msgid "kNN library ({librarySize} pts) — first example neighbors"
msgstr "kNN library ({librarySize} pts) — first example neighbors"

#: src/features/timeSeries/experiment/ModelKnobs.tsx
#: src/pages/processData/buildMode/dock/ModelDockTab.tsx
msgid "kNN library cap"
msgstr "kNN library cap"

#: src/features/timeSeries/experiment/DiagnosticsPanel.tsx
msgid "kNN neighbor picks (sample queries)"
msgstr "kNN neighbor picks (sample queries)"

#: src/features/timeSeries/experiment/RunComparison.tsx
msgid "knn_cap {value77_28}→{value77_45}"
msgstr "knn_cap {value77_28}→{value77_45}"

#: src/features/timeSeries/experiment/RunComparison.tsx
msgid "knn_k {value75_49}→{value75_60}"
msgstr "knn_k {value75_49}→{value75_60}"

#: src/features/timeSeries/agentTab/dock/BacktestTab.tsx
msgid "Known events"
msgstr "Known events"

#: src/features/mdCases/components/ProvenanceContentViewer.tsx
#: src/features/mdCases/components/ProvenanceContentViewer.tsx
msgid "Known unknowns"
msgstr "Known unknowns"

#: src/features/timeSeries/agentTab/AgentHeader.tsx
msgid "KPI line unavailable"
msgstr "KPI line unavailable"

#: src/features/timeSeries/agentTab/AgentHeader.tsx
msgid "KPI not chartable"
msgstr "KPI not chartable"

#: src/features/timeSeries/agentTab/AgentHeader.tsx
msgid "KPI only"
msgstr "KPI only"

#: src/pages/processData/components/helpGuide/HelpGuideChapters.tsx
msgid "Label"
msgstr "Label"

#: src/pages/evaluations/metadata/dashboard/components/dataLabeling/DataLabelingDashboardLabelDataButton.tsx
msgid "Label data"
msgstr "Label data"

#: src/pages/evaluations/metadata/labeling/components/DataLabelingLanding.tsx
msgid "Label one page at a time, or browse pages you already confirmed or deferred."
msgstr "Label one page at a time, or browse pages you already confirmed or deferred."

#: src/pages/evaluations/metadata/components/LabelingActions.tsx
#: src/pages/evaluations/metadata/components/LabelingActions.tsx
msgid "Label pages"
msgstr "Label pages"

#: src/pages/evaluations/metadata/labeling/components/DataLabelingStatusFilter.tsx
msgid "Label status"
msgstr "Label status"

#: src/features/timeSeries/components/labelTool/LabelConfigPanel.tsx
msgid "Label title"
msgstr "Label title"

#: src/pages/details/visualization/markupEditing/EditToolBar.tsx
msgid "Label tool"
msgstr "Label tool"

#: src/pages/evaluations/metadata/labeling/components/DataLabelingLabeledByFilter.tsx
msgid "Labeled by"
msgstr "Labeled by"

#: src/features/knowledgeDocumentViewer/components/metadata/PageMetadataEvalLabeledByBadge.tsx
msgid "Labeled by {labeledBy}"
msgstr "Labeled by {labeledBy}"

#: src/pages/evaluations/metadata/labeling/components/DataLabelingLabeledByFilter.tsx
#: src/pages/evaluations/metadata/labeling/components/DataLabelingLandingCounts.tsx
msgid "Labeled by me"
msgstr "Labeled by me"

#: src/pages/evaluations/metadata/labeling/components/DataLabelingLabeledByFilter.tsx
msgid "Labeled by NAES"
msgstr "Labeled by NAES"

#: src/pages/evaluations/metadata/dashboard/components/DashboardComparisonRows.tsx
msgid "Labeler coverage of reviewer pages"
msgstr "Labeler coverage of reviewer pages"

#: src/pages/evaluations/metadata/dashboard/components/DashboardComparisonRows.tsx
msgid "Labelers vs pipeline"
msgstr "Labelers vs pipeline"

#: src/pages/evaluations/metadata/components/MetricsCard.tsx
#: src/pages/evaluations/metadata/dashboard/components/dataLabeling/DataLabelingDashboardBreadcrumb.tsx
#: src/pages/evaluations/metadata/dashboard/components/dataLabeling/DataLabelingDashboardBreadcrumb.tsx
#: src/pages/evaluations/metadata/dashboard/components/dataLabeling/DataLabelingDashboardFrame.tsx
#: src/pages/evaluations/metadata/dashboard/MetadataEvalsPage.tsx
msgid "Labeling eval"
msgstr "Labeling eval"

#: src/features/knowledgeDocumentViewer/components/toolbar/KnowledgeDocumentHeaderBar.tsx
msgid "Labeling mode"
msgstr "Labeling mode"

#: src/features/timeSeries/components/ScatterplotSidebar.tsx
#: src/pages/processData/buildMode/dock/EvalLabelTable.tsx
#: src/pages/processData/components/WorkbenchChartArea.tsx
msgid "Labels"
msgstr "Labels"

#: src/pages/processData/buildMode/dock/EvalLabelTable.tsx
msgid "Labels are drawn in View mode with the Label tool; ones touching the target show up here."
msgstr "Labels are drawn in View mode with the Label tool; ones touching the target show up here."

#: src/pages/processData/buildMode/dock/CompareDockTab.tsx
msgid "labels hit"
msgstr "labels hit"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
#: src/features/knowledgeDocumentViewer/workOrders/legacyCmmsRecordPdf.ts
msgid "Labor"
msgstr "Labor"

#: src/features/knowledgeDocumentViewer/workOrders/workOrderPdf.ts
msgid "Labor and cost totals"
msgstr "Labor and cost totals"

#: src/features/knowledgeDocumentViewer/workOrders/workOrderPdf.ts
msgid "Labor cost"
msgstr "Labor cost"

#: src/features/knowledgeDocumentViewer/workOrders/workOrderPdf.ts
msgid "Labor hours"
msgstr "Labor hours"

#: src/features/navbar/LanguageToggle.tsx
msgid "Language"
msgstr "Language"

#: src/features/forecastNotifications/NotificationListPanel.tsx
msgid "Last 14 Days"
msgstr "Last 14 Days"

#: src/features/timeSeries/components/ActiveTimeRangeSectionWithPopover.tsx
#: src/features/timeSeries/components/TimeRangeSelector.tsx
msgid "Last 24 Hours"
msgstr "Last 24 Hours"

#: src/features/timeSeries/components/ActiveTimeRangeSectionWithPopover.tsx
#: src/features/timeSeries/components/TimeRangeSelector.tsx
msgid "Last 3 Months"
msgstr "Last 3 Months"

#: src/features/forecastNotifications/NotificationListPanel.tsx
#: src/features/timeSeries/components/ActiveTimeRangeSectionWithPopover.tsx
#: src/features/timeSeries/components/TimeRangeSelector.tsx
msgid "Last 30 Days"
msgstr "Last 30 Days"

#: src/features/timeSeries/agentTab/chat/BuildCard.tsx
msgid "last 30d <0>{last30Actual}</0> vs expected <1>{last30Expected}</1>"
msgstr "last 30d <0>{last30Actual}</0> vs expected <1>{last30Expected}</1>"

#: src/features/timeSeries/agentTab/dock/TargetTab.tsx
msgid "last 30d actual"
msgstr "last 30d actual"

#: src/features/timeSeries/components/ActiveTimeRangeSectionWithPopover.tsx
#: src/features/timeSeries/components/TimeRangeSelector.tsx
msgid "Last 5 Years"
msgstr "Last 5 Years"

#: src/features/forecastNotifications/NotificationListPanel.tsx
#: src/features/timeSeries/components/ActiveTimeRangeSectionWithPopover.tsx
#: src/features/timeSeries/components/TimeRangeSelector.tsx
msgid "Last 7 Days"
msgstr "Last 7 Days"

#: src/features/timeSeries/components/ActiveTimeRangeSectionWithPopover.tsx
#: src/features/timeSeries/components/TimeRangeSelector.tsx
msgid "Last 8 Hours"
msgstr "Last 8 Hours"

#: src/features/forecastNotifications/NotificationListPanel.tsx
msgid "Last 90 Days"
msgstr "Last 90 Days"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
#: src/features/knowledgeDocumentViewer/workOrders/legacyCmmsRecordPdf.ts
msgid "Last cost"
msgstr "Last cost"

#: src/pages/facilityModel/SentinelOverviewPage.tsx
msgid "Last detection"
msgstr "Last detection"

#: src/features/lotoReports/components/LotoReportsTable.tsx
msgid "Last edited"
msgstr "Last edited"

#: src/features/timeSeries/agentTab/dock/TargetTab.tsx
msgid "last fit"
msgstr "last fit"

#: src/features/timeSeries/components/ActiveTimeRangeSectionWithPopover.tsx
#: src/features/timeSeries/components/TimeRangeSelector.tsx
msgid "Last Hour"
msgstr "Last Hour"

#: src/pages/overview/sidebar/table/SiteViewSidebarTableOrganizers.tsx
msgid "Last Inspected"
msgstr "Last Inspected"

#: src/pages/systemView/components/unitsTab/UnitListItem.tsx
msgid "Last inspection: {lastInspectionLabel}"
msgstr "Last inspection: {lastInspectionLabel}"

#: src/features/knowledgeDocumentViewer/components/viewer/shared/TooltipSparkline.tsx
msgid "Last measured: {lastMeasuredText}"
msgstr "Last measured: {lastMeasuredText}"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
#: src/features/knowledgeDocumentViewer/workOrders/legacyCmmsRecordPdf.ts
msgid "Last recorded completion date"
msgstr "Last recorded completion date"

#: src/features/timeSeries/agentTab/dock/AlertingTab.tsx
msgid "last run"
msgstr "last run"

#: src/features/sentinels/components/MonitorTab.tsx
msgid "Last scored "
msgstr "Last scored "

#: src/pages/cases/md/MdCaseDetailsPage.tsx
msgid "Last update failed"
msgstr "Last update failed"

#: src/pages/cases/components/CasesTableColumns.tsx
msgid "Last Updated"
msgstr "Last Updated"

#: src/features/timeSeries/components/ActiveTimeRangeSectionWithPopover.tsx
#: src/features/timeSeries/components/TimeRangeSelector.tsx
msgid "Last Year"
msgstr "Last Year"

#: src/features/knowledgeDocumentViewer/components/metadata/RevisionFamilyCard.tsx
msgid "Latest"
msgstr "Latest"

#: src/features/knowledgeDocumentViewer/components/viewer/search/DocReferencePreviewCard.tsx
msgid "Latest of {matchCount} revisions — click to open"
msgstr "Latest of {matchCount} revisions — click to open"

#: src/pages/evaluations/metadata/labeling/utils/pageClassificationTaxonomy.ts
msgid "Layouts, geometry and fabrication"
msgstr "Layouts, geometry and fabrication"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
#: src/features/knowledgeDocumentViewer/workOrders/workOrderFields.ts
msgid "Lead"
msgstr "Lead"

#: src/features/timeSeries/agentTab/dock/BacktestTab.tsx
msgid "lead (days)"
msgstr "lead (days)"

#: src/pages/documents/PowerCustomerUploadLeaveWarning.tsx
msgid "Leave and cancel upload"
msgstr "Leave and cancel upload"

#: src/pages/cases/components/CaseFeedbackModal.tsx
msgid "Leave blank"
msgstr "Leave blank"

#: src/pages/documents/PowerCustomerUploadLeaveWarning.tsx
msgid "Leave document upload?"
msgstr "Leave document upload?"

#: src/features/knowledgeDocumentViewer/components/photoMode/PhotoModeHeader.tsx
msgid "Leave photo mode"
msgstr "Leave photo mode"

#: src/features/copcPointClouds/CopcOrientationCube.tsx
msgid "Left"
msgstr "Left"

#: src/features/workbench/LayoutToggles.tsx
msgid "left panel"
msgstr "left panel"

#: src/features/timeSeries/experiment/knobCopy.ts
msgid "Left: minimum aligned rows required to train at all. Right: minimum observed-target train rows (and usable-driver kNN rows). Production uses 1000 / 300; lab defaults are relaxed for faster iteration."
msgstr "Left: minimum aligned rows required to train at all. Right: minimum observed-target train rows (and usable-driver kNN rows). Production uses 1000 / 300; lab defaults are relaxed for faster iteration."

#: src/features/knowledgeDocumentViewer/utils/documentTypeLabels.ts
#: src/pages/evaluations/metadata/labeling/utils/pageClassificationTaxonomy.ts
msgid "Legend"
msgstr "Legend"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/documentsTableView/DocumentTableColumns.tsx
msgid "Length"
msgstr "Length"

#: src/features/timeSeries/experiment/knobCopy.ts
msgid "Length of the trailing rolling mean on each driver (and on the target when Self history is on), in sample periods. Default 6 → 60 min at a 10 min interval. Smooths short noise; larger windows blur faster dynamics."
msgstr "Length of the trailing rolling mean on each driver (and on the target when Self history is on), in sample periods. Default 6 → 60 min at a 10 min interval. Smooths short noise; larger windows blur faster dynamics."

#: src/features/timeSeries/agentTab/dock/AlertingTab.tsx
msgid "level"
msgstr "level"

#: src/features/timeSeries/agentTab/dock/AlertingTab.tsx
msgid "Level — sustained drift"
msgstr "Level — sustained drift"

#: src/features/navbar/navConfig.ts
msgid "Libra"
msgstr "Libra"

#: src/pages/processData/buildMode/dock/ModelDockTab.tsx
msgid "Library cap (0 = all)"
msgstr "Library cap (0 = all)"

#: src/features/timeSeries/components/ScatterplotSidebarDefault.tsx
#: src/features/timeSeries/components/YScaleControls.tsx
#: src/pages/processData/components/helpGuide/HelpGuideChapters.tsx
msgid "Line"
msgstr "Line"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
#: src/features/knowledgeDocumentViewer/workOrders/legacyCmmsRecordPdf.ts
msgid "Line cost"
msgstr "Line cost"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
#: src/features/knowledgeDocumentViewer/workOrders/legacyCmmsRecordPdf.ts
msgid "Line cost in transaction currency"
msgstr "Line cost in transaction currency"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
#: src/features/knowledgeDocumentViewer/workOrders/legacyCmmsRecordPdf.ts
#: src/features/knowledgeDocumentViewer/workOrders/legacyCmmsRecordPdf.ts
#: src/features/knowledgeDocumentViewer/workOrders/legacyCmmsRecordPdf.ts
msgid "Line number"
msgstr "Line number"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
#: src/features/knowledgeDocumentViewer/workOrders/legacyCmmsRecordPdf.ts
msgid "Line type"
msgstr "Line type"

#: src/features/timeSeries/experiment/knobCopy.ts
msgid "Linear: OLS residual on the tags. Ratio: target ÷ first against-tag (efficiency-style). Quadratic: OLS on x and x² (curved responses). Log: OLS on ln x — rows with x ≤ 0 are skipped. Power: log-log OLS (y = scale·xᵇ, reports the exponent) — needs x and y > 0. None trains a Sentinel — just intuition for drivers."
msgstr "Linear: OLS residual on the tags. Ratio: target ÷ first against-tag (efficiency-style). Quadratic: OLS on x and x² (curved responses). Log: OLS on ln x — rows with x ≤ 0 are skipped. Power: log-log OLS (y = scale·xᵇ, reports the exponent) — needs x and y > 0. None trains a Sentinel — just intuition for drivers."

#: src/features/knowledgeDocumentViewer/workOrders/WorkOrderViewer.tsx
#: src/pages/systemView/components/SystemViewAnnotationSidebar.tsx
msgid "Link copied"
msgstr "Link copied"

#: src/features/knowledgeDocumentViewer/components/toolbar/SettingsMenu.tsx
msgid "Link highlights"
msgstr "Link highlights"

#: src/pages/cases/md/mdCaseDetailsHelpers.ts
msgid "Link reference"
msgstr "Link reference"

#: src/pages/cases/md/MdCaseDetailsInspector.tsx
msgid "Linked Alerts"
msgstr "Linked Alerts"

#: src/features/mdCases/components/CaseStorySection.tsx
msgid "Linked detection"
msgstr "Linked detection"

#: src/features/timeSeries/components/PenDrawer.tsx
msgid "Linked subjects for {value769_55}"
msgstr "Linked subjects for {value769_55}"

#: src/pages/assetLens/components/tabs/DocumentsTab.tsx
msgid "List Documents"
msgstr "List Documents"

#: src/features/timeSeries/agentTab/toolSentence.ts
msgid "Listed the saved models"
msgstr "Listed the saved models"

#: src/features/timeSeries/agentTab/toolSentence.ts
msgid "Listing the saved models"
msgstr "Listing the saved models"

#: src/features/timeSeries/components/ActiveTimeRangeModeTag.tsx
msgid "Live"
msgstr "Live"

#: src/features/sentinels/components/DesignRunOverviewSections.tsx
msgid "Live check"
msgstr "Live check"

#: src/features/sentinels/components/DesignRunOverviewSections.tsx
msgid "Live check — score a recent window with the saved models"
msgstr "Live check — score a recent window with the saved models"

#: src/features/timeSeries/experiment/knobCopy.ts
msgid "Live count of how many points survive each stage: raw aggregate grid → cleaning → target-observed → lag warm-up → train/val/test → estimated fit/calib rows. Also shows each tag’s native sample spacing vs the chosen interval."
msgstr "Live count of how many points survive each stage: raw aggregate grid → cleaning → target-observed → lag warm-up → train/val/test → estimated fit/calib rows. Also shows each tag’s native sample spacing vs the chosen interval."

#: src/features/timeSeries/components/RelativeDateConfig.tsx
#: src/features/timeSeries/components/RelativeDateConfig.tsx
#: src/pages/processData/components/helpGuide/HelpGuideChapters.tsx
msgid "Live Tail"
msgstr "Live Tail"

#: src/features/timeSeries/experiment/ExperimentTab.tsx
msgid "Live train progress"
msgstr "Live train progress"

#: src/features/assetVizAdapter/MeasurementStrip.tsx
msgid "Lo"
msgstr "Lo"

#: src/features/timeSeries/experiment/ExperimentTab.tsx
msgid "Load"
msgstr "Load"

#: src/pages/processData/buildMode/rightPanel/SavedModelShelf.tsx
msgid "Load {value215_29}"
msgstr "Load {value215_29}"

#: src/pages/processData/components/ProcessDataTopBar.tsx
msgid "Load a model to configure it"
msgstr "Load a model to configure it"

#: src/features/timeSeries/components/timeSeriesScatterplot/PenCapNotice.tsx
msgid "Load all {value65_29} pens. This chart may take minutes to load and will be hard to read."
msgstr "Load all {value65_29} pens. This chart may take minutes to load and will be hard to read."

#: src/features/chatbot/hooks/useReconnect.ts
msgid "Load messages failed"
msgstr "Load messages failed"

#: src/features/embeddedSidebar/chatHistory/AgenticChatHistorySidebar.tsx
#: src/features/sentinels/components/SentinelAlertsPanel.tsx
#: src/pages/facilityModel/SentinelOverviewPage.tsx
msgid "Load more"
msgstr "Load more"

#: src/features/timeSeries/experiment/ExperimentTab.tsx
msgid "Loaded {value360_18}{value360_43}"
msgstr "Loaded {value360_18}{value360_43}"

#: src/features/timeSeries/agentTab/toolSentence.ts
msgid "Loaded a saved model"
msgstr "Loaded a saved model"

#: src/features/timeSeries/agentTab/toolSentence.ts
msgid "Loaded a saved model ({shortId})"
msgstr "Loaded a saved model ({shortId})"

#: src/features/timeSeries/components/ActiveTimeRangeSelector.tsx
#: src/features/timeSeries/components/timeSeriesScatterplot/TimeSeriesScatterplotChart.tsx
#: src/features/timeSeries/components/timeSeriesScatterplot/TimeSeriesScatterplotChart.tsx
msgid "Loading"
msgstr "Loading"

#: src/pages/processData/buildMode/dock/CompareDockTab.tsx
msgid "Loading "
msgstr "Loading "

#: src/pages/cases/components/RelatedObjectsSection.tsx
msgid "Loading {lowerCaseTitle}..."
msgstr "Loading {lowerCaseTitle}..."

#: src/features/timeSeries/agentTab/toolSentence.ts
msgid "Loading a saved model"
msgstr "Loading a saved model"

#: src/features/timeSeries/agentTab/toolSentence.ts
msgid "Loading a saved model ({shortId})"
msgstr "Loading a saved model ({shortId})"

#: src/pages/evaluations/metadata/dashboard/components/dataLabeling/DataLabelingDashboardOverview.tsx
msgid "Loading active pipeline comparisons…"
msgstr "Loading active pipeline comparisons…"

#: src/pages/cases/activity/ActivityFeed.tsx
msgid "Loading activity..."
msgstr "Loading activity..."

#: src/pages/alerts/AlertDetails.tsx
msgid "Loading alert…"
msgstr "Loading alert…"

#: src/features/sentinels/components/SentinelAlertsPanel.tsx
msgid "Loading alerts…"
msgstr "Loading alerts…"

#: src/features/embeddedSidebar/chatHistory/AgenticChatHistorySidebar.tsx
msgid "Loading archived chats…"
msgstr "Loading archived chats…"

#: src/pages/assetLens/components/tabs/SensorIssuesTab.tsx
msgid "Loading asset information..."
msgstr "Loading asset information..."

#: src/features/sentinels/SentinelInstancePicker.tsx
msgid "Loading asset instances…"
msgstr "Loading asset instances…"

#: src/pages/cases/components/CaseDetailsContent.tsx
#: src/pages/cases/components/EditCaseForm.tsx
#: src/pages/cases/md/MdCaseDetailsPage.tsx
msgid "Loading case..."
msgstr "Loading case..."

#: src/features/sentinels/components/CasesPanel.tsx
msgid "Loading cases…"
msgstr "Loading cases…"

#: src/features/knowledgeDocumentViewer/components/revisionCompare/RevisionCompareContent.tsx
msgid "Loading changes…"
msgstr "Loading changes…"

#: src/features/mdCases/components/MonitorLineagePanel.tsx
msgid "Loading chat session…"
msgstr "Loading chat session…"

#: src/features/embeddedSidebar/chatHistory/AgenticChatHistorySidebar.tsx
msgid "Loading chats…"
msgstr "Loading chats…"

#: src/features/richText/components/slashCommandCards/UnitConfigurationModal.tsx
msgid "Loading color scale..."
msgstr "Loading color scale..."

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/RevisionComparePreviewPanel.tsx
msgid "Loading comparison…"
msgstr "Loading comparison…"

#: src/features/timeSeries/agentTab/chat/ConversationDrawer.tsx
msgid "Loading conversations"
msgstr "Loading conversations"

#: src/pages/evaluations/metadata/dashboard/components/dataLabeling/DataLabelingDashboard.tsx
#: src/pages/evaluations/metadata/dashboard/components/dataLabeling/DataLabelingDashboardOrg.tsx
msgid "Loading dashboard metrics…"
msgstr "Loading dashboard metrics…"

#: src/features/timeSeries/components/ScatterPlotTableConfig.tsx
#: src/features/timeSeries/components/ScatterPlotTableLegend.tsx
msgid "Loading data for the plot..."
msgstr "Loading data for the plot..."

#: src/features/timeSeries/experiment/ExperimentTab.tsx
msgid "Loading data preview…"
msgstr "Loading data preview…"

#: src/features/richText/components/slashCommandCards/UnitConfigurationModal.tsx
msgid "Loading data statistics..."
msgstr "Loading data statistics..."

#: src/features/knowledgeDocumentViewer/components/metadata/DocumentMetadataContent.tsx
msgid "Loading document details…"
msgstr "Loading document details…"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocumentResultsContent.tsx
msgid "Loading document preview"
msgstr "Loading document preview"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocumentResultsFooter.tsx
msgid "Loading document result controls"
msgstr "Loading document result controls"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocumentResultsContent.tsx
msgid "Loading document results"
msgstr "Loading document results"

#: src/features/knowledgeDocumentViewer/components/viewer/PagedDocumentViewer.tsx
msgid "Loading document..."
msgstr "Loading document..."

#: src/pages/assetLens/components/tabs/DocumentsTab.tsx
msgid "Loading documents"
msgstr "Loading documents"

#: src/features/chatbot/components/DocumentAttachmentPopover.tsx
msgid "Loading documents..."
msgstr "Loading documents..."

#: src/features/knowledgeDocumentViewer/components/sidebar/GraphNodePanel.tsx
#: src/features/knowledgeDocumentViewer/components/sidebar/SubjectDocumentsPanel.tsx
msgid "Loading documents…"
msgstr "Loading documents…"

#: src/features/lotoReports/components/LotoDrawingsCoverage.tsx
msgid "Loading drawings"
msgstr "Loading drawings"

#: src/features/lotoReports/components/LotoTargetDrawings.tsx
msgid "Loading drawings…"
msgstr "Loading drawings…"

#: src/features/cases/components/SupplementaryLinksActivityContent.tsx
#: src/features/richText/editorPlugins/SlashCommandPlugin.tsx
msgid "Loading entries..."
msgstr "Loading entries..."

#: src/pages/facilityModel/FacilityModelCatalog.tsx
#: src/pages/facilityModel/FacilityModelTable.tsx
msgid "Loading facility model…"
msgstr "Loading facility model…"

#: src/features/kestrelViewer/ui/tools/photoreel/PhotoViewer.tsx
msgid "Loading full-resolution photo"
msgstr "Loading full-resolution photo"

#: src/features/fim/photos/PhotoLightbox.tsx
msgid "Loading full-resolution photo…"
msgstr "Loading full-resolution photo…"

#: src/features/knowledgeDocumentViewer/graph/useDocumentGraph.ts
msgid "Loading graph…"
msgstr "Loading graph…"

#: src/features/richText/nodes/ImageNode.tsx
msgid "Loading image..."
msgstr "Loading image..."

#: src/pages/details/extensions/flow/ImageryExtension.tsx
msgid "Loading images at "
msgstr "Loading images at "

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatInspectionViewer.tsx
#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatInspectionViewer.tsx
msgid "Loading inspection data…"
msgstr "Loading inspection data…"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatInspectionViewer.tsx
#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/InspectionPreviewPanel.tsx
#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/ReportAssetView.tsx
msgid "Loading inspection model…"
msgstr "Loading inspection model…"

#: src/pages/details/visualization/tools/KestrelTools.tsx
msgid "Loading Kestrel..."
msgstr "Loading Kestrel..."

#: src/features/mdCases/components/MonitorLineagePanel.tsx
msgid "Loading lineage…"
msgstr "Loading lineage…"

#: src/features/lotoReports/components/LotoReportEditorLoading.tsx
msgid "Loading LOTO report"
msgstr "Loading LOTO report"

#: src/features/lotoReports/components/LotoReportsLoading.tsx
msgid "Loading LOTO reports"
msgstr "Loading LOTO reports"

#: src/features/lotoReports/components/LotoPagePanel.tsx
msgid "Loading LOTO reports…"
msgstr "Loading LOTO reports…"

#: src/pages/cases/md/MdCasesListPage.tsx
msgid "Loading M&D cases…"
msgstr "Loading M&D cases…"

#: src/pages/evaluations/metadata/components/OrganizationMetrics.tsx
msgid "Loading metadata evaluation metrics…"
msgstr "Loading metadata evaluation metrics…"

#: src/features/kestrelUpload/KestrelModelUploadSection.tsx
msgid "Loading model files…"
msgstr "Loading model files…"

#: src/features/sentinels/components/MonitorTab.tsx
msgid "Loading monitor config…"
msgstr "Loading monitor config…"

#: src/features/forecastNotifications/NotificationListPanel.tsx
#: src/features/forecastNotifications/NotificationsDropdownContent.tsx
msgid "Loading notifications..."
msgstr "Loading notifications..."

#: src/pages/evaluations/metadata/components/MetricsCard.tsx
msgid "Loading organization…"
msgstr "Loading organization…"

#: src/features/knowledgeDocumentViewer/components/metadata/EvalPagePending.tsx
#: src/features/knowledgeDocumentViewer/components/metadata/PageMetadataContent.tsx
msgid "Loading page metadata…"
msgstr "Loading page metadata…"

#: src/features/facilityModel/components/ReferencePreviewPanel.tsx
msgid "Loading page preview…"
msgstr "Loading page preview…"

#: src/features/knowledgeDocumentViewer/components/revisionCompare/RevisionComparePane.tsx
#: src/features/lotoReports/components/LotoIsolationPointRow.tsx
#: src/features/lotoReports/components/LotoPagePlaceholder.tsx
#: src/features/lotoReports/components/LotoSessionOtherPages.tsx
msgid "Loading page…"
msgstr "Loading page…"

#: src/features/timeSeries/components/PenDrawer.tsx
msgid "Loading pens…"
msgstr "Loading pens…"

#: src/features/copcPointClouds/CopcViewerOverlay.tsx
msgid "Loading point cloud…"
msgstr "Loading point cloud…"

#: src/features/forecastNotifications/NotificationPreferencesModal.tsx
msgid "Loading preferences..."
msgstr "Loading preferences..."

#: src/features/knowledgeDocumentViewer/components/viewer/search/DocReferencePreviewCard.tsx
#: src/features/mdCases/components/ProvenanceContentViewer.tsx
#: src/features/mdCases/components/ProvenanceContentViewer.tsx
msgid "Loading preview…"
msgstr "Loading preview…"

#: src/features/chatbot/components/conversationMessage/ProposalCard.tsx
msgid "Loading proposal…"
msgstr "Loading proposal…"

#: src/pages/forgingsReporting/ForgingsReportPage.tsx
msgid "Loading report…"
msgstr "Loading report…"

#: src/features/knowledgeDocumentViewer/components/metadata/ScopeSummaryCard.tsx
msgid "Loading revision family edits…"
msgstr "Loading revision family edits…"

#: src/pages/processData/buildMode/rightPanel/SavedModelShelf.tsx
msgid "Loading saved models…"
msgstr "Loading saved models…"

#: src/pages/forgingsReporting/ForgingsReportingPage.tsx
msgid "Loading saved reports"
msgstr "Loading saved reports"

#: src/features/knowledgeDocumentViewer/components/viewer/shared/SparklineTooltipContent.tsx
msgid "Loading sensor data..."
msgstr "Loading sensor data..."

#: src/pages/facilityModel/SentinelDetailPage.tsx
msgid "Loading sentinel…"
msgstr "Loading sentinel…"

#: src/features/sentinels/components/SentinelList.tsx
#: src/pages/facilityModel/SentinelOverviewPage.tsx
msgid "Loading sentinels…"
msgstr "Loading sentinels…"

#: src/features/fimReview/InspectSources.tsx
msgid "Loading source records…"
msgstr "Loading source records…"

#: src/pages/facilityModel/SubjectDetailPage.tsx
msgid "Loading Subject…"
msgstr "Loading Subject…"

#: src/features/copcPointClouds/CopcSurfaceControl.tsx
msgid "Loading surface…"
msgstr "Loading surface…"

#: src/features/timeSeries/agentTab/chat/Transcript.tsx
msgid "Loading the conversation"
msgstr "Loading the conversation"

#: src/pages/alerts/components/AlertTimeSeriesChart.tsx
msgid "Loading time series data..."
msgstr "Loading time series data..."

#: src/features/facilityModel/catalogQuery.ts
msgid "Loading timed out — retry."
msgstr "Loading timed out — retry."

#: src/features/powerCustomerUploads/components/PowerCustomerUploadHistoryPanel.tsx
msgid "Loading upload history"
msgstr "Loading upload history"

#: src/features/richText/editorPlugins/MentionPluginBase.tsx
msgid "Loading users..."
msgstr "Loading users..."

#: src/features/assetLifecycleV2/views/observations/LtaObservationCompositeViz.tsx
msgid "Loading visualization..."
msgstr "Loading visualization..."

#: src/features/knowledgeDocumentViewer/components/metadata/RevisionFamilyDropdownItem.tsx
#: src/features/knowledgeDocumentViewer/components/toolbar/PdfDownloadMenuOptions.tsx
#: src/features/locale/GeckoLocaleProvider.tsx
#: src/features/locale/GeckoLocaleProvider.tsx
#: src/features/mdCases/components/ProvenanceContentViewer.tsx
#: src/features/nnpp/components/NnppPageFrame.tsx
#: src/features/timeSeries/agentTab/dock/VersionsTab.tsx
#: src/features/timeSeries/components/PenSubjectLinksSection.tsx
#: src/features/timeSeries/experiment/ExperimentTab.tsx
#: src/features/timeSeries/sentinelStudio/SentinelComparison.tsx
#: src/pages/details/rightSidebar/DetailsRightSidebar.tsx
#: src/pages/details/rightSidebar/DetailsRightSidebar.tsx
msgid "Loading…"
msgstr "Loading…"

#: src/features/knowledgeDocumentViewer/workOrders/workOrderPdf.ts
msgid "Local definitions are unverified. Only source flags set to true are shown; they do not verify permits, compliance or work performed."
msgstr "Local definitions are unverified. Only source flags set to true are shown; they do not verify permits, compliance or work performed."

#: src/features/powerCustomerUploads/components/PowerCustomerUploadStatus.tsx
msgid "Local issue"
msgstr "Local issue"

#: src/pages/details/extensions/fde/ffsLtaGeneration/FfsLtaGenerationSidebar.tsx
msgid "Local Thin Areas were generated, but the page could not refresh. Reload to see the latest data."
msgstr "Local Thin Areas were generated, but the page could not refresh. Reload to see the latest data."

#: src/features/knowledgeDocumentViewer/components/viewer/search/CitedTextBar.tsx
msgid "Locating cited text..."
msgstr "Locating cited text..."

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
#: src/features/knowledgeDocumentViewer/workOrders/legacyCmmsRecordPdf.ts
#: src/features/knowledgeDocumentViewer/workOrders/WorkOrderCardMetadata.tsx
#: src/features/knowledgeDocumentViewer/workOrders/workOrderPresentation.ts
#: src/pages/alerts/AlertDetails.tsx
#: src/pages/alerts/components/AssetInfoCard.tsx
msgid "Location"
msgstr "Location"

#: src/pages/assetLens/components/tabs/imagesTabComponents/ImageUploadModal.tsx
msgid "Location / Component Part"
msgstr "Location / Component Part"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
msgid "Location ancestor"
msgstr "Location ancestor"

#: src/features/knowledgeDocumentViewer/workOrders/legacyCmmsRecordPdf.ts
msgid "Location ancestors"
msgstr "Location ancestors"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
#: src/features/knowledgeDocumentViewer/workOrders/legacyCmmsRecordPdf.ts
msgid "Location hierarchy"
msgstr "Location hierarchy"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
msgid "Location meter"
msgstr "Location meter"

#: src/features/knowledgeDocumentViewer/workOrders/legacyCmmsRecordPdf.ts
msgid "Location meters"
msgstr "Location meters"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
msgid "Location specification"
msgstr "Location specification"

#: src/features/knowledgeDocumentViewer/workOrders/legacyCmmsRecordPdf.ts
msgid "Location specifications"
msgstr "Location specifications"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
msgid "Location system"
msgstr "Location system"

#: src/features/knowledgeDocumentViewer/workOrders/legacyCmmsRecordPdf.ts
msgid "Location systems"
msgstr "Location systems"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
#: src/features/knowledgeDocumentViewer/workOrders/legacyCmmsRecordPdf.ts
msgid "Location type"
msgstr "Location type"

#: src/features/lotoReports/recordSheet/recordSheetLayout.ts
msgid ""
"Lock\n"
"#"
msgstr ""
"Lock\n"
"#"

#: src/features/lotoReports/components/LotoSheetHeaderFields.tsx
msgid "Lock box #"
msgstr "Lock box #"

#: src/features/lotoReports/recordSheet/recordSheetLayout.ts
msgid "LOCK BOX #"
msgstr "LOCK BOX #"

#: src/features/auth/vendors/LoginPage.tsx
msgid "Log In"
msgstr "Log In"

#: src/features/navbar/profileAndSettings/ProfileAndSettingsSidebar.tsx
#: src/features/navbar/profileAndSettings/ProfileAndSettingsTopBar.tsx
msgid "Log out"
msgstr "Log out"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
msgid "Log type"
msgstr "Log type"

#: src/features/navbar/navConfig.ts
msgid "Logbook"
msgstr "Logbook"

#: src/features/knowledgeDocumentViewer/utils/documentTypeLabels.ts
msgid "Logic Diagram"
msgstr "Logic Diagram"

#: src/pages/evaluations/metadata/labeling/utils/pageClassificationTaxonomy.ts
msgid "Logic Diagram (I&C)"
msgstr "Logic Diagram (I&C)"

#: src/pages/processData/buildMode/dock/BacktestDockTab.tsx
msgid "Long range — the recompute can take tens of seconds."
msgstr "Long range — the recompute can take tens of seconds."

#: src/features/timeSeries/components/TimeRangeSelector.tsx
msgid "Long-term history"
msgstr "Long-term history"

#: src/features/timeSeries/experiment/TransparencyStrip.tsx
msgid "Longest gap"
msgstr "Longest gap"

#: src/features/assetLifecycleV2/views/observations/LtaObservationCompositeViz.tsx
msgid "Longitudinal Critical Thickness Profile"
msgstr "Longitudinal Critical Thickness Profile"

#: src/features/timeSeries/agentTab/dock/AlertingTab.tsx
msgid "look back"
msgstr "look back"

#: src/features/timeSeries/agentTab/toolSentence.ts
msgid "Looked inside a drawing"
msgstr "Looked inside a drawing"

#: src/features/timeSeries/agentTab/toolSentence.ts
msgid "Looked inside a drawing for {query}"
msgstr "Looked inside a drawing for {query}"

#: src/features/timeSeries/components/timeSeriesScatterplot/NoDataInRange.tsx
msgid "Looking for the nearest data…"
msgstr "Looking for the nearest data…"

#: src/features/timeSeries/agentTab/toolSentence.ts
msgid "Looking inside a drawing"
msgstr "Looking inside a drawing"

#: src/features/timeSeries/agentTab/toolSentence.ts
msgid "Looking inside a drawing for {query}"
msgstr "Looking inside a drawing for {query}"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatEvalCaseCitations.tsx
msgid "Looking up this document…"
msgstr "Looking up this document…"

#: src/pages/facilityModel/SubjectDetailPage.tsx
msgid "Looks right"
msgstr "Looks right"

#: src/features/chatbot/contexts/ChatbotDataLayer.tsx
msgid "Lost connection to the assistant. The response may still finish in the background — reload the conversation to check."
msgstr "Lost connection to the assistant. The response may still finish in the background — reload the conversation to check."

#: src/features/nnpp/nnppReportPresentation.ts
msgid "Lot number"
msgstr "Lot number"

#: src/features/lotoReports/components/LotoPagePanelHeader.tsx
msgid "LOTO"
msgstr "LOTO"

#: src/features/lotoReports/printReport/printPageText.ts
msgid "LOTO {lotoIndex} · {reportName}"
msgstr "LOTO {lotoIndex} · {reportName}"

#: src/features/lotoReports/components/LotoSheetHeaderFields.tsx
msgid "LOTO index #"
msgstr "LOTO index #"

#: src/features/lotoReports/components/LotoReportTableRow.tsx
msgid "LOTO index # {lotoIndex}"
msgstr "LOTO index # {lotoIndex}"

#: src/features/lotoReports/recordSheet/recordSheetLayout.ts
msgid "LOTO NDEX #:"
msgstr "LOTO NDEX #:"

#: src/features/lotoReports/components/LotoPagePanel.tsx
msgid "LOTO panel"
msgstr "LOTO panel"

#: src/features/lotoReports/components/LotoReportSelect.tsx
msgid "LOTO report"
msgstr "LOTO report"

#: src/features/lotoReports/components/LotoBackToListLink.tsx
#: src/features/lotoReports/components/LotoReportsList.tsx
#: src/features/lotoReports/useLotoReportWorkspaceTab.ts
#: src/features/navbar/navConfig.ts
msgid "LOTO reports"
msgstr "LOTO reports"

#: src/features/lotoReports/components/LotoSheetHeaderFields.tsx
msgid "LOTO requestor"
msgstr "LOTO requestor"

#: src/features/lotoReports/recordSheet/recordSheetLayout.ts
msgid "LOTO REQUESTOR:"
msgstr "LOTO REQUESTOR:"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatModelSettingsMenu.tsx
#: src/features/knowledgeDocumentViewer/components/bugReport/BugReportPriorityField.tsx
#: src/features/mdCases/mdCaseDisplay.ts
#: src/features/timeSeries/components/rulerTool/RulerMetricsPanel.tsx
#: src/pages/assetLens/components/tabs/AnomalyDashboard.tsx
#: src/pages/assetLens/components/tabs/SensorIssuesTab.tsx
msgid "Low"
msgstr "Low"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/InspectionFindingActions.tsx
msgid "Low area {index} · minimum reading"
msgstr "Low area {index} · minimum reading"

#: src/pages/processData/buildMode/dock/TagCleaningEditor.tsx
msgid "Low clip quantile"
msgstr "Low clip quantile"

#: src/features/timeSeries/utils/chartHelpers.ts
msgid "Lower"
msgstr "Lower"

#: src/features/timeSeries/utils/chartHelpers.ts
msgid "Lower Low"
msgstr "Lower Low"

#: src/features/timeSeries/components/ThresholdConfigurationModal.tsx
msgid "Lower Low:"
msgstr "Lower Low:"

#: src/features/timeSeries/components/ThresholdConfigurationModal.tsx
msgid "Lower:"
msgstr "Lower:"

#: src/features/assetLifecycleV2/views/observations/LtaObservationCompositeViz.tsx
msgid "LTA visualization unavailable"
msgstr "LTA visualization unavailable"

#: src/features/mdCases/components/MonitorLineagePanel.tsx
#: src/features/mdCases/components/ProvenanceContentViewer.tsx
msgid "M&D agent chat"
msgstr "M&D agent chat"

#: src/pages/cases/md/mdCaseDetailsHelpers.ts
msgid "M&D case is missing required fields"
msgstr "M&D case is missing required fields"

#: src/features/timeSeries/experiment/DiagnosticsPanel.tsx
msgid "MAE/scale"
msgstr "MAE/scale"

#: src/pages/evaluations/metadata/labeling/utils/pageClassificationTaxonomy.ts
msgid "Maintenance, repair, and troubleshooting"
msgstr "Maintenance, repair, and troubleshooting"

#: src/features/mdCases/components/ProvenanceContentViewer.tsx
msgid "Major subsystems"
msgstr "Major subsystems"

#: src/features/fim/photos/PhotoHeroAction.tsx
msgid "Make hero"
msgstr "Make hero"

#: src/pages/processData/components/helpGuide/HelpGuideChapters.tsx
#: src/pages/processData/components/viewSwitcher/ViewSwitcher.tsx
msgid "Manage"
msgstr "Manage"

#: src/pages/manageAccess/ManageAccessPage.tsx
msgid "Manage Access"
msgstr "Manage Access"

#: src/pages/homepage/constants.ts
msgid "Manage Capital Expenditure alongside the health of the assets and systems at your site."
msgstr "Manage Capital Expenditure alongside the health of the assets and systems at your site."

#: src/features/navbar/configSettings/ConfigSettingsSidebarMenuItems.tsx
#: src/features/navbar/configSettings/ConfigSettingsSidebarMenuItems.tsx
#: src/features/navbar/configSettings/ConfigSettingsTopBarMenuItems.tsx
msgid "Manage Extensions"
msgstr "Manage Extensions"

#: src/features/forecastNotifications/NotificationPreferencesModal.tsx
#: src/features/navbar/profileAndSettings/ProfileAndSettingsTopBar.tsx
msgid "Manage Notifications"
msgstr "Manage Notifications"

#: src/features/navbar/configSettings/ConfigSettingsSidebarMenuItems.tsx
#: src/features/navbar/configSettings/ConfigSettingsSidebarMenuItems.tsx
#: src/features/navbar/configSettings/ConfigSettingsTopBarMenuItems.tsx
msgid "Manage Permissions"
msgstr "Manage Permissions"

#: src/features/navbar/profileAndSettings/ProfileAndSettingsSidebar.tsx
#: src/features/navbar/profileAndSettings/ProfileAndSettingsSidebar.tsx
#: src/features/navbar/profileAndSettings/ProfileAndSettingsTopBar.tsx
msgid "Manage Site Access"
msgstr "Manage Site Access"

#: src/features/navbar/configSettings/ConfigSettingsSidebarMenuItems.tsx
#: src/features/navbar/configSettings/ConfigSettingsSidebarMenuItems.tsx
#: src/features/navbar/configSettings/ConfigSettingsTopBarMenuItems.tsx
msgid "Manage Users"
msgstr "Manage Users"

#: src/pages/processData/components/viewSwitcher/ManageViewsDialog.tsx
msgid "Manage views"
msgstr "Manage views"

#: src/features/mdCases/mdCaseDisplay.ts
#: src/pages/alerts/components/AlertsTableColumns.tsx
msgid "Manual"
msgstr "Manual"

#: src/features/fimEvidence/SubjectGlyphs.tsx
#: src/features/modelOperations/Corroboration.tsx
msgid "Manual labels"
msgstr "Manual labels"

#: src/features/mdCases/components/ProvenanceContentViewer.tsx
msgid "Manual needed · Unit: <0/>"
msgstr "Manual needed · Unit: <0/>"

#: src/features/timeSeries/experiment/CorrelationCard.tsx
msgid "Manual phase shift (periods) per driver:"
msgstr "Manual phase shift (periods) per driver:"

#: src/features/mdCases/components/ProvenanceContentViewer.tsx
msgid "Manual request"
msgstr "Manual request"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
#: src/features/knowledgeDocumentViewer/workOrders/legacyCmmsRecordPdf.ts
msgid "Manufacturer"
msgstr "Manufacturer"

#: src/pages/assetLens/components/AssetHeader.tsx
msgid "Manufacturer and Model Unknown"
msgstr "Manufacturer and Model Unknown"

#: src/features/forecastNotifications/NotificationListPanel.tsx
#: src/features/forecastNotifications/NotificationsDropdownContent.tsx
#: src/features/forecastNotifications/NotificationsDropdownContent.tsx
msgid "Mark all as read"
msgstr "Mark all as read"

#: src/pages/alerts/AlertDetails.tsx
msgid "Mark as acknowledged"
msgstr "Mark as acknowledged"

#: src/features/forecastNotifications/NotificationDetailPanel.tsx
#: src/features/forecastNotifications/NotificationListPanel.tsx
#: src/features/forecastNotifications/NotificationListPanel.tsx
msgid "Mark as read"
msgstr "Mark as read"

#: src/features/forecastNotifications/NotificationDetailPanel.tsx
#: src/features/forecastNotifications/NotificationListPanel.tsx
#: src/features/forecastNotifications/NotificationListPanel.tsx
msgid "Mark as unread"
msgstr "Mark as unread"

#: src/features/timeSeries/agentTab/dock/VersionsTab.tsx
msgid "masks"
msgstr "masks"

#: src/pages/evaluations/metadata/dashboard/components/dataLabeling/DataLabelingDashboardComparisonRow.tsx
msgid "Match"
msgstr "Match"

#: src/features/timeSeries/components/panes/TagSearchDialog.tsx
msgid "Match tags on name AND description, or either (OR)"
msgstr "Match tags on name AND description, or either (OR)"

#: src/features/knowledgeDocumentViewer/components/revisionCompare/RevisionStatusLegend.tsx
#: src/features/knowledgeDocumentViewer/graph/offPageConnectorTooltipRows.ts
msgid "Matched"
msgstr "Matched"

#: src/features/fimReview/provenance.ts
msgid "Matched by tag rules"
msgstr "Matched by tag rules"

#: src/features/knowledgeDocumentViewer/components/metadata/RevisionAuditBadge.tsx
msgid "Matched in system"
msgstr "Matched in system"

#: src/pages/evaluations/metadata/dashboard/components/dataLabeling/DataLabelingDashboardFieldDrilldown.tsx
msgid "Matches"
msgstr "Matches"

#: src/features/powerCustomerUploads/state/powerCustomerUploadApprovalResponseMapping.ts
#: src/features/powerCustomerUploads/uploadRequest/powerCustomerUploadApprovalPipeline.ts
msgid "Matches content already on this site."
msgstr "Matches content already on this site."

#: src/pages/evaluations/metadata/dashboard/components/dataLabeling/DataLabelingDashboardFieldDrilldown.tsx
msgid "Matches: {matchedLabel}"
msgstr "Matches: {matchedLabel}"

#: src/pages/evaluations/metadata/labeling/utils/pageClassificationTaxonomy.ts
msgid "Material and product conformance certificates"
msgstr "Material and product conformance certificates"

#: src/features/knowledgeDocumentViewer/workOrders/workOrderPdf.ts
msgid "Material availability"
msgstr "Material availability"

#: src/features/knowledgeDocumentViewer/workOrders/workOrderPdf.ts
msgid "Material availability status on work orders"
msgstr "Material availability status on work orders"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
#: src/features/knowledgeDocumentViewer/workOrders/workOrderFields.ts
msgid "Material availability updated"
msgstr "Material availability updated"

#: src/features/knowledgeDocumentViewer/workOrders/workOrderPdf.ts
msgid "Material cost"
msgstr "Material cost"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
msgid "Material usage line"
msgstr "Material usage line"

#: src/features/knowledgeDocumentViewer/workOrders/legacyCmmsRecordPdf.ts
msgid "Material usage lines"
msgstr "Material usage lines"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
msgid "Materials"
msgstr "Materials"

#: src/features/dataFilter/rangeFilter/RangeInputs.tsx
#: src/features/knowledgeDocumentViewer/components/table/enhancements/filters/NumberFilter.tsx
#: src/features/timeSeries/components/panes/TagConfigurationList.tsx
msgid "Max"
msgstr "Max"

#: src/features/timeSeries/experiment/knobCopy.ts
msgid "Max consecutive empty bins a driver may forward-fill before staying NaN. Default 2 (= 20 min at 10 min). Target is never forward-filled. Remaining holes become MLP missingness masks / kNN partial distance."
msgstr "Max consecutive empty bins a driver may forward-fill before staying NaN. Default 2 (= 20 min at 10 min). Target is never forward-filled. Remaining holes become MLP missingness masks / kNN partial distance."

#: src/pages/assetLens/components/tabs/imagesTabComponents/ImageTrendAnalysis.tsx
msgid "Max Decibel"
msgstr "Max Decibel"

#: src/pages/processData/buildMode/dock/ModelDockTab.tsx
#: src/pages/processData/buildMode/dock/ModelDockTab.tsx
msgid "Max iterations"
msgstr "Max iterations"

#: src/features/timeSeries/experiment/CorrelationCard.tsx
msgid "Max shift (periods)"
msgstr "Max shift (periods)"

#: src/pages/assetLens/components/tabs/imagesTabComponents/ImageTrendAnalysis.tsx
msgid "Max Temperature"
msgstr "Max Temperature"

#: src/features/timeSeries/experiment/knobCopy.ts
msgid "Max training iterations for the MLP (with early stopping). Raise if you see under-fitting; lower for faster experiments."
msgstr "Max training iterations for the MLP (with early stopping). Raise if you see under-fitting; lower for faster experiments."

#: src/features/timeSeries/components/ScatterPlotTableConfig.tsx
msgid "Max Y"
msgstr "Max Y"

#: src/features/timeSeries/components/ActiveTimeRangeSelector.tsx
msgid "Max zoom"
msgstr "Max zoom"

#: src/features/timeSeries/components/ActiveTimeRangeSelector.tsx
msgid "Max zoom reached"
msgstr "Max zoom reached"

#: src/features/timeSeries/components/XAxisSection.tsx
#: src/features/timeSeries/components/YAxisItem.tsx
msgid "Max:"
msgstr "Max:"

#: src/pages/assetLens/components/tabs/imagesTabComponents/ImageMetadata.tsx
msgid "Max: {acousticMax} dB, Avg: {acousticAvg} dB"
msgstr "Max: {acousticMax} dB, Avg: {acousticAvg} dB"

#: src/pages/assetLens/components/tabs/imagesTabComponents/ImageMetadata.tsx
msgid "Max: {irMax}°F, Avg: {irAvg}°F"
msgstr "Max: {irMax}°F, Avg: {irAvg}°F"

#: src/features/knowledgeDocumentViewer/components/revisionCompare/RevisionComparePane.tsx
msgid "Maximize"
msgstr "Maximize"

#: src/features/workbench/WorkbenchDock.tsx
msgid "Maximize panel"
msgstr "Maximize panel"

#: src/features/knowledgeDocumentViewer/workOrders/workOrderPdf.ts
msgid "Maximo field references"
msgstr "Maximo field references"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
#: src/features/knowledgeDocumentViewer/workOrders/workOrderFields.ts
msgid "Maximo organization"
msgstr "Maximo organization"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
#: src/features/knowledgeDocumentViewer/workOrders/workOrderFields.ts
msgid "Maximo site"
msgstr "Maximo site"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatInspectionViewer.tsx
#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatInspectionViewer.tsx
msgid "Maximum"
msgstr "Maximum"

#: src/features/dataFilter/rangeFilter/RangeSlider.tsx
msgid "Maximum color threshold"
msgstr "Maximum color threshold"

#: src/pages/assetLens/components/tabs/imagesTabComponents/ImageUploadModal.tsx
msgid "Maximum Decibel (dB)"
msgstr "Maximum Decibel (dB)"

#: src/features/timeSeries/experiment/knobCopy.ts
msgid "Maximum historical rows kept in the kNN library. 0 keeps every eligible training row. A smaller library scores faster and uses less memory, but may lose coverage of uncommon operating conditions."
msgstr "Maximum historical rows kept in the kNN library. 0 keeps every eligible training row. A smaller library scores faster and uses less memory, but may lose coverage of uncommon operating conditions."

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
#: src/features/knowledgeDocumentViewer/workOrders/legacyCmmsRecordPdf.ts
msgid "Maximum level"
msgstr "Maximum level"

#: src/pages/details/extensions/flow/SummarizerExtension.tsx
msgid "Maximum readings"
msgstr "Maximum readings"

#: src/pages/assetLens/components/tabs/imagesTabComponents/ImageUploadModal.tsx
msgid "Maximum Temperature (°F)"
msgstr "Maximum Temperature (°F)"

#: src/features/dataFilter/rangeFilter/RangeSlider.tsx
msgid "Maximum value"
msgstr "Maximum value"

#: src/features/knowledgeDocumentViewer/components/metadata/RevisionAuditBadge.tsx
msgid "May be missing"
msgstr "May be missing"

#: src/features/timeSeries/components/rulerTool/RulerMetricsPanel.tsx
msgid "Mean"
msgstr "Mean"

#: src/features/fimReview/ReviewActions.tsx
msgid "Meaningless subject input removed."
msgstr "Meaningless subject input removed."

#: src/features/knowledgeDocumentViewer/workOrders/workOrderPdf.ts
msgid "Measure"
msgstr "Measure"

#: src/pages/processData/components/helpGuide/HelpGuideChapters.tsx
msgid "Measure and Annotate"
msgstr "Measure and Annotate"

#: src/pages/alerts/AlertDetails.tsx
msgid "Measured at alert"
msgstr "Measured at alert"

#: src/pages/systemView/components/SystemViewAnnotationSidebar.tsx
msgid "Measurements"
msgstr "Measurements"

#: src/pages/evaluations/metadata/labeling/utils/pageClassificationTaxonomy.ts
msgid "Mechanical component sizing and design analysis"
msgstr "Mechanical component sizing and design analysis"

#: src/features/knowledgeDocumentViewer/components/bugReport/BugReportPriorityField.tsx
msgid "Med"
msgstr "Med"

#: src/features/timeSeries/agentTab/dock/FitTab.tsx
msgid "median gap"
msgstr "median gap"

#: src/pages/processData/buildMode/dock/EvalsDockTab.tsx
msgid "median lead "
msgstr "median lead "

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatModelSettingsMenu.tsx
#: src/features/mdCases/mdCaseDisplay.ts
#: src/pages/assetLens/components/tabs/AnomalyDashboard.tsx
#: src/pages/assetLens/components/tabs/SensorIssuesTab.tsx
msgid "Medium"
msgstr "Medium"

#: src/pages/manageAccess/users.ts
msgctxt "access role"
msgid "Member"
msgstr "Member"

#: src/features/richText/editorPlugins/MentionPluginBase.tsx
msgid "Mention User"
msgstr "Mention User"

#: src/features/navbar/Homebar.tsx
msgid "Menu"
msgstr "Menu"

#: src/features/fimReview/StructuralReviewFlow.tsx
msgid "Merge {label} with existing Subject"
msgstr "Merge {label} with existing Subject"

#: src/features/fimReview/ReviewActions.tsx
msgid "Merge target"
msgstr "Merge target"

#: src/features/fimReview/StructuralReviewFlow.tsx
msgid "Merge this Subject into an existing Subject"
msgstr "Merge this Subject into an existing Subject"

#: src/features/fimReview/StructuralReviewFlow.tsx
msgid "Merge with Subject"
msgstr "Merge with Subject"

#: src/features/fimReview/StructuralReviewFlow.tsx
msgid "Merge with: {name}"
msgstr "Merge with: {name}"

#: src/features/fimReview/DecisionHistory.tsx
msgid "Merged"
msgstr "Merged"

#: src/features/fimReview/DecisionHistory.tsx
msgid "Merged Subjects"
msgstr "Merged Subjects"

#: src/pages/evaluations/metadata/components/MetricsContent.tsx
msgid "Metadata evaluation rates"
msgstr "Metadata evaluation rates"

#: src/features/richText/components/slashCommandCards/ChartSlashCommandCard.tsx
msgid "Metadata for Chart"
msgstr "Metadata for Chart"

#: src/pages/evaluations/metadata/labeling/components/DataLabelingLanding.tsx
#: src/pages/evaluations/metadata/labeling/DataLabelingPage.tsx
msgid "Metadata Labeling"
msgstr "Metadata Labeling"

#: src/features/knowledgeDocumentViewer/components/metadata/MetadataScopeToggle.tsx
msgid "Metadata scope"
msgstr "Metadata scope"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/utils/inspectionLayers.ts
msgid "Metal loss"
msgstr "Metal loss"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
#: src/features/knowledgeDocumentViewer/workOrders/legacyCmmsRecordPdf.ts
msgid "Meter"
msgstr "Meter"

#: src/features/timeSeries/components/DataSmoothing.tsx
#: src/features/timeSeries/components/DataSmoothing.tsx
#: src/features/timeSeries/components/PenTransformControls.tsx
#: src/features/timeSeries/experiment/NormalizationViewer.tsx
#: src/features/timeSeries/experiment/RunComparison.tsx
msgid "Method"
msgstr "Method"

#: src/features/timeSeries/sentinelStudio/SentinelComparison.tsx
msgid "Methods"
msgstr "Methods"

#: src/pages/evaluations/metadata/components/MetricsContent.tsx
msgid "Metric"
msgstr "Metric"

#: src/pages/metrics/Metrics.tsx
msgid "Metrics"
msgstr "Metrics"

#: src/features/timeSeries/experiment/DiagnosticsPanel.tsx
msgid "Metrics by split role"
msgstr "Metrics by split role"

#: src/pages/processData/buildMode/rightPanel/CurrentModelPane.tsx
msgid "Metrics on the {option} rows"
msgstr "Metrics on the {option} rows"

#: src/pages/metrics/Metrics.tsx
msgid "Metrics unavailable: {error}"
msgstr "Metrics unavailable: {error}"

#: src/features/dataFilter/rangeFilter/RangeSlider.tsx
msgid "Middle color threshold"
msgstr "Middle color threshold"

#: src/features/dataFilter/rangeFilter/RangeInputs.tsx
#: src/features/knowledgeDocumentViewer/components/table/enhancements/filters/NumberFilter.tsx
#: src/features/timeSeries/components/panes/TagConfigurationList.tsx
msgid "Min"
msgstr "Min"

#: src/features/timeSeries/experiment/ModelKnobs.tsx
msgid "Min usable / train rows"
msgstr "Min usable / train rows"

#: src/features/timeSeries/components/ScatterPlotTableConfig.tsx
msgid "Min Y"
msgstr "Min Y"

#: src/features/timeSeries/components/XAxisSection.tsx
#: src/features/timeSeries/components/YAxisItem.tsx
msgid "Min:"
msgstr "Min:"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatModelSettingsMenu.tsx
msgid "Minimal"
msgstr "Minimal"

#: src/features/knowledgeDocumentViewer/components/viewer/shared/DocumentMinimap.tsx
msgid "minimap"
msgstr "minimap"

#: src/features/knowledgeDocumentViewer/components/viewer/shared/DocumentMinimap.tsx
msgid "minimap page {pageNumber}"
msgstr "minimap page {pageNumber}"

#: src/features/timeSeries/components/rulerTool/RulerMetricsPanel.tsx
msgid "Minimize"
msgstr "Minimize"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatInspectionViewer.tsx
#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatInspectionViewer.tsx
msgid "Minimum"
msgstr "Minimum"

#: src/features/dataFilter/rangeFilter/RangeSlider.tsx
msgid "Minimum color threshold"
msgstr "Minimum color threshold"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
#: src/features/knowledgeDocumentViewer/workOrders/legacyCmmsRecordPdf.ts
msgid "Minimum level"
msgstr "Minimum level"

#: src/pages/details/extensions/flow/SummarizerExtension.tsx
msgid "Minimum readings"
msgstr "Minimum readings"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/utils/inspectionLayers.ts
msgid "Minimum required thickness"
msgstr "Minimum required thickness"

#: src/features/assetLifecycleV2/views/observations/LtaObservationCompositeViz.tsx
msgid "Minimum Thickness"
msgstr "Minimum Thickness"

#: src/features/dataFilter/rangeFilter/RangeSlider.tsx
msgid "Minimum value"
msgstr "Minimum value"

#: src/features/knowledgeDocumentViewer/components/bugReport/BugReportPriorityField.tsx
msgid "Minor inconvenience — prioritize accordingly."
msgstr "Minor inconvenience — prioritize accordingly."

#: src/features/timeSeries/components/RelativeDateConfig.tsx
msgid "Minutes"
msgstr "Minutes"

#: src/pages/evaluations/metadata/dashboard/components/dataLabeling/DataLabelingDashboardComparisonRow.tsx
msgid "Mismatch"
msgstr "Mismatch"

#: src/pages/evaluations/metadata/dashboard/components/dataLabeling/DataLabelingDashboardFieldDrilldown.tsx
msgid "Mismatches"
msgstr "Mismatches"

#: src/features/knowledgeDocumentViewer/components/metadata/RevisionAuditBadge.tsx
msgid "missing"
msgstr "missing"

#: src/features/knowledgeDocumentViewer/components/metadata/RevisionAuditBadge.tsx
msgid "Missing"
msgstr "Missing"

#: src/features/timeSeries/experiment/TransparencyStrip.tsx
msgid "Missing %"
msgstr "Missing %"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatRevisionMissingCard.tsx
msgid "Missing count unknown"
msgstr "Missing count unknown"

#: src/features/knowledgeDocumentViewer/components/metadata/RevisionAuditBadge.tsx
msgid "Missing revision"
msgstr "Missing revision"

#: src/pages/site/components/CustomFieldInfoModal.tsx
msgid "Missing site information"
msgstr "Missing site information"

#: src/features/knowledgeDocumentViewer/utils/resolveMetadataUserEditSaveContext.ts
msgid "Missing site or organization for edit"
msgstr "Missing site or organization for edit"

#: src/features/facilityModel/views.ts
#: src/features/fim/assetInventory.ts
msgid "Missing type"
msgstr "Missing type"

#: src/features/powerCustomerUploads/state/powerCustomerUploadRowUpdates.ts
msgid "Missing: {missingStoreLabels}"
msgstr "Missing: {missingStoreLabels}"

#: src/features/timeSeries/experiment/SplitBuilder.tsx
msgid "mixed (cyan→red tail split)"
msgstr "mixed (cyan→red tail split)"

#: src/pages/processData/buildMode/dock/ModelDockTab.tsx
msgid "MLP — current drivers"
msgstr "MLP — current drivers"

#: src/pages/processData/buildMode/dock/ModelDockTab.tsx
msgid "MLP — driver + target history"
msgstr "MLP — driver + target history"

#: src/pages/processData/buildMode/dock/ModelDockTab.tsx
msgid "MLP — driver history"
msgstr "MLP — driver history"

#: src/features/sentinels/methodLabels.ts
msgid "MLP (no drivers)"
msgstr "MLP (no drivers)"

#: src/features/sentinels/methodLabels.ts
msgid "MLP + drivers"
msgstr "MLP + drivers"

#: src/features/sentinels/methodLabels.ts
msgid "MLP + drivers + own history"
msgstr "MLP + drivers + own history"

#: src/features/timeSeries/experiment/ModelKnobs.tsx
msgid "MLP hidden sizes"
msgstr "MLP hidden sizes"

#: src/features/timeSeries/experiment/DiagnosticsPanel.tsx
msgid "MLP loss curve ({iterations} iters)"
msgstr "MLP loss curve ({iterations} iters)"

#: src/features/timeSeries/experiment/ModelKnobs.tsx
msgid "MLP max iter"
msgstr "MLP max iter"

#: src/features/timeSeries/experiment/knobCopy.ts
msgid "MLP that predicts the target from current driver values only — no lags or rolling history. Fast baseline; ignores dynamics."
msgstr "MLP that predicts the target from current driver values only — no lags or rolling history. Fast baseline; ignores dynamics."

#: src/features/timeSeries/experiment/knobCopy.ts
msgid "MLP with current drivers plus driver lags and rolling means. Captures delayed physical responses without looking at past target."
msgstr "MLP with current drivers plus driver lags and rolling means. Captures delayed physical responses without looking at past target."

#: src/features/timeSeries/experiment/knobCopy.ts
msgid "MLP with driver history plus prior target history. Often lowest error, but can mask gradual target degradation. Requires Self history on."
msgstr "MLP with driver history plus prior target history. Often lowest error, but can mask gradual target degradation. Requires Self history on."

#: src/features/timeSeries/experiment/knobCopy.ts
msgid "mlp_driver — + driver history"
msgstr "mlp_driver — + driver history"

#: src/features/timeSeries/experiment/knobCopy.ts
msgid "mlp_driver_own — + self history"
msgstr "mlp_driver_own — + self history"

#: src/features/timeSeries/experiment/knobCopy.ts
msgid "mlp_none — current drivers"
msgstr "mlp_none — current drivers"

#: src/features/timeSeries/components/ScatterplotSidebarDefault.tsx
msgid "Mode"
msgstr "Mode"

#: src/features/timeSeries/agentTab/ModelPicker.tsx
msgid "model"
msgstr "model"

#: src/features/facilityModel/columns.ts
#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatModelSettingsMenu.tsx
#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatModelSettingsMenu.tsx
#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
#: src/features/knowledgeDocumentViewer/workOrders/legacyCmmsRecordPdf.ts
#: src/features/timeSeries/experiment/ModelKnobs.tsx
#: src/features/timeSeries/sentinelStudio/SentinelComparison.tsx
#: src/pages/facilityModel/SentinelDetailPage.tsx
#: src/pages/processData/buildMode/components/BuildDock.tsx
#: src/pages/processData/buildMode/dock/BacktestDockTab.tsx
#: src/pages/processData/buildMode/dock/EvalsDockTab.tsx
#: src/pages/processData/buildMode/dock/ModelDockTab.tsx
msgid "Model"
msgstr "Model"

#: src/pages/processData/buildMode/components/ModelingTagsPane.tsx
msgid "Model {tagName} instead"
msgstr "Model {tagName} instead"

#: src/pages/processData/buildMode/components/ModeSwitcher.tsx
msgid "Model builder mode"
msgstr "Model builder mode"

#: src/features/mdCases/components/CaseTimeline.tsx
msgid "Model calibrated"
msgstr "Model calibrated"

#: src/pages/processData/components/ProcessDataTopBar.tsx
msgid "model configuration"
msgstr "model configuration"

#: src/pages/processData/components/WorkbenchBody.tsx
msgid "Model configuration"
msgstr "Model configuration"

#: src/pages/alerts/AlertDetails.tsx
msgid "Model expected at alert"
msgstr "Model expected at alert"

#: src/features/timeSeries/agentTab/dock/TargetTab.tsx
msgid "model health"
msgstr "model health"

#: src/features/timeSeries/experiment/ExperimentTab.tsx
#: src/pages/processData/buildMode/dock/ModelDockTab.tsx
msgid "Model knobs"
msgstr "Model knobs"

#: src/pages/facilityModel/SubjectDetailPage.tsx
msgid "Model lifecycle"
msgstr "Model lifecycle"

#: src/pages/processData/buildMode/rightPanel/CurrentModelPane.tsx
msgid "model name"
msgstr "model name"

#: src/features/timeSeries/agentTab/dock/SaveModelBar.tsx
msgid "Model name"
msgstr "Model name"

#: src/features/navbar/navConfig.ts
msgid "Model Operations"
msgstr "Model Operations"

#: src/features/timeSeries/agentTab/dock/SettingsTab.tsx
msgid "model output"
msgstr "model output"

#: src/features/timeSeries/components/SentinelsTab.tsx
msgid "Model quality: MAE "
msgstr "Model quality: MAE "

#: src/features/timeSeries/agentTab/chat/BuildCard.tsx
msgid "model saved"
msgstr "model saved"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatModelSettingsMenu.tsx
msgid "Model settings"
msgstr "Model settings"

#: src/features/timeSeries/experiment/ExperimentTab.tsx
msgid "Model Studio"
msgstr "Model Studio"

#: src/pages/processData/buildMode/components/ModelingTagsPane.tsx
msgid "Model this tag instead"
msgstr "Model this tag instead"

#: src/features/timeSeries/components/RegressionPrediction.tsx
msgid "Model type"
msgstr "Model type"

#: src/pages/processData/buildMode/components/ModelingTagsPane.tsx
msgid "Modeling tags"
msgstr "Modeling tags"

#: src/features/kestrelUpload/KestrelModelUploadSection.tsx
#: src/features/timeSeries/components/timeSeriesScatterplot/EmbeddedChartToolbar.tsx
#: src/features/timeSeries/components/timeSeriesScatterplot/EmbeddedChartToolbar.tsx
#: src/features/timeSeries/components/timeSeriesScatterplot/TimeSeriesScatterplot.tsx
#: src/pages/processData/components/ProcessDataTopBar.tsx
#: src/pages/processData/components/ProcessDataTopBar.tsx
#: src/pages/processData/components/WorkbenchChartArea.tsx
msgid "Models"
msgstr "Models"

#: src/pages/processData/buildMode/rightPanel/SavedModelShelf.tsx
msgid "Models of this target"
msgstr "Models of this target"

#: src/features/knowledgeDocumentViewer/graph/nodeTooltip.ts
msgid "Modifier"
msgstr "Modifier"

#: src/pages/metrics/components/MonthlyTable.tsx
msgid "MoM Growth"
msgstr "MoM Growth"

#: src/features/sentinels/components/DesignRunDetails.tsx
#: src/features/sentinels/components/MonitorTab.tsx
#: src/features/sentinels/components/MonitorTab.tsx
#: src/pages/alerts/components/AlertsTableColumns.tsx
msgid "Monitor"
msgstr "Monitor"

#: src/features/mdCases/components/CaseStorySection.tsx
msgid "Monitor {ordinal}"
msgstr "Monitor {ordinal}"

#: src/pages/assetLens/components/tabs/SensorIssuesTab.tsx
msgid "Monitor and track sensor anomalies and analyze their root cause analyses."
msgstr "Monitor and track sensor anomalies and analyze their root cause analyses."

#: src/pages/processData/buildMode/rightPanel/PromoteModelAction.tsx
msgid "Monitor name"
msgstr "Monitor name"

#: src/features/mdCases/components/MonitorLineagePanel.tsx
#: src/features/mdCases/components/MonitorProvenanceModal.tsx
#: src/pages/cases/md/MdCaseDetailsMainColumn.tsx
msgid "Monitor Provenance"
msgstr "Monitor Provenance"

#: src/pages/facilityModel/SentinelDetailPage.tsx
msgid "Monitor settings are read-only for your role. The monitoring state above reflects the current configuration."
msgstr "Monitor settings are read-only for your role. The monitoring state above reflects the current configuration."

#: src/features/facilityModel/provenance/ProvenanceChain.tsx
msgid "Monitor signal"
msgstr "Monitor signal"

#: src/features/mdCases/components/MonitorLineagePanel.tsx
msgid "Monitor specs ({monitorSpecCount})"
msgstr "Monitor specs ({monitorSpecCount})"

#: src/features/sentinels/components/SentinelAssetPanel.tsx
msgid "Monitored equipment"
msgstr "Monitored equipment"

#: src/features/timeSeries/agentTab/dock/AlertingTab.tsx
#: src/pages/facilityModel/SentinelOverviewPage.tsx
msgid "Monitoring"
msgstr "Monitoring"

#: src/features/mdCases/components/CaseTimeline.tsx
msgid "Monitoring enabled"
msgstr "Monitoring enabled"

#: src/pages/facilityModel/SentinelDetailPage.tsx
msgid "Monitoring every {cadenceMinutes} min"
msgstr "Monitoring every {cadenceMinutes} min"

#: src/pages/facilityModel/SentinelDetailPage.tsx
msgid "Monitoring off"
msgstr "Monitoring off"

#: src/pages/metrics/components/MonthlyTable.tsx
msgid "Month"
msgstr "Month"

#: src/features/timeSeries/components/TimeRangeSelector.tsx
msgid "Monthly analysis"
msgstr "Monthly analysis"

#: src/designSystem/components/RecordHeader.tsx
#: src/features/embeddedSidebar/components/EmbeddedSidebarMoreFeaturesMenu.tsx
#: src/features/timeSeries/components/TimeRangeSelector.tsx
msgid "More"
msgstr "More"

#: src/features/embeddedSidebar/chatHistory/AgenticChatHistorySessionOverflowMenu.tsx
msgid "More actions for {sessionTitle}"
msgstr "More actions for {sessionTitle}"

#: src/features/embeddedSidebar/components/EmbeddedSidebarMoreFeaturesMenu.tsx
msgid "More features"
msgstr "More features"

#: src/designSystem/components/Pagination.tsx
msgid "More pages"
msgstr "More pages"

#: src/features/knowledgeDocumentViewer/components/sidebar/SubjectDocumentsPanel.tsx
msgid "More references to {subjectName} exist on {pageCount, plural, one {page} other {pages}} {pageList}"
msgstr "More references to {subjectName} exist on {pageCount, plural, one {page} other {pages}} {pageList}"

#: src/pages/processData/buildMode/rightPanel/CurrentModelPane.tsx
msgid "More save options"
msgstr "More save options"

#: src/features/timeSeries/agentTab/dock/WindowsTab.tsx
msgid "More than one window is allowed and often better — if the first period already contains degradation, the model learns the degradation as normal. A second healthy window elsewhere is the check on that. The baseline is shaded on the chart whenever this model is drawn, so you can see what it was fitted against rather than taking these dates on trust."
msgstr "More than one window is allowed and often better — if the first period already contains degradation, the model learns the degradation as normal. A second healthy window elsewhere is the check on that. The baseline is shaded on the chart whenever this model is drawn, so you can see what it was fitted against rather than taking these dates on trust."

#: src/features/embeddedSidebar/chatHistory/ChatHistoryBulkActionDialog.tsx
msgid "Move all your archived chats for this site back to Recent chats. Open tabs and unsent drafts will stay. You can archive these chats again later."
msgstr "Move all your archived chats for this site back to Recent chats. Open tabs and unsent drafts will stay. You can archive these chats again later."

#: src/pages/processData/components/helpGuide/HelpGuideChapters.tsx
msgid "Move Around the Chart"
msgstr "Move Around the Chart"

#: src/features/timeSeries/components/YAxisItem.tsx
msgid "Move to left axis"
msgstr "Move to left axis"

#: src/features/timeSeries/components/YAxisItem.tsx
msgid "Move to right axis"
msgstr "Move to right axis"

#: src/features/embeddedSidebar/chatHistory/ChatHistoryBulkActionDialog.tsx
msgid "Move your recent chats for this site to Archived chats and close their open tabs. Pinned chats, running replies, and chats with unsent drafts will stay. You can restore archived chats later."
msgstr "Move your recent chats for this site to Archived chats and close their open tabs. Pinned chats, running replies, and chats with unsent drafts will stay. You can restore archived chats later."

#: src/features/timeSeries/components/YAxisModeSection.tsx
msgid "Multi"
msgstr "Multi"

#: src/features/timeSeries/components/YScaleControls.tsx
#: src/pages/processData/components/helpGuide/HelpGuideChapters.tsx
msgid "Multi Y-Scale"
msgstr "Multi Y-Scale"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatAgentsMenu.tsx
msgid "Multicall"
msgstr "Multicall"

#: src/features/timeSeries/experiment/knobCopy.ts
msgid "Multiplier on err_scale for the shaded ±band. Production uses 2. Higher = wider band (fewer “out of band” points); lower = tighter. Judge with Band coverage on the test/val metrics."
msgstr "Multiplier on err_scale for the shaded ±band. Production uses 2. Higher = wider band (fewer “out of band” points); lower = tighter. Judge with Band coverage on the test/val metrics."

#: src/features/timeSeries/hooks/useTimeSeriesDataProcessing.ts
msgid "Multivariate linear regression prediction: {value816_79}"
msgstr "Multivariate linear regression prediction: {value816_79}"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatEvalCaseReview.tsx
msgid "Must not state"
msgstr "Must not state"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatEvalCaseReview.tsx
msgid "Must state"
msgstr "Must state"

#: src/pages/processData/components/helpGuide/HelpGuideChapters.tsx
msgid "mw from generator exciter"
msgstr "mw from generator exciter"

#: src/features/timeSeries/experiment/NormalizationViewer.tsx
msgid "n_valid={value127_55}"
msgstr "n_valid={value127_55}"

#: src/features/timeSeries/components/RegressionPrediction.tsx
#: src/pages/alerts/AlertDetails.tsx
#: src/pages/alerts/components/AssetInfoCard.tsx
#: src/pages/alerts/components/AssetInfoCard.tsx
#: src/pages/assetLens/components/tabs/AnomalyDashboard.tsx
#: src/pages/assetLens/components/tabs/AnomalyDashboard.tsx
#: src/pages/assetLens/components/tabs/imagesTabComponents/ImageGalleryView.tsx
#: src/pages/assetLens/components/tabs/imagesTabComponents/ImageGalleryView.tsx
#: src/pages/assetLens/context/AssetLensContext.tsx
#: src/pages/overview/sidebar/table/SiteViewSidebarTableOrganizers.tsx
#: src/pages/overview/sidebar/table/SiteViewSidebarTableOrganizers.tsx
msgid "N/A"
msgstr "N/A"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
msgid "naes_confinedspace"
msgstr "naes_confinedspace"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
msgid "naes_crane"
msgstr "naes_crane"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
msgid "naes_environmental"
msgstr "naes_environmental"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
msgid "naes_insulation"
msgstr "naes_insulation"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
msgid "naes_loto"
msgstr "naes_loto"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
msgid "naes_lotoid"
msgstr "naes_lotoid"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
msgid "naes_moc"
msgstr "naes_moc"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
msgid "naes_nde"
msgstr "naes_nde"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
msgid "naes_nerc"
msgstr "naes_nerc"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
msgid "naes_outage"
msgstr "naes_outage"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
msgid "naes_outagedur"
msgstr "naes_outagedur"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
msgid "naes_outagetype"
msgstr "naes_outagetype"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
msgid "naes_outageyear"
msgstr "naes_outageyear"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
msgid "naes_projectid"
msgstr "naes_projectid"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
msgid "naes_pwht"
msgstr "naes_pwht"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
msgid "naes_safety"
msgstr "naes_safety"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
msgid "naes_scaffolding"
msgstr "naes_scaffolding"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
msgid "naes_welding"
msgstr "naes_welding"

#: src/features/facilityModel/columns.ts
#: src/features/fimReview/ReviewActions.tsx
#: src/features/fimReview/ReviewActions.tsx
#: src/features/fimReview/ReviewActions.tsx
#: src/features/fimReview/StructuralReviewFlow.tsx
#: src/features/fimReview/StructuralReviewFlow.tsx
#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatEvalCaseReview.tsx
#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/sensors/SensorTableColumns.tsx
#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
#: src/features/knowledgeDocumentViewer/workOrders/legacyCmmsRecordPdf.ts
#: src/features/powerCustomerUploads/components/PowerCustomerUploadReviewTable.tsx
#: src/features/timeSeries/experiment/ExperimentTab.tsx
#: src/pages/alerts/components/AlertsTableColumns.tsx
#: src/pages/facilityModel/SentinelOverviewPage.tsx
#: src/pages/processData/components/viewSwitcher/ManageViewsDialog.tsx
msgid "Name"
msgstr "Name"

#: src/features/timeSeries/components/DerivedValues.tsx
#: src/features/timeSeries/components/panes/DerivedTagsPane.tsx
msgid "Name (e.g., Power Output)"
msgstr "Name (e.g., Power Output)"

#: src/features/fimReview/DecisionHistory.tsx
msgid "name → {canonicalName}"
msgstr "name → {canonicalName}"

#: src/features/fim/assetInventory.ts
msgid "Name A–Z"
msgstr "Name A–Z"

#: src/features/modelOperations/templates/templateModel.ts
msgid "Name is required."
msgstr "Name is required."

#: src/features/modelOperations/templates/templateModel.ts
msgid "Name needs at least one letter or number."
msgstr "Name needs at least one letter or number."

#: src/features/lotoReports/components/NewLotoReportDialog.tsx
msgid "Name the report. You can fill in the record sheet details next."
msgstr "Name the report. You can fill in the record sheet details next."

#: src/features/timeSeries/agentTab/dock/FitTab.tsx
msgid "Name the role and pick a tag first"
msgstr "Name the role and pick a tag first"

#: src/features/timeSeries/components/DashboardHeader.tsx
msgid "Name this chart"
msgstr "Name this chart"

#: src/features/timeSeries/agentTab/dock/SaveModelBar.tsx
msgid "Name this model"
msgstr "Name this model"

#: src/features/timeSeries/components/chartActions/ChartSaveAction.tsx
msgid "Name this view"
msgstr "Name this view"

#: src/features/richText/components/slashCommandCards/ChartSlashCommandCard.tsx
#: src/features/richText/nodes/MentionNode.tsx
msgid "Name:"
msgstr "Name:"

#: src/features/richText/components/slashCommandCards/ChartSlashCommandCard.tsx
msgid "Name: {chartName}"
msgstr "Name: {chartName}"

#: src/features/richText/components/slashCommandCards/SystemSlashCommandCard.tsx
msgid "Name: {systemName}"
msgstr "Name: {systemName}"

#: src/features/richText/components/slashCommandCards/UnitSlashCommandCard.tsx
msgid "Name: {unitName}"
msgstr "Name: {unitName}"

#: src/pages/manageAccess/components/invite/EmailChipsInput.tsx
msgid "name@company.com"
msgstr "name@company.com"

#: src/features/timeSeries/experiment/TransparencyStrip.tsx
msgid "Native spacing"
msgstr "Native spacing"

#: src/pages/processData/components/helpGuide/HelpGuideChapters.tsx
msgid "Navigate"
msgstr "Navigate"

#: src/features/breadcrumbBar/BreadcrumbBar.tsx
msgid "Navigate back to {lastPage}"
msgstr "Navigate back to {lastPage}"

#: src/pages/details/visualization/alerts/specificAlerts/ConduitPipelineAlert.tsx
msgid "Navigate to Data Ops to view more details"
msgstr "Navigate to Data Ops to view more details"

#: src/features/knowledgeDocumentViewer/components/sidebar/OcrTableColumns.tsx
msgid "Navigate to linked document"
msgstr "Navigate to linked document"

#: src/pages/details/visualization/photogrammetry/NiraHud.tsx
msgid "Navigation"
msgstr "Navigation"

#: src/pages/processData/buildMode/dock/ModelDockTab.tsx
msgid "Nearest historical driver snapshots vote on the expected value."
msgstr "Nearest historical driver snapshots vote on the expected value."

#: src/features/facilityModel/columns.ts
#: src/features/modelOperations/SubjectDetails.tsx
msgid "Needs revalidation"
msgstr "Needs revalidation"

#: src/features/facilityModel/views.ts
#: src/features/fim/assetInventory.ts
#: src/pages/facilityModel/FacilityModelCatalog.tsx
#: src/pages/facilityModel/SubjectAssetPanel.tsx
msgid "Needs review"
msgstr "Needs review"

#: src/pages/facilityModel/FacilityModelCatalog.tsx
msgid "Needs Review"
msgstr "Needs Review"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatRevisionMissingCard.tsx
msgid "Needs-review count unknown (not counted as missing)"
msgstr "Needs-review count unknown (not counted as missing)"

#: src/pages/assetLens/components/tabs/imagesTabComponents/EnvironmentalCorrelationCard.tsx
msgid "Negative correlation"
msgstr "Negative correlation"

#: src/features/timeSeries/experiment/DiagnosticsPanel.tsx
msgid "Neighbor ys (nearest→)"
msgstr "Neighbor ys (nearest→)"

#: src/pages/processData/buildMode/dock/ModelDockTab.tsx
#: src/pages/processData/buildMode/dock/ModelDockTab.tsx
msgid "Neighbors (k)"
msgstr "Neighbors (k)"

#: src/features/powerCustomerUploads/uploadSource/powerCustomerUploadZipArchiveFiles.ts
msgid "Nested ZIP archives exceed the 1 GiB expansion limit. Select smaller archives."
msgstr "Nested ZIP archives exceed the 1 GiB expansion limit. Select smaller archives."

#: src/features/timeSeries/experiment/knobCopy.ts
msgid "Neurons per hidden layer of the MLP, e.g. 64,32. Larger nets fit more nonlinear structure but overfit faster and train slower."
msgstr "Neurons per hidden layer of the MLP, e.g. 64,32. Larger nets fit more nonlinear structure but overfit faster and train slower."

#: src/pages/systemView/components/SystemViewAnnotationSidebar.tsx
msgid "New"
msgstr "New"

#: src/features/mdCases/mdCaseDisplay.ts
msgid "New Alert"
msgstr "New Alert"

#: src/pages/cases/components/CasesTable.tsx
msgid "New Case"
msgstr "New Case"

#: src/features/embeddedSidebar/components/SidebarNewChatButton.tsx
#: src/features/embeddedSidebar/components/SidebarNewChatButton.tsx
#: src/features/workspaceTabs/components/WorkspaceTabBar.tsx
#: src/features/workspaceTabs/components/WorkspaceTabBar.tsx
#: src/features/workspaceTabs/components/WorkspaceTabBar.tsx
#: src/features/workspaceTabs/components/WorkspaceTabBar.tsx
msgid "New chat"
msgstr "New chat"

#: src/features/chatbot/components/SessionHeaderBar.tsx
#: src/features/chatbot/components/SessionTabs.tsx
msgid "New Chat"
msgstr "New Chat"

#: src/features/chatbot/components/SessionHeaderBar.tsx
#: src/features/timeSeries/agentTab/AgentTab.tsx
msgid "New conversation"
msgstr "New conversation"

#: src/features/timeSeries/components/panes/DerivedTagsPane.tsx
msgid "New derived tag"
msgstr "New derived tag"

#: src/features/timeSeries/components/labelTool/LabelConfigPanel.tsx
msgid "New label"
msgstr "New label"

#: src/features/lotoReports/components/NewLotoReportDialog.tsx
#: src/features/lotoReports/components/NewLotoReportDialog.tsx
msgid "New LOTO report"
msgstr "New LOTO report"

#: src/features/lotoReports/components/LotoReportSelect.tsx
msgid "New LOTO report…"
msgstr "New LOTO report…"

#: src/features/timeSeries/agentTab/dock/FitTab.tsx
msgid "new role"
msgstr "new role"

#: src/features/workspaceTabs/utils/getWorkspaceTabLabel.ts
msgid "New Search"
msgstr "New Search"

#: src/features/timeSeries/components/SentinelsTab.tsx
#: src/features/timeSeries/components/SentinelsTab.tsx
#: src/features/timeSeries/sentinelStudio/SentinelBuilderPanel.tsx
msgid "New sentinel"
msgstr "New sentinel"

#: src/features/knowledgeDocumentViewer/components/toolbar/DocumentTabs.tsx
#: src/features/knowledgeDocumentViewer/components/toolbar/DocumentTabs.tsx
#: src/features/workspaceTabs/utils/getWorkspaceTabLabel.ts
#: src/features/workspaceTabs/utils/getWorkspaceTabLabel.ts
msgid "New Tab"
msgstr "New Tab"

#: src/features/powerCustomerUploads/components/PowerCustomerUploadPage.tsx
msgid "New upload"
msgstr "New upload"

#: src/features/knowledgeDocumentViewer/components/table/enhancements/BulkActionModalEditConfiguration.tsx
#: src/features/knowledgeDocumentViewer/components/table/enhancements/BulkActionModalEditConfiguration.tsx
#: src/features/knowledgeDocumentViewer/components/table/enhancements/BulkActionModalEditConfiguration.tsx
#: src/features/knowledgeDocumentViewer/components/table/enhancements/BulkActionModalEditConfiguration.tsx
msgid "New Value"
msgstr "New Value"

#: src/pages/processData/components/helpGuide/HelpGuideChapters.tsx
#: src/pages/processData/components/ProcessDataTopBar.tsx
#: src/pages/processData/components/viewSwitcher/ViewSwitcher.tsx
#: src/pages/processData/components/WorkbenchBody.tsx
msgid "New view"
msgstr "New view"

#: src/features/forecastNotifications/NotificationListPanel.tsx
msgid "Newest first"
msgstr "Newest first"

#: src/pages/cases/md/MdCaseDetailsMainColumn.tsx
msgid "Newest First"
msgstr "Newest First"

#: src/designSystem/components/Pagination.tsx
#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatTagPickerCard.tsx
#: src/pages/assetLens/components/tabs/DocumentsTab.tsx
#: src/pages/processData/components/helpGuide/HelpGuideDialog.tsx
msgid "Next"
msgstr "Next"

#: src/pages/details/overlays/inspections/InspectionsListOverlay.tsx
msgid "Next inspections"
msgstr "Next inspections"

#: src/features/knowledgeDocumentViewer/components/viewer/search/IntraDocSearchBar.tsx
#: src/features/knowledgeDocumentViewer/workOrders/WorkOrderViewer.tsx
msgid "Next match"
msgstr "Next match"

#: src/features/knowledgeDocumentViewer/components/viewer/search/IntraDocSearchBar.tsx
msgid "Next match (Enter)"
msgstr "Next match (Enter)"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/documentPreview/PreviewPageNavigator.tsx
msgid "Next page"
msgstr "Next page"

#: src/features/knowledgeDocumentViewer/components/toolbar/PageSelector.tsx
msgid "Next Page"
msgstr "Next Page"

#: src/features/knowledgeDocumentViewer/components/metadata/EvalQueueNavigation.tsx
msgid "Next page in queue"
msgstr "Next page in queue"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
#: src/features/knowledgeDocumentViewer/workOrders/workOrderFields.ts
msgid "Next PM due"
msgstr "Next PM due"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatTagPickerCard.tsx
msgid "Next question"
msgstr "Next question"

#: src/features/facilityModel/components/ReferencePreviewPanel.tsx
#: src/features/facilityModel/components/ReferencePreviewPanel.tsx
msgid "Next reference"
msgstr "Next reference"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
#: src/features/knowledgeDocumentViewer/workOrders/legacyCmmsRecordPdf.ts
msgid "Next scheduled date"
msgstr "Next scheduled date"

#: src/features/knowledgeDocumentViewer/components/toolbar/SearchResultsNavigator.tsx
msgid "Next search result"
msgstr "Next search result"

#: src/features/timeSeries/components/ActiveTimeRangeSelector.tsx
#: src/features/timeSeries/components/ActiveTimeRangeSelector.tsx
#: src/features/timeSeries/components/TimeRangeSelector.tsx
#: src/features/timeSeries/components/TimeRangeSelector.tsx
msgid "Next time period"
msgstr "Next time period"

#: src/features/fimReview/SubjectDiagnostics.tsx
msgid "Next:"
msgstr "Next:"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatInspectionCard.tsx
msgid "NII assessment"
msgstr "NII assessment"

#: src/features/navbar/navConfig.ts
msgid "NII Dashboard"
msgstr "NII Dashboard"

#: src/features/knowledgeDocumentViewer/components/metadata/ShouldHaveMetadataField.tsx
#: src/features/knowledgeDocumentViewer/graph/nodeTooltip.ts
#: src/pages/site/components/CustomFieldsTableColumns.tsx
#: src/pages/site/forms/customFieldInfoFormFields.ts
msgid "No"
msgstr "No"

#: src/pages/assetLens/components/tabs/imagesTabComponents/ImageGalleryView.tsx
#: src/pages/assetLens/components/tabs/imagesTabComponents/ImageTimelineView.tsx
msgid "No acoustic images available for this asset."
msgstr "No acoustic images available for this asset."

#: src/pages/cases/md/mdCasesListHelpers.ts
msgid "No active M&D cases match the current filters."
msgstr "No active M&D cases match the current filters."

#: src/pages/cases/md/mdCasesListHelpers.ts
msgid "No active M&D cases match the current filters. Switch to Archived or All to inspect closed work."
msgstr "No active M&D cases match the current filters. Switch to Archived or All to inspect closed work."

#: src/pages/evaluations/metadata/dashboard/components/dataLabeling/DataLabelingDashboardComparisonRow.tsx
#: src/pages/evaluations/metadata/dashboard/components/dataLabeling/DataLabelingDashboardFieldDrilldown.tsx
msgid "No active output"
msgstr "No active output"

#: src/pages/cases/activity/ActivityFeed.tsx
msgid "No activity yet"
msgstr "No activity yet"

#: src/features/chatbot/components/ChatbotHelpModal.tsx
msgid "No Agent Response"
msgstr "No Agent Response"

#: src/features/mdCases/components/ProvenanceContentViewer.tsx
msgid "No alerts for this site yet."
msgstr "No alerts for this site yet."

#: src/features/mdCases/components/MonitorLineagePanel.tsx
msgid "No alerts linked to this case yet."
msgstr "No alerts linked to this case yet."

#: src/features/sentinels/components/SentinelAlertsPanel.tsx
msgid "No alerts raised by this sentinel yet."
msgstr "No alerts raised by this sentinel yet."

#: src/pages/assetLens/components/tabs/AnomalyDashboard.tsx
msgid "No anomalies detected"
msgstr "No anomalies detected"

#: src/pages/processData/buildMode/dock/EvalsDockTab.tsx
msgid "No anomaly labels touch "
msgstr "No anomaly labels touch "

#: src/pages/cases/md/mdCasesListHelpers.ts
msgid "No archived M&D cases match the current filters."
msgstr "No archived M&D cases match the current filters."

#: src/features/forecastNotifications/NotificationListPanel.tsx
msgid "No archived notifications"
msgstr "No archived notifications"

#: src/pages/facilityModel/SubjectAssetPanel.tsx
msgid "No asset template exists for this Subject type yet."
msgstr "No asset template exists for this Subject type yet."

#: src/features/timeSeries/agentTab/dock/WindowsTab.tsx
msgid "No baseline window."
msgstr "No baseline window."

#: src/pages/details/extensions/flow/ImageryExtension.tsx
msgid "No bin selected"
msgstr "No bin selected"

#: src/features/timeSeries/utils/uPlotPlugins.ts
msgid "No case yet"
msgstr "No case yet"

#: src/features/sentinels/components/CasesPanel.tsx
msgid "No cases yet — none of this sentinel's ticks breached."
msgstr "No cases yet — none of this sentinel's ticks breached."

#: src/features/mdCases/components/ProvenanceContentViewer.tsx
msgid "No chart yet — at least one threshold has value: <0>null</0> (source: <1>needed</1>). Stage 3 emits a SKIP-stub for this check (see _render_needed_skip_stub in stage3_generate.py), so the function exists in BQ but always returns SKIP and never asserts. Fill in the spec and regenerate to replace the stub with a real check + fixture."
msgstr "No chart yet — at least one threshold has value: <0>null</0> (source: <1>needed</1>). Stage 3 emits a SKIP-stub for this check (see _render_needed_skip_stub in stage3_generate.py), so the function exists in BQ but always returns SKIP and never asserts. Fill in the spec and regenerate to replace the stub with a real check + fixture."

#: src/features/mdCases/components/ProvenanceContentViewer.tsx
msgid "No chat messages persisted for this session yet."
msgstr "No chat messages persisted for this session yet."

#: src/features/knowledgeDocumentViewer/components/sidebar/CrossReferencePanel.tsx
msgid "No clear cross-reference target here. Try closer to a label or symbol."
msgstr "No clear cross-reference target here. Try closer to a label or symbol."

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatInspectionCard.tsx
msgid "No component configuration was provided; default forecast settings may apply."
msgstr "No component configuration was provided; default forecast settings may apply."

#: src/features/richText/components/slashCommandCards/UnitConfigurationModal.tsx
msgid "No components found for this unit"
msgstr "No components found for this unit"

#: src/pages/evaluations/metadata/components/MetricsContent.tsx
msgid "No confirmed labels yet for this organization."
msgstr "No confirmed labels yet for this organization."

#: src/features/fimReview/InspectSources.tsx
msgid "No constituent source records."
msgstr "No constituent source records."

#: src/features/richText/components/RichTextViewer.tsx
#: src/pages/cases/components/CaseCommentContent.tsx
#: src/pages/cases/components/CaseDetailsContent.tsx
msgid "No content"
msgstr "No content"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatEvalCaseReview.tsx
msgid "No conversation id"
msgstr "No conversation id"

#: src/features/timeSeries/agentTab/chat/ConversationDrawer.tsx
msgid "No conversations at this site yet. The one you start will be here for everyone."
msgstr "No conversations at this site yet. The one you start will be here for everyone."

#: src/features/knowledgeDocumentViewer/components/advancedSearch/utils/datapointValueCitations.ts
msgid "no data"
msgstr "no data"

#: src/features/timeSeries/components/panes/TagConfigurationList.tsx
#: src/features/timeSeries/components/panes/TagFilterControls.tsx
#: src/features/timeSeries/components/ScatterPlotTableConfig.tsx
#: src/features/timeSeries/components/ScatterPlotTableLegend.tsx
#: src/features/timeSeries/components/timeSeriesScatterplot/TimeSeriesScatterplotChart.tsx
#: src/features/timeSeries/components/YAxisItem.tsx
#: src/features/timeSeries/components/YScaleControls.tsx
msgid "No data"
msgstr "No data"

#: src/pages/alerts/components/AlertTimeSeriesChart.tsx
msgid "No data available"
msgstr "No data available"

#: src/features/timeSeries/components/timeSeriesScatterplot/NoDataInRange.tsx
msgid "No data found near this range for the selected pens."
msgstr "No data found near this range for the selected pens."

#: src/features/timeSeries/components/rulerTool/RulerMetricsPanel.tsx
msgid "No data in selection"
msgstr "No data in selection"

#: src/features/timeSeries/components/AllTagsTable.tsx
#: src/features/timeSeries/components/AllTagsTable.tsx
msgid "No data in the last 24 hours"
msgstr "No data in the last 24 hours"

#: src/features/timeSeries/components/timeSeriesScatterplot/NoDataInRange.tsx
msgid "No data in this range"
msgstr "No data in this range"

#: src/pages/alerts/components/AlertTimeSeriesChart.tsx
msgid "No datapoint ID associated with this alert"
msgstr "No datapoint ID associated with this alert"

#: src/features/fimEvidence/ProcessDataPanel.tsx
msgid "No datastream on the chart — add one from the details panel."
msgstr "No datastream on the chart — add one from the details panel."

#: src/features/timeSeries/experiment/useLabTransformsOnChart.ts
msgid "No denoise ops in this plan."
msgstr "No denoise ops in this plan."

#: src/features/knowledgeDocumentViewer/components/revisionCompare/RevisionDetailChangeList.tsx
msgid "No detailed changes"
msgstr "No detailed changes"

#: src/features/sentinels/components/CasesPanel.tsx
msgid "No diagnosis text."
msgstr "No diagnosis text."

#: src/pages/evaluations/metadata/dashboard/components/dataLabeling/DataLabelingDashboardOverview.tsx
msgid "No disagreements match these filters."
msgstr "No disagreements match these filters."

#: src/features/knowledgeDocumentViewer/components/metadata/DocumentMetadataContent.tsx
msgid "No document details"
msgstr "No document details"

#: src/features/knowledgeDocumentViewer/components/DocumentTabContent.tsx
#: src/features/knowledgeDocumentViewer/components/viewer/search/DocReferencePreviewCard.tsx
msgid "No document found for “{referenceLabel}”"
msgstr "No document found for “{referenceLabel}”"

#: src/features/knowledgeDocumentViewer/artifacts/useArtifact.ts
msgid "No document is loaded."
msgstr "No document is loaded."

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatEvalCaseCitations.tsx
msgid "No document with this id on this site."
msgstr "No document with this id on this site."

#: src/features/sentinels/SentinelInstancePicker.tsx
msgid "no documents"
msgstr "no documents"

#: src/pages/assetLens/components/tabs/DocumentsTab.tsx
msgid "No documents available for this asset"
msgstr "No documents available for this asset"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatEvalCaseCitations.tsx
msgid "No documents cited"
msgstr "No documents cited"

#: src/features/chatbot/components/DocumentAttachmentPopover.tsx
#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocumentResultsContent.tsx
#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocumentResultsContent.tsx
msgid "No documents found"
msgstr "No documents found"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocumentResultsContent.tsx
msgid "No documents match the current filters"
msgstr "No documents match the current filters"

#: src/pages/assetLens/components/tabs/DocumentsTab.tsx
msgid "No documents match your search"
msgstr "No documents match your search"

#: src/features/knowledgeDocumentViewer/components/sidebar/SubjectDocumentsPanel.tsx
msgid "No documents reference this subject."
msgstr "No documents reference this subject."

#: src/features/knowledgeDocumentViewer/components/sidebar/GraphNodePanel.tsx
msgid "No documents show this node."
msgstr "No documents show this node."

#: src/pages/assetLens/components/AssetDocumentsWrapper.tsx
msgid "No documents yet"
msgstr "No documents yet"

#: src/features/lotoReports/components/LotoTargetDrawings.tsx
msgid "No drawings show this equipment."
msgstr "No drawings show this equipment."

#: src/features/timeSeries/agentTab/dock/FitTab.tsx
msgid "No drivers — the fit cannot run without at least one."
msgstr "No drivers — the fit cannot run without at least one."

#: src/features/timeSeries/components/SentinelsTab.tsx
msgid "No drivers recorded for this sentinel."
msgstr "No drivers recorded for this sentinel."

#: src/features/richText/editorPlugins/SlashCommandPlugin.tsx
msgid "No entries found"
msgstr "No entries found"

#: src/pages/facilityModel/FacilityModelCatalog.tsx
msgid "No equipment Subjects in the published run."
msgstr "No equipment Subjects in the published run."

#: src/features/lotoReports/components/LotoTargetEquipmentList.tsx
msgid "No equipment targeted yet."
msgstr "No equipment targeted yet."

#: src/features/kestrelUpload/KestrelModelUploadSection.tsx
msgid "No files"
msgstr "No files"

#: src/features/powerCustomerUploads/components/PowerCustomerUploadPicker.tsx
msgid "No files found. Choose a folder with files or select files to upload."
msgstr "No files found. Choose a folder with files or select files to upload."

#: src/features/powerCustomerUploads/components/PowerCustomerUploadPicker.tsx
msgid "No files found. Drop files or folders, or use Browse to select them."
msgstr "No files found. Drop files or folders, or use Browse to select them."

#: src/features/powerCustomerUploads/components/PowerCustomerUploadPage.tsx
msgid "No files in this upload request"
msgstr "No files in this upload request"

#: src/features/powerCustomerUploads/components/PowerCustomerUploadPage.tsx
msgid "No files staged"
msgstr "No files staged"

#: src/pages/processData/buildMode/dock/SamplingSection.tsx
msgid "no fill"
msgstr "no fill"

#: src/features/sentinels/SentinelInstancePicker.tsx
msgid "No filled asset instance on this site yet. Fill one from the Assets tab first — a sentinel is designed from the fill's bound tags."
msgstr "No filled asset instance on this site yet. Fill one from the Assets tab first — a sentinel is designed from the fill's bound tags."

#: src/features/mdCases/components/ProvenanceContentViewer.tsx
msgid "No fixture found for check \"{nodeName}\" in the {unitSlug} bundle. The bundle exists but the check wasn’t included in the most recent fixture compile."
msgstr "No fixture found for check \"{nodeName}\" in the {unitSlug} bundle. The bundle exists but the check wasn’t included in the most recent fixture compile."

#: src/features/knowledgeDocumentViewer/graph/useDocumentGraph.ts
msgid "No graph overlays on this page."
msgstr "No graph overlays on this page."

#: src/pages/facilityModel/SubjectAssetPanel.tsx
msgid "no historian tag"
msgstr "no historian tag"

#: src/pages/facilityModel/SubjectDetailPage.tsx
msgid "No historian tags are linked to this Subject."
msgstr "No historian tags are linked to this Subject."

#: src/features/timeSeries/agentTab/dock/VersionsTab.tsx
msgid "No history yet — this model has only been saved once. Editing a knob and applying it will push the current settings here."
msgstr "No history yet — this model has only been saved once. Editing a knob and applying it will push the current settings here."

#: src/features/knowledgeDocumentViewer/components/revisionCompare/RevisionComparePane.tsx
msgid "No image available"
msgstr "No image available"

#: src/pages/details/extensions/flow/ImageryExtension.tsx
msgid "No image available at "
msgstr "No image available at "

#: src/features/facilityModel/components/ReferencePreviewPanel.tsx
msgid "No inline preview — open in a tab."
msgstr "No inline preview — open in a tab."

#: src/pages/facilityModel/FacilityModelCatalog.tsx
msgid "No instrument Subjects in the published run."
msgstr "No instrument Subjects in the published run."

#: src/pages/cases/md/MdCaseDetailsMainColumn.tsx
#: src/pages/cases/md/MdCaseDetailsMainColumn.tsx
msgid "No investigation notes yet."
msgstr "No investigation notes yet."

#: src/pages/assetLens/components/tabs/imagesTabComponents/ImageGalleryView.tsx
#: src/pages/assetLens/components/tabs/imagesTabComponents/ImageTimelineView.tsx
msgid "No IR images available for this asset."
msgstr "No IR images available for this asset."

#: src/features/lotoReports/components/LotoSheetEditor.tsx
msgid "No isolation points yet."
msgstr "No isolation points yet."

#: src/features/timeSeries/components/LabelsTab.tsx
msgid "No labels at this site yet. Draw one with the label tool on the chart."
msgstr "No labels at this site yet. Draw one with the label tool on the chart."

#: src/features/timeSeries/components/LabelsTab.tsx
msgid "No labels match these filters."
msgstr "No labels match these filters."

#: src/pages/cases/md/MdCaseDetailsInspector.tsx
msgid "No linked alerts are attached to this case yet."
msgstr "No linked alerts are attached to this case yet."

#: src/features/mdCases/components/CaseStorySection.tsx
msgid "No linked signal for this group."
msgstr "No linked signal for this group."

#: src/features/lotoReports/components/LotoReportsEmptyState.tsx
msgid "No LOTO reports yet"
msgstr "No LOTO reports yet"

#: src/pages/cases/md/mdCasesListHelpers.ts
msgid "No M&D cases match the current filters."
msgstr "No M&D cases match the current filters."

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatEvalCaseCitations.tsx
msgid "No matched pages. Paste its document id or link above and enter a page number."
msgstr "No matched pages. Paste its document id or link above and enter a page number."

#: src/features/timeSeries/experiment/TagPicker.tsx
msgid "No matches"
msgstr "No matches"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/documentsCardView/documentCardFilterBar/MultiSelectFilterField.tsx
msgid "No matches found"
msgstr "No matches found"

#: src/pages/metrics/components/FilterPopover.tsx
msgid "No matches."
msgstr "No matches."

#: src/pages/manageAccess/components/scope/SiteSelect.tsx
msgid "No matching organizations"
msgstr "No matching organizations"

#: src/pages/manageAccess/components/scope/SiteSelect.tsx
msgid "No matching sites"
msgstr "No matching sites"

#: src/features/modelOperations/SubjectTargetPickerColumn.tsx
msgid "No matching Subjects."
msgstr "No matching Subjects."

#: src/components/DateTimeWithTimezone.tsx
msgid "No matching timezones"
msgstr "No matching timezones"

#: src/pages/details/visualization/Visualization.tsx
msgid "No measurement data layer is currently displayed."
msgstr "No measurement data layer is currently displayed."

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatRevisionMissingCard.tsx
msgid "No missing revisions found in a complete audit."
msgstr "No missing revisions found in a complete audit."

#: src/features/timeSeries/agentTab/dock/AgentDock.tsx
msgid "No model yet. Ask the agent to build one in the Models panel — the parameters below fill in as it decides them."
msgstr "No model yet. Ask the agent to build one in the Models panel — the parameters below fill in as it decides them."

#: src/pages/processData/buildMode/rightPanel/SavedModelShelf.tsx
msgid "No models match."
msgstr "No models match."

#: src/features/timeSeries/agentTab/ModelPicker.tsx
msgid "no models yet"
msgstr "no models yet"

#: src/features/knowledgeDocumentViewer/contexts/PageMetadataEvalSessionContext.tsx
msgid "No more pages in this queue"
msgstr "No more pages in this queue"

#: src/features/richText/components/slashCommandCards/UnitConfigurationModal.tsx
msgid "No multi-component view configured for this unit. Please configure the asset model to enable visualization controls."
msgstr "No multi-component view configured for this unit. Please configure the asset model to enable visualization controls."

#: src/features/forecastNotifications/NotificationListPanel.tsx
#: src/features/forecastNotifications/NotificationsDropdownContent.tsx
msgid "No notifications"
msgstr "No notifications"

#: src/features/forecastNotifications/NotificationListPanel.tsx
msgid "No notifications match your search"
msgstr "No notifications match your search"

#: src/features/kestrelViewer/ui/tools/photoreel/annotation/usePhotoAnnotationSession.ts
msgid "No object was found at that point. Try clicking directly on an object."
msgstr "No object was found at that point. Try clicking directly on an object."

#: src/pages/manageAccess/components/table/UsersSection.tsx
msgid "No one has access to this site yet."
msgstr "No one has access to this site yet."

#: src/pages/manageAccess/components/table/UsersSection.tsx
msgid "No one matches that search."
msgstr "No one matches that search."

#: src/pages/facilityModel/SubjectAssetPanel.tsx
msgid "No openable document for this reference"
msgstr "No openable document for this reference"

#: src/features/knowledgeDocumentViewer/components/table/cells/HeaderCell.tsx
msgid "No options"
msgstr "No options"

#: src/features/lotoReports/printReport/printPageText.ts
msgid "No P&ID markup for this page"
msgstr "No P&ID markup for this page"

#: src/features/knowledgeDocumentViewer/components/metadata/PageMetadataContent.tsx
msgid "No page metadata for page {pageNum}"
msgstr "No page metadata for page {pageNum}"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/documentPreview/DocumentPreviewContent.tsx
msgid "No page summary"
msgstr "No page summary"

#: src/pages/evaluations/metadata/dashboard/components/dataLabeling/DataLabelingDashboardSummaryCards.tsx
msgid "No pages in this corpus"
msgstr "No pages in this corpus"

#: src/pages/evaluations/metadata/labeling/components/DataLabelingSessionViewer.tsx
msgid "No pages in this queue"
msgstr "No pages in this queue"

#: src/pages/evaluations/metadata/dashboard/components/dataLabeling/DataLabelingDashboardFieldDrilldown.tsx
msgid "No pages match these filters."
msgstr "No pages match these filters."

#: src/features/lotoReports/components/LotoAttachmentsSection.tsx
msgid "No pages yet. Open a drawing in the document viewer and add its pages to this report."
msgstr "No pages yet. Open a drawing in the document viewer and add its pages to this report."

#: src/features/timeSeries/agentTab/dock/VersionsTab.tsx
msgid "no parameter change"
msgstr "no parameter change"

#: src/features/timeSeries/components/labelTool/LabelConfigPanel.tsx
msgid "No pens on the chart"
msgstr "No pens on the chart"

#: src/features/mdCases/components/ProvenanceContentViewer.tsx
msgid "No pens with data in the last 7 days."
msgstr "No pens with data in the last 7 days."

#: src/features/fim/photos/SubjectPhotos.tsx
msgid "No photos are attached to this Subject."
msgstr "No photos are attached to this Subject."

#: src/features/fim/photos/SubjectPhotos.tsx
msgid "No photos are attached to this Subject. Add one from the field or drop a file here."
msgstr "No photos are attached to this Subject. Add one from the field or drop a file here."

#: src/features/sentinels/SentinelInstancePicker.tsx
msgid "no PI tags"
msgstr "no PI tags"

#: src/features/knowledgeDocumentViewer/components/DocumentUnavailablePanel.tsx
msgid "No pipeline configs found for this site."
msgstr "No pipeline configs found for this site."

#: src/features/timeSeries/experiment/ExperimentTab.tsx
msgid "No points left the expected ± band for the selected method."
msgstr "No points left the expected ± band for the selected method."

#: src/features/knowledgeDocumentViewer/components/metadata/RevisionFamilyCard.tsx
msgid "No preview"
msgstr "No preview"

#: src/features/knowledgeDocumentViewer/components/viewer/search/DocReferencePreviewCard.tsx
msgid "No preview available"
msgstr "No preview available"

#: src/features/chatbot/components/ChatHistoryDrawer.tsx
msgid "No previous conversations"
msgstr "No previous conversations"

#: src/pages/facilityModel/FacilityModelCatalog.tsx
#: src/pages/facilityModel/SubjectDetailPage.tsx
msgid "No published fusion run for this site yet."
msgstr "No published fusion run for this site yet."

#: src/pages/cases/md/MdCaseDetailsMainColumn.tsx
msgid "No published recommendation"
msgstr "No published recommendation"

#: src/features/timeSeries/experiment/useLabTransformsOnChart.ts
msgid "No range or gate ops in this plan."
msgstr "No range or gate ops in this plan."

#: src/features/timeSeries/experiment/SplitBuilder.tsx
msgid "No ranges yet — set the date window above, then press “Reset to window”. Running with an empty list ignores the custom dates."
msgstr "No ranges yet — set the date window above, then press “Reset to window”. Running with an empty list ignores the custom dates."

#: src/features/mdCases/components/ProvenanceContentViewer.tsx
msgid "No real file behind this reference (entry {entryId}). The LLM may have hallucinated this citation."
msgstr "No real file behind this reference (entry {entryId}). The LLM may have hallucinated this citation."

#: src/pages/assetLens/components/tabs/AnomalyDashboard.tsx
msgid "No recent activity"
msgstr "No recent activity"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/sensors/SensorPreviewPanel.tsx
msgid "No recent data"
msgstr "No recent data"

#: src/features/knowledgeDocumentViewer/components/viewer/shared/SparklineTooltipContent.tsx
msgid "No recent data available"
msgstr "No recent data available"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/SearchSuggestionsDropdown.tsx
msgid "No recent searches"
msgstr "No recent searches"

#: src/pages/cases/md/MdCaseDetailsMainColumn.tsx
#: src/pages/cases/md/MdCaseDetailsMainColumn.tsx
msgid "No recommendation draft yet."
msgstr "No recommendation draft yet."

#: src/pages/assetLens/components/tabs/SensorIssuesTab.tsx
msgid "No recommended action provided."
msgstr "No recommended action provided."

#: src/features/mdCases/components/CaseTimeline.tsx
msgid "No recorded events yet."
msgstr "No recorded events yet."

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/ReportTable.tsx
msgid "No recorded rows."
msgstr "No recorded rows."

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/ReportChart.tsx
msgid "No recorded values."
msgstr "No recorded values."

#: src/features/timeSeries/components/PenSubjectLinksSection.tsx
msgid "No referenced documents"
msgstr "No referenced documents"

#: src/pages/cases/md/MdCaseReferencesDrawer.tsx
msgid "No references are attached to this case yet."
msgstr "No references are attached to this case yet."

#: src/features/fimReview/IdentityPanel.tsx
msgid "No references recorded for this alias."
msgstr "No references recorded for this alias."

#: src/features/knowledgeDocumentViewer/components/sidebar/CrossReferencePanel.tsx
msgid "No related documents found for this region."
msgstr "No related documents found for this region."

#: src/features/timeSeries/experiment/CleaningControls.tsx
msgid "no removals"
msgstr "no removals"

#: src/features/chatbot/components/conversationMessage/ConversationMessage.tsx
msgid "No response from AI"
msgstr "No response from AI"

#: src/features/knowledgeDocumentViewer/components/viewer/search/IntraDocSearchBar.tsx
#: src/features/knowledgeDocumentViewer/workOrders/WorkOrderViewer.tsx
msgid "No results"
msgstr "No results"

#: src/components/table/TableComponent.tsx
#: src/features/knowledgeDocumentViewer/components/table/GeckoPowerTable.tsx
msgid "No results."
msgstr "No results."

#: src/pages/evaluations/metadata/components/MetricsContent.tsx
msgid "No reviewer comparisons yet"
msgstr "No reviewer comparisons yet"

#: src/features/knowledgeDocumentViewer/components/revisionCompare/RevisionCompareContent.tsx
msgid "No revision diff available."
msgstr "No revision diff available."

#: src/features/knowledgeDocumentViewer/hooks/useSaveDocumentMetadataUserEdit.ts
#: src/features/knowledgeDocumentViewer/hooks/useSaveDocumentPageMetadataUserEdit.ts
msgid "No revision family members to save"
msgstr "No revision family members to save"

#: src/pages/systemView/components/unitsTab/UnitListItem.tsx
msgid "no risk assessment or Gecko scan found"
msgstr "no risk assessment or Gecko scan found"

#: src/features/timeSeries/experiment/ExperimentTab.tsx
msgid "No saved experiments"
msgstr "No saved experiments"

#: src/pages/processData/buildMode/rightPanel/SavedModelShelf.tsx
msgid "No saved models for this tag yet — “All” shows the whole shelf."
msgstr "No saved models for this tag yet — “All” shows the whole shelf."

#: src/pages/processData/buildMode/dock/EvalsDockTab.tsx
msgid "No saved models with weights yet — train and “Save trained model” first."
msgstr "No saved models with weights yet — train and “Save trained model” first."

#: src/pages/processData/buildMode/dock/BacktestDockTab.tsx
msgid "No saved models with weights yet — train, then “Save trained model”."
msgstr "No saved models with weights yet — train, then “Save trained model”."

#: src/features/timeSeries/agentTab/ModelPicker.tsx
msgid "No saved models yet. Ask the agent to build one, then say “save it”."
msgstr "No saved models yet. Ask the agent to build one, then say “save it”."

#: src/pages/forgingsReporting/ForgingsReportingPage.tsx
msgid "No saved reports"
msgstr "No saved reports"

#: src/pages/forgingsReporting/ForgingsReportingPage.tsx
msgid "No saved reports are available with your current access."
msgstr "No saved reports are available with your current access."

#: src/pages/assetLens/components/tabs/SensorIssuesTab.tsx
msgid "No sensor issues detected"
msgstr "No sensor issues detected"

#: src/features/timeSeries/components/RegressionPrediction.tsx
#: src/features/timeSeries/components/ThresholdConfigurationModal.tsx
#: src/features/timeSeries/components/ThresholdFiltering.tsx
msgid "No sensors selected"
msgstr "No sensors selected"

#: src/features/sentinels/components/SentinelList.tsx
msgid "No sentinels for this site yet. Runs from the sentinel backend appear here automatically."
msgstr "No sentinels for this site yet. Runs from the sentinel backend appear here automatically."

#: src/features/timeSeries/components/SentinelsTab.tsx
msgid "No sentinels match “"
msgstr "No sentinels match “"

#: src/pages/facilityModel/SentinelOverviewPage.tsx
msgid "No sentinels on this site."
msgstr "No sentinels on this site."

#: src/features/timeSeries/components/SentinelsTab.tsx
msgid "No sentinels yet. Press "
msgstr "No sentinels yet. Press "

#: src/pages/cases/md/mdCasesListHelpers.ts
msgid "No shelved M&D cases match the current filters."
msgstr "No shelved M&D cases match the current filters."

#: src/pages/documents/PowerCustomerUploadRoutePage.tsx
#: src/pages/evaluations/metadata/labeling/DataLabelingPage.tsx
msgid "No site ID"
msgstr "No site ID"

#: src/pages/homepage/Homepage.tsx
msgid "No site ID found"
msgstr "No site ID found"

#: src/pages/manageAccess/components/scope/SiteSelect.tsx
msgid "No sites available"
msgstr "No sites available"

#: src/pages/noSites/NoSites.tsx
#: src/pages/noSites/NoSites.tsx
msgid "No Sites Found"
msgstr "No Sites Found"

#: src/pages/metrics/components/ConversationExplorerCard.tsx
#: src/pages/metrics/Metrics.tsx
msgid "No sites in the current selection."
msgstr "No sites in the current selection."

#: src/pages/evaluations/metadata/dashboard/components/dataLabeling/DataLabelingDashboardSites.tsx
msgid "No sites in this organization."
msgstr "No sites in this organization."

#: src/pages/facilityModel/SubjectDetailPage.tsx
msgid "No source asserts this Subject in the published run."
msgstr "No source asserts this Subject in the published run."

#: src/features/fimEvidence/SubjectGlyphs.tsx
#: src/features/modelOperations/Corroboration.tsx
msgid "No source corroboration"
msgstr "No source corroboration"

#: src/pages/facilityModel/FacilityModelDataIssues.tsx
msgid "no Subject in the published run"
msgstr "no Subject in the published run"

#: src/pages/facilityModel/FacilityModelCatalog.tsx
msgid "No Subjects in the published run."
msgstr "No Subjects in the published run."

#: src/pages/facilityModel/FacilityModelCatalog.tsx
msgid "No Subjects in this site have been promoted to Asset Instances yet."
msgstr "No Subjects in this site have been promoted to Asset Instances yet."

#: src/pages/facilityModel/FacilityModelCatalog.tsx
msgid "No Subjects match the current filters."
msgstr "No Subjects match the current filters."

#: src/features/timeSeries/experiment/ExperimentTab.tsx
msgid "no summary"
msgstr "no summary"

#: src/features/knowledgeDocumentViewer/components/viewer/search/ConnectorLookupPanel.tsx
msgid "No supported destination found."
msgstr "No supported destination found."

#: src/features/mdCases/components/ProvenanceContentViewer.tsx
msgid "No synthetic fixture bundle for unit \"{unitSlug}\" yet — the explanation chart is generated downstream from a Constructor V3 fixture, and this unit hasn't been compiled into one."
msgstr "No synthetic fixture bundle for unit \"{unitSlug}\" yet — the explanation chart is generated downstream from a Constructor V3 fixture, and this unit hasn't been compiled into one."

#: src/pages/systemView/components/UnitsTab.tsx
msgid "No tagged units yet."
msgstr "No tagged units yet."

#: src/features/timeSeries/components/panes/tagFilters.ts
msgid "No tags match."
msgstr "No tags match."

#: src/features/timeSeries/components/DerivedValuesTab.tsx
msgid "No Tags Selected"
msgstr "No Tags Selected"

#: src/features/facilityModel/views.ts
#: src/features/fim/assetInventory.ts
msgid "No template"
msgstr "No template"

#: src/pages/facilityModel/SubjectAssetPanel.tsx
msgid "No template-fill detail is available for this Asset Instance yet."
msgstr "No template-fill detail is available for this Asset Instance yet."

#: src/features/timeSeries/experiment/ResidualMiniPlot.tsx
msgid "No test rows in this split — nothing to residual-plot."
msgstr "No test rows in this split — nothing to residual-plot."

#: src/features/assetLifecycleV2/views/observations/LtaProfilePlot.tsx
msgid "No thickness data is available inside this LTA region."
msgstr "No thickness data is available inside this LTA region."

#: src/pages/alerts/components/AlertTimeSeriesChart.tsx
msgid "No time series data found for this alert in the specified time range"
msgstr "No time series data found for this alert in the specified time range"

#: src/pages/evaluations/metadata/labeling/components/DataLabelingTypeFilter.tsx
msgid "No types"
msgstr "No types"

#: src/pages/evaluations/metadata/labeling/components/DataLabelingTypeFilter.tsx
msgid "No types match"
msgstr "No types match"

#: src/features/timeSeries/components/timeSeriesScatterplot/useChartInteractionFunctions.ts
#: src/features/timeSeries/hooks/useInterpolatedHover.ts
#: src/features/timeSeries/hooks/useTimeSeriesDataProcessing.ts
#: src/features/timeSeries/hooks/useTimeSeriesUX.ts
#: src/pages/assetLens/AssetLens.tsx
msgid "No Unit"
msgstr "No Unit"

#: src/pages/assetLens/AssetLens.tsx
msgid "No Unit ID Provided"
msgstr "No Unit ID Provided"

#: src/pages/systemView/components/UnitsTab.tsx
msgid "No units match the current filters."
msgstr "No units match the current filters."

#: src/features/forecastNotifications/NotificationListPanel.tsx
#: src/features/forecastNotifications/NotificationsDropdownContent.tsx
msgid "No unread notifications"
msgstr "No unread notifications"

#: src/features/powerCustomerUploads/components/PowerCustomerUploadHistoryPanel.tsx
msgid "No upload history"
msgstr "No upload history"

#: src/features/powerCustomerUploads/components/PowerCustomerUploadHistoryPanel.tsx
msgid "No uploads match these filters"
msgstr "No uploads match these filters"

#: src/features/richText/editorPlugins/MentionPluginBase.tsx
msgid "No users found"
msgstr "No users found"

#: src/features/richText/components/TaggableUsersCard.tsx
msgid "No users in the list. Search and add users above."
msgstr "No users in the list. Search and add users above."

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/documentsCardView/documentCardFilterBar/MultiSelectFilterField.tsx
msgid "No values available"
msgstr "No values available"

#: src/pages/evaluations/metadata/labeling/utils/vendorOptions.ts
msgid "No vendors"
msgstr "No vendors"

#: src/pages/evaluations/metadata/labeling/components/DataLabelingVendorFilter.tsx
msgid "No vendors found"
msgstr "No vendors found"

#: src/pages/processData/components/viewSwitcher/ViewSwitcher.tsx
msgid "No views match."
msgstr "No views match."

#: src/features/timeSeries/components/DataLayersControl.tsx
msgid "No work orders available for this asset. Create work orders to see maintenance and inspection events on the timeline."
msgstr "No work orders available for this asset. Create work orders to see maintenance and inspection events on the timeline."

#: src/features/knowledgeDocumentViewer/workOrders/workOrderPdf.ts
msgid "No work-log text in this imported record."
msgstr "No work-log text in this imported record."

#: src/pages/details/extensions/flow/SummarizerExtension.tsx
msgid "Nominal"
msgstr "Nominal"

#: src/pages/details/extensions/flow/AssetModelEditorExtension.tsx
msgid "Nominal plates are read-only for EMAT inspections."
msgstr "Nominal plates are read-only for EMAT inspections."

#: src/pages/details/visualization/tools/CompartmentsToggle.tsx
msgid "Nominal Plates shown"
msgstr "Nominal Plates shown"

#: src/features/facilityModel/columns.ts
msgid "Non-asset"
msgstr "Non-asset"

#: src/pages/evaluations/metadata/labeling/utils/pageClassificationTaxonomy.ts
msgid "Non-isometric piping and conduit arrangements"
msgstr "Non-isometric piping and conduit arrangements"

#: src/features/timeSeries/agentTab/chat/BuildCard.tsx
#: src/features/timeSeries/agentTab/dock/AlertingTab.tsx
msgid "none"
msgstr "none"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatAgentsMenu.tsx
#: src/features/lotoReports/components/LotoDrawingsCoverage.tsx
#: src/features/lotoReports/components/LotoEquipmentCoverage.tsx
#: src/features/lotoReports/components/LotoPointsCoverage.tsx
#: src/features/timeSeries/components/labelTool/LabelConfigPanel.tsx
#: src/features/timeSeries/components/panes/TagFilterControls.tsx
msgid "None"
msgstr "None"

#: src/features/knowledgeDocumentViewer/components/DocumentUnavailablePanel.tsx
msgid "none (bare id)"
msgstr "none (bare id)"

#: src/features/knowledgeDocumentViewer/components/DocumentUnavailablePanel.tsx
msgid "none selected"
msgstr "none selected"

#: src/pages/assetLens/components/tabs/imagesTabComponents/ImageTrendAnalysis.tsx
msgid "normal"
msgstr "normal"

#: src/pages/alerts/alertStatusLabel.ts
msgid "Normal"
msgstr "Normal"

#: src/features/timeSeries/experiment/ExperimentTab.tsx
msgid "Normalization"
msgstr "Normalization"

#: src/pages/cases/md/MdCaseDetailsPage.tsx
#: src/pages/cases/md/MdCaseDetailsPage.tsx
msgid "Normalization diagnostics"
msgstr "Normalization diagnostics"

#: src/features/timeSeries/experiment/NormalizationViewer.tsx
msgid "Normalize"
msgstr "Normalize"

#: src/features/timeSeries/experiment/NormalizationViewer.tsx
msgid "Normalize against"
msgstr "Normalize against"

#: src/features/timeSeries/experiment/NormalizationViewer.tsx
msgid "normalize failed"
msgstr "normalize failed"

#: src/features/timeSeries/experiment/NormalizationViewer.tsx
msgid "Normalize the target against selected tags. Flatness = variance reduction (1 − var(normalized)/var(target)). Higher = more of the target's movement is explained by the selected tags. With N drivers, the chart shows the combined result plus one trace per driver."
msgstr "Normalize the target against selected tags. Flatness = variance reduction (1 − var(normalized)/var(target)). Higher = more of the target's movement is explained by the selected tags. With N drivers, the chart shows the combined result plus one trace per driver."

#: src/pages/alerts/components/AlertsTableColumns.tsx
msgid "Not Acknowledged"
msgstr "Not Acknowledged"

#: src/features/fimReview/InspectSources.tsx
#: src/features/fimReview/StructuralReviewFlow.tsx
msgid "Not an asset"
msgstr "Not an asset"

#: src/features/fimReview/InspectSources.tsx
msgid "Not connected"
msgstr "Not connected"

#: src/features/timeSeries/agentTab/dock/AlertingTab.tsx
msgid "Not evaluated yet."
msgstr "Not evaluated yet."

#: src/features/timeSeries/agentTab/dock/TargetTab.tsx
msgid "not fitted yet"
msgstr "not fitted yet"

#: src/features/timeSeries/agentTab/dock/BacktestTab.tsx
msgid "Not held out — these events were in the baseline, so the model was taught they were normal. Treat a miss here as uninformative."
msgstr "Not held out — these events were in the baseline, so the model was taught they were normal. Treat a miss here as uninformative."

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatFeedbackButton.tsx
msgid "Not helpful"
msgstr "Not helpful"

#: src/pages/facilityModel/SubjectAssetPanel.tsx
msgid "Not matched"
msgstr "Not matched"

#: src/pages/facilityModel/FacilityModelCatalog.tsx
#: src/pages/facilityModel/FacilityModelFilters.tsx
msgid "Not promoted"
msgstr "Not promoted"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/ReportTable.tsx
#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/ReportView.tsx
#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/ReportView.tsx
msgid "Not recorded"
msgstr "Not recorded"

#: src/features/timeSeries/agentTab/AgentHeader.tsx
msgid "not saved"
msgstr "not saved"

#: src/features/timeSeries/agentTab/dock/SaveModelBar.tsx
msgid "Not saved yet"
msgstr "Not saved yet"

#: src/features/fimReview/ReviewActions.tsx
#: src/features/knowledgeDocumentViewer/components/metadata/MetadataCardGrid.tsx
#: src/features/knowledgeDocumentViewer/components/metadata/MetadataFieldRow.tsx
#: src/features/modelOperations/SubjectDetails.tsx
#: src/features/modelOperations/SubjectDetails.tsx
#: src/pages/facilityModel/SubjectDetailPage.tsx
#: src/pages/facilityModel/SubjectDetailPage.tsx
msgid "Not set"
msgstr "Not set"

#: src/features/knowledgeDocumentViewer/workOrders/workOrderPdf.ts
msgid "Not supplied"
msgstr "Not supplied"

#: src/features/facilityModel/columns.ts
#: src/features/modelOperations/SubjectDetails.tsx
msgid "Not validated"
msgstr "Not validated"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/utils/docChatFeedback.ts
msgid "Not what I asked for"
msgstr "Not what I asked for"

#: src/features/fimReview/ReviewActions.tsx
msgid "Note (optional)"
msgstr "Note (optional)"

#: src/features/timeSeries/sentinelStudio/SentinelBuilderPanel.tsx
msgid "Notes for the design agent"
msgstr "Notes for the design agent"

#: src/pages/facilityModel/FacilityModelCatalog.tsx
msgid "Nothing is waiting for review."
msgstr "Nothing is waiting for review."

#: src/features/timeSeries/agentTab/dock/WindowsTab.tsx
msgid "Nothing masked."
msgstr "Nothing masked."

#: src/features/timeSeries/components/timeSeriesScatterplot/EmbeddedChartToolbar.tsx
#: src/pages/processData/components/ProcessDataTopBar.tsx
msgid "Nothing plotted yet"
msgstr "Nothing plotted yet"

#: src/features/timeSeries/agentTab/dock/SettingsTab.tsx
#: src/features/timeSeries/components/panes/PensPane.tsx
#: src/features/timeSeries/components/panes/TagConfigurationList.tsx
msgid "Nothing plotted yet."
msgstr "Nothing plotted yet."

#: src/pages/processData/buildMode/rightPanel/SavedModelShelf.tsx
msgid "Nothing saved yet — train, then Save to build your shelf."
msgstr "Nothing saved yet — train, then Save to build your shelf."

#: src/features/forecastNotifications/NotificationsDropdownContent.tsx
#: src/features/forecastNotifications/NotificationsDropdownSidebar.tsx
#: src/features/navbar/navConfig.ts
#: src/pages/manageAccess/ManageAccessPage.tsx
msgid "Notifications"
msgstr "Notifications"

#: src/features/forecastNotifications/NotificationListPanel.tsx
msgid "Notifications ({total})"
msgstr "Notifications ({total})"

#: src/features/timeSeries/components/TimeRangeDisplay.tsx
#: src/pages/evaluations/metadata/components/MetricsContent.tsx
msgid "Now"
msgstr "Now"

#: src/features/timeSeries/components/RelativeDateConfig.tsx
msgid "Now (refreshing every "
msgstr "Now (refreshing every "

#: src/pages/site/forms/customFieldInfoFormFields.ts
msgid "Number"
msgstr "Number"

#: src/pages/details/extensions/flow/SummarizerExtension.tsx
msgid "Number of A-scans"
msgstr "Number of A-scans"

#: src/pages/details/extensions/flow/SummarizerExtension.tsx
msgid "Number of bins with data"
msgstr "Number of bins with data"

#: src/features/richText/components/ToolbarPlugin.tsx
msgid "Numbered List"
msgstr "Numbered List"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
#: src/features/knowledgeDocumentViewer/workOrders/legacyCmmsRecordPdf.ts
msgid "Numeric response"
msgstr "Numeric response"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
#: src/features/knowledgeDocumentViewer/workOrders/legacyCmmsRecordPdf.ts
msgid "Numeric value"
msgstr "Numeric value"

#: src/pages/evaluations/metadata/labeling/utils/pageClassificationTaxonomy.ts
msgid "Observations, tests and service records"
msgstr "Observations, tests and service records"

#: src/features/fimReview/StructuralReviewFlow.tsx
#: src/features/timeSeries/experiment/TransparencyStrip.tsx
msgid "Observed"
msgstr "Observed"

#: src/features/knowledgeDocumentViewer/components/toolbar/SettingsMenu.tsx
msgid "OCR boxes"
msgstr "OCR boxes"

#: src/features/fimReview/DecisionHistory.tsx
msgid "OCR corrected"
msgstr "OCR corrected"

#: src/features/fimReview/IdentityPanel.tsx
msgid "OCR correction"
msgstr "OCR correction"

#: src/features/fimReview/IdentityPanel.tsx
#: src/features/fimReview/InspectSources.tsx
msgid "OCR variant"
msgstr "OCR variant"

#: src/features/timeSeries/experiment/DiagnosticsPanel.tsx
msgid "of |residual| on "
msgstr "of |residual| on "

#: src/features/timeSeries/agentTab/dock/AlertingTab.tsx
msgid "of last"
msgstr "of last"

#: src/features/knowledgeDocumentViewer/components/toolbar/DocumentPreviewModeSwitch.tsx
#: src/features/navbar/KeyboardShortcutsToggle.tsx
#: src/pages/facilityModel/SentinelOverviewPage.tsx
#: src/pages/processData/buildMode/components/OnOffToggle.tsx
msgid "Off"
msgstr "Off"

#: src/features/timeSeries/experiment/SamplingKnobs.tsx
msgid "off (prod default)"
msgstr "off (prod default)"

#: src/pages/processData/buildMode/dock/CleaningSection.tsx
msgid "Off keeps every test row even where a gate fails, so held-out metrics see all operating regimes; gates then only drop train and val rows."
msgstr "Off keeps every test row even where a gate fails, so held-out metrics see all operating regimes; gates then only drop train and val rows."

#: src/features/knowledgeDocumentViewer/graph/nodeTooltip.ts
msgid "Off-page connector {offPageConnectorNumber}"
msgstr "Off-page connector {offPageConnectorNumber}"

#: src/pages/cases/components/CaseFeedbackModal.tsx
msgid "Okay"
msgstr "Okay"

#: src/features/forecastNotifications/NotificationListPanel.tsx
msgid "Oldest first"
msgstr "Oldest first"

#: src/pages/cases/md/MdCaseDetailsMainColumn.tsx
msgid "Oldest First"
msgstr "Oldest First"

#: src/features/knowledgeDocumentViewer/components/toolbar/DocumentPreviewModeSwitch.tsx
#: src/features/navbar/KeyboardShortcutsToggle.tsx
#: src/pages/processData/buildMode/components/OnOffToggle.tsx
msgid "On"
msgstr "On"

#: src/features/timeSeries/agentTab/AgentHeader.tsx
msgid "on chart"
msgstr "on chart"

#: src/features/timeSeries/agentTab/dock/AlertingTab.tsx
msgid "on days"
msgstr "on days"

#: src/features/timeSeries/agentTab/chat/ToolCard.tsx
msgid "On the chart"
msgstr "On the chart"

#: src/features/lotoReports/components/LotoReportSelect.tsx
msgid "On this page"
msgstr "On this page"

#: src/features/timeSeries/agentTab/dock/TargetTab.tsx
msgid "One control on purpose: this is both what gets pulled from the historian and what one point on the chart means. The KPI and its expectation are both drawn at this resolution, and sigma is measured at it too — a finer bucket is noisier, so the band widens. Alert cadence counts buckets, so leave it at 1 day for long-term drift monitoring."
msgstr "One control on purpose: this is both what gets pulled from the historian and what one point on the chart means. The KPI and its expectation are both drawn at this resolution, and sigma is measured at it too — a finer bucket is noisier, so the band widens. Alert cadence counts buckets, so leave it at 1 day for long-term drift monitoring."

#: src/pages/processData/buildMode/dock/CleaningSection.tsx
msgid "One row per modeled tag with its data quality at a glance. Expand a row to bound, clip, de-freeze, or gate that tag."
msgstr "One row per modeled tag with its data quality at a glance. Expand a row to bound, clip, de-freeze, or gate that tag."

#: src/pages/manageAccess/components/table/UserRow.tsx
msgid "Only an admin can change another admin's user type."
msgstr "Only an admin can change another admin's user type."

#: src/pages/assetLens/components/tabs/imagesTabComponents/ImageTimelineView.tsx
msgid "Only one image available. Date: {singleImageDate}"
msgstr "Only one image available. Date: {singleImageDate}"

#: src/features/fimReview/subjectDecisionBuilders.ts
msgid "Only one split Subject can merge into an existing Subject."
msgstr "Only one split Subject can merge into an existing Subject."

#: src/features/timeSeries/components/PenTransformControls.tsx
msgid "Only past points, like a Sentinel target’s own history."
msgstr "Only past points, like a Sentinel target’s own history."

#: src/features/timeSeries/components/ThresholdFiltering.tsx
msgid "Only show data points where conditions are met. Stability filters by coefficient of variance (CV)."
msgstr "Only show data points where conditions are met. Stability filters by coefficient of variance (CV)."

#: src/pages/details/extensions/flow/SummarizerExtension.tsx
msgid "Only show plate minimums ≥ 6” from welds"
msgstr "Only show plate minimums ≥ 6” from welds"

#: src/pages/cases/components/CasesTable.tsx
msgid "Only visible to you"
msgstr "Only visible to you"

#: src/features/chatbot/components/AttachmentPills.tsx
#: src/features/chatbot/components/conversationMessage/AIResponseExtras.tsx
#: src/features/chatbot/components/conversationMessage/AIResponseExtras.tsx
#: src/features/knowledgeDocumentViewer/artifacts/ArtifactCard.tsx
#: src/features/knowledgeDocumentViewer/artifacts/ArtifactCard.tsx
#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/documentPreview/DocumentPreviewPanel.tsx
#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/documentPreview/DocumentPreviewPanel.tsx
#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatEvalCaseCitations.tsx
#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/EvidenceChip.tsx
#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/sensors/SensorPreviewPanel.tsx
#: src/features/knowledgeDocumentViewer/components/ContextMenu.tsx
#: src/features/mdCases/mdCaseDisplay.test.ts
#: src/features/mdCases/mdCaseDisplay.test.ts
#: src/features/timeSeries/components/SentinelsTab.tsx
#: src/pages/evaluations/metadata/components/MetricsCard.tsx
#: src/pages/evaluations/metadata/dashboard/components/dataLabeling/DataLabelingDashboardSiteRow.tsx
#: src/pages/evaluations/metadata/dashboard/components/dataLabeling/DataLabelingDashboardSites.tsx
msgid "Open"
msgstr "Open"

#: src/pages/assetLens/components/tabs/AnomalyDashboard.tsx
msgctxt "anomaly status"
msgid "Open"
msgstr "Open"

#: src/features/mdCases/mdCaseDisplay.ts
msgctxt "case status"
msgid "Open"
msgstr "Open"

#: src/features/lotoReports/components/LotoPointPositionCombobox.tsx
msgctxt "LOTO isolation position"
msgid "Open"
msgstr "Open"

#: src/pages/assetLens/components/tabs/SensorIssuesTab.tsx
msgctxt "sensor issue status"
msgid "Open"
msgstr "Open"

#: src/features/chatbot/components/AttachmentPills.tsx
msgid "Open {displayTitle}"
msgstr "Open {displayTitle}"

#: src/features/modelOperations/SubjectDetails.tsx
msgid "Open {docLabel}"
msgstr "Open {docLabel}"

#: src/features/lotoReports/components/LotoIsolationPointRow.tsx
msgid "Open {document} page {pageNumber}"
msgstr "Open {document} page {pageNumber}"

#: src/pages/evaluations/metadata/dashboard/components/dataLabeling/DataLabelingDashboardComparisonRow.tsx
msgid "Open {documentName} page {pageNumber} in a new Cantilever tab"
msgstr "Open {documentName} page {pageNumber} in a new Cantilever tab"

#: src/features/mdCases/components/ProvenanceContentViewer.tsx
msgid "Open {entryLabel} description"
msgstr "Open {entryLabel} description"

#: src/pages/details/extensions/flow/filesExt/FileOpenNewTabButton.tsx
msgid "Open {fileName} in a new tab"
msgstr "Open {fileName} in a new tab"

#: src/features/mdCases/components/ProvenanceContentViewer.tsx
msgid "Open {fmName}"
msgstr "Open {fmName}"

#: src/pages/facilityModel/SubjectAssetPanel.tsx
msgid "Open {label}"
msgstr "Open {label}"

#: src/features/timeSeries/agentTab/ModelPicker.tsx
msgid "Open {modelName} model card"
msgstr "Open {modelName} model card"

#: src/features/mdCases/components/ProvenanceContentViewer.tsx
msgid "Open {name}"
msgstr "Open {name}"

#: src/features/knowledgeDocumentViewer/components/sidebar/TimeSeriesSection.tsx
msgid "Open {piTag}"
msgstr "Open {piTag}"

#: src/pages/evaluations/metadata/dashboard/components/dataLabeling/DataLabelingDashboardSiteRow.tsx
msgid "Open {siteName}"
msgstr "Open {siteName}"

#: src/features/lotoReports/components/LotoSheetOpenOnDrawing.tsx
msgid "Open {tag} on its drawing"
msgstr "Open {tag} on its drawing"

#: src/features/knowledgeDocumentViewer/components/metadata/RevisionFamilyCard.tsx
msgid "Open {title} in new tab"
msgstr "Open {title} in new tab"

#: src/features/mdCases/components/CaseStorySection.tsx
msgid "Open ↗"
msgstr "Open ↗"

#: src/features/timeSeries/agentTab/dock/AlertingTab.tsx
msgid "Open a case on "
msgstr "Open a case on "

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatTagPickerCard.tsx
msgid "Open a trend for {label}"
msgstr "Open a trend for {label}"

#: src/pages/assetLens/components/AssetHeader.tsx
msgid "Open AI Assistant"
msgstr "Open AI Assistant"

#: src/features/sentinels/components/SentinelAlertsPanel.tsx
#: src/pages/cases/md/MdCaseDetailsInspector.tsx
#: src/pages/cases/md/MdCaseDetailsInspector.tsx
msgid "Open alert"
msgstr "Open alert"

#: src/features/knowledgeDocumentViewer/components/sidebar/TimeSeriesSection.tsx
msgid "Open all"
msgstr "Open all"

#: src/pages/facilityModel/SubjectDetailPage.tsx
msgid "Open all {streamCount} tags as one trend"
msgstr "Open all {streamCount} tags as one trend"

#: src/features/knowledgeDocumentViewer/components/sidebar/TimeSeriesSection.tsx
msgid "Open all {timeSeriesCount} datastreams in one Process Data tab"
msgstr "Open all {timeSeriesCount} datastreams in one Process Data tab"

#: src/pages/assetLens/components/AssetHeader.tsx
msgid "Open Anomalies"
msgstr "Open Anomalies"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatInspectionCard.tsx
msgid "Open asset"
msgstr "Open asset"

#: src/features/timeSeries/components/timeSeriesScatterplot/MdDraftAlertCaseFlowPanels.tsx
#: src/pages/alerts/AlertDetails.tsx
msgid "Open Case"
msgstr "Open Case"

#: src/features/timeSeries/utils/uPlotPlugins.ts
msgid "Open case — click to view"
msgstr "Open case — click to view"

#: src/pages/assetLens/components/tabs/SensorIssuesTab.tsx
msgid "Open Cases"
msgstr "Open Cases"

#: src/features/navbar/configSettings/ConfigSettingsSidebar.tsx
#: src/features/navbar/configSettings/ConfigSettingsTopBar.tsx
msgid "Open config settings menu"
msgstr "Open config settings menu"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatRevisionMissingCard.tsx
#: src/features/knowledgeDocumentViewer/components/metadata/RevisionAuditBadge.tsx
msgid "Open document"
msgstr "Open document"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/documentPreview/DocumentPreviewContent.tsx
msgid "Open Document"
msgstr "Open Document"

#: src/features/knowledgeDocumentViewer/components/metadata/RevisionAuditBadge.tsx
msgid "Open document for revision {revisionLabel}"
msgstr "Open document for revision {revisionLabel}"

#: src/features/knowledgeDocumentViewer/components/toolbar/DocumentTabs.tsx
msgid "Open documents"
msgstr "Open documents"

#: src/pages/nnpp/imports/NnppImportVerificationPage.tsx
msgid "Open import summary"
msgstr "Open import summary"

#: src/features/modelOperations/SubjectDetails.tsx
msgid "Open in Datastreams"
msgstr "Open in Datastreams"

#: src/pages/cases/md/MdCaseReferencesDrawer.tsx
msgid "Open in Documents"
msgstr "Open in Documents"

#: src/features/knowledgeDocumentViewer/workOrders/WorkOrderViewer.tsx
#: src/features/knowledgeDocumentViewer/workOrders/WorkOrderViewer.tsx
msgid "Open in Maximo"
msgstr "Open in Maximo"

#: src/features/facilityModel/components/ReferencePreviewPanel.tsx
#: src/features/facilityModel/components/ReferencePreviewPanel.tsx
#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/documentPreview/DocumentPreviewPanel.tsx
#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/documentPreview/DocumentPreviewPanel.tsx
#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/documentsCardView/DocumentResultCard.tsx
#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/EvidenceChip.tsx
msgid "Open in new tab"
msgstr "Open in new tab"

#: src/features/knowledgeDocumentViewer/components/ContextMenu.tsx
msgid "Open in New Tab"
msgstr "Open in New Tab"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/documentPreview/DocumentPreviewPanel.tsx
#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/documentPreview/DocumentPreviewPanel.tsx
#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/sensors/SensorPreviewPanel.tsx
msgid "Open In New Tab"
msgstr "Open In New Tab"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/TrendPreviewPanel.tsx
#: src/pages/cases/md/MdCaseDetailsInspector.tsx
#: src/pages/cases/md/MdCaseReferencesDrawer.tsx
msgid "Open in Process Data"
msgstr "Open in Process Data"

#: src/features/mdCases/components/CaseStorySection.tsx
msgid "Open in Process Data ↗"
msgstr "Open in Process Data ↗"

#: src/features/knowledgeDocumentViewer/artifacts/ArtifactCard.tsx
#: src/features/knowledgeDocumentViewer/artifacts/ArtifactPanelHeader.tsx
msgid "Open in tab"
msgstr "Open in tab"

#: src/pages/evaluations/metadata/components/MetricsCard.tsx
msgid "Open Labeling eval"
msgstr "Open Labeling eval"

#: src/pages/cases/md/MdCaseReferencesDrawer.tsx
msgid "Open link"
msgstr "Open link"

#: src/features/embeddedSidebar/components/EmbeddedSidebarMobileHeader.tsx
#: src/features/embeddedSidebar/components/EmbeddedSidebarMobileHeader.tsx
msgid "Open navigation menu"
msgstr "Open navigation menu"

#: src/features/forecastNotifications/NotificationsDropdownSidebar.tsx
#: src/features/forecastNotifications/NotificationsDropdownTopBar.tsx
msgid "Open notifications"
msgstr "Open notifications"

#: src/pages/evaluations/metadata/dashboard/components/dataLabeling/DataLabelingDashboardComparisonRow.tsx
msgid "Open page"
msgstr "Open page"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/EvidenceChip.tsx
msgid "Open page {pageNum}"
msgstr "Open page {pageNum}"

#: src/features/lotoReports/components/LotoProposalCard.tsx
msgid "Open page {pageNumber}"
msgstr "Open page {pageNumber}"

#: src/features/workspaceTabs/components/WorkspaceTabBar.tsx
msgid "Open pages"
msgstr "Open pages"

#: src/features/navbar/profileAndSettings/ProfileAndSettingsTopBar.tsx
msgid "Open profile settings menu"
msgstr "Open profile settings menu"

#: src/features/navbar/profileAndSettings/ProfileAndSettingsSidebar.tsx
msgid "Open profile settings menu for {userDisplayName}"
msgstr "Open profile settings menu for {userDisplayName}"

#: src/features/lotoReports/components/LotoProposalCard.tsx
msgid "Open report"
msgstr "Open report"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatRevisionDiffCard.tsx
msgid "Open revision"
msgstr "Open revision"

#: src/pages/facilityModel/SubjectDetailPage.tsx
msgid "Open sentinel"
msgstr "Open sentinel"

#: src/features/knowledgeDocumentViewer/components/metadata/RevisionFamilyCard.tsx
msgid "Open Tab"
msgstr "Open Tab"

#: src/features/fimReview/IdentityPanel.tsx
msgid "Open the document at the cited region"
msgstr "Open the document at the cited region"

#: src/features/timeSeries/agentTab/ModelPicker.tsx
msgid "Open the model card — every parameter the agent chose"
msgstr "Open the model card — every parameter the agent chose"

#: src/features/lotoReports/components/LotoPrintAlert.tsx
msgid "Open the PDF to print"
msgstr "Open the PDF to print"

#: src/features/timeSeries/sentinelStudio/SentinelBuilderPanel.tsx
msgid "Open the Plan stage to edit this."
msgstr "Open the Plan stage to edit this."

#: src/pages/processData/components/ProcessDataTopBar.tsx
msgid "Open the Process Data guide"
msgstr "Open the Process Data guide"

#: src/features/timeSeries/sentinelStudio/SentinelBuilderPanel.tsx
msgid "Open the sentinel"
msgstr "Open the sentinel"

#: src/pages/cases/md/MdCaseDetailsInspector.tsx
msgid "Open this alert"
msgstr "Open this alert"

#: src/features/mdCases/components/CaseStorySection.tsx
msgid "Open this alert in Process Data"
msgstr "Open this alert in Process Data"

#: src/features/sentinels/components/SentinelAssetPanel.tsx
msgid "Open this asset in Facility Model"
msgstr "Open this asset in Facility Model"

#: src/features/timeSeries/agentTab/chat/ConversationDrawer.tsx
msgid "Open this conversation"
msgstr "Open this conversation"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatTagPickerCard.tsx
#: src/pages/facilityModel/SubjectDetailPage.tsx
msgid "Open trend"
msgstr "Open trend"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatTrendCard.tsx
msgid "Open trend: {trendLabel} · {penLabel}"
msgstr "Open trend: {trendLabel} · {penLabel}"

#: src/pages/processData/components/helpGuide/HelpGuideDialog.tsx
msgid "Opened bug report from Process Data guide"
msgstr "Opened bug report from Process Data guide"

#: src/features/embeddedSidebar/chatHistory/AgenticChatHistorySessionRow.tsx
msgid "Opening…"
msgstr "Opening…"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
#: src/features/knowledgeDocumentViewer/workOrders/legacyCmmsRecordPdf.ts
msgid "Operating location"
msgstr "Operating location"

#: src/pages/evaluations/metadata/labeling/utils/pageClassificationTaxonomy.ts
msgid "Operation and configuration"
msgstr "Operation and configuration"

#: src/pages/evaluations/metadata/labeling/utils/pageClassificationTaxonomy.ts
msgid "Operational and environmental monitoring records"
msgstr "Operational and environmental monitoring records"

#: src/pages/systemView/components/unitsTab/FilterControls.tsx
msgid "Operational Status"
msgstr "Operational Status"

#: src/pages/evaluations/metadata/labeling/utils/pageClassificationTaxonomy.ts
msgid "Operator mimic and control interfaces"
msgstr "Operator mimic and control interfaces"

#: src/pages/facilityModel/SubjectAssetPanel.tsx
msgid "Optional slots still unfilled"
msgstr "Optional slots still unfilled"

#: src/features/knowledgeDocumentViewer/components/bugReport/BugReportScreenshots.tsx
msgid "Or paste an image. Up to 3 images, 5 MB each."
msgstr "Or paste an image. Up to 3 images, 5 MB each."

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
#: src/features/knowledgeDocumentViewer/workOrders/legacyCmmsRecordPdf.ts
msgid "Order date"
msgstr "Order date"

#: src/features/nnpp/nnppReportPresentation.ts
msgid "Order number"
msgstr "Order number"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
#: src/features/knowledgeDocumentViewer/workOrders/legacyCmmsRecordPdf.ts
msgid "Order quantity"
msgstr "Order quantity"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
#: src/features/knowledgeDocumentViewer/workOrders/legacyCmmsRecordPdf.ts
msgid "Order unit"
msgstr "Order unit"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
msgid "Ordered line"
msgstr "Ordered line"

#: src/features/knowledgeDocumentViewer/workOrders/legacyCmmsRecordPdf.ts
msgid "Ordered lines"
msgstr "Ordered lines"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
msgid "Ordered scope; not proof of installation or repair."
msgstr "Ordered scope; not proof of installation or repair."

#: src/features/navbar/navConfig.ts
msgid "Orders"
msgstr "Orders"

#: src/features/navbar/configSettings/ConfigSettingsSidebarMenuItems.tsx
#: src/features/navbar/configSettings/ConfigSettingsSidebarMenuItems.tsx
#: src/features/navbar/configSettings/ConfigSettingsTopBarMenuItems.tsx
msgid "Org & Site App Config"
msgstr "Org & Site App Config"

#: src/pages/metrics/components/SiteRowsTable.tsx
msgid "Org users"
msgstr "Org users"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatEvalCaseReview.tsx
#: src/features/navbar/siteSelectors/SiteSelectorsSidebar.tsx
#: src/features/navbar/siteSelectors/SiteSelectorsSidebar.tsx
#: src/pages/metrics/components/SiteRowsTable.tsx
#: src/pages/metrics/Metrics.tsx
msgid "Organization"
msgstr "Organization"

#: src/features/forgingsReporting/ReportsTable.tsx
msgid "Origin part"
msgstr "Origin part"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
#: src/features/knowledgeDocumentViewer/workOrders/workOrderFields.ts
msgid "Originating record"
msgstr "Originating record"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
#: src/features/knowledgeDocumentViewer/workOrders/workOrderFields.ts
msgid "Originating record class"
msgstr "Originating record class"

#: src/features/chatbot/components/ChatbotHelpModal.tsx
#: src/features/knowledgeDocumentViewer/components/advancedSearch/utils/docChatFeedback.ts
#: src/features/knowledgeDocumentViewer/components/sidebar/FeedbackModal.tsx
#: src/features/knowledgeDocumentViewer/utils/documentTypeLabels.ts
#: src/pages/evaluations/metadata/labeling/utils/pageClassificationTaxonomy.ts
#: src/pages/evaluations/metadata/labeling/utils/pageClassificationTaxonomy.ts
msgid "Other"
msgstr "Other"

#: src/pages/evaluations/metadata/labeling/utils/pageClassificationTaxonomy.ts
msgid "Other business or organizational information"
msgstr "Other business or organizational information"

#: src/features/knowledgeDocumentViewer/components/revisionCompare/RevisionDetailChangeList.tsx
msgid "Other changes"
msgstr "Other changes"

#: src/pages/evaluations/metadata/labeling/utils/pageClassificationTaxonomy.ts
msgid "Other document navigation or control"
msgstr "Other document navigation or control"

#: src/pages/evaluations/metadata/labeling/utils/pageClassificationTaxonomy.ts
msgid "Other engineering calculations and analysis"
msgstr "Other engineering calculations and analysis"

#: src/pages/details/extensions/flow/FilesExtension.tsx
msgid "Other files"
msgstr "Other files"

#: src/pages/evaluations/metadata/labeling/utils/pageClassificationTaxonomy.ts
msgid "Other instructions or requirements"
msgstr "Other instructions or requirements"

#: src/features/lotoReports/components/LotoReportSelect.tsx
msgid "Other LOTOs"
msgstr "Other LOTOs"

#: src/features/lotoReports/components/LotoSessionOtherPages.tsx
msgid "Other pages with no isolation points"
msgstr "Other pages with no isolation points"

#: src/pages/evaluations/metadata/labeling/utils/pageClassificationTaxonomy.ts
msgid "Other physical design"
msgstr "Other physical design"

#: src/pages/evaluations/metadata/labeling/utils/pageClassificationTaxonomy.ts
msgid "Other records and results"
msgstr "Other records and results"

#: src/pages/evaluations/metadata/labeling/utils/pageClassificationTaxonomy.ts
msgid "Other system connectivity or behavior"
msgstr "Other system connectivity or behavior"

#: src/pages/evaluations/metadata/labeling/utils/pageClassificationTaxonomy.ts
msgid "Other technical reference information"
msgstr "Other technical reference information"

#: src/features/knowledgeDocumentViewer/components/metadata/RevisionFamilyCard.tsx
msgid "Out of Date"
msgstr "Out of Date"

#: src/features/timeSeries/agentTab/dock/TargetTab.tsx
msgid "out of range ({displayedHealthRatio}×)"
msgstr "out of range ({displayedHealthRatio}×)"

#: src/pages/systemView/components/unitsTab/FilterControls.tsx
#: src/pages/systemView/components/unitsTab/UnitListItem.tsx
msgid "Out of Service"
msgstr "Out of Service"

#: src/features/timeSeries/experiment/ExperimentTab.tsx
msgid "Out-of-band points"
msgstr "Out-of-band points"

#: src/pages/processData/buildMode/components/ChartOverlayToggles.tsx
#: src/pages/processData/buildMode/components/ChartOverlayToggles.tsx
msgid "Out-of-bounds flags"
msgstr "Out-of-bounds flags"

#: src/pages/processData/buildMode/dock/EvalLabelTable.tsx
msgid "outside span"
msgstr "outside span"

#: src/pages/processData/buildMode/dock/EvalsDockTab.tsx
msgid "over evaluated window"
msgstr "over evaluated window"

#: src/features/timeSeries/components/SentinelsTab.tsx
msgid "Over the scored window, with the selected method"
msgstr "Over the scored window, with the selected method"

#: src/pages/cases/components/CaseFeedbackModal.tsx
msgid "Overall"
msgstr "Overall"

#: src/features/sentinels/components/DesignRunDetails.tsx
#: src/pages/evaluations/metadata/dashboard/components/dataLabeling/DataLabelingDashboardOverviewTabs.tsx
#: src/pages/processData/components/helpGuide/HelpGuideChapters.tsx
msgid "Overview"
msgstr "Overview"

#: src/pages/facilityModel/SubjectDetailPage.tsx
msgid "Overwrite the Asset Instance from the current Subject and queue a fresh template fill"
msgstr "Overwrite the Asset Instance from the current Subject and queue a fresh template fill"

#: src/features/modelOperations/SubjectDetails.tsx
msgid "Overwrite the existing Asset Instance from the current Subject and queue a fresh template fill (the prior fill stays visible until overwritten)"
msgstr "Overwrite the existing Asset Instance from the current Subject and queue a fresh template fill (the prior fill stays visible until overwritten)"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
#: src/features/knowledgeDocumentViewer/workOrders/workOrderFields.ts
msgid "Owner"
msgstr "Owner"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
#: src/features/knowledgeDocumentViewer/workOrders/workOrderFields.ts
msgid "Owner group"
msgstr "Owner group"

#: src/features/timeSeries/components/RegressionPrediction.tsx
msgid "P-Val"
msgstr "P-Val"

#: src/features/modelOperations/SubjectDetails.tsx
#: src/pages/facilityModel/SubjectDetailPage.tsx
msgid "p. {pageList}"
msgstr "p. {pageList}"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatEvalCaseCitations.tsx
msgid "p.{pageNum}"
msgstr "p.{pageNum}"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/documentsCardView/DocumentResultCard.tsx
msgid "p.{pageNumber}"
msgstr "p.{pageNumber}"

#: src/features/knowledgeDocumentViewer/utils/documentTypeLabels.ts
msgid "P&ID"
msgstr "P&ID"

#: src/features/timeSeries/sentinelStudio/SentinelBuilderPanel.tsx
msgid "P&ID (optional PDF)"
msgstr "P&ID (optional PDF)"

#: src/pages/evaluations/metadata/labeling/utils/pageClassificationTaxonomy.ts
msgid "P&ID (Piping & Instrumentation Diagram)"
msgstr "P&ID (Piping & Instrumentation Diagram)"

#: src/features/modelOperations/fimShared.ts
#: src/features/modelOperations/fimShared.ts
msgid "P&ID graph"
msgstr "P&ID graph"

#: src/features/timeSeries/sentinelStudio/SentinelBuilderPanel.tsx
msgid "P&ID to send:"
msgstr "P&ID to send:"

#: src/features/timeSeries/sentinelStudio/SentinelBuilderPanel.tsx
msgid "P&ID upload failed"
msgstr "P&ID upload failed"

#: src/features/timeSeries/sentinelStudio/SentinelBuilderPanel.tsx
msgid "P&ID upload failed: "
msgstr "P&ID upload failed: "

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatEvalCaseCitations.tsx
#: src/features/knowledgeDocumentViewer/components/metadata/MetadataScopeToggle.tsx
#: src/features/knowledgeDocumentViewer/components/toolbar/PageSelector.tsx
#: src/features/knowledgeDocumentViewer/utils/metadataFieldLabelMessages.ts
#: src/pages/evaluations/metadata/dashboard/components/dataLabeling/DataLabelingDashboardComparisonTable.tsx
msgid "Page"
msgstr "Page"

#: src/features/knowledgeDocumentViewer/components/viewer/search/DocReferencePreviewCard.tsx
msgid "Page {bestPageNumber} of {title}"
msgstr "Page {bestPageNumber} of {title}"

#: src/features/powerCustomerUploads/components/PowerCustomerUploadReviewTablePagination.tsx
msgid "Page {currentPage} of {pageCount}"
msgstr "Page {currentPage} of {pageCount}"

#: src/features/knowledgeDocumentViewer/components/sidebar/CrossReferencePanel.tsx
#: src/features/knowledgeDocumentViewer/components/viewer/search/ConnectorLookupPanel.tsx
msgid "Page {page}"
msgstr "Page {page}"

#: src/features/knowledgeDocumentViewer/workOrders/workOrderSheet.ts
#: src/features/lotoReports/recordSheet/recordSheetLayout.ts
msgid "Page {page} of {pageCount}"
msgstr "Page {page} of {pageCount}"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/EvidenceChip.tsx
msgid "Page {pageNum}"
msgstr "Page {pageNum}"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatEvalCaseCitations.tsx
msgid "Page {pageNum} of {title} is cited"
msgstr "Page {pageNum} of {title} is cited"

#: src/features/chatbot/components/CitationTooltip.tsx
#: src/features/knowledgeDocumentViewer/components/thumbnailSidebar/PageThumbnailItem.tsx
#: src/features/knowledgeDocumentViewer/components/viewer/continuous/ContinuousPageImage.tsx
#: src/features/lotoReports/components/LotoPagePanelHeader.tsx
#: src/features/lotoReports/components/LotoProposalCard.tsx
#: src/features/lotoReports/components/LotoTargetDrawings.tsx
msgid "Page {pageNumber}"
msgstr "Page {pageNumber}"

#: src/features/knowledgeDocumentViewer/components/viewer/shared/PageImageStatus.tsx
msgid "Page {pageNumber} could not be displayed"
msgstr "Page {pageNumber} could not be displayed"

#: src/features/knowledgeDocumentViewer/utils/pdfOutlineUnits.ts
msgid "Page {startPage}"
msgstr "Page {startPage}"

#: src/pages/evaluations/metadata/dashboard/components/dataLabeling/DataLabelingDashboardFieldDrilldown.tsx
msgid "Page comparisons"
msgstr "Page comparisons"

#: src/features/knowledgeDocumentViewer/hooks/usePageMetadataEvalActions.ts
msgid "Page confirmed"
msgstr "Page confirmed"

#: src/features/knowledgeDocumentViewer/components/metadata/ScopeSummaryCard.tsx
msgid "Page data changes apply only to {trimmedFilename}."
msgstr "Page data changes apply only to {trimmedFilename}."

#: src/features/knowledgeDocumentViewer/components/metadata/ScopeSummaryCard.tsx
msgid "Page data changes apply only to this document."
msgstr "Page data changes apply only to this document."

#: src/features/knowledgeDocumentViewer/components/metadata/ScopeSummaryCard.tsx
msgid "Page data changes apply to every document in this revision family."
msgstr "Page data changes apply to every document in this revision family."

#: src/features/knowledgeDocumentViewer/hooks/usePageMetadataEvalActions.ts
msgid "Page deferred"
msgstr "Page deferred"

#: src/features/knowledgeDocumentViewer/components/metadata/PageMetadataEditSection.tsx
#: src/features/knowledgeDocumentViewer/components/metadata/PageMetadataEvalChrome.tsx
#: src/features/knowledgeDocumentViewer/utils/sharedMetadataFieldBridge.ts
msgid "Page Details"
msgstr "Page Details"

#: src/features/knowledgeDocumentViewer/components/toolbar/SettingsMenu.tsx
msgid "Page layout"
msgstr "Page layout"

#: src/features/knowledgeDocumentViewer/hooks/useSaveDocumentPageMetadataUserEdit.ts
msgid "Page metadata updated"
msgstr "Page metadata updated"

#: src/features/knowledgeDocumentViewer/hooks/useSaveDocumentPageMetadataUserEdit.ts
msgid "Page metadata updated for {revisionCount, plural, one {# revision} other {# revisions}}"
msgstr "Page metadata updated for {revisionCount, plural, one {# revision} other {# revisions}}"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/documentPreview/PreviewPageNavigator.tsx
msgid "Page navigation"
msgstr "Page navigation"

#: src/pages/noMatch/NoMatch.tsx
msgid "Page Not Found"
msgstr "Page Not Found"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatEvalCaseCitations.tsx
msgid "Page number"
msgstr "Page number"

#: src/features/knowledgeDocumentViewer/components/toolbar/PageRangeControls.tsx
msgid "Page range"
msgstr "Page range"

#: src/features/knowledgeDocumentViewer/hooks/usePageMetadataEvalActions.ts
msgid "Page saved, but updated metadata could not be refreshed"
msgstr "Page saved, but updated metadata could not be refreshed"

#: src/features/lotoReports/components/LotoIsolationPointRow.tsx
#: src/features/lotoReports/components/LotoPagePlaceholder.tsx
#: src/features/lotoReports/components/LotoProposalCard.tsx
#: src/features/lotoReports/components/LotoSessionOtherPages.tsx
msgid "Page unavailable"
msgstr "Page unavailable"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/documentPreview/DocumentPreviewMeta.tsx
#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/documentPreview/PreviewDocumentDetailsSection.tsx
#: src/features/knowledgeDocumentViewer/components/toolbar/PageSelector.tsx
#: src/features/knowledgeDocumentViewer/utils/metadataFieldLabelMessages.ts
#: src/features/lotoReports/components/LotoAttachmentsSection.tsx
msgid "Pages"
msgstr "Pages"

#: src/pages/metrics/components/SiteRowsTable.tsx
#: src/pages/metrics/Metrics.tsx
msgid "Pages hosted"
msgstr "Pages hosted"

#: src/features/richText/components/ToolbarPlugin.tsx
msgid "Paragraph"
msgstr "Paragraph"

#: src/pages/evaluations/metadata/labeling/utils/pageClassificationTaxonomy.ts
msgid "Parameters, signals, and data maps"
msgstr "Parameters, signals, and data maps"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
#: src/features/knowledgeDocumentViewer/workOrders/legacyCmmsRecordPdf.ts
#: src/features/mdCases/components/ProvenanceContentViewer.tsx
msgid "Parent"
msgstr "Parent"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
msgid "Parent location"
msgstr "Parent location"

#: src/features/knowledgeDocumentViewer/workOrders/workOrderPresentation.ts
msgid "Parent work order"
msgstr "Parent work order"

#: src/features/fimReview/InspectSources.tsx
msgid "Parsed tag"
msgstr "Parsed tag"

#: src/pages/cases/components/CaseFeedbackModal.tsx
#: src/pages/cases/components/CaseFeedbackModal.tsx
#: src/pages/cases/components/CaseFeedbackModal.tsx
#: src/pages/metrics/components/MonthlyTable.tsx
msgid "Partial"
msgstr "Partial"

#: src/features/powerCustomerUploads/components/PowerCustomerUploadHistoryPanel.tsx
#: src/features/powerCustomerUploads/components/powerCustomerUploadHistoryPresentation.ts
#: src/features/powerCustomerUploads/components/powerCustomerUploadHistoryPresentation.ts
msgid "Partially failed"
msgstr "Partially failed"

#: src/pages/evaluations/metadata/labeling/utils/pageClassificationTaxonomy.ts
msgid "Parts and equipment schedules"
msgstr "Parts and equipment schedules"

#: src/features/navbar/navConfig.ts
msgid "Parts Thread"
msgstr "Parts Thread"

#: src/features/timeSeries/agentTab/AgentTab.tsx
#: src/features/timeSeries/agentTab/AgentTab.tsx
msgid "Past conversations"
msgstr "Past conversations"

#: src/features/timeSeries/experiment/knobCopy.ts
msgid "Past driver values to include as features, in sample periods. Default 1,3,6 → at 10 min interval that is 10/30/60 min ago. Only used when Driver history is on."
msgstr "Past driver values to include as features, in sample periods. Default 1,3,6 → at 10 min interval that is 10/30/60 min ago. Only used when Driver history is on."

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatEvalCaseCitations.tsx
msgid "Paste a document id or link"
msgstr "Paste a document id or link"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatEvalCaseCitations.tsx
msgid "Paste a document id or link."
msgstr "Paste a document id or link."

#: src/pages/cases/md/MdCaseReferencesDrawer.tsx
msgid "Paste a document URL or reference identifier."
msgstr "Paste a document URL or reference identifier."

#: src/features/timeSeries/sentinelStudio/SentinelBuilderPanel.tsx
msgid "Paste datapoint ids and the agent assembles a context bundle, designs a model plan from it, and you edit that plan before anything is fitted. The training window is the chart's date range ("
msgstr "Paste datapoint ids and the agent assembles a context bundle, designs a model plan from it, and you edit that plan before anything is fitted. The training window is the chart's date range ("

#: src/features/timeSeries/sentinelStudio/SentinelBuilderPanel.tsx
msgid "Paste tags"
msgstr "Paste tags"

#: src/features/powerCustomerUploads/components/PowerCustomerUploadReviewTable.tsx
msgid "Path"
msgstr "Path"

#: src/pages/processData/components/helpGuide/HelpGuideMedia.tsx
msgid "Pause the clip"
msgstr "Pause the clip"

#: src/features/forgingsReporting/ForgingsReportWorkspace.tsx
msgid "PDF preview"
msgstr "PDF preview"

#: src/pages/metrics/components/MonthlyTable.tsx
msgid "Peak Week"
msgstr "Peak Week"

#: src/features/timeSeries/agentTab/dock/BacktestTab.tsx
msgid "peak σ"
msgstr "peak σ"

#: src/features/timeSeries/agentTab/chat/BuildCard.tsx
msgid "pen added"
msgstr "pen added"

#: src/features/timeSeries/components/ColorSwatch.tsx
msgid "Pen color"
msgstr "Pen color"

#: src/features/timeSeries/components/panes/TagBrowserList.tsx
#: src/features/timeSeries/components/panes/TagSearchDialogRow.tsx
msgid "Pen limit reached ({MAX_PENS})"
msgstr "Pen limit reached ({MAX_PENS})"

#: src/features/timeSeries/agentTab/chat/BuildCard.tsx
msgid "pen removed"
msgstr "pen removed"

#: src/features/timeSeries/components/SensorScatterplotTableColumns.tsx
msgid "Pen transforms"
msgstr "Pen transforms"

#: src/pages/processData/components/helpGuide/HelpGuideChapters.tsx
msgid "Pen visibility"
msgstr "Pen visibility"

#: src/features/chatbot/components/conversationMessage/ProposalCard.tsx
msgid "pending"
msgstr "pending"

#: src/features/fim/photos/photoElections.ts
msgid "pending model sync"
msgstr "pending model sync"

#: src/features/fim/photos/PhotoLightbox.tsx
msgid "Pending upload"
msgstr "Pending upload"

#: src/features/timeSeries/components/ScatterplotConfigSidebar.tsx
#: src/features/timeSeries/components/ScatterplotSidebar.tsx
msgid "Pens"
msgstr "Pens"

#: src/features/timeSeries/components/labelTool/LabelConfigPanel.tsx
msgid "Pens in scope"
msgstr "Pens in scope"

#: src/pages/evaluations/metadata/labeling/utils/pageClassificationTaxonomy.ts
msgid "People, roles, and organizational records"
msgstr "People, roles, and organizational records"

#: src/features/timeSeries/experiment/knobCopy.ts
msgid "Per-tag ops that drop bad points or gate rows before training: range, clip_quantile, frozen-sensor runs, operating-regime gate. Experiment-only denoise_mean / denoise_median smooth surviving points."
msgstr "Per-tag ops that drop bad points or gate rows before training: range, clip_quantile, frozen-sensor runs, operating-regime gate. Experiment-only denoise_mean / denoise_median smooth surviving points."

#: src/features/dataFilter/categoryFilter/ValueBreakdownDisplayTypeSelector.tsx
msgid "Percent"
msgstr "Percent"

#: src/pages/details/extensions/flow/SummarizerExtension.tsx
msgid "Percent of bins in filter range"
msgstr "Percent of bins in filter range"

#: src/pages/details/extensions/flow/SummarizerExtension.tsx
msgid "Percent of bins with data"
msgstr "Percent of bins with data"

#: src/features/timeSeries/experiment/knobCopy.ts
msgid "Percentile of absolute calibration residuals used when Band estimator = abs quantile (e.g. 0.9 ≈ 90th percentile)."
msgstr "Percentile of absolute calibration residuals used when Band estimator = abs quantile (e.g. 0.9 ≈ 90th percentile)."

#: src/features/navbar/PermissionGateToggle.tsx
msgid "Permission Gates"
msgstr "Permission Gates"

#: src/pages/manageAccess/components/table/UserRow.tsx
#: src/pages/manageAccess/components/table/UserRowActions.tsx
#: src/pages/manageAccess/components/table/UserRowActions.tsx
msgid "Permissions are still loading. Please wait."
msgstr "Permissions are still loading. Please wait."

#: src/features/timeSeries/agentTab/dock/AlertingTab.tsx
msgid "Persistence is what makes a computed KPI safe to alert on. One bad transmitter day should not open a case."
msgstr "Persistence is what makes a computed KPI safe to alert on. One bad transmitter day should not open a case."

#: src/pages/manageAccess/components/table/UsersTableHead.tsx
msgid "Person"
msgstr "Person"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
#: src/features/knowledgeDocumentViewer/workOrders/workOrderFields.ts
msgid "Person group"
msgstr "Person group"

#: src/pages/evaluations/metadata/labeling/utils/pageClassificationTaxonomy.ts
msgid "Personnel qualification records"
msgstr "Personnel qualification records"

#: src/pages/processData/buildMode/dock/EngineeringSection.tsx
msgid "Phase shift for {tag}"
msgstr "Phase shift for {tag}"

#: src/features/fim/photos/types.ts
msgid "Photo"
msgstr "Photo"

#: src/features/fim/photos/SubjectPhotoUploader.tsx
msgid "Photo attached."
msgstr "Photo attached."

#: src/features/fim/photos/PhotoLightbox.tsx
msgid "Photo caption"
msgstr "Photo caption"

#: src/features/fim/photos/photoService.ts
msgid "Photo is no longer available."
msgstr "Photo is no longer available."

#: src/features/knowledgeDocumentViewer/components/photoMode/PhotoModeHeader.tsx
#: src/features/knowledgeDocumentViewer/components/toolbar/SettingsMenu.tsx
msgid "Photo mode"
msgstr "Photo mode"

#: src/features/fim/photos/useSubjectPhotoActions.ts
msgid "Photo remove failed: {reason}"
msgstr "Photo remove failed: {reason}"

#: src/features/fim/photos/SubjectPhotoUploader.tsx
msgid "Photograph the physical equipment and attach it to this Subject"
msgstr "Photograph the physical equipment and attach it to this Subject"

#: src/features/fim/photos/SubjectPhotos.tsx
msgid "Photos ({photoCount})"
msgstr "Photos ({photoCount})"

#: src/features/fim/photos/SubjectPhotos.tsx
#: src/features/knowledgeDocumentViewer/components/photoMode/PhotoModeSubjectSection.tsx
msgid "Photos can be attached once this Subject has a tag or name alias."
msgstr "Photos can be attached once this Subject has a tag or name alias."

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
#: src/features/knowledgeDocumentViewer/workOrders/legacyCmmsRecordPdf.ts
msgid "Physical count"
msgstr "Physical count"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
#: src/features/knowledgeDocumentViewer/workOrders/legacyCmmsRecordPdf.ts
msgid "Physical count date"
msgstr "Physical count date"

#: src/features/timeSeries/agentTab/chat/BuildCard.tsx
msgid "physics KPI · {kpi}"
msgstr "physics KPI · {kpi}"

#: src/pages/cases/md/MdCaseReferencesDrawer.tsx
msgid "PI Tag"
msgstr "PI Tag"

#: src/pages/cases/md/mdCaseDetailsHelpers.ts
msgid "PI Tag {position}"
msgstr "PI Tag {position}"

#: src/pages/cases/md/MdCaseReferencesDrawer.tsx
msgid "PI tag ID"
msgstr "PI tag ID"

#: src/pages/facilityModel/SubjectAssetPanel.tsx
msgid "PI tags"
msgstr "PI tags"

#: src/features/sentinels/SentinelInstancePicker.tsx
msgid "PI tags bound"
msgstr "PI tags bound"

#: src/features/modelOperations/templates/templateModel.ts
msgid "PI-tag row {row} needs a label."
msgstr "PI-tag row {row} needs a label."

#: src/features/lotoReports/components/LotoSheetScheduleField.tsx
msgid "Pick a date to keep this time"
msgstr "Pick a date to keep this time"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatEvalCaseCitations.tsx
msgid "Pick a document"
msgstr "Pick a document"

#: src/features/timeSeries/sentinelStudio/SentinelBuilderPanel.tsx
msgid "Pick a filled asset and the agent builds a monitor from its tags. The training window is the chart's date range."
msgstr "Pick a filled asset and the agent builds a monitor from its tags. The training window is the chart's date range."

#: src/pages/facilityModel/SubjectDetailPage.tsx
msgid "Pick a Subject"
msgstr "Pick a Subject"

#: src/pages/processData/buildMode/components/BuildPrimaryCta.tsx
msgid "Pick a target and at least one driver first"
msgstr "Pick a target and at least one driver first"

#: src/features/timeSeries/experiment/ExperimentTab.tsx
#: src/features/timeSeries/experiment/ExperimentTab.tsx
msgid "Pick a target and drivers above."
msgstr "Pick a target and drivers above."

#: src/features/timeSeries/experiment/TransparencyStrip.tsx
msgid "Pick a target and drivers to see how many points are used."
msgstr "Pick a target and drivers to see how many points are used."

#: src/pages/processData/components/helpGuide/HelpGuideChapters.tsx
msgid "Pick a tool from the toolbar, use it as many times as you like, press "
msgstr "Pick a tool from the toolbar, use it as many times as you like, press "

#: src/pages/processData/buildMode/dock/CleaningSection.tsx
msgid "Pick tags on the left to see their quality here."
msgstr "Pick tags on the left to see their quality here."

#: src/features/timeSeries/experiment/SplitBuilder.tsx
msgid "Pick the exact dates for each period. Ranges run from 00:00 on the start date up to (not including) 00:00 on the end date, so set one range's end to the next one's start to butt them together. Rows outside every range are dropped from both fitting and scoring — useful for cutting an outage out of the middle."
msgstr "Pick the exact dates for each period. Ranges run from 00:00 on the start date up to (not including) 00:00 on the end date, so set one range's end to the next one's start to butt them together. Rows outside every range are dropped from both fitting and scoring — useful for cutting an outage out of the middle."

#: src/features/lotoReports/components/LotoSortablePoints.tsx
msgid "Picked up {tag} at position {position} of {count}."
msgstr "Picked up {tag} at position {position} of {count}."

#: src/features/embeddedSidebar/chatHistory/AgenticChatHistorySessionOverflowMenu.tsx
msgid "Pin"
msgstr "Pin"

#: src/features/timeSeries/experiment/ExperimentTab.tsx
msgid "Pin a tag's chart Y range (custom bounds win over auto). Applies to the viewer's pens immediately and saves with the experiment. Leave a field empty for auto."
msgstr "Pin a tag's chart Y range (custom bounds win over auto). Applies to the viewer's pens immediately and saves with the experiment. Leave a field empty for auto."

#: src/features/powerCustomerUploads/state/powerCustomerUploadRowUpdates.ts
msgid "Pinecone rich text summary"
msgstr "Pinecone rich text summary"

#: src/features/knowledgeDocumentViewer/utils/documentTypeLabels.ts
#: src/pages/evaluations/metadata/labeling/utils/pageClassificationTaxonomy.ts
msgid "Pipe Support"
msgstr "Pipe Support"

#: src/features/facilityModel/columns.ts
#: src/features/fimReview/InspectSources.tsx
#: src/features/fimReview/StructuralReviewFlow.tsx
msgid "Pipeline"
msgstr "Pipeline"

#: src/features/navbar/navConfig.ts
msgid "Pipeline Fleet"
msgstr "Pipeline Fleet"

#: src/pages/evaluations/metadata/components/OrganizationMetrics.tsx
msgid "Pipeline trends unavailable."
msgstr "Pipeline trends unavailable."

#: src/features/knowledgeDocumentViewer/components/metadata/ShouldHaveMetadataField.tsx
msgid "Pipeline values are empty. Choose no to confirm that, or fill the fields if it should have metadata."
msgstr "Pipeline values are empty. Choose no to confirm that, or fill the fields if it should have metadata."

#: src/features/navbar/navConfig.ts
msgid "Pipelines"
msgstr "Pipelines"

#: src/features/knowledgeDocumentViewer/utils/documentTypeLabels.ts
#: src/pages/evaluations/metadata/labeling/utils/pageClassificationTaxonomy.ts
msgid "Piping Isometric"
msgstr "Piping Isometric"

#: src/features/timeSeries/agentTab/dock/AlertingTab.tsx
msgid "placebo p (raw)"
msgstr "placebo p (raw)"

#: src/features/timeSeries/agentTab/dock/AlertingTab.tsx
#: src/features/timeSeries/agentTab/dock/AlertingTab.tsx
msgid "placebo z"
msgstr "placebo z"

#: src/features/timeSeries/agentTab/dock/AlertingTab.tsx
msgid "Placebo z is how far outside the ordinary date-to-date wobble the step sits, measured against steps at 400 arbitrary dates. It gates instead of a p-value because a discovered date's p is flattered by the scan, and a large real step contaminates its own null."
msgstr "Placebo z is how far outside the ordinary date-to-date wobble the step sits, measured against steps at 400 arbitrary dates. It gates instead of a p-value because a discovered date's p is flattered by the scan, and a large real step contaminates its own null."

#: src/components/table/TableComponent.tsx
msgid "Placeholder"
msgstr "Placeholder"

#: src/features/timeSeries/sentinelStudio/SentinelBuilderPanel.tsx
msgid "Plan"
msgstr "Plan"

#: src/pages/overview/sidebar/table/SiteViewSidebarTableOrganizers.tsx
msgid "Plan Cost"
msgstr "Plan Cost"

#: src/features/timeSeries/experiment/ExperimentTab.tsx
msgid "Plan tags: "
msgstr "Plan tags: "

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
#: src/features/knowledgeDocumentViewer/workOrders/legacyCmmsRecordPdf.ts
msgid "Planned hours"
msgstr "Planned hours"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
msgid "Planned instructions and resources; not performed work."
msgstr "Planned instructions and resources; not performed work."

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
msgid "Planned item"
msgstr "Planned item"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
#: src/features/knowledgeDocumentViewer/workOrders/legacyCmmsRecordPdf.ts
msgid "Planned item quantity"
msgstr "Planned item quantity"

#: src/features/knowledgeDocumentViewer/workOrders/legacyCmmsRecordPdf.ts
msgid "Planned items"
msgstr "Planned items"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
msgid "Planned job-plan sequence"
msgstr "Planned job-plan sequence"

#: src/features/knowledgeDocumentViewer/workOrders/legacyCmmsRecordPdf.ts
msgid "Planned job-plan sequences"
msgstr "Planned job-plan sequences"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
#: src/features/knowledgeDocumentViewer/workOrders/legacyCmmsRecordPdf.ts
msgid "Planned labor"
msgstr "Planned labor"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
msgid "Planned material"
msgstr "Planned material"

#: src/features/knowledgeDocumentViewer/workOrders/legacyCmmsRecordPdf.ts
msgid "Planned materials"
msgstr "Planned materials"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
msgid "Planned service"
msgstr "Planned service"

#: src/features/knowledgeDocumentViewer/workOrders/legacyCmmsRecordPdf.ts
msgid "Planned services"
msgstr "Planned services"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
msgid "Planned task"
msgstr "Planned task"

#: src/features/knowledgeDocumentViewer/workOrders/legacyCmmsRecordPdf.ts
msgid "Planned tasks"
msgstr "Planned tasks"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
msgid "Planned tool"
msgstr "Planned tool"

#: src/features/knowledgeDocumentViewer/workOrders/legacyCmmsRecordPdf.ts
msgid "Planned tools"
msgstr "Planned tools"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
msgid "Planning"
msgstr "Planning"

#: src/pages/details/visualization/tools/CompartmentsToggle.tsx
msgid "Plates disabled"
msgstr "Plates disabled"

#: src/features/forecastNotifications/NotificationPreferencesModal.tsx
msgid "Platform Notifications"
msgstr "Platform Notifications"

#: src/pages/processData/components/helpGuide/HelpGuideMedia.tsx
msgid "Play the clip"
msgstr "Play the clip"

#: src/features/chatbot/components/ChatbotHelpModal.tsx
msgid "Please describe the issue and our team will get back to you as soon as possible."
msgstr "Please describe the issue and our team will get back to you as soon as possible."

#: src/pages/assetLens/components/tabs/imagesTabComponents/ImageUploadModal.tsx
#: src/pages/assetLens/components/tabs/imagesTabComponents/ImageUploadModal.tsx
msgid "Please enter a numeric value"
msgstr "Please enter a numeric value"

#: src/pages/assetLens/components/tabs/imagesTabComponents/ImageUploadModal.tsx
msgid "Please enter the location or component part"
msgstr "Please enter the location or component part"

#: src/features/timeSeries/components/ThresholdConfigurationModal.tsx
msgid "Please fix the following issues:"
msgstr "Please fix the following issues:"

#: src/features/timeSeries/components/DerivedValuesTab.tsx
msgid "Please go to the Data from Tags tab and select some tags before creating calculations."
msgstr "Please go to the Data from Tags tab and select some tags before creating calculations."

#: src/pages/assetLens/components/tabs/DocumentsTab.tsx
msgid "Please select a file to upload"
msgstr "Please select a file to upload"

#: src/pages/assetLens/components/tabs/imagesTabComponents/ImageUploadModal.tsx
msgid "Please select an image file to upload."
msgstr "Please select an image file to upload."

#: src/features/timeSeries/components/ThresholdConfigurationModal.tsx
msgid "Please select sensors from the sidebar to configure their thresholds."
msgstr "Please select sensors from the sidebar to configure their thresholds."

#: src/pages/assetLens/components/tabs/imagesTabComponents/ImageUploadModal.tsx
msgid "Please select the date of capture"
msgstr "Please select the date of capture"

#: src/pages/assetLens/components/tabs/imagesTabComponents/ImageUploadModal.tsx
msgid "Please select the source of the image"
msgstr "Please select the source of the image"

#: src/pages/assetLens/components/tabs/DocumentsTab.tsx
msgid "Please upload a file"
msgstr "Please upload a file"

#: src/pages/assetLens/components/tabs/imagesTabComponents/ImageUploadModal.tsx
msgid "Please upload an image file"
msgstr "Please upload an image file"

#: src/pages/processData/components/helpGuide/HelpGuideChapters.tsx
msgid "Plot and Style Pens"
msgstr "Plot and Style Pens"

#: src/features/timeSeries/components/panes/DerivedTagsPane.tsx
msgid "Plot the tags you want to combine, then build a derived tag from them."
msgstr "Plot the tags you want to combine, then build a derived tag from them."

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
msgid "PM"
msgstr "PM"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
#: src/features/knowledgeDocumentViewer/workOrders/workOrderFields.ts
msgid "PM due"
msgstr "PM due"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
msgid "PM meter"
msgstr "PM meter"

#: src/features/knowledgeDocumentViewer/workOrders/legacyCmmsRecordPdf.ts
msgid "PM meters"
msgstr "PM meters"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
msgid "PO reference"
msgstr "PO reference"

#: src/features/timeSeries/components/timeSeriesScatterplot/EmbeddedChartToolbar.tsx
#: src/features/timeSeries/components/timeSeriesScatterplot/TimeSeriesScatterplotContent.tsx
#: src/pages/processData/components/helpGuide/HelpGuideChapters.tsx
#: src/pages/processData/components/ProcessDataTopBar.tsx
msgid "Point Annotation"
msgstr "Point Annotation"

#: src/features/timeSeries/components/timeSeriesScatterplot/EmbeddedChartToolbar.tsx
#: src/features/timeSeries/components/timeSeriesScatterplot/TimeSeriesScatterplotContent.tsx
#: src/pages/processData/components/ProcessDataTopBar.tsx
msgid "Point annotations require time on the x-axis"
msgstr "Point annotations require time on the x-axis"

#: src/features/copcPointClouds/CopcViewerOverlay.tsx
msgid "Point cloud error: {error}"
msgstr "Point cloud error: {error}"

#: src/features/copcPointClouds/CopcLocalizationColorControl.tsx
msgid "Point color"
msgstr "Point color"

#: src/features/mdCases/components/CaseTimeline.tsx
msgid "Point marked manually"
msgstr "Point marked manually"

#: src/features/mdCases/components/CaseStorySection.tsx
msgid "Point marked manually (in band)"
msgstr "Point marked manually (in band)"

#: src/features/copcPointClouds/CopcViewerOverlay.tsx
msgid "Point size"
msgstr "Point size"

#: src/features/lotoReports/components/LotoReportCard.tsx
msgid "Points"
msgstr "Points"

#: src/pages/cases/components/CaseFeedbackModal.tsx
msgid "Poor"
msgstr "Poor"

#: src/features/lotoReports/components/LotoPointPositionCombobox.tsx
msgid "Position"
msgstr "Position"

#: src/features/lotoReports/components/LotoPointPositionCombobox.tsx
msgid "Position for {tag}"
msgstr "Position for {tag}"

#: src/pages/assetLens/components/tabs/imagesTabComponents/EnvironmentalCorrelationCard.tsx
msgid "Positive correlation"
msgstr "Positive correlation"

#: src/features/timeSeries/experiment/CorrelationCard.tsx
msgid "Positive shift = driver leads the target. Scan window:"
msgstr "Positive shift = driver leads the target. Scan window:"

#: src/pages/cases/components/CaseCommentInput.tsx
msgid "Post Comment"
msgstr "Post Comment"

#: src/features/powerCustomerUploads/state/powerCustomerUploadRowUpdates.ts
msgid "Postgres linearized text"
msgstr "Postgres linearized text"

#: src/pages/cases/components/CaseCommentInput.tsx
msgid "Posting..."
msgstr "Posting..."

#: src/pages/assetLens/components/tabs/AnomalyDashboard.tsx
msgid "Potential Causes:"
msgstr "Potential Causes:"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
#: src/features/knowledgeDocumentViewer/workOrders/legacyCmmsRecordPdf.ts
msgid "Predecessor job plan"
msgstr "Predecessor job plan"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
#: src/features/knowledgeDocumentViewer/workOrders/legacyCmmsRecordPdf.ts
msgid "Predecessor task"
msgstr "Predecessor task"

#: src/features/timeSeries/components/ScatterPlotTableLegend.tsx
msgid "Predicted"
msgstr "Predicted"

#: src/pages/processData/buildMode/dock/ModelDockTab.tsx
msgid "Predicts the target from current driver values only."
msgstr "Predicts the target from current driver values only."

#: src/pages/details/extensions/flow/AssetModelEditorExtension.tsx
msgid "Prefer to work with JSON?"
msgstr "Prefer to work with JSON?"

#: src/features/powerCustomerUploads/components/powerCustomerUploadProgressModel.ts
#: src/features/powerCustomerUploads/components/PowerCustomerUploadStatus.tsx
#: src/features/powerCustomerUploads/components/PowerCustomerUploadStatus.tsx
msgid "Preparing"
msgstr "Preparing"

#: src/features/lotoReports/components/LotoPrintButton.tsx
msgid "Preparing {loaded} of {total} pages…"
msgstr "Preparing {loaded} of {total} pages…"

#: src/features/timeSeries/components/timeSeriesScatterplot/TimeSeriesScatterplotChart.tsx
msgid "Preparing chart data for the plot."
msgstr "Preparing chart data for the plot."

#: src/features/knowledgeDocumentViewer/workOrders/WorkOrderViewer.tsx
msgid "Preparing CMMS record…"
msgstr "Preparing CMMS record…"

#: src/features/knowledgeDocumentViewer/hooks/useDocumentPrintActions.ts
msgid "Preparing document for printing…"
msgstr "Preparing document for printing…"

#: src/pages/reporting/reports/rug/hooks/UseDraftPdfGeneration.tsx
msgid "Preparing PDF images..."
msgstr "Preparing PDF images..."

#: src/features/knowledgeDocumentViewer/components/toolbar/PrintDocumentButton.tsx
msgid "Preparing print..."
msgstr "Preparing print..."

#: src/features/lotoReports/printReport/useLotoReportPrint.ts
msgid "Preparing the LOTO report for printing…"
msgstr "Preparing the LOTO report for printing…"

#: src/features/fimReview/StructuralReviewFlow.tsx
msgid "Preparing this Subject…"
msgstr "Preparing this Subject…"

#: src/features/lotoReports/components/LotoPrintButton.tsx
#: src/features/lotoReports/components/LotoPrintPreview.tsx
msgid "Preparing…"
msgstr "Preparing…"

#: src/features/timeSeries/experiment/SplitBuilder.tsx
msgid "Preset: alt months"
msgstr "Preset: alt months"

#: src/features/timeSeries/experiment/SplitBuilder.tsx
msgid "Preset: tail 10%"
msgstr "Preset: tail 10%"

#: src/features/timeSeries/experiment/SplitBuilder.tsx
msgid "Preset: year holdout"
msgstr "Preset: year holdout"

#: src/pages/processData/components/helpGuide/HelpGuideChapters.tsx
msgid "Press "
msgstr "Press "

#: src/pages/assetLens/components/tabs/DocumentsTab.tsx
msgid "Prev"
msgstr "Prev"

#: src/features/knowledgeDocumentViewer/workOrders/legacyCmmsRecordPdf.ts
#: src/features/knowledgeDocumentViewer/workOrders/legacyCmmsRecordPdf.ts
#: src/features/knowledgeDocumentViewer/workOrders/workOrderPresentation.ts
msgid "Preventive maintenance"
msgstr "Preventive maintenance"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
msgid "Preventive maintenance schedule"
msgstr "Preventive maintenance schedule"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/documentPreview/FloatingDocumentPreviewOverlay.tsx
#: src/features/knowledgeDocumentViewer/components/toolbar/DocumentPreviewModeSwitch.tsx
msgid "Preview"
msgstr "Preview"

#: src/pages/facilityModel/SubjectDetailPage.tsx
msgid "Preview {citationLabel}"
msgstr "Preview {citationLabel}"

#: src/features/fimReview/StructuralReviewFlow.tsx
msgid "Preview change"
msgstr "Preview change"

#: src/features/knowledgeDocumentViewer/components/toolbar/DocumentPreviewModeSwitch.tsx
msgid "Preview mode off"
msgstr "Preview mode off"

#: src/features/knowledgeDocumentViewer/components/toolbar/DocumentPreviewModeSwitch.tsx
msgid "Preview mode on"
msgstr "Preview mode on"

#: src/pages/assetLens/components/tabs/DocumentsTab.tsx
msgid "Preview not available for {fileTypeLabel} files"
msgstr "Preview not available for {fileTypeLabel} files"

#: src/features/fimReview/DecisionHistory.tsx
msgid "Preview revert"
msgstr "Preview revert"

#: src/features/mdCases/components/ProvenanceContentViewer.tsx
#: src/features/mdCases/components/ProvenanceContentViewer.tsx
msgid "Preview unavailable."
msgstr "Preview unavailable."

#: src/features/fimReview/DecisionHistory.tsx
msgid "preview: {before} → {after}"
msgstr "preview: {before} → {after}"

#: src/features/fimReview/DecisionHistory.tsx
msgid "Previewing revert…"
msgstr "Previewing revert…"

#: src/features/fimReview/StructuralReviewFlow.tsx
msgid "Previewing…"
msgstr "Previewing…"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/AgenticChatPage.tsx
msgid "Previews from the chat open here at full width."
msgstr "Previews from the chat open here at full width."

#: src/designSystem/components/Pagination.tsx
msgid "Previous"
msgstr "Previous"

#: src/pages/details/overlays/inspections/InspectionsListOverlay.tsx
msgid "Previous inspections"
msgstr "Previous inspections"

#: src/features/knowledgeDocumentViewer/components/viewer/search/IntraDocSearchBar.tsx
#: src/features/knowledgeDocumentViewer/workOrders/WorkOrderViewer.tsx
msgid "Previous match"
msgstr "Previous match"

#: src/features/knowledgeDocumentViewer/components/viewer/search/IntraDocSearchBar.tsx
msgid "Previous match (Shift+Enter)"
msgstr "Previous match (Shift+Enter)"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/documentPreview/PreviewPageNavigator.tsx
msgid "Previous page"
msgstr "Previous page"

#: src/features/knowledgeDocumentViewer/components/toolbar/PageSelector.tsx
msgid "Previous Page"
msgstr "Previous Page"

#: src/features/knowledgeDocumentViewer/components/metadata/EvalQueueNavigation.tsx
msgid "Previous page in queue"
msgstr "Previous page in queue"

#: src/features/timeSeries/agentTab/dock/VersionsTab.tsx
msgid "Previous parameter sets"
msgstr "Previous parameter sets"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatTagPickerCard.tsx
msgid "Previous question"
msgstr "Previous question"

#: src/features/facilityModel/components/ReferencePreviewPanel.tsx
#: src/features/facilityModel/components/ReferencePreviewPanel.tsx
msgid "Previous reference"
msgstr "Previous reference"

#: src/features/knowledgeDocumentViewer/components/toolbar/SearchResultsNavigator.tsx
msgid "Previous search result"
msgstr "Previous search result"

#: src/features/timeSeries/components/ActiveTimeRangeSelector.tsx
#: src/features/timeSeries/components/ActiveTimeRangeSelector.tsx
#: src/features/timeSeries/components/TimeRangeSelector.tsx
#: src/features/timeSeries/components/TimeRangeSelector.tsx
msgid "Previous time period"
msgstr "Previous time period"

#: src/features/mdCases/components/ProvenanceContentViewer.tsx
#: src/features/mdCases/components/ProvenanceContentViewer.tsx
msgid "Primary datapoint ID"
msgstr "Primary datapoint ID"

#: src/pages/systemView/components/SystemViewAnnotationSidebar.tsx
msgid "Primitives"
msgstr "Primitives"

#: src/features/lotoReports/components/LotoPrintButton.tsx
msgid "Print"
msgstr "Print"

#: src/features/knowledgeDocumentViewer/components/toolbar/PrintDocumentButton.tsx
msgid "Print Document"
msgstr "Print Document"

#: src/features/knowledgeDocumentViewer/components/toolbar/PrintDocumentMenuOptions.tsx
msgid "Print page range"
msgstr "Print page range"

#: src/features/lotoReports/components/LotoReportEditorHeader.tsx
msgid "Print preview"
msgstr "Print preview"

#: src/pages/alerts/components/AlertsTableColumns.tsx
msgid "Prio"
msgstr "Prio"

#: src/features/fimReview/IdentityPanel.tsx
msgid "Prior Subjects"
msgstr "Prior Subjects"

#: src/features/knowledgeDocumentViewer/components/bugReport/BugReportPriorityField.tsx
#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
#: src/features/knowledgeDocumentViewer/workOrders/workOrderPresentation.ts
#: src/features/mdCases/components/ProvenanceContentViewer.tsx
#: src/features/mdCases/components/ProvenanceContentViewer.tsx
#: src/pages/cases/md/MdCasesCardList.tsx
#: src/pages/cases/md/MdCasesColumnHeader.tsx
msgid "Priority"
msgstr "Priority"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
#: src/features/knowledgeDocumentViewer/workOrders/workOrderFields.ts
msgid "Priority description"
msgstr "Priority description"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
#: src/features/knowledgeDocumentViewer/workOrders/workOrderFields.ts
#: src/features/knowledgeDocumentViewer/workOrders/workOrderPdf.ts
msgid "Priority justification"
msgstr "Priority justification"

#: src/pages/cases/components/CaseDetailsSidebar.tsx
msgid "Private"
msgstr "Private"

#: src/pages/cases/components/CasesTable.tsx
msgid "Private Cases"
msgstr "Private Cases"

#: src/pages/alerts/AlertDetails.tsx
msgid "Probable Causes"
msgstr "Probable Causes"

#: src/features/fimEvidence/SubjectGlyphs.tsx
#: src/features/fimReview/provenance.ts
#: src/features/modelOperations/Corroboration.tsx
#: src/pages/facilityModel/SubjectDetailPage.tsx
msgid "Process data"
msgstr "Process data"

#: src/features/navbar/navConfig.ts
msgid "Process Data"
msgstr "Process Data"

#: src/pages/processData/components/helpGuide/HelpGuideDialog.tsx
msgid "Process Data Guide"
msgstr "Process Data Guide"

#: src/pages/processData/components/helpGuide/HelpGuideChapters.tsx
msgid "Process Data lives in the app's left sidebar. A <0>view</0> is everything on screen — pens, styling, time range, annotations."
msgstr "Process Data lives in the app's left sidebar. A <0>view</0> is everything on screen — pens, styling, time range, annotations."

#: src/pages/processData/components/helpGuide/HelpGuideChapters.tsx
msgid "Process Data plots any tag on your site over time. Tags on the left, chart in the center, time range along the bottom, live values on the right. The whole setup saves as a view your team can open."
msgstr "Process Data plots any tag on your site over time. Tags on the left, chart in the center, time range along the bottom, live values on the right. The whole setup saves as a view your team can open."

#: src/pages/evaluations/metadata/labeling/utils/pageClassificationTaxonomy.ts
msgid "Process flow and fluid circuits"
msgstr "Process flow and fluid circuits"

#: src/features/navbar/navConfig.ts
msgid "Process Flow Diagrams"
msgstr "Process Flow Diagrams"

#: src/pages/evaluations/metadata/labeling/utils/pageClassificationTaxonomy.ts
msgid "Process, fluid, and thermal performance analysis"
msgstr "Process, fluid, and thermal performance analysis"

#: src/features/powerCustomerUploads/components/PowerCustomerUploadStatus.tsx
#: src/features/powerCustomerUploads/components/PowerCustomerUploadStatus.tsx
msgid "Processed"
msgstr "Processed"

#: src/features/powerCustomerUploads/components/PowerCustomerUploadStatus.tsx
#: src/features/powerCustomerUploads/components/PowerCustomerUploadStatus.tsx
msgid "Processing"
msgstr "Processing"

#: src/pages/evaluations/metadata/labeling/utils/pageClassificationTaxonomy.ts
msgid "Product selection and ordering guides"
msgstr "Product selection and ordering guides"

#: src/features/navbar/navConfig.ts
msgid "Production Dashboard"
msgstr "Production Dashboard"

#: src/pages/processData/buildMode/hooks/usePromoteSentinel.ts
msgid "promote failed"
msgstr "promote failed"

#: src/pages/processData/buildMode/rightPanel/PromoteModelAction.tsx
#: src/pages/processData/buildMode/rightPanel/PromoteModelAction.tsx
#: src/pages/processData/buildMode/rightPanel/PromoteModelAction.tsx
msgid "Promote to active monitor"
msgstr "Promote to active monitor"

#: src/features/facilityModel/columns.ts
#: src/pages/facilityModel/FacilityModelCatalog.tsx
msgid "Promoted"
msgstr "Promoted"

#: src/pages/facilityModel/SubjectDetailPage.tsx
msgid "Promoted asset"
msgstr "Promoted asset"

#: src/pages/facilityModel/FacilityModelFilters.tsx
msgid "Promoted only"
msgstr "Promoted only"

#: src/pages/processData/buildMode/rightPanel/PromoteModelAction.tsx
msgid "Promoting…"
msgstr "Promoting…"

#: src/pages/cases/md/mdCasesListSearchContract.ts
msgid "Promotion State"
msgstr "Promotion State"

#: src/features/lotoReports/components/LotoProposalCard.tsx
#: src/features/lotoReports/components/LotoProposalCard.tsx
msgid "Proposed LOTO report"
msgstr "Proposed LOTO report"

#: src/features/mdCases/components/ProvenanceContentViewer.tsx
#: src/pages/alerts/components/AlertProvenanceCard.tsx
msgid "Provenance"
msgstr "Provenance"

#: src/pages/cases/components/CaseFeedbackModal.tsx
#: src/pages/cases/md/MdCaseDetailsMainColumn.tsx
msgid "Provide Feedback"
msgstr "Provide Feedback"

#: src/features/fimReview/InspectSources.tsx
msgid "Proxy"
msgstr "Proxy"

#: src/pages/cases/md/MdCaseDetailsPage.tsx
msgid "Publish"
msgstr "Publish"

#: src/pages/cases/components/EditCaseForm.tsx
msgid "Publish and Share"
msgstr "Publish and Share"

#: src/pages/processData/buildMode/rightPanel/PromoteModelAction.tsx
msgid "Publish as active monitor"
msgstr "Publish as active monitor"

#: src/pages/cases/components/CaseDetailsContent.tsx
#: src/pages/cases/components/CaseDetailsContent.tsx
msgid "Publish Case"
msgstr "Publish Case"

#: src/pages/details/extensions/fde/ffsLtaGeneration/FfsLtaGenerationSidebar.tsx
msgid "Publish observations"
msgstr "Publish observations"

#: src/pages/cases/md/MdCaseDetailsPage.tsx
msgid "Publish the current recommendation to the site."
msgstr "Publish the current recommendation to the site."

#: src/features/mdCases/mdCaseDisplay.ts
#: src/features/mdCases/mdCaseDisplay.ts
#: src/pages/cases/components/CaseDetailsSidebar.tsx
#: src/pages/cases/md/MdCasesCardList.tsx
#: src/pages/cases/md/MdCasesColumnHeader.tsx
msgid "Published"
msgstr "Published"

#: src/pages/cases/md/MdCaseDetailsMainColumn.tsx
msgid "Published {publishedAtLabel}"
msgstr "Published {publishedAtLabel}"

#: src/features/mdCases/components/CaseTimeline.tsx
msgid "Published recommendation"
msgstr "Published recommendation"

#: src/pages/cases/md/MdCaseDetailsMainColumn.tsx
msgid "Published Recommendation"
msgstr "Published Recommendation"

#: src/pages/cases/md/mdCasesListSearchContract.ts
msgid "Published State"
msgstr "Published State"

#: src/pages/cases/md/MdCaseDetailsPage.tsx
msgid "Publishing the latest saved recommendation."
msgstr "Publishing the latest saved recommendation."

#: src/pages/processData/buildMode/rightPanel/PromoteModelAction.tsx
msgid "Publishing to active requires the promote endpoint — rolling out"
msgstr "Publishing to active requires the promote endpoint — rolling out"

#: src/pages/cases/components/CaseDetailsContent.tsx
#: src/pages/cases/md/MdCaseDetailsPage.tsx
msgid "Publishing..."
msgstr "Publishing..."

#: src/features/timeSeries/agentTab/toolSentence.ts
msgid "Pulled data"
msgstr "Pulled data"

#: src/features/timeSeries/agentTab/toolSentence.ts
msgid "Pulled data into {dataset}"
msgstr "Pulled data into {dataset}"

#: src/features/timeSeries/agentTab/toolSentence.ts
msgid "Pulling data"
msgstr "Pulling data"

#: src/features/timeSeries/agentTab/toolSentence.ts
msgid "Pulling data into {dataset}"
msgstr "Pulling data into {dataset}"

#: src/features/sentinels/components/DesignRunOverviewSections.tsx
msgid "Pulls fresh data and scores it with the refit model. No retraining, and nothing is saved."
msgstr "Pulls fresh data and scores it with the refit model. No retraining, and nothing is saved."

#: src/features/fimReview/ReviewActions.tsx
msgid "Pump, valve, vendor…"
msgstr "Pump, valve, vendor…"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
#: src/features/knowledgeDocumentViewer/workOrders/legacyCmmsRecordPdf.ts
#: src/features/knowledgeDocumentViewer/workOrders/legacyCmmsRecordPdf.ts
msgid "Purchase order"
msgstr "Purchase order"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
#: src/features/knowledgeDocumentViewer/workOrders/legacyCmmsRecordPdf.ts
#: src/features/knowledgeDocumentViewer/workOrders/legacyCmmsRecordPdf.ts
msgid "Purchase requisition"
msgstr "Purchase requisition"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
msgid "Purchasing term"
msgstr "Purchasing term"

#: src/features/knowledgeDocumentViewer/workOrders/legacyCmmsRecordPdf.ts
msgid "Purchasing terms"
msgstr "Purchasing terms"

#: src/features/timeSeries/components/LabelsTab.tsx
msgid "Put these labels on the chart"
msgstr "Put these labels on the chart"

#: src/pages/processData/buildMode/dock/BandsDockTab.tsx
msgid "Quantile"
msgstr "Quantile"

#: src/features/timeSeries/experiment/CleaningControls.tsx
msgid "Quantile clip"
msgstr "Quantile clip"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
#: src/features/knowledgeDocumentViewer/workOrders/legacyCmmsRecordPdf.ts
msgid "Quantity"
msgstr "Quantity"

#: src/features/timeSeries/components/TimeRangeSelector.tsx
msgid "Quarterly review"
msgstr "Quarterly review"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatEvalCaseReview.tsx
msgid "Query"
msgstr "Query"

#: src/features/timeSeries/experiment/DiagnosticsPanel.tsx
msgid "Query ts"
msgstr "Query ts"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
#: src/features/knowledgeDocumentViewer/workOrders/legacyCmmsRecordPdf.ts
msgid "Question"
msgstr "Question"

#: src/pages/facilityModel/SubjectAssetPanel.tsx
msgid "Queue a fresh template fill for this Asset Instance"
msgstr "Queue a fresh template fill for this Asset Instance"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatSearchBox.tsx
msgid "Queue message"
msgstr "Queue message"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatMessageQueue.tsx
msgid "Queue paused while editing."
msgstr "Queue paused while editing."

#: src/features/facilityModel/views.ts
msgid "Queued"
msgstr "Queued"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatMessageQueue.tsx
msgid "Queued messages"
msgstr "Queued messages"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatMessageQueue.tsx
msgid "Queued messages send in order after the current response."
msgstr "Queued messages send in order after the current response."

#: src/pages/facilityModel/SubjectAssetPanel.tsx
msgid "Queueing…"
msgstr "Queueing…"

#: src/features/timeSeries/experiment/NormalizationViewer.tsx
msgid "Quick pick — the experiment's drivers:"
msgstr "Quick pick — the experiment's drivers:"

#: src/features/timeSeries/components/ActiveTimeRangeSectionWithPopover.tsx
#: src/features/timeSeries/components/TimeRangeSelector.tsx
msgid "Quick Select"
msgstr "Quick Select"

#: src/features/timeSeries/agentTab/dock/AlertingTab.tsx
msgid "quiet"
msgstr "quiet"

#: src/features/chatbot/components/CitationTooltip.tsx
msgid "Quotations"
msgstr "Quotations"

#: src/features/richText/components/ToolbarPlugin.tsx
msgid "Quote"
msgstr "Quote"

#: src/features/timeSeries/experiment/DiagnosticsPanel.tsx
#: src/pages/processData/buildMode/dock/CompareDockTab.tsx
#: src/pages/processData/buildMode/rightPanel/RankingTable.tsx
#: src/pages/processData/buildMode/rightPanel/RankingTable.tsx
msgid "R²"
msgstr "R²"

#: src/features/timeSeries/components/RegressionPrediction.tsx
msgid "R² ="
msgstr "R² ="

#: src/features/sentinels/components/DesignRunOverviewSections.tsx
msgid "Raised when the plan was designed and validated against the fit. Advisory only — none of them blocked this run."
msgstr "Raised when the plan was designed and validated against the fit. Advisory only — none of them blocked this run."

#: src/pages/details/visualization/tools/VizDebugMenu.tsx
msgid "RAM debug colors"
msgstr "RAM debug colors"

#: src/features/timeSeries/agentTab/toolSentence.ts
msgid "Ran {readable}"
msgstr "Ran {readable}"

#: src/features/timeSeries/experiment/ModelKnobs.tsx
msgid "Random seed"
msgstr "Random seed"

#: src/features/timeSeries/components/rulerTool/RulerMetricsPanel.tsx
msgid "Range"
msgstr "Range"

#: src/features/timeSeries/experiment/CleaningControls.tsx
msgid "Range min / max"
msgstr "Range min / max"

#: src/features/timeSeries/components/timeSeriesScatterplot/MdDraftAlertCaseFlowPanels.tsx
msgid "Range:"
msgstr "Range:"

#: src/pages/cases/components/CaseFeedbackModal.tsx
msgid "Rating"
msgstr "Rating"

#: src/features/timeSeries/experiment/SamplingKnobs.tsx
msgid "Raw historian points (all available)"
msgstr "Raw historian points (all available)"

#: src/features/timeSeries/experiment/SamplingKnobs.tsx
msgid "Raw mode pulls every historian point and only aligns tags when timestamps match exactly. Prefer a shorter date range — dense tags can be huge."
msgstr "Raw mode pulls every historian point and only aligns tags when timestamps match exactly. Prefer a shorter date range — dense tags can be huge."

#: src/pages/processData/buildMode/dock/SamplingSection.tsx
msgid "Raw points"
msgstr "Raw points"

#: src/features/mdCases/components/CaseStorySection.tsx
msgid "Raw signal · snapshot values on each alert are authoritative."
msgstr "Raw signal · snapshot values on each alert are authoritative."

#: src/features/fimReview/InspectSources.tsx
msgid "raw source row · agent-asserted"
msgstr "raw source row · agent-asserted"

#: src/features/fimReview/InspectSources.tsx
msgid "raw source row · as ingested from the upload"
msgstr "raw source row · as ingested from the upload"

#: src/pages/facilityModel/SubjectAssetPanel.tsx
msgid "Re-fill"
msgstr "Re-fill"

#: src/pages/facilityModel/SubjectAssetPanel.tsx
msgid "Re-fill failed: {reason}"
msgstr "Re-fill failed: {reason}"

#: src/features/modelOperations/SubjectDetails.tsx
#: src/pages/facilityModel/SubjectDetailPage.tsx
msgid "Re-instantiate"
msgstr "Re-instantiate"

#: src/pages/facilityModel/SubjectDetailPage.tsx
msgid "Re-instantiate failed: {reason}"
msgstr "Re-instantiate failed: {reason}"

#: src/features/modelOperations/SubjectDetails.tsx
msgid "Re-instantiating…"
msgstr "Re-instantiating…"

#: src/features/timeSeries/agentTab/dock/AgentDock.tsx
msgid "Re-pulling and refitting…"
msgstr "Re-pulling and refitting…"

#: src/features/timeSeries/agentTab/dock/AlertingTab.tsx
msgid "Re-pulls and grades against the rule above without waiting for the schedule."
msgstr "Re-pulls and grades against the rule above without waiting for the schedule."

#: src/features/sentinels/components/CasesPanel.tsx
msgid "Re-run RCA"
msgstr "Re-run RCA"

#: src/pages/processData/components/helpGuide/HelpGuideChapters.tsx
msgid "Reach out to your Gecko site contact — send a note by email, or schedule a call to walk through what you need. Requests go straight into our product planning."
msgstr "Reach out to your Gecko site contact — send a note by email, or schedule a call to walk through what you need. Requests go straight into our product planning."

#: src/features/forecastNotifications/notificationUtils.ts
msgid "Read"
msgstr "Read"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/utils/docChatText.ts
msgid "Read live values for {datapointLabel}"
msgstr "Read live values for {datapointLabel}"

#: src/features/timeSeries/agentTab/toolSentence.ts
msgid "Read the instruments on a drawing"
msgstr "Read the instruments on a drawing"

#: src/features/timeSeries/agentTab/toolSentence.ts
msgid "Read the instruments on a drawing page {page}"
msgstr "Read the instruments on a drawing page {page}"

#: src/pages/details/extensions/flow/SummarizerExtension.tsx
msgid "Reading {formattedValue}, {xAxisName} {formattedX}, {yAxisName} {formattedY}. Activate to focus the viewport on this measurement."
msgstr "Reading {formattedValue}, {xAxisName} {formattedX}, {yAxisName} {formattedY}. Activate to focus the viewport on this measurement."

#: src/features/timeSeries/agentTab/toolSentence.ts
msgid "Reading the instruments on a drawing"
msgstr "Reading the instruments on a drawing"

#: src/features/timeSeries/agentTab/toolSentence.ts
msgid "Reading the instruments on a drawing page {page}"
msgstr "Reading the instruments on a drawing page {page}"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatAgentsMenu.tsx
msgid "Reads and charts plant data on your next question"
msgstr "Reads and charts plant data on your next question"

#: src/features/powerCustomerUploads/components/PowerCustomerUploadSummary.tsx
msgid "Ready"
msgstr "Ready"

#: src/pages/nnpp/imports/NnppImportVerificationPage.tsx
msgid "Ready to complete"
msgstr "Ready to complete"

#: src/pages/assetLens/components/tabs/AnomalyDashboard.tsx
msgid "Real-time anomaly detection and management"
msgstr "Real-time anomaly detection and management"

#: src/features/timeSeries/components/TimeRangeSelector.tsx
msgid "Real-time monitoring"
msgstr "Real-time monitoring"

#: src/features/knowledgeDocumentViewer/components/metadata/DeferPageMetadataDialog.tsx
msgid "Reason"
msgstr "Reason"

#: src/features/fimReview/ReviewActions.tsx
#: src/features/fimReview/StructuralReviewFlow.tsx
msgid "Reason (optional)"
msgstr "Reason (optional)"

#: src/features/fimReview/ReviewActions.tsx
msgid "Reason for classification change"
msgstr "Reason for classification change"

#: src/features/lotoReports/components/LotoSheetHeaderFields.tsx
msgid "Reason for LOTO"
msgstr "Reason for LOTO"

#: src/features/lotoReports/recordSheet/recordSheetLayout.ts
msgid "REASON FOR LOTO:"
msgstr "REASON FOR LOTO:"

#: src/features/fimReview/ReviewActions.tsx
msgid "Reason for removing input"
msgstr "Reason for removing input"

#: src/pages/cases/md/MdCaseDetailsPage.tsx
msgid "Reason for reopening this case:"
msgstr "Reason for reopening this case:"

#: src/features/fimReview/StructuralReviewFlow.tsx
msgid "Reason for structural correction"
msgstr "Reason for structural correction"

#: src/pages/assetLens/components/tabs/AnomalyDashboard.tsx
msgid "Reason:"
msgstr "Reason:"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatModelSettingsMenu.tsx
msgid "Reasoning effort"
msgstr "Reasoning effort"

#: src/features/timeSeries/sentinelStudio/SentinelBuilderPanel.tsx
msgid "Rebuild context"
msgstr "Rebuild context"

#: src/features/timeSeries/components/RegressionPrediction.tsx
msgid "Recalc"
msgstr "Recalc"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
#: src/features/knowledgeDocumentViewer/workOrders/legacyCmmsRecordPdf.ts
msgid "Receipt state"
msgstr "Receipt state"

#: src/features/forecastNotifications/NotificationPreferencesModal.tsx
msgid "Receive notifications via email"
msgstr "Receive notifications via email"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
#: src/features/knowledgeDocumentViewer/workOrders/legacyCmmsRecordPdf.ts
msgid "Received quantity"
msgstr "Received quantity"

#: src/pages/processData/components/viewSwitcher/ViewSwitcher.tsx
msgid "Recent"
msgstr "Recent"

#: src/pages/assetLens/components/tabs/AnomalyDashboard.tsx
msgid "Recent Activity"
msgstr "Recent Activity"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/LandingScrollSections.tsx
msgid "Recent Charts"
msgstr "Recent Charts"

#: src/features/embeddedSidebar/chatHistory/ChatHistoryOverflowMenu.tsx
msgid "Recent chat actions"
msgstr "Recent chat actions"

#: src/features/embeddedSidebar/chatHistory/AgenticChatHistorySidebar.tsx
msgid "Recent chats"
msgstr "Recent chats"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/LandingScrollSections.tsx
msgid "Recent Documents"
msgstr "Recent Documents"

#: src/features/timeSeries/agentTab/dock/TargetTab.tsx
msgid "Recent scatter is {healthRatio}× the baseline band, so a sigma here measures the regime change, not the asset. Refit on a baseline that covers current operation."
msgstr "Recent scatter is {healthRatio}× the baseline band, so a sigma here measures the regime change, not the asset. Refit on a baseline that covers current operation."

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/SearchSuggestionsDropdown.tsx
msgid "Recent searches"
msgstr "Recent searches"

#: src/features/fim/assetInventory.ts
msgid "Recently updated"
msgstr "Recently updated"

#: src/pages/homepage/Homepage.tsx
msgid "RECENTS"
msgstr "RECENTS"

#: src/features/fimReview/DecisionHistory.tsx
msgid "Reclassified"
msgstr "Reclassified"

#: src/features/chatbot/components/conversationMessage/ProposalCard.tsx
#: src/pages/assetLens/components/tabs/SensorIssuesTab.tsx
#: src/pages/cases/md/MdCaseDetailsMainColumn.tsx
#: src/pages/cases/md/MdCaseDetailsPage.tsx
msgid "Recommendation"
msgstr "Recommendation"

#: src/pages/cases/components/CaseFeedbackModal.tsx
msgid "Recommendation Accuracy"
msgstr "Recommendation Accuracy"

#: src/features/mdCases/components/CaseTimeline.tsx
msgid "Recommendation draft"
msgstr "Recommendation draft"

#: src/features/mdCases/components/CaseTimeline.tsx
msgid "Recommendation summary"
msgstr "Recommendation summary"

#: src/pages/assetLens/components/tabs/AnomalyDashboard.tsx
msgid "Recommended Actions:"
msgstr "Recommended Actions:"

#: src/features/fimReview/SubjectDiagnostics.tsx
msgid "Recommended:"
msgstr "Recommended:"

#: src/features/chatbot/api/sseClient.ts
msgid "Reconnect failed: HTTP {status}"
msgstr "Reconnect failed: HTTP {status}"

#: src/features/chatbot/api/sseClient.ts
msgid "Reconnection error"
msgstr "Reconnection error"

#: src/features/chatbot/api/sseClient.ts
msgid "Reconnection stream error"
msgstr "Reconnection stream error"

#: src/designSystem/components/RecordHeader.tsx
msgid "Record actions"
msgstr "Record actions"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
msgid "Record class"
msgstr "Record class"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
#: src/features/knowledgeDocumentViewer/workOrders/legacyCmmsRecordPdf.ts
msgid "Record details"
msgstr "Record details"

#: src/features/knowledgeDocumentViewer/workOrders/workOrderPresentation.ts
msgid "Record kind"
msgstr "Record kind"

#: src/features/lotoReports/components/LotoSheetEditor.tsx
msgid "Record sheet page {pageNumber} of {count}"
msgstr "Record sheet page {pageNumber} of {count}"

#: src/features/lotoReports/components/LotoReportEditorHeader.tsx
msgid "Record sheet view"
msgstr "Record sheet view"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
msgid "Recorded inspection responses; unanswered fields are not passes."
msgstr "Recorded inspection responses; unanswered fields are not passes."

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
msgid "Recorded location and hierarchy."
msgstr "Recorded location and hierarchy."

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
msgid "Recorded material movement; not proof of installation."
msgstr "Recorded material movement; not proof of installation."

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
msgid "Recorded material transaction"
msgstr "Recorded material transaction"

#: src/features/knowledgeDocumentViewer/workOrders/legacyCmmsRecordPdf.ts
msgid "Recorded material transactions"
msgstr "Recorded material transactions"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
msgid "Recorded receipt transaction"
msgstr "Recorded receipt transaction"

#: src/features/knowledgeDocumentViewer/workOrders/legacyCmmsRecordPdf.ts
msgid "Recorded receipt transactions"
msgstr "Recorded receipt transactions"

#: src/features/knowledgeDocumentViewer/workOrders/WorkOrderCardMetadata.tsx
msgid "Recorded status: {status}"
msgstr "Recorded status: {status}"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
msgid "Recorded supplier"
msgstr "Recorded supplier"

#: src/features/knowledgeDocumentViewer/workOrders/workOrderPdf.ts
msgid "Recorded totals for this record; currency is not supplied. Labor hours measure effort, not elapsed downtime."
msgstr "Recorded totals for this record; currency is not supplied. Labor hours measure effort, not elapsed downtime."

#: src/features/knowledgeDocumentViewer/workOrders/workOrderPdf.ts
msgid "Recorded totals in {currency}. Labor hours measure effort, not elapsed downtime."
msgstr "Recorded totals in {currency}. Labor hours measure effort, not elapsed downtime."

#: src/pages/nnpp/acceptance/NnppAcceptanceReviewPage.tsx
msgid "Recording acceptance decisions is not available yet."
msgstr "Recording acceptance decisions is not available yet."

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/ReportChart.tsx
msgid "Records without values: {missing}"
msgstr "Records without values: {missing}"

#: src/pages/details/visualization/markupEditing/EditToolBar.tsx
msgid "Rectangle tool"
msgstr "Rectangle tool"

#: src/features/knowledgeDocumentViewer/graph/offPageConnectorTooltipRows.ts
msgid "Reference only"
msgstr "Reference only"

#: src/features/facilityModel/components/ReferencePreviewPanel.tsx
msgid "Reference preview"
msgstr "Reference preview"

#: src/features/knowledgeDocumentViewer/components/viewer/search/DocReferenceOverlay.tsx
msgid "Reference: {referenceLabel}"
msgstr "Reference: {referenceLabel}"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
msgid "Referenced asset"
msgstr "Referenced asset"

#: src/features/knowledgeDocumentViewer/workOrders/legacyCmmsRecordPdf.ts
msgid "Referenced assets"
msgstr "Referenced assets"

#: src/features/facilityModel/citations.ts
#: src/features/knowledgeDocumentViewer/components/viewer/search/DocReferencePreviewCard.tsx
#: src/features/modelOperations/SubjectDetails.tsx
msgid "Referenced document"
msgstr "Referenced document"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
#: src/features/knowledgeDocumentViewer/workOrders/legacyCmmsRecordPdf.ts
msgid "Referenced inventory"
msgstr "Referenced inventory"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
msgid "Referenced job plan"
msgstr "Referenced job plan"

#: src/features/knowledgeDocumentViewer/workOrders/legacyCmmsRecordPdf.ts
msgid "Referenced job plans"
msgstr "Referenced job plans"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
msgid "Referenced location"
msgstr "Referenced location"

#: src/features/knowledgeDocumentViewer/workOrders/legacyCmmsRecordPdf.ts
msgid "Referenced locations"
msgstr "Referenced locations"

#: src/features/knowledgeDocumentViewer/graph/offPageConnectorTooltipRows.ts
msgid "Referenced off-page connector"
msgstr "Referenced off-page connector"

#: src/features/sentinels/components/CasesPanel.tsx
msgid "Referenced:"
msgstr "Referenced:"

#: src/pages/cases/components/CaseFeedbackModal.tsx
#: src/pages/cases/md/MdCaseReferencesDrawer.tsx
msgid "References"
msgstr "References"

#: src/features/mdCases/components/ProvenanceContentViewer.tsx
msgid "References ({refCount})"
msgstr "References ({refCount})"

#: src/features/chatbot/components/conversationMessage/AIResponseExtras.tsx
msgid "References ({referenceCount})"
msgstr "References ({referenceCount})"

#: src/features/chatbot/components/StreamingReferences.tsx
msgid "References ({totalCount})"
msgstr "References ({totalCount})"

#: src/features/knowledgeDocumentViewer/components/toolbar/DocumentTabs.tsx
#: src/features/knowledgeDocumentViewer/components/toolbar/KnowledgeDocumentHeaderBar.tsx
msgid "References to {referenceText}"
msgstr "References to {referenceText}"

#: src/features/sentinels/components/DesignRunOverviewSections.tsx
msgid "refit FAILED — "
msgstr "refit FAILED — "

#: src/features/timeSeries/agentTab/dock/AlertingTab.tsx
msgid "refit needed"
msgstr "refit needed"

#: src/features/sentinels/components/DesignRunOverviewSections.tsx
msgid "refit on the"
msgstr "refit on the"

#: src/features/kestrelUpload/KestrelModelUploadSection.tsx
#: src/features/timeSeries/experiment/ExperimentTab.tsx
#: src/pages/systemView/components/unitsTab/ActionsRow.tsx
#: src/pages/systemView/components/unitsTab/ActionsRow.tsx
msgid "Refresh"
msgstr "Refresh"

#: src/pages/cases/md/MdCaseDetailsPage.tsx
msgid "Refreshing latest case details..."
msgstr "Refreshing latest case details..."

#: src/features/timeSeries/experiment/ExperimentTab.tsx
msgid "Refreshing preview…"
msgstr "Refreshing preview…"

#: src/features/timeSeries/experiment/ExperimentTab.tsx
#: src/pages/cases/md/MdCasesListPage.tsx
msgid "Refreshing…"
msgstr "Refreshing…"

#: src/features/fimReview/IdentityPanel.tsx
#: src/features/knowledgeDocumentViewer/components/sidebar/OcrTableColumns.tsx
msgid "Refs"
msgstr "Refs"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
#: src/features/knowledgeDocumentViewer/workOrders/legacyCmmsRecordPdf.ts
msgid "Region"
msgstr "Region"

#: src/pages/assetLens/components/tabs/timeSeriesAnalysis/DataProcessingToolbar.tsx
msgid "Regression & Prediction"
msgstr "Regression & Prediction"

#: src/pages/assetLens/components/tabs/canvas/AnalysisState.tsx
msgid "Regressions"
msgstr "Regressions"

#: src/features/chatbot/components/conversationMessage/ProposalCard.tsx
#: src/pages/nnpp/acceptance/NnppAcceptanceReviewPage.tsx
msgid "Reject"
msgstr "Reject"

#: src/features/chatbot/components/conversationMessage/ProposalCard.tsx
msgid "rejected"
msgstr "rejected"

#: src/features/facilityModel/columns.ts
#: src/features/fimReview/InspectSources.tsx
#: src/features/fimReview/StructuralReviewFlow.tsx
#: src/features/powerCustomerUploads/components/PowerCustomerUploadStatus.tsx
msgid "Rejected"
msgstr "Rejected"

#: src/features/fimReview/DecisionHistory.tsx
msgid "Rejected (legacy)"
msgstr "Rejected (legacy)"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
#: src/features/knowledgeDocumentViewer/workOrders/legacyCmmsRecordPdf.ts
msgid "Rejected quantity"
msgstr "Rejected quantity"

#: src/pages/assetLens/components/tabs/DocumentsTab.tsx
msgid "Related Asset"
msgstr "Related Asset"

#: src/designSystem/components/RecordHeader.tsx
msgid "Related records"
msgstr "Related records"

#: src/features/lotoReports/recordSheet/recordSheetLayout.ts
msgid ""
"Released\n"
"Initial"
msgstr ""
"Released\n"
"Initial"

#: src/features/lotoReports/recordSheet/recordSheetLayout.ts
msgid ""
"Released\n"
"Position"
msgstr ""
"Released\n"
"Position"

#: src/features/lotoReports/components/LotoSheetPointRow.tsx
msgid "Released position"
msgstr "Released position"

#: src/features/timeSeries/experiment/RunComparison.tsx
msgid "Reload"
msgstr "Reload"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/utils/inspectionLayers.ts
msgid "Remaining corrosion allowance"
msgstr "Remaining corrosion allowance"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/utils/inspectionLayers.ts
msgid "Remaining life"
msgstr "Remaining life"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatInspectionCard.tsx
msgid "Remaining life unavailable for this selection."
msgstr "Remaining life unavailable for this selection."

#: src/features/timeSeries/agentTab/chat/BuildCard.tsx
msgid "remove"
msgstr "remove"

#: src/features/chatbot/components/AttachmentPills.tsx
#: src/features/fim/photos/PhotoRemoveButton.tsx
#: src/features/fim/photos/PhotoRemoveButton.tsx
#: src/features/fimReview/StructuralReviewFlow.tsx
#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatEvalCaseReview.tsx
#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatEvalCaseReview.tsx
#: src/features/timeSeries/components/ScatterPlotTableConfig.tsx
#: src/features/timeSeries/experiment/SplitBuilder.tsx
#: src/features/timeSeries/experiment/TagPicker.tsx
#: src/pages/details/extensions/fde/NavyRepairPlanningExtension.tsx
msgid "Remove"
msgstr "Remove"

#: src/features/fimReview/IdentityPanel.tsx
msgid "Remove {aliasValue} from fusion"
msgstr "Remove {aliasValue} from fusion"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatSearchBox.tsx
msgid "Remove {attachmentName}"
msgstr "Remove {attachmentName}"

#: src/features/chatbot/components/AttachmentPills.tsx
msgid "Remove {displayTitle}"
msgstr "Remove {displayTitle}"

#: src/features/timeSeries/agentTab/dock/FitTab.tsx
msgid "Remove {driver} from the fit"
msgstr "Remove {driver} from the fit"

#: src/pages/manageAccess/components/invite/EmailChipsInput.tsx
msgid "Remove {email}"
msgstr "Remove {email}"

#: src/features/knowledgeDocumentViewer/components/bugReport/BugReportScreenshots.tsx
msgid "Remove {filename}"
msgstr "Remove {filename}"

#: src/features/timeSeries/components/panes/TagFilterControls.tsx
msgid "Remove {label}"
msgstr "Remove {label}"

#: src/features/lotoReports/components/LotoTargetEquipmentList.tsx
#: src/features/timeSeries/components/panes/DerivedTagsPane.tsx
#: src/features/timeSeries/components/pointTool/PointAnnotationOverlay.tsx
msgid "Remove {name}"
msgstr "Remove {name}"

#: src/features/timeSeries/agentTab/dock/FitTab.tsx
msgid "Remove {role}"
msgstr "Remove {role}"

#: src/features/lotoReports/components/LotoIsolationPointRow.tsx
#: src/features/lotoReports/components/LotoSheetPointRow.tsx
msgid "Remove {tag}"
msgstr "Remove {tag}"

#: src/pages/processData/buildMode/components/ModelingTagsPane.tsx
msgid "Remove {tagName}"
msgstr "Remove {tagName}"

#: src/features/timeSeries/components/ScatterPlotTableConfig.tsx
msgid "Remove {value291_51} from the chart?"
msgstr "Remove {value291_51} from the chart?"

#: src/features/timeSeries/components/rulerTool/RulerMetricsPanel.tsx
msgid "Remove {value395_51}"
msgstr "Remove {value395_51}"

#: src/features/timeSeries/agentTab/dock/SettingsTab.tsx
msgid "Remove {value404_48}"
msgstr "Remove {value404_48}"

#: src/features/timeSeries/agentTab/dock/SettingsTab.tsx
msgid "Remove {value426_46}"
msgstr "Remove {value426_46}"

#: src/features/timeSeries/components/LabelsTab.tsx
#: src/features/timeSeries/components/panes/TagConfigurationPane.tsx
msgid "Remove all"
msgstr "Remove all"

#: src/features/timeSeries/components/ScatterplotSidebarConfig.tsx
msgid "Remove All"
msgstr "Remove All"

#: src/features/timeSeries/components/ScatterplotSidebarConfig.tsx
msgid "Remove all data from the chart?"
msgstr "Remove all data from the chart?"

#: src/features/timeSeries/components/panes/TagConfigurationPane.tsx
#: src/features/timeSeries/components/panes/TagConfigurationPane.tsx
#: src/features/timeSeries/components/SensorScatterplotTableColumns.tsx
msgid "Remove all pens"
msgstr "Remove all pens"

#: src/features/timeSeries/components/panes/TagConfigurationPane.tsx
msgid "Remove all pens?"
msgstr "Remove all pens?"

#: src/features/timeSeries/components/SensorScatterplotTable.tsx
msgid "Remove all sensors from the chart?"
msgstr "Remove all sensors from the chart?"

#: src/features/timeSeries/components/pointTool/PointAnnotationOverlay.tsx
msgid "Remove annotation"
msgstr "Remove annotation"

#: src/features/timeSeries/components/panes/DerivedTagsPane.tsx
msgid "Remove derived tag"
msgstr "Remove derived tag"

#: src/pages/processData/buildMode/components/ModelingTagsPane.tsx
msgid "Remove driver"
msgstr "Remove driver"

#: src/pages/systemView/components/unitsTab/FilterControls.tsx
msgid "Remove filter"
msgstr "Remove filter"

#: src/features/timeSeries/components/LabelsTab.tsx
msgid "Remove from chart"
msgstr "Remove from chart"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/documentsCardView/DocumentResultCard.tsx
#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/recents/FavoriteDocumentCard.tsx
#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/recents/FavoriteDocumentCard.tsx
#: src/features/knowledgeDocumentViewer/components/toolbar/KnowledgeDocumentHeaderBar.tsx
#: src/features/knowledgeDocumentViewer/workOrders/WorkOrderViewer.tsx
#: src/features/knowledgeDocumentViewer/workOrders/WorkOrderViewer.tsx
msgid "Remove from favorites"
msgstr "Remove from favorites"

#: src/features/modelOperations/SubjectDetails.tsx
msgid "Remove from Process Data"
msgstr "Remove from Process Data"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/SearchSuggestionsDropdown.tsx
msgid "Remove from saved"
msgstr "Remove from saved"

#: src/pages/processData/buildMode/components/ModelingTagsPane.tsx
msgid "Remove modeled tag"
msgstr "Remove modeled tag"

#: src/features/lotoReports/components/LotoPageCard.tsx
msgid "Remove page"
msgstr "Remove page"

#: src/features/lotoReports/components/LotoPageCard.tsx
msgid "Remove page {pageId} of {documentName}"
msgstr "Remove page {pageId} of {documentName}"

#: src/features/lotoReports/components/LotoPageCard.tsx
msgid "Remove page {pageNumber} of {documentName}"
msgstr "Remove page {pageNumber} of {documentName}"

#: src/features/timeSeries/components/panes/TagConfigurationList.tsx
#: src/features/timeSeries/components/panes/TagConfigurationList.tsx
#: src/features/timeSeries/components/SensorScatterplotTableColumns.tsx
msgid "Remove pen"
msgstr "Remove pen"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatQueuedMessageRow.tsx
msgid "Remove queued message {position}"
msgstr "Remove queued message {position}"

#: src/features/timeSeries/agentTab/dock/FitTab.tsx
msgid "Remove role {role}"
msgstr "Remove role {role}"

#: src/pages/details/extensions/fde/NavyRepairPlanningExtension.tsx
msgid "Remove scenario"
msgstr "Remove scenario"

#: src/features/fimReview/ReviewActions.tsx
msgid "Remove selected aliases"
msgstr "Remove selected aliases"

#: src/features/timeSeries/components/SentinelsTab.tsx
msgid "Remove sentinel from chart"
msgstr "Remove sentinel from chart"

#: src/features/fimReview/ReviewActions.tsx
msgid "Remove the complete subject ({aliasCountLabel})"
msgstr "Remove the complete subject ({aliasCountLabel})"

#: src/features/timeSeries/agentTab/AgentHeader.tsx
msgid "Remove the residual pen"
msgstr "Remove the residual pen"

#: src/features/timeSeries/agentTab/dock/BacktestTab.tsx
msgid "Remove this event"
msgstr "Remove this event"

#: src/features/timeSeries/agentTab/dock/SettingsTab.tsx
#: src/features/timeSeries/agentTab/dock/SettingsTab.tsx
msgid "Remove this pen the agent added"
msgstr "Remove this pen the agent added"

#: src/features/fim/photos/PhotoLightbox.tsx
msgid "Remove this photo from this Subject (the photo itself is kept)"
msgstr "Remove this photo from this Subject (the photo itself is kept)"

#: src/features/fim/photos/PhotoRemoveButton.tsx
msgid "Remove this photo?"
msgstr "Remove this photo?"

#: src/features/timeSeries/agentTab/dock/WindowsTab.tsx
msgid "Remove this range"
msgstr "Remove this range"

#: src/pages/facilityModel/FacilityModelCatalog.tsx
msgid "Remove this search term"
msgstr "Remove this search term"

#: src/features/richText/components/TaggableUsersCard.tsx
msgid "Remove user"
msgstr "Remove user"

#: src/features/cases/components/SupplementaryLinksActivityContent.tsx
#: src/features/knowledgeDocumentViewer/components/revisionCompare/RevisionStatusLegend.tsx
msgid "Removed"
msgstr "Removed"

#: src/features/timeSeries/experiment/CleaningControls.tsx
msgid "removed {formattedRemovedCount} pts{removedPercentageSuffix}"
msgstr "removed {formattedRemovedCount} pts{removedPercentageSuffix}"

#: src/features/fim/photos/PhotoUploadRow.tsx
msgid "Removing…"
msgstr "Removing…"

#: src/features/chatbot/components/SessionTabs.tsx
#: src/features/embeddedSidebar/chatHistory/AgenticChatHistorySessionOverflowMenu.tsx
#: src/features/embeddedSidebar/chatHistory/AgenticChatHistorySessionOverflowMenu.tsx
#: src/features/knowledgeDocumentViewer/components/toolbar/DocumentTabs.tsx
#: src/pages/details/extensions/flow/filesExt/FileMenuButton.tsx
#: src/pages/processData/components/viewSwitcher/ViewActionDialogs.tsx
#: src/pages/processData/components/viewSwitcher/ViewSwitcher.tsx
msgid "Rename"
msgstr "Rename"

#: src/features/timeSeries/agentTab/chat/ConversationDrawer.tsx
msgid "Rename {title}"
msgstr "Rename {title}"

#: src/pages/systemView/components/SystemViewAnnotationSidebar.tsx
msgid "Rename {whiteboardLabel}"
msgstr "Rename {whiteboardLabel}"

#: src/features/embeddedSidebar/chatHistory/AgenticChatHistorySessionOverflowMenu.tsx
msgid "Rename chat"
msgstr "Rename chat"

#: src/pages/processData/components/ProcessDataTopBar.tsx
#: src/pages/processData/components/ProcessDataTopBar.tsx
#: src/pages/processData/components/viewSwitcher/ManageViewsDialog.tsx
#: src/pages/processData/components/viewSwitcher/ViewActionDialogs.tsx
msgid "Rename view"
msgstr "Rename view"

#: src/features/knowledgeDocumentViewer/workOrders/workOrderSheet.ts
msgid "Rendered from the imported CMMS record."
msgstr "Rendered from the imported CMMS record."

#: src/features/sentinels/components/DesignRunDetails.tsx
msgid "Reopen the design flow at the {stage} stage. Refitting overwrites this run."
msgstr "Reopen the design flow at the {stage} stage. Refitting overwrites this run."

#: src/pages/cases/md/MdCaseDetailsPage.tsx
msgid "Reopen this case before rerunning the analysis."
msgstr "Reopen this case before rerunning the analysis."

#: src/features/lotoReports/components/LotoSortablePoints.tsx
msgid "Reorder {tag}"
msgstr "Reorder {tag}"

#: src/features/lotoReports/components/LotoSortablePoints.tsx
msgid "Reordering cancelled. {tag} is back at position {position} of {count}."
msgstr "Reordering cancelled. {tag} is back at position {position} of {count}."

#: src/designSystem/components/RecordHeader.tsx
#: src/features/forgingsReporting/ReportsTable.tsx
#: src/features/lotoReports/components/LotoReportsTable.tsx
msgid "Report"
msgstr "Report"

#: src/features/nnpp/nnppReportPresentation.ts
msgid "Report date"
msgstr "Report date"

#: src/pages/nnpp/reports/NnppReportDetailPage.tsx
msgid "Report ID"
msgstr "Report ID"

#: src/features/knowledgeDocumentViewer/components/bugReport/DocumentsBugReportButton.tsx
#: src/features/knowledgeDocumentViewer/components/bugReport/DocumentsBugReportButton.tsx
#: src/features/knowledgeDocumentViewer/components/bugReport/DocumentsBugReportButton.tsx
#: src/features/knowledgeDocumentViewer/components/sidebar/FeedbackModal.tsx
#: src/features/knowledgeDocumentViewer/components/sidebar/OcrTableColumns.tsx
#: src/pages/processData/components/helpGuide/HelpGuideDialog.tsx
msgid "Report Issue"
msgstr "Report Issue"

#: src/features/lotoReports/components/LotoNewDraftForm.tsx
#: src/features/lotoReports/components/LotoReportEditorHeader.tsx
#: src/features/lotoReports/components/NewLotoReportDialog.tsx
msgid "Report name"
msgstr "Report name"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
#: src/features/knowledgeDocumentViewer/workOrders/workOrderFields.ts
#: src/features/knowledgeDocumentViewer/workOrders/workOrderPresentation.ts
msgid "Reported"
msgstr "Reported"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
msgid "Reported by"
msgstr "Reported by"

#: src/pages/assetLens/components/tabs/SensorIssuesTab.tsx
msgid "Reported: {reportedAt}"
msgstr "Reported: {reportedAt}"

#: src/features/navbar/navConfig.ts
msgid "Reporting"
msgstr "Reporting"

#: src/features/forgingsReporting/ForgingsReportWorkspace.tsx
#: src/features/navbar/navConfig.ts
msgid "Reports"
msgstr "Reports"

#: src/pages/cases/md/MdCaseDetailsPage.tsx
msgid "Republish"
msgstr "Republish"

#: src/pages/metrics/hooks/useMetricsDataset.ts
msgid "Request failed"
msgstr "Request failed"

#: src/features/knowledgeDocumentViewer/hooks/useInstrumentTimeSeriesData.ts
msgid "Request timeout"
msgstr "Request timeout"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
msgid "Requested line"
msgstr "Requested line"

#: src/features/knowledgeDocumentViewer/workOrders/legacyCmmsRecordPdf.ts
msgid "Requested lines"
msgstr "Requested lines"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
msgid "Requested procurement; not proof of ordering or receipt."
msgstr "Requested procurement; not proof of ordering or receipt."

#: src/pages/site/components/CustomFieldsTableColumns.tsx
#: src/pages/site/forms/customFieldInfoFormFields.ts
msgid "Required"
msgstr "Required"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
#: src/features/knowledgeDocumentViewer/workOrders/legacyCmmsRecordPdf.ts
msgid "Required date"
msgstr "Required date"

#: src/pages/facilityModel/SubjectAssetPanel.tsx
msgid "Required docs"
msgstr "Required docs"

#: src/pages/facilityModel/SubjectAssetPanel.tsx
msgid "Required PI tags"
msgstr "Required PI tags"

#: src/pages/facilityModel/SubjectAssetPanel.tsx
msgid "Required slots still unfilled"
msgstr "Required slots still unfilled"

#: src/features/permissions/components/PermissionsGate.tsx
msgid "Requires any of:"
msgstr "Requires any of:"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
#: src/features/knowledgeDocumentViewer/workOrders/legacyCmmsRecordPdf.ts
msgid "Requisition issue date"
msgstr "Requisition issue date"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
msgid "Requisition term"
msgstr "Requisition term"

#: src/features/knowledgeDocumentViewer/workOrders/legacyCmmsRecordPdf.ts
msgid "Requisition terms"
msgstr "Requisition terms"

#: src/pages/cases/md/MdCaseDetailsMainColumn.tsx
#: src/pages/cases/md/MdCaseDetailsPage.tsx
#: src/pages/cases/md/MdCaseDetailsPage.tsx
msgid "Rerun analysis"
msgstr "Rerun analysis"

#: src/features/chatbot/components/conversationMessage/UserMessage.tsx
msgid "Resend"
msgstr "Resend"

#: src/pages/manageAccess/components/table/UserRowActions.tsx
msgid "Resend Invite"
msgstr "Resend Invite"

#: src/features/copcPointClouds/CopcCoordinateOriginControl.tsx
#: src/features/dataFilter/rangeFilter/RangeSelector.tsx
#: src/features/kestrelViewer/ui/tools/photoreel/adjustments/PhotoAdjustPanel.tsx
msgid "Reset"
msgstr "Reset"

#: src/features/timeSeries/components/panes/TagConfigurationList.tsx
msgid "Reset {value223_39} Y range to auto"
msgstr "Reset {value223_39} Y range to auto"

#: src/features/timeSeries/components/panes/TagConfigurationList.tsx
msgid "Reset {value284_39} Y range to auto"
msgstr "Reset {value284_39} Y range to auto"

#: src/features/timeSeries/agentTab/dock/SettingsTab.tsx
msgid "Reset {value394_45} Y range"
msgstr "Reset {value394_45} Y range"

#: src/features/timeSeries/experiment/ExperimentTab.tsx
msgid "Reset chart to window"
msgstr "Reset chart to window"

#: src/pages/details/extensions/flow/assetModelEditorExt/AssetModelEditorRawJSON.tsx
msgid "Reset Data"
msgstr "Reset Data"

#: src/pages/details/extensions/DetailsPageExtensionsProvider.tsx
msgid "Reset extension"
msgstr "Reset extension"

#: src/pages/facilityModel/FacilityModelFilters.tsx
msgid "Reset filters"
msgstr "Reset filters"

#: src/features/timeSeries/agentTab/dock/SettingsTab.tsx
msgid "Reset this pen’s Y range to auto"
msgstr "Reset this pen’s Y range to auto"

#: src/features/timeSeries/components/XAxisSection.tsx
#: src/features/timeSeries/components/YAxisItem.tsx
msgid "Reset to automatic scaling"
msgstr "Reset to automatic scaling"

#: src/features/richText/components/slashCommandCards/UnitConfigurationModal.tsx
msgid "Reset to Defaults"
msgstr "Reset to Defaults"

#: src/features/timeSeries/components/ActiveTimeRangeSelector.tsx
#: src/features/timeSeries/components/ActiveTimeRangeSelector.tsx
#: src/pages/processData/components/helpGuide/HelpGuideChapters.tsx
msgid "Reset to saved date"
msgstr "Reset to saved date"

#: src/features/timeSeries/experiment/SplitBuilder.tsx
msgid "Reset to window (90 / 10)"
msgstr "Reset to window (90 / 10)"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatInspectionViewer.tsx
#: src/pages/processData/components/helpGuide/HelpGuideChapters.tsx
#: src/pages/processData/components/ProcessDataTopBar.tsx
msgid "Reset view"
msgstr "Reset view"

#: src/features/timeSeries/components/panes/TagConfigurationList.tsx
#: src/features/timeSeries/components/panes/TagConfigurationList.tsx
msgid "Reset Y range to auto"
msgstr "Reset Y range to auto"

#: src/features/knowledgeDocumentViewer/components/viewer/shared/ZoomControls.tsx
#: src/features/knowledgeDocumentViewer/components/viewer/shared/ZoomControls.tsx
msgid "Reset Zoom"
msgstr "Reset Zoom"

#: src/features/timeSeries/agentTab/AgentHeader.tsx
msgid "Residual"
msgstr "Residual"

#: src/pages/processData/buildMode/dock/BandsDockTab.tsx
msgid "Residual band"
msgstr "Residual band"

#: src/features/timeSeries/experiment/DiagnosticsPanel.tsx
msgid "Residual histogram"
msgstr "Residual histogram"

#: src/pages/processData/buildMode/components/ChartOverlayToggles.tsx
#: src/pages/processData/buildMode/components/ChartOverlayToggles.tsx
msgid "Residual lane"
msgstr "Residual lane"

#: src/features/sentinels/components/RecentScorePanel.tsx
msgid "Residuals — "
msgstr "Residuals — "

#: src/pages/processData/components/helpGuide/HelpGuideChapters.tsx
msgid "Resize"
msgstr "Resize"

#: src/features/embeddedSidebar/components/EmbeddedSidebarPagesSplitHandle.tsx
msgid "Resize pages and recent chats"
msgstr "Resize pages and recent chats"

#: src/pages/processData/components/helpGuide/HelpGuideChapters.tsx
msgid "Resizing panes, toggling descriptions, and hiding pens."
msgstr "Resizing panes, toggling descriptions, and hiding pens."

#: src/features/assetVizAdapter/ForecastAssetVizWindow.tsx
#: src/features/assetVizAdapter/forecastAssetVizWindow/ForecastAssetVizWindowSurface.tsx
msgid "Resolution"
msgstr "Resolution"

#: src/pages/nnpp/imports/NnppImportVerificationPage.tsx
msgid "Resolve the import loading error before continuing."
msgstr "Resolve the import loading error before continuing."

#: src/features/mdCases/mdCaseDisplay.ts
#: src/pages/assetLens/components/tabs/AnomalyDashboard.tsx
msgid "Resolved"
msgstr "Resolved"

#: src/features/modelOperations/SubjectDetails.tsx
msgid "Resolved by {tierLabel}"
msgstr "Resolved by {tierLabel}"

#: src/pages/assetLens/components/tabs/AnomalyDashboard.tsx
msgid "Resolved Today"
msgstr "Resolved Today"

#: src/features/knowledgeDocumentViewer/components/viewer/search/DocReferencePreviewCard.tsx
msgid "Resolving “{referenceLabel}”…"
msgstr "Resolving “{referenceLabel}”…"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
#: src/features/knowledgeDocumentViewer/workOrders/workOrderFields.ts
msgid "Respond by"
msgstr "Respond by"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
#: src/features/knowledgeDocumentViewer/workOrders/legacyCmmsRecordPdf.ts
msgid "Response date"
msgstr "Response date"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
#: src/features/knowledgeDocumentViewer/workOrders/workOrderPdf.ts
msgid "Responsibility"
msgstr "Responsibility"

#: src/features/knowledgeDocumentViewer/components/revisionCompare/RevisionComparePane.tsx
#: src/features/timeSeries/agentTab/dock/VersionsTab.tsx
msgid "Restore"
msgstr "Restore"

#: src/features/timeSeries/agentTab/dock/VersionsTab.tsx
msgid "Restore loads the settings; Apply commits them."
msgstr "Restore loads the settings; Apply commits them."

#: src/features/timeSeries/agentTab/dock/VersionsTab.tsx
msgid "Restore loads those settings into the knobs without applying them — you still press Apply, so a rollback is reviewable rather than instant."
msgstr "Restore loads those settings into the knobs without applying them — you still press Apply, so a rollback is reviewable rather than instant."

#: src/features/workbench/WorkbenchDock.tsx
msgid "Restore panel size"
msgstr "Restore panel size"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
#: src/features/knowledgeDocumentViewer/workOrders/legacyCmmsRecordPdf.ts
#: src/features/timeSeries/agentTab/dock/BacktestTab.tsx
#: src/pages/evaluations/metadata/dashboard/components/dataLabeling/DataLabelingDashboardComparisonTable.tsx
#: src/pages/evaluations/metadata/dashboard/components/dataLabeling/DataLabelingDashboardFieldDrilldown.tsx
msgid "Result"
msgstr "Result"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
msgid "Result status"
msgstr "Result status"

#: src/features/timeSeries/components/SentinelsTab.tsx
msgid "Resume"
msgstr "Resume"

#: src/features/fimReview/InspectSources.tsx
msgid "Retired"
msgstr "Retired"

#: src/pages/processData/buildMode/components/BuildPrimaryCta.tsx
msgid "Retrain {methodCount} models"
msgstr "Retrain {methodCount} models"

#: src/pages/processData/buildMode/components/BuildPrimaryCta.tsx
msgid "Retrain model"
msgstr "Retrain model"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/AgenticInlineDocumentResults.tsx
msgid "Retrieved sources"
msgstr "Retrieved sources"

#: src/features/embeddedSidebar/chatHistory/AgenticChatHistorySessionOverflowMenu.tsx
#: src/features/embeddedSidebar/chatHistory/AgenticChatHistorySidebar.tsx
#: src/features/fim/photos/PhotoUploadRow.tsx
#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatMessageActions.tsx
#: src/features/knowledgeDocumentViewer/graph/GraphStatus.tsx
#: src/features/knowledgeDocumentViewer/workOrders/WorkOrderViewer.tsx
#: src/features/lotoReports/components/LotoPrintPreview.tsx
#: src/features/lotoReports/components/LotoSheetEditor.tsx
#: src/pages/cases/md/MdCasesListPage.tsx
#: src/pages/evaluations/metadata/dashboard/components/dataLabeling/DataLabelingDashboardOverview.tsx
#: src/pages/evaluations/metadata/labeling/components/DataLabelingSessionPlaceholder.tsx
#: src/pages/facilityModel/FacilityModelTable.tsx
#: src/pages/facilityModel/FacilityModelTable.tsx
msgid "Retry"
msgstr "Retry"

#: src/features/knowledgeDocumentViewer/components/metadata/EvalPagePending.tsx
msgid "Retry loading page"
msgstr "Retry loading page"

#: src/features/knowledgeDocumentViewer/components/metadata/PageMetadataEvalSection.tsx
msgid "Retry loading pages"
msgstr "Retry loading pages"

#: src/features/knowledgeDocumentViewer/components/sidebar/EvalMetadataSection.tsx
msgid "Retry loading saved edits"
msgstr "Retry loading saved edits"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatMessageActions.tsx
msgid "Retry search"
msgstr "Retry search"

#: src/pages/noMatch/NoMatch.tsx
msgid "Return to the <0>landing page?</0>"
msgstr "Return to the <0>landing page?</0>"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
#: src/features/knowledgeDocumentViewer/workOrders/legacyCmmsRecordPdf.ts
msgid "Returned quantity"
msgstr "Returned quantity"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/documentsTableView/DocumentTableColumns.tsx
msgid "Rev"
msgstr "Rev"

#: src/features/knowledgeDocumentViewer/artifacts/ArtifactPanelHeader.tsx
#: src/features/knowledgeDocumentViewer/components/sidebar/CrossReferencePanel.tsx
msgid "Rev {revision}"
msgstr "Rev {revision}"

#: src/features/knowledgeDocumentViewer/utils/revisionHelpers.ts
msgid "Rev {revisionCode}"
msgstr "Rev {revisionCode}"

#: src/features/knowledgeDocumentViewer/components/revisionCompare/RevisionCompareContent.tsx
#: src/features/knowledgeDocumentViewer/components/revisionCompare/RevisionPairPicker.tsx
msgid "Rev {revisionLabel}"
msgstr "Rev {revisionLabel}"

#: src/features/knowledgeDocumentViewer/utils/revisionHelpers.ts
msgid "Rev unknown"
msgstr "Rev unknown"

#: src/features/knowledgeDocumentViewer/components/sidebar/RelatedDocumentsTable.tsx
msgid "Rev."
msgstr "Rev."

#: src/features/knowledgeDocumentViewer/utils/metadataFieldLabelMessages.ts
msgid "Rev. Date"
msgstr "Rev. Date"

#: src/features/copcPointClouds/CopcViewerOverlay.tsx
#: src/features/copcPointClouds/CopcViewerOverlay.tsx
msgid "Reverse axial direction"
msgstr "Reverse axial direction"

#: src/features/copcPointClouds/CopcViewerOverlay.tsx
#: src/features/copcPointClouds/CopcViewerOverlay.tsx
msgid "Reverse circumferential direction"
msgstr "Reverse circumferential direction"

#: src/features/timeSeries/components/DashboardHeader.tsx
msgid "Revert"
msgstr "Revert"

#: src/features/fimReview/DecisionHistory.tsx
msgid "Revert failed."
msgstr "Revert failed."

#: src/features/fimReview/DecisionHistory.tsx
msgid "Revert no longer active"
msgstr "Revert no longer active"

#: src/features/fimReview/DecisionHistory.tsx
msgid "Revert preview failed."
msgstr "Revert preview failed."

#: src/features/timeSeries/components/panes/TagConfigurationPane.tsx
#: src/features/timeSeries/components/panes/TagConfigurationPane.tsx
msgid "Revert to auto Y-scaling"
msgstr "Revert to auto Y-scaling"

#: src/features/fimReview/DecisionHistory.tsx
msgid "Reverted"
msgstr "Reverted"

#: src/features/fimReview/DecisionHistory.tsx
msgid "Reverted decision"
msgstr "Reverted decision"

#: src/features/fimReview/DecisionHistory.tsx
msgid "Reverting…"
msgstr "Reverting…"

#: src/pages/facilityModel/SubjectAssetPanel.tsx
msgid "Review"
msgstr "Review"

#: src/features/knowledgeDocumentViewer/components/bugReport/BugReportAgentModeField.tsx
msgid "Review and propose"
msgstr "Review and propose"

#: src/features/knowledgeDocumentViewer/components/metadata/RevisionAuditBadge.tsx
msgid "Review revision history"
msgstr "Review revision history"

#: src/pages/facilityModel/SubjectAssetPanel.tsx
msgid "review: "
msgstr "review: "

#: src/pages/evaluations/metadata/dashboard/components/DashboardComparisonRows.tsx
msgid "Reviewer coverage of labeler pages"
msgstr "Reviewer coverage of labeler pages"

#: src/pages/evaluations/metadata/dashboard/components/DashboardComparisonRows.tsx
msgid "Reviewers vs labelers"
msgstr "Reviewers vs labelers"

#: src/pages/evaluations/metadata/components/MetricsContent.tsx
#: src/pages/evaluations/metadata/dashboard/components/DashboardComparisonRows.tsx
msgid "Reviewers vs pipeline"
msgstr "Reviewers vs pipeline"

#: src/features/knowledgeDocumentViewer/utils/metadataFieldLabelMessages.ts
#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
#: src/features/knowledgeDocumentViewer/workOrders/legacyCmmsRecordPdf.ts
msgid "Revision"
msgstr "Revision"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatRevisionDiffCard.tsx
msgid "Revision {from} to {to}"
msgstr "Revision {from} to {to}"

#: src/features/knowledgeDocumentViewer/components/metadata/RevisionFamilyCard.tsx
#: src/features/knowledgeDocumentViewer/components/toolbar/DocumentHeaderTitle.tsx
msgid "Revision {revisionCode}"
msgstr "Revision {revisionCode}"

#: src/features/knowledgeDocumentViewer/components/toolbar/DocumentHeaderTitle.tsx
msgid "Revision {revisionCode} ({revisionDate})"
msgstr "Revision {revisionCode} ({revisionDate})"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatRevisionDiffCard.tsx
msgid "Revision {to}"
msgstr "Revision {to}"

#: src/pages/evaluations/metadata/labeling/utils/pageClassificationTaxonomy.ts
msgid "Revision and change history"
msgstr "Revision and change history"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatRevisionMissingCard.tsx
msgid "Revision audit"
msgstr "Revision audit"

#: src/features/knowledgeDocumentViewer/components/metadata/RevisionAuditBadge.tsx
msgid "Revision audit needs review"
msgstr "Revision audit needs review"

#: src/features/knowledgeDocumentViewer/components/revisionCompare/RevisionChangeCitations.tsx
msgid "Revision cloud"
msgstr "Revision cloud"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/documentPreview/PreviewDocumentDetailsSection.tsx
#: src/features/knowledgeDocumentViewer/utils/metadataFieldLabelMessages.ts
msgid "Revision Code"
msgstr "Revision Code"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/documentPreview/PreviewDocumentDetailsSection.tsx
#: src/features/knowledgeDocumentViewer/utils/metadataFieldLabelMessages.ts
msgid "Revision Date"
msgstr "Revision Date"

#: src/features/knowledgeDocumentViewer/components/metadata/RevisionAuditBadge.tsx
msgid "Revision history"
msgstr "Revision history"

#: src/features/knowledgeDocumentViewer/components/metadata/RevisionAuditBadge.tsx
msgid "Revision history couldn’t be computed."
msgstr "Revision history couldn’t be computed."

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/documentsCardView/DocumentResultCard.tsx
msgid "Revision stacking failed: duplicate titles or dates"
msgstr "Revision stacking failed: duplicate titles or dates"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/documentsCardView/DocumentResultCard.tsx
msgid "Revision stacking failed:<0/>duplicate titles or dates"
msgstr "Revision stacking failed:<0/>duplicate titles or dates"

#: src/features/knowledgeDocumentViewer/components/metadata/RevisionFamilyCard.tsx
msgid "Revision unknown"
msgstr "Revision unknown"

#: src/features/knowledgeDocumentViewer/utils/metadataFieldLabelMessages.ts
msgid "Revision-controlled Drawing"
msgstr "Revision-controlled Drawing"

#: src/features/knowledgeDocumentViewer/components/metadata/RevisionFamilyList.tsx
msgid "Revisions ({memberCount})"
msgstr "Revisions ({memberCount})"

#: src/features/knowledgeDocumentViewer/components/metadata/RevisionFamilyDropdown.tsx
msgid "Revisions ({revisionCount})"
msgstr "Revisions ({revisionCount})"

#: src/pages/manageAccess/components/dialogs/RevokeUserAccessDialog.tsx
#: src/pages/manageAccess/components/table/UserRowActions.tsx
msgid "Revoke access"
msgstr "Revoke access"

#: src/pages/manageAccess/components/dialogs/RevokeUserAccessDialog.tsx
msgid "Revoke access for {userName}?"
msgstr "Revoke access for {userName}?"

#: src/pages/manageAccess/hooks/useListedRoster.ts
msgid "Revoke access from an organization or site view."
msgstr "Revoke access from an organization or site view."

#: src/pages/manageAccess/hooks/useListedRoster.ts
msgid "Revoking access…"
msgstr "Revoking access…"

#: src/features/copcPointClouds/CopcOrientationCube.tsx
msgid "Right"
msgstr "Right"

#: src/features/timeSeries/experiment/TransparencyStrip.tsx
msgid "Right now Val = 0 rows → band calibration will use spread blocks inside Train (prod behavior)."
msgstr "Right now Val = 0 rows → band calibration will use spread blocks inside Train (prod behavior)."

#: src/features/workbench/LayoutToggles.tsx
msgid "right panel"
msgstr "right panel"

#: src/pages/processData/components/helpGuide/HelpGuideChapters.tsx
msgid "Right-drag"
msgstr "Right-drag"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
msgid "risk"
msgstr "risk"

#: src/pages/systemView/components/unitsTab/FilterControls.tsx
msgid "Risk"
msgstr "Risk"

#: src/pages/overview/sidebar/assetTracker/SiteViewAssetCountBreakdownLabels.tsx
#: src/pages/overview/sidebar/healthConditionFilter/SiteViewHealthConditionFilter.tsx
msgid "Risk Category"
msgstr "Risk Category"

#: src/pages/systemView/components/unitsTab/FilterControls.tsx
msgid "Risk Level"
msgstr "Risk Level"

#: src/features/timeSeries/experiment/knobCopy.ts
msgid "RNG seed for MLP init / early-stopping split. Same seed + data → more repeatable fits."
msgstr "RNG seed for MLP init / early-stopping split. Same seed + data → more repeatable fits."

#: src/pages/assetLens/components/tabs/imagesTabComponents/ImageUploadModal.tsx
msgid "Robotic Inspection"
msgstr "Robotic Inspection"

#: src/pages/assetLens/components/tabs/imagesTabComponents/ImageMetadata.tsx
msgid "Robotic Scan"
msgstr "Robotic Scan"

#: src/features/timeSeries/agentTab/dock/TargetTab.tsx
msgid "robust sigma"
msgstr "robust sigma"

#: src/features/mdCases/mdCaseDisplay.ts
#: src/features/mdCases/mdCaseDisplay.ts
msgid "ROC Only"
msgstr "ROC Only"

#: src/features/timeSeries/experiment/DiagnosticsPanel.tsx
msgid "Role"
msgstr "Role"

#: src/features/timeSeries/agentTab/dock/FitTab.tsx
msgid "Role → tag"
msgstr "Role → tag"

#: src/pages/processData/buildMode/dock/SplitChunksTable.tsx
msgid "Role for {value53_42}"
msgstr "Role for {value53_42}"

#: src/features/timeSeries/components/PenTransformControls.tsx
msgid "Rolling average"
msgstr "Rolling average"

#: src/features/timeSeries/components/PenTransformControls.tsx
msgid "Rolling average for this pen"
msgstr "Rolling average for this pen"

#: src/features/timeSeries/experiment/CleaningControls.tsx
msgid "Rolling median/mean over surviving points (experiment-only; does not remove points)."
msgstr "Rolling median/mean over surviving points (experiment-only; does not remove points)."

#: src/features/timeSeries/components/PenTransformControls.tsx
#: src/features/timeSeries/experiment/ModelKnobs.tsx
#: src/pages/processData/buildMode/dock/EngineeringSection.tsx
msgid "Rolling window"
msgstr "Rolling window"

#: src/pages/processData/buildMode/dock/EngineeringSection.tsx
msgid "Rolling window (periods)"
msgstr "Rolling window (periods)"

#: src/features/powerCustomerUploads/state/powerCustomerUploadRowUpdates.ts
msgid "Rolodex system doc"
msgstr "Rolodex system doc"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
#: src/features/knowledgeDocumentViewer/workOrders/workOrderFields.ts
msgid "Route"
msgstr "Route"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
#: src/features/knowledgeDocumentViewer/workOrders/workOrderFields.ts
msgid "Route stop"
msgstr "Route stop"

#: src/features/timeSeries/agentTab/dock/TargetTab.tsx
msgid "row-level noise"
msgstr "row-level noise"

#: src/features/timeSeries/experiment/DiagnosticsPanel.tsx
msgid "Rows"
msgstr "Rows"

#: src/features/powerCustomerUploads/components/PowerCustomerUploadReviewTablePagination.tsx
msgid "Rows per page"
msgstr "Rows per page"

#: src/features/timeSeries/agentTab/dock/TargetTab.tsx
msgid "Rows the gate rejects are neither learned from nor graded. Use it for at-load and steady-state, not to hide periods you dislike — that is what the excluded ranges below are for."
msgstr "Rows the gate rejects are neither learned from nor graded. Use it for at-load and steady-state, not to hide periods you dislike — that is what the excluded ranges below are for."

#: src/pages/processData/components/helpGuide/HelpGuideChapters.tsx
msgid "Ruler"
msgstr "Ruler"

#: src/features/timeSeries/experiment/RunComparison.tsx
#: src/features/timeSeries/sentinelStudio/SentinelBuilderPanel.tsx
#: src/features/timeSeries/sentinelStudio/SentinelBuilderPanel.tsx
msgid "Run"
msgstr "Run"

#: src/features/fimReview/IdentityPanel.tsx
msgid "run {run}"
msgstr "run {run}"

#: src/features/timeSeries/experiment/runPersistence.ts
msgid "Run {runNumber}"
msgstr "Run {runNumber}"

#: src/features/timeSeries/experiment/ExperimentTab.tsx
msgid "Run {value301_24}"
msgstr "Run {value301_24}"

#: src/pages/processData/buildMode/hooks/useBuildSession.ts
msgid "Run {value57_24}"
msgstr "Run {value57_24}"

#: src/pages/processData/buildMode/dock/BacktestDockTab.tsx
msgid "Run a backtest — flagged points and episodes per method land here."
msgstr "Run a backtest — flagged points and episodes per method land here."

#: src/features/timeSeries/experiment/SplitBuilder.tsx
msgid "run a preview"
msgstr "run a preview"

#: src/pages/processData/buildMode/dock/BacktestDockTab.tsx
msgid "Run backtest"
msgstr "Run backtest"

#: src/pages/processData/buildMode/dock/EvalsDockTab.tsx
msgid "Run detection eval"
msgstr "Run detection eval"

#: src/features/sentinels/components/DesignRunOverviewSections.tsx
msgid "Run id"
msgstr "Run id"

#: src/features/sentinels/components/RecentScorePanel.tsx
msgid "Run now"
msgstr "Run now"

#: src/features/sentinels/components/DesignRunOverviewSections.tsx
msgid "Run provenance"
msgstr "Run provenance"

#: src/features/sentinels/components/CasesPanel.tsx
msgid "Run RCA"
msgstr "Run RCA"

#: src/features/fimReview/SubjectDiagnostics.tsx
msgid "rung {rung}"
msgstr "rung {rung}"

#: src/features/facilityModel/views.ts
msgid "Running"
msgstr "Running"

#: src/features/timeSeries/agentTab/toolSentence.ts
msgid "Running {readable}"
msgstr "Running {readable}"

#: src/features/sentinels/components/CasesPanel.tsx
#: src/features/timeSeries/agentTab/dock/BacktestTab.tsx
msgid "Running…"
msgstr "Running…"

#: src/features/assetLifecycleV2/views/observations/LtaObservationCompositeViz.tsx
msgid "S Extent"
msgstr "S Extent"

#: src/pages/evaluations/metadata/labeling/utils/pageClassificationTaxonomy.ts
msgid "Safety and work practices"
msgstr "Safety and work practices"

#: src/pages/site/forms/siteInfoFormFields.ts
msgid "Salesforce Account"
msgstr "Salesforce Account"

#: src/features/fimReview/ReviewActions.tsx
msgid "Same as another subject"
msgstr "Same as another subject"

#: src/features/lotoReports/components/LotoSheetHeaderFields.tsx
msgid "Same as page 1. Changes apply to every page."
msgstr "Same as page 1. Changes apply to every page."

#: src/features/timeSeries/experiment/RunComparison.tsx
msgid "same knobs"
msgstr "same knobs"

#: src/features/timeSeries/agentTab/dock/TargetTab.tsx
msgid "sampled every"
msgstr "sampled every"

#: src/pages/processData/buildMode/dock/SamplingSection.tsx
#: src/pages/processData/buildMode/dock/SamplingSection.tsx
msgid "Sampling"
msgstr "Sampling"

#: src/features/timeSeries/experiment/SamplingKnobs.tsx
#: src/pages/processData/buildMode/dock/SamplingSection.tsx
msgid "Sampling mode"
msgstr "Sampling mode"

#: src/features/timeSeries/experiment/TransparencyStrip.tsx
msgid "Sampling: aggregate {value146_34} @ {value146_71} {unit} · gap_fill={value146_103}"
msgstr "Sampling: aggregate {value146_34} @ {value146_71} {unit} · gap_fill={value146_103}"

#: src/features/timeSeries/experiment/TransparencyStrip.tsx
msgid "Sampling: RAW historian points, outer-joined on exact timestamps (no mean binning)."
msgstr "Sampling: RAW historian points, outer-joined on exact timestamps (no mean binning)."

#: src/components/NamePromptModal.tsx
#: src/features/dataFilter/rangeFilter/RangeSelector.tsx
#: src/features/forecastNotifications/NotificationPreferencesModal.tsx
#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatQueuedMessageRow.tsx
#: src/features/lotoReports/components/LotoReportEditorHeader.tsx
#: src/features/lotoReports/components/LotoSelectedReport.tsx
#: src/features/sentinels/components/MonitorTab.tsx
#: src/features/timeSeries/components/chartActions/ChartSaveAction.tsx
#: src/features/timeSeries/components/DashboardHeader.tsx
#: src/features/timeSeries/components/labelTool/LabelConfigPanel.tsx
#: src/features/timeSeries/components/panes/TagSearchDialog.tsx
#: src/features/timeSeries/experiment/ExperimentTab.tsx
#: src/pages/manageAccess/components/dialogs/SiteAccessDialog.tsx
msgid "Save"
msgstr "Save"

#: src/features/chatbot/components/conversationMessage/UserMessage.tsx
msgid "Save & Resend"
msgstr "Save & Resend"

#: src/features/knowledgeDocumentViewer/components/metadata/DocumentMetadataEditSection.tsx
#: src/features/knowledgeDocumentViewer/components/metadata/PageMetadataEditSection.tsx
msgid "Save all {familySize} revisions"
msgstr "Save all {familySize} revisions"

#: src/features/lotoReports/components/LotoLeaveDialog.tsx
msgid "Save and continue"
msgstr "Save and continue"

#: src/pages/processData/components/helpGuide/HelpGuideChapters.tsx
msgid "Save and Manage Views"
msgstr "Save and Manage Views"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatMessageActions.tsx
msgid "Save as eval case"
msgstr "Save as eval case"

#: src/features/lotoReports/components/LotoProposalCard.tsx
msgid "Save as LOTO report"
msgstr "Save as LOTO report"

#: src/features/timeSeries/experiment/ExperimentTab.tsx
#: src/pages/processData/buildMode/rightPanel/CurrentModelPane.tsx
msgid "Save as new"
msgstr "Save as new"

#: src/features/fim/photos/PhotoLightbox.tsx
msgid "Save caption"
msgstr "Save caption"

#: src/features/fimReview/ReviewActions.tsx
msgid "Save changes"
msgstr "Save changes"

#: src/features/richText/components/slashCommandCards/UnitConfigurationModal.tsx
msgid "Save Changes"
msgstr "Save Changes"

#: src/features/lotoReports/components/LotoLeaveDialog.tsx
msgid "Save changes to {name}?"
msgstr "Save changes to {name}?"

#: src/features/timeSeries/components/DashboardHeader.tsx
msgid "Save chart"
msgstr "Save chart"

#: src/pages/processData/buildMode/rightPanel/CurrentModelPane.tsx
msgid "Save config only"
msgstr "Save config only"

#: src/features/timeSeries/components/ThresholdConfigurationModal.tsx
msgid "Save Configurations"
msgstr "Save Configurations"

#: src/features/richText/components/slashCommandCards/UnitConfigurationModal.tsx
msgid "Save current settings"
msgstr "Save current settings"

#: src/pages/site/components/CustomFieldInfoModal.tsx
msgid "Save Custom Field"
msgstr "Save Custom Field"

#: src/features/knowledgeDocumentViewer/components/metadata/DocumentMetadataEditSection.tsx
msgid "Save document data"
msgstr "Save document data"

#: src/features/knowledgeDocumentViewer/components/metadata/DocumentMetadataEditSection.tsx
msgid "Save document metadata"
msgstr "Save document metadata"

#: src/pages/cases/md/MdCaseDetailsMainColumn.tsx
msgid "Save Draft"
msgstr "Save Draft"

#: src/pages/cases/md/MdCaseDetailsPage.tsx
msgid "Save Draft + Publish"
msgstr "Save Draft + Publish"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatEvalCaseReview.tsx
msgid "Save eval case"
msgstr "Save eval case"

#: src/pages/cases/components/CaseFeedbackModal.tsx
msgid "Save Feedback"
msgstr "Save Feedback"

#: src/features/timeSeries/agentTab/dock/SaveModelBar.tsx
msgid "Save model"
msgstr "Save model"

#: src/features/timeSeries/agentTab/chat/ConversationDrawer.tsx
#: src/pages/systemView/components/SystemViewAnnotationSidebar.tsx
msgid "Save name"
msgstr "Save name"

#: src/pages/cases/md/MdCaseDetailsMainColumn.tsx
msgid "Save Notes"
msgstr "Save Notes"

#: src/pages/nnpp/imports/NnppImportVerificationPage.tsx
msgid "Save or discard your field changes to continue."
msgstr "Save or discard your field changes to continue."

#: src/features/knowledgeDocumentViewer/components/metadata/PageMetadataEditSection.tsx
msgid "Save page data"
msgstr "Save page data"

#: src/features/knowledgeDocumentViewer/components/metadata/PageMetadataEditSection.tsx
msgid "Save page metadata"
msgstr "Save page metadata"

#: src/features/timeSeries/agentTab/dock/AlertingTab.tsx
msgid "Save rule"
msgstr "Save rule"

#: src/features/timeSeries/agentTab/dock/SaveModelBar.tsx
msgid "Save this model so it can be edited, alerted on and backtested"
msgstr "Save this model so it can be edited, alerted on and backtested"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/SearchSuggestionsDropdown.tsx
msgid "Save this search"
msgstr "Save this search"

#: src/pages/cases/md/MdCaseDetailsMainColumn.tsx
msgid "Save Title"
msgstr "Save Title"

#: src/pages/processData/buildMode/rightPanel/CurrentModelPane.tsx
msgid "Save trained model"
msgstr "Save trained model"

#: src/features/timeSeries/components/chartActions/ChartSaveAction.tsx
#: src/features/timeSeries/components/chartActions/ChartSaveAction.tsx
#: src/features/timeSeries/components/chartActions/ChartSaveAction.tsx
#: src/pages/processData/components/helpGuide/HelpGuideChapters.tsx
msgid "Save view"
msgstr "Save view"

#: src/pages/processData/components/helpGuide/HelpGuideChapters.tsx
msgid "Save Views"
msgstr "Save Views"

#: src/features/timeSeries/agentTab/dock/VersionsTab.tsx
msgid "saved"
msgstr "saved"

#: src/features/sentinels/components/MonitorTab.tsx
#: src/features/timeSeries/experiment/ExperimentTab.tsx
msgid "Saved"
msgstr "Saved"

#: src/features/timeSeries/experiment/ExperimentTab.tsx
msgid "Saved ({value331_22})"
msgstr "Saved ({value331_22})"

#: src/pages/processData/buildMode/hooks/useSaveExperiment.ts
msgid "Saved ({value53_24})"
msgstr "Saved ({value53_24})"

#: src/features/timeSeries/utils/timeUtils.ts
msgid "Saved {diffDays}d ago"
msgstr "Saved {diffDays}d ago"

#: src/features/timeSeries/utils/timeUtils.ts
msgid "Saved {diffHours}h ago"
msgstr "Saved {diffHours}h ago"

#: src/features/timeSeries/utils/timeUtils.ts
msgid "Saved {diffMinutes}m ago"
msgstr "Saved {diffMinutes}m ago"

#: src/features/timeSeries/utils/timeUtils.ts
msgid "Saved {diffMonths}mo ago"
msgstr "Saved {diffMonths}mo ago"

#: src/features/timeSeries/utils/timeUtils.ts
msgid "Saved {diffWeeks}w ago"
msgstr "Saved {diffWeeks}w ago"

#: src/features/timeSeries/utils/timeUtils.ts
msgid "Saved {diffYears}y ago"
msgstr "Saved {diffYears}y ago"

#: src/pages/processData/buildMode/hooks/useSaveExperiment.ts
msgid "Saved {value55_25} with model weights"
msgstr "Saved {value55_25} with model weights"

#: src/pages/processData/buildMode/hooks/useSaveExperiment.ts
msgid "Saved {value56_25}"
msgstr "Saved {value56_25}"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/SearchSuggestionsDropdown.tsx
msgid "Saved & recent searches"
msgstr "Saved & recent searches"

#: src/features/timeSeries/components/timeSeriesScatterplot/MdDraftAlertCaseFlowPanels.tsx
msgid "Saved alert"
msgstr "Saved alert"

#: src/features/timeSeries/experiment/ExperimentTab.tsx
msgid "Saved as {value332_24}"
msgstr "Saved as {value332_24}"

#: src/features/lotoReports/components/LotoProposalCard.tsx
msgid "Saved as a LOTO report."
msgstr "Saved as a LOTO report."

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatMessageActions.tsx
msgid "Saved as eval case"
msgstr "Saved as eval case"

#: src/features/timeSeries/experiment/ExperimentTab.tsx
msgid "Saved experiments"
msgstr "Saved experiments"

#: src/features/timeSeries/utils/timeUtils.ts
msgid "Saved just now"
msgstr "Saved just now"

#: src/pages/processData/buildMode/dock/BacktestDockTab.tsx
msgid "Saved model"
msgstr "Saved model"

#: src/pages/processData/buildMode/dock/EvalsDockTab.tsx
msgid "Saved model to evaluate"
msgstr "Saved model to evaluate"

#: src/pages/processData/buildMode/rightPanel/SavedModelsPane.tsx
msgid "Saved models"
msgstr "Saved models"

#: src/features/timeSeries/sentinelStudio/SentinelBuilderPanel.tsx
msgid "Saved on the context bundle, so this plan survives a reload"
msgstr "Saved on the context bundle, so this plan survives a reload"

#: src/features/timeSeries/agentTab/modelSeries.ts
msgid "Saved output of agent model {entryId}"
msgstr "Saved output of agent model {entryId}"

#: src/features/timeSeries/experiment/runPersistence.ts
msgid "Saved run"
msgstr "Saved run"

#: src/features/timeSeries/agentTab/toolSentence.ts
msgid "Saved the model"
msgstr "Saved the model"

#: src/features/timeSeries/agentTab/toolSentence.ts
msgid "Saved the model as {name}"
msgstr "Saved the model as {name}"

#: src/features/knowledgeDocumentViewer/contexts/DocumentTabDataContext.tsx
msgid "Saved to Rolodex"
msgstr "Saved to Rolodex"

#: src/pages/processData/buildMode/rightPanel/SavedModelShelf.tsx
msgid "Saved with model weights"
msgstr "Saved with model weights"

#: src/pages/processData/buildMode/rightPanel/PromoteModelAction.tsx
msgid "Saved without model weights — save with “Save trained model” first"
msgstr "Saved without model weights — save with “Save trained model” first"

#: src/pages/processData/components/helpGuide/HelpGuideChapters.tsx
msgid "Saving a view, then loading it from the switcher."
msgstr "Saving a view, then loading it from the switcher."

#: src/pages/manageAccess/hooks/useListedRoster.ts
msgid "Saving access…"
msgstr "Saving access…"

#: src/features/timeSeries/agentTab/dock/SaveModelBar.tsx
msgid "Saving and re-running the fit…"
msgstr "Saving and re-running the fit…"

#: src/pages/cases/md/MdCaseDetailsPage.tsx
msgid "Saving Draft..."
msgstr "Saving Draft..."

#: src/features/timeSeries/agentTab/dock/SaveModelBar.tsx
msgid "Saving re-runs the fit on the server, so the saved model is reproducible from its parameters — then Alerting and Backtest open up."
msgstr "Saving re-runs the fit on the server, so the saved model is reproducible from its parameters — then Alerting and Backtest open up."

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatCollapsibleThoughts.tsx
msgid "Saving response..."
msgstr "Saving response..."

#: src/pages/cases/md/MdCaseDetailsPage.tsx
msgid "Saving the current recommendation draft before publish."
msgstr "Saving the current recommendation draft before publish."

#: src/features/timeSeries/agentTab/toolSentence.ts
msgid "Saving the model"
msgstr "Saving the model"

#: src/features/timeSeries/agentTab/toolSentence.ts
msgid "Saving the model as {name}"
msgstr "Saving the model as {name}"

#: src/features/knowledgeDocumentViewer/components/metadata/DocumentMetadataEditSection.tsx
msgid "Saving these edits confirms that all document information is correct."
msgstr "Saving these edits confirms that all document information is correct."

#: src/features/knowledgeDocumentViewer/components/metadata/PageMetadataEditSection.tsx
msgid "Saving these edits confirms that all page information is correct."
msgstr "Saving these edits confirms that all page information is correct."

#: src/pages/manageAccess/hooks/useListedRoster.ts
msgid "Saving user type…"
msgstr "Saving user type…"

#: src/features/forecastNotifications/NotificationPreferencesModal.tsx
#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatEvalCaseReview.tsx
#: src/pages/cases/components/CaseFeedbackModal.tsx
#: src/pages/cases/components/CaseMetadataForm.tsx
#: src/pages/cases/components/EditableCaseTitle.tsx
#: src/pages/cases/components/EditableCaseTitle.tsx
msgid "Saving..."
msgstr "Saving..."

#: src/features/fimReview/ReviewActions.tsx
#: src/features/knowledgeDocumentViewer/components/metadata/MetadataEditFormChrome.tsx
#: src/features/knowledgeDocumentViewer/components/metadata/PageMetadataEvalChrome.tsx
#: src/features/lotoReports/components/LotoLeaveDialog.tsx
#: src/features/lotoReports/components/LotoProposalCard.tsx
#: src/features/lotoReports/components/LotoReportEditorHeader.tsx
#: src/features/lotoReports/components/LotoSaveStatusText.tsx
#: src/features/sentinels/components/MonitorTab.tsx
#: src/features/timeSeries/agentTab/dock/AlertingTab.tsx
#: src/features/timeSeries/experiment/ExperimentTab.tsx
#: src/pages/nnpp/imports/NnppImportVerificationPage.tsx
#: src/pages/processData/buildMode/rightPanel/CurrentModelPane.tsx
msgid "Saving…"
msgstr "Saving…"

#: src/features/timeSeries/experiment/NormalizationViewer.tsx
msgid "scale={value123_51}"
msgstr "scale={value123_51}"

#: src/pages/assetLens/components/tabs/imagesTabComponents/ImageComparisonView.tsx
msgid "Scan from {imageDate}"
msgstr "Scan from {imageDate}"

#: src/features/timeSeries/components/ScatterplotSidebarDefault.tsx
#: src/features/timeSeries/components/YScaleControls.tsx
#: src/pages/processData/components/helpGuide/HelpGuideChapters.tsx
msgid "Scatter"
msgstr "Scatter"

#: src/pages/processData/components/helpGuide/HelpGuideChapters.tsx
msgid "Scatter and line, y-scales, and pen colors."
msgstr "Scatter and line, y-scales, and pen colors."

#: src/features/timeSeries/agentTab/dock/TargetTab.tsx
msgid "Scatter of the gap over the last {healthWindowDays} days, as a multiple of the baseline band. Past 2× the plant has left the regime the band describes: refit before reading the sigma."
msgstr "Scatter of the gap over the last {healthWindowDays} days, as a multiple of the baseline band. Past 2× the plant has left the regime the band describes: refit before reading the sigma."

#: src/pages/assetLens/components/tabs/canvas/TimeSeriesWorkflow.tsx
msgid "Scatterplot"
msgstr "Scatterplot"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
#: src/features/knowledgeDocumentViewer/workOrders/workOrderPdf.ts
msgid "Schedule"
msgstr "Schedule"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
#: src/features/knowledgeDocumentViewer/workOrders/workOrderFields.ts
msgid "Scheduled finish"
msgstr "Scheduled finish"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
#: src/features/knowledgeDocumentViewer/workOrders/workOrderFields.ts
msgid "Scheduled start"
msgstr "Scheduled start"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
msgid "Scheduled work; not evidence of execution."
msgstr "Scheduled work; not evidence of execution."

#: src/features/sentinels/components/DesignRunOverviewSections.tsx
msgid "schema v"
msgstr "schema v"

#: src/features/mdCases/components/ProvenanceContentViewer.tsx
#: src/pages/manageAccess/components/scope/SiteSelect.tsx
msgid "Scope"
msgstr "Scope"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatInspectionCard.tsx
msgid "Scope and calculation details"
msgstr "Scope and calculation details"

#: src/features/timeSeries/components/labelTool/LabelConfigPanel.tsx
msgid "Scoped by this label but not on the chart"
msgstr "Scoped by this label but not on the chart"

#: src/features/chatbot/components/ChatbotContent.tsx
msgid "Scoped to <0>{pinnedScopeName}</0>"
msgstr "Scoped to <0>{pinnedScopeName}</0>"

#: src/features/chatbot/components/ChatbotContent.tsx
msgid "Scoped to case {pinnedCaseId}"
msgstr "Scoped to case {pinnedCaseId}"

#: src/features/chatbot/components/ChatbotContent.tsx
msgid "Scoped to case: {pinnedCaseTitle}"
msgstr "Scoped to case: {pinnedCaseTitle}"

#: src/features/timeSeries/experiment/ModelKnobs.tsx
msgid "Score complete rows only"
msgstr "Score complete rows only"

#: src/features/sentinels/hooks/useScoreRecent.ts
#: src/features/timeSeries/hooks/useSentinelScores.ts
msgid "scoring failed"
msgstr "scoring failed"

#: src/features/timeSeries/components/SentinelsTab.tsx
msgid "Scoring failed: "
msgstr "Scoring failed: "

#: src/pages/processData/buildMode/dock/BacktestDockTab.tsx
msgid "Scoring is capped at "
msgstr "Scoring is capped at "

#: src/features/sentinels/components/RecentScorePanel.tsx
#: src/pages/processData/buildMode/dock/BacktestDockTab.tsx
#: src/pages/processData/buildMode/dock/EvalsDockTab.tsx
msgid "Scoring…"
msgstr "Scoring…"

#: src/features/knowledgeDocumentViewer/components/bugReport/BugReportScreenshots.tsx
msgid "Screenshot: {filename}"
msgstr "Screenshot: {filename}"

#: src/features/knowledgeDocumentViewer/components/bugReport/BugReportScreenshots.tsx
#: src/features/knowledgeDocumentViewer/components/bugReport/BugReportScreenshots.tsx
msgid "Screenshots"
msgstr "Screenshots"

#: src/components/SearchBar.tsx
#: src/features/embeddedSidebar/components/SidebarSearchMenuRow.tsx
#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/SearchToolbar.tsx
#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/SearchToolbar.tsx
#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/SearchToolbar.tsx
#: src/features/knowledgeDocumentViewer/components/table/enhancements/TableTopBar.tsx
#: src/features/knowledgeDocumentViewer/components/table/enhancements/TableTopBar.tsx
msgid "Search"
msgstr "Search"

#: src/features/knowledgeDocumentViewer/components/table/cells/HeaderCell.tsx
#: src/features/knowledgeDocumentViewer/components/table/enhancements/filters/ComboboxFilter.tsx
msgid "Search {columnHeaderLower}..."
msgstr "Search {columnHeaderLower}..."

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/documentsCardView/documentCardFilterBar/MultiSelectFilterField.tsx
msgid "Search {searchPlaceholderLabel}..."
msgstr "Search {searchPlaceholderLabel}..."

#: src/features/knowledgeDocumentViewer/components/table/enhancements/TableTopBar.tsx
msgid "Search {tableName}"
msgstr "Search {tableName}"

#: src/pages/cases/components/RelatedObjectsSection.tsx
msgid "Search {title}"
msgstr "Search {title}"

#: src/features/navbar/MidSection.tsx
msgid "Search apps..."
msgstr "Search apps..."

#: src/features/timeSeries/components/AllTagsTab.tsx
#: src/features/timeSeries/components/panes/TagSearchDialog.tsx
msgid "Search by description..."
msgstr "Search by description..."

#: src/pages/systemView/components/unitsTab/FilterControls.tsx
msgid "Search by name or asset type..."
msgstr "Search by name or asset type..."

#: src/pages/manageAccess/components/table/UserSearchInput.tsx
msgid "Search by name or email"
msgstr "Search by name or email"

#: src/pages/facilityModel/FacilityModelCatalog.tsx
msgid "Search by name, alias, or type..."
msgstr "Search by name, alias, or type..."

#: src/features/timeSeries/components/AllTagsTab.tsx
#: src/features/timeSeries/components/panes/TagSearchDialog.tsx
msgid "Search by tag name..."
msgstr "Search by tag name..."

#: src/features/embeddedSidebar/components/SidebarNewChatButton.tsx
#: src/features/embeddedSidebar/components/SidebarSearchMenuRow.tsx
msgid "Search Cantilever ({COMMAND_PALETTE_SHORTCUT_LABEL})"
msgstr "Search Cantilever ({COMMAND_PALETTE_SHORTCUT_LABEL})"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatSearchBox.tsx
#: src/pages/assetLens/components/tabs/DocumentsTab.tsx
msgid "Search documents"
msgstr "Search documents"

#: src/pages/assetLens/components/tabs/DocumentsTab.tsx
msgid "Search documents by title or description"
msgstr "Search documents by title or description"

#: src/features/chatbot/components/DocumentAttachmentPopover.tsx
#: src/features/knowledgeDocumentViewer/components/advancedSearch/utils/constants.ts
msgid "Search documents..."
msgstr "Search documents..."

#: src/features/knowledgeDocumentViewer/components/advancedSearch/utils/docChatText.ts
msgid "Search failed. Try again."
msgstr "Search failed. Try again."

#: src/pages/cases/components/RelatedObjectsSection.tsx
msgid "Search for {lowerCaseTitle}..."
msgstr "Search for {lowerCaseTitle}..."

#: src/designSystem/components/Command.tsx
msgid "Search for a command to run..."
msgstr "Search for a command to run..."

#: src/features/knowledgeDocumentViewer/components/sidebar/CrossReferencePanel.tsx
#: src/features/knowledgeDocumentViewer/components/sidebar/CrossReferencePanel.tsx
msgid "Search for..."
msgstr "Search for..."

#: src/pages/assetLens/components/tabs/DocumentsTab.tsx
msgid "Search in {title}"
msgstr "Search in {title}"

#: src/features/timeSeries/components/LabelsTab.tsx
msgid "Search labels"
msgstr "Search labels"

#: src/features/timeSeries/components/LabelsTab.tsx
msgid "Search labels, pens…"
msgstr "Search labels, pens…"

#: src/pages/manageAccess/components/scope/SiteSelect.tsx
msgid "Search organizations"
msgstr "Search organizations"

#: src/features/navbar/siteSelectors/SiteSelectorsSidebar.tsx
msgid "Search organizations..."
msgstr "Search organizations..."

#: src/features/navbar/siteSelectors/SiteSelectorsTopBar.tsx
msgid "Search Organizations(…)"
msgstr "Search Organizations(…)"

#: src/pages/manageAccess/components/table/UserSearchInput.tsx
msgid "Search people by name or email"
msgstr "Search people by name or email"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/utils/constants.ts
msgid "Search sensors..."
msgstr "Search sensors..."

#: src/features/timeSeries/components/SentinelsTab.tsx
msgid "Search sentinels by name or target tag..."
msgstr "Search sentinels by name or target tag..."

#: src/pages/manageAccess/components/scope/SiteSelect.tsx
msgid "Search sites"
msgstr "Search sites"

#: src/features/navbar/siteSelectors/SiteSelectorsSidebar.tsx
msgid "Search sites..."
msgstr "Search sites..."

#: src/features/navbar/siteSelectors/SiteSelectorsTopBar.tsx
msgid "Search Sites(…)"
msgstr "Search Sites(…)"

#: src/features/modelOperations/SubjectTargetPickerColumn.tsx
msgid "Search subjects by name, alias, or tag…"
msgstr "Search subjects by name, alias, or tag…"

#: src/features/knowledgeDocumentViewer/components/sidebar/OcrTable.tsx
#: src/features/timeSeries/components/panes/TagSearchDialog.tsx
msgid "Search tags"
msgstr "Search tags"

#: src/features/knowledgeDocumentViewer/components/sidebar/OcrTable.tsx
msgid "Search Tags"
msgstr "Search Tags"

#: src/features/timeSeries/experiment/TagPicker.tsx
msgid "Search tags…"
msgstr "Search tags…"

#: src/components/DateTimeWithTimezone.tsx
msgid "Search timezones..."
msgstr "Search timezones..."

#: src/pages/evaluations/metadata/labeling/components/DataLabelingTypeFilter.tsx
msgid "Search types"
msgstr "Search types"

#: src/features/richText/components/TaggableUsersCard.tsx
msgid "Search users by name or email..."
msgstr "Search users by name or email..."

#: src/pages/evaluations/metadata/labeling/components/DataLabelingVendorFilter.tsx
msgid "Search vendors..."
msgstr "Search vendors..."

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatTimelineRows.tsx
msgid "Searched for <0>{searchLabel}</0>"
msgstr "Searched for <0>{searchLabel}</0>"

#: src/features/timeSeries/agentTab/toolSentence.ts
msgid "Searched tags"
msgstr "Searched tags"

#: src/features/timeSeries/agentTab/toolSentence.ts
msgid "Searched tags for {query}"
msgstr "Searched tags for {query}"

#: src/features/timeSeries/agentTab/toolSentence.ts
msgid "Searched the drawings"
msgstr "Searched the drawings"

#: src/features/timeSeries/agentTab/toolSentence.ts
msgid "Searched the drawings for {query}"
msgstr "Searched the drawings for {query}"

#: src/pages/metrics/components/MonthlyTable.tsx
#: src/pages/metrics/components/SiteRowsTable.tsx
#: src/pages/metrics/Metrics.tsx
msgid "Searches"
msgstr "Searches"

#: src/pages/metrics/Metrics.tsx
msgid "Searches — 7-day rolling average"
msgstr "Searches — 7-day rolling average"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatAgentsMenu.tsx
msgid "Searches documents in multiple steps to answer your next question"
msgstr "Searches documents in multiple steps to answer your next question"

#: src/features/timeSeries/agentTab/toolSentence.ts
msgid "Searching tags"
msgstr "Searching tags"

#: src/features/timeSeries/agentTab/toolSentence.ts
msgid "Searching tags for {query}"
msgstr "Searching tags for {query}"

#: src/features/timeSeries/agentTab/toolSentence.ts
msgid "Searching the drawings"
msgstr "Searching the drawings"

#: src/features/timeSeries/agentTab/toolSentence.ts
msgid "Searching the drawings for {query}"
msgstr "Searching the drawings for {query}"

#: src/features/knowledgeDocumentViewer/components/viewer/shared/CrossReferenceMarker.tsx
msgid "Searching this location"
msgstr "Searching this location"

#: src/features/knowledgeDocumentViewer/components/viewer/search/IntraDocSearchBar.tsx
msgid "Searching..."
msgstr "Searching..."

#: src/features/modelOperations/SubjectTargetPickerColumn.tsx
msgid "Searching…"
msgstr "Searching…"

#: src/pages/alerts/AlertDetails.tsx
msgid "See Relevant Documents"
msgstr "See Relevant Documents"

#: src/pages/homepage/constants.ts
msgid "See system health, unit/component status, live sensor data, process flow diagrams, and system documentation."
msgstr "See system health, unit/component status, live sensor data, process flow diagrams, and system documentation."

#: src/features/knowledgeDocumentViewer/components/metadata/RevisionFamilyDropdownItem.tsx
msgid "Select"
msgstr "Select"

#: src/pages/manageAccess/components/scope/SiteSelect.tsx
msgid "Select {orgName}"
msgstr "Select {orgName}"

#: src/features/knowledgeDocumentViewer/components/metadata/RevisionFamilyCard.tsx
msgid "Select {title}"
msgstr "Select {title}"

#: src/pages/assetLens/components/tabs/ModelViewerTab.tsx
msgid "Select a component"
msgstr "Select a component"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatEvalCaseCitations.tsx
msgid "Select a document to open it in the preview."
msgstr "Select a document to open it in the preview."

#: src/features/knowledgeDocumentViewer/components/table/enhancements/BulkActionModalEditConfiguration.tsx
msgid "Select a field to edit"
msgstr "Select a field to edit"

#: src/features/forecastNotifications/NotificationDetailPanel.tsx
msgid "Select a notification to view details"
msgstr "Select a notification to view details"

#: src/features/timeSeries/components/chartTools/SensorSelect.tsx
#: src/features/timeSeries/components/pointTool/PointAnnotationOverlay.tsx
#: src/features/timeSeries/components/rulerTool/RulerMetricsPanel.tsx
msgid "Select a pen"
msgstr "Select a pen"

#: src/features/timeSeries/components/pointTool/PointAnnotationOverlay.tsx
msgid "Select a pen to snap this annotation."
msgstr "Select a pen to snap this annotation."

#: src/features/timeSeries/components/FormulaBuilder.tsx
msgid "Select a sensor to insert:"
msgstr "Select a sensor to insert:"

#: src/pages/facilityModel/FacilityModelCatalog.tsx
msgid "Select a site to browse its facility model."
msgstr "Select a site to browse its facility model."

#: src/pages/documents/CmmsExplorerRoutePage.tsx
msgid "Select a site to explore its CMMS data."
msgstr "Select a site to explore its CMMS data."

#: src/pages/facilityModel/SubjectDetailPage.tsx
msgid "Select a site to open this Subject."
msgstr "Select a site to open this Subject."

#: src/features/embeddedSidebar/chatHistory/AgenticChatHistorySidebar.tsx
msgid "Select a site to view chats."
msgstr "Select a site to view chats."

#: src/features/lotoReports/components/LotoReportsScopeGate.tsx
msgid "Select a site to view its LOTO reports."
msgstr "Select a site to view its LOTO reports."

#: src/pages/facilityModel/SubjectDetailPage.tsx
msgid "Select a Subject from the list to inspect it before using it."
msgstr "Select a Subject from the list to inspect it before using it."

#: src/features/modelOperations/SubjectDetails.tsx
msgid "Select a subject to see its details."
msgstr "Select a subject to see its details."

#: src/features/knowledgeDocumentViewer/components/table/enhancements/BulkActionModalEditConfiguration.tsx
msgid "Select a value"
msgstr "Select a value"

#: src/features/knowledgeDocumentViewer/components/table/enhancements/BulkEditModal.tsx
#: src/features/knowledgeDocumentViewer/components/table/enhancements/BulkEditModal.tsx
msgid "Select Action"
msgstr "Select Action"

#: src/features/fimReview/IdentityPanel.tsx
msgid "Select alias"
msgstr "Select alias"

#: src/pages/evaluations/metadata/labeling/components/DataLabelingFilterActions.tsx
msgid "Select all"
msgstr "Select all"

#: src/features/knowledgeDocumentViewer/components/sidebar/FeedbackModal.tsx
msgid "Select an issue type"
msgstr "Select an issue type"

#: src/pages/manageAccess/ManageAccessPage.tsx
msgid "Select an organization in the sidebar to manage its access."
msgstr "Select an organization in the sidebar to manage its access."

#: src/pages/evaluations/metadata/components/MetricsCard.tsx
#: src/pages/evaluations/metadata/dashboard/MetadataEvalsPage.tsx
msgid "Select an organization to view metadata evaluation metrics."
msgstr "Select an organization to view metadata evaluation metrics."

#: src/pages/systemView/components/SystemViewAnnotationSidebar.tsx
msgid "Select annotation"
msgstr "Select annotation"

#: src/features/fimReview/ReviewActions.tsx
msgid "Select at least one alias to remove."
msgstr "Select at least one alias to remove."

#: src/designSystem/components/DatePicker.tsx
#: src/designSystem/components/DatePicker.tsx
msgid "Select date"
msgstr "Select date"

#: src/features/timeSeries/components/AbsoluteDateConfig.tsx
#: src/features/timeSeries/components/RegressionPrediction.tsx
msgid "Select end date"
msgstr "Select end date"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatTagPickerCard.tsx
msgid "Select every tag that applies."
msgstr "Select every tag that applies."

#: src/pages/systemView/components/unitsTab/FilterControls.tsx
msgid "Select field"
msgstr "Select field"

#: src/pages/systemView/components/SystemViewAnnotationSidebar.tsx
msgid "Select measurement"
msgstr "Select measurement"

#: src/pages/systemView/components/unitsTab/FilterControls.tsx
msgid "Select metric"
msgstr "Select metric"

#: src/features/lotoReports/components/LotoTargetEquipmentList.tsx
msgid "Select on drawing"
msgstr "Select on drawing"

#: src/pages/systemView/components/SystemViewAnnotationSidebar.tsx
msgid "Select primitive"
msgstr "Select primitive"

#: src/features/knowledgeDocumentViewer/components/metadata/RevisionFamilyCard.tsx
msgid "Select Revision"
msgstr "Select Revision"

#: src/features/timeSeries/components/FormulaBuilder.tsx
msgid "Select sensor"
msgstr "Select sensor"

#: src/pages/assetLens/components/tabs/imagesTabComponents/ImageUploadModal.tsx
msgid "Select source"
msgstr "Select source"

#: src/features/timeSeries/components/AbsoluteDateConfig.tsx
msgid "Select start date"
msgstr "Select start date"

#: src/pages/systemView/components/unitsTab/FilterControls.tsx
msgid "Select value"
msgstr "Select value"

#: src/features/knowledgeDocumentViewer/components/metadata/RevisionFamilyCard.tsx
msgid "Selected"
msgstr "Selected"

#: src/features/fimReview/ReviewActions.tsx
msgid "Selected aliases removed from fusion."
msgstr "Selected aliases removed from fusion."

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
msgid "Selected inspection option"
msgstr "Selected inspection option"

#: src/features/knowledgeDocumentViewer/workOrders/legacyCmmsRecordPdf.ts
msgid "Selected inspection options"
msgstr "Selected inspection options"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
#: src/features/knowledgeDocumentViewer/workOrders/legacyCmmsRecordPdf.ts
msgid "Selected response"
msgstr "Selected response"

#: src/features/timeSeries/components/panes/PensPane.tsx
msgid "Selected Tags"
msgstr "Selected Tags"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatFeedbackDialog.tsx
msgid "Selected text"
msgstr "Selected text"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatInspectionCard.tsx
msgid "Selection"
msgstr "Selection"

#: src/features/timeSeries/experiment/ModelKnobs.tsx
msgid "Self history (target lags)"
msgstr "Self history (target lags)"

#: src/features/timeSeries/agentTab/chat/Composer.tsx
#: src/features/timeSeries/agentTab/chat/Composer.tsx
#: src/pages/assetLens/components/tabs/SensorIssuesTab.tsx
msgid "Send"
msgstr "Send"

#: src/features/knowledgeDocumentViewer/components/bugReport/DocumentsBugReportButton.tsx
msgid "Send a message to the Gecko Support Team."
msgstr "Send a message to the Gecko Support Team."

#: src/features/timeSeries/agentTab/chat/Composer.tsx
msgid "Send this prompt"
msgstr "Send this prompt"

#: src/pages/manageAccess/hooks/useListedRoster.ts
msgid "Sending invitations…"
msgstr "Sending invitations…"

#: src/pages/alerts/components/AlertTimeSeriesChart.tsx
msgid "Sensor"
msgstr "Sensor"

#: src/pages/assetLens/components/tabs/AnomalyDashboard.tsx
msgid "Sensor Data:"
msgstr "Sensor Data:"

#: src/pages/alerts/AlertDetails.tsx
msgid "Sensor Name"
msgstr "Sensor Name"

#: src/pages/assetLens/components/tabs/imagesTabComponents/ImageMetadata.tsx
msgid "Sensor: {sensorValue} mils"
msgstr "Sensor: {sensorValue} mils"

#: src/pages/assetLens/components/tabs/imagesTabComponents/ImageMetadata.tsx
msgid "Sensor: {sensorValue}°F"
msgstr "Sensor: {sensorValue}°F"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/sensors/SensorResultsSection.tsx
#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/sensors/SensorResultsSection.tsx
#: src/features/knowledgeDocumentViewer/components/advancedSearch/utils/constants.ts
msgid "Sensors"
msgstr "Sensors"

#: src/pages/assetLens/components/AssetHeader.tsx
msgid "Sensors Tracked"
msgstr "Sensors Tracked"

#: src/features/mdCases/mdCaseDisplay.ts
msgid "Sent To Site"
msgstr "Sent To Site"

#: src/features/facilityModel/provenance/ProvenanceChain.tsx
#: src/pages/alerts/components/AlertsTableColumns.tsx
#: src/pages/facilityModel/SentinelDetailPage.tsx
msgid "Sentinel"
msgstr "Sentinel"

#: src/features/mdCases/components/CaseStorySection.tsx
msgid "Sentinel {ordinal}"
msgstr "Sentinel {ordinal}"

#: src/features/timeSeries/sentinelStudio/SentinelBuilderPanel.tsx
msgid "Sentinel name"
msgstr "Sentinel name"

#: src/features/timeSeries/ScatterplotContext.tsx
msgid "Sentinel target tag {target} was not found at this site"
msgstr "Sentinel target tag {target} was not found at this site"

#: src/features/timeSeries/components/ScatterplotSidebar.tsx
#: src/features/timeSeries/components/SentinelsTab.tsx
#: src/pages/facilityModel/FacilityModelCatalog.tsx
#: src/pages/facilityModel/SentinelOverviewPage.tsx
#: src/pages/facilityModel/SentinelOverviewPage.tsx
msgid "Sentinels"
msgstr "Sentinels"

#: src/pages/facilityModel/SubjectDetailPage.tsx
msgid "Sentinels ({sentinelCount})"
msgstr "Sentinels ({sentinelCount})"

#: src/pages/manageAccess/components/invite/InviteUsersDialog.tsx
msgid "Separate addresses with a comma, a space, or Enter."
msgstr "Separate addresses with a comma, a space, or Enter."

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
#: src/features/knowledgeDocumentViewer/workOrders/legacyCmmsRecordPdf.ts
#: src/features/knowledgeDocumentViewer/workOrders/legacyCmmsRecordPdf.ts
msgid "Sequence"
msgstr "Sequence"

#: src/designSystem/components/RecordHeader.tsx
msgid "Serial"
msgstr "Serial"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
#: src/features/knowledgeDocumentViewer/workOrders/legacyCmmsRecordPdf.ts
msgid "Serial number"
msgstr "Serial number"

#: src/features/sentinels/components/MonitorTab.tsx
msgid "Served method — whose residuals are watched"
msgstr "Served method — whose residuals are watched"

#: src/features/sentinels/components/DesignRunOverviewSections.tsx
msgid "Served model"
msgstr "Served model"

#: src/features/knowledgeDocumentViewer/workOrders/workOrderPdf.ts
msgid "Service cost"
msgstr "Service cost"

#: src/features/chatbot/components/ChatHistoryDrawer.tsx
msgid "Session"
msgstr "Session"

#: src/features/navbar/configSettings/ConfigSettingsSidebarMenuItems.tsx
#: src/features/navbar/configSettings/ConfigSettingsTopBarMenuItems.tsx
msgid "Session recording: Off (this browser)"
msgstr "Session recording: Off (this browser)"

#: src/features/navbar/configSettings/ConfigSettingsSidebarMenuItems.tsx
#: src/features/navbar/configSettings/ConfigSettingsTopBarMenuItems.tsx
msgid "Session recording: On"
msgstr "Session recording: On"

#: src/pages/details/visualization/screenshot/ScreenshotTools.tsx
msgid "Set 11x7 Image Aspect Ratio"
msgstr "Set 11x7 Image Aspect Ratio"

#: src/features/timeSeries/experiment/NormalizationViewer.tsx
msgid "Set a target first."
msgstr "Set a target first."

#: src/features/copcPointClouds/CopcCoordinateOriginControl.tsx
msgid "Set origin"
msgstr "Set origin"

#: src/features/mdCases/components/ProvenanceContentViewer.tsx
#: src/features/mdCases/components/ProvenanceContentViewer.tsx
#: src/pages/alerts/AlertDetails.tsx
#: src/pages/alerts/components/AlertsTableColumns.tsx
msgid "Setpoint"
msgstr "Setpoint"

#: src/features/timeSeries/experiment/knobCopy.ts
msgid "Sets each driver’s phase shift to the lag with strongest absolute correlation vs the target in the preview scan."
msgstr "Sets each driver’s phase shift to the lag with strongest absolute correlation vs the target in the preview scan."

#: src/features/knowledgeDocumentViewer/components/toolbar/SettingsMenu.tsx
#: src/features/navbar/configSettings/ConfigSettingsSidebar.tsx
#: src/features/timeSeries/agentTab/dock/AgentDock.tsx
#: src/pages/facilityModel/SentinelDetailPage.tsx
msgid "Settings"
msgstr "Settings"

#: src/features/chatbot/components/conversationMessage/ProposalCard.tsx
#: src/pages/assetLens/components/tabs/AnomalyDashboard.tsx
#: src/pages/cases/md/MdCaseDetailsInspector.tsx
#: src/pages/cases/md/mdCasesListSearchContract.ts
msgid "Severity"
msgstr "Severity"

#: src/features/timeSeries/components/timeSeriesScatterplot/MdDraftAlertCaseFlowPanels.tsx
msgid "Severity not set"
msgstr "Severity not set"

#: src/features/mdCases/components/ProvenanceContentViewer.tsx
msgid "Severity: {nodeSeverity}"
msgstr "Severity: {nodeSeverity}"

#: src/features/mdCases/components/ProvenanceContentViewer.tsx
#: src/pages/cases/md/MdCaseDetailsInspector.tsx
msgid "Severity: {severityLabel}"
msgstr "Severity: {severityLabel}"

#: src/pages/systemView/components/SystemViewAnnotationSidebar.tsx
msgid "Share"
msgstr "Share"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatFeedbackDialog.tsx
msgid "Share details (optional)"
msgstr "Share details (optional)"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatFeedbackDialog.tsx
msgid "Share feedback"
msgstr "Share feedback"

#: src/pages/assetLens/components/tabs/AnomalyDashboard.tsx
msgid "Share Report"
msgstr "Share Report"

#: src/pages/cases/components/CasesTable.tsx
msgid "Shared Cases"
msgstr "Shared Cases"

#: src/pages/processData/components/helpGuide/HelpGuideChapters.tsx
msgid "Sharing feedback and requesting improvements."
msgstr "Sharing feedback and requesting improvements."

#: src/pages/details/visualization/tools/HeatmapToggle.tsx
#: src/pages/details/visualization/tools/HeatmapToggle.tsx
msgid "Sharp heatmap"
msgstr "Sharp heatmap"

#: src/features/knowledgeDocumentViewer/components/sidebar/CrossReferencePanel.tsx
msgid "Sheet {sheet}"
msgstr "Sheet {sheet}"

#: src/features/knowledgeDocumentViewer/utils/metadataFieldLabelMessages.ts
msgid "Sheet #"
msgstr "Sheet #"

#: src/features/knowledgeDocumentViewer/components/toolbar/PdfDownloadMenuOptions.tsx
msgid "Sheets"
msgstr "Sheets"

#: src/pages/cases/md/MdCasesCardList.tsx
msgid "Shelve Case"
msgstr "Shelve Case"

#: src/features/mdCases/mdCaseDisplay.ts
#: src/pages/cases/md/MdCasesListPage.tsx
msgid "Shelved"
msgstr "Shelved"

#: src/pages/cases/md/MdCasesListPage.tsx
msgid "Shelved ({shelvedCount})"
msgstr "Shelved ({shelvedCount})"

#: src/pages/cases/md/MdCasesCardList.tsx
msgid "Shelving..."
msgstr "Shelving..."

#: src/features/timeSeries/experiment/CorrelationCard.tsx
msgid "shift (positive = driver leads)"
msgstr "shift (positive = driver leads)"

#: src/features/knowledgeDocumentViewer/components/viewer/shared/InstrumentTimeSeriesPreview.tsx
msgid "Shift+click: {linkedDocumentCount, plural, one {# doc} other {# docs}}"
msgstr "Shift+click: {linkedDocumentCount, plural, one {# doc} other {# docs}}"

#: src/features/navbar/navConfig.ts
msgid "Ships"
msgstr "Ships"

#: src/features/knowledgeDocumentViewer/components/metadata/ShouldHaveMetadataField.tsx
#: src/features/knowledgeDocumentViewer/components/metadata/ShouldHaveMetadataField.tsx
msgid "Should this page have metadata?"
msgstr "Should this page have metadata?"

#: src/features/kestrelUpload/KestrelModelUploadSection.tsx
#: src/features/knowledgeDocumentViewer/components/revisionCompare/RevisionStatusLegend.tsx
#: src/features/navbar/PermissionGateToggle.tsx
#: src/features/timeSeries/components/RegressionPrediction.tsx
msgid "Show"
msgstr "Show"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/AgenticInlineDocumentResults.tsx
#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatTagPickerCard.tsx
msgid "Show {hiddenCount} more"
msgstr "Show {hiddenCount} more"

#: src/features/sentinels/components/RecentScorePanel.tsx
#: src/features/workbench/LayoutToggles.tsx
msgid "Show {label}"
msgstr "Show {label}"

#: src/pages/details/visualization/screenshot/ScreenshotTools.tsx
msgid "Show a single course"
msgstr "Show a single course"

#: src/pages/cases/md/MdCaseDetailsMainColumn.tsx
msgid "Show Activity"
msgstr "Show Activity"

#: src/features/timeSeries/agentTab/dock/SettingsTab.tsx
#: src/features/timeSeries/components/timeSeriesScatterplot/PenCapNotice.tsx
msgid "Show all"
msgstr "Show all"

#: src/pages/details/visualization/tools/features/FeaturesToggleMenu.tsx
msgid "Show All"
msgstr "Show All"

#: src/features/timeSeries/components/chartActions/PenDisplayActions.tsx
#: src/features/timeSeries/components/chartActions/PenDisplayActions.tsx
#: src/features/timeSeries/components/PenDrawer.tsx
#: src/features/timeSeries/components/PenDrawer.tsx
msgid "Show all alerts"
msgstr "Show all alerts"

#: src/features/timeSeries/components/chartActions/PenDisplayActions.tsx
#: src/features/timeSeries/components/chartActions/PenDisplayActions.tsx
#: src/features/timeSeries/components/PenDrawer.tsx
#: src/features/timeSeries/components/PenDrawer.tsx
msgid "Show all pens"
msgstr "Show all pens"

#: src/pages/details/visualization/screenshot/ShellCoursesSelector.tsx
msgid "Show all sections"
msgstr "Show all sections"

#: src/pages/assetLens/components/tabs/imagesTabComponents/ImageTimelineView.tsx
msgid "Show Anomalies"
msgstr "Show Anomalies"

#: src/pages/details/visualization/tools/VizDebugMenu.tsx
msgid "Show bin values"
msgstr "Show bin values"

#: src/pages/details/visualization/tools/CameraControlsToggle.tsx
msgid "Show camera controls"
msgstr "Show camera controls"

#: src/features/kestrelViewer/ui/tools/photoreel/PhotoReel2DToolbar.tsx
msgid "Show camera poses"
msgstr "Show camera poses"

#: src/pages/overview/sidebar/capexOutlook/SiteViewCapExOutlookMenu.tsx
msgid "Show CapEx Outlook"
msgstr "Show CapEx Outlook"

#: src/features/timeSeries/components/panes/TagConfigurationPane.tsx
#: src/features/timeSeries/components/panes/TagConfigurationPane.tsx
msgid "Show chart controls"
msgstr "Show chart controls"

#: src/features/copcPointClouds/CopcViewerOverlay.tsx
msgid "Show coordinate origin"
msgstr "Show coordinate origin"

#: src/pages/details/visualization/tools/DebugMenuToggle.tsx
msgid "Show debug menu"
msgstr "Show debug menu"

#: src/features/timeSeries/experiment/ExperimentTab.tsx
msgid "Show denoise as a rolling overlay"
msgstr "Show denoise as a rolling overlay"

#: src/features/timeSeries/components/chartActions/PenDisplayActions.tsx
#: src/features/timeSeries/components/chartActions/PenDisplayActions.tsx
#: src/features/timeSeries/components/panes/TagBrowserPane.tsx
#: src/features/timeSeries/components/panes/TagBrowserPane.tsx
#: src/features/timeSeries/components/PenDrawer.tsx
#: src/features/timeSeries/components/PenDrawer.tsx
msgid "Show descriptions"
msgstr "Show descriptions"

#: src/features/timeSeries/components/AllTagsTab.tsx
#: src/pages/cases/activity/ActivityContent.tsx
msgid "Show details"
msgstr "Show details"

#: src/features/timeSeries/components/SentinelsTab.tsx
#: src/features/timeSeries/components/SentinelsTab.tsx
msgid "Show drivers"
msgstr "Show drivers"

#: src/pages/facilityModel/SubjectAssetPanel.tsx
msgid "Show fewer"
msgstr "Show fewer"

#: src/pages/processData/buildMode/rightPanel/SavedModelsPane.tsx
msgid "Show filters"
msgstr "Show filters"

#: src/features/copcPointClouds/CopcSurfaceControl.tsx
msgid "Show fitted surface"
msgstr "Show fitted surface"

#: src/pages/details/visualization/tools/KestrelTools.tsx
msgid "Show Kestrel"
msgstr "Show Kestrel"

#: src/pages/details/visualization/tools/ShowLabelsToggle.tsx
msgid "Show labels"
msgstr "Show labels"

#: src/pages/details/visualization/tools/features/FeaturesToggleMenu.tsx
msgid "Show Labels"
msgstr "Show Labels"

#: src/pages/details/visualization/screenshot/ScreenshotTools.tsx
msgid "Show Legend"
msgstr "Show Legend"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/AgenticInlineDocumentResults.tsx
msgid "Show less"
msgstr "Show less"

#: src/features/copcPointClouds/CopcLocalizationColorControl.tsx
msgid "Show LiDAR"
msgstr "Show LiDAR"

#: src/features/knowledgeDocumentViewer/components/toolbar/SettingsMenu.tsx
msgid "Show live process data"
msgstr "Show live process data"

#: src/features/knowledgeDocumentViewer/components/toolbar/KnowledgeDocumentHeaderBar.tsx
msgid "Show LOTO panel"
msgstr "Show LOTO panel"

#: src/features/knowledgeDocumentViewer/components/toolbar/KnowledgeDocumentHeaderBar.tsx
msgid "Show Metadata"
msgstr "Show Metadata"

#: src/features/knowledgeDocumentViewer/components/viewer/shared/ZoomControls.tsx
msgid "Show Minimap"
msgstr "Show Minimap"

#: src/features/forecastNotifications/NotificationPreferencesModal.tsx
msgid "Show notifications in Cantilever"
msgstr "Show notifications in Cantilever"

#: src/pages/details/visualization/screenshot/ShellCoursesSelector.tsx
msgid "Show only this section"
msgstr "Show only this section"

#: src/features/knowledgeDocumentViewer/components/toolbar/KnowledgeDocumentHeaderBar.tsx
msgid "Show Page Thumbnails"
msgstr "Show Page Thumbnails"

#: src/features/navbar/PermissionGateToggle.tsx
msgid "Show permission gates"
msgstr "Show permission gates"

#: src/features/knowledgeDocumentViewer/components/viewer/shared/ZoomControls.tsx
msgid "Show photo counts"
msgstr "Show photo counts"

#: src/pages/details/visualization/tools/NiraToggle.tsx
msgid "Show Photogrammetry"
msgstr "Show Photogrammetry"

#: src/pages/details/visualization/tools/CopcPointCloudToggle.tsx
#: src/pages/details/visualization/tools/LidarPointCloudToggle.tsx
msgid "Show Point Cloud"
msgstr "Show Point Cloud"

#: src/features/timeSeries/experiment/ExperimentTab.tsx
msgid "Show range / gate as pen filters"
msgstr "Show range / gate as pen filters"

#: src/features/copcPointClouds/CopcViewerOverlay.tsx
msgid "Show rulers"
msgstr "Show rulers"

#: src/pages/processData/buildMode/rightPanel/SavedModelsPane.tsx
msgid "Show shelf filters"
msgstr "Show shelf filters"

#: src/pages/kestrel/components/DesktopSidebarToggle.tsx
msgid "Show sidebar"
msgstr "Show sidebar"

#: src/features/timeSeries/components/ActiveTimeRangeSelector.tsx
#: src/features/timeSeries/components/ActiveTimeRangeSelector.tsx
msgid "Show tag names"
msgstr "Show tag names"

#: src/pages/details/extensions/flow/filesExt/ReportItem.tsx
#: src/pages/details/extensions/flow/filesExt/ReportItem.tsx
msgid "Show tags"
msgstr "Show tags"

#: src/features/fimReview/IdentityPanel.tsx
msgid "Show the prior Subjects folded into this one"
msgstr "Show the prior Subjects folded into this one"

#: src/features/fimReview/IdentityPanel.tsx
msgid "Show the references behind this alias"
msgstr "Show the references behind this alias"

#: src/features/timeSeries/experiment/SamplingKnobs.tsx
msgid "Show these buckets on the chart"
msgstr "Show these buckets on the chart"

#: src/features/timeSeries/components/SentinelsTab.tsx
msgid "Show this sentinel's driver tags on the chart too"
msgstr "Show this sentinel's driver tags on the chart too"

#: src/features/timeSeries/experiment/ModelKnobs.tsx
msgid "Show this window on the chart"
msgstr "Show this window on the chart"

#: src/pages/details/visualization/tools/HideToolbarToggle.tsx
msgid "Show toggles"
msgstr "Show toggles"

#: src/pages/details/visualization/tools/HideToolbarToggle.tsx
msgid "Show Toggles"
msgstr "Show Toggles"

#: src/features/knowledgeDocumentViewer/components/toolbar/SettingsMenu.tsx
msgid "Show tooltip when hovering on links"
msgstr "Show tooltip when hovering on links"

#: src/features/powerCustomerUploads/components/PowerCustomerUploadFailureDetails.tsx
msgid "Show upload failure details"
msgstr "Show upload failure details"

#: src/features/timeSeries/components/ScatterPlotTableConfig.tsx
msgid "Show/Hide"
msgstr "Show/Hide"

#: src/features/timeSeries/agentTab/chat/BuildCard.tsx
msgid "showed {shown}"
msgstr "showed {shown}"

#: src/features/timeSeries/components/timeSeriesScatterplot/PenCapNotice.tsx
msgid "Showing "
msgstr "Showing "

#: src/pages/evaluations/metadata/dashboard/components/dataLabeling/DataLabelingDashboardComparisonTable.tsx
msgid "Showing {fromLabel}–{toLabel} of {totalLabel}"
msgstr "Showing {fromLabel}–{toLabel} of {totalLabel}"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/documentsCardView/DocumentCardResultCountLabel.tsx
msgid "Showing {rangeStart}-{rangeEnd} of {displayCount, plural, one {# result} other {# results}}"
msgstr "Showing {rangeStart}-{rangeEnd} of {displayCount, plural, one {# result} other {# results}}"

#: src/pages/details/visualization/Visualization.tsx
msgid "Showing inspection \"{inspectionName}\" from {inspectionDate}."
msgstr "Showing inspection \"{inspectionName}\" from {inspectionDate}."

#: src/pages/details/visualization/Visualization.tsx
msgid "Showing inspection \"{inspectionName}\"."
msgstr "Showing inspection \"{inspectionName}\"."

#: src/features/knowledgeDocumentViewer/graph/useDocumentGraph.ts
msgid "Showing partial graph. Extraction is incomplete."
msgstr "Showing partial graph. Extraction is incomplete."

#: src/features/modelOperations/SubjectTargetPickerColumn.tsx
msgid "Showing the top {shownCount} of {totalMatchesLabel} matches — narrow the search."
msgstr "Showing the top {shownCount} of {totalMatchesLabel} matches — narrow the search."

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/AgenticInlineDocumentResults.tsx
msgid "Showing the top work-order matches. Narrow your question for more specific results."
msgstr "Showing the top work-order matches. Narrow your question for more specific results."

#: src/features/timeSeries/experiment/knobCopy.ts
msgid "Shows how many rows have the target and drivers present together. Off-frequency sensors do not invent mid-points: a value only appears on a row if that tag had a sample in that bin (aggregate) or that exact timestamp (raw). Limited driver ffill can borrow a few prior driver values; the target is never filled. kNN needs enough drivers on the same row; MLP can mask missing drivers."
msgstr "Shows how many rows have the target and drivers present together. Off-frequency sensors do not invent mid-points: a value only appears on a row if that tag had a sample in that bin (aggregate) or that exact timestamp (raw). Limited driver ffill can borrow a few prior driver values; the target is never filled. kNN needs enough drivers on the same row; MLP can mask missing drivers."

#: src/pages/forgingsReporting/ForgingsReportPage.tsx
msgid "Sign in to open this report."
msgstr "Sign in to open this report."

#: src/features/facilityModel/provenance/ProvenanceChain.tsx
msgid "Signal"
msgstr "Signal"

#: src/features/mdCases/components/ProvenanceContentViewer.tsx
msgid "Signal roles"
msgstr "Signal roles"

#: src/features/mdCases/components/CaseStorySection.tsx
msgid "Signals {ordinal}"
msgstr "Signals {ordinal}"

#: src/features/lotoReports/recordSheet/recordSheetLayout.ts
msgid "Signature (Control Authority):"
msgstr "Signature (Control Authority):"

#: src/features/lotoReports/recordSheet/recordSheetLayout.ts
msgid "Signature:"
msgstr "Signature:"

#: src/features/timeSeries/components/YAxisModeSection.tsx
#: src/pages/processData/components/helpGuide/HelpGuideChapters.tsx
msgid "Single"
msgstr "Single"

#: src/features/knowledgeDocumentViewer/components/toolbar/SettingsMenu.tsx
msgid "Single page"
msgstr "Single page"

#: src/features/timeSeries/components/YScaleControls.tsx
msgid "Single Y-Scale"
msgstr "Single Y-Scale"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatEvalCaseReview.tsx
#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
#: src/features/knowledgeDocumentViewer/workOrders/cmmsRecordPdf.ts
#: src/features/knowledgeDocumentViewer/workOrders/legacyCmmsRecordPdf.ts
#: src/features/navbar/siteSelectors/SiteSelectorsSidebar.tsx
#: src/pages/evaluations/metadata/dashboard/components/dataLabeling/DataLabelingDashboardComparisonTable.tsx
#: src/pages/evaluations/metadata/dashboard/components/dataLabeling/DataLabelingDashboardDisagreementFilters.tsx
#: src/pages/evaluations/metadata/dashboard/components/dataLabeling/DataLabelingDashboardDisagreementFilters.tsx
#: src/pages/evaluations/metadata/dashboard/components/dataLabeling/DataLabelingDashboardFieldDrilldown.tsx
#: src/pages/evaluations/metadata/dashboard/components/dataLabeling/DataLabelingDashboardSites.tsx
#: src/pages/metrics/components/SiteRowsTable.tsx
#: src/pages/metrics/Metrics.tsx
msgid "Site"
msgstr "Site"

#: src/pages/manageAccess/components/dialogs/SiteAccessDialog.tsx
msgid "Site access"
msgstr "Site access"

#: src/features/navbar/navConfig.ts
msgid "Site Context & Monitoring"
msgstr "Site Context & Monitoring"

#: src/pages/site/components/SiteFilesTableCard.tsx
msgid "Site Files"
msgstr "Site Files"

#: src/pages/site/components/SiteInfoCard.tsx
msgid "Site Info"
msgstr "Site Info"

#: src/features/mdCases/components/ProvenanceContentViewer.tsx
#: src/features/mdCases/components/ProvenanceContentViewer.tsx
msgid "Site name"
msgstr "Site name"

#: src/pages/site/forms/siteInfoFormFields.ts
msgid "Site Name"
msgstr "Site Name"

#: src/pages/overview/SiteViewPageContainer.tsx
msgid "Site not found"
msgstr "Site not found"

#: src/features/mdCases/components/MonitorLineagePanel.tsx
msgid "Site outputs · {siteId}"
msgstr "Site outputs · {siteId}"

#: src/features/navbar/navConfig.ts
msgid "Site Overview"
msgstr "Site Overview"

#: src/pages/documents/Documents.tsx
msgid "Site unavailable"
msgstr "Site unavailable"

#: src/features/knowledgeDocumentViewer/workOrders/workOrderPdf.ts
msgid "Site-specific fields"
msgstr "Site-specific fields"

#: src/features/mdCases/components/ProvenanceContentViewer.tsx
msgid "Site: {siteId}"
msgstr "Site: {siteId}"

#: src/pages/evaluations/metadata/dashboard/components/dataLabeling/DataLabelingDashboardSites.tsx
#: src/pages/evaluations/metadata/dashboard/components/dataLabeling/DataLabelingDashboardSites.tsx
#: src/pages/metrics/Metrics.tsx
msgid "Sites"
msgstr "Sites"

#: src/pages/metrics/components/MonthlyTable.tsx
msgid "Sites live"
msgstr "Sites live"

#: src/features/powerCustomerUploads/components/PowerCustomerUploadReviewTable.tsx
#: src/features/richText/components/ToolbarPlugin.tsx
msgid "Size"
msgstr "Size"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
#: src/features/knowledgeDocumentViewer/workOrders/legacyCmmsRecordPdf.ts
msgid "Skill"
msgstr "Skill"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatTagPickerCard.tsx
msgid "Skip"
msgstr "Skip"

#: src/features/powerCustomerUploads/components/PowerCustomerUploadStatus.tsx
#: src/features/powerCustomerUploads/components/PowerCustomerUploadStatus.tsx
msgid "Skipped"
msgstr "Skipped"

#: src/pages/site/forms/siteInfoFormFields.ts
msgid "Slack Channel"
msgstr "Slack Channel"

#: src/features/knowledgeDocumentViewer/components/toolbar/OutlineUnitList.tsx
msgid "Slide {startPage}"
msgstr "Slide {startPage}"

#: src/features/knowledgeDocumentViewer/components/toolbar/PdfDownloadMenuOptions.tsx
msgid "Slides"
msgstr "Slides"

#: src/features/facilityModel/columns.ts
msgid "Slots"
msgstr "Slots"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/utils/docChatFeedback.ts
msgid "Slow or buggy"
msgstr "Slow or buggy"

#: src/features/kestrelViewer/ui/tools/photoreel/DockedPhotoReelPanel.tsx
msgid "Smart Select"
msgstr "Smart Select"

#: src/features/kestrelViewer/ui/tools/photoreel/annotation/usePhotoAnnotationSession.ts
msgid "Smart Select failed. Please try again."
msgstr "Smart Select failed. Please try again."

#: src/pages/details/visualization/tools/HeatmapToggle.tsx
#: src/pages/details/visualization/tools/HeatmapToggle.tsx
msgid "Smooth heatmap"
msgstr "Smooth heatmap"

#: src/features/timeSeries/agentTab/dock/VersionsTab.tsx
msgid "smoothing {before}→{after}"
msgstr "smoothing {before}→{after}"

#: src/features/timeSeries/agentTab/dock/useModelDraft.ts
msgid "smoothing must be 0 (off) or between 2 and 120 days"
msgstr "smoothing must be 0 (off) or between 2 and 120 days"

#: src/features/lotoReports/recordSheet/recordSheetLayout.ts
msgid "SMP-03"
msgstr "SMP-03"

#: src/features/copcPointClouds/CopcOrientationCube.tsx
msgid "Snap to {label} view"
msgstr "Snap to {label} view"

#: src/features/knowledgeDocumentViewer/components/bugReport/BugReportPriorityField.tsx
msgid "Solve now, including outside working hours."
msgstr "Solve now, including outside working hours."

#: src/features/lotoReports/components/LotoPrintAlert.tsx
msgid "Some attached pages could not be found. They print as placeholder pages."
msgstr "Some attached pages could not be found. They print as placeholder pages."

#: src/features/knowledgeDocumentViewer/graph/useGraphInstrumentation.ts
msgid "Some linked process data could not be loaded."
msgstr "Some linked process data could not be loaded."

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/AgenticInlineDocumentResults.tsx
msgid "Some search methods were unavailable or work-order evidence was shortened. Open a source to review the full imported record."
msgstr "Some search methods were unavailable or work-order evidence was shortened. Open a source to review the full imported record."

#: src/pages/errorFallback/ErrorFallback.tsx
msgid "Something went wrong"
msgstr "Something went wrong"

#: src/features/knowledgeDocumentViewer/artifacts/ArtifactPanel.tsx
msgid "Something went wrong."
msgstr "Something went wrong."

#: src/features/knowledgeDocumentViewer/components/sidebar/SubjectDocumentsPanel.tsx
msgid "Something wrong? Edit this Subject in the Facility Model"
msgstr "Something wrong? Edit this Subject in the Facility Model"

#: src/features/forecastNotifications/NotificationListPanel.tsx
msgid "Sort"
msgstr "Sort"

#: src/pages/facilityModel/FacilityModelTable.tsx
msgid "Sort by {columnLabel}"
msgstr "Sort by {columnLabel}"

#: src/pages/manageAccess/components/table/UsersTableHead.tsx
msgid "Sort by {label}"
msgstr "Sort by {label}"

#: src/pages/cases/activity/ActivitySection.tsx
msgid "Sort by newest first"
msgstr "Sort by newest first"

#: src/pages/cases/activity/ActivitySection.tsx
msgid "Sort by oldest first"
msgstr "Sort by oldest first"

#: src/features/forecastNotifications/NotificationListPanel.tsx
msgid "Sort newest first"
msgstr "Sort newest first"

#: src/features/forecastNotifications/NotificationListPanel.tsx
msgid "Sort oldest first"
msgstr "Sort oldest first"

#: src/features/lotoReports/components/LotoSortablePoints.tsx
msgctxt "Drag handle role description"
msgid "sortable"
msgstr "sortable"

#: src/pages/facilityModel/FacilityModelCatalog.tsx
msgid "sorted by relevance"
msgstr "sorted by relevance"

#: src/features/fimReview/IdentityPanel.tsx
#: src/features/fimReview/StructuralReviewFlow.tsx
#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
#: src/features/timeSeries/components/AllTagsTab.tsx
#: src/features/timeSeries/components/panes/TagFilterControls.tsx
#: src/pages/alerts/components/AlertsTableColumns.tsx
msgid "Source"
msgstr "Source"

#: src/features/timeSeries/components/AllTagsTable.tsx
#: src/features/timeSeries/experiment/TagLabel.tsx
msgid "Source "
msgstr "Source "

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
#: src/features/knowledgeDocumentViewer/workOrders/workOrderFields.ts
msgid "Source changed by"
msgstr "Source changed by"

#: src/features/facilityModel/provenance/ProvenanceChain.tsx
msgid "Source documents ({documentCount})"
msgstr "Source documents ({documentCount})"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsRecordPdf.ts
#: src/features/knowledgeDocumentViewer/workOrders/legacyCmmsRecordPdf.ts
msgid "Source key"
msgstr "Source key"

#: src/pages/assetLens/components/tabs/imagesTabComponents/ImageUploadModal.tsx
msgid "Source of Image"
msgstr "Source of Image"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsRecordPdf.ts
#: src/features/knowledgeDocumentViewer/workOrders/legacyCmmsRecordPdf.ts
#: src/features/knowledgeDocumentViewer/workOrders/workOrderPdf.ts
msgid "Source record"
msgstr "Source record"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsRecordPdf.ts
#: src/features/knowledgeDocumentViewer/workOrders/legacyCmmsRecordPdf.ts
msgid "Source system"
msgstr "Source system"

#: src/features/mdCases/components/ProvenanceContentViewer.tsx
#: src/features/mdCases/components/ProvenanceContentViewer.tsx
msgid "Source type"
msgstr "Source type"

#: src/pages/cases/md/mdCasesListSearchContract.ts
msgid "Source Type"
msgstr "Source Type"

#: src/features/knowledgeDocumentViewer/workOrders/WorkOrderCardMetadata.tsx
#: src/features/knowledgeDocumentViewer/workOrders/workOrderSheet.ts
msgid "Source updated"
msgstr "Source updated"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsRecordPdf.ts
#: src/features/knowledgeDocumentViewer/workOrders/legacyCmmsRecordPdf.ts
#: src/features/knowledgeDocumentViewer/workOrders/workOrderPdf.ts
msgid "Source version"
msgstr "Source version"

#: src/features/facilityModel/columns.ts
#: src/pages/cases/md/MdCaseDetailsMainColumn.tsx
#: src/pages/facilityModel/FacilityModelFilters.tsx
#: src/pages/facilityModel/SubjectDetailPage.tsx
msgid "Sources"
msgstr "Sources"

#: src/features/fimReview/InspectSources.tsx
msgid "Spare"
msgstr "Spare"

#: src/features/copcPointClouds/CopcSpatialContextControl.tsx
msgid "Spatial context radius from asset"
msgstr "Spatial context radius from asset"

#: src/features/mdCases/components/ProvenanceContentViewer.tsx
msgid "Spec needed · Unit: <0/>"
msgstr "Spec needed · Unit: <0/>"

#: src/features/mdCases/components/ProvenanceContentViewer.tsx
msgid "Spec request"
msgstr "Spec request"

#: src/features/mdCases/components/ProvenanceContentViewer.tsx
msgid "Specs needed"
msgstr "Specs needed"

#: src/pages/overview/sidebar/capexOutlook/kpiCards/SiteViewCapExKPIs.tsx
msgid "Spend Next 10 Years"
msgstr "Spend Next 10 Years"

#: src/pages/overview/sidebar/capexOutlook/kpiCards/SiteViewCapExKPIs.tsx
msgid "Spend Next 25 Years"
msgstr "Spend Next 25 Years"

#: src/pages/overview/sidebar/capexOutlook/kpiCards/SiteViewCapExKPIs.tsx
msgid "Spend This Year"
msgstr "Spend This Year"

#: src/features/fimReview/DecisionHistory.tsx
msgid "Split"
msgstr "Split"

#: src/features/timeSeries/experiment/ExperimentTab.tsx
msgid "Split builder"
msgstr "Split builder"

#: src/features/timeSeries/experiment/knobCopy.ts
msgid "Split each chunk in time instead of assigning whole chunks: the last N% of rows within EVERY un-assigned chunk become test (min 1 test and 1 train row per chunk), the rest train. Chunks you explicitly click keep their whole-chunk role and are never tail-split. A window that collapses to a single chunk always tail-splits (at 1 − train frac) so there is something to score."
msgstr "Split each chunk in time instead of assigning whole chunks: the last N% of rows within EVERY un-assigned chunk become test (min 1 test and 1 train row per chunk), the rest train. Chunks you explicitly click keep their whole-chunk role and are never tail-split. A window that collapses to a single chunk always tail-splits (at 1 − train frac) so there is something to score."

#: src/features/timeSeries/experiment/RunComparison.tsx
msgid "split ranges"
msgstr "split ranges"

#: src/pages/processData/buildMode/dock/WindowsDockTab.tsx
msgid "Split strategy"
msgstr "Split strategy"

#: src/features/fimReview/DecisionHistory.tsx
msgid "Split Subject"
msgstr "Split Subject"

#: src/pages/processData/components/helpGuide/HelpGuideChapters.tsx
msgid "Spotted an issue, or need something this page doesn't do yet? We want to hear about it."
msgstr "Spotted an issue, or need something this page doesn't do yet? We want to hear about it."

#: src/features/timeSeries/experiment/DiagnosticsPanel.tsx
msgid "spread blocks carved from Train"
msgstr "spread blocks carved from Train"

#: src/features/chatbot/api/sseClient.ts
msgid "SSE connection error"
msgstr "SSE connection error"

#: src/features/timeSeries/components/PenTransformControls.tsx
msgid "Stability window"
msgstr "Stability window"

#: src/features/powerCustomerUploads/components/powerCustomerUploadProgressModel.ts
#: src/features/powerCustomerUploads/components/PowerCustomerUploadStatus.tsx
#: src/features/powerCustomerUploads/components/PowerCustomerUploadStatus.tsx
msgid "Staged"
msgstr "Staged"

#: src/features/powerCustomerUploads/components/PowerCustomerUploadSelection.tsx
msgid "Staging files..."
msgstr "Staging files..."

#: src/features/facilityModel/views.ts
msgid "Stale"
msgstr "Stale"

#: src/pages/details/extensions/flow/SummarizerExtension.tsx
msgid "Standard deviation"
msgstr "Standard deviation"

#: src/features/assetLifecycleV2/views/observations/LtaObservationCompositeViz.tsx
msgid "Standard Deviation"
msgstr "Standard Deviation"

#: src/pages/metrics/components/DailySearchesChart.tsx
msgid "Standard search"
msgstr "Standard search"

#: src/pages/metrics/components/DailySearchesChart.tsx
msgid "Standard search (7d avg)"
msgstr "Standard search (7d avg)"

#: src/features/timeSeries/experiment/ExperimentTab.tsx
#: src/pages/cases/md/MdCaseReferencesDrawer.tsx
msgid "Start"
msgstr "Start"

#: src/pages/cases/md/MdCaseDetailsPage.tsx
msgid "Start a new chat focused on this case"
msgstr "Start a new chat focused on this case"

#: src/features/timeSeries/agentTab/AgentTab.tsx
msgid "Start a new conversation"
msgstr "Start a new conversation"

#: src/features/knowledgeDocumentViewer/components/table/enhancements/filters/DateFilter.tsx
#: src/features/timeSeries/components/CustomRangePicker.tsx
msgid "Start date"
msgstr "Start date"

#: src/features/timeSeries/components/AbsoluteDateConfig.tsx
#: src/features/timeSeries/components/RelativeDateConfig.tsx
msgid "Start Date"
msgstr "Start Date"

#: src/pages/evaluations/metadata/components/LabelingActions.tsx
#: src/pages/evaluations/metadata/labeling/components/DataLabelingLanding.tsx
msgid "Start labeling"
msgstr "Start labeling"

#: src/features/timeSeries/components/CustomRangePicker.tsx
#: src/features/timeSeries/components/TimeRangeSelector.tsx
#: src/features/timeSeries/components/TimeRangeSelector.tsx
msgid "Start Time"
msgstr "Start Time"

#: src/components/richText/LexicalEditorWrapper.tsx
msgid "Start typing..."
msgstr "Start typing..."

#: src/features/timeSeries/experiment/ExperimentTab.tsx
#: src/features/timeSeries/sentinelStudio/SentinelBuilderPanel.tsx
#: src/pages/cases/md/MdCaseDetailsPage.tsx
msgid "Starting…"
msgstr "Starting…"

#: src/features/timeSeries/agentTab/dock/AlertingTab.tsx
msgid "state"
msgstr "state"

#: src/features/fimReview/InspectSources.tsx
#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
#: src/features/knowledgeDocumentViewer/workOrders/legacyCmmsRecordPdf.ts
#: src/features/knowledgeDocumentViewer/workOrders/legacyCmmsRecordPdf.ts
#: src/features/knowledgeDocumentViewer/workOrders/workOrderPdf.ts
#: src/features/powerCustomerUploads/components/PowerCustomerUploadHistoryPanel.tsx
#: src/features/powerCustomerUploads/components/PowerCustomerUploadStatusFilterMenu.tsx
#: src/pages/alerts/AlertDetails.tsx
#: src/pages/alerts/components/AlertsTableColumns.tsx
#: src/pages/assetLens/components/tabs/AnomalyDashboard.tsx
#: src/pages/cases/components/CaseDetailsSidebar.tsx
#: src/pages/cases/components/CaseMetadataForm.tsx
#: src/pages/cases/md/MdCaseDetailsInspector.tsx
#: src/pages/cases/md/MdCasesCardList.tsx
#: src/pages/cases/md/MdCasesColumnHeader.tsx
#: src/pages/cases/md/mdCasesListSearchContract.ts
#: src/pages/manageAccess/components/table/UsersTableHead.tsx
#: src/pages/systemView/components/unitsTab/FilterControls.tsx
msgid "Status"
msgstr "Status"

#: src/features/mdCases/components/CaseTimeline.tsx
msgid "Status changed"
msgstr "Status changed"

#: src/features/mdCases/components/CaseTimeline.tsx
msgid "Status changed from {fromLabel}"
msgstr "Status changed from {fromLabel}"

#: src/features/mdCases/components/CaseTimeline.tsx
msgid "Status changed from {fromLabel} to {toLabel}"
msgstr "Status changed from {fromLabel} to {toLabel}"

#: src/features/mdCases/components/CaseTimeline.tsx
msgid "Status changed to {toLabel}"
msgstr "Status changed to {toLabel}"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
#: src/features/knowledgeDocumentViewer/workOrders/legacyCmmsRecordPdf.ts
msgid "Status label"
msgstr "Status label"

#: src/features/powerCustomerUploads/components/PowerCustomerUploadHistoryPanel.tsx
#: src/features/powerCustomerUploads/components/powerCustomerUploadHistoryPresentation.ts
#: src/features/powerCustomerUploads/components/powerCustomerUploadHistoryPresentation.ts
msgid "Status unavailable"
msgstr "Status unavailable"

#: src/features/knowledgeDocumentViewer/workOrders/workOrderPresentation.ts
msgid "Status updated"
msgstr "Status updated"

#: src/features/mdCases/components/ProvenanceContentViewer.tsx
msgid "Status: {status}"
msgstr "Status: {status}"

#: src/pages/documents/PowerCustomerUploadLeaveWarning.tsx
msgid "Stay on page"
msgstr "Stay on page"

#: src/pages/processData/buildMode/dock/BandsDockTab.tsx
msgid "Std dev"
msgstr "Std dev"

#: src/features/timeSeries/agentTab/dock/AlertingTab.tsx
msgid "step"
msgstr "step"

#: src/features/timeSeries/experiment/CorrelationCard.tsx
msgid "Step"
msgstr "Step"

#: src/features/timeSeries/agentTab/dock/AlertingTab.tsx
msgid "Step — something changed"
msgstr "Step — something changed"

#: src/features/chatbot/components/ChatbotInputCard.tsx
#: src/features/chatbot/components/conversationMessage/UserMessage.tsx
#: src/features/timeSeries/agentTab/chat/Composer.tsx
msgid "Stop"
msgstr "Stop"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatComposerActionButton.tsx
#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatComposerActionButton.tsx
msgid "Stop generating"
msgstr "Stop generating"

#: src/features/timeSeries/agentTab/chat/Composer.tsx
msgid "Stop the agent"
msgstr "Stop the agent"

#: src/features/chatbot/components/Conversation.tsx
#: src/features/chatbot/components/Conversation.tsx
msgid "Stopped"
msgstr "Stopped"

#: src/features/sentinels/components/SentinelList.tsx
msgid "stopped reporting · "
msgstr "stopped reporting · "

#: src/features/knowledgeDocumentViewer/components/advancedSearch/utils/docChatText.ts
msgid "Stopped."
msgstr "Stopped."

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
#: src/features/knowledgeDocumentViewer/workOrders/workOrderFields.ts
msgid "Storeroom material availability"
msgstr "Storeroom material availability"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
msgid "Storeroom snapshot; not a reservation or availability guarantee."
msgstr "Storeroom snapshot; not a reservation or availability guarantee."

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
#: src/features/knowledgeDocumentViewer/workOrders/legacyCmmsRecordPdf.ts
msgid "Storeroom total balance"
msgstr "Storeroom total balance"

#: src/pages/processData/buildMode/dock/WindowsDockTab.tsx
msgid "Strategy"
msgstr "Strategy"

#: src/pages/details/visualization/screenshot/ScreenshotTools.tsx
msgid "Stretch Asset to Fit Screen"
msgstr "Stretch Asset to Fit Screen"

#: src/features/timeSeries/experiment/knobCopy.ts
msgid "Stride between shifts in the correlation scan (1 = every period). Larger steps make the scan faster but coarser — best-shift picks may land off the true peak."
msgstr "Stride between shifts in the correlation scan (1 = every period). Larger steps make the scan faster but coarser — best-shift picks may land off the true peak."

#: src/features/richText/components/ToolbarPlugin.tsx
msgid "Strikethrough"
msgstr "Strikethrough"

#: src/pages/cases/components/CaseFeedbackModal.tsx
#: src/pages/cases/components/CaseFeedbackModal.tsx
msgid "Strong"
msgstr "Strong"

#: src/features/fimReview/StructuralReviewFlow.tsx
msgid "Structural correction failed: {message}"
msgstr "Structural correction failed: {message}"

#: src/pages/evaluations/metadata/labeling/utils/pageClassificationTaxonomy.ts
msgid "Structural load and capacity analysis"
msgstr "Structural load and capacity analysis"

#: src/pages/details/visualization/tools/StructuresToggle.tsx
msgid "Structures disabled"
msgstr "Structures disabled"

#: src/pages/details/visualization/tools/StructuresToggle.tsx
msgid "Structures shown"
msgstr "Structures shown"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/utils/docChatFeedback.ts
msgid "Style or tone"
msgstr "Style or tone"

#: src/pages/processData/components/helpGuide/HelpGuideChapters.tsx
msgid "Style Pens"
msgstr "Style Pens"

#: src/features/knowledgeDocumentViewer/components/sidebar/KnowledgeDocumentSidebar.tsx
#: src/features/knowledgeDocumentViewer/components/sidebar/SubjectDocumentsPanel.tsx
msgid "Subject"
msgstr "Subject"

#: src/features/fimReview/StructuralReviewFlow.tsx
msgid "Subject {suffix}"
msgstr "Subject {suffix}"

#: src/features/fimReview/IdentityPanel.tsx
msgid "Subject aliases"
msgstr "Subject aliases"

#: src/features/fimReview/StructuralReviewFlow.tsx
msgid "Subject assignment for {recordId}"
msgstr "Subject assignment for {recordId}"

#: src/features/modelOperations/SubjectDetails.tsx
msgid "Subject classification"
msgstr "Subject classification"

#: src/features/fimReview/ReviewActions.tsx
msgid "Subject classification updated."
msgstr "Subject classification updated."

#: src/features/knowledgeDocumentViewer/components/viewer/shared/SubjectTimeSeriesTooltip.tsx
msgid "subject details"
msgstr "subject details"

#: src/features/fimReview/ReviewActions.tsx
msgid "Subject details"
msgstr "Subject details"

#: src/features/fimReview/IdentityPanel.tsx
msgid "Subject history"
msgstr "Subject history"

#: src/pages/facilityModel/SubjectDetailPage.tsx
msgid "Subject identity"
msgstr "Subject identity"

#: src/pages/facilityModel/SubjectDetailPage.tsx
msgid "Subject references"
msgstr "Subject references"

#: src/features/fimReview/ReviewActions.tsx
msgid "Subject review failed: {failureMessage}"
msgstr "Subject review failed: {failureMessage}"

#: src/pages/facilityModel/SubjectDetailPage.tsx
msgid "Subject review failed: {reason}"
msgstr "Subject review failed: {reason}"

#: src/features/fimReview/ReviewActions.tsx
msgid "Subject review outcome"
msgstr "Subject review outcome"

#: src/pages/facilityModel/SubjectDetailPage.tsx
msgid "Subject target picker"
msgstr "Subject target picker"

#: src/features/fimReview/reviewOutcome.ts
msgid "Subject validated."
msgstr "Subject validated."

#: src/features/fimReview/reviewOutcome.ts
msgid "Subject validated. Its Asset Instance will appear in Assets."
msgstr "Subject validated. Its Asset Instance will appear in Assets."

#: src/pages/facilityModel/FacilityModelCatalog.tsx
msgid "Subjects"
msgstr "Subjects"

#: src/pages/facilityModel/FacilityModelFilters.tsx
msgid "Subjects that have an Asset Instance, in any fill state"
msgstr "Subjects that have an Asset Instance, in any fill state"

#: src/features/fimReview/StructuralReviewFlow.tsx
msgid "Subjects:"
msgstr "Subjects:"

#: src/features/chatbot/components/ChatbotHelpModal.tsx
#: src/features/chatbot/components/ChatbotInputCard.tsx
#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatFeedbackDialog.tsx
#: src/features/knowledgeDocumentViewer/components/bugReport/DocumentsBugReportButton.tsx
#: src/features/knowledgeDocumentViewer/components/sidebar/FeedbackModal.tsx
msgid "Submit"
msgstr "Submit"

#: src/pages/details/extensions/flow/assetModelEditorExt/AssetModelEditorRawJSON.tsx
msgid "Submit & Regenerate"
msgstr "Submit & Regenerate"

#: src/features/chatbot/components/ChatbotHelpModal.tsx
msgid "Submit Request"
msgstr "Submit Request"

#: src/features/knowledgeDocumentViewer/components/bugReport/DocumentsBugReportButton.tsx
msgid "Submitting..."
msgstr "Submitting..."

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatFeedbackDialog.tsx
msgid "Submitting…"
msgstr "Submitting…"

#: src/features/facilityModel/columns.ts
#: src/features/fimReview/InspectSources.tsx
#: src/features/fimReview/InspectSources.tsx
#: src/features/fimReview/StructuralReviewFlow.tsx
#: src/features/modelOperations/SubjectDetails.tsx
msgid "Subsystem"
msgstr "Subsystem"

#: src/features/mdCases/components/MonitorLineagePanel.tsx
msgid "Subsystem models ({subsystemModelCount})"
msgstr "Subsystem models ({subsystemModelCount})"

#: src/features/mdCases/components/ProvenanceContentViewer.tsx
#: src/features/mdCases/components/ProvenanceContentViewer.tsx
msgid "Subsystem: {subsystem}"
msgstr "Subsystem: {subsystem}"

#: src/features/notifications/GeckoNotificationContext.tsx
msgid "Success"
msgstr "Success"

#: src/features/timeSeries/services/workOrderService.ts
msgid "Successfully imported {value130_42} work orders."
msgstr "Successfully imported {value130_42} work orders."

#: src/features/chatbot/components/ChatbotHelpModal.tsx
msgid "Successfully sent support email!"
msgstr "Successfully sent support email!"

#: src/pages/details/extensions/flow/assetModelEditorExt/AssetModelEditorRawJSON.tsx
msgid "Successfully updated in Rolodex!"
msgstr "Successfully updated in Rolodex!"

#: src/features/chatbot/components/conversationMessage/ProposalCard.tsx
msgid "Suggested update"
msgstr "Suggested update"

#: src/pages/details/extensions/flow/SummarizerExtension.tsx
#: src/pages/details/extensions/flow/SummarizerExtension.tsx
msgid "Summarize"
msgstr "Summarize"

#: src/features/mdCases/components/ProvenanceContentViewer.tsx
#: src/features/mdCases/components/ProvenanceContentViewer.tsx
#: src/features/mdCases/components/ProvenanceContentViewer.tsx
msgid "Summary"
msgstr "Summary"

#: src/features/chatbot/components/conversationMessage/ProposalCard.tsx
msgid "superseded"
msgstr "superseded"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
#: src/features/knowledgeDocumentViewer/workOrders/workOrderFields.ts
msgid "Supervisor"
msgstr "Supervisor"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
msgid "Supplier identity; not proof of equipment compatibility."
msgstr "Supplier identity; not proof of equipment compatibility."

#: src/features/chatbot/components/ChatbotHelpModal.tsx
msgid "Support request sent successfully"
msgstr "Support request sent successfully"

#: src/features/powerCustomerUploads/components/PowerCustomerUploadSelection.tsx
#: src/pages/assetLens/components/tabs/DocumentsTab.tsx
msgid "Supported: PDF, Word, Excel, PowerPoint"
msgstr "Supported: PDF, Word, Excel, PowerPoint"

#: src/pages/assetLens/components/tabs/imagesTabComponents/ImageUploadModal.tsx
msgid "Supports JPG, PNG, GIF, WEBP. Max 5MB."
msgstr "Supports JPG, PNG, GIF, WEBP. Max 5MB."

#: src/features/fimReview/StructuralReviewFlow.tsx
msgid "Survivor"
msgstr "Survivor"

#: src/features/navbar/LanguageToggle.tsx
msgid "Switch language to English"
msgstr "Switch language to English"

#: src/features/navbar/LanguageToggle.tsx
msgid "Switch language to Spanish"
msgstr "Switch language to Spanish"

#: src/features/facilityModel/columns.ts
#: src/features/facilityModel/columns.ts
#: src/features/fimReview/InspectSources.tsx
#: src/features/fimReview/StructuralReviewFlow.tsx
#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/documentPreview/DocumentPreviewMeta.tsx
#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/documentPreview/PreviewDocumentDetailsSection.tsx
#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/documentsCardView/documentCardFilterBar/types.ts
#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/documentsTableView/DocumentTableColumns.tsx
#: src/features/knowledgeDocumentViewer/components/advancedSearch/utils/constants.ts
#: src/features/knowledgeDocumentViewer/utils/metadataFieldLabelMessages.ts
#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
#: src/features/knowledgeDocumentViewer/workOrders/legacyCmmsRecordPdf.ts
#: src/features/richText/components/slashCommandCards/SystemSlashCommandCard.tsx
#: src/pages/facilityModel/FacilityModelFilters.tsx
#: src/pages/facilityModel/SubjectDetailPage.tsx
msgid "System"
msgstr "System"

#: src/pages/facilityModel/FacilityModelCatalog.tsx
msgid "System {subsystem}"
msgstr "System {subsystem}"

#: src/pages/evaluations/metadata/labeling/utils/pageClassificationTaxonomy.ts
msgid "System connectivity and behavior"
msgstr "System connectivity and behavior"

#: src/features/fimEvidence/SubjectGlyphs.tsx
#: src/features/fimReview/provenance.ts
#: src/features/modelOperations/Corroboration.tsx
msgid "System documents"
msgstr "System documents"

#: src/pages/evaluations/metadata/labeling/utils/pageClassificationTaxonomy.ts
msgid "System integration and network architecture"
msgstr "System integration and network architecture"

#: src/features/navbar/navConfig.ts
#: src/pages/homepage/constants.ts
msgid "System Lens"
msgstr "System Lens"

#: src/pages/evaluations/metadata/labeling/utils/pageClassificationTaxonomy.ts
msgid "System operating principles"
msgstr "System operating principles"

#: src/pages/systemView/components/DataPanel.tsx
msgid "System View"
msgstr "System View"

#: src/features/assetLifecycleV2/views/observations/LtaObservationCompositeViz.tsx
msgid "T Threshold"
msgstr "T Threshold"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/utils/inspectionAnalysisCitations.ts
msgid "t-min by component"
msgstr "t-min by component"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/utils/inspectionAnalysisCitations.ts
msgid "t-min by shell course"
msgstr "t-min by shell course"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/utils/inspectionAnalysisCitations.ts
msgid "t-min given by the user"
msgstr "t-min given by the user"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/ResponseSegmentInspectionChip.tsx
msgid "t-min: {tminMethod}"
msgstr "t-min: {tminMethod}"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocumentViewModeToggle.tsx
msgid "Table"
msgstr "Table"

#: src/features/chatbot/components/AttachmentPills.tsx
#: src/features/fimReview/IdentityPanel.tsx
msgid "tag"
msgstr "tag"

#: src/features/fimReview/InspectSources.tsx
#: src/features/lotoReports/components/LotoSheetPointRow.tsx
#: src/features/timeSeries/components/panes/TagConfigurationList.tsx
#: src/features/timeSeries/components/panes/TagSearchDialog.tsx
#: src/features/timeSeries/components/ScatterPlotTableConfig.tsx
#: src/features/timeSeries/experiment/ExperimentTab.tsx
#: src/features/timeSeries/experiment/TransparencyStrip.tsx
msgid "Tag"
msgstr "Tag"

#: src/features/lotoReports/recordSheet/recordSheetLayout.ts
msgid ""
"Tag\n"
"#"
msgstr ""
"Tag\n"
"#"

#: src/features/lotoReports/components/LotoSheetPointRow.tsx
msgid "Tag #"
msgstr "Tag #"

#: src/pages/processData/components/ProcessDataTopBar.tsx
msgid "tag configuration"
msgstr "tag configuration"

#: src/features/timeSeries/components/panes/TagConfigurationPane.tsx
#: src/features/timeSeries/components/ScatterplotSidebar.tsx
#: src/pages/processData/components/helpGuide/HelpGuideChapters.tsx
msgid "Tag Configuration"
msgstr "Tag Configuration"

#: src/features/sentinels/components/RecentScorePanel.tsx
msgid "Tag drilldown (native interval)"
msgstr "Tag drilldown (native interval)"

#: src/pages/processData/components/ProcessDataTopBar.tsx
msgid "tag legend"
msgstr "tag legend"

#: src/features/timeSeries/agentTab/dock/VersionsTab.tsx
msgid "tag map"
msgstr "tag map"

#: src/features/timeSeries/components/AllTagsTable.tsx
#: src/features/timeSeries/components/SensorScatterplotTableColumns.tsx
#: src/pages/alerts/components/AssetInfoCard.tsx
msgid "Tag Name"
msgstr "Tag Name"

#: src/features/timeSeries/components/ScatterplotSidebar.tsx
msgid "Tag Search"
msgstr "Tag Search"

#: src/features/timeSeries/sentinelStudio/SentinelBuilderPanel.tsx
msgid "Tag source"
msgstr "Tag source"

#: src/features/richText/components/TaggableUsersCard.tsx
msgid "Taggable Users for @ Mentions"
msgstr "Taggable Users for @ Mentions"

#: src/features/timeSeries/components/panes/TagBrowserPane.tsx
#: src/features/timeSeries/components/ScatterplotConfigSidebar.tsx
msgid "Tags"
msgstr "Tags"

#: src/features/timeSeries/agentTab/dock/FitTab.tsx
msgid "Tags come from the chart’s pens. Removing a role the expression uses breaks it."
msgstr "Tags come from the chart’s pens. Removing a role the expression uses breaks it."

#: src/features/timeSeries/agentTab/chat/BuildCard.tsx
msgid "tags picked · dataset “{dataset}”"
msgstr "tags picked · dataset “{dataset}”"

#: src/features/timeSeries/experiment/knobCopy.ts
msgid "Tags used to explain/remove structure from the target. Flatness = variance reduction — how much of the target’s movement those tags account for. Each tag’s chip also shows Spearman ρ, a shape-free rank correlation (“is it related at all”), independent of the chosen method."
msgstr "Tags used to explain/remove structure from the target. Flatness = variance reduction — how much of the target’s movement those tags account for. Each tag’s chip also shows Spearman ρ, a shape-free rank correlation (“is it related at all”), independent of the chosen method."

#: src/pages/processData/buildMode/components/BuildCoverageBanner.tsx
msgid "Tags with a live monitor, out of every tag on this site — plus tags with saved experiments that are not promoted yet."
msgstr "Tags with a live monitor, out of every tag on this site — plus tags with saved experiments that are not promoted yet."

#: src/features/timeSeries/components/panes/TagFilterControls.tsx
msgid "Tags with an active monitor"
msgstr "Tags with an active monitor"

#: src/features/timeSeries/components/panes/TagFilterControls.tsx
msgid "Tags with experiments but no active monitor"
msgstr "Tags with experiments but no active monitor"

#: src/features/timeSeries/components/panes/TagFilterControls.tsx
msgid "Tags with recent data"
msgstr "Tags with recent data"

#: src/features/timeSeries/components/panes/TagFilterControls.tsx
msgid "Tags without recent data"
msgstr "Tags without recent data"

#: src/pages/processData/buildMode/dock/WindowsDockTab.tsx
msgid "Tail fraction"
msgstr "Tail fraction"

#: src/features/timeSeries/experiment/SplitBuilder.tsx
msgid "Tail-split each chunk"
msgstr "Tail-split each chunk"

#: src/features/fim/photos/SubjectPhotoUploader.tsx
msgid "Take a photo"
msgstr "Take a photo"

#: src/pages/details/visualization/screenshot/ScreenshotTools.tsx
msgid "Take Screenshot"
msgstr "Take Screenshot"

#: src/features/timeSeries/components/LabelsTab.tsx
msgid "Take these labels off the chart"
msgstr "Take these labels off the chart"

#: src/features/timeSeries/agentTab/AgentHeader.tsx
msgid "Take this model off the chart"
msgstr "Take this model off the chart"

#: src/features/timeSeries/agentTab/AgentHeader.tsx
msgid "Take this model off the chart and bring your pens back"
msgstr "Take this model off the chart and bring your pens back"

#: src/features/knowledgeDocumentViewer/components/photoMode/PhotoModePanel.tsx
msgid "Tap a highlighted subject to add a photo."
msgstr "Tap a highlighted subject to add a photo."

#: src/pages/processData/buildMode/components/ModelingTagsPane.tsx
msgid "target"
msgstr "target"

#: src/features/timeSeries/experiment/ExperimentTab.tsx
#: src/features/timeSeries/sentinelStudio/SentinelComparison.tsx
#: src/pages/facilityModel/SentinelOverviewPage.tsx
msgid "Target"
msgstr "Target"

#: src/features/sentinels/components/CasesPanel.tsx
#: src/features/sentinels/components/MonitorTab.tsx
msgid "Target "
msgstr "Target "

#: src/pages/facilityModel/SentinelDetailPage.tsx
msgid "target {target}"
msgstr "target {target}"

#: src/features/timeSeries/experiment/ExperimentTab.tsx
msgid "Target / Drivers"
msgstr "Target / Drivers"

#: src/features/timeSeries/experiment/TransparencyStrip.tsx
msgid "Target + all drivers (exact)"
msgstr "Target + all drivers (exact)"

#: src/features/timeSeries/experiment/SamplingKnobs.tsx
msgid "Target and drivers get a stepped line on this grid, fetched the same way training fetches it."
msgstr "Target and drivers get a stepped line on this grid, fetched the same way training fetches it."

#: src/features/lotoReports/components/LotoProposalCard.tsx
#: src/features/lotoReports/components/LotoTargetEquipmentList.tsx
msgid "Target equipment"
msgstr "Target equipment"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
#: src/features/knowledgeDocumentViewer/workOrders/workOrderFields.ts
#: src/features/knowledgeDocumentViewer/workOrders/workOrderPresentation.ts
msgid "Target finish"
msgstr "Target finish"

#: src/pages/processData/buildMode/dock/EngineeringSection.tsx
msgid "target history"
msgstr "target history"

#: src/pages/processData/buildMode/dock/EngineeringSection.tsx
msgid "Target history"
msgstr "Target history"

#: src/features/timeSeries/experiment/TransparencyStrip.tsx
msgid "Target observed"
msgstr "Target observed"

#: src/features/timeSeries/experiment/ExperimentTab.tsx
msgid "Target only (hide driver pens)"
msgstr "Target only (hide driver pens)"

#: src/features/sentinels/components/RecentScorePanel.tsx
msgid "Target scoring — {value451_42} (native interval)"
msgstr "Target scoring — {value451_42} (native interval)"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
#: src/features/knowledgeDocumentViewer/workOrders/workOrderFields.ts
#: src/features/knowledgeDocumentViewer/workOrders/workOrderPresentation.ts
msgid "Target start"
msgstr "Target start"

#: src/features/timeSeries/experiment/NormalizationViewer.tsx
msgid "Target vs normalized (combined + per driver)"
msgstr "Target vs normalized (combined + per driver)"

#: src/features/lotoReports/components/LotoEquipmentCoverage.tsx
msgid "Targeted equipment"
msgstr "Targeted equipment"

#: src/features/knowledgeDocumentViewer/workOrders/workOrderPresentation.ts
msgid "Task (istask=true)"
msgstr "Task (istask=true)"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
#: src/features/knowledgeDocumentViewer/workOrders/legacyCmmsRecordPdf.ts
msgid "Task duration"
msgstr "Task duration"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
#: src/features/knowledgeDocumentViewer/workOrders/workOrderFields.ts
msgid "Task number"
msgstr "Task number"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
msgid "Task record"
msgstr "Task record"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
msgid "Task relationship"
msgstr "Task relationship"

#: src/features/knowledgeDocumentViewer/workOrders/legacyCmmsRecordPdf.ts
msgid "Task relationships"
msgstr "Task relationships"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
#: src/features/knowledgeDocumentViewer/workOrders/legacyCmmsRecordPdf.ts
#: src/features/knowledgeDocumentViewer/workOrders/workOrderFields.ts
msgid "Task sequence"
msgstr "Task sequence"

#: src/features/copcPointClouds/CopcLocalizationColorControl.tsx
msgid "Teal"
msgstr "Teal"

#: src/pages/evaluations/metadata/labeling/utils/pageClassificationTaxonomy.ts
msgid "Technical and compliance requirements"
msgstr "Technical and compliance requirements"

#: src/pages/evaluations/metadata/labeling/utils/pageClassificationTaxonomy.ts
msgid "Technical reference"
msgstr "Technical reference"

#: src/features/knowledgeDocumentViewer/components/bugReport/DocumentsBugReportButton.tsx
msgid "Tell us about the feature you would like..."
msgstr "Tell us about the feature you would like..."

#: src/features/knowledgeDocumentViewer/components/bugReport/DocumentsBugReportButton.tsx
msgid "Tell us what we could improve..."
msgstr "Tell us what we could improve..."

#: src/features/knowledgeDocumentViewer/components/bugReport/DocumentsBugReportButton.tsx
msgid "Tell us what went wrong..."
msgstr "Tell us what went wrong..."

#: src/pages/assetLens/components/tabs/imagesTabComponents/EnvironmentalCorrelationCard.tsx
msgid "temperature"
msgstr "temperature"

#: src/pages/assetLens/components/tabs/ModelViewerTab.tsx
msgid "Temperature"
msgstr "Temperature"

#: src/pages/assetLens/components/tabs/imagesTabComponents/ImageTrendAnalysis.tsx
msgid "Temperature Trend Analysis"
msgstr "Temperature Trend Analysis"

#: src/pages/assetLens/components/tabs/imagesTabComponents/ImageTrendAnalysis.tsx
msgid "Temperature trend is"
msgstr "Temperature trend is"

#: src/features/facilityModel/columns.ts
#: src/features/fimReview/TypeCombobox.tsx
#: src/pages/facilityModel/FacilityModelFilters.tsx
#: src/pages/facilityModel/SubjectAssetPanel.tsx
msgid "Template"
msgstr "Template"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
#: src/features/knowledgeDocumentViewer/workOrders/legacyCmmsRecordPdf.ts
msgid "Term"
msgstr "Term"

#: src/features/navbar/profileAndSettings/ProfileAndSettingsSidebar.tsx
#: src/features/navbar/profileAndSettings/ProfileAndSettingsTopBar.tsx
msgid "Terms of Service"
msgstr "Terms of Service"

#: src/pages/processData/buildMode/components/WindowDrawToolButtons.tsx
msgid "Test"
msgstr "Test"

#: src/features/timeSeries/experiment/SplitBuilder.tsx
msgid "test (red)"
msgstr "test (red)"

#: src/pages/processData/buildMode/dock/BandsDockTab.tsx
msgid "test coverage"
msgstr "test coverage"

#: src/features/timeSeries/experiment/RunComparison.tsx
msgid "Test MAE"
msgstr "Test MAE"

#: src/features/timeSeries/experiment/ExperimentTab.tsx
msgid "Test residual"
msgstr "Test residual"

#: src/features/timeSeries/experiment/RunComparison.tsx
msgid "Test RMSE"
msgstr "Test RMSE"

#: src/features/timeSeries/agentTab/toolSentence.ts
msgid "Tested for step changes"
msgstr "Tested for step changes"

#: src/features/timeSeries/agentTab/toolSentence.ts
msgid "Tested for step changes in {kpi}"
msgstr "Tested for step changes in {kpi}"

#: src/features/timeSeries/agentTab/toolSentence.ts
msgid "Testing for step changes"
msgstr "Testing for step changes"

#: src/features/timeSeries/agentTab/toolSentence.ts
msgid "Testing for step changes in {kpi}"
msgstr "Testing for step changes in {kpi}"

#: src/pages/evaluations/metadata/labeling/utils/pageClassificationTaxonomy.ts
msgid "Testing, inspection, and calibration"
msgstr "Testing, inspection, and calibration"

#: src/features/knowledgeDocumentViewer/components/sidebar/OcrTableColumns.tsx
#: src/pages/site/forms/customFieldInfoFormFields.ts
msgid "Text"
msgstr "Text"

#: src/pages/site/forms/customFieldInfoFormFields.ts
msgid "Text Area"
msgstr "Text Area"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
#: src/features/knowledgeDocumentViewer/workOrders/legacyCmmsRecordPdf.ts
msgid "Text response"
msgstr "Text response"

#: src/features/kestrelUpload/KestrelModelUploadSection.tsx
msgid "Textures"
msgstr "Textures"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatFeedbackDialog.tsx
msgid "Thanks for your feedback"
msgstr "Thanks for your feedback"

#: src/features/lotoReports/recordSheet/recordSheetLayout.ts
msgid "The above equipment has been properly tagged, vented, drained. Work is safe to begin."
msgstr "The above equipment has been properly tagged, vented, drained. Work is safe to begin."

#: src/features/lotoReports/recordSheet/recordSheetLayout.ts
msgid "The above equipment has been released from the LOTO."
msgstr "The above equipment has been released from the LOTO."

#: src/features/timeSeries/agentTab/dock/AgentDock.tsx
msgid "The agent is setting parameters…"
msgstr "The agent is setting parameters…"

#: src/features/timeSeries/sentinelStudio/SentinelBuilderPanel.tsx
msgid "The agent picks the target and drivers from these. At least three are needed."
msgstr "The agent picks the target and drivers from these. At least three are needed."

#: src/features/powerCustomerUploads/api/powerCustomerUploadClient.ts
msgid "The backend could not approve this upload request because it conflicts with existing upload state."
msgstr "The backend could not approve this upload request because it conflicts with existing upload state."

#: src/features/powerCustomerUploads/api/powerCustomerUploadClient.ts
msgid "The backend could not approve this upload request."
msgstr "The backend could not approve this upload request."

#: src/features/timeSeries/agentTab/dock/AgentDock.tsx
msgid "the backtest failed"
msgstr "the backtest failed"

#: src/features/timeSeries/components/SentinelsTab.tsx
msgid "The band and its sigmas are calibrated on interval averages, so raw spikes briefer than the interval are not scored against it"
msgstr "The band and its sigmas are calibrated on interval averages, so raw spikes briefer than the interval are not scored against it"

#: src/features/timeSeries/agentTab/dock/WindowsTab.tsx
msgid "The baseline window is shaded on the Process Data chart whenever this model is drawn, so you can see what it was fitted against rather than taking these dates on trust."
msgstr "The baseline window is shaded on the Process Data chart whenever this model is drawn, so you can see what it was fitted against rather than taking these dates on trust."

#: src/pages/processData/components/helpGuide/HelpGuideChapters.tsx
msgid "The bottom bar sets exact dates, steps between periods, and zooms."
msgstr "The bottom bar sets exact dates, steps between periods, and zooms."

#: src/pages/facilityModel/FacilityModelCatalog.tsx
msgid "The bounded Asset Instance read hit its limit. Asset counts and rows below are incomplete."
msgstr "The bounded Asset Instance read hit its limit. Asset counts and rows below are incomplete."

#: src/features/lotoReports/components/LotoPrintAlert.tsx
msgid "The browser blocked the print dialog."
msgstr "The browser blocked the print dialog."

#: src/pages/cases/md/mdCaseDetailsHelpers.ts
msgid "The case was identified as M&D, but the normalized detail shape is incomplete and cannot be edited here yet."
msgstr "The case was identified as M&D, but the normalized detail shape is incomplete and cannot be edited here yet."

#: src/features/timeSeries/experiment/useLabBucketsOnChart.ts
msgid "The chart's bucket read has no {value100_46} aggregation, so this grid cannot be drawn."
msgstr "The chart's bucket read has no {value100_46} aggregation, so this grid cannot be drawn."

#: src/features/timeSeries/experiment/ExperimentTab.tsx
msgid "The chart's pens and the experiment's tags are the same set: every pen on the chart (including ones already there) joins the experiment — the first as target, the rest as drivers — and target/driver tags picked here plot as pens. Removing either side removes both. Removed points and the trained expected/residual band draw over the pens, with the chart's zoom, tooltip, and ruler. Diagnostics live here."
msgstr "The chart's pens and the experiment's tags are the same set: every pen on the chart (including ones already there) joins the experiment — the first as target, the rest as drivers — and target/driver tags picked here plot as pens. Removing either side removes both. Removed points and the trained expected/residual band draw over the pens, with the chart's zoom, tooltip, and ruler. Diagnostics live here."

#: src/features/knowledgeDocumentViewer/graph/GraphTooltip.tsx
msgid "The connected page has not been resolved in the graph."
msgstr "The connected page has not been resolved in the graph."

#: src/features/fimReview/subjectDecisionBuilders.ts
msgid "The corrected value must be different."
msgstr "The corrected value must be different."

#: src/features/fimReview/StructuralReviewFlow.tsx
msgid "The decision failed."
msgstr "The decision failed."

#: src/features/fimReview/reviewOutcome.ts
msgid "The decision was recorded, but the current subject was not updated. It will apply during the next fusion run."
msgstr "The decision was recorded, but the current subject was not updated. It will apply during the next fusion run."

#: src/features/timeSeries/components/panes/DerivedTagsPane.tsx
msgid "The derived tag could not be saved."
msgstr "The derived tag could not be saved."

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatRevisionMissingCard.tsx
msgid "The document inventory is not fully in scope."
msgstr "The document inventory is not fully in scope."

#: src/features/timeSeries/agentTab/dock/AgentDock.tsx
msgid "the evaluation failed"
msgstr "the evaluation failed"

#: src/features/timeSeries/agentTab/agentKpiPen.ts
msgid "the expression calls {value116_34}, "
msgstr "the expression calls {value116_34}, "

#: src/pages/facilityModel/FacilityModelCatalog.tsx
msgid "The facility model reads the site's published run only. Publish a fusion run in Model Operations to populate it."
msgstr "The facility model reads the site's published run only. Publish a fusion run in Model Operations to populate it."

#: src/pages/processData/buildMode/dock/EngineeringSection.tsx
msgid "The feature set every driver contributes: lagged values, a rolling mean, and forward-fill tolerance. Per-driver phase shifts align a leading driver with the target; the suggestion comes from the correlation scan."
msgstr "The feature set every driver contributes: lagged values, a rolling mean, and forward-fill tolerance. Per-driver phase shifts align a leading driver with the target; the suggestion comes from the correlation scan."

#: src/features/timeSeries/agentTab/dock/WindowsTab.tsx
msgid "The fit has nothing to call healthy and will refuse to run."
msgstr "The fit has nothing to call healthy and will refuse to run."

#: src/features/sentinels/components/DesignRunOverviewSections.tsx
msgid "The full-window refit failed, so this sentinel has no served model and cannot score. The metrics below are still the honest split fit."
msgstr "The full-window refit failed, so this sentinel has no served model and cannot score. The metrics below are still the honest split fit."

#: src/features/timeSeries/sentinelStudio/SentinelBuilderPanel.tsx
msgid "The historian pull and a plot per tag take a few minutes; it appears here on its own when it lands."
msgstr "The historian pull and a plot per tag take a few minutes; it appears here on its own when it lands."

#: src/features/timeSeries/agentTab/dock/AgentDock.tsx
msgid "the history could not be loaded"
msgstr "the history could not be loaded"

#: src/features/fimReview/StructuralReviewFlow.tsx
msgid "The inputs changed. Preview again before applying."
msgstr "The inputs changed. Preview again before applying."

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatInspectionViewer.tsx
#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/InspectionPreviewPanel.tsx
#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/InspectionPreviewPanel.tsx
#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/ReportAssetView.tsx
msgid "The inspection model is unavailable."
msgstr "The inspection model is unavailable."

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatRevisionMissingCard.tsx
msgid "The inventory search is incomplete."
msgstr "The inventory search is incomplete."

#: src/features/timeSeries/agentTab/dock/useModelDraft.ts
msgid "the kNN fit needs at least one driver"
msgstr "the kNN fit needs at least one driver"

#: src/features/timeSeries/agentTab/dock/FitTab.tsx
msgid "The KPI expression uses this role"
msgstr "The KPI expression uses this role"

#: src/features/timeSeries/agentTab/AgentHeader.tsx
msgid "The KPI line cannot draw — {kpiIssue}"
msgstr "The KPI line cannot draw — {kpiIssue}"

#: src/features/timeSeries/agentTab/AgentHeader.tsx
msgid "The KPI line cannot draw: this site has no pen for {missingForKpi}"
msgstr "The KPI line cannot draw: this site has no pen for {missingForKpi}"

#: src/features/timeSeries/agentTab/dock/useModelDraft.ts
msgid "the KPI needs a name"
msgstr "the KPI needs a name"

#: src/features/timeSeries/agentTab/dock/useModelDraft.ts
msgid "the KPI needs an expression"
msgstr "the KPI needs an expression"

#: src/pages/facilityModel/SubjectAssetPanel.tsx
msgid "The last template fill failed."
msgstr "The last template fill failed."

#: src/features/knowledgeDocumentViewer/components/DocumentUnavailablePanel.tsx
msgid "The link may be broken, or the document may not be part of this site's current document set."
msgstr "The link may be broken, or the document may not be part of this site's current document set."

#: src/pages/errorFallback/ErrorFallback.tsx
msgid "The link you followed is missing required information. Try going back, or open the page from the menu."
msgstr "The link you followed is missing required information. Try going back, or open the page from the menu."

#: src/features/timeSeries/agentTab/agentKpiPen.ts
msgid "the model carries no KPI expression"
msgstr "the model carries no KPI expression"

#: src/features/timeSeries/agentTab/ModelPicker.tsx
msgid "The model on the chart is not saved yet, so it is not in this list. Open its card to name and save it."
msgstr "The model on the chart is not saved yet, so it is not in this list. Open its card to name and save it."

#: src/features/fim/photos/PhotoRemoveButton.tsx
msgid "The photo will be removed from this Subject."
msgstr "The photo will be removed from this Subject."

#: src/features/timeSeries/agentTab/dock/useModelDraft.ts
msgid "the refit failed"
msgstr "the refit failed"

#: src/features/knowledgeDocumentViewer/components/metadata/RevisionAuditBadge.tsx
msgid "The revision audit couldn’t complete — one or more sheets were unreadable. Needs review."
msgstr "The revision audit couldn’t complete — one or more sheets were unreadable. Needs review."

#: src/features/knowledgeDocumentViewer/components/metadata/RevisionAuditBadge.tsx
msgid "The revision audit couldn’t complete and needs review"
msgstr "The revision audit couldn’t complete and needs review"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatRevisionMissingCard.tsx
msgid "The revision table scan is incomplete."
msgstr "The revision table scan is incomplete."

#: src/features/timeSeries/agentTab/dock/AgentDock.tsx
msgid "the rule was NOT saved — {value234_40}"
msgstr "the rule was NOT saved — {value234_40}"

#: src/features/timeSeries/agentTab/dock/TargetTab.tsx
msgid "The same spread as IQR/1.349: what the band was before it became a standard deviation. Far below the sd means fat tails."
msgstr "The same spread as IQR/1.349: what the band was before it became a standard deviation. Far below the sd means fat tails."

#: src/pages/processData/buildMode/dock/SamplingSection.tsx
msgid "The sample window is whatever the chart shows — pan or zoom to change what trains. These knobs shape how rows land on the shared time grid: bin width and how bins aggregate. The preview re-runs automatically on every change."
msgstr "The sample window is whatever the chart shows — pan or zoom to change what trains. These knobs shape how rows land on the shared time grid: bin width and how bins aggregate. The preview re-runs automatically on every change."

#: src/features/timeSeries/agentTab/dock/AgentDock.tsx
msgid "the save failed"
msgstr "the save failed"

#: src/pages/processData/components/viewSwitcher/ViewActionDialogs.tsx
msgid "The saved view is removed for everyone at this site. Chart data is not affected."
msgstr "The saved view is removed for everyone at this site. Chart data is not affected."

#: src/pages/cases/md/mdCaseDetailsHelpers.ts
msgid "The selected case could not be loaded for this site. It may have been deleted or moved."
msgstr "The selected case could not be loaded for this site. It may have been deleted or moved."

#: src/features/fimReview/subjectDecisionBuilders.ts
#: src/features/fimReview/subjectDecisionBuilders.ts
msgid "The selected merge target needs to be regenerated first."
msgstr "The selected merge target needs to be regenerated first."

#: src/pages/evaluations/metadata/components/MetricsCard.tsx
msgid "the selected organization"
msgstr "the selected organization"

#: src/features/timeSeries/components/timeSeriesScatterplot/NoDataInRange.tsx
msgid "The selected pens have data"
msgstr "The selected pens have data"

#: src/features/timeSeries/experiment/knobCopy.ts
msgid "The sensor the model tries to predict. Residuals (actual − expected) are what you watch for anomalies on this tag."
msgstr "The sensor the model tries to predict. Residuals (actual − expected) are what you watch for anomalies on this tag."

#: src/features/timeSeries/components/SentinelsTab.tsx
msgid "The Sentinels data layer is off — enable it to see the alerting range on the chart."
msgstr "The Sentinels data layer is off — enable it to see the alerting range on the chart."

#: src/features/fim/photos/SubjectPhotos.tsx
msgid "The site photo list hit the load ceiling, so some photos may be missing from this view."
msgstr "The site photo list hit the load ceiling, so some photos may be missing from this view."

#: src/features/sentinels/components/DesignRunOverviewSections.tsx
msgid "the split fit above"
msgstr "the split fit above"

#: src/features/fimReview/reviewOutcome.ts
msgid "The subject could not be updated."
msgstr "The subject could not be updated."

#: src/features/facilityModel/catalogQuery.ts
msgid "The Subject search timed out — narrow the query and retry."
msgstr "The Subject search timed out — narrow the query and retry."

#: src/pages/details/extensions/flow/filesExt/ReportItem.tsx
msgid "The URL for this file is not available."
msgstr "The URL for this file is not available."

#: src/features/timeSeries/components/SentinelsTab.tsx
msgid "The visible range is longer than the "
msgstr "The visible range is longer than the "

#: src/pages/processData/buildMode/dock/SamplingSection.tsx
msgid "The window follows the chart. Rows are the grid after cleaning and alignment, then how the split assigns them. Zero train or test rows means the window or split needs attention."
msgstr "The window follows the chart. Rows are the grid after cleaning and alignment, then how the split assigns them. Zero train or test rows means the window or split needs attention."

#: src/pages/processData/components/helpGuide/HelpGuideChapters.tsx
msgid "The Workbench at a Glance"
msgstr "The Workbench at a Glance"

#: src/features/navbar/ThemeModeToggle.tsx
msgid "Theme"
msgstr "Theme"

#: src/pages/noSites/NoSites.tsx
msgid "There are no known sites for {organizationName}, or you do not have access to them"
msgstr "There are no known sites for {organizationName}, or you do not have access to them"

#: src/pages/assetLens/components/tabs/imagesTabComponents/EnvironmentalCorrelationCard.tsx
msgid "There is a {percentChange}% change in {readingKind} readings between low and high {factor} conditions. Consider this environmental factor when analyzing {readingKind} data."
msgstr "There is a {percentChange}% change in {readingKind} readings between low and high {factor} conditions. Consider this environmental factor when analyzing {readingKind} data."

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatTurnRows.tsx
msgid "There is likely an issue with the server. Please try again. If the problem persists, please contact support."
msgstr "There is likely an issue with the server. Please try again. If the problem persists, please contact support."

#: src/pages/details/extensions/flow/assetModelEditorExt/AssetModelEditorRawJSON.tsx
msgid "There was an issue parsing the JSON into a GeckoAssetModel! {error}"
msgstr "There was an issue parsing the JSON into a GeckoAssetModel! {error}"

#: src/pages/details/extensions/flow/assetModelEditorExt/AssetModelEditorRawJSON.tsx
msgid "There was an issue parsing the JSON into a GeckoUnit! {error}"
msgstr "There was an issue parsing the JSON into a GeckoUnit! {error}"

#: src/pages/details/extensions/flow/assetModelEditorExt/AssetModelEditorRawJSON.tsx
msgid ""
"There was an issue patching the data into Rolodex! Error below:\n"
"\n"
"{err}"
msgstr ""
"There was an issue patching the data into Rolodex! Error below:\n"
"\n"
"{err}"

#: src/pages/details/extensions/flow/assetModelEditorExt/AssetModelEditorRawJSON.tsx
msgid ""
"There was an issue patching the updated data to the Rolodex Cache! Error below:\n"
"\n"
"{error}"
msgstr ""
"There was an issue patching the updated data to the Rolodex Cache! Error below:\n"
"\n"
"{error}"

#: src/pages/assetLens/components/tabs/imagesTabComponents/EnvironmentalCorrelationCard.tsx
msgid "thermal"
msgstr "thermal"

#: src/pages/assetLens/components/tabs/ModelViewerTab.tsx
msgid "Thermal View"
msgstr "Thermal View"

#: src/features/knowledgeDocumentViewer/utils/sharedMetadataFieldBridge.ts
msgid "These changes also update {surface}: {joined}."
msgstr "These changes also update {surface}: {joined}."

#: src/pages/manageAccess/hooks/useListedRoster.ts
msgid "They lost access, but their sign-in couldn't be removed. Contact an administrator."
msgstr "They lost access, but their sign-in couldn't be removed. Contact an administrator."

#: src/pages/manageAccess/components/dialogs/ConfirmUserTypeChangeDialog.tsx
msgid "They will be able to manage access, including inviting and deactivating people in the selected scope."
msgstr "They will be able to manage access, including inviting and deactivating people in the selected scope."

#: src/pages/manageAccess/components/invite/InviteUsersDialog.tsx
msgid "They will be invited to this site and can be given more sites once they appear on the roster."
msgstr "They will be invited to this site and can be given more sites once they appear on the roster."

#: src/pages/manageAccess/components/dialogs/SiteAccessDialog.tsx
msgid "They will not see any sites."
msgstr "They will not see any sites."

#: src/features/assetLifecycleV2/views/observations/LtaProfilePlot.tsx
#: src/features/assetLifecycleV2/views/shared/MarkupFocusViz.tsx
#: src/features/copcPointClouds/CopcViewerOverlay.tsx
#: src/features/knowledgeDocumentViewer/components/advancedSearch/utils/inspectionLayers.ts
msgid "Thickness"
msgstr "Thickness"

#: src/features/chatbot/components/Conversation.tsx
#: src/features/chatbot/components/Conversation.tsx
msgid "Thinking"
msgstr "Thinking"

#: src/features/kestrelViewer/ui/tools/photoreel/DockedPhotoReelPanel.tsx
#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatCollapsibleThoughts.tsx
#: src/features/timeSeries/agentTab/chat/Transcript.tsx
msgid "Thinking..."
msgstr "Thinking..."

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatTimelineRows.tsx
msgid "Thinking{dots}"
msgstr "Thinking{dots}"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatRevisionMissingCard.tsx
msgid "This audit is not complete, so missing revisions cannot be ruled out."
msgstr "This audit is not complete, so missing revisions cannot be ruled out."

#: src/pages/cases/md/MdCaseDetailsPage.tsx
msgid "This case has no linked alerts to re-analyze."
msgstr "This case has no linked alerts to re-analyze."

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/ReportChart.tsx
msgid "This chart is truncated. Open the source record for complete results."
msgstr "This chart is truncated. Open the source record for complete results."

#: src/features/embeddedSidebar/chatHistory/AgenticChatHistorySessionOverflowMenu.tsx
msgid "This chat will be removed from your history."
msgstr "This chat will be removed from your history."

#: src/features/knowledgeDocumentViewer/workOrders/WorkOrderViewer.tsx
msgid "This CMMS record has changed since it was cited. Showing the latest imported record."
msgstr "This CMMS record has changed since it was cited. Showing the latest imported record."

#: src/features/knowledgeDocumentViewer/workOrders/WorkOrderViewer.tsx
msgid "This CMMS record is unavailable or you do not have access."
msgstr "This CMMS record is unavailable or you do not have access."

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/RevisionComparePreviewPanel.tsx
msgid "This comparison is unavailable for the requested revisions."
msgstr "This comparison is unavailable for the requested revisions."

#: src/features/timeSeries/experiment/useLabTransformsOnChart.ts
msgid "This config builds no rolling features."
msgstr "This config builds no rolling features."

#: src/features/timeSeries/sentinelStudio/SentinelBuilderPanel.tsx
msgid "This context build didn't finish."
msgstr "This context build didn't finish."

#: src/features/fimReview/reviewOutcome.ts
msgid "This decision is taking longer than expected. It may still finish in the background. Refresh this Subject before trying again."
msgstr "This decision is taking longer than expected. It may still finish in the background. Refresh this Subject before trying again."

#: src/features/kestrelUpload/KestrelModelUploadSection.tsx
msgid "This deletes all {count} files in {category}. This cannot be undone."
msgstr "This deletes all {count} files in {category}. This cannot be undone."

#: src/features/kestrelUpload/KestrelModelUploadSection.tsx
msgid "This deletes all source files under assets/models/, including meshes, point clouds, and textures. This cannot be undone."
msgstr "This deletes all source files under assets/models/, including meshes, point clouds, and textures. This cannot be undone."

#: src/pages/cases/md/mdCaseDetailsHelpers.ts
msgid "This detail page only supports M&D cases. The selected case is using a different workflow domain."
msgstr "This detail page only supports M&D cases. The selected case is using a different workflow domain."

#: src/features/knowledgeDocumentViewer/components/metadata/ChooseEditScopePanel.tsx
msgid "This document belongs to a family of {familySize} revisions."
msgstr "This document belongs to a family of {familySize} revisions."

#: src/features/knowledgeDocumentViewer/artifacts/ArtifactPanel.tsx
msgid "This document could not be loaded."
msgstr "This document could not be loaded."

#: src/features/knowledgeDocumentViewer/components/DocumentUnavailablePanel.tsx
msgid "This document exists only under other pipeline configs. Switch this site's active config to view it here."
msgstr "This document exists only under other pipeline configs. Switch this site's active config to view it here."

#: src/features/knowledgeDocumentViewer/components/DocumentUnavailablePanel.tsx
msgid "This document isn't available"
msgstr "This document isn't available"

#: src/features/knowledgeDocumentViewer/components/DocumentUnavailablePanel.tsx
msgid "This document isn't present under any of this site's pipeline configs — it may belong to a different site or have been re-ingested under a new id."
msgstr "This document isn't present under any of this site's pipeline configs — it may belong to a different site or have been re-ingested under a new id."

#: src/pages/facilityModel/SubjectAssetPanel.tsx
msgid "This fill is stale — the Subject or its template changed since it was computed. Re-fill to refresh it."
msgstr "This fill is stale — the Subject or its template changed since it was computed. Re-fill to refresh it."

#: src/pages/forgingsReporting/ForgingsReportPage.tsx
msgid "This inspection is unavailable in the selected reporting scope."
msgstr "This inspection is unavailable in the selected reporting scope."

#: src/pages/details/visualization/Visualization.tsx
msgid "This is a graphical view; use the visualization toolbar controls and the left sidebar to explore the data."
msgstr "This is a graphical view; use the visualization toolbar controls and the left sidebar to explore the data."

#: src/features/timeSeries/components/SentinelsTab.tsx
msgid "This is a legacy multi-tag sentinel; design a new one to manage it here."
msgstr "This is a legacy multi-tag sentinel; design a new one to manage it here."

#: src/pages/facilityModel/SentinelDetailPage.tsx
msgid "This is a legacy multi-tag sentinel."
msgstr "This is a legacy multi-tag sentinel."

#: src/features/timeSeries/components/LabelsTab.tsx
msgid "This label's tags are already on the chart"
msgstr "This label's tags are already on the chart"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatInspectionViewer.tsx
msgid "This layer is unavailable for the selected inspection inputs."
msgstr "This layer is unavailable for the selected inspection inputs."

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatEvalCaseCitations.tsx
msgid "This link does not open a document."
msgstr "This link does not open a document."

#: src/features/knowledgeDocumentViewer/components/DocumentUnavailablePanel.tsx
msgid "This link's config"
msgstr "This link's config"

#: src/features/lotoReports/components/LotoLeaveDialog.tsx
msgid "this LOTO"
msgstr "this LOTO"

#: src/features/lotoReports/useLotoLeaveGuards.ts
msgid "This LOTO has unsaved changes. Leave without saving them?"
msgstr "This LOTO has unsaved changes. Leave without saving them?"

#: src/features/lotoReports/components/LotoLeaveDialog.tsx
msgid "This LOTO has unsaved changes. Save them before you continue, or discard them."
msgstr "This LOTO has unsaved changes. Save them before you continue, or discard them."

#: src/features/lotoReports/components/LotoReportEditorLoader.tsx
msgid "This LOTO report does not exist for the selected site and pipeline configuration. It may have been deleted."
msgstr "This LOTO report does not exist for the selected site and pipeline configuration. It may have been deleted."

#: src/features/lotoReports/components/LotoPagePanel.tsx
msgid "This LOTO report is no longer available."
msgstr "This LOTO report is no longer available."

#: src/features/timeSeries/agentTab/AgentHeader.tsx
msgid "This model is drawn on the chart"
msgstr "This model is drawn on the chart"

#: src/features/timeSeries/agentTab/AgentHeader.tsx
msgid "This model is not saved — open the model card to name and save it"
msgstr "This model is not saved — open the model card to name and save it"

#: src/pages/manageAccess/ManageAccessPage.tsx
msgid "This organization has no sites to manage access for yet."
msgstr "This organization has no sites to manage access for yet."

#: src/features/lotoReports/components/LotoIsolationPointRow.tsx
msgid "This page"
msgstr "This page"

#: src/features/lotoReports/components/LotoSelectedReport.tsx
msgid "This page isn’t in this LOTO yet."
msgstr "This page isn’t in this LOTO yet."

#: src/pages/errorFallback/ErrorFallback.tsx
msgid "This page link is incomplete"
msgstr "This page link is incomplete"

#: src/features/knowledgeDocumentViewer/components/metadata/EvalPagePending.tsx
msgid "This page's metadata is unavailable. Retry or continue to another page."
msgstr "This page's metadata is unavailable. Retry or continue to another page."

#: src/pages/manageAccess/hooks/useListedRoster.ts
msgid "This person has no access in this view to remove."
msgstr "This person has no access in this view to remove."

#: src/features/fim/photos/SubjectPhotoUploader.tsx
msgid "This photo is already attached to this Subject."
msgstr "This photo is already attached to this Subject."

#: src/features/sentinels/components/DesignRunOverviewSections.tsx
msgid "This plan has been fitted, so it is history rather than a draft."
msgstr "This plan has been fitted, so it is history rather than a draft."

#: src/features/timeSeries/components/PenTransformControls.tsx
msgid "This point and the ones before it, like a driver feature."
msgstr "This point and the ones before it, like a driver feature."

#: src/features/facilityModel/components/ReferencePreviewPanel.tsx
msgid "This reference has no page image."
msgstr "This reference has no page image."

#: src/pages/manageAccess/components/dialogs/RevokeUserAccessDialog.tsx
msgid "This removes their access in this view. If they have no access left anywhere, their account is deleted and you will need to reinvite them."
msgstr "This removes their access in this view. If they have no access left anywhere, their account is deleted and you will need to reinvite them."

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/documentsCardView/DocumentResultCard.tsx
#: src/features/knowledgeDocumentViewer/components/toolbar/DocumentHeaderRevisionChip.tsx
msgid "This revision is out of date"
msgstr "This revision is out of date"

#: src/features/sentinels/components/DesignRunDetails.tsx
msgid "This run has no entry yet, so it cannot be monitored."
msgstr "This run has no entry yet, so it cannot be monitored."

#: src/features/timeSeries/sentinelStudio/SentinelBuilderPanel.tsx
msgid "This run started "
msgstr "This run started "

#: src/features/timeSeries/components/SentinelsTab.tsx
msgid "This run stopped reporting and never finished — its job likely died. Delete it and design a new one."
msgstr "This run stopped reporting and never finished — its job likely died. Delete it and design a new one."

#: src/pages/facilityModel/SentinelDetailPage.tsx
msgid "This run stopped reporting and never finished."
msgstr "This run stopped reporting and never finished."

#: src/features/sentinels/components/DesignRunOverviewSections.tsx
msgid "This run stored no fitted methods, so there are no results to show."
msgstr "This run stored no fitted methods, so there are no results to show."

#: src/features/sentinels/components/DesignRunOverviewSections.tsx
msgid "This run stored no readable plan, so what was fitted cannot be shown."
msgstr "This run stored no readable plan, so what was fitted cannot be shown."

#: src/pages/documents/Documents.tsx
msgid "This site does not exist or you do not have access to it."
msgstr "This site does not exist or you do not have access to it."

#: src/features/lotoReports/components/LotoReportsScopeGate.tsx
msgid "This site has no document pipeline configuration, so it has no LOTO reports."
msgstr "This site has no document pipeline configuration, so it has no LOTO reports."

#: src/features/knowledgeDocumentViewer/components/sidebar/SubjectDocumentsPanel.tsx
msgid "this subject"
msgstr "this subject"

#: src/features/fimReview/StructuralReviewFlow.tsx
msgid "This Subject changed after you opened it. Refresh and preview the decision again."
msgstr "This Subject changed after you opened it. Refresh and preview the decision again."

#: src/pages/facilityModel/SubjectDetailPage.tsx
msgid "This Subject cites no documents in the published run."
msgstr "This Subject cites no documents in the published run."

#: src/features/knowledgeDocumentViewer/components/photoMode/PhotoModeSubjectSection.tsx
msgid "This Subject could not be loaded. Tap another highlight."
msgstr "This Subject could not be loaded. Tap another highlight."

#: src/pages/facilityModel/SubjectAssetPanel.tsx
msgid "This Subject has no taxonomy type, so no template can be matched."
msgstr "This Subject has no taxonomy type, so no template can be matched."

#: src/pages/facilityModel/SubjectDetailPage.tsx
msgid "This Subject is not part of the site’s published fusion run."
msgstr "This Subject is not part of the site’s published fusion run."

#: src/features/fimReview/subjectDecisionBuilders.ts
msgid "This Subject needs to be regenerated before it can be merged."
msgstr "This Subject needs to be regenerated before it can be merged."

#: src/features/fimReview/subjectDecisionBuilders.ts
msgid "This Subject needs to be regenerated before it can be split."
msgstr "This Subject needs to be regenerated before it can be split."

#: src/features/fimReview/subjectDecisionBuilders.ts
msgid "This Subject needs to be regenerated before its OCR can be corrected."
msgstr "This Subject needs to be regenerated before its OCR can be corrected."

#: src/pages/assetLens/components/tabs/SensorIssuesTab.tsx
msgid "This tab displays open sensor anomaly cases. Issues are identified by Gecko experts and categorized by severity."
msgstr "This tab displays open sensor anomaly cases. Issues are identified by Gecko experts and categorized by severity."

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/ReportTable.tsx
msgid "This table is truncated. Open the source record for complete results."
msgstr "This table is truncated. Open the source record for complete results."

#: src/pages/processData/buildMode/rightPanel/SavedModelShelf.tsx
msgid "This tag"
msgstr "This tag"

#: src/pages/processData/buildMode/dock/EvalsDockTab.tsx
msgid "this target"
msgstr "this target"

#: src/pages/processData/components/ProcessDataTopBar.tsx
msgid "This view is not saved yet — Save view to keep it"
msgstr "This view is not saved yet — Save view to keep it"

#: src/features/assetLifecycleV2/views/observations/LtaObservationCompositeViz.tsx
msgid "This view requires an inspection thickness layer."
msgstr "This view requires an inspection thickness layer."

#: src/pages/systemView/components/SystemViewAnnotationSidebar.tsx
msgid "This whiteboard has no annotations yet."
msgstr "This whiteboard has no annotations yet."

#: src/pages/cases/md/MdCaseDetailsPage.tsx
msgid "This will erase all generated content on this case — investigation notes, recommendation draft, references, and the chat thread — and replace it with a fresh AI analysis based on the linked alerts. Comments, feedback, the published recommendation, and the case title are preserved. This cannot be undone."
msgstr "This will erase all generated content on this case — investigation notes, recommendation draft, references, and the chat thread — and replace it with a fresh AI analysis based on the linked alerts. Comments, feedback, the published recommendation, and the case title are preserved. This cannot be undone."

#: src/features/timeSeries/components/ActiveTimeRangeSelector.tsx
msgid "This window is at the data's resolution — about one sample every {value437_93}. Zooming in further won't reveal more detail; panning and zooming out still work."
msgstr "This window is at the data's resolution — about one sample every {value437_93}. Zooming in further won't reveal more detail; panning and zooming out still work."

#: src/features/chatbot/components/conversationMessage/AIResponseExtras.tsx
msgid "Thought for {thinkingTime}"
msgstr "Thought for {thinkingTime}"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatCollapsibleThoughts.tsx
#: src/features/knowledgeDocumentViewer/components/advancedSearch/utils/docChatText.ts
msgid "Thoughts"
msgstr "Thoughts"

#: src/features/timeSeries/experiment/knobCopy.ts
msgid "Three different “validation” ideas: (1) timeline Val chunks — if you assign any, they calibrate the residual band scale; (2) if no Val chunks, band scale uses spread calibration blocks carved out of Train; (3) MLP early_stopping also holds out an internal sklearn slice of its fit rows. Prod’s tail-fraction split often leaves Val empty — band still calibrates via (2)."
msgstr "Three different “validation” ideas: (1) timeline Val chunks — if you assign any, they calibrate the residual band scale; (2) if no Val chunks, band scale uses spread calibration blocks carved out of Train; (3) MLP early_stopping also holds out an internal sklearn slice of its fit rows. Prod’s tail-fraction split often leaves Val empty — band still calibrates via (2)."

#: src/features/timeSeries/utils/chartHelpers.ts
msgid "Threshold"
msgstr "Threshold"

#: src/pages/details/extensions/fde/ffsLtaGeneration/FfsLtaGenerationSidebar.tsx
msgid "Threshold ({thresholdUnitId})"
msgstr "Threshold ({thresholdUnitId})"

#: src/features/timeSeries/components/ThresholdConfigurationModal.tsx
msgid "Threshold Configuration"
msgstr "Threshold Configuration"

#: src/pages/assetLens/components/tabs/timeSeriesAnalysis/DataProcessingToolbar.tsx
msgid "Threshold Filtering"
msgstr "Threshold Filtering"

#: src/pages/assetLens/components/tabs/AnomalyDashboard.tsx
msgid "Threshold: {upper} - {lower}"
msgstr "Threshold: {upper} - {lower}"

#: src/features/mdCases/components/ProvenanceContentViewer.tsx
msgid "Thresholds ({thresholdCount})"
msgstr "Thresholds ({thresholdCount})"

#: src/features/knowledgeDocumentViewer/components/bugReport/BugReportAgentModeField.tsx
msgid "Ticket only"
msgstr "Ticket only"

#: src/features/chatbot/components/AttachmentPills.tsx
msgid "time"
msgstr "time"

#: src/features/lotoReports/components/LotoSheetHeaderFields.tsx
#: src/features/timeSeries/hooks/useTimeSeriesDataProcessing.ts
#: src/features/timeSeries/regressionHelpers.ts
#: src/pages/alerts/components/AlertsTableColumns.tsx
#: src/pages/alerts/components/AlertTimeSeriesChart.tsx
msgid "Time"
msgstr "Time"

#: src/features/timeSeries/components/TimeRangeSelector.tsx
#: src/features/timeSeries/components/TimeRangeSelector.tsx
msgid "Time Interval"
msgstr "Time Interval"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatAgentsMenu.tsx
#: src/features/knowledgeDocumentViewer/components/sidebar/TimeSeriesSection.tsx
#: src/pages/cases/md/MdCaseReferencesDrawer.tsx
msgid "Time series"
msgstr "Time series"

#: src/pages/assetLens/components/tabs/canvas/AnalysisState.tsx
msgid "Time Series"
msgstr "Time Series"

#: src/pages/assetLens/components/tabs/canvas/TimeSeriesWorkflow.tsx
msgid "Time Series Points Added"
msgstr "Time Series Points Added"

#: src/features/lotoReports/recordSheet/recordSheetLayout.ts
msgid "TIME:"
msgstr "TIME:"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
#: src/pages/cases/md/MdCaseDetailsPage.tsx
msgid "Timeline"
msgstr "Timeline"

#: src/features/timeSeries/experiment/TransparencyStrip.tsx
msgid "Timeline Val chunks (if you assign any) calibrate the residual band. If Val is empty — which is normal for the prod-like “tail 10%” preset — band scale still uses spread calibration blocks carved out of Train. Separately, each MLP uses sklearn early_stopping on an internal holdout of its fit rows. So “no Val chunks” does not mean the MLP trains with zero validation."
msgstr "Timeline Val chunks (if you assign any) calibrate the residual band. If Val is empty — which is normal for the prod-like “tail 10%” preset — band scale still uses spread calibration blocks carved out of Train. Separately, each MLP uses sklearn early_stopping on an internal holdout of its fit rows. So “no Val chunks” does not mean the MLP trains with zero validation."

#: src/features/chatbot/components/conversationMessage/ProposalCard.tsx
#: src/features/knowledgeDocumentViewer/utils/metadataFieldLabelMessages.ts
#: src/features/timeSeries/components/labelTool/LabelConfigPanel.tsx
#: src/pages/cases/components/CasesTableColumns.tsx
msgid "Title"
msgstr "Title"

#: src/features/cases/components/CaseCreatedContent.tsx
msgid "Title: {caseTitle}"
msgstr "Title: {caseTitle}"

#: src/features/knowledgeDocumentViewer/components/toolbar/PageRangeControls.tsx
msgid "to"
msgstr "to"

#: src/features/knowledgeDocumentViewer/components/revisionCompare/RevisionPairPicker.tsx
#: src/features/knowledgeDocumentViewer/components/toolbar/PageRangeControls.tsx
#: src/features/timeSeries/components/LabelsTab.tsx
msgid "To"
msgstr "To"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
#: src/features/knowledgeDocumentViewer/workOrders/legacyCmmsRecordPdf.ts
msgid "To bin"
msgstr "To bin"

#: src/features/knowledgeDocumentViewer/artifacts/ArtifactPanel.tsx
msgid "To change this document, tell Cantilever what to edit."
msgstr "To change this document, tell Cantilever what to edit."

#: src/features/knowledgeDocumentViewer/graph/offPageConnectorTooltipRows.ts
msgid "To drawing"
msgstr "To drawing"

#: src/features/lotoReports/components/LotoSortablePoints.tsx
msgid "To reorder an isolation point, press Space or Enter on its drag handle, move it with the up and down arrow keys, then press Space or Enter to drop it or Escape to cancel."
msgstr "To reorder an isolation point, press Space or Enter on its drag handle, move it with the up and down arrow keys, then press Space or Enter to drop it or Escape to cancel."

#: src/features/knowledgeDocumentViewer/components/revisionCompare/RevisionPairPicker.tsx
msgid "To revision"
msgstr "To revision"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
#: src/features/knowledgeDocumentViewer/workOrders/legacyCmmsRecordPdf.ts
msgid "To storeroom"
msgstr "To storeroom"

#: src/pages/details/rightSidebar/DetailsRightSidebar.tsx
msgid "Toggle {title} extension"
msgstr "Toggle {title} extension"

#: src/pages/systemView/components/SystemViewAnnotationSidebar.tsx
#: src/pages/systemView/components/SystemViewAnnotationSidebar.tsx
#: src/pages/systemView/components/unitsTab/ActionsRow.tsx
#: src/pages/systemView/components/unitsTab/ActionsRow.tsx
msgid "Toggle Asset Visibility"
msgstr "Toggle Asset Visibility"

#: src/features/forecastNotifications/NotificationsDropdownContent.tsx
msgid "Toggle between all and unread notifications"
msgstr "Toggle between all and unread notifications"

#: src/features/knowledgeDocumentViewer/components/revisionCompare/RevisionCompareContent.tsx
msgid "Toggle change highlighting"
msgstr "Toggle change highlighting"

#: src/pages/cases/md/MdCaseDetailsPage.tsx
msgid "Toggle chatbot"
msgstr "Toggle chatbot"

#: src/pages/details/visualization/tools/features/FeaturesToggle.tsx
msgid "Toggle Features..."
msgstr "Toggle Features..."

#: src/pages/details/visualization/photogrammetry/NiraHud.tsx
msgid "Toggle navigation help"
msgstr "Toggle navigation help"

#: src/features/navbar/Homebar.tsx
#: src/features/navbar/Homebar.tsx
msgid "Toggle navigation menu"
msgstr "Toggle navigation menu"

#: src/features/knowledgeDocumentViewer/components/toolbar/DocumentPreviewModeSwitch.tsx
msgid "Toggle Preview Mode"
msgstr "Toggle Preview Mode"

#: src/features/powerCustomerUploads/api/powerCustomerUploadClient.ts
msgid "Too many files were selected for one upload request."
msgstr "Too many files were selected for one upload request."

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
#: src/features/knowledgeDocumentViewer/workOrders/legacyCmmsRecordPdf.ts
msgid "Tool"
msgstr "Tool"

#: src/features/knowledgeDocumentViewer/workOrders/workOrderPdf.ts
msgid "Tool cost"
msgstr "Tool cost"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatAgentsMenu.tsx
msgid "Tool information"
msgstr "Tool information"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatAgentsMenu.tsx
#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatAgentsMenu.tsx
msgid "Tools"
msgstr "Tools"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatAgentsMenu.tsx
msgid "Tools on: {activeAgentNames}"
msgstr "Tools on: {activeAgentNames}"

#: src/pages/details/visualization/tools/TooltipDisabledToggle.tsx
msgid "Tooltip disabled"
msgstr "Tooltip disabled"

#: src/pages/details/visualization/tools/TooltipDisabledToggle.tsx
msgid "Tooltip disabled (T)"
msgstr "Tooltip disabled (T)"

#: src/pages/details/visualization/tools/TooltipDisabledToggle.tsx
msgid "Tooltip enabled"
msgstr "Tooltip enabled"

#: src/pages/details/visualization/tools/TooltipDisabledToggle.tsx
msgid "Tooltip enabled (T)"
msgstr "Tooltip enabled (T)"

#: src/features/copcPointClouds/CopcOrientationCube.tsx
msgid "Top"
msgstr "Top"

#: src/pages/assetLens/components/tabs/AnomalyDashboard.tsx
msgid "Total Anomalies"
msgstr "Total Anomalies"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
#: src/features/knowledgeDocumentViewer/workOrders/legacyCmmsRecordPdf.ts
msgid "Total cost"
msgstr "Total cost"

#: src/pages/evaluations/metadata/labeling/components/DataLabelingLandingCounts.tsx
msgid "Total deferred"
msgstr "Total deferred"

#: src/pages/evaluations/metadata/labeling/components/DataLabelingLandingCounts.tsx
msgid "Total labeled"
msgstr "Total labeled"

#: src/pages/details/extensions/flow/SummarizerExtension.tsx
msgid "Total number of bins"
msgstr "Total number of bins"

#: src/features/powerCustomerUploads/components/PowerCustomerUploadSummary.tsx
msgid "Total Uploaded"
msgstr "Total Uploaded"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
msgid "Totals"
msgstr "Totals"

#: src/pages/overview/sidebar/assetTracker/SiteViewAssetTracker.tsx
msgid "Tracking {trackedAssetCount}"
msgstr "Tracking {trackedAssetCount}"

#: src/pages/processData/buildMode/components/WindowDrawToolButtons.tsx
msgid "Train"
msgstr "Train"

#: src/features/timeSeries/experiment/ExperimentTab.tsx
msgctxt "model training action"
msgid "Train"
msgstr "Train"

#: src/features/timeSeries/experiment/SplitBuilder.tsx
msgid "train (cyan)"
msgstr "train (cyan)"

#: src/pages/processData/buildMode/components/BuildPrimaryCta.tsx
msgid "Train {methodCount} models"
msgstr "Train {methodCount} models"

#: src/features/timeSeries/experiment/TransparencyStrip.tsx
msgid "Train / val / test"
msgstr "Train / val / test"

#: src/features/timeSeries/experiment/SplitBuilder.tsx
msgid "Train / val / test — click a chunk to cycle roles. Train fits; val calibrates the band; test is held out for metrics."
msgstr "Train / val / test — click a chunk to cycle roles. Train fits; val calibrates the band; test is held out for metrics."

#: src/pages/processData/buildMode/dock/WindowsDockTab.tsx
msgid "Train / val / test windows"
msgstr "Train / val / test windows"

#: src/pages/processData/buildMode/dock/BandsDockTab.tsx
msgid "Train a model to calibrate the band."
msgstr "Train a model to calibrate the band."

#: src/pages/processData/buildMode/rightPanel/CurrentModelPane.tsx
msgid "Train a model to see its metrics here — residuals draw on the chart."
msgstr "Train a model to see its metrics here — residuals draw on the chart."

#: src/pages/processData/buildMode/components/BuildPrimaryCta.tsx
msgid "Train again"
msgstr "Train again"

#: src/features/timeSeries/experiment/useExperimentApi.ts
#: src/features/timeSeries/experiment/useExperimentApi.ts
msgid "train failed"
msgstr "train failed"

#: src/pages/processData/buildMode/rightPanel/CurrentModelPane.tsx
msgid "Train failed: "
msgstr "Train failed: "

#: src/features/timeSeries/experiment/SplitBuilder.tsx
msgid "train frac"
msgstr "train frac"

#: src/pages/processData/buildMode/dock/WindowsDockTab.tsx
msgid "Train fraction"
msgstr "Train fraction"

#: src/pages/processData/buildMode/components/BuildPrimaryCta.tsx
msgid "Train model"
msgstr "Train model"

#: src/features/timeSeries/experiment/DiagnosticsPanel.tsx
msgid "Train results"
msgstr "Train results"

#: src/features/timeSeries/experiment/RunComparison.tsx
msgid "Train runs appear here for side-by-side comparison and persist with the saved experiment."
msgstr "Train runs appear here for side-by-side comparison and persist with the saved experiment."

#: src/pages/processData/buildMode/components/ChartOverlayToggles.tsx
#: src/pages/processData/buildMode/components/ChartOverlayToggles.tsx
msgid "Train/val/test/excl windows"
msgstr "Train/val/test/excl windows"

#: src/features/timeSeries/sentinelStudio/SentinelBuilderPanel.tsx
msgid "Training"
msgstr "Training"

#: src/features/sentinels/components/SentinelList.tsx
msgid "training — {value69_26} · "
msgstr "training — {value69_26} · "

#: src/pages/facilityModel/SentinelDetailPage.tsx
msgid "Training — this updates on its own."
msgstr "Training — this updates on its own."

#: src/features/timeSeries/components/PenTransformControls.tsx
msgid "Training buckets"
msgstr "Training buckets"

#: src/features/timeSeries/components/PenTransformControls.tsx
msgid "Training buckets for this pen"
msgstr "Training buckets for this pen"

#: src/features/timeSeries/experiment/DiagnosticsPanel.tsx
msgid "Training: "
msgstr "Training: "

#: src/features/timeSeries/experiment/ExperimentTab.tsx
#: src/pages/processData/buildMode/rightPanel/CurrentModelPane.tsx
msgid "Training…"
msgstr "Training…"

#: src/features/sentinels/components/SentinelList.tsx
msgid "training… · "
msgstr "training… · "

#: src/pages/processData/buildMode/components/BuildPrimaryCta.tsx
msgid "Training… Cancel"
msgstr "Training… Cancel"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
#: src/features/knowledgeDocumentViewer/workOrders/legacyCmmsRecordPdf.ts
msgid "Transaction date"
msgstr "Transaction date"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
#: src/features/knowledgeDocumentViewer/workOrders/legacyCmmsRecordPdf.ts
msgid "Transaction type"
msgstr "Transaction type"

#: src/features/timeSeries/components/PenDrawer.tsx
msgid "Transforms for {value785_54}"
msgstr "Transforms for {value785_54}"

#: src/pages/evaluations/metadata/labeling/utils/pageClassificationTaxonomy.ts
msgid "Transmittals and document tracking"
msgstr "Transmittals and document tracking"

#: src/pages/evaluations/metadata/components/MetricsContent.tsx
msgid "Trend"
msgstr "Trend"

#: src/features/knowledgeDocumentViewer/components/sidebar/CrossReferencePanel.tsx
#: src/features/knowledgeDocumentViewer/components/viewer/search/ConnectorLookupPanel.tsx
#: src/features/lotoReports/components/LotoPagePanel.tsx
#: src/features/lotoReports/components/LotoReportsListContent.tsx
#: src/features/lotoReports/components/LotoReportsMessage.tsx
#: src/features/timeSeries/agentTab/chat/ConversationDrawer.tsx
msgid "Try again"
msgstr "Try again"

#: src/features/permissions/profiles/power.ts
msgid "Try new Doc Chat agents, such as multi-step search, time series, and maintenance records where available."
msgstr "Try new Doc Chat agents, such as multi-step search, time series, and maintenance records where available."

#: src/features/navbar/KeyboardShortcutsToggle.tsx
msgid "Turn keyboard shortcuts off"
msgstr "Turn keyboard shortcuts off"

#: src/features/navbar/KeyboardShortcutsToggle.tsx
msgid "Turn keyboard shortcuts on"
msgstr "Turn keyboard shortcuts on"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatBetaSwitch.tsx
msgid "Turns on the new Doc Chat tools available at this site. Turn it off to use standard Doc Chat."
msgstr "Turns on the new Doc Chat tools available at this site. Turn it off to use standard Doc Chat."

#: src/features/timeSeries/agentTab/dock/AlertingTab.tsx
msgid "twice daily"
msgstr "twice daily"

#: src/features/knowledgeDocumentViewer/components/toolbar/SettingsMenu.tsx
msgid "Two-page spread"
msgstr "Two-page spread"

#: src/features/facilityModel/columns.ts
#: src/features/fimReview/ReviewActions.tsx
#: src/features/fimReview/ReviewActions.tsx
#: src/features/fimReview/ReviewActions.tsx
#: src/features/fimReview/StructuralReviewFlow.tsx
#: src/features/fimReview/StructuralReviewFlow.tsx
#: src/features/forgingsReporting/ReportsTable.tsx
#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/documentPreview/DocumentPreviewMeta.tsx
#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/documentPreview/PreviewDocumentDetailsSection.tsx
#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/documentsCardView/documentCardFilterBar/types.ts
#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/documentsTableView/DocumentTableColumns.tsx
#: src/features/knowledgeDocumentViewer/components/advancedSearch/utils/constants.ts
#: src/features/knowledgeDocumentViewer/components/bugReport/BugReportTypeField.tsx
#: src/features/knowledgeDocumentViewer/components/sidebar/OcrTableColumns.tsx
#: src/features/knowledgeDocumentViewer/utils/metadataFieldLabelMessages.ts
#: src/features/modelOperations/SubjectDetails.tsx
#: src/pages/cases/components/CaseDetailsSidebar.tsx
#: src/pages/cases/components/CaseMetadataForm.tsx
#: src/pages/evaluations/metadata/labeling/components/DataLabelingTypeFilter.tsx
#: src/pages/facilityModel/FacilityModelFilters.tsx
#: src/pages/facilityModel/SubjectDetailPage.tsx
msgid "Type"
msgstr "Type"

#: src/features/timeSeries/components/panes/tagFilters.ts
msgid "Type {MIN_SEARCH_LENGTH}+ characters to check availability."
msgstr "Type {MIN_SEARCH_LENGTH}+ characters to check availability."

#: src/features/fimReview/DecisionHistory.tsx
msgid "type → {subjectType}"
msgstr "type → {subjectType}"

#: src/features/fimReview/InspectSources.tsx
msgid "Type guess"
msgstr "Type guess"

#: src/pages/processData/components/helpGuide/HelpGuideChapters.tsx
msgid "Type in "
msgstr "Type in "

#: src/features/fimReview/TypeCombobox.tsx
msgid "Type suggestions"
msgstr "Type suggestions"

#: src/features/powerCustomerUploads/components/PowerCustomerUploadHistoryPanel.tsx
msgid "Type unavailable"
msgstr "Type unavailable"

#: src/features/knowledgeDocumentViewer/components/viewer/shared/PositionedTooltip.tsx
msgid "Type: {boxType}"
msgstr "Type: {boxType}"

#: src/features/cases/components/CaseCreatedContent.tsx
msgid "Type: {caseType}"
msgstr "Type: {caseType}"

#: src/features/richText/components/slashCommandCards/InspectionSlashCommandCard.tsx
msgid "Type: {inspectionType}"
msgstr "Type: {inspectionType}"

#: src/features/richText/components/slashCommandCards/SystemSlashCommandCard.tsx
msgid "Type: {systemType}"
msgstr "Type: {systemType}"

#: src/features/timeSeries/experiment/SplitBuilder.tsx
msgid "Un-assigned chunks split in time: their last"
msgstr "Un-assigned chunks split in time: their last"

#: src/features/knowledgeDocumentViewer/utils/resolveMetadataUserEditSaveContext.ts
msgid "Unable to determine current user for edit"
msgstr "Unable to determine current user for edit"

#: src/pages/details/extensions/flow/assetModelEditorExt/AssetModelEditorRawJSON.tsx
msgid "Unable to get value from editor! Current reference is not set!"
msgstr "Unable to get value from editor! Current reference is not set!"

#: src/pages/cases/md/MdCaseDetailsPage.tsx
msgid "Unable to load case details"
msgstr "Unable to load case details"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocumentResultsContent.tsx
msgid "Unable to load documents"
msgstr "Unable to load documents"

#: src/pages/forgingsReporting/ForgingsReportingPage.tsx
msgid "Unable to load saved reports. Please try again."
msgstr "Unable to load saved reports. Please try again."

#: src/pages/documents/CmmsExplorerRoutePage.tsx
msgid "Unable to load the site CMMS configuration."
msgstr "Unable to load the site CMMS configuration."

#: src/features/knowledgeDocumentViewer/components/viewer/shared/SparklineTooltipContent.tsx
#: src/pages/alerts/components/AlertTimeSeriesChart.tsx
msgid "Unable to load time series data"
msgstr "Unable to load time series data"

#: src/pages/noSites/NoSites.tsx
msgid "Unable to locate an organization. Are you sure the ID is correct?"
msgstr "Unable to locate an organization. Are you sure the ID is correct?"

#: src/pages/details/extensions/flow/assetModelEditorExt/AssetModelEditorRawJSON.tsx
msgid "Unable to parse JSON from editor. Reference is not defined!"
msgstr "Unable to parse JSON from editor. Reference is not defined!"

#: src/pages/details/extensions/flow/assetModelEditorExt/AssetModelEditorRawJSON.tsx
msgid "Unable to patch data to Rolodex! Missing field 'raw' on assetModel"
msgstr "Unable to patch data to Rolodex! Missing field 'raw' on assetModel"

#: src/pages/details/extensions/flow/assetModelEditorExt/AssetModelEditorRawJSON.tsx
msgid "Unable to patch data to Rolodex! Missing field 'raw' on unit"
msgstr "Unable to patch data to Rolodex! Missing field 'raw' on unit"

#: src/pages/details/extensions/flow/assetModelEditorExt/AssetModelEditorRawJSON.tsx
msgid "Unable to patch the data to Rolodex! updatedData is undefined!"
msgstr "Unable to patch the data to Rolodex! updatedData is undefined!"

#: src/features/powerCustomerUploads/api/powerCustomerUploadClient.ts
msgid "Unable to reach the upload approval service."
msgstr "Unable to reach the upload approval service."

#: src/pages/cases/md/MdCaseDetailsPage.tsx
msgid "Unable to refresh case details"
msgstr "Unable to refresh case details"

#: src/pages/manageAccess/components/table/UserRowActions.tsx
msgid "Unable to resend invitation. Please try again."
msgstr "Unable to resend invitation. Please try again."

#: src/pages/details/extensions/flow/assetModelEditorExt/AssetModelEditorRawJSON.tsx
msgid "Unable to reset data, it appears the editor reference has not been set!"
msgstr "Unable to reset data, it appears the editor reference has not been set!"

#: src/pages/details/extensions/flow/assetModelEditorExt/AssetModelEditorRawJSON.tsx
msgid "Unable to reset data! assetModel appears to be undefined!"
msgstr "Unable to reset data! assetModel appears to be undefined!"

#: src/pages/details/extensions/flow/assetModelEditorExt/AssetModelEditorRawJSON.tsx
msgid "Unable to reset data! unit appears to be undefined!"
msgstr "Unable to reset data! unit appears to be undefined!"

#: src/pages/details/extensions/flow/filesExt/UploadButton.tsx
msgid "Unable to upload file! The component information is missing"
msgstr "Unable to upload file! The component information is missing"

#: src/pages/details/extensions/flow/filesExt/UploadButton.tsx
msgid "Unable to upload file! The file was unexpectedly missing"
msgstr "Unable to upload file! The file was unexpectedly missing"

#: src/pages/details/extensions/flow/filesExt/UploadButton.tsx
msgid "Unable to upload report! CDF is missing"
msgstr "Unable to upload report! CDF is missing"

#: src/pages/details/extensions/flow/assetModelEditorExt/AssetModelEditorRawJSON.tsx
msgid "Unable to validate and patch new data! Missing field 'raw' on assetModel"
msgstr "Unable to validate and patch new data! Missing field 'raw' on assetModel"

#: src/pages/details/extensions/flow/assetModelEditorExt/AssetModelEditorRawJSON.tsx
msgid "Unable to validate and patch new data! Missing field 'raw' on unit"
msgstr "Unable to validate and patch new data! Missing field 'raw' on unit"

#: src/features/timeSeries/agentTab/dock/AgentDock.tsx
msgid "Unapplied edits — the chart still shows the saved fit."
msgstr "Unapplied edits — the chart still shows the saved fit."

#: src/features/embeddedSidebar/chatHistory/AgenticChatHistorySessionOverflowMenu.tsx
#: src/features/forecastNotifications/NotificationDetailPanel.tsx
msgid "Unarchive"
msgstr "Unarchive"

#: src/features/embeddedSidebar/chatHistory/ChatHistoryOverflowMenu.tsx
msgid "Unarchive all"
msgstr "Unarchive all"

#: src/features/embeddedSidebar/chatHistory/ChatHistoryBulkActionDialog.tsx
msgid "Unarchive all chats?"
msgstr "Unarchive all chats?"

#: src/features/embeddedSidebar/chatHistory/ChatHistoryBulkActionDialog.tsx
msgid "Unarchive chats"
msgstr "Unarchive chats"

#: src/features/embeddedSidebar/chatHistory/AgenticChatHistorySessionRow.tsx
#: src/features/embeddedSidebar/chatHistory/ChatHistoryBulkActionDialog.tsx
msgid "Unarchiving…"
msgstr "Unarchiving…"

#: src/features/fimReview/StructuralReviewFlow.tsx
msgid "Unassigned"
msgstr "Unassigned"

#: src/features/fim/photos/PhotoLightbox.tsx
msgid "Unattached"
msgstr "Unattached"

#: src/features/knowledgeDocumentViewer/components/metadata/RevisionFamilyDropdownItem.tsx
#: src/pages/evaluations/metadata/dashboard/components/dataLabeling/DataLabelingDashboardComparisonRow.tsx
msgid "Unavailable"
msgstr "Unavailable"

#: src/features/timeSeries/agentTab/chat/BuildCard.tsx
msgid "unchanged"
msgstr "unchanged"

#: src/features/knowledgeDocumentViewer/components/revisionCompare/RevisionStatusLegend.tsx
msgid "Unclassified"
msgstr "Unclassified"

#: src/features/mdCases/components/ProvenanceContentViewer.tsx
msgid "Under {parentLabel}"
msgstr "Under {parentLabel}"

#: src/pages/assetLens/components/tabs/AnomalyDashboard.tsx
msgid "Under Investigation"
msgstr "Under Investigation"

#: src/features/richText/components/ToolbarPlugin.tsx
msgid "Underline (Ctrl+U)"
msgstr "Underline (Ctrl+U)"

#: src/pages/details/extensions/flow/AssetModelEditorExtension.tsx
msgid "Unexpected AssetEditor state"
msgstr "Unexpected AssetEditor state"

#: src/pages/details/extensions/flow/AssetModelEditorExtension.tsx
msgid "Unexpected state!"
msgstr "Unexpected state!"

#: src/features/sentinels/components/SentinelList.tsx
#: src/features/timeSeries/components/SentinelsTab.tsx
msgid "Unfinished"
msgstr "Unfinished"

#: src/features/sentinels/components/SentinelList.tsx
msgid "unfinished · "
msgstr "unfinished · "

#: src/features/timeSeries/components/LabelsTab.tsx
msgid "Ungrouped"
msgstr "Ungrouped"

#: src/pages/metrics/components/DailySearchesChart.tsx
#: src/pages/metrics/Metrics.tsx
msgid "Unique users"
msgstr "Unique users"

#: src/pages/metrics/components/DailySearchesChart.tsx
msgid "Unique users (7d avg)"
msgstr "Unique users (7d avg)"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/sensors/SensorPreviewPanel.tsx
#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/sensors/SensorTableColumns.tsx
#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
#: src/features/knowledgeDocumentViewer/workOrders/legacyCmmsRecordPdf.ts
#: src/features/richText/components/slashCommandCards/UnitSlashCommandCard.tsx
#: src/features/timeSeries/components/panes/TagSearchDialog.tsx
#: src/features/timeSeries/experiment/SamplingKnobs.tsx
#: src/pages/alerts/components/AlertsTableColumns.tsx
#: src/pages/details/extensions/flow/filesExt/FileTags.tsx
msgid "Unit"
msgstr "Unit"

#: src/features/timeSeries/experiment/TagLabel.tsx
msgid "Unit "
msgstr "Unit "

#: src/features/timeSeries/components/DerivedValues.tsx
#: src/features/timeSeries/components/panes/DerivedTagsPane.tsx
msgid "Unit (e.g., kW, m/s)"
msgstr "Unit (e.g., kW, m/s)"

#: src/features/timeSeries/components/FormulaBuilder.tsx
msgid "Unit conversions:"
msgstr "Unit conversions:"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
#: src/features/knowledgeDocumentViewer/workOrders/legacyCmmsRecordPdf.ts
msgid "Unit cost"
msgstr "Unit cost"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
#: src/features/knowledgeDocumentViewer/workOrders/legacyCmmsRecordPdf.ts
msgid "Unit cost in transaction currency"
msgstr "Unit cost in transaction currency"

#: src/features/timeSeries/experiment/knobCopy.ts
msgid "Unit for the aggregate bin width (seconds / minutes / hours). Only used in aggregate mode."
msgstr "Unit for the aggregate bin width (seconds / minutes / hours). Only used in aggregate mode."

#: src/pages/site/components/CustomFieldsTableColumns.tsx
#: src/pages/site/forms/customFieldInfoFormFields.ts
msgid "Unit Magnitude"
msgstr "Unit Magnitude"

#: src/pages/overview/sidebar/filterSelects/unitFilter/UnitTypeFilter.tsx
msgid "Unit Type:"
msgstr "Unit Type:"

#: src/features/mdCases/components/ProvenanceContentViewer.tsx
msgid "Unit: {unit}"
msgstr "Unit: {unit}"

#: src/features/mdCases/components/ProvenanceContentViewer.tsx
#: src/features/navbar/UnitsToggle.tsx
msgid "Units"
msgstr "Units"

#: src/features/knowledgeDocumentViewer/components/revisionCompare/RevisionCompareContent.tsx
#: src/features/knowledgeDocumentViewer/components/revisionCompare/RevisionPairPicker.tsx
msgid "unknown"
msgstr "unknown"

#: src/features/mdCases/mdCaseDisplay.ts
#: src/features/mdCases/mdCaseDisplay.ts
#: src/features/mdCases/mdCaseDisplay.ts
#: src/features/mdCases/mdCaseDisplay.ts
#: src/features/mdCases/mdCaseDisplay.ts
#: src/features/mdCases/mdCaseDisplay.ts
#: src/features/mdCases/mdCaseDisplay.ts
#: src/pages/alerts/AlertDetails.tsx
#: src/pages/alerts/AlertDetails.tsx
#: src/pages/alerts/components/AlertsTableColumns.tsx
#: src/pages/alerts/components/AlertsTableColumns.tsx
#: src/pages/alerts/components/AlertsTableColumns.tsx
#: src/pages/alerts/components/AlertsTableColumns.tsx
#: src/pages/alerts/components/AssetInfoCard.tsx
#: src/pages/alerts/components/AssetInfoCard.tsx
#: src/pages/cases/md/MdCaseDetailsInspector.tsx
#: src/pages/facilityModel/SubjectAssetPanel.tsx
#: src/pages/overview/sidebar/filterSelects/unitFilter/UnitTypeFilter.tsx
msgid "Unknown"
msgstr "Unknown"

#: src/features/lotoReports/components/LotoDrawingsCoverage.tsx
#: src/features/lotoReports/printReport/printPageText.ts
msgid "Unknown drawing"
msgstr "Unknown drawing"

#: src/pages/cases/md/mdCaseDetailsHelpers.ts
#: src/pages/cases/md/MdCaseDetailsInspector.tsx
msgid "Unknown end"
msgstr "Unknown end"

#: src/features/chatbot/api/sseClient.ts
#: src/features/chatbot/hooks/useMessageSender.ts
#: src/pages/details/extensions/DetailsPageExtensionsProvider.tsx
#: src/pages/details/extensions/DetailsPageExtensionsProvider.tsx
#: src/pages/details/extensions/DetailsPageExtensionsProvider.tsx
#: src/pages/errorFallback/ErrorFallback.tsx
msgid "Unknown error"
msgstr "Unknown error"

#: src/pages/details/extensions/flow/filesExt/UploadButton.tsx
msgid "Unknown patch error!"
msgstr "Unknown patch error!"

#: src/features/fimReview/provenance.ts
msgid "Unknown source"
msgstr "Unknown source"

#: src/pages/cases/md/mdCaseDetailsHelpers.ts
#: src/pages/cases/md/MdCaseDetailsInspector.tsx
msgid "Unknown start"
msgstr "Unknown start"

#: src/pages/assetLens/components/AssetHeader.tsx
#: src/pages/systemView/components/HealthPlansModal.tsx
msgid "Unknown Unit"
msgstr "Unknown Unit"

#: src/pages/details/extensions/flow/filesExt/UploadButton.tsx
msgid "Unknown upload error!"
msgstr "Unknown upload error!"

#: src/pages/cases/contexts/CaseDetailsProvider.tsx
#: src/pages/cases/contexts/CaseDetailsProvider.tsx
#: src/pages/cases/md/MdCaseDetailsProvider.tsx
#: src/pages/cases/md/MdCaseDetailsProvider.tsx
msgid "Unknown User"
msgstr "Unknown User"

#: src/features/knowledgeDocumentViewer/components/metadata/PageMetadataEvalStatusChip.tsx
msgid "Unlabeled"
msgstr "Unlabeled"

#: src/pages/evaluations/metadata/labeling/components/DataLabelingLandingCounts.tsx
msgid "Unlabeled remaining"
msgstr "Unlabeled remaining"

#: src/pages/facilityModel/SubjectAssetPanel.tsx
msgid "Unmet required slots:"
msgstr "Unmet required slots:"

#: src/features/sentinels/coverage.ts
msgid "Unmonitored"
msgstr "Unmonitored"

#: src/features/timeSeries/components/panes/TagFilterControls.tsx
msgid "Unmonitored tags"
msgstr "Unmonitored tags"

#: src/features/lotoReports/components/LotoIsolationPointRow.tsx
#: src/features/lotoReports/components/LotoSheetPointRow.tsx
msgid "Unnamed point"
msgstr "Unnamed point"

#: src/pages/manageAccess/hooks/useListedRoster.ts
#: src/pages/manageAccess/utils/rolodex/rolodexUserMapping.ts
#: src/pages/manageAccess/utils/rolodex/rolodexUserMapping.ts
msgid "Unnamed user"
msgstr "Unnamed user"

#: src/features/embeddedSidebar/chatHistory/AgenticChatHistorySessionOverflowMenu.tsx
msgid "Unpin"
msgstr "Unpin"

#: src/pages/cases/components/EditCaseForm.tsx
msgid "Unpublish"
msgstr "Unpublish"

#: src/features/mdCases/mdCaseDisplay.ts
#: src/pages/cases/md/MdCaseDetailsMainColumn.tsx
msgid "Unpublished"
msgstr "Unpublished"

#: src/features/forecastNotifications/NotificationsDropdownContent.tsx
#: src/features/forecastNotifications/notificationUtils.ts
msgid "Unread"
msgstr "Unread"

#: src/features/knowledgeDocumentViewer/graph/offPageConnectorTooltipRows.ts
#: src/pages/facilityModel/SubjectAssetPanel.tsx
msgid "Unresolved"
msgstr "Unresolved"

#: src/pages/processData/components/ProcessDataTopBar.tsx
msgid "Unsaved"
msgstr "Unsaved"

#: src/features/timeSeries/components/chartActions/ChartSaveAction.tsx
#: src/features/timeSeries/components/chartActions/ChartSaveAction.tsx
#: src/features/timeSeries/components/chartActions/MarkupToolButtons.tsx
#: src/features/timeSeries/components/chartActions/MarkupToolButtons.tsx
msgid "Unsaved annotation changes"
msgstr "Unsaved annotation changes"

#: src/features/lotoReports/components/LotoEditorSaveState.tsx
#: src/features/lotoReports/components/LotoSaveStatusText.tsx
#: src/pages/processData/components/viewSwitcher/ViewSwitcher.tsx
msgid "Unsaved changes"
msgstr "Unsaved changes"

#: src/pages/cases/md/MdCaseDetailsPage.tsx
msgid "Unsaved recommendation edits will be saved first."
msgstr "Unsaved recommendation edits will be saved first."

#: src/pages/cases/md/mdCaseDetailsHelpers.ts
msgid "Unsupported case type"
msgstr "Unsupported case type"

#: src/features/lotoReports/components/LotoPointsCoverage.tsx
msgid "Untagged"
msgstr "Untagged"

#: src/features/lotoReports/components/LotoProposalCard.tsx
msgid "Untagged point"
msgstr "Untagged point"

#: src/pages/cases/md/MdCaseDetailsMainColumn.tsx
#: src/pages/cases/md/MdCaseDetailsMainColumn.tsx
#: src/pages/cases/md/MdCasesCardList.tsx
msgid "Untitled case"
msgstr "Untitled case"

#: src/pages/cases/components/CaseDetailsContent.tsx
#: src/pages/cases/components/EditableCaseTitle.tsx
msgid "Untitled Case"
msgstr "Untitled Case"

#: src/features/timeSeries/components/DashboardHeader.tsx
#: src/pages/processData/utils/chartDisplayName.ts
msgid "Untitled Chart"
msgstr "Untitled Chart"

#: src/features/lotoReports/components/LotoAttachmentsSection.tsx
#: src/features/lotoReports/components/LotoIsolationPointRow.tsx
#: src/features/lotoReports/components/LotoSessionOtherPages.tsx
#: src/features/lotoReports/components/LotoSheetPointRow.tsx
msgid "Untitled document"
msgstr "Untitled document"

#: src/features/timeSeries/components/LabelsTab.tsx
#: src/features/timeSeries/components/labelTool/LabelOverlay.tsx
#: src/pages/processData/buildMode/dock/EvalLabelTable.tsx
msgid "Untitled label"
msgstr "Untitled label"

#: src/pages/processData/components/ProcessDataTopBar.tsx
#: src/pages/processData/components/WorkbenchBody.tsx
msgid "Untitled view"
msgstr "Untitled view"

#: src/features/timeSeries/components/DerivedValues.tsx
#: src/features/timeSeries/components/panes/DerivedTagsPane.tsx
msgid "Update"
msgstr "Update"

#: src/features/knowledgeDocumentViewer/components/table/enhancements/BulkEditModal.tsx
msgid "Update Rows"
msgstr "Update Rows"

#: src/features/timeSeries/experiment/ExperimentTab.tsx
msgid "Update save"
msgstr "Update save"

#: src/features/knowledgeDocumentViewer/artifacts/sheet/FreeformDocumentSheet.tsx
#: src/features/knowledgeDocumentViewer/artifacts/sheet/FreeformDocumentSheet.tsx
#: src/pages/cases/md/MdCasesCardList.tsx
#: src/pages/cases/md/MdCasesColumnHeader.tsx
msgid "Updated"
msgstr "Updated"

#: src/features/knowledgeDocumentViewer/workOrders/WorkOrderCardMetadata.tsx
msgid "Updated {updated}"
msgstr "Updated {updated}"

#: src/pages/cases/md/MdCaseDetailsMainColumn.tsx
msgid "Updated {updatedAtLabel}"
msgstr "Updated {updatedAtLabel}"

#: src/features/mdCases/components/ProvenanceContentViewer.tsx
msgid "Updated {updatedLabel}"
msgstr "Updated {updatedLabel}"

#: src/features/cases/components/CaseContentUpdatedContent.tsx
msgid "Updated case content"
msgstr "Updated case content"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/utils/docChatText.ts
msgid "Updated search query and found {resultLabel}"
msgstr "Updated search query and found {resultLabel}"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatTimelineRows.tsx
msgid "Updated search query and found <0>{resultLabel}</0>"
msgstr "Updated search query and found <0>{resultLabel}</0>"

#: src/pages/assetLens/components/tabs/SensorIssuesTab.tsx
msgid "Updated: {updatedAt}"
msgstr "Updated: {updatedAt}"

#: src/pages/facilityModel/FacilityModelTable.tsx
msgid "Updating results…"
msgstr "Updating results…"

#: src/features/powerCustomerUploads/components/powerCustomerUploadHistoryPresentation.ts
#: src/features/powerCustomerUploads/components/PowerCustomerUploadReviewTable.tsx
#: src/features/powerCustomerUploads/components/PowerCustomerUploadSelection.tsx
#: src/pages/assetLens/components/tabs/imagesTabComponents/ImageUploadModal.tsx
msgid "Upload"
msgstr "Upload"

#: src/features/powerCustomerUploads/components/powerCustomerUploadHistoryPresentation.ts
msgid "Upload · {date}"
msgstr "Upload · {date}"

#: src/pages/assetLens/components/tabs/imagesTabComponents/ImageGalleryView.tsx
#: src/pages/assetLens/components/tabs/imagesTabComponents/ImageTimelineView.tsx
#: src/pages/assetLens/components/tabs/imagesTabComponents/ImageUploadModal.tsx
msgid "Upload Acoustic Image"
msgstr "Upload Acoustic Image"

#: src/features/powerCustomerUploads/api/powerCustomerUploadClient.ts
#: src/features/powerCustomerUploads/api/powerCustomerUploadClient.ts
msgid "Upload approval request was cancelled."
msgstr "Upload approval request was cancelled."

#: src/pages/assetLens/components/tabs/DocumentsTab.tsx
msgid "Upload Date"
msgstr "Upload Date"

#: src/features/powerCustomerUploads/state/powerCustomerUploadHistoryRows.ts
msgid "Upload did not finish."
msgstr "Upload did not finish."

#: src/pages/assetLens/components/tabs/DocumentsTab.tsx
msgid "Upload Document"
msgstr "Upload Document"

#: src/features/powerCustomerUploads/components/PowerCustomerUploadSelection.tsx
msgid "Upload documents"
msgstr "Upload documents"

#: src/features/navbar/profileAndSettings/ProfileAndSettingsSidebar.tsx
msgid "Upload Documents"
msgstr "Upload Documents"

#: src/features/fim/photos/PhotoUploadRow.tsx
#: src/features/powerCustomerUploads/components/PowerCustomerUploadStatus.tsx
msgid "Upload failed"
msgstr "Upload failed"

#: src/features/powerCustomerUploads/components/PowerCustomerUploadSelection.tsx
msgid "Upload Files"
msgstr "Upload Files"

#: src/features/powerCustomerUploads/components/PowerCustomerUploadPicker.tsx
msgid "Upload files or folders separately. Drop only files or only folders."
msgstr "Upload files or folders separately. Drop only files or only folders."

#: src/features/powerCustomerUploads/uploadRequest/powerCustomerUploadApprovalPipeline.ts
msgid "Upload finalization failed."
msgstr "Upload finalization failed."

#: src/features/powerCustomerUploads/components/PowerCustomerUploadSelection.tsx
msgid "Upload Folder"
msgstr "Upload Folder"

#: src/features/powerCustomerUploads/hooks/usePowerCustomerUploadHistory.ts
msgid "Upload history could not be loaded."
msgstr "Upload history could not be loaded."

#: src/features/powerCustomerUploads/hooks/usePowerCustomerUploadHistory.ts
msgid "Upload history could not be loaded. {detail}"
msgstr "Upload history could not be loaded. {detail}"

#: src/features/richText/components/ToolbarPlugin.tsx
msgid "Upload Image"
msgstr "Upload Image"

#: src/features/powerCustomerUploads/components/PowerCustomerUploadStatus.tsx
msgid "Upload incomplete"
msgstr "Upload incomplete"

#: src/pages/assetLens/components/tabs/imagesTabComponents/ImageGalleryView.tsx
#: src/pages/assetLens/components/tabs/imagesTabComponents/ImageTimelineView.tsx
#: src/pages/assetLens/components/tabs/imagesTabComponents/ImageUploadModal.tsx
msgid "Upload IR Image"
msgstr "Upload IR Image"

#: src/features/permissions/profiles/power.ts
msgid "Upload new documents."
msgstr "Upload new documents."

#: src/pages/assetLens/components/tabs/imagesTabComponents/ImageGalleryView.tsx
#: src/pages/assetLens/components/tabs/imagesTabComponents/ImageTimelineView.tsx
msgid "Upload New Image"
msgstr "Upload New Image"

#: src/features/powerCustomerUploads/components/PowerCustomerUploadReviewTablePagination.tsx
msgid "Upload pages"
msgstr "Upload pages"

#: src/pages/details/extensions/flow/FilesExtension.tsx
msgid "Upload report"
msgstr "Upload report"

#: src/features/powerCustomerUploads/components/PowerCustomerUploadHistoryPanel.tsx
msgid "Upload type"
msgstr "Upload type"

#: src/pages/assetLens/components/AssetDocumentsWrapper.tsx
msgid "Upload your first document to get started. Drag & drop or click the upload zone above."
msgstr "Upload your first document to get started. Drag & drop or click the upload zone above."

#: src/features/fim/photos/PhotoUploadRow.tsx
#: src/features/powerCustomerUploads/components/PowerCustomerUploadStatus.tsx
#: src/features/powerCustomerUploads/components/PowerCustomerUploadStatus.tsx
msgid "Uploaded"
msgstr "Uploaded"

#: src/features/fim/photos/PhotoLightbox.tsx
msgid "Uploaded by {uploader}"
msgstr "Uploaded by {uploader}"

#: src/features/fim/photos/PhotoLightbox.tsx
msgid "Uploaded by {uploader} on {uploadedAt}"
msgstr "Uploaded by {uploader} on {uploadedAt}"

#: src/features/powerCustomerUploads/components/powerCustomerUploadProgressModel.ts
#: src/features/powerCustomerUploads/components/PowerCustomerUploadStatus.tsx
#: src/features/powerCustomerUploads/components/PowerCustomerUploadStatus.tsx
#: src/features/powerCustomerUploads/components/PowerCustomerUploadStatus.tsx
msgid "Uploading"
msgstr "Uploading"

#: src/features/richText/components/ToolbarPlugin.tsx
#: src/features/richText/editorPlugins/DragDropPastePlugin.tsx
msgid "Uploading image..."
msgstr "Uploading image..."

#: src/features/richText/components/ToolbarPlugin.tsx
msgid "Uploading..."
msgstr "Uploading..."

#: src/features/fim/photos/PhotoUploadRow.tsx
#: src/features/timeSeries/sentinelStudio/SentinelBuilderPanel.tsx
msgid "Uploading…"
msgstr "Uploading…"

#: src/features/timeSeries/utils/chartHelpers.ts
msgid "Upper"
msgstr "Upper"

#: src/features/timeSeries/utils/chartHelpers.ts
msgid "Upper High"
msgstr "Upper High"

#: src/features/timeSeries/components/ThresholdConfigurationModal.tsx
msgid "Upper High:"
msgstr "Upper High:"

#: src/features/timeSeries/components/ThresholdConfigurationModal.tsx
msgid "Upper:"
msgstr "Upper:"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
msgid "Usage split"
msgstr "Usage split"

#: src/features/knowledgeDocumentViewer/workOrders/legacyCmmsRecordPdf.ts
msgid "Usage splits"
msgstr "Usage splits"

#: src/features/lotoReports/components/LotoPresetCombobox.tsx
msgid "Use “{typed}”"
msgstr "Use “{typed}”"

#: src/features/modelOperations/SubjectTargetPickerColumn.tsx
#: src/features/modelOperations/SubjectTargetPickerColumn.tsx
msgid "Use {selectedName}"
msgstr "Use {selectedName}"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatEvalCaseCitations.tsx
msgid "Use a DOC-… document id, or a link to a document opened from search."
msgstr "Use a DOC-… document id, or a link to a document opened from search."

#: src/pages/processData/buildMode/dock/EngineeringSection.tsx
msgid "Use best"
msgstr "Use best"

#: src/features/timeSeries/experiment/ExperimentTab.tsx
msgid "Use chart range"
msgstr "Use chart range"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatEvalCaseReview.tsx
msgid "Use lowercase letters, numbers, hyphens, and underscores."
msgstr "Use lowercase letters, numbers, hyphens, and underscores."

#: src/features/timeSeries/components/ScatterPlotTableLegend.tsx
#: src/features/timeSeries/components/timeSeriesScatterplot/TimeSeriesScatterplotChart.tsx
msgid "Use the Edit pens button to add data to the plot."
msgstr "Use the Edit pens button to add data to the plot."

#: src/pages/systemView/components/SystemViewAnnotationSidebar.tsx
msgid "Use the viewer tools to place annotations, measurements, or primitives."
msgstr "Use the viewer tools to place annotations, measurements, or primitives."

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
#: src/features/knowledgeDocumentViewer/workOrders/legacyCmmsRecordPdf.ts
#: src/features/knowledgeDocumentViewer/workOrders/legacyCmmsRecordPdf.ts
msgid "Use type"
msgstr "Use type"

#: src/pages/cases/components/CaseFeedbackModal.tsx
msgid "Useful"
msgstr "Useful"

#: src/pages/homepage/Homepage.tsx
#: src/pages/homepage/Homepage.tsx
msgid "User"
msgstr "User"

#: src/features/richText/components/TaggableUsersCard.tsx
msgid "User already in the allowed list"
msgstr "User already in the allowed list"

#: src/features/richText/nodes/MentionNode.tsx
msgid "User ID:"
msgstr "User ID:"

#: src/features/richText/nodes/MentionNode.tsx
msgid "User Information"
msgstr "User Information"

#: src/features/navbar/profileAndSettings/useProfileAndSettingsState.ts
msgid "User Name"
msgstr "User Name"

#: src/pages/manageAccess/hooks/useListedRoster.ts
msgid "User permissions successfully updated"
msgstr "User permissions successfully updated"

#: src/pages/manageAccess/components/invite/InviteRoleGroup.tsx
msgid "User Roles"
msgstr "User Roles"

#: src/pages/manageAccess/components/invite/InviteUsersDialog.tsx
#: src/pages/manageAccess/components/table/UsersTableHead.tsx
msgid "User type"
msgstr "User type"

#: src/pages/manageAccess/hooks/useListedRoster.ts
msgid "User type successfully updated"
msgstr "User type successfully updated"

#: src/features/chatbot/components/SessionHeaderBar.tsx
msgid "User: {text}"
msgstr "User: {text}"

#: src/pages/metrics/components/SiteRowsTable.tsx
msgid "Users"
msgstr "Users"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatInspectionCard.tsx
msgid "Uses current component configuration with the inspection-linked asset model."
msgstr "Uses current component configuration with the inspection-linked asset model."

#: src/features/copcPointClouds/CopcViewerOverlay.tsx
msgid "UT point size"
msgstr "UT point size"

#: src/features/forgingsReporting/ReportsTable.tsx
msgid "UT Report"
msgstr "UT Report"

#: src/pages/processData/buildMode/components/WindowDrawToolButtons.tsx
msgid "Val"
msgstr "Val"

#: src/features/timeSeries/experiment/SplitBuilder.tsx
msgid "val (orange)"
msgstr "val (orange)"

#: src/pages/details/extensions/flow/assetModelEditorExt/AssetModelEditorRawJSON.tsx
msgid "Validate"
msgstr "Validate"

#: src/pages/facilityModel/SubjectDetailPage.tsx
msgid "Validate permanently?"
msgstr "Validate permanently?"

#: src/features/fimReview/ReviewActions.tsx
msgid "Validate subject"
msgstr "Validate subject"

#: src/features/modelOperations/SubjectTargetPickerColumn.tsx
msgid "validated"
msgstr "validated"

#: src/features/facilityModel/columns.ts
#: src/features/fimReview/DecisionHistory.tsx
#: src/features/modelOperations/SubjectDetails.tsx
msgid "Validated"
msgstr "Validated"

#: src/features/fimReview/ReviewActions.tsx
#: src/pages/facilityModel/SubjectDetailPage.tsx
msgid "Validating…"
msgstr "Validating…"

#: src/features/facilityModel/columns.ts
#: src/pages/facilityModel/FacilityModelFilters.tsx
msgid "Validation"
msgstr "Validation"

#: src/features/timeSeries/components/ThresholdConfigurationModal.tsx
msgid "Validation Errors"
msgstr "Validation Errors"

#: src/features/fimReview/reviewOutcome.ts
msgid "Validation is taking longer than expected. It may still finish in the background. Refresh this Subject before trying again."
msgstr "Validation is taking longer than expected. It may still finish in the background. Refresh this Subject before trying again."

#: src/features/fimReview/ReviewActions.tsx
msgid "Validation note"
msgstr "Validation note"

#: src/pages/facilityModel/SubjectDetailPage.tsx
msgid "Validation writes durable identity constraints; there is no un-validate"
msgstr "Validation writes durable identity constraints; there is no un-validate"

#: src/features/timeSeries/experiment/DiagnosticsPanel.tsx
msgid "Validation:"
msgstr "Validation:"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
#: src/features/knowledgeDocumentViewer/workOrders/legacyCmmsRecordPdf.ts
#: src/features/timeSeries/components/PenTransformControls.tsx
#: src/features/timeSeries/components/ScatterPlotTableConfig.tsx
#: src/features/timeSeries/components/ThresholdFiltering.tsx
#: src/pages/alerts/components/AlertTimeSeriesChart.tsx
#: src/pages/systemView/components/unitsTab/FilterControls.tsx
msgid "Value"
msgstr "Value"

#: src/pages/alerts/components/AlertTimeSeriesChart.tsx
msgid "Value ({unit})"
msgstr "Value ({unit})"

#: src/features/timeSeries/components/ThresholdFiltering.tsx
msgid "Value 2"
msgstr "Value 2"

#: src/features/timeSeries/agentTab/dock/SettingsTab.tsx
msgid "value at cursor"
msgstr "value at cursor"

#: src/pages/processData/buildMode/dock/TagCleaningEditor.tsx
msgid "Value ceiling"
msgstr "Value ceiling"

#: src/pages/processData/buildMode/dock/TagCleaningEditor.tsx
msgid "Value floor"
msgstr "Value floor"

#: src/pages/assetLens/components/tabs/imagesTabComponents/ImageUploadModal.tsx
#: src/pages/assetLens/components/tabs/imagesTabComponents/ImageUploadModal.tsx
msgid "Value must be a number"
msgstr "Value must be a number"

#: src/features/dataFilter/rangeFilter/RangeSlider.tsx
msgid "Value range and color threshold controls{unitLabel}"
msgstr "Value range and color threshold controls{unitLabel}"

#: src/features/dataFilter/rangeFilter/RangeSlider.tsx
msgid "Value range filter"
msgstr "Value range filter"

#: src/features/navbar/navConfig.ts
msgid "Value Stories"
msgstr "Value Stories"

#: src/pages/assetLens/components/tabs/AnomalyDashboard.tsx
msgid "Value: {value} {unit}"
msgstr "Value: {value} {unit}"

#: src/pages/assetLens/components/tabs/imagesTabComponents/utils.ts
msgid "Values tend to decrease with higher ambient temperatures"
msgstr "Values tend to decrease with higher ambient temperatures"

#: src/pages/assetLens/components/tabs/imagesTabComponents/utils.ts
msgid "Values tend to decrease with higher humidity"
msgstr "Values tend to decrease with higher humidity"

#: src/pages/assetLens/components/tabs/imagesTabComponents/utils.ts
msgid "Values tend to increase with higher ambient temperatures"
msgstr "Values tend to increase with higher ambient temperatures"

#: src/pages/assetLens/components/tabs/imagesTabComponents/utils.ts
msgid "Values tend to increase with higher humidity"
msgstr "Values tend to increase with higher humidity"

#: src/features/lotoReports/components/LotoSheetPointRow.tsx
msgid "Valve/breaker"
msgstr "Valve/breaker"

#: src/features/lotoReports/recordSheet/recordSheetLayout.ts
msgid "Valve/Breaker"
msgstr "Valve/Breaker"

#: src/features/timeSeries/components/RegressionPrediction.tsx
msgid "Variable"
msgstr "Variable"

#: src/pages/assetLens/components/tabs/canvas/AnalysisState.tsx
msgid "Variables"
msgstr "Variables"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/documentPreview/DocumentPreviewMeta.tsx
#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/documentPreview/PreviewDocumentDetailsSection.tsx
#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/documentsCardView/documentCardFilterBar/types.ts
#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/documentsTableView/DocumentTableColumns.tsx
#: src/features/knowledgeDocumentViewer/components/advancedSearch/utils/constants.ts
#: src/features/knowledgeDocumentViewer/utils/metadataFieldLabelMessages.ts
#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
#: src/features/knowledgeDocumentViewer/workOrders/legacyCmmsRecordPdf.ts
#: src/features/knowledgeDocumentViewer/workOrders/legacyCmmsRecordPdf.ts
#: src/features/knowledgeDocumentViewer/workOrders/workOrderFields.ts
#: src/pages/evaluations/metadata/labeling/components/DataLabelingVendorFilter.tsx
msgid "Vendor"
msgstr "Vendor"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
msgid "Vendor category"
msgstr "Vendor category"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
msgid "Vendor directory"
msgstr "Vendor directory"

#: src/pages/evaluations/metadata/labeling/utils/vendorOptions.ts
msgid "Vendor: {count}"
msgstr "Vendor: {count}"

#: src/pages/nnpp/imports/NnppImportVerificationPage.tsx
msgid "Verification incomplete"
msgstr "Verification incomplete"

#: src/features/lotoReports/recordSheet/recordSheetLayout.ts
msgid ""
"Verified\n"
"Initial"
msgstr ""
"Verified\n"
"Initial"

#: src/pages/nnpp/imports/NnppImportVerificationPage.tsx
msgid "Verify the remaining extracted values and links to continue."
msgstr "Verify the remaining extracted values and links to continue."

#: src/features/timeSeries/agentTab/dock/AgentDock.tsx
msgid "Versions"
msgstr "Versions"

#: src/features/timeSeries/components/SensorScatterplotTableColumns.tsx
#: src/pages/processData/buildMode/components/ModeSwitcher.tsx
msgid "View"
msgstr "View"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatTurnAttachments.tsx
msgid "View {attachmentName}"
msgstr "View {attachmentName}"

#: src/pages/manageAccess/components/scope/SiteSelect.tsx
msgid "View {orgName}"
msgstr "View {orgName}"

#: src/pages/assetLens/components/tabs/DocumentsTab.tsx
msgid "View {title}"
msgstr "View {title}"

#: src/pages/processData/components/ProcessDataTopBar.tsx
#: src/pages/processData/components/ProcessDataTopBar.tsx
#: src/pages/processData/components/viewSwitcher/ViewSwitcher.tsx
msgid "View actions"
msgstr "View actions"

#: src/features/forecastNotifications/NotificationsDropdownContent.tsx
msgid "View all notifications"
msgstr "View all notifications"

#: src/pages/homepage/constants.ts
msgid "View and manage your assets at your site."
msgstr "View and manage your assets at your site."

#: src/pages/manageAccess/components/dialogs/ViewAsConfirmDialog.tsx
msgid "View as {userName}"
msgstr "View as {userName}"

#: src/pages/systemView/components/unitsTab/UnitListItem.tsx
msgid "View Asset"
msgstr "View Asset"

#: src/features/sentinels/components/SentinelAlertsPanel.tsx
#: src/pages/alerts/components/AlertsTableColumns.tsx
#: src/pages/facilityModel/SentinelOverviewPage.tsx
msgid "View case"
msgstr "View case"

#: src/pages/evaluations/metadata/dashboard/components/dataLabeling/DataLabelingDashboardAgreementByFieldRow.tsx
msgid "View comparisons for {translatedField}"
msgstr "View comparisons for {translatedField}"

#: src/pages/processData/components/viewSwitcher/ViewActionDialogs.tsx
msgid "View deleted"
msgstr "View deleted"

#: src/pages/assetLens/components/tabs/AnomalyDashboard.tsx
msgid "View Details"
msgstr "View Details"

#: src/pages/manageAccess/components/dialogs/ViewAsConfirmDialog.tsx
msgid "View Forecast as {userName}?"
msgstr "View Forecast as {userName}?"

#: src/features/lotoReports/components/LotoPagePanelHeader.tsx
msgid "View full report"
msgstr "View full report"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatInspectionCard.tsx
msgid "View inspection"
msgstr "View inspection"

#: src/features/knowledgeDocumentViewer/components/sidebar/OcrTableColumns.tsx
msgid "View linked documents"
msgstr "View linked documents"

#: src/features/assetVizAdapter/forecastAssetVizWindow/ForecastAssetVizWindowSurface.tsx
msgid "View mode"
msgstr "View mode"

#: src/features/timeSeries/components/chartActions/ChartSaveAction.tsx
msgid "View name"
msgstr "View name"

#: src/pages/processData/components/viewSwitcher/ViewActionDialogs.tsx
msgid "View renamed"
msgstr "View renamed"

#: src/features/copcPointClouds/CopcViewerOverlay.tsx
#: src/features/copcPointClouds/CopcViewerOverlay.tsx
#: src/features/copcPointClouds/CopcViewerOverlay.tsx
#: src/features/copcPointClouds/CopcViewerOverlay.tsx
msgid "View settings"
msgstr "View settings"

#: src/pages/manageAccess/users.ts
msgctxt "access role"
msgid "View the Manage Access page."
msgstr "View the Manage Access page."

#: src/pages/manageAccess/users.ts
msgctxt "access role"
msgid "Viewer"
msgstr "Viewer"

#: src/pages/processData/buildMode/components/ModeSwitcher.tsx
msgid "Viewer mode"
msgstr "Viewer mode"

#: src/pages/details/visualization/alerts/specificAlerts/PublishingStateNotice.tsx
msgid "Viewing {stateName} data layer"
msgstr "Viewing {stateName} data layer"

#: src/features/knowledgeDocumentViewer/utils/metadataFieldLabelMessages.ts
msgid "Viewing Rotation"
msgstr "Viewing Rotation"

#: src/pages/processData/components/helpGuide/HelpGuideChapters.tsx
msgid "Views are shared — everyone on the site sees the same list."
msgstr "Views are shared — everyone on the site sees the same list."

#: src/features/navbar/navConfig.ts
msgid "Virtual Reports"
msgstr "Virtual Reports"

#: src/pages/cases/components/CaseDetailsSidebar.tsx
msgid "Visibility"
msgstr "Visibility"

#: src/pages/cases/components/CasesTable.tsx
msgid "Visible to everyone"
msgstr "Visible to everyone"

#: src/features/timeSeries/experiment/RunComparison.tsx
msgid "vs first"
msgstr "vs first"

#: src/pages/nnpp/imports/NnppImportVerificationPage.tsx
msgid "Wait for import details to finish loading."
msgstr "Wait for import details to finish loading."

#: src/pages/nnpp/imports/NnppImportVerificationPage.tsx
msgid "Wait for requirement sets to load."
msgstr "Wait for requirement sets to load."

#: src/pages/nnpp/imports/NnppImportVerificationPage.tsx
msgid "Wait for the current save to finish"
msgstr "Wait for the current save to finish"

#: src/pages/cases/md/MdCaseDetailsPage.tsx
msgid "Wait for the current update to finish."
msgstr "Wait for the current update to finish."

#: src/pages/nnpp/imports/NnppImportVerificationPage.tsx
msgid "Wait for your correction to save."
msgstr "Wait for your correction to save."

#: src/pages/nnpp/imports/NnppImportVerificationPage.tsx
msgid "Wait for your reviews to finish saving."
msgstr "Wait for your reviews to finish saving."

#: src/features/powerCustomerUploads/state/powerCustomerUploadRowUpdates.ts
msgid "Waiting for pipeline scan."
msgstr "Waiting for pipeline scan."

#: src/features/navbar/navConfig.ts
msgid "Walkdowns"
msgstr "Walkdowns"

#: src/pages/assetLens/components/tabs/SensorIssuesTab.tsx
#: src/pages/details/visualization/markupEditing/IconSelector.tsx
msgid "Warning"
msgstr "Warning"

#: src/pages/evaluations/metadata/labeling/utils/pageClassificationTaxonomy.ts
msgid "Warranty and liability terms"
msgstr "Warranty and liability terms"

#: src/pages/cases/components/CaseFeedbackModal.tsx
msgid "Was the recommendation accurate, partially accurate, or off?"
msgstr "Was the recommendation accurate, partially accurate, or off?"

#: src/features/mdCases/mdCaseDisplay.ts
msgid "Watch"
msgstr "Watch"

#: src/features/powerCustomerUploads/components/PowerCustomerUploadPicker.tsx
msgid "We couldn't read this selection. Try again or choose different files."
msgstr "We couldn't read this selection. Try again or choose different files."

#: src/pages/cases/components/CaseFeedbackModal.tsx
#: src/pages/cases/components/CaseFeedbackModal.tsx
msgid "Weak"
msgstr "Weak"

#: src/pages/metrics/components/MonthlyTable.tsx
msgid "Week of {weekStart}"
msgstr "Week of {weekStart}"

#: src/features/timeSeries/agentTab/dock/AlertingTab.tsx
msgid "weekly"
msgstr "weekly"

#: src/features/timeSeries/components/TimeRangeSelector.tsx
msgid "Weekly trend"
msgstr "Weekly trend"

#: src/pages/processData/buildMode/rightPanel/SavedModelShelf.tsx
msgid "weights"
msgstr "weights"

#: src/features/navbar/navConfig.ts
msgid "Weld Map"
msgstr "Weld Map"

#: src/pages/cases/components/CaseFeedbackModal.tsx
msgid "Were the linked references useful or lacking context?"
msgstr "Were the linked references useful or lacking context?"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatRevisionDiffCard.tsx
#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/RevisionComparePreviewPanel.tsx
#: src/features/knowledgeDocumentViewer/components/revisionCompare/RevisionCompareLauncher.tsx
#: src/features/knowledgeDocumentViewer/components/revisionCompare/RevisionCompareLauncher.tsx
#: src/features/knowledgeDocumentViewer/components/revisionCompare/RevisionCompareView.tsx
msgid "What changed"
msgstr "What changed"

#: src/features/timeSeries/agentTab/dock/VersionsTab.tsx
msgid "what changed after it"
msgstr "what changed after it"

#: src/features/chatbot/components/FeedbackMenu.tsx
msgid "What could be improved?"
msgstr "What could be improved?"

#: src/features/timeSeries/experiment/TransparencyStrip.tsx
msgid "What data is actually used{value177_48}"
msgstr "What data is actually used{value177_48}"

#: src/features/timeSeries/components/labelTool/LabelConfigPanel.tsx
msgid "What happened in this window?"
msgstr "What happened in this window?"

#: src/pages/processData/buildMode/dock/BandsDockTab.tsx
msgid "What the last run calibrated for the selected method — retrain after changing the knobs to recalibrate."
msgstr "What the last run calibrated for the selected method — retrain after changing the knobs to recalibrate."

#: src/features/timeSeries/experiment/knobCopy.ts
msgid "What to do when an aggregate bin has no samples. Off (prod) omits empty bins (tags stay sparse/NaN). LOCF carries the last observed value forward across empty bins — fills gaps but invents values. Not used in raw mode (exact timestamps only)."
msgstr "What to do when an aggregate bin has no samples. Off (prod) omits empty bins (tags stay sparse/NaN). LOCF carries the last observed value forward across empty bins — fills gaps but invents values. Not used in raw mode (exact timestamps only)."

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatFeedbackDialog.tsx
msgid "What was wrong with this answer? Your feedback is used to improve DocChat."
msgstr "What was wrong with this answer? Your feedback is used to improve DocChat."

#: src/features/timeSeries/components/XAxisSection.tsx
msgid "When enabled, lines will be drawn between data points. When disabled, only markers will be shown."
msgstr "When enabled, lines will be drawn between data points. When disabled, only markers will be shown."

#: src/features/timeSeries/components/XAxisSection.tsx
msgid "When enabled, missing data points will be interpolated. This helps create smoother visualizations when data has gaps."
msgstr "When enabled, missing data points will be interpolated. This helps create smoother visualizations when data has gaps."

#: src/features/sentinels/components/MonitorTab.tsx
msgid "When enabled, this sentinel is scored on the cadence below and a case is opened whenever the target leaves its band. Off by default — nothing runs until you turn it on."
msgstr "When enabled, this sentinel is scored on the cadence below and a case is opened whenever the target leaves its band. Off by default — nothing runs until you turn it on."

#: src/features/timeSeries/experiment/knobCopy.ts
msgid "When on, MLP “driver” / “driver+own” methods get lag + rolling-mean features for each driver, not just current values. Off = current drivers only (like mlp_none’s feature set for history)."
msgstr "When on, MLP “driver” / “driver+own” methods get lag + rolling-mean features for each driver, not just current values. Off = current drivers only (like mlp_none’s feature set for history)."

#: src/features/timeSeries/experiment/knobCopy.ts
msgid "When on, MLPs only score rows where the target and every driver feature are present — no placeholder fills for missing inputs. Predictions are cleaner (no jumps from missingness masks) but the monitor goes blind wherever any sensor drops out."
msgstr "When on, MLPs only score rows where the target and every driver feature are present — no placeholder fills for missing inputs. Predictions are cleaner (no jumps from missingness masks) but the monitor goes blind wherever any sensor drops out."

#: src/features/timeSeries/experiment/knobCopy.ts
msgid "When on, the “driver+own” MLP also sees prior target lags + rolling mean (never the current target). Powerful for tracking, but can hide slow target drift because the model can copy recent target history."
msgstr "When on, the “driver+own” MLP also sees prior target lags + rolling mean (never the current target). Powerful for tracking, but can hide slow target drift because the model can copy recent target history."

#: src/features/timeSeries/experiment/TransparencyStrip.tsx
msgid "When timestamps don’t line up"
msgstr "When timestamps don’t line up"

#: src/features/timeSeries/experiment/TransparencyStrip.tsx
msgid "Where does validation fit in?"
msgstr "Where does validation fit in?"

#: src/features/timeSeries/agentTab/dock/TargetTab.tsx
msgid "Where it stands"
msgstr "Where it stands"

#: src/features/fimReview/ReviewActions.tsx
msgid "Which aliases are junk?"
msgstr "Which aliases are junk?"

#: src/features/timeSeries/agentTab/dock/FitTab.tsx
msgid "Which band of the driver carries the loss."
msgstr "Which band of the driver carries the loss."

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatTagPickerCard.tsx
msgid "Which tag did you mean for “{identifier}”?"
msgstr "Which tag did you mean for “{identifier}”?"

#: src/features/timeSeries/agentTab/agentKpiPen.ts
msgid "which the chart's math cannot evaluate"
msgstr "which the chart's math cannot evaluate"

#: src/features/copcPointClouds/CopcLocalizationColorControl.tsx
msgid "White"
msgstr "White"

#: src/pages/systemView/components/SystemViewAnnotationSidebar.tsx
msgid "Whiteboard name"
msgstr "Whiteboard name"

#: src/pages/manageAccess/ManageAccessPage.tsx
msgid "Who can do what in each part of {organizationName}."
msgstr "Who can do what in each part of {organizationName}."

#: src/pages/manageAccess/ManageAccessPage.tsx
msgid "Who can do what in each part of the platform."
msgstr "Who can do what in each part of the platform."

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatInspectionCard.tsx
msgid "Whole grid"
msgstr "Whole grid"

#: src/features/fimReview/ReviewActions.tsx
msgid "Why is this input meaningless? (required)"
msgstr "Why is this input meaningless? (required)"

#: src/features/timeSeries/experiment/knobCopy.ts
msgid "Width of each aggregate bin on the shared time grid. Production Sentinels default to 10 minutes. All lags/rolling windows are counted in these bins (e.g. lag 3 @ 10 min = 30 min). Ignored in raw mode. You can use seconds for finer grids."
msgstr "Width of each aggregate bin on the shared time grid. Production Sentinels default to 10 minutes. All lags/rolling windows are counted in these bins (e.g. lag 3 @ 10 min = 30 min). Ignored in raw mode. You can use seconds for finer grids."

#: src/features/sentinels/components/DesignRunOverviewSections.tsx
#: src/features/timeSeries/components/DataSmoothing.tsx
#: src/features/timeSeries/components/PenTransformControls.tsx
#: src/features/timeSeries/components/ThresholdFiltering.tsx
#: src/features/timeSeries/sentinelStudio/SentinelComparison.tsx
#: src/pages/processData/buildMode/dock/BacktestDockTab.tsx
msgid "Window"
msgstr "Window"

#: src/features/timeSeries/components/PenTransformControls.tsx
msgid "Window ends"
msgstr "Window ends"

#: src/pages/processData/buildMode/dock/CustomRangesTable.tsx
msgid "Window role"
msgstr "Window role"

#: src/features/timeSeries/components/DataSmoothing.tsx
msgid "Window size"
msgstr "Window size"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/ResponseSegmentValueChip.tsx
msgid "window: min {min} · mean {mean} · max {max}"
msgstr "window: min {min} · mean {mean} · max {max}"

#: src/features/timeSeries/agentTab/dock/WindowsTab.tsx
#: src/pages/processData/buildMode/components/BuildDock.tsx
msgid "Windows"
msgstr "Windows"

#: src/features/timeSeries/sentinelStudio/SentinelBuilderPanel.tsx
msgid "Without a P&ID the agent plans from the tags and stats alone."
msgstr "Without a P&ID the agent plans from the tags and stats alone."

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
msgid "WO group"
msgstr "WO group"

#: src/features/knowledgeDocumentViewer/workOrders/workOrderPresentation.ts
msgid "WO group (wogroup)"
msgstr "WO group (wogroup)"

#: src/features/knowledgeDocumentViewer/workOrders/workOrderPdf.ts
msgid "Work details"
msgstr "Work details"

#: src/pages/evaluations/metadata/labeling/utils/pageClassificationTaxonomy.ts
msgid "Work execution and traceability records"
msgstr "Work execution and traceability records"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
msgid "Work log"
msgstr "Work log"

#: src/features/knowledgeDocumentViewer/workOrders/workOrderPdf.ts
msgid "Work logs"
msgstr "Work logs"

#: src/features/knowledgeDocumentViewer/utils/documentTypeLabels.ts
#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
#: src/features/knowledgeDocumentViewer/workOrders/legacyCmmsRecordPdf.ts
#: src/features/knowledgeDocumentViewer/workOrders/legacyCmmsRecordPdf.ts
#: src/features/knowledgeDocumentViewer/workOrders/workOrderPdf.ts
#: src/features/knowledgeDocumentViewer/workOrders/workOrderPresentation.ts
msgid "Work order"
msgstr "Work order"

#: src/features/knowledgeDocumentViewer/workOrders/workOrderPresentation.ts
msgid "Work order (istask=false)"
msgstr "Work order (istask=false)"

#: src/features/lotoReports/components/LotoSheetHeaderFields.tsx
msgid "Work order #"
msgstr "Work order #"

#: src/features/lotoReports/recordSheet/recordSheetLayout.ts
msgid "WORK ORDER #:"
msgstr "WORK ORDER #:"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
#: src/features/knowledgeDocumentViewer/workOrders/legacyCmmsRecordPdf.ts
msgid "Work order reference"
msgstr "Work order reference"

#: src/features/knowledgeDocumentViewer/workOrders/workOrderPdf.ts
msgid "Work orders"
msgstr "Work orders"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/AgenticInlineDocumentResults.tsx
msgid "Work orders come from an imported snapshot; results do not represent a complete maintenance history."
msgstr "Work orders come from an imported snapshot; results do not represent a complete maintenance history."

#: src/features/navbar/siteSelectors/SiteSelectorsSidebar.tsx
msgid "Work Site"
msgstr "Work Site"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
#: src/features/knowledgeDocumentViewer/workOrders/legacyCmmsRecordPdf.ts
#: src/features/knowledgeDocumentViewer/workOrders/workOrderPresentation.ts
msgid "Work type"
msgstr "Work type"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
#: src/features/knowledgeDocumentViewer/workOrders/workOrderFields.ts
msgid "Work-order priority"
msgstr "Work-order priority"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
#: src/features/knowledgeDocumentViewer/workOrders/workOrderFields.ts
msgid "Work-package material availability"
msgstr "Work-package material availability"

#: src/pages/cases/md/mdCasesListSearchContract.ts
msgid "Workflow Mode"
msgstr "Workflow Mode"

#: src/features/workspaceTabs/components/WorkspaceTabSwitcher.tsx
msgid "Workspace"
msgstr "Workspace"

#: src/features/timeSeries/agentTab/dock/AlertingTab.tsx
msgid "worst σ"
msgstr "worst σ"

#: src/features/timeSeries/agentTab/dock/AlertingTab.tsx
msgid "would alert"
msgstr "would alert"

#: src/pages/cases/components/CaseCommentInput.tsx
msgid "Write a comment..."
msgstr "Write a comment..."

#: src/features/timeSeries/agentTab/dock/TargetTab.tsx
msgid "Written against the role names below, not tag ids — so repointing a role at a different tag leaves the physics alone. Smoothing is a rolling MEDIAN over that many days; the band is re-derived at the same smoothing, so sigma stays comparable."
msgstr "Written against the role names below, not tag ids — so repointing a role at a different tag leaves the physics alone. Smoothing is a rolling MEDIAN over that many days; the band is re-derived at the same smoothing, so sigma stays comparable."

#: src/features/knowledgeDocumentViewer/components/sidebar/FeedbackModal.tsx
msgid "Wrong Asset Type"
msgstr "Wrong Asset Type"

#: src/features/knowledgeDocumentViewer/components/sidebar/FeedbackModal.tsx
msgid "Wrong Bounding Box"
msgstr "Wrong Bounding Box"

#: src/features/knowledgeDocumentViewer/components/sidebar/FeedbackModal.tsx
msgid "Wrong Document Type"
msgstr "Wrong Document Type"

#: src/features/knowledgeDocumentViewer/components/sidebar/FeedbackModal.tsx
msgid "Wrong Drawing Number"
msgstr "Wrong Drawing Number"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/utils/docChatFeedback.ts
msgid "Wrong or missing documents"
msgstr "Wrong or missing documents"

#: src/features/knowledgeDocumentViewer/components/sidebar/FeedbackModal.tsx
msgid "Wrong System"
msgstr "Wrong System"

#: src/features/assetLifecycleV2/views/observations/LtaProfilePlot.tsx
#: src/features/assetLifecycleV2/views/shared/MarkupFocusViz.tsx
msgid "X"
msgstr "X"

#: src/features/timeSeries/components/XAxisSection.tsx
msgid "X-Axis Options"
msgstr "X-Axis Options"

#: src/features/timeSeries/components/XAxisSection.tsx
msgid "X-Axis:"
msgstr "X-Axis:"

#: src/features/timeSeries/experiment/NormalizationViewer.tsx
msgid "x²: {value125_39}"
msgstr "x²: {value125_39}"

#: src/features/assetLifecycleV2/views/observations/LtaProfilePlot.tsx
#: src/features/assetLifecycleV2/views/shared/MarkupFocusViz.tsx
msgid "Y"
msgstr "Y"

#: src/features/timeSeries/regressionHelpers.ts
msgid "y = {terms} (t normalized to [-1,1])"
msgstr "y = {terms} (t normalized to [-1,1])"

#: src/features/timeSeries/regressionHelpers.ts
msgid "y = {value315_23} / (1 + e^(-{value315_50}(x - {value315_70})))"
msgstr "y = {value315_23} / (1 + e^(-{value315_50}(x - {value315_70})))"

#: src/features/timeSeries/regressionHelpers.ts
msgid "y = {value430_23} * sin({value430_45}x + {value430_64}) + {value430_83} (period: {value430_108} days)"
msgstr "y = {value430_23} * sin({value430_45}x + {value430_64}) + {value430_83} (period: {value430_108} days)"

#: src/features/timeSeries/experiment/ExperimentTab.tsx
msgid "Y axis ranges"
msgstr "Y axis ranges"

#: src/features/timeSeries/agentTab/dock/SettingsTab.tsx
msgid "y max"
msgstr "y max"

#: src/features/timeSeries/experiment/ExperimentTab.tsx
msgid "Y max"
msgstr "Y max"

#: src/features/timeSeries/components/SensorScatterplotTableColumns.tsx
msgid "Y Max"
msgstr "Y Max"

#: src/features/timeSeries/components/panes/TagConfigurationList.tsx
#: src/features/timeSeries/components/panes/TagConfigurationList.tsx
msgid "Y max override"
msgstr "Y max override"

#: src/features/timeSeries/agentTab/dock/SettingsTab.tsx
msgid "y min"
msgstr "y min"

#: src/features/timeSeries/experiment/ExperimentTab.tsx
msgid "Y min"
msgstr "Y min"

#: src/features/timeSeries/components/SensorScatterplotTableColumns.tsx
msgid "Y Min"
msgstr "Y Min"

#: src/features/timeSeries/components/panes/TagConfigurationList.tsx
#: src/features/timeSeries/components/panes/TagConfigurationList.tsx
msgid "Y min override"
msgstr "Y min override"

#: src/features/timeSeries/components/YAxisModeSection.tsx
msgid "Y-Scale"
msgstr "Y-Scale"

#: src/features/timeSeries/components/YScaleControls.tsx
msgid "Y-scale mode"
msgstr "Y-scale mode"

#: src/features/knowledgeDocumentViewer/components/metadata/ShouldHaveMetadataField.tsx
#: src/features/knowledgeDocumentViewer/graph/nodeTooltip.ts
#: src/pages/site/components/CustomFieldsTableColumns.tsx
#: src/pages/site/forms/customFieldInfoFormFields.ts
msgid "Yes"
msgstr "Yes"

#: src/features/lotoReports/components/LotoTargetDrawings.tsx
msgid "You are here"
msgstr "You are here"

#: src/features/powerCustomerUploads/api/powerCustomerUploadClient.ts
msgid "You are not authorized to upload documents for this site."
msgstr "You are not authorized to upload documents for this site."

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatSuggestedQuestions.tsx
msgid "You can also ask"
msgstr "You can also ask"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatSearchBox.tsx
msgid "You can attach up to {MAX_DOC_CHAT_ATTACHMENTS} images."
msgstr "You can attach up to {MAX_DOC_CHAT_ATTACHMENTS} images."

#: src/features/knowledgeDocumentViewer/components/bugReport/BugReportScreenshots.tsx
msgid "You can attach up to 3 screenshots. Remove one before adding more."
msgstr "You can attach up to 3 screenshots. Remove one before adding more."

#: src/features/chatbot/components/ChatbotHelpModal.tsx
msgid "You can expect a response from our team soon."
msgstr "You can expect a response from our team soon."

#: src/pages/assetLens/components/tabs/imagesTabComponents/ImageUploadModal.tsx
msgid "You can only upload JPG, PNG, GIF, or WEBP files!"
msgstr "You can only upload JPG, PNG, GIF, or WEBP files!"

#: src/pages/manageAccess/components/table/UserRowActions.tsx
msgid "You can't revoke your own access."
msgstr "You can't revoke your own access."

#: src/pages/manageAccess/components/table/UserRow.tsx
msgid "You cannot change your own access roles."
msgstr "You cannot change your own access roles."

#: src/pages/manageAccess/components/table/UserRow.tsx
msgid "You cannot change your own user type."
msgstr "You cannot change your own user type."

#: src/pages/manageAccess/ManageAccessPage.tsx
msgid "You do not have access grants in this organization."
msgstr "You do not have access grants in this organization."

#: src/pages/manageAccess/components/table/UserRow.tsx
msgid "You do not have permission to change access roles."
msgstr "You do not have permission to change access roles."

#: src/pages/manageAccess/components/table/UserRow.tsx
msgid "You do not have permission to change user types."
msgstr "You do not have permission to change user types."

#: src/features/permissions/components/PermissionsGate.tsx
msgid "You do not have permissions to view this page"
msgstr "You do not have permissions to view this page"

#: src/features/chatbot/components/ChatbotSidePanel.tsx
msgid "You don't have access to this feature. Contact your admin to request the <0>cantilever:chat:user</0> permission."
msgstr "You don't have access to this feature. Contact your admin to request the <0>cantilever:chat:user</0> permission."

#: src/pages/manageAccess/hooks/useListedRoster.ts
msgid "You don't have permission to revoke this person's access here. Contact an administrator."
msgstr "You don't have permission to revoke this person's access here. Contact an administrator."

#: src/features/terms/TermsModal.tsx
msgid "You must accept the terms to continue."
msgstr "You must accept the terms to continue."

#: src/features/auth/AuthInactivityMonitor.tsx
msgid "You will be disconnected in {idleModalCountdown, plural, one {# second} other {# seconds}}"
msgstr "You will be disconnected in {idleModalCountdown, plural, one {# second} other {# seconds}}"

#: src/pages/manageAccess/components/dialogs/ViewAsConfirmDialog.tsx
msgid "You will see navigation and page controls using the permissions shown on this page for {userName}. Site lists and loaded data still use your account. Saving is turned off. Your permissions do not change in the database. An ungated banner at the top of the screen lets you restore your access at any time."
msgstr "You will see navigation and page controls using the permissions shown on this page for {userName}. Site lists and loaded data still use your account. Saving is turned off. Your permissions do not change in the database. An ungated banner at the top of the screen lets you restore your access at any time."

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatFeedbackDialog.tsx
msgid "Your feedback was sent to the DocChat team."
msgstr "Your feedback was sent to the DocChat team."

#: src/features/timeSeries/experiment/DiagnosticsPanel.tsx
msgid "your Val timeline chunks"
msgstr "your Val timeline chunks"

#: src/features/timeSeries/components/ActiveTimeRangeSectionWithPopover.tsx
msgid "YTD"
msgstr "YTD"

#: src/features/timeSeries/experiment/ExperimentTab.tsx
msgid "Z — actual "
msgstr "Z — actual "

#: src/features/knowledgeDocumentViewer/workOrders/workOrderPdf.ts
msgid "Zero totals do not establish that no work or materials were used."
msgstr "Zero totals do not establish that no work or materials were used."

#: src/features/timeSeries/experiment/ExperimentTab.tsx
msgid "zero-width band"
msgstr "zero-width band"

#: src/features/powerCustomerUploads/uploadSource/powerCustomerUploadZipArchiveFiles.ts
msgid "ZIP archives nested more than 10 levels are not supported."
msgstr "ZIP archives nested more than 10 levels are not supported."

#: src/features/lotoReports/components/LotoReportEditorHeader.tsx
msgid "Zoom"
msgstr "Zoom"

#: src/pages/processData/buildMode/dock/SplitChunksTable.tsx
#: src/pages/processData/buildMode/dock/SplitChunksTable.tsx
msgid "Zoom chart to chunk"
msgstr "Zoom chart to chunk"

#: src/pages/processData/buildMode/dock/CustomRangesTable.tsx
#: src/pages/processData/buildMode/dock/CustomRangesTable.tsx
msgid "Zoom chart to window"
msgstr "Zoom chart to window"

#: src/features/facilityModel/components/ReferencePreviewPanel.tsx
#: src/features/facilityModel/components/ReferencePreviewPanel.tsx
msgid "Zoom in"
msgstr "Zoom in"

#: src/features/knowledgeDocumentViewer/components/viewer/shared/ZoomControls.tsx
#: src/features/knowledgeDocumentViewer/components/viewer/shared/ZoomControls.tsx
#: src/features/timeSeries/components/ActiveTimeRangeSelector.tsx
#: src/features/timeSeries/components/ActiveTimeRangeSelector.tsx
#: src/features/timeSeries/components/TimeRangeSelector.tsx
#: src/features/timeSeries/components/TimeRangeSelector.tsx
msgid "Zoom In"
msgstr "Zoom In"

#: src/features/facilityModel/components/ReferencePreviewPanel.tsx
#: src/features/facilityModel/components/ReferencePreviewPanel.tsx
msgid "Zoom out"
msgstr "Zoom out"

#: src/features/knowledgeDocumentViewer/components/viewer/shared/ZoomControls.tsx
#: src/features/knowledgeDocumentViewer/components/viewer/shared/ZoomControls.tsx
#: src/features/timeSeries/components/ActiveTimeRangeSelector.tsx
#: src/features/timeSeries/components/ActiveTimeRangeSelector.tsx
#: src/features/timeSeries/components/TimeRangeSelector.tsx
#: src/features/timeSeries/components/TimeRangeSelector.tsx
msgid "Zoom Out"
msgstr "Zoom Out"

#: src/features/knowledgeDocumentViewer/components/sidebar/OcrTableColumns.tsx
msgid "Zoom to box"
msgstr "Zoom to box"

#: src/features/facilityModel/components/ReferencePreviewPanel.tsx
#: src/features/facilityModel/components/ReferencePreviewPanel.tsx
msgid "Zoom to citation"
msgstr "Zoom to citation"

#: src/pages/processData/buildMode/rightPanel/RankingTable.tsx
msgid "σ resid"
msgstr "σ resid"
